/* eslint-disable */
import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * A date-time string at UTC, such as 2007-12-03T10:15:30Z,
   *     compliant with the 'date-time' format outlined in section 5.6 of
   *     the RFC 3339 profile of the ISO 8601 standard for representation
   *     of dates and times using the Gregorian calendar.
   */
  DateTime: { input: string; output: string; }
  /** The 'Dimension' type represents dimensions as whole numeric values between `1` and `4000`. */
  Dimension: { input: number; output: number; }
  /** The 'HexColor' type represents color in `rgb:ffffff` string format. */
  HexColor: { input: string; output: string; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: unknown; output: unknown; }
  /** The 'Quality' type represents quality as whole numeric values between `1` and `100`. */
  Quality: { input: number; output: number; }
};

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/aLVvzQa2bY0a0ogrM8pSt) */
export type AlVvzQa2By0A0OgrM8PSt = Entry & _Node & {
  __typename?: 'ALVvzQa2BY0A0OgrM8PSt';
  _id: Scalars['ID']['output'];
  altText?: Maybe<Scalars['String']['output']>;
  bynderAnimation?: Maybe<Scalars['JSON']['output']>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<AlVvzQa2By0A0OgrM8PStLinkingCollections>;
  notes?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/aLVvzQa2bY0a0ogrM8pSt) */
export type AlVvzQa2By0A0OgrM8PStAltTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/aLVvzQa2bY0a0ogrM8pSt) */
export type AlVvzQa2By0A0OgrM8PStBynderAnimationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/aLVvzQa2bY0a0ogrM8pSt) */
export type AlVvzQa2By0A0OgrM8PStLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/aLVvzQa2bY0a0ogrM8pSt) */
export type AlVvzQa2By0A0OgrM8PStNotesArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/aLVvzQa2bY0a0ogrM8pSt) */
export type AlVvzQa2By0A0OgrM8PStSlugArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/aLVvzQa2bY0a0ogrM8pSt) */
export type AlVvzQa2By0A0OgrM8PStTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AlVvzQa2By0A0OgrM8PStCollection = {
  __typename?: 'ALVvzQa2BY0A0OgrM8PStCollection';
  items: Array<Maybe<AlVvzQa2By0A0OgrM8PSt>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AlVvzQa2By0A0OgrM8PStCursorCollection = {
  __typename?: 'ALVvzQa2BY0A0OgrM8PStCursorCollection';
  items: Array<Maybe<AlVvzQa2By0A0OgrM8PSt>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type AlVvzQa2By0A0OgrM8PStFilter = {
  AND?: InputMaybe<Array<InputMaybe<AlVvzQa2By0A0OgrM8PStFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AlVvzQa2By0A0OgrM8PStFilter>>>;
  altText?: InputMaybe<Scalars['String']['input']>;
  altText_contains?: InputMaybe<Scalars['String']['input']>;
  altText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  altText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  altText_not?: InputMaybe<Scalars['String']['input']>;
  altText_not_contains?: InputMaybe<Scalars['String']['input']>;
  altText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderAnimation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notes_contains?: InputMaybe<Scalars['String']['input']>;
  notes_exists?: InputMaybe<Scalars['Boolean']['input']>;
  notes_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notes_not?: InputMaybe<Scalars['String']['input']>;
  notes_not_contains?: InputMaybe<Scalars['String']['input']>;
  notes_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AlVvzQa2By0A0OgrM8PStLinkingCollections = {
  __typename?: 'ALVvzQa2BY0A0OgrM8PStLinkingCollections';
  componentContentBlockV2Collection?: Maybe<ComponentContentBlockV2Collection>;
  componentContentBlockV2CursorCollection?: Maybe<ComponentContentBlockV2CursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type AlVvzQa2By0A0OgrM8PStLinkingCollectionsComponentContentBlockV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AlVvzQa2By0A0OgrM8PStLinkingCollectionsComponentContentBlockV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AlVvzQa2By0A0OgrM8PStLinkingCollectionsComponentContentBlockV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AlVvzQa2By0A0OgrM8PStLinkingCollectionsComponentContentBlockV2CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AlVvzQa2By0A0OgrM8PStLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AlVvzQa2By0A0OgrM8PStLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AlVvzQa2By0A0OgrM8PStLinkingCollectionsComponentContentBlockV2CollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  HeaderLevelAsc = 'headerLevel_ASC',
  HeaderLevelDesc = 'headerLevel_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MediaPositionAsc = 'mediaPosition_ASC',
  MediaPositionDesc = 'mediaPosition_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAlignmentAsc = 'textAlignment_ASC',
  TextAlignmentDesc = 'textAlignment_DESC'
}

export enum AlVvzQa2By0A0OgrM8PStLinkingCollectionsComponentContentBlockV2CursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  HeaderLevelAsc = 'headerLevel_ASC',
  HeaderLevelDesc = 'headerLevel_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MediaPositionAsc = 'mediaPosition_ASC',
  MediaPositionDesc = 'mediaPosition_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAlignmentAsc = 'textAlignment_ASC',
  TextAlignmentDesc = 'textAlignment_DESC'
}

export enum AlVvzQa2By0A0OgrM8PStOrder {
  AltTextAsc = 'altText_ASC',
  AltTextDesc = 'altText_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** Represents a binary file in a space. An asset can be any file type. */
export type Asset = {
  __typename?: 'Asset';
  contentType?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  linkedFrom?: Maybe<AssetLinkingCollections>;
  size?: Maybe<Scalars['Int']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetContentTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetFileNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetHeightArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  transform?: InputMaybe<ImageTransformOptions>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssetCollection = {
  __typename?: 'AssetCollection';
  items: Array<Maybe<Asset>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AssetCursorCollection = {
  __typename?: 'AssetCursorCollection';
  items: Array<Maybe<Asset>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type AssetFilter = {
  AND?: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  contentType_contains?: InputMaybe<Scalars['String']['input']>;
  contentType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentType_not?: InputMaybe<Scalars['String']['input']>;
  contentType_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileName_contains?: InputMaybe<Scalars['String']['input']>;
  fileName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fileName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fileName_not?: InputMaybe<Scalars['String']['input']>;
  fileName_not_contains?: InputMaybe<Scalars['String']['input']>;
  fileName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  height?: InputMaybe<Scalars['Int']['input']>;
  height_exists?: InputMaybe<Scalars['Boolean']['input']>;
  height_gt?: InputMaybe<Scalars['Int']['input']>;
  height_gte?: InputMaybe<Scalars['Int']['input']>;
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  height_lt?: InputMaybe<Scalars['Int']['input']>;
  height_lte?: InputMaybe<Scalars['Int']['input']>;
  height_not?: InputMaybe<Scalars['Int']['input']>;
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  size?: InputMaybe<Scalars['Int']['input']>;
  size_exists?: InputMaybe<Scalars['Boolean']['input']>;
  size_gt?: InputMaybe<Scalars['Int']['input']>;
  size_gte?: InputMaybe<Scalars['Int']['input']>;
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  size_lt?: InputMaybe<Scalars['Int']['input']>;
  size_lte?: InputMaybe<Scalars['Int']['input']>;
  size_not?: InputMaybe<Scalars['Int']['input']>;
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  width?: InputMaybe<Scalars['Int']['input']>;
  width_exists?: InputMaybe<Scalars['Boolean']['input']>;
  width_gt?: InputMaybe<Scalars['Int']['input']>;
  width_gte?: InputMaybe<Scalars['Int']['input']>;
  width_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  width_lt?: InputMaybe<Scalars['Int']['input']>;
  width_lte?: InputMaybe<Scalars['Int']['input']>;
  width_not?: InputMaybe<Scalars['Int']['input']>;
  width_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type AssetLinkingCollections = {
  __typename?: 'AssetLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  wrapperBannerImageCollection?: Maybe<WrapperBannerImageCollection>;
  wrapperBannerImageCursorCollection?: Maybe<WrapperBannerImageCursorCollection>;
  wrapperDocumentCollection?: Maybe<WrapperDocumentCollection>;
  wrapperDocumentCursorCollection?: Maybe<WrapperDocumentCursorCollection>;
  wrapperIconCollection?: Maybe<WrapperIconCollection>;
  wrapperIconCursorCollection?: Maybe<WrapperIconCursorCollection>;
  wrapperImageCollection?: Maybe<WrapperImageCollection>;
  wrapperImageCursorCollection?: Maybe<WrapperImageCursorCollection>;
  wrapperVideoCollection?: Maybe<WrapperVideoCollection>;
  wrapperVideoCursorCollection?: Maybe<WrapperVideoCursorCollection>;
};


export type AssetLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsWrapperBannerImageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsWrapperBannerImageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsWrapperDocumentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsWrapperDocumentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsWrapperIconCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsWrapperIconCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsWrapperImageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsWrapperImageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsWrapperVideoCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsWrapperVideoCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AssetOrder {
  ContentTypeAsc = 'contentType_ASC',
  ContentTypeDesc = 'contentType_DESC',
  FileNameAsc = 'fileName_ASC',
  FileNameDesc = 'fileName_DESC',
  HeightAsc = 'height_ASC',
  HeightDesc = 'height_DESC',
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC',
  WidthAsc = 'width_ASC',
  WidthDesc = 'width_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/author) */
export type Author = Entry & _Node & {
  __typename?: 'Author';
  _id: Scalars['ID']['output'];
  bio?: Maybe<AuthorBio>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<AuthorLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/author) */
export type AuthorBioArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/author) */
export type AuthorLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/author) */
export type AuthorNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AuthorBio = {
  __typename?: 'AuthorBio';
  json: Scalars['JSON']['output'];
  links: AuthorBioLinks;
};

export type AuthorBioAssets = {
  __typename?: 'AuthorBioAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type AuthorBioEntries = {
  __typename?: 'AuthorBioEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type AuthorBioLinks = {
  __typename?: 'AuthorBioLinks';
  assets: AuthorBioAssets;
  entries: AuthorBioEntries;
  resources: AuthorBioResources;
};

export type AuthorBioResources = {
  __typename?: 'AuthorBioResources';
  block: Array<AuthorBioResourcesBlock>;
  hyperlink: Array<AuthorBioResourcesHyperlink>;
  inline: Array<AuthorBioResourcesInline>;
};

export type AuthorBioResourcesBlock = ResourceLink & {
  __typename?: 'AuthorBioResourcesBlock';
  sys: ResourceSys;
};

export type AuthorBioResourcesHyperlink = ResourceLink & {
  __typename?: 'AuthorBioResourcesHyperlink';
  sys: ResourceSys;
};

export type AuthorBioResourcesInline = ResourceLink & {
  __typename?: 'AuthorBioResourcesInline';
  sys: ResourceSys;
};

export type AuthorCollection = {
  __typename?: 'AuthorCollection';
  items: Array<Maybe<Author>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AuthorCursorCollection = {
  __typename?: 'AuthorCursorCollection';
  items: Array<Maybe<Author>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type AuthorFilter = {
  AND?: InputMaybe<Array<InputMaybe<AuthorFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AuthorFilter>>>;
  bio_contains?: InputMaybe<Scalars['String']['input']>;
  bio_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bio_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type AuthorLinkingCollections = {
  __typename?: 'AuthorLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type AuthorLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AuthorLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AuthorLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AuthorLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AuthorLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AuthorLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AuthorLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum AuthorLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum AuthorOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildArticlePage) */
export type BuildArticlePage = Entry & _Node & {
  __typename?: 'BuildArticlePage';
  _id: Scalars['ID']['output'];
  articleLabels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  articleMainLabel?: Maybe<Scalars['String']['output']>;
  author?: Maybe<Author>;
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  componentsCollection?: Maybe<BuildArticlePageComponentsCollection>;
  componentsCursorCollection?: Maybe<BuildArticlePageComponentsCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  cta1?: Maybe<PackCta>;
  cta1Behaviour?: Maybe<Scalars['String']['output']>;
  cta1Type?: Maybe<Scalars['String']['output']>;
  cta2?: Maybe<PackCta>;
  cta2Behaviour?: Maybe<Scalars['String']['output']>;
  cta2Type?: Maybe<Scalars['String']['output']>;
  includeInSiteMap?: Maybe<Scalars['Boolean']['output']>;
  indexibility?: Maybe<Scalars['String']['output']>;
  jiraStoryNumber?: Maybe<Scalars['Int']['output']>;
  linkedFrom?: Maybe<BuildArticlePageLinkingCollections>;
  masthead?: Maybe<BuildArticlePageMasthead>;
  mastheadLayout?: Maybe<Scalars['String']['output']>;
  nextReview?: Maybe<Scalars['DateTime']['output']>;
  publishDate?: Maybe<Scalars['DateTime']['output']>;
  relatedContentCollection?: Maybe<BuildArticlePageRelatedContentCollection>;
  relatedContentCursorCollection?: Maybe<BuildArticlePageRelatedContentCursorCollection>;
  slug?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildArticlePage) */
export type BuildArticlePageArticleLabelsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildArticlePage) */
export type BuildArticlePageArticleMainLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildArticlePage) */
export type BuildArticlePageAuthorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AuthorFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildArticlePage) */
export type BuildArticlePageCanonicalUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildArticlePage) */
export type BuildArticlePageComponentsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildArticlePageComponentsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildArticlePage) */
export type BuildArticlePageComponentsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildArticlePageComponentsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildArticlePage) */
export type BuildArticlePageCta1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildArticlePage) */
export type BuildArticlePageCta1BehaviourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildArticlePage) */
export type BuildArticlePageCta1TypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildArticlePage) */
export type BuildArticlePageCta2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildArticlePage) */
export type BuildArticlePageCta2BehaviourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildArticlePage) */
export type BuildArticlePageCta2TypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildArticlePage) */
export type BuildArticlePageIncludeInSiteMapArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildArticlePage) */
export type BuildArticlePageIndexibilityArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildArticlePage) */
export type BuildArticlePageJiraStoryNumberArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildArticlePage) */
export type BuildArticlePageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildArticlePage) */
export type BuildArticlePageMastheadArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildArticlePage) */
export type BuildArticlePageMastheadLayoutArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildArticlePage) */
export type BuildArticlePageNextReviewArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildArticlePage) */
export type BuildArticlePagePublishDateArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildArticlePage) */
export type BuildArticlePageRelatedContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildArticlePageRelatedContentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildArticlePageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildArticlePage) */
export type BuildArticlePageRelatedContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildArticlePageRelatedContentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildArticlePageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildArticlePage) */
export type BuildArticlePageSlugArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BuildArticlePageCollection = {
  __typename?: 'BuildArticlePageCollection';
  items: Array<Maybe<BuildArticlePage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BuildArticlePageComponentsCollection = {
  __typename?: 'BuildArticlePageComponentsCollection';
  items: Array<Maybe<BuildArticlePageComponentsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BuildArticlePageComponentsCursorCollection = {
  __typename?: 'BuildArticlePageComponentsCursorCollection';
  items: Array<Maybe<BuildArticlePageComponentsItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BuildArticlePageComponentsFilter = {
  AND?: InputMaybe<Array<InputMaybe<BuildArticlePageComponentsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BuildArticlePageComponentsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type BuildArticlePageComponentsItem = BuildCustomerInformationCard | ComponentAccordion | ComponentActionCard | ComponentBlockCard | ComponentCallout | ComponentCard | ComponentCardGrid | ComponentCardGroup | ComponentCarousel | ComponentCategoryBrowser | ComponentContactAndUsefulLinks | ComponentContentBlock | ComponentContentBlockV2 | ComponentCtaBanner | ComponentFootnotes | ComponentForm | ComponentGuidesRail | ComponentHelpAndCta | ComponentHelpHomepageDualLayout | ComponentIframe | ComponentImageGallery | ComponentImageWithDescription | ComponentPostcodeFinder | ComponentProductGroup | ComponentPromoCardRail | ComponentSectionSteps | ComponentSpotlightGrid | ComponentTable | ComponentTariffCardGroup | ComponentTextAndCta | ComponentTrustpilot | ComponentUspGroup | ComponentVideoPlayer;

export type BuildArticlePageCursorCollection = {
  __typename?: 'BuildArticlePageCursorCollection';
  items: Array<Maybe<BuildArticlePage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BuildArticlePageFilter = {
  AND?: InputMaybe<Array<InputMaybe<BuildArticlePageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BuildArticlePageFilter>>>;
  articleLabels_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  articleLabels_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  articleLabels_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  articleLabels_exists?: InputMaybe<Scalars['Boolean']['input']>;
  articleMainLabel?: InputMaybe<Scalars['String']['input']>;
  articleMainLabel_contains?: InputMaybe<Scalars['String']['input']>;
  articleMainLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  articleMainLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  articleMainLabel_not?: InputMaybe<Scalars['String']['input']>;
  articleMainLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  articleMainLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  author?: InputMaybe<CfAuthorNestedFilter>;
  author_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonicalUrl?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_contains?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonicalUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonicalUrl_not?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  components?: InputMaybe<CfcomponentsMultiTypeNestedFilter>;
  componentsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta1?: InputMaybe<CfPackCtaNestedFilter>;
  cta1Behaviour?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta1Behaviour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Behaviour_not?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Type?: InputMaybe<Scalars['String']['input']>;
  cta1Type_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta1Type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Type_not?: InputMaybe<Scalars['String']['input']>;
  cta1Type_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2?: InputMaybe<CfPackCtaNestedFilter>;
  cta2Behaviour?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2Behaviour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Behaviour_not?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Type?: InputMaybe<Scalars['String']['input']>;
  cta2Type_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2Type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Type_not?: InputMaybe<Scalars['String']['input']>;
  cta2Type_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  includeInSiteMap?: InputMaybe<Scalars['Boolean']['input']>;
  includeInSiteMap_exists?: InputMaybe<Scalars['Boolean']['input']>;
  includeInSiteMap_not?: InputMaybe<Scalars['Boolean']['input']>;
  indexibility?: InputMaybe<Scalars['String']['input']>;
  indexibility_contains?: InputMaybe<Scalars['String']['input']>;
  indexibility_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexibility_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  indexibility_not?: InputMaybe<Scalars['String']['input']>;
  indexibility_not_contains?: InputMaybe<Scalars['String']['input']>;
  indexibility_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  jiraStoryNumber?: InputMaybe<Scalars['Int']['input']>;
  jiraStoryNumber_exists?: InputMaybe<Scalars['Boolean']['input']>;
  jiraStoryNumber_gt?: InputMaybe<Scalars['Int']['input']>;
  jiraStoryNumber_gte?: InputMaybe<Scalars['Int']['input']>;
  jiraStoryNumber_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  jiraStoryNumber_lt?: InputMaybe<Scalars['Int']['input']>;
  jiraStoryNumber_lte?: InputMaybe<Scalars['Int']['input']>;
  jiraStoryNumber_not?: InputMaybe<Scalars['Int']['input']>;
  jiraStoryNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  mastheadLayout?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_contains?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mastheadLayout_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mastheadLayout_not?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_not_contains?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  masthead_exists?: InputMaybe<Scalars['Boolean']['input']>;
  nextReview?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_exists?: InputMaybe<Scalars['Boolean']['input']>;
  nextReview_gt?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_gte?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nextReview_lt?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_lte?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_not?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishDate?: InputMaybe<Scalars['DateTime']['input']>;
  publishDate_exists?: InputMaybe<Scalars['Boolean']['input']>;
  publishDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  publishDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  publishDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  publishDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  publishDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  publishDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  relatedContent?: InputMaybe<CfBuildArticlePageNestedFilter>;
  relatedContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type BuildArticlePageLinkingCollections = {
  __typename?: 'BuildArticlePageLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  packLandingPageArticlesCollection?: Maybe<PackLandingPageArticlesCollection>;
  packLandingPageArticlesCursorCollection?: Maybe<PackLandingPageArticlesCursorCollection>;
};


export type BuildArticlePageLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildArticlePageLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildArticlePageLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildArticlePageLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildArticlePageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildArticlePageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildArticlePageLinkingCollectionsPackLandingPageArticlesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildArticlePageLinkingCollectionsPackLandingPageArticlesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildArticlePageLinkingCollectionsPackLandingPageArticlesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildArticlePageLinkingCollectionsPackLandingPageArticlesCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BuildArticlePageLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BuildArticlePageLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BuildArticlePageLinkingCollectionsPackLandingPageArticlesCollectionOrder {
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BuildArticlePageLinkingCollectionsPackLandingPageArticlesCursorCollectionOrder {
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BuildArticlePageMasthead = PackArticlePage | WrapperPageRouting;

export enum BuildArticlePageOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BuildArticlePageRelatedContentCollection = {
  __typename?: 'BuildArticlePageRelatedContentCollection';
  items: Array<Maybe<BuildArticlePage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum BuildArticlePageRelatedContentCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BuildArticlePageRelatedContentCursorCollection = {
  __typename?: 'BuildArticlePageRelatedContentCursorCollection';
  items: Array<Maybe<BuildArticlePage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum BuildArticlePageRelatedContentCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildArticlesLandingPage) */
export type BuildArticlesLandingPage = Entry & _Node & {
  __typename?: 'BuildArticlesLandingPage';
  _id: Scalars['ID']['output'];
  articlesType?: Maybe<Scalars['String']['output']>;
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  includeInSiteMap?: Maybe<Scalars['Boolean']['output']>;
  indexibility?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<BuildArticlesLandingPageLinkingCollections>;
  masthead?: Maybe<PackLandingPageArticles>;
  mastheadLayout?: Maybe<Scalars['String']['output']>;
  nextReview?: Maybe<Scalars['DateTime']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildArticlesLandingPage) */
export type BuildArticlesLandingPageArticlesTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildArticlesLandingPage) */
export type BuildArticlesLandingPageCanonicalUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildArticlesLandingPage) */
export type BuildArticlesLandingPageIncludeInSiteMapArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildArticlesLandingPage) */
export type BuildArticlesLandingPageIndexibilityArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildArticlesLandingPage) */
export type BuildArticlesLandingPageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildArticlesLandingPage) */
export type BuildArticlesLandingPageMastheadArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackLandingPageArticlesFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildArticlesLandingPage) */
export type BuildArticlesLandingPageMastheadLayoutArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildArticlesLandingPage) */
export type BuildArticlesLandingPageNextReviewArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildArticlesLandingPage) */
export type BuildArticlesLandingPageSlugArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BuildArticlesLandingPageCollection = {
  __typename?: 'BuildArticlesLandingPageCollection';
  items: Array<Maybe<BuildArticlesLandingPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BuildArticlesLandingPageCursorCollection = {
  __typename?: 'BuildArticlesLandingPageCursorCollection';
  items: Array<Maybe<BuildArticlesLandingPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BuildArticlesLandingPageFilter = {
  AND?: InputMaybe<Array<InputMaybe<BuildArticlesLandingPageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BuildArticlesLandingPageFilter>>>;
  articlesType?: InputMaybe<Scalars['String']['input']>;
  articlesType_contains?: InputMaybe<Scalars['String']['input']>;
  articlesType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  articlesType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  articlesType_not?: InputMaybe<Scalars['String']['input']>;
  articlesType_not_contains?: InputMaybe<Scalars['String']['input']>;
  articlesType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonicalUrl?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_contains?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonicalUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonicalUrl_not?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  includeInSiteMap?: InputMaybe<Scalars['Boolean']['input']>;
  includeInSiteMap_exists?: InputMaybe<Scalars['Boolean']['input']>;
  includeInSiteMap_not?: InputMaybe<Scalars['Boolean']['input']>;
  indexibility?: InputMaybe<Scalars['String']['input']>;
  indexibility_contains?: InputMaybe<Scalars['String']['input']>;
  indexibility_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexibility_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  indexibility_not?: InputMaybe<Scalars['String']['input']>;
  indexibility_not_contains?: InputMaybe<Scalars['String']['input']>;
  indexibility_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  masthead?: InputMaybe<CfPackLandingPageArticlesNestedFilter>;
  mastheadLayout?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_contains?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mastheadLayout_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mastheadLayout_not?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_not_contains?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  masthead_exists?: InputMaybe<Scalars['Boolean']['input']>;
  nextReview?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_exists?: InputMaybe<Scalars['Boolean']['input']>;
  nextReview_gt?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_gte?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nextReview_lt?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_lte?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_not?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type BuildArticlesLandingPageLinkingCollections = {
  __typename?: 'BuildArticlesLandingPageLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type BuildArticlesLandingPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildArticlesLandingPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BuildArticlesLandingPageOrder {
  ArticlesTypeAsc = 'articlesType_ASC',
  ArticlesTypeDesc = 'articlesType_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildCampaignPage) */
export type BuildCampaignPage = Entry & _Node & {
  __typename?: 'BuildCampaignPage';
  _id: Scalars['ID']['output'];
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  componentsCollection?: Maybe<BuildCampaignPageComponentsCollection>;
  componentsCursorCollection?: Maybe<BuildCampaignPageComponentsCursorCollection>;
  contactAndLinks?: Maybe<ComponentContactAndUsefulLinks>;
  contentfulMetadata: ContentfulMetadata;
  cta1?: Maybe<PackCta>;
  cta1Behaviour?: Maybe<Scalars['String']['output']>;
  cta1Type?: Maybe<Scalars['String']['output']>;
  cta2?: Maybe<PackCta>;
  cta2Behaviour?: Maybe<Scalars['String']['output']>;
  cta2Type?: Maybe<Scalars['String']['output']>;
  includeInSiteMap?: Maybe<Scalars['Boolean']['output']>;
  indexibility?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<BuildCampaignPageLinkingCollections>;
  masthead?: Maybe<BuildCampaignPageMasthead>;
  mastheadLayout?: Maybe<Scalars['String']['output']>;
  nextReview?: Maybe<Scalars['DateTime']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildCampaignPage) */
export type BuildCampaignPageCanonicalUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildCampaignPage) */
export type BuildCampaignPageComponentsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildCampaignPageComponentsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildCampaignPage) */
export type BuildCampaignPageComponentsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildCampaignPageComponentsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildCampaignPage) */
export type BuildCampaignPageContactAndLinksArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentContactAndUsefulLinksFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildCampaignPage) */
export type BuildCampaignPageCta1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildCampaignPage) */
export type BuildCampaignPageCta1BehaviourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildCampaignPage) */
export type BuildCampaignPageCta1TypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildCampaignPage) */
export type BuildCampaignPageCta2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildCampaignPage) */
export type BuildCampaignPageCta2BehaviourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildCampaignPage) */
export type BuildCampaignPageCta2TypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildCampaignPage) */
export type BuildCampaignPageIncludeInSiteMapArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildCampaignPage) */
export type BuildCampaignPageIndexibilityArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildCampaignPage) */
export type BuildCampaignPageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildCampaignPage) */
export type BuildCampaignPageMastheadArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildCampaignPage) */
export type BuildCampaignPageMastheadLayoutArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildCampaignPage) */
export type BuildCampaignPageNextReviewArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildCampaignPage) */
export type BuildCampaignPageSlugArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BuildCampaignPageCollection = {
  __typename?: 'BuildCampaignPageCollection';
  items: Array<Maybe<BuildCampaignPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BuildCampaignPageComponentsCollection = {
  __typename?: 'BuildCampaignPageComponentsCollection';
  items: Array<Maybe<BuildCampaignPageComponentsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BuildCampaignPageComponentsCursorCollection = {
  __typename?: 'BuildCampaignPageComponentsCursorCollection';
  items: Array<Maybe<BuildCampaignPageComponentsItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BuildCampaignPageComponentsFilter = {
  AND?: InputMaybe<Array<InputMaybe<BuildCampaignPageComponentsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BuildCampaignPageComponentsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type BuildCampaignPageComponentsItem = BuildCustomerInformationCard | ComponentAccordion | ComponentCallout | ComponentCardGrid | ComponentCardGroup | ComponentCarousel | ComponentContentBlock | ComponentCtaBanner | ComponentDetailInfoSection | ComponentFootnotes | ComponentForm | ComponentGuidesRail | ComponentHelpAndCta | ComponentHelpHomepageDualLayout | ComponentImageGallery | ComponentImageWithDescription | ComponentInfoGroup | ComponentLauncherGroup | ComponentLogoGroup | ComponentPostcodeFinder | ComponentProductGroup | ComponentProductRail | ComponentPromoCardRail | ComponentPromoSection | ComponentPromoTextCardSection | ComponentSectionSteps | ComponentSpotlightGrid | ComponentTable | ComponentTariffCardGroup | ComponentTextAndCta | ComponentTrustpilot | ComponentUspGroup | ComponentVideoPlayer | VariationContainer;

export type BuildCampaignPageCursorCollection = {
  __typename?: 'BuildCampaignPageCursorCollection';
  items: Array<Maybe<BuildCampaignPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BuildCampaignPageFilter = {
  AND?: InputMaybe<Array<InputMaybe<BuildCampaignPageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BuildCampaignPageFilter>>>;
  canonicalUrl?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_contains?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonicalUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonicalUrl_not?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  components?: InputMaybe<CfcomponentsMultiTypeNestedFilter>;
  componentsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contactAndLinks?: InputMaybe<CfComponentContactAndUsefulLinksNestedFilter>;
  contactAndLinks_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta1?: InputMaybe<CfPackCtaNestedFilter>;
  cta1Behaviour?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta1Behaviour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Behaviour_not?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Type?: InputMaybe<Scalars['String']['input']>;
  cta1Type_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta1Type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Type_not?: InputMaybe<Scalars['String']['input']>;
  cta1Type_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2?: InputMaybe<CfPackCtaNestedFilter>;
  cta2Behaviour?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2Behaviour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Behaviour_not?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Type?: InputMaybe<Scalars['String']['input']>;
  cta2Type_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2Type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Type_not?: InputMaybe<Scalars['String']['input']>;
  cta2Type_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  includeInSiteMap?: InputMaybe<Scalars['Boolean']['input']>;
  includeInSiteMap_exists?: InputMaybe<Scalars['Boolean']['input']>;
  includeInSiteMap_not?: InputMaybe<Scalars['Boolean']['input']>;
  indexibility?: InputMaybe<Scalars['String']['input']>;
  indexibility_contains?: InputMaybe<Scalars['String']['input']>;
  indexibility_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexibility_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  indexibility_not?: InputMaybe<Scalars['String']['input']>;
  indexibility_not_contains?: InputMaybe<Scalars['String']['input']>;
  indexibility_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mastheadLayout?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_contains?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mastheadLayout_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mastheadLayout_not?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_not_contains?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  masthead_exists?: InputMaybe<Scalars['Boolean']['input']>;
  nextReview?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_exists?: InputMaybe<Scalars['Boolean']['input']>;
  nextReview_gt?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_gte?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nextReview_lt?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_lte?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_not?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type BuildCampaignPageLinkingCollections = {
  __typename?: 'BuildCampaignPageLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type BuildCampaignPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildCampaignPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BuildCampaignPageMasthead = PackCampaignPage | PackPageStandard | WrapperPageRouting;

export enum BuildCampaignPageOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildCategoryWebpage) */
export type BuildCategoryWebpage = Entry & _Node & {
  __typename?: 'BuildCategoryWebpage';
  _id: Scalars['ID']['output'];
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  category?: Maybe<PackCategory>;
  componentsCollection?: Maybe<BuildCategoryWebpageComponentsCollection>;
  componentsCursorCollection?: Maybe<BuildCategoryWebpageComponentsCursorCollection>;
  contactAndLinks?: Maybe<ComponentContactAndUsefulLinks>;
  contentfulMetadata: ContentfulMetadata;
  includeInSiteMap?: Maybe<Scalars['Boolean']['output']>;
  indexibility?: Maybe<Scalars['String']['output']>;
  jiraStoryNumber?: Maybe<Scalars['Int']['output']>;
  linkedFrom?: Maybe<BuildCategoryWebpageLinkingCollections>;
  masthead?: Maybe<BuildCategoryWebpageMasthead>;
  nextReview?: Maybe<Scalars['DateTime']['output']>;
  pathname?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildCategoryWebpage) */
export type BuildCategoryWebpageCanonicalUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildCategoryWebpage) */
export type BuildCategoryWebpageCategoryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCategoryFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildCategoryWebpage) */
export type BuildCategoryWebpageComponentsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildCategoryWebpageComponentsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildCategoryWebpage) */
export type BuildCategoryWebpageComponentsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildCategoryWebpageComponentsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildCategoryWebpage) */
export type BuildCategoryWebpageContactAndLinksArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentContactAndUsefulLinksFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildCategoryWebpage) */
export type BuildCategoryWebpageIncludeInSiteMapArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildCategoryWebpage) */
export type BuildCategoryWebpageIndexibilityArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildCategoryWebpage) */
export type BuildCategoryWebpageJiraStoryNumberArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildCategoryWebpage) */
export type BuildCategoryWebpageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildCategoryWebpage) */
export type BuildCategoryWebpageMastheadArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildCategoryWebpage) */
export type BuildCategoryWebpageNextReviewArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildCategoryWebpage) */
export type BuildCategoryWebpagePathnameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BuildCategoryWebpageCollection = {
  __typename?: 'BuildCategoryWebpageCollection';
  items: Array<Maybe<BuildCategoryWebpage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BuildCategoryWebpageComponentsCollection = {
  __typename?: 'BuildCategoryWebpageComponentsCollection';
  items: Array<Maybe<BuildCategoryWebpageComponentsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BuildCategoryWebpageComponentsCursorCollection = {
  __typename?: 'BuildCategoryWebpageComponentsCursorCollection';
  items: Array<Maybe<BuildCategoryWebpageComponentsItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BuildCategoryWebpageComponentsFilter = {
  AND?: InputMaybe<Array<InputMaybe<BuildCategoryWebpageComponentsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BuildCategoryWebpageComponentsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type BuildCategoryWebpageComponentsItem = ComponentContentBlock | PackCategoryList;

export type BuildCategoryWebpageCursorCollection = {
  __typename?: 'BuildCategoryWebpageCursorCollection';
  items: Array<Maybe<BuildCategoryWebpage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BuildCategoryWebpageFilter = {
  AND?: InputMaybe<Array<InputMaybe<BuildCategoryWebpageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BuildCategoryWebpageFilter>>>;
  canonicalUrl?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_contains?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonicalUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonicalUrl_not?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category?: InputMaybe<CfPackCategoryNestedFilter>;
  category_exists?: InputMaybe<Scalars['Boolean']['input']>;
  components?: InputMaybe<CfcomponentsMultiTypeNestedFilter>;
  componentsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contactAndLinks?: InputMaybe<CfComponentContactAndUsefulLinksNestedFilter>;
  contactAndLinks_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  includeInSiteMap?: InputMaybe<Scalars['Boolean']['input']>;
  includeInSiteMap_exists?: InputMaybe<Scalars['Boolean']['input']>;
  includeInSiteMap_not?: InputMaybe<Scalars['Boolean']['input']>;
  indexibility?: InputMaybe<Scalars['String']['input']>;
  indexibility_contains?: InputMaybe<Scalars['String']['input']>;
  indexibility_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexibility_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  indexibility_not?: InputMaybe<Scalars['String']['input']>;
  indexibility_not_contains?: InputMaybe<Scalars['String']['input']>;
  indexibility_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  jiraStoryNumber?: InputMaybe<Scalars['Int']['input']>;
  jiraStoryNumber_exists?: InputMaybe<Scalars['Boolean']['input']>;
  jiraStoryNumber_gt?: InputMaybe<Scalars['Int']['input']>;
  jiraStoryNumber_gte?: InputMaybe<Scalars['Int']['input']>;
  jiraStoryNumber_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  jiraStoryNumber_lt?: InputMaybe<Scalars['Int']['input']>;
  jiraStoryNumber_lte?: InputMaybe<Scalars['Int']['input']>;
  jiraStoryNumber_not?: InputMaybe<Scalars['Int']['input']>;
  jiraStoryNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  masthead_exists?: InputMaybe<Scalars['Boolean']['input']>;
  nextReview?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_exists?: InputMaybe<Scalars['Boolean']['input']>;
  nextReview_gt?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_gte?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nextReview_lt?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_lte?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_not?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  pathname?: InputMaybe<Scalars['String']['input']>;
  pathname_contains?: InputMaybe<Scalars['String']['input']>;
  pathname_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pathname_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pathname_not?: InputMaybe<Scalars['String']['input']>;
  pathname_not_contains?: InputMaybe<Scalars['String']['input']>;
  pathname_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type BuildCategoryWebpageLinkingCollections = {
  __typename?: 'BuildCategoryWebpageLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  packCtaCollection?: Maybe<PackCtaCollection>;
  packCtaCursorCollection?: Maybe<PackCtaCursorCollection>;
  packFooterItemCollection?: Maybe<PackFooterItemCollection>;
  packFooterItemCursorCollection?: Maybe<PackFooterItemCursorCollection>;
  packNavBarCtaCollection?: Maybe<PackNavBarCtaCollection>;
  packNavBarCtaCursorCollection?: Maybe<PackNavBarCtaCursorCollection>;
  packNavBarItemCollection?: Maybe<PackNavBarItemCollection>;
  packNavBarItemCursorCollection?: Maybe<PackNavBarItemCursorCollection>;
  packNavBarItemV2Collection?: Maybe<PackNavBarItemV2Collection>;
  packNavBarItemV2CursorCollection?: Maybe<PackNavBarItemV2CursorCollection>;
  packRecommendedContentAccordionItemCollection?: Maybe<PackRecommendedContentAccordionItemCollection>;
  packRecommendedContentAccordionItemCursorCollection?: Maybe<PackRecommendedContentAccordionItemCursorCollection>;
  wrapperPageRoutingCollection?: Maybe<WrapperPageRoutingCollection>;
  wrapperPageRoutingCursorCollection?: Maybe<WrapperPageRoutingCursorCollection>;
};


export type BuildCategoryWebpageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildCategoryWebpageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildCategoryWebpageLinkingCollectionsPackCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildCategoryWebpageLinkingCollectionsPackCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildCategoryWebpageLinkingCollectionsPackCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildCategoryWebpageLinkingCollectionsPackCtaCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildCategoryWebpageLinkingCollectionsPackFooterItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildCategoryWebpageLinkingCollectionsPackFooterItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildCategoryWebpageLinkingCollectionsPackFooterItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildCategoryWebpageLinkingCollectionsPackFooterItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildCategoryWebpageLinkingCollectionsPackNavBarCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildCategoryWebpageLinkingCollectionsPackNavBarCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildCategoryWebpageLinkingCollectionsPackNavBarCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildCategoryWebpageLinkingCollectionsPackNavBarCtaCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildCategoryWebpageLinkingCollectionsPackNavBarItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildCategoryWebpageLinkingCollectionsPackNavBarItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildCategoryWebpageLinkingCollectionsPackNavBarItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildCategoryWebpageLinkingCollectionsPackNavBarItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildCategoryWebpageLinkingCollectionsPackNavBarItemV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildCategoryWebpageLinkingCollectionsPackNavBarItemV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildCategoryWebpageLinkingCollectionsPackNavBarItemV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildCategoryWebpageLinkingCollectionsPackNavBarItemV2CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildCategoryWebpageLinkingCollectionsPackRecommendedContentAccordionItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildCategoryWebpageLinkingCollectionsPackRecommendedContentAccordionItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildCategoryWebpageLinkingCollectionsPackRecommendedContentAccordionItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildCategoryWebpageLinkingCollectionsPackRecommendedContentAccordionItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildCategoryWebpageLinkingCollectionsWrapperPageRoutingCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildCategoryWebpageLinkingCollectionsWrapperPageRoutingCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildCategoryWebpageLinkingCollectionsWrapperPageRoutingCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildCategoryWebpageLinkingCollectionsWrapperPageRoutingCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BuildCategoryWebpageLinkingCollectionsPackCtaCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export enum BuildCategoryWebpageLinkingCollectionsPackCtaCursorCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export enum BuildCategoryWebpageLinkingCollectionsPackFooterItemCollectionOrder {
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BuildCategoryWebpageLinkingCollectionsPackFooterItemCursorCollectionOrder {
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BuildCategoryWebpageLinkingCollectionsPackNavBarCtaCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BuildCategoryWebpageLinkingCollectionsPackNavBarCtaCursorCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BuildCategoryWebpageLinkingCollectionsPackNavBarItemCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BuildCategoryWebpageLinkingCollectionsPackNavBarItemCursorCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BuildCategoryWebpageLinkingCollectionsPackNavBarItemV2CollectionOrder {
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BuildCategoryWebpageLinkingCollectionsPackNavBarItemV2CursorCollectionOrder {
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BuildCategoryWebpageLinkingCollectionsPackRecommendedContentAccordionItemCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BuildCategoryWebpageLinkingCollectionsPackRecommendedContentAccordionItemCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BuildCategoryWebpageLinkingCollectionsWrapperPageRoutingCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TemporaryOrPermanentAsc = 'temporaryOrPermanent_ASC',
  TemporaryOrPermanentDesc = 'temporaryOrPermanent_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export enum BuildCategoryWebpageLinkingCollectionsWrapperPageRoutingCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TemporaryOrPermanentAsc = 'temporaryOrPermanent_ASC',
  TemporaryOrPermanentDesc = 'temporaryOrPermanent_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export type BuildCategoryWebpageMasthead = PackPageStandard | WrapperPageRouting;

export enum BuildCategoryWebpageOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PathnameAsc = 'pathname_ASC',
  PathnameDesc = 'pathname_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildCustomerInformationCard) */
export type BuildCustomerInformationCard = Entry & _Node & {
  __typename?: 'BuildCustomerInformationCard';
  _id: Scalars['ID']['output'];
  actionCardsCollection?: Maybe<BuildCustomerInformationCardActionCardsCollection>;
  actionCardsCursorCollection?: Maybe<BuildCustomerInformationCardActionCardsCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<BuildCustomerInformationCardLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildCustomerInformationCard) */
export type BuildCustomerInformationCardActionCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildCustomerInformationCardActionCardsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentActionCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildCustomerInformationCard) */
export type BuildCustomerInformationCardActionCardsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildCustomerInformationCardActionCardsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentActionCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildCustomerInformationCard) */
export type BuildCustomerInformationCardInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildCustomerInformationCard) */
export type BuildCustomerInformationCardLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BuildCustomerInformationCardActionCardsCollection = {
  __typename?: 'BuildCustomerInformationCardActionCardsCollection';
  items: Array<Maybe<ComponentActionCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum BuildCustomerInformationCardActionCardsCollectionOrder {
  ActionCodeAsc = 'actionCode_ASC',
  ActionCodeDesc = 'actionCode_DESC',
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  CanBeDismissedAsc = 'canBeDismissed_ASC',
  CanBeDismissedDesc = 'canBeDismissed_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  DarkModeAsc = 'darkMode_ASC',
  DarkModeDesc = 'darkMode_DESC',
  InvertedAsc = 'inverted_ASC',
  InvertedDesc = 'inverted_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  NonRoundedEdgesAsc = 'nonRoundedEdges_ASC',
  NonRoundedEdgesDesc = 'nonRoundedEdges_DESC',
  OptimizelyFeatureFlagAsc = 'optimizelyFeatureFlag_ASC',
  OptimizelyFeatureFlagDesc = 'optimizelyFeatureFlag_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BuildCustomerInformationCardActionCardsCursorCollection = {
  __typename?: 'BuildCustomerInformationCardActionCardsCursorCollection';
  items: Array<Maybe<ComponentActionCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum BuildCustomerInformationCardActionCardsCursorCollectionOrder {
  ActionCodeAsc = 'actionCode_ASC',
  ActionCodeDesc = 'actionCode_DESC',
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  CanBeDismissedAsc = 'canBeDismissed_ASC',
  CanBeDismissedDesc = 'canBeDismissed_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  DarkModeAsc = 'darkMode_ASC',
  DarkModeDesc = 'darkMode_DESC',
  InvertedAsc = 'inverted_ASC',
  InvertedDesc = 'inverted_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  NonRoundedEdgesAsc = 'nonRoundedEdges_ASC',
  NonRoundedEdgesDesc = 'nonRoundedEdges_DESC',
  OptimizelyFeatureFlagAsc = 'optimizelyFeatureFlag_ASC',
  OptimizelyFeatureFlagDesc = 'optimizelyFeatureFlag_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BuildCustomerInformationCardCollection = {
  __typename?: 'BuildCustomerInformationCardCollection';
  items: Array<Maybe<BuildCustomerInformationCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BuildCustomerInformationCardCursorCollection = {
  __typename?: 'BuildCustomerInformationCardCursorCollection';
  items: Array<Maybe<BuildCustomerInformationCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BuildCustomerInformationCardFilter = {
  AND?: InputMaybe<Array<InputMaybe<BuildCustomerInformationCardFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BuildCustomerInformationCardFilter>>>;
  actionCards?: InputMaybe<CfComponentActionCardNestedFilter>;
  actionCardsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type BuildCustomerInformationCardLinkingCollections = {
  __typename?: 'BuildCustomerInformationCardLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildLandingpageCollection?: Maybe<BuildLandingpageCollection>;
  buildLandingpageCursorCollection?: Maybe<BuildLandingpageCursorCollection>;
  buildTariffPageCollection?: Maybe<BuildTariffPageCollection>;
  buildTariffPageCursorCollection?: Maybe<BuildTariffPageCursorCollection>;
  buildWebpageCollection?: Maybe<BuildWebpageCollection>;
  buildWebpageCursorCollection?: Maybe<BuildWebpageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type BuildCustomerInformationCardLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildCustomerInformationCardLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildCustomerInformationCardLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildCustomerInformationCardLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildCustomerInformationCardLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildCustomerInformationCardLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildCustomerInformationCardLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildCustomerInformationCardLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildCustomerInformationCardLinkingCollectionsBuildLandingpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildCustomerInformationCardLinkingCollectionsBuildLandingpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildCustomerInformationCardLinkingCollectionsBuildLandingpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildCustomerInformationCardLinkingCollectionsBuildLandingpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildCustomerInformationCardLinkingCollectionsBuildTariffPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildCustomerInformationCardLinkingCollectionsBuildTariffPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildCustomerInformationCardLinkingCollectionsBuildTariffPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildCustomerInformationCardLinkingCollectionsBuildTariffPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildCustomerInformationCardLinkingCollectionsBuildWebpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildCustomerInformationCardLinkingCollectionsBuildWebpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildCustomerInformationCardLinkingCollectionsBuildWebpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildCustomerInformationCardLinkingCollectionsBuildWebpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildCustomerInformationCardLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildCustomerInformationCardLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BuildCustomerInformationCardLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BuildCustomerInformationCardLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BuildCustomerInformationCardLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BuildCustomerInformationCardLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BuildCustomerInformationCardLinkingCollectionsBuildLandingpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BuildCustomerInformationCardLinkingCollectionsBuildLandingpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BuildCustomerInformationCardLinkingCollectionsBuildTariffPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BuildCustomerInformationCardLinkingCollectionsBuildTariffPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BuildCustomerInformationCardLinkingCollectionsBuildWebpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BuildCustomerInformationCardLinkingCollectionsBuildWebpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BuildCustomerInformationCardOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildFaQs) */
export type BuildFaQs = Entry & _Node & {
  __typename?: 'BuildFaQs';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<BuildFaQsLinkingCollections>;
  structuredTextCollection?: Maybe<BuildFaQsStructuredTextCollection>;
  structuredTextCursorCollection?: Maybe<BuildFaQsStructuredTextCursorCollection>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildFaQs) */
export type BuildFaQsInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildFaQs) */
export type BuildFaQsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildFaQs) */
export type BuildFaQsStructuredTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildFaQsStructuredTextCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackStructuredTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildFaQs) */
export type BuildFaQsStructuredTextCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildFaQsStructuredTextCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackStructuredTextFilter>;
};

export type BuildFaQsCollection = {
  __typename?: 'BuildFaQsCollection';
  items: Array<Maybe<BuildFaQs>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BuildFaQsCursorCollection = {
  __typename?: 'BuildFaQsCursorCollection';
  items: Array<Maybe<BuildFaQs>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BuildFaQsFilter = {
  AND?: InputMaybe<Array<InputMaybe<BuildFaQsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BuildFaQsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structuredText?: InputMaybe<CfPackStructuredTextNestedFilter>;
  structuredTextCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type BuildFaQsLinkingCollections = {
  __typename?: 'BuildFaQsLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type BuildFaQsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildFaQsLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BuildFaQsOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BuildFaQsStructuredTextCollection = {
  __typename?: 'BuildFaQsStructuredTextCollection';
  items: Array<Maybe<PackStructuredText>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum BuildFaQsStructuredTextCollectionOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BuildFaQsStructuredTextCursorCollection = {
  __typename?: 'BuildFaQsStructuredTextCursorCollection';
  items: Array<Maybe<PackStructuredText>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum BuildFaQsStructuredTextCursorCollectionOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildGenericTemplatePage) */
export type BuildGenericTemplatePage = Entry & _Node & {
  __typename?: 'BuildGenericTemplatePage';
  _id: Scalars['ID']['output'];
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  componentsCollection?: Maybe<BuildGenericTemplatePageComponentsCollection>;
  componentsCursorCollection?: Maybe<BuildGenericTemplatePageComponentsCursorCollection>;
  contactAndLinks?: Maybe<ComponentContactAndUsefulLinks>;
  contentfulMetadata: ContentfulMetadata;
  cta1?: Maybe<PackCta>;
  cta1Behaviour?: Maybe<Scalars['String']['output']>;
  cta1Type?: Maybe<Scalars['String']['output']>;
  cta2?: Maybe<PackCta>;
  cta2Behaviour?: Maybe<Scalars['String']['output']>;
  cta2Type?: Maybe<Scalars['String']['output']>;
  includeInSiteMap?: Maybe<Scalars['Boolean']['output']>;
  indexibility?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<BuildGenericTemplatePageLinkingCollections>;
  mainBanner?: Maybe<ComponentImageWithDescription>;
  masthead?: Maybe<BuildGenericTemplatePageMasthead>;
  mastheadLayout?: Maybe<Scalars['String']['output']>;
  nextReview?: Maybe<Scalars['DateTime']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildGenericTemplatePage) */
export type BuildGenericTemplatePageCanonicalUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildGenericTemplatePage) */
export type BuildGenericTemplatePageComponentsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildGenericTemplatePageComponentsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildGenericTemplatePage) */
export type BuildGenericTemplatePageComponentsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildGenericTemplatePageComponentsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildGenericTemplatePage) */
export type BuildGenericTemplatePageContactAndLinksArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentContactAndUsefulLinksFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildGenericTemplatePage) */
export type BuildGenericTemplatePageCta1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildGenericTemplatePage) */
export type BuildGenericTemplatePageCta1BehaviourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildGenericTemplatePage) */
export type BuildGenericTemplatePageCta1TypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildGenericTemplatePage) */
export type BuildGenericTemplatePageCta2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildGenericTemplatePage) */
export type BuildGenericTemplatePageCta2BehaviourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildGenericTemplatePage) */
export type BuildGenericTemplatePageCta2TypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildGenericTemplatePage) */
export type BuildGenericTemplatePageIncludeInSiteMapArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildGenericTemplatePage) */
export type BuildGenericTemplatePageIndexibilityArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildGenericTemplatePage) */
export type BuildGenericTemplatePageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildGenericTemplatePage) */
export type BuildGenericTemplatePageMainBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentImageWithDescriptionFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildGenericTemplatePage) */
export type BuildGenericTemplatePageMastheadArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildGenericTemplatePage) */
export type BuildGenericTemplatePageMastheadLayoutArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildGenericTemplatePage) */
export type BuildGenericTemplatePageNextReviewArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildGenericTemplatePage) */
export type BuildGenericTemplatePageSlugArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BuildGenericTemplatePageCollection = {
  __typename?: 'BuildGenericTemplatePageCollection';
  items: Array<Maybe<BuildGenericTemplatePage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BuildGenericTemplatePageComponentsCollection = {
  __typename?: 'BuildGenericTemplatePageComponentsCollection';
  items: Array<Maybe<BuildGenericTemplatePageComponentsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BuildGenericTemplatePageComponentsCursorCollection = {
  __typename?: 'BuildGenericTemplatePageComponentsCursorCollection';
  items: Array<Maybe<BuildGenericTemplatePageComponentsItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BuildGenericTemplatePageComponentsFilter = {
  AND?: InputMaybe<Array<InputMaybe<BuildGenericTemplatePageComponentsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BuildGenericTemplatePageComponentsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type BuildGenericTemplatePageComponentsItem = ComponentAccordion | ComponentCardGroup | ComponentContentBlock | ComponentDetailInfoSection | ComponentFootnotes | ComponentForm | ComponentGuidesRail | ComponentHelpAndCta | ComponentIframe | ComponentImageGallery | ComponentImageWithDescription | ComponentInfoGroup | ComponentLauncherGroup | ComponentLogoGroup | ComponentPostcodeFinder | ComponentProductGroup | ComponentProductRail | ComponentPromoCardRail | ComponentPromoSection | ComponentPromoTextCardSection | ComponentSectionSteps | ComponentTable | ComponentTariffCardGroup | ComponentTextAndCta | ComponentTrustpilot | ComponentUspGroup | ComponentVideoPlayer | VariationContainer;

export type BuildGenericTemplatePageCursorCollection = {
  __typename?: 'BuildGenericTemplatePageCursorCollection';
  items: Array<Maybe<BuildGenericTemplatePage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BuildGenericTemplatePageFilter = {
  AND?: InputMaybe<Array<InputMaybe<BuildGenericTemplatePageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BuildGenericTemplatePageFilter>>>;
  canonicalUrl?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_contains?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonicalUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonicalUrl_not?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  components?: InputMaybe<CfcomponentsMultiTypeNestedFilter>;
  componentsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contactAndLinks?: InputMaybe<CfComponentContactAndUsefulLinksNestedFilter>;
  contactAndLinks_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta1?: InputMaybe<CfPackCtaNestedFilter>;
  cta1Behaviour?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta1Behaviour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Behaviour_not?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Type?: InputMaybe<Scalars['String']['input']>;
  cta1Type_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta1Type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Type_not?: InputMaybe<Scalars['String']['input']>;
  cta1Type_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2?: InputMaybe<CfPackCtaNestedFilter>;
  cta2Behaviour?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2Behaviour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Behaviour_not?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Type?: InputMaybe<Scalars['String']['input']>;
  cta2Type_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2Type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Type_not?: InputMaybe<Scalars['String']['input']>;
  cta2Type_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  includeInSiteMap?: InputMaybe<Scalars['Boolean']['input']>;
  includeInSiteMap_exists?: InputMaybe<Scalars['Boolean']['input']>;
  includeInSiteMap_not?: InputMaybe<Scalars['Boolean']['input']>;
  indexibility?: InputMaybe<Scalars['String']['input']>;
  indexibility_contains?: InputMaybe<Scalars['String']['input']>;
  indexibility_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexibility_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  indexibility_not?: InputMaybe<Scalars['String']['input']>;
  indexibility_not_contains?: InputMaybe<Scalars['String']['input']>;
  indexibility_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainBanner?: InputMaybe<CfComponentImageWithDescriptionNestedFilter>;
  mainBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mastheadLayout?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_contains?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mastheadLayout_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mastheadLayout_not?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_not_contains?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  masthead_exists?: InputMaybe<Scalars['Boolean']['input']>;
  nextReview?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_exists?: InputMaybe<Scalars['Boolean']['input']>;
  nextReview_gt?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_gte?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nextReview_lt?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_lte?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_not?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type BuildGenericTemplatePageLinkingCollections = {
  __typename?: 'BuildGenericTemplatePageLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type BuildGenericTemplatePageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildGenericTemplatePageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BuildGenericTemplatePageMasthead = PackPageStandard | PackPageStandardV2 | WrapperPageRouting;

export enum BuildGenericTemplatePageOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildLandingpage) */
export type BuildLandingpage = Entry & _Node & {
  __typename?: 'BuildLandingpage';
  _id: Scalars['ID']['output'];
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  componentsCollection?: Maybe<BuildLandingpageComponentsCollection>;
  componentsCursorCollection?: Maybe<BuildLandingpageComponentsCursorCollection>;
  contactAndLinks?: Maybe<BuildLandingpageContactAndLinks>;
  contentfulMetadata: ContentfulMetadata;
  cta1?: Maybe<BuildLandingpageCta1>;
  cta1Behaviour?: Maybe<Scalars['String']['output']>;
  cta1Type?: Maybe<Scalars['String']['output']>;
  cta2?: Maybe<BuildLandingpageCta2>;
  cta2Behaviour?: Maybe<Scalars['String']['output']>;
  cta2Type?: Maybe<Scalars['String']['output']>;
  cta3?: Maybe<PackCta>;
  includeInSiteMap?: Maybe<Scalars['Boolean']['output']>;
  indexibility?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<BuildLandingpageLinkingCollections>;
  masthead?: Maybe<BuildLandingpageMasthead>;
  mastheadLayout?: Maybe<Scalars['String']['output']>;
  nextReview?: Maybe<Scalars['DateTime']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildLandingpage) */
export type BuildLandingpageCanonicalUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildLandingpage) */
export type BuildLandingpageComponentsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildLandingpageComponentsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildLandingpage) */
export type BuildLandingpageComponentsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildLandingpageComponentsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildLandingpage) */
export type BuildLandingpageContactAndLinksArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildLandingpage) */
export type BuildLandingpageCta1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildLandingpage) */
export type BuildLandingpageCta1BehaviourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildLandingpage) */
export type BuildLandingpageCta1TypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildLandingpage) */
export type BuildLandingpageCta2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildLandingpage) */
export type BuildLandingpageCta2BehaviourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildLandingpage) */
export type BuildLandingpageCta2TypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildLandingpage) */
export type BuildLandingpageCta3Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildLandingpage) */
export type BuildLandingpageIncludeInSiteMapArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildLandingpage) */
export type BuildLandingpageIndexibilityArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildLandingpage) */
export type BuildLandingpageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildLandingpage) */
export type BuildLandingpageMastheadArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildLandingpage) */
export type BuildLandingpageMastheadLayoutArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildLandingpage) */
export type BuildLandingpageNextReviewArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildLandingpage) */
export type BuildLandingpageSlugArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BuildLandingpageCollection = {
  __typename?: 'BuildLandingpageCollection';
  items: Array<Maybe<BuildLandingpage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BuildLandingpageComponentsCollection = {
  __typename?: 'BuildLandingpageComponentsCollection';
  items: Array<Maybe<BuildLandingpageComponentsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BuildLandingpageComponentsCursorCollection = {
  __typename?: 'BuildLandingpageComponentsCursorCollection';
  items: Array<Maybe<BuildLandingpageComponentsItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BuildLandingpageComponentsFilter = {
  AND?: InputMaybe<Array<InputMaybe<BuildLandingpageComponentsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BuildLandingpageComponentsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type BuildLandingpageComponentsItem = BuildCustomerInformationCard | ComponentAccordion | ComponentCallout | ComponentCardGrid | ComponentCarousel | ComponentContentBlock | ComponentCtaBanner | ComponentFootnotes | ComponentForm | ComponentGuidesRail | ComponentHelpAndCta | ComponentHelpHomepageDualLayout | ComponentIframe | ComponentPageHero | ComponentPostcodeFinder | ComponentProductGroup | ComponentPromoCardRail | ComponentQrCodePopup | ComponentSpotlightGrid | ComponentTable | ComponentTrustpilot | ComponentUspGroup | VariationContainer;

export type BuildLandingpageContactAndLinks = ComponentContactAndUsefulLinks | VariationContainer;

export type BuildLandingpageCta1 = PackCta | VariationContainer;

export type BuildLandingpageCta2 = PackCta | VariationContainer;

export type BuildLandingpageCursorCollection = {
  __typename?: 'BuildLandingpageCursorCollection';
  items: Array<Maybe<BuildLandingpage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BuildLandingpageFilter = {
  AND?: InputMaybe<Array<InputMaybe<BuildLandingpageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BuildLandingpageFilter>>>;
  canonicalUrl?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_contains?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonicalUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonicalUrl_not?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  components?: InputMaybe<CfcomponentsMultiTypeNestedFilter>;
  componentsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contactAndLinks_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta1Behaviour?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta1Behaviour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Behaviour_not?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Type?: InputMaybe<Scalars['String']['input']>;
  cta1Type_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta1Type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Type_not?: InputMaybe<Scalars['String']['input']>;
  cta1Type_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2Behaviour?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2Behaviour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Behaviour_not?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Type?: InputMaybe<Scalars['String']['input']>;
  cta2Type_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2Type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Type_not?: InputMaybe<Scalars['String']['input']>;
  cta2Type_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta3?: InputMaybe<CfPackCtaNestedFilter>;
  cta3_exists?: InputMaybe<Scalars['Boolean']['input']>;
  includeInSiteMap?: InputMaybe<Scalars['Boolean']['input']>;
  includeInSiteMap_exists?: InputMaybe<Scalars['Boolean']['input']>;
  includeInSiteMap_not?: InputMaybe<Scalars['Boolean']['input']>;
  indexibility?: InputMaybe<Scalars['String']['input']>;
  indexibility_contains?: InputMaybe<Scalars['String']['input']>;
  indexibility_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexibility_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  indexibility_not?: InputMaybe<Scalars['String']['input']>;
  indexibility_not_contains?: InputMaybe<Scalars['String']['input']>;
  indexibility_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mastheadLayout?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_contains?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mastheadLayout_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mastheadLayout_not?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_not_contains?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  masthead_exists?: InputMaybe<Scalars['Boolean']['input']>;
  nextReview?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_exists?: InputMaybe<Scalars['Boolean']['input']>;
  nextReview_gt?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_gte?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nextReview_lt?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_lte?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_not?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type BuildLandingpageLinkingCollections = {
  __typename?: 'BuildLandingpageLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type BuildLandingpageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildLandingpageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BuildLandingpageMasthead = PackHomePage | PackPageStandard | PackPageStandardV2 | VariationContainer | WrapperPageRouting;

export enum BuildLandingpageOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildNextBestAction) */
export type BuildNextBestAction = Entry & _Node & {
  __typename?: 'BuildNextBestAction';
  _id: Scalars['ID']['output'];
  actionCardsCollection?: Maybe<BuildNextBestActionActionCardsCollection>;
  actionCardsCursorCollection?: Maybe<BuildNextBestActionActionCardsCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<BuildNextBestActionLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildNextBestAction) */
export type BuildNextBestActionActionCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildNextBestActionActionCardsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentActionCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildNextBestAction) */
export type BuildNextBestActionActionCardsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildNextBestActionActionCardsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentActionCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildNextBestAction) */
export type BuildNextBestActionInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildNextBestAction) */
export type BuildNextBestActionLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BuildNextBestActionActionCardsCollection = {
  __typename?: 'BuildNextBestActionActionCardsCollection';
  items: Array<Maybe<ComponentActionCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum BuildNextBestActionActionCardsCollectionOrder {
  ActionCodeAsc = 'actionCode_ASC',
  ActionCodeDesc = 'actionCode_DESC',
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  CanBeDismissedAsc = 'canBeDismissed_ASC',
  CanBeDismissedDesc = 'canBeDismissed_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  DarkModeAsc = 'darkMode_ASC',
  DarkModeDesc = 'darkMode_DESC',
  InvertedAsc = 'inverted_ASC',
  InvertedDesc = 'inverted_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  NonRoundedEdgesAsc = 'nonRoundedEdges_ASC',
  NonRoundedEdgesDesc = 'nonRoundedEdges_DESC',
  OptimizelyFeatureFlagAsc = 'optimizelyFeatureFlag_ASC',
  OptimizelyFeatureFlagDesc = 'optimizelyFeatureFlag_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BuildNextBestActionActionCardsCursorCollection = {
  __typename?: 'BuildNextBestActionActionCardsCursorCollection';
  items: Array<Maybe<ComponentActionCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum BuildNextBestActionActionCardsCursorCollectionOrder {
  ActionCodeAsc = 'actionCode_ASC',
  ActionCodeDesc = 'actionCode_DESC',
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  CanBeDismissedAsc = 'canBeDismissed_ASC',
  CanBeDismissedDesc = 'canBeDismissed_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  DarkModeAsc = 'darkMode_ASC',
  DarkModeDesc = 'darkMode_DESC',
  InvertedAsc = 'inverted_ASC',
  InvertedDesc = 'inverted_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  NonRoundedEdgesAsc = 'nonRoundedEdges_ASC',
  NonRoundedEdgesDesc = 'nonRoundedEdges_DESC',
  OptimizelyFeatureFlagAsc = 'optimizelyFeatureFlag_ASC',
  OptimizelyFeatureFlagDesc = 'optimizelyFeatureFlag_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BuildNextBestActionCollection = {
  __typename?: 'BuildNextBestActionCollection';
  items: Array<Maybe<BuildNextBestAction>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BuildNextBestActionCursorCollection = {
  __typename?: 'BuildNextBestActionCursorCollection';
  items: Array<Maybe<BuildNextBestAction>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BuildNextBestActionFilter = {
  AND?: InputMaybe<Array<InputMaybe<BuildNextBestActionFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BuildNextBestActionFilter>>>;
  actionCards?: InputMaybe<CfComponentActionCardNestedFilter>;
  actionCardsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type BuildNextBestActionLinkingCollections = {
  __typename?: 'BuildNextBestActionLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type BuildNextBestActionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildNextBestActionLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BuildNextBestActionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildProductDetailPage) */
export type BuildProductDetailPage = Entry & _Node & {
  __typename?: 'BuildProductDetailPage';
  _id: Scalars['ID']['output'];
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  componentsCollection?: Maybe<BuildProductDetailPageComponentsCollection>;
  componentsCursorCollection?: Maybe<BuildProductDetailPageComponentsCursorCollection>;
  contactAndLinks?: Maybe<ComponentContactAndUsefulLinks>;
  contentfulMetadata: ContentfulMetadata;
  cta1?: Maybe<PackCta>;
  cta1Behaviour?: Maybe<Scalars['String']['output']>;
  cta1Type?: Maybe<Scalars['String']['output']>;
  cta2?: Maybe<PackCta>;
  cta2Behaviour?: Maybe<Scalars['String']['output']>;
  cta2Type?: Maybe<Scalars['String']['output']>;
  includeInSiteMap?: Maybe<Scalars['Boolean']['output']>;
  indexibility?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<BuildProductDetailPageLinkingCollections>;
  masthead?: Maybe<BuildProductDetailPageMasthead>;
  mastheadLayout?: Maybe<Scalars['String']['output']>;
  nextReview?: Maybe<Scalars['DateTime']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildProductDetailPage) */
export type BuildProductDetailPageCanonicalUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildProductDetailPage) */
export type BuildProductDetailPageComponentsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildProductDetailPageComponentsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildProductDetailPage) */
export type BuildProductDetailPageComponentsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildProductDetailPageComponentsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildProductDetailPage) */
export type BuildProductDetailPageContactAndLinksArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentContactAndUsefulLinksFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildProductDetailPage) */
export type BuildProductDetailPageCta1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildProductDetailPage) */
export type BuildProductDetailPageCta1BehaviourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildProductDetailPage) */
export type BuildProductDetailPageCta1TypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildProductDetailPage) */
export type BuildProductDetailPageCta2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildProductDetailPage) */
export type BuildProductDetailPageCta2BehaviourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildProductDetailPage) */
export type BuildProductDetailPageCta2TypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildProductDetailPage) */
export type BuildProductDetailPageIncludeInSiteMapArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildProductDetailPage) */
export type BuildProductDetailPageIndexibilityArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildProductDetailPage) */
export type BuildProductDetailPageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildProductDetailPage) */
export type BuildProductDetailPageMastheadArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildProductDetailPage) */
export type BuildProductDetailPageMastheadLayoutArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildProductDetailPage) */
export type BuildProductDetailPageNextReviewArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildProductDetailPage) */
export type BuildProductDetailPageSlugArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BuildProductDetailPageCollection = {
  __typename?: 'BuildProductDetailPageCollection';
  items: Array<Maybe<BuildProductDetailPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BuildProductDetailPageComponentsCollection = {
  __typename?: 'BuildProductDetailPageComponentsCollection';
  items: Array<Maybe<BuildProductDetailPageComponentsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BuildProductDetailPageComponentsCursorCollection = {
  __typename?: 'BuildProductDetailPageComponentsCursorCollection';
  items: Array<Maybe<BuildProductDetailPageComponentsItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BuildProductDetailPageComponentsFilter = {
  AND?: InputMaybe<Array<InputMaybe<BuildProductDetailPageComponentsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BuildProductDetailPageComponentsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type BuildProductDetailPageComponentsItem = ComponentAccordion | ComponentCardGroup | ComponentContentBlock | ComponentDetailInfoSection | ComponentFootnotes | ComponentForm | ComponentGuidesRail | ComponentHelpAndCta | ComponentIframe | ComponentImageGallery | ComponentImageWithDescription | ComponentInfoGroup | ComponentLauncherGroup | ComponentPostcodeFinder | ComponentProductRail | ComponentPromoTextCardSection | ComponentSectionSteps | ComponentTable | ComponentTariffCardGroup | ComponentTextAndCta | ComponentTrustpilot | ComponentUspGroup | ComponentVideoPlayer;

export type BuildProductDetailPageCursorCollection = {
  __typename?: 'BuildProductDetailPageCursorCollection';
  items: Array<Maybe<BuildProductDetailPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BuildProductDetailPageFilter = {
  AND?: InputMaybe<Array<InputMaybe<BuildProductDetailPageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BuildProductDetailPageFilter>>>;
  canonicalUrl?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_contains?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonicalUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonicalUrl_not?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  components?: InputMaybe<CfcomponentsMultiTypeNestedFilter>;
  componentsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contactAndLinks?: InputMaybe<CfComponentContactAndUsefulLinksNestedFilter>;
  contactAndLinks_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta1?: InputMaybe<CfPackCtaNestedFilter>;
  cta1Behaviour?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta1Behaviour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Behaviour_not?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Type?: InputMaybe<Scalars['String']['input']>;
  cta1Type_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta1Type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Type_not?: InputMaybe<Scalars['String']['input']>;
  cta1Type_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2?: InputMaybe<CfPackCtaNestedFilter>;
  cta2Behaviour?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2Behaviour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Behaviour_not?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Type?: InputMaybe<Scalars['String']['input']>;
  cta2Type_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2Type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Type_not?: InputMaybe<Scalars['String']['input']>;
  cta2Type_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  includeInSiteMap?: InputMaybe<Scalars['Boolean']['input']>;
  includeInSiteMap_exists?: InputMaybe<Scalars['Boolean']['input']>;
  includeInSiteMap_not?: InputMaybe<Scalars['Boolean']['input']>;
  indexibility?: InputMaybe<Scalars['String']['input']>;
  indexibility_contains?: InputMaybe<Scalars['String']['input']>;
  indexibility_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexibility_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  indexibility_not?: InputMaybe<Scalars['String']['input']>;
  indexibility_not_contains?: InputMaybe<Scalars['String']['input']>;
  indexibility_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mastheadLayout?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_contains?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mastheadLayout_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mastheadLayout_not?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_not_contains?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  masthead_exists?: InputMaybe<Scalars['Boolean']['input']>;
  nextReview?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_exists?: InputMaybe<Scalars['Boolean']['input']>;
  nextReview_gt?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_gte?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nextReview_lt?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_lte?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_not?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type BuildProductDetailPageLinkingCollections = {
  __typename?: 'BuildProductDetailPageLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type BuildProductDetailPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildProductDetailPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BuildProductDetailPageMasthead = PackPageProductDetail | WrapperPageRouting;

export enum BuildProductDetailPageOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildProductOverviewPage) */
export type BuildProductOverviewPage = Entry & _Node & {
  __typename?: 'BuildProductOverviewPage';
  _id: Scalars['ID']['output'];
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  componentsCollection?: Maybe<BuildProductOverviewPageComponentsCollection>;
  componentsCursorCollection?: Maybe<BuildProductOverviewPageComponentsCursorCollection>;
  contactAndLinks?: Maybe<ComponentContactAndUsefulLinks>;
  contentfulMetadata: ContentfulMetadata;
  cta1?: Maybe<PackCta>;
  cta1Behaviour?: Maybe<Scalars['String']['output']>;
  cta1Type?: Maybe<Scalars['String']['output']>;
  cta2?: Maybe<PackCta>;
  cta2Behaviour?: Maybe<Scalars['String']['output']>;
  cta2Type?: Maybe<Scalars['String']['output']>;
  includeInSiteMap?: Maybe<Scalars['Boolean']['output']>;
  indexibility?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<BuildProductOverviewPageLinkingCollections>;
  masthead?: Maybe<BuildProductOverviewPageMasthead>;
  mastheadLayout?: Maybe<Scalars['String']['output']>;
  nextReview?: Maybe<Scalars['DateTime']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildProductOverviewPage) */
export type BuildProductOverviewPageCanonicalUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildProductOverviewPage) */
export type BuildProductOverviewPageComponentsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildProductOverviewPageComponentsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildProductOverviewPage) */
export type BuildProductOverviewPageComponentsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildProductOverviewPageComponentsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildProductOverviewPage) */
export type BuildProductOverviewPageContactAndLinksArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentContactAndUsefulLinksFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildProductOverviewPage) */
export type BuildProductOverviewPageCta1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildProductOverviewPage) */
export type BuildProductOverviewPageCta1BehaviourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildProductOverviewPage) */
export type BuildProductOverviewPageCta1TypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildProductOverviewPage) */
export type BuildProductOverviewPageCta2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildProductOverviewPage) */
export type BuildProductOverviewPageCta2BehaviourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildProductOverviewPage) */
export type BuildProductOverviewPageCta2TypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildProductOverviewPage) */
export type BuildProductOverviewPageIncludeInSiteMapArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildProductOverviewPage) */
export type BuildProductOverviewPageIndexibilityArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildProductOverviewPage) */
export type BuildProductOverviewPageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildProductOverviewPage) */
export type BuildProductOverviewPageMastheadArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildProductOverviewPage) */
export type BuildProductOverviewPageMastheadLayoutArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildProductOverviewPage) */
export type BuildProductOverviewPageNextReviewArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildProductOverviewPage) */
export type BuildProductOverviewPageSlugArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BuildProductOverviewPageCollection = {
  __typename?: 'BuildProductOverviewPageCollection';
  items: Array<Maybe<BuildProductOverviewPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BuildProductOverviewPageComponentsCollection = {
  __typename?: 'BuildProductOverviewPageComponentsCollection';
  items: Array<Maybe<BuildProductOverviewPageComponentsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BuildProductOverviewPageComponentsCursorCollection = {
  __typename?: 'BuildProductOverviewPageComponentsCursorCollection';
  items: Array<Maybe<BuildProductOverviewPageComponentsItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BuildProductOverviewPageComponentsFilter = {
  AND?: InputMaybe<Array<InputMaybe<BuildProductOverviewPageComponentsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BuildProductOverviewPageComponentsFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type BuildProductOverviewPageComponentsItem = ComponentContentBlock | ComponentDetailInfoSection | ComponentFootnotes | ComponentGuidesRail | ComponentHelpAndCta | ComponentImageWithDescription | ComponentInfoGroup | ComponentLauncherGroup | ComponentPromoTextCardSection | ComponentTextAndCta | ComponentVideoPlayer;

export type BuildProductOverviewPageCursorCollection = {
  __typename?: 'BuildProductOverviewPageCursorCollection';
  items: Array<Maybe<BuildProductOverviewPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BuildProductOverviewPageFilter = {
  AND?: InputMaybe<Array<InputMaybe<BuildProductOverviewPageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BuildProductOverviewPageFilter>>>;
  canonicalUrl?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_contains?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonicalUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonicalUrl_not?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  components?: InputMaybe<CfcomponentsMultiTypeNestedFilter>;
  componentsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contactAndLinks?: InputMaybe<CfComponentContactAndUsefulLinksNestedFilter>;
  contactAndLinks_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta1?: InputMaybe<CfPackCtaNestedFilter>;
  cta1Behaviour?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta1Behaviour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Behaviour_not?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Type?: InputMaybe<Scalars['String']['input']>;
  cta1Type_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta1Type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Type_not?: InputMaybe<Scalars['String']['input']>;
  cta1Type_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2?: InputMaybe<CfPackCtaNestedFilter>;
  cta2Behaviour?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2Behaviour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Behaviour_not?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Type?: InputMaybe<Scalars['String']['input']>;
  cta2Type_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2Type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Type_not?: InputMaybe<Scalars['String']['input']>;
  cta2Type_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  includeInSiteMap?: InputMaybe<Scalars['Boolean']['input']>;
  includeInSiteMap_exists?: InputMaybe<Scalars['Boolean']['input']>;
  includeInSiteMap_not?: InputMaybe<Scalars['Boolean']['input']>;
  indexibility?: InputMaybe<Scalars['String']['input']>;
  indexibility_contains?: InputMaybe<Scalars['String']['input']>;
  indexibility_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexibility_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  indexibility_not?: InputMaybe<Scalars['String']['input']>;
  indexibility_not_contains?: InputMaybe<Scalars['String']['input']>;
  indexibility_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mastheadLayout?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_contains?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mastheadLayout_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mastheadLayout_not?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_not_contains?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  masthead_exists?: InputMaybe<Scalars['Boolean']['input']>;
  nextReview?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_exists?: InputMaybe<Scalars['Boolean']['input']>;
  nextReview_gt?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_gte?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nextReview_lt?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_lte?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_not?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type BuildProductOverviewPageLinkingCollections = {
  __typename?: 'BuildProductOverviewPageLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type BuildProductOverviewPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildProductOverviewPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BuildProductOverviewPageMasthead = PackCampaignPage | PackPageStandard | PackPageStandardV2 | WrapperPageRouting;

export enum BuildProductOverviewPageOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildRecommendedContent) */
export type BuildRecommendedContent = Entry & _Node & {
  __typename?: 'BuildRecommendedContent';
  _id: Scalars['ID']['output'];
  annotation?: Maybe<Scalars['String']['output']>;
  baseContentWebCollection?: Maybe<BuildRecommendedContentBaseContentWebCollection>;
  baseContentWebCursorCollection?: Maybe<BuildRecommendedContentBaseContentWebCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  image?: Maybe<WrapperImage>;
  linkedFrom?: Maybe<BuildRecommendedContentLinkingCollections>;
  optionalContentWebCollection?: Maybe<BuildRecommendedContentOptionalContentWebCollection>;
  optionalContentWebCursorCollection?: Maybe<BuildRecommendedContentOptionalContentWebCursorCollection>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildRecommendedContent) */
export type BuildRecommendedContentAnnotationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildRecommendedContent) */
export type BuildRecommendedContentBaseContentWebCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildRecommendedContentBaseContentWebCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<IntegrationOptimizelyFlagFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildRecommendedContent) */
export type BuildRecommendedContentBaseContentWebCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildRecommendedContentBaseContentWebCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<IntegrationOptimizelyFlagFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildRecommendedContent) */
export type BuildRecommendedContentImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildRecommendedContent) */
export type BuildRecommendedContentLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildRecommendedContent) */
export type BuildRecommendedContentOptionalContentWebCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildRecommendedContentOptionalContentWebCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<IntegrationOptimizelyFlagFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildRecommendedContent) */
export type BuildRecommendedContentOptionalContentWebCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildRecommendedContentOptionalContentWebCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<IntegrationOptimizelyFlagFilter>;
};

export type BuildRecommendedContentBaseContentWebCollection = {
  __typename?: 'BuildRecommendedContentBaseContentWebCollection';
  items: Array<Maybe<IntegrationOptimizelyFlag>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum BuildRecommendedContentBaseContentWebCollectionOrder {
  IdentifierAsc = 'identifier_ASC',
  IdentifierDesc = 'identifier_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BuildRecommendedContentBaseContentWebCursorCollection = {
  __typename?: 'BuildRecommendedContentBaseContentWebCursorCollection';
  items: Array<Maybe<IntegrationOptimizelyFlag>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum BuildRecommendedContentBaseContentWebCursorCollectionOrder {
  IdentifierAsc = 'identifier_ASC',
  IdentifierDesc = 'identifier_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BuildRecommendedContentCollection = {
  __typename?: 'BuildRecommendedContentCollection';
  items: Array<Maybe<BuildRecommendedContent>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BuildRecommendedContentCursorCollection = {
  __typename?: 'BuildRecommendedContentCursorCollection';
  items: Array<Maybe<BuildRecommendedContent>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BuildRecommendedContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<BuildRecommendedContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BuildRecommendedContentFilter>>>;
  annotation?: InputMaybe<Scalars['String']['input']>;
  annotation_contains?: InputMaybe<Scalars['String']['input']>;
  annotation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  annotation_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  annotation_not?: InputMaybe<Scalars['String']['input']>;
  annotation_not_contains?: InputMaybe<Scalars['String']['input']>;
  annotation_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  baseContentWeb?: InputMaybe<CfIntegrationOptimizelyFlagNestedFilter>;
  baseContentWebCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image?: InputMaybe<CfWrapperImageNestedFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  optionalContentWeb?: InputMaybe<CfIntegrationOptimizelyFlagNestedFilter>;
  optionalContentWebCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type BuildRecommendedContentLinkingCollections = {
  __typename?: 'BuildRecommendedContentLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type BuildRecommendedContentLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildRecommendedContentLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BuildRecommendedContentOptionalContentWebCollection = {
  __typename?: 'BuildRecommendedContentOptionalContentWebCollection';
  items: Array<Maybe<IntegrationOptimizelyFlag>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum BuildRecommendedContentOptionalContentWebCollectionOrder {
  IdentifierAsc = 'identifier_ASC',
  IdentifierDesc = 'identifier_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BuildRecommendedContentOptionalContentWebCursorCollection = {
  __typename?: 'BuildRecommendedContentOptionalContentWebCursorCollection';
  items: Array<Maybe<IntegrationOptimizelyFlag>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum BuildRecommendedContentOptionalContentWebCursorCollectionOrder {
  IdentifierAsc = 'identifier_ASC',
  IdentifierDesc = 'identifier_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BuildRecommendedContentOrder {
  AnnotationAsc = 'annotation_ASC',
  AnnotationDesc = 'annotation_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildTariffPage) */
export type BuildTariffPage = Entry & _Node & {
  __typename?: 'BuildTariffPage';
  _id: Scalars['ID']['output'];
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  componentsCollection?: Maybe<BuildTariffPageComponentsCollection>;
  componentsCursorCollection?: Maybe<BuildTariffPageComponentsCursorCollection>;
  contactAndLinks?: Maybe<ComponentContactAndUsefulLinks>;
  contentfulMetadata: ContentfulMetadata;
  cta1?: Maybe<PackCta>;
  cta1Behaviour?: Maybe<Scalars['String']['output']>;
  cta1Type?: Maybe<Scalars['String']['output']>;
  cta2?: Maybe<PackCta>;
  cta2Behaviour?: Maybe<Scalars['String']['output']>;
  cta2Type?: Maybe<Scalars['String']['output']>;
  includeInSiteMap?: Maybe<Scalars['Boolean']['output']>;
  indexibility?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<BuildTariffPageLinkingCollections>;
  masthead?: Maybe<BuildTariffPageMasthead>;
  mastheadLayout?: Maybe<Scalars['String']['output']>;
  nextReview?: Maybe<Scalars['DateTime']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildTariffPage) */
export type BuildTariffPageCanonicalUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildTariffPage) */
export type BuildTariffPageComponentsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildTariffPageComponentsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildTariffPage) */
export type BuildTariffPageComponentsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildTariffPageComponentsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildTariffPage) */
export type BuildTariffPageContactAndLinksArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentContactAndUsefulLinksFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildTariffPage) */
export type BuildTariffPageCta1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildTariffPage) */
export type BuildTariffPageCta1BehaviourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildTariffPage) */
export type BuildTariffPageCta1TypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildTariffPage) */
export type BuildTariffPageCta2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildTariffPage) */
export type BuildTariffPageCta2BehaviourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildTariffPage) */
export type BuildTariffPageCta2TypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildTariffPage) */
export type BuildTariffPageIncludeInSiteMapArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildTariffPage) */
export type BuildTariffPageIndexibilityArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildTariffPage) */
export type BuildTariffPageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildTariffPage) */
export type BuildTariffPageMastheadArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildTariffPage) */
export type BuildTariffPageMastheadLayoutArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildTariffPage) */
export type BuildTariffPageNextReviewArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildTariffPage) */
export type BuildTariffPageSlugArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BuildTariffPageCollection = {
  __typename?: 'BuildTariffPageCollection';
  items: Array<Maybe<BuildTariffPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BuildTariffPageComponentsCollection = {
  __typename?: 'BuildTariffPageComponentsCollection';
  items: Array<Maybe<BuildTariffPageComponentsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BuildTariffPageComponentsCursorCollection = {
  __typename?: 'BuildTariffPageComponentsCursorCollection';
  items: Array<Maybe<BuildTariffPageComponentsItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BuildTariffPageComponentsFilter = {
  AND?: InputMaybe<Array<InputMaybe<BuildTariffPageComponentsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BuildTariffPageComponentsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type BuildTariffPageComponentsItem = BuildCustomerInformationCard | ComponentAccordion | ComponentCallout | ComponentCardGrid | ComponentCardGroup | ComponentCarousel | ComponentContentBlock | ComponentCtaBanner | ComponentDetailInfoSection | ComponentFootnotes | ComponentForm | ComponentGuidesRail | ComponentHelpAndCta | ComponentHelpHomepageDualLayout | ComponentPageHero | ComponentPostcodeFinder | ComponentProductGroup | ComponentPromoCardRail | ComponentQrCodePopup | ComponentSpotlightGrid | ComponentTable | ComponentTariffCardGroup | ComponentTariffHero | ComponentTextAndCta | ComponentTrustpilot | ComponentUspGroup | ComponentVideoPlayer | VariationContainer;

export type BuildTariffPageCursorCollection = {
  __typename?: 'BuildTariffPageCursorCollection';
  items: Array<Maybe<BuildTariffPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BuildTariffPageFilter = {
  AND?: InputMaybe<Array<InputMaybe<BuildTariffPageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BuildTariffPageFilter>>>;
  canonicalUrl?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_contains?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonicalUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonicalUrl_not?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  components?: InputMaybe<CfcomponentsMultiTypeNestedFilter>;
  componentsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contactAndLinks?: InputMaybe<CfComponentContactAndUsefulLinksNestedFilter>;
  contactAndLinks_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta1?: InputMaybe<CfPackCtaNestedFilter>;
  cta1Behaviour?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta1Behaviour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Behaviour_not?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Type?: InputMaybe<Scalars['String']['input']>;
  cta1Type_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta1Type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Type_not?: InputMaybe<Scalars['String']['input']>;
  cta1Type_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2?: InputMaybe<CfPackCtaNestedFilter>;
  cta2Behaviour?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2Behaviour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Behaviour_not?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Type?: InputMaybe<Scalars['String']['input']>;
  cta2Type_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2Type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Type_not?: InputMaybe<Scalars['String']['input']>;
  cta2Type_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  includeInSiteMap?: InputMaybe<Scalars['Boolean']['input']>;
  includeInSiteMap_exists?: InputMaybe<Scalars['Boolean']['input']>;
  includeInSiteMap_not?: InputMaybe<Scalars['Boolean']['input']>;
  indexibility?: InputMaybe<Scalars['String']['input']>;
  indexibility_contains?: InputMaybe<Scalars['String']['input']>;
  indexibility_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexibility_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  indexibility_not?: InputMaybe<Scalars['String']['input']>;
  indexibility_not_contains?: InputMaybe<Scalars['String']['input']>;
  indexibility_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mastheadLayout?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_contains?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mastheadLayout_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mastheadLayout_not?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_not_contains?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  masthead_exists?: InputMaybe<Scalars['Boolean']['input']>;
  nextReview?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_exists?: InputMaybe<Scalars['Boolean']['input']>;
  nextReview_gt?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_gte?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nextReview_lt?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_lte?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_not?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type BuildTariffPageLinkingCollections = {
  __typename?: 'BuildTariffPageLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type BuildTariffPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildTariffPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BuildTariffPageMasthead = PackHomePage | PackPageStandard | PackPageStandardV2 | WrapperPageRouting;

export enum BuildTariffPageOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildWebpage) */
export type BuildWebpage = Entry & _Node & {
  __typename?: 'BuildWebpage';
  _id: Scalars['ID']['output'];
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  categoryCollection?: Maybe<BuildWebpageCategoryCollection>;
  categoryCursorCollection?: Maybe<BuildWebpageCategoryCursorCollection>;
  componentsCollection?: Maybe<BuildWebpageComponentsCollection>;
  componentsCursorCollection?: Maybe<BuildWebpageComponentsCursorCollection>;
  contactAndLinks?: Maybe<ComponentContactAndUsefulLinks>;
  contentfulMetadata: ContentfulMetadata;
  cta1?: Maybe<PackCta>;
  cta1Behaviour?: Maybe<Scalars['String']['output']>;
  cta1Type?: Maybe<Scalars['String']['output']>;
  cta2?: Maybe<PackCta>;
  cta2Behaviour?: Maybe<Scalars['String']['output']>;
  cta2Type?: Maybe<Scalars['String']['output']>;
  includeInSiteMap?: Maybe<Scalars['Boolean']['output']>;
  indexibility?: Maybe<Scalars['String']['output']>;
  jiraStoryNumber?: Maybe<Scalars['Int']['output']>;
  linkedFrom?: Maybe<BuildWebpageLinkingCollections>;
  masthead?: Maybe<BuildWebpageMasthead>;
  mastheadLayout?: Maybe<Scalars['String']['output']>;
  nextReview?: Maybe<Scalars['DateTime']['output']>;
  showInCategoryList?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildWebpage) */
export type BuildWebpageCanonicalUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildWebpage) */
export type BuildWebpageCategoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildWebpageCategoryCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCategoryFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildWebpage) */
export type BuildWebpageCategoryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildWebpageCategoryCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCategoryFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildWebpage) */
export type BuildWebpageComponentsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildWebpageComponentsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildWebpage) */
export type BuildWebpageComponentsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildWebpageComponentsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildWebpage) */
export type BuildWebpageContactAndLinksArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentContactAndUsefulLinksFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildWebpage) */
export type BuildWebpageCta1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildWebpage) */
export type BuildWebpageCta1BehaviourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildWebpage) */
export type BuildWebpageCta1TypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildWebpage) */
export type BuildWebpageCta2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildWebpage) */
export type BuildWebpageCta2BehaviourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildWebpage) */
export type BuildWebpageCta2TypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildWebpage) */
export type BuildWebpageIncludeInSiteMapArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildWebpage) */
export type BuildWebpageIndexibilityArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildWebpage) */
export type BuildWebpageJiraStoryNumberArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildWebpage) */
export type BuildWebpageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildWebpage) */
export type BuildWebpageMastheadArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildWebpage) */
export type BuildWebpageMastheadLayoutArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildWebpage) */
export type BuildWebpageNextReviewArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildWebpage) */
export type BuildWebpageShowInCategoryListArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/buildWebpage) */
export type BuildWebpageSlugArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BuildWebpageCategoryCollection = {
  __typename?: 'BuildWebpageCategoryCollection';
  items: Array<Maybe<PackCategory>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum BuildWebpageCategoryCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BuildWebpageCategoryCursorCollection = {
  __typename?: 'BuildWebpageCategoryCursorCollection';
  items: Array<Maybe<PackCategory>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum BuildWebpageCategoryCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BuildWebpageCollection = {
  __typename?: 'BuildWebpageCollection';
  items: Array<Maybe<BuildWebpage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BuildWebpageComponentsCollection = {
  __typename?: 'BuildWebpageComponentsCollection';
  items: Array<Maybe<BuildWebpageComponentsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BuildWebpageComponentsCursorCollection = {
  __typename?: 'BuildWebpageComponentsCursorCollection';
  items: Array<Maybe<BuildWebpageComponentsItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BuildWebpageComponentsFilter = {
  AND?: InputMaybe<Array<InputMaybe<BuildWebpageComponentsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BuildWebpageComponentsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type BuildWebpageComponentsItem = BuildCustomerInformationCard | ComponentAccordion | ComponentCallout | ComponentCardGrid | ComponentContentBlock | ComponentCtaBanner | ComponentFootnotes | ComponentForm | ComponentHelpAndCta | ComponentHelpHomepageDualLayout | ComponentSpotlightGrid | ComponentTable | ComponentVideoPlayer;

export type BuildWebpageCursorCollection = {
  __typename?: 'BuildWebpageCursorCollection';
  items: Array<Maybe<BuildWebpage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BuildWebpageFilter = {
  AND?: InputMaybe<Array<InputMaybe<BuildWebpageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BuildWebpageFilter>>>;
  canonicalUrl?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_contains?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonicalUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonicalUrl_not?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category?: InputMaybe<CfPackCategoryNestedFilter>;
  categoryCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  components?: InputMaybe<CfcomponentsMultiTypeNestedFilter>;
  componentsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contactAndLinks?: InputMaybe<CfComponentContactAndUsefulLinksNestedFilter>;
  contactAndLinks_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta1?: InputMaybe<CfPackCtaNestedFilter>;
  cta1Behaviour?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta1Behaviour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Behaviour_not?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Type?: InputMaybe<Scalars['String']['input']>;
  cta1Type_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta1Type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Type_not?: InputMaybe<Scalars['String']['input']>;
  cta1Type_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2?: InputMaybe<CfPackCtaNestedFilter>;
  cta2Behaviour?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2Behaviour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Behaviour_not?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Type?: InputMaybe<Scalars['String']['input']>;
  cta2Type_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2Type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Type_not?: InputMaybe<Scalars['String']['input']>;
  cta2Type_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  includeInSiteMap?: InputMaybe<Scalars['Boolean']['input']>;
  includeInSiteMap_exists?: InputMaybe<Scalars['Boolean']['input']>;
  includeInSiteMap_not?: InputMaybe<Scalars['Boolean']['input']>;
  indexibility?: InputMaybe<Scalars['String']['input']>;
  indexibility_contains?: InputMaybe<Scalars['String']['input']>;
  indexibility_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexibility_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  indexibility_not?: InputMaybe<Scalars['String']['input']>;
  indexibility_not_contains?: InputMaybe<Scalars['String']['input']>;
  indexibility_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  jiraStoryNumber?: InputMaybe<Scalars['Int']['input']>;
  jiraStoryNumber_exists?: InputMaybe<Scalars['Boolean']['input']>;
  jiraStoryNumber_gt?: InputMaybe<Scalars['Int']['input']>;
  jiraStoryNumber_gte?: InputMaybe<Scalars['Int']['input']>;
  jiraStoryNumber_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  jiraStoryNumber_lt?: InputMaybe<Scalars['Int']['input']>;
  jiraStoryNumber_lte?: InputMaybe<Scalars['Int']['input']>;
  jiraStoryNumber_not?: InputMaybe<Scalars['Int']['input']>;
  jiraStoryNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  mastheadLayout?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_contains?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mastheadLayout_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mastheadLayout_not?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_not_contains?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  masthead_exists?: InputMaybe<Scalars['Boolean']['input']>;
  nextReview?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_exists?: InputMaybe<Scalars['Boolean']['input']>;
  nextReview_gt?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_gte?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nextReview_lt?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_lte?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_not?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  showInCategoryList?: InputMaybe<Scalars['Boolean']['input']>;
  showInCategoryList_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showInCategoryList_not?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type BuildWebpageLinkingCollections = {
  __typename?: 'BuildWebpageLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  packCtaCollection?: Maybe<PackCtaCollection>;
  packCtaCursorCollection?: Maybe<PackCtaCursorCollection>;
  packFooterItemCollection?: Maybe<PackFooterItemCollection>;
  packFooterItemCursorCollection?: Maybe<PackFooterItemCursorCollection>;
  packNavBarCtaCollection?: Maybe<PackNavBarCtaCollection>;
  packNavBarCtaCursorCollection?: Maybe<PackNavBarCtaCursorCollection>;
  packNavBarItemCollection?: Maybe<PackNavBarItemCollection>;
  packNavBarItemCursorCollection?: Maybe<PackNavBarItemCursorCollection>;
  packNavBarItemV2Collection?: Maybe<PackNavBarItemV2Collection>;
  packNavBarItemV2CursorCollection?: Maybe<PackNavBarItemV2CursorCollection>;
  packRecommendedContentAccordionItemCollection?: Maybe<PackRecommendedContentAccordionItemCollection>;
  packRecommendedContentAccordionItemCursorCollection?: Maybe<PackRecommendedContentAccordionItemCursorCollection>;
  wrapperPageRoutingCollection?: Maybe<WrapperPageRoutingCollection>;
  wrapperPageRoutingCursorCollection?: Maybe<WrapperPageRoutingCursorCollection>;
};


export type BuildWebpageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildWebpageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildWebpageLinkingCollectionsPackCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildWebpageLinkingCollectionsPackCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildWebpageLinkingCollectionsPackCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildWebpageLinkingCollectionsPackCtaCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildWebpageLinkingCollectionsPackFooterItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildWebpageLinkingCollectionsPackFooterItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildWebpageLinkingCollectionsPackFooterItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildWebpageLinkingCollectionsPackFooterItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildWebpageLinkingCollectionsPackNavBarCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildWebpageLinkingCollectionsPackNavBarCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildWebpageLinkingCollectionsPackNavBarCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildWebpageLinkingCollectionsPackNavBarCtaCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildWebpageLinkingCollectionsPackNavBarItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildWebpageLinkingCollectionsPackNavBarItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildWebpageLinkingCollectionsPackNavBarItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildWebpageLinkingCollectionsPackNavBarItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildWebpageLinkingCollectionsPackNavBarItemV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildWebpageLinkingCollectionsPackNavBarItemV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildWebpageLinkingCollectionsPackNavBarItemV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildWebpageLinkingCollectionsPackNavBarItemV2CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildWebpageLinkingCollectionsPackRecommendedContentAccordionItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildWebpageLinkingCollectionsPackRecommendedContentAccordionItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildWebpageLinkingCollectionsPackRecommendedContentAccordionItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildWebpageLinkingCollectionsPackRecommendedContentAccordionItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildWebpageLinkingCollectionsWrapperPageRoutingCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildWebpageLinkingCollectionsWrapperPageRoutingCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildWebpageLinkingCollectionsWrapperPageRoutingCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildWebpageLinkingCollectionsWrapperPageRoutingCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BuildWebpageLinkingCollectionsPackCtaCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export enum BuildWebpageLinkingCollectionsPackCtaCursorCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export enum BuildWebpageLinkingCollectionsPackFooterItemCollectionOrder {
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BuildWebpageLinkingCollectionsPackFooterItemCursorCollectionOrder {
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BuildWebpageLinkingCollectionsPackNavBarCtaCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BuildWebpageLinkingCollectionsPackNavBarCtaCursorCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BuildWebpageLinkingCollectionsPackNavBarItemCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BuildWebpageLinkingCollectionsPackNavBarItemCursorCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BuildWebpageLinkingCollectionsPackNavBarItemV2CollectionOrder {
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BuildWebpageLinkingCollectionsPackNavBarItemV2CursorCollectionOrder {
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BuildWebpageLinkingCollectionsPackRecommendedContentAccordionItemCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BuildWebpageLinkingCollectionsPackRecommendedContentAccordionItemCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BuildWebpageLinkingCollectionsWrapperPageRoutingCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TemporaryOrPermanentAsc = 'temporaryOrPermanent_ASC',
  TemporaryOrPermanentDesc = 'temporaryOrPermanent_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export enum BuildWebpageLinkingCollectionsWrapperPageRoutingCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TemporaryOrPermanentAsc = 'temporaryOrPermanent_ASC',
  TemporaryOrPermanentDesc = 'temporaryOrPermanent_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export type BuildWebpageMasthead = PackPageStandard | WrapperPageRouting;

export enum BuildWebpageOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentAccordion) */
export type ComponentAccordion = Entry & _Node & {
  __typename?: 'ComponentAccordion';
  _id: Scalars['ID']['output'];
  accordionIntro?: Maybe<PackStructuredText>;
  accordionItemCollection?: Maybe<ComponentAccordionAccordionItemCollection>;
  accordionItemCursorCollection?: Maybe<ComponentAccordionAccordionItemCursorCollection>;
  anchor?: Maybe<Scalars['String']['output']>;
  behaviour?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<ComponentAccordionLinkingCollections>;
  showTitle?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  variant?: Maybe<Scalars['Boolean']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentAccordion) */
export type ComponentAccordionAccordionIntroArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackStructuredTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentAccordion) */
export type ComponentAccordionAccordionItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentAccordionAccordionItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackStructuredTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentAccordion) */
export type ComponentAccordionAccordionItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentAccordionAccordionItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackStructuredTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentAccordion) */
export type ComponentAccordionAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentAccordion) */
export type ComponentAccordionBehaviourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentAccordion) */
export type ComponentAccordionLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentAccordion) */
export type ComponentAccordionShowTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentAccordion) */
export type ComponentAccordionVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentAccordionAccordionItemCollection = {
  __typename?: 'ComponentAccordionAccordionItemCollection';
  items: Array<Maybe<PackStructuredText>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComponentAccordionAccordionItemCollectionOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComponentAccordionAccordionItemCursorCollection = {
  __typename?: 'ComponentAccordionAccordionItemCursorCollection';
  items: Array<Maybe<PackStructuredText>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComponentAccordionAccordionItemCursorCollectionOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComponentAccordionCollection = {
  __typename?: 'ComponentAccordionCollection';
  items: Array<Maybe<ComponentAccordion>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentAccordionCursorCollection = {
  __typename?: 'ComponentAccordionCursorCollection';
  items: Array<Maybe<ComponentAccordion>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentAccordionFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentAccordionFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentAccordionFilter>>>;
  accordionIntro?: InputMaybe<CfPackStructuredTextNestedFilter>;
  accordionIntro_exists?: InputMaybe<Scalars['Boolean']['input']>;
  accordionItem?: InputMaybe<CfPackStructuredTextNestedFilter>;
  accordionItemCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  behaviour?: InputMaybe<Scalars['String']['input']>;
  behaviour_contains?: InputMaybe<Scalars['String']['input']>;
  behaviour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  behaviour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  behaviour_not?: InputMaybe<Scalars['String']['input']>;
  behaviour_not_contains?: InputMaybe<Scalars['String']['input']>;
  behaviour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  variant?: InputMaybe<Scalars['Boolean']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentAccordionLinkingCollections = {
  __typename?: 'ComponentAccordionLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildGenericTemplatePageCollection?: Maybe<BuildGenericTemplatePageCollection>;
  buildGenericTemplatePageCursorCollection?: Maybe<BuildGenericTemplatePageCursorCollection>;
  buildLandingpageCollection?: Maybe<BuildLandingpageCollection>;
  buildLandingpageCursorCollection?: Maybe<BuildLandingpageCursorCollection>;
  buildProductDetailPageCollection?: Maybe<BuildProductDetailPageCollection>;
  buildProductDetailPageCursorCollection?: Maybe<BuildProductDetailPageCursorCollection>;
  buildTariffPageCollection?: Maybe<BuildTariffPageCollection>;
  buildTariffPageCursorCollection?: Maybe<BuildTariffPageCursorCollection>;
  buildWebpageCollection?: Maybe<BuildWebpageCollection>;
  buildWebpageCursorCollection?: Maybe<BuildWebpageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  packCtaCollection?: Maybe<PackCtaCollection>;
  packCtaCursorCollection?: Maybe<PackCtaCursorCollection>;
};


export type ComponentAccordionLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentAccordionLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentAccordionLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentAccordionLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentAccordionLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentAccordionLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentAccordionLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentAccordionLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentAccordionLinkingCollectionsBuildGenericTemplatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentAccordionLinkingCollectionsBuildGenericTemplatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentAccordionLinkingCollectionsBuildGenericTemplatePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentAccordionLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentAccordionLinkingCollectionsBuildLandingpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentAccordionLinkingCollectionsBuildLandingpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentAccordionLinkingCollectionsBuildLandingpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentAccordionLinkingCollectionsBuildLandingpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentAccordionLinkingCollectionsBuildProductDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentAccordionLinkingCollectionsBuildProductDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentAccordionLinkingCollectionsBuildProductDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentAccordionLinkingCollectionsBuildProductDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentAccordionLinkingCollectionsBuildTariffPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentAccordionLinkingCollectionsBuildTariffPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentAccordionLinkingCollectionsBuildTariffPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentAccordionLinkingCollectionsBuildTariffPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentAccordionLinkingCollectionsBuildWebpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentAccordionLinkingCollectionsBuildWebpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentAccordionLinkingCollectionsBuildWebpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentAccordionLinkingCollectionsBuildWebpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentAccordionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentAccordionLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentAccordionLinkingCollectionsPackCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentAccordionLinkingCollectionsPackCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentAccordionLinkingCollectionsPackCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentAccordionLinkingCollectionsPackCtaCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentAccordionLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentAccordionLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentAccordionLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentAccordionLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentAccordionLinkingCollectionsBuildGenericTemplatePageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentAccordionLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentAccordionLinkingCollectionsBuildLandingpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentAccordionLinkingCollectionsBuildLandingpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentAccordionLinkingCollectionsBuildProductDetailPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentAccordionLinkingCollectionsBuildProductDetailPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentAccordionLinkingCollectionsBuildTariffPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentAccordionLinkingCollectionsBuildTariffPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentAccordionLinkingCollectionsBuildWebpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentAccordionLinkingCollectionsBuildWebpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentAccordionLinkingCollectionsPackCtaCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export enum ComponentAccordionLinkingCollectionsPackCtaCursorCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export enum ComponentAccordionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  BehaviourAsc = 'behaviour_ASC',
  BehaviourDesc = 'behaviour_DESC',
  ShowTitleAsc = 'showTitle_ASC',
  ShowTitleDesc = 'showTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentActionCard) */
export type ComponentActionCard = Entry & _Node & {
  __typename?: 'ComponentActionCard';
  _id: Scalars['ID']['output'];
  actionCode?: Maybe<Scalars['String']['output']>;
  anchor?: Maybe<Scalars['String']['output']>;
  canBeDismissed?: Maybe<Scalars['Boolean']['output']>;
  contentfulMetadata: ContentfulMetadata;
  cta?: Maybe<PackCta>;
  ctaBehaviour?: Maybe<Scalars['String']['output']>;
  ctaType?: Maybe<Scalars['String']['output']>;
  darkMode?: Maybe<Scalars['Boolean']['output']>;
  image?: Maybe<WrapperImage>;
  inverted?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<ComponentActionCardLinkingCollections>;
  mixpanelId?: Maybe<Scalars['String']['output']>;
  nonRoundedEdges?: Maybe<Scalars['Boolean']['output']>;
  optimizelyFeatureFlag?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  text?: Maybe<PackStructuredText>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentActionCard) */
export type ComponentActionCardActionCodeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentActionCard) */
export type ComponentActionCardAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentActionCard) */
export type ComponentActionCardCanBeDismissedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentActionCard) */
export type ComponentActionCardCtaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentActionCard) */
export type ComponentActionCardCtaBehaviourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentActionCard) */
export type ComponentActionCardCtaTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentActionCard) */
export type ComponentActionCardDarkModeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentActionCard) */
export type ComponentActionCardImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentActionCard) */
export type ComponentActionCardInvertedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentActionCard) */
export type ComponentActionCardLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentActionCard) */
export type ComponentActionCardMixpanelIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentActionCard) */
export type ComponentActionCardNonRoundedEdgesArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentActionCard) */
export type ComponentActionCardOptimizelyFeatureFlagArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentActionCard) */
export type ComponentActionCardTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackStructuredTextFilter>;
};

export type ComponentActionCardCollection = {
  __typename?: 'ComponentActionCardCollection';
  items: Array<Maybe<ComponentActionCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentActionCardCursorCollection = {
  __typename?: 'ComponentActionCardCursorCollection';
  items: Array<Maybe<ComponentActionCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentActionCardFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentActionCardFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentActionCardFilter>>>;
  actionCode?: InputMaybe<Scalars['String']['input']>;
  actionCode_contains?: InputMaybe<Scalars['String']['input']>;
  actionCode_exists?: InputMaybe<Scalars['Boolean']['input']>;
  actionCode_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionCode_not?: InputMaybe<Scalars['String']['input']>;
  actionCode_not_contains?: InputMaybe<Scalars['String']['input']>;
  actionCode_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canBeDismissed?: InputMaybe<Scalars['Boolean']['input']>;
  canBeDismissed_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canBeDismissed_not?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta?: InputMaybe<CfPackCtaNestedFilter>;
  ctaBehaviour?: InputMaybe<Scalars['String']['input']>;
  ctaBehaviour_contains?: InputMaybe<Scalars['String']['input']>;
  ctaBehaviour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaBehaviour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaBehaviour_not?: InputMaybe<Scalars['String']['input']>;
  ctaBehaviour_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaBehaviour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaType?: InputMaybe<Scalars['String']['input']>;
  ctaType_contains?: InputMaybe<Scalars['String']['input']>;
  ctaType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaType_not?: InputMaybe<Scalars['String']['input']>;
  ctaType_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta_exists?: InputMaybe<Scalars['Boolean']['input']>;
  darkMode?: InputMaybe<Scalars['Boolean']['input']>;
  darkMode_exists?: InputMaybe<Scalars['Boolean']['input']>;
  darkMode_not?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<CfWrapperImageNestedFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  inverted?: InputMaybe<Scalars['Boolean']['input']>;
  inverted_exists?: InputMaybe<Scalars['Boolean']['input']>;
  inverted_not?: InputMaybe<Scalars['Boolean']['input']>;
  mixpanelId?: InputMaybe<Scalars['String']['input']>;
  mixpanelId_contains?: InputMaybe<Scalars['String']['input']>;
  mixpanelId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mixpanelId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mixpanelId_not?: InputMaybe<Scalars['String']['input']>;
  mixpanelId_not_contains?: InputMaybe<Scalars['String']['input']>;
  mixpanelId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonRoundedEdges?: InputMaybe<Scalars['Boolean']['input']>;
  nonRoundedEdges_exists?: InputMaybe<Scalars['Boolean']['input']>;
  nonRoundedEdges_not?: InputMaybe<Scalars['Boolean']['input']>;
  optimizelyFeatureFlag?: InputMaybe<Scalars['String']['input']>;
  optimizelyFeatureFlag_contains?: InputMaybe<Scalars['String']['input']>;
  optimizelyFeatureFlag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  optimizelyFeatureFlag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optimizelyFeatureFlag_not?: InputMaybe<Scalars['String']['input']>;
  optimizelyFeatureFlag_not_contains?: InputMaybe<Scalars['String']['input']>;
  optimizelyFeatureFlag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<CfPackStructuredTextNestedFilter>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentActionCardLinkingCollections = {
  __typename?: 'ComponentActionCardLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  buildCustomerInformationCardCollection?: Maybe<BuildCustomerInformationCardCollection>;
  buildCustomerInformationCardCursorCollection?: Maybe<BuildCustomerInformationCardCursorCollection>;
  buildNextBestActionCollection?: Maybe<BuildNextBestActionCollection>;
  buildNextBestActionCursorCollection?: Maybe<BuildNextBestActionCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentActionCardLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentActionCardLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentActionCardLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentActionCardLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentActionCardLinkingCollectionsBuildCustomerInformationCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentActionCardLinkingCollectionsBuildCustomerInformationCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentActionCardLinkingCollectionsBuildCustomerInformationCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentActionCardLinkingCollectionsBuildCustomerInformationCardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentActionCardLinkingCollectionsBuildNextBestActionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentActionCardLinkingCollectionsBuildNextBestActionCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentActionCardLinkingCollectionsBuildNextBestActionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentActionCardLinkingCollectionsBuildNextBestActionCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentActionCardLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentActionCardLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentActionCardLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentActionCardLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentActionCardLinkingCollectionsBuildCustomerInformationCardCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentActionCardLinkingCollectionsBuildCustomerInformationCardCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentActionCardLinkingCollectionsBuildNextBestActionCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentActionCardLinkingCollectionsBuildNextBestActionCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentActionCardOrder {
  ActionCodeAsc = 'actionCode_ASC',
  ActionCodeDesc = 'actionCode_DESC',
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  CanBeDismissedAsc = 'canBeDismissed_ASC',
  CanBeDismissedDesc = 'canBeDismissed_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  DarkModeAsc = 'darkMode_ASC',
  DarkModeDesc = 'darkMode_DESC',
  InvertedAsc = 'inverted_ASC',
  InvertedDesc = 'inverted_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  NonRoundedEdgesAsc = 'nonRoundedEdges_ASC',
  NonRoundedEdgesDesc = 'nonRoundedEdges_DESC',
  OptimizelyFeatureFlagAsc = 'optimizelyFeatureFlag_ASC',
  OptimizelyFeatureFlagDesc = 'optimizelyFeatureFlag_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentBlockCard) */
export type ComponentBlockCard = Entry & _Node & {
  __typename?: 'ComponentBlockCard';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  cta?: Maybe<PackCta>;
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<ContentType5OiHchWgV9Y8SuvDxHCaLy>;
  label?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ComponentBlockCardLinkingCollections>;
  richTextDescription?: Maybe<ComponentBlockCardRichTextDescription>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentBlockCard) */
export type ComponentBlockCardCtaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentBlockCard) */
export type ComponentBlockCardDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentBlockCard) */
export type ComponentBlockCardImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentBlockCard) */
export type ComponentBlockCardLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentBlockCard) */
export type ComponentBlockCardLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentBlockCard) */
export type ComponentBlockCardRichTextDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentBlockCard) */
export type ComponentBlockCardTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentBlockCardCollection = {
  __typename?: 'ComponentBlockCardCollection';
  items: Array<Maybe<ComponentBlockCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentBlockCardCursorCollection = {
  __typename?: 'ComponentBlockCardCursorCollection';
  items: Array<Maybe<ComponentBlockCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentBlockCardFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentBlockCardFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentBlockCardFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta?: InputMaybe<CfPackCtaNestedFilter>;
  cta_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image?: InputMaybe<CfContentType5OiHchWgV9Y8SuvDxHCaLyNestedFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  richTextDescription_contains?: InputMaybe<Scalars['String']['input']>;
  richTextDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  richTextDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlockCardLinkingCollections = {
  __typename?: 'ComponentBlockCardLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  componentInfoGroupCollection?: Maybe<ComponentInfoGroupCollection>;
  componentInfoGroupCursorCollection?: Maybe<ComponentInfoGroupCursorCollection>;
  componentLauncherGroupCollection?: Maybe<ComponentLauncherGroupCollection>;
  componentLauncherGroupCursorCollection?: Maybe<ComponentLauncherGroupCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentBlockCardLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentBlockCardLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentBlockCardLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentBlockCardLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentBlockCardLinkingCollectionsComponentInfoGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentBlockCardLinkingCollectionsComponentInfoGroupCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentBlockCardLinkingCollectionsComponentInfoGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentBlockCardLinkingCollectionsComponentInfoGroupCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentBlockCardLinkingCollectionsComponentLauncherGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentBlockCardLinkingCollectionsComponentLauncherGroupCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentBlockCardLinkingCollectionsComponentLauncherGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentBlockCardLinkingCollectionsComponentLauncherGroupCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentBlockCardLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentBlockCardLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentBlockCardLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentBlockCardLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentBlockCardLinkingCollectionsComponentInfoGroupCollectionOrder {
  AlignAsc = 'align_ASC',
  AlignDesc = 'align_DESC',
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ComponentBlockCardLinkingCollectionsComponentInfoGroupCursorCollectionOrder {
  AlignAsc = 'align_ASC',
  AlignDesc = 'align_DESC',
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ComponentBlockCardLinkingCollectionsComponentLauncherGroupCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC'
}

export enum ComponentBlockCardLinkingCollectionsComponentLauncherGroupCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC'
}

export enum ComponentBlockCardOrder {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ComponentBlockCardRichTextDescription = {
  __typename?: 'ComponentBlockCardRichTextDescription';
  json: Scalars['JSON']['output'];
  links: ComponentBlockCardRichTextDescriptionLinks;
};

export type ComponentBlockCardRichTextDescriptionAssets = {
  __typename?: 'ComponentBlockCardRichTextDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComponentBlockCardRichTextDescriptionEntries = {
  __typename?: 'ComponentBlockCardRichTextDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComponentBlockCardRichTextDescriptionLinks = {
  __typename?: 'ComponentBlockCardRichTextDescriptionLinks';
  assets: ComponentBlockCardRichTextDescriptionAssets;
  entries: ComponentBlockCardRichTextDescriptionEntries;
  resources: ComponentBlockCardRichTextDescriptionResources;
};

export type ComponentBlockCardRichTextDescriptionResources = {
  __typename?: 'ComponentBlockCardRichTextDescriptionResources';
  block: Array<ComponentBlockCardRichTextDescriptionResourcesBlock>;
  hyperlink: Array<ComponentBlockCardRichTextDescriptionResourcesHyperlink>;
  inline: Array<ComponentBlockCardRichTextDescriptionResourcesInline>;
};

export type ComponentBlockCardRichTextDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'ComponentBlockCardRichTextDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type ComponentBlockCardRichTextDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'ComponentBlockCardRichTextDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type ComponentBlockCardRichTextDescriptionResourcesInline = ResourceLink & {
  __typename?: 'ComponentBlockCardRichTextDescriptionResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCallout) */
export type ComponentCallout = Entry & _Node & {
  __typename?: 'ComponentCallout';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  icon?: Maybe<WrapperIcon>;
  linkedFrom?: Maybe<ComponentCalloutLinkingCollections>;
  sys: Sys;
  text?: Maybe<PackHighlightedText>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCallout) */
export type ComponentCalloutAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCallout) */
export type ComponentCalloutIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperIconFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCallout) */
export type ComponentCalloutLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCallout) */
export type ComponentCalloutTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackHighlightedTextFilter>;
};

export type ComponentCalloutCollection = {
  __typename?: 'ComponentCalloutCollection';
  items: Array<Maybe<ComponentCallout>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentCalloutCursorCollection = {
  __typename?: 'ComponentCalloutCursorCollection';
  items: Array<Maybe<ComponentCallout>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentCalloutFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentCalloutFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentCalloutFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon?: InputMaybe<CfWrapperIconNestedFilter>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<CfPackHighlightedTextNestedFilter>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentCalloutLinkingCollections = {
  __typename?: 'ComponentCalloutLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildLandingpageCollection?: Maybe<BuildLandingpageCollection>;
  buildLandingpageCursorCollection?: Maybe<BuildLandingpageCursorCollection>;
  buildTariffPageCollection?: Maybe<BuildTariffPageCollection>;
  buildTariffPageCursorCollection?: Maybe<BuildTariffPageCursorCollection>;
  buildWebpageCollection?: Maybe<BuildWebpageCollection>;
  buildWebpageCursorCollection?: Maybe<BuildWebpageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  packCtaCollection?: Maybe<PackCtaCollection>;
  packCtaCursorCollection?: Maybe<PackCtaCursorCollection>;
};


export type ComponentCalloutLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCalloutLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCalloutLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCalloutLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCalloutLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCalloutLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCalloutLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCalloutLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCalloutLinkingCollectionsBuildLandingpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCalloutLinkingCollectionsBuildLandingpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCalloutLinkingCollectionsBuildLandingpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCalloutLinkingCollectionsBuildLandingpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCalloutLinkingCollectionsBuildTariffPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCalloutLinkingCollectionsBuildTariffPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCalloutLinkingCollectionsBuildTariffPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCalloutLinkingCollectionsBuildTariffPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCalloutLinkingCollectionsBuildWebpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCalloutLinkingCollectionsBuildWebpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCalloutLinkingCollectionsBuildWebpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCalloutLinkingCollectionsBuildWebpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCalloutLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCalloutLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCalloutLinkingCollectionsPackCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCalloutLinkingCollectionsPackCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCalloutLinkingCollectionsPackCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCalloutLinkingCollectionsPackCtaCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentCalloutLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCalloutLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCalloutLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCalloutLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCalloutLinkingCollectionsBuildLandingpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCalloutLinkingCollectionsBuildLandingpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCalloutLinkingCollectionsBuildTariffPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCalloutLinkingCollectionsBuildTariffPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCalloutLinkingCollectionsBuildWebpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCalloutLinkingCollectionsBuildWebpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCalloutLinkingCollectionsPackCtaCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export enum ComponentCalloutLinkingCollectionsPackCtaCursorCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export enum ComponentCalloutOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCard) */
export type ComponentCard = Entry & _Node & {
  __typename?: 'ComponentCard';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  cta?: Maybe<PackCta>;
  ctaBehaviour?: Maybe<Scalars['String']['output']>;
  ctaType?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ComponentCardLinkingCollections>;
  media?: Maybe<ComponentCardMedia>;
  shortText?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  text?: Maybe<PackStructuredText>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCard) */
export type ComponentCardAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCard) */
export type ComponentCardCtaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCard) */
export type ComponentCardCtaBehaviourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCard) */
export type ComponentCardCtaTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCard) */
export type ComponentCardLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCard) */
export type ComponentCardMediaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCard) */
export type ComponentCardShortTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCard) */
export type ComponentCardTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackStructuredTextFilter>;
};

export type ComponentCardCollection = {
  __typename?: 'ComponentCardCollection';
  items: Array<Maybe<ComponentCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentCardCursorCollection = {
  __typename?: 'ComponentCardCursorCollection';
  items: Array<Maybe<ComponentCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentCardFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentCardFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentCardFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta?: InputMaybe<CfPackCtaNestedFilter>;
  ctaBehaviour?: InputMaybe<Scalars['String']['input']>;
  ctaBehaviour_contains?: InputMaybe<Scalars['String']['input']>;
  ctaBehaviour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaBehaviour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaBehaviour_not?: InputMaybe<Scalars['String']['input']>;
  ctaBehaviour_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaBehaviour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaType?: InputMaybe<Scalars['String']['input']>;
  ctaType_contains?: InputMaybe<Scalars['String']['input']>;
  ctaType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaType_not?: InputMaybe<Scalars['String']['input']>;
  ctaType_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta_exists?: InputMaybe<Scalars['Boolean']['input']>;
  media_exists?: InputMaybe<Scalars['Boolean']['input']>;
  shortText?: InputMaybe<Scalars['String']['input']>;
  shortText_contains?: InputMaybe<Scalars['String']['input']>;
  shortText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  shortText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortText_not?: InputMaybe<Scalars['String']['input']>;
  shortText_not_contains?: InputMaybe<Scalars['String']['input']>;
  shortText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<CfPackStructuredTextNestedFilter>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCardGrid) */
export type ComponentCardGrid = Entry & _Node & {
  __typename?: 'ComponentCardGrid';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  cardsCollection?: Maybe<ComponentCardGridCardsCollection>;
  cardsCursorCollection?: Maybe<ComponentCardGridCardsCursorCollection>;
  cardsIntro?: Maybe<PackStructuredText>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<ComponentCardGridLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCardGrid) */
export type ComponentCardGridAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCardGrid) */
export type ComponentCardGridCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardGridCardsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCardGrid) */
export type ComponentCardGridCardsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardGridCardsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCardGrid) */
export type ComponentCardGridCardsIntroArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackStructuredTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCardGrid) */
export type ComponentCardGridLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentCardGridCardsCollection = {
  __typename?: 'ComponentCardGridCardsCollection';
  items: Array<Maybe<ComponentCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComponentCardGridCardsCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  ShortTextAsc = 'shortText_ASC',
  ShortTextDesc = 'shortText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComponentCardGridCardsCursorCollection = {
  __typename?: 'ComponentCardGridCardsCursorCollection';
  items: Array<Maybe<ComponentCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComponentCardGridCardsCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  ShortTextAsc = 'shortText_ASC',
  ShortTextDesc = 'shortText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComponentCardGridCollection = {
  __typename?: 'ComponentCardGridCollection';
  items: Array<Maybe<ComponentCardGrid>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentCardGridCursorCollection = {
  __typename?: 'ComponentCardGridCursorCollection';
  items: Array<Maybe<ComponentCardGrid>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentCardGridFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentCardGridFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentCardGridFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cards?: InputMaybe<CfComponentCardNestedFilter>;
  cardsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardsIntro?: InputMaybe<CfPackStructuredTextNestedFilter>;
  cardsIntro_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type ComponentCardGridLinkingCollections = {
  __typename?: 'ComponentCardGridLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildLandingpageCollection?: Maybe<BuildLandingpageCollection>;
  buildLandingpageCursorCollection?: Maybe<BuildLandingpageCursorCollection>;
  buildTariffPageCollection?: Maybe<BuildTariffPageCollection>;
  buildTariffPageCursorCollection?: Maybe<BuildTariffPageCursorCollection>;
  buildWebpageCollection?: Maybe<BuildWebpageCollection>;
  buildWebpageCursorCollection?: Maybe<BuildWebpageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  packCtaCollection?: Maybe<PackCtaCollection>;
  packCtaCursorCollection?: Maybe<PackCtaCursorCollection>;
};


export type ComponentCardGridLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardGridLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCardGridLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardGridLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCardGridLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardGridLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCardGridLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardGridLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCardGridLinkingCollectionsBuildLandingpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardGridLinkingCollectionsBuildLandingpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCardGridLinkingCollectionsBuildLandingpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardGridLinkingCollectionsBuildLandingpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCardGridLinkingCollectionsBuildTariffPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardGridLinkingCollectionsBuildTariffPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCardGridLinkingCollectionsBuildTariffPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardGridLinkingCollectionsBuildTariffPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCardGridLinkingCollectionsBuildWebpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardGridLinkingCollectionsBuildWebpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCardGridLinkingCollectionsBuildWebpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardGridLinkingCollectionsBuildWebpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCardGridLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCardGridLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCardGridLinkingCollectionsPackCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardGridLinkingCollectionsPackCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCardGridLinkingCollectionsPackCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardGridLinkingCollectionsPackCtaCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentCardGridLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCardGridLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCardGridLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCardGridLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCardGridLinkingCollectionsBuildLandingpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCardGridLinkingCollectionsBuildLandingpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCardGridLinkingCollectionsBuildTariffPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCardGridLinkingCollectionsBuildTariffPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCardGridLinkingCollectionsBuildWebpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCardGridLinkingCollectionsBuildWebpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCardGridLinkingCollectionsPackCtaCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export enum ComponentCardGridLinkingCollectionsPackCtaCursorCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export enum ComponentCardGridOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCardGroup) */
export type ComponentCardGroup = Entry & _Node & {
  __typename?: 'ComponentCardGroup';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  ctaListCollection?: Maybe<ComponentCardGroupCtaListCollection>;
  ctaListCursorCollection?: Maybe<ComponentCardGroupCtaListCursorCollection>;
  infoCardListCollection?: Maybe<ComponentCardGroupInfoCardListCollection>;
  infoCardListCursorCollection?: Maybe<ComponentCardGroupInfoCardListCursorCollection>;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ComponentCardGroupLinkingCollections>;
  showTitleInline?: Maybe<Scalars['Boolean']['output']>;
  smallText?: Maybe<ComponentCardGroupSmallText>;
  subtitle?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  theme?: Maybe<Scalars['String']['output']>;
  title1?: Maybe<Scalars['String']['output']>;
  title2?: Maybe<Scalars['String']['output']>;
  titleColour?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCardGroup) */
export type ComponentCardGroupAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCardGroup) */
export type ComponentCardGroupCtaListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardGroupCtaListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCardGroup) */
export type ComponentCardGroupCtaListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardGroupCtaListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCardGroup) */
export type ComponentCardGroupInfoCardListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardGroupInfoCardListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentInfoCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCardGroup) */
export type ComponentCardGroupInfoCardListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardGroupInfoCardListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentInfoCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCardGroup) */
export type ComponentCardGroupInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCardGroup) */
export type ComponentCardGroupLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCardGroup) */
export type ComponentCardGroupShowTitleInlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCardGroup) */
export type ComponentCardGroupSmallTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCardGroup) */
export type ComponentCardGroupSubtitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCardGroup) */
export type ComponentCardGroupThemeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCardGroup) */
export type ComponentCardGroupTitle1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCardGroup) */
export type ComponentCardGroupTitle2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCardGroup) */
export type ComponentCardGroupTitleColourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentCardGroupCollection = {
  __typename?: 'ComponentCardGroupCollection';
  items: Array<Maybe<ComponentCardGroup>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentCardGroupCtaListCollection = {
  __typename?: 'ComponentCardGroupCtaListCollection';
  items: Array<Maybe<PackCta>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComponentCardGroupCtaListCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export type ComponentCardGroupCtaListCursorCollection = {
  __typename?: 'ComponentCardGroupCtaListCursorCollection';
  items: Array<Maybe<PackCta>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComponentCardGroupCtaListCursorCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export type ComponentCardGroupCursorCollection = {
  __typename?: 'ComponentCardGroupCursorCollection';
  items: Array<Maybe<ComponentCardGroup>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentCardGroupFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentCardGroupFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentCardGroupFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctaList?: InputMaybe<CfPackCtaNestedFilter>;
  ctaListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  infoCardList?: InputMaybe<CfComponentInfoCardNestedFilter>;
  infoCardListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showTitleInline?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_not?: InputMaybe<Scalars['Boolean']['input']>;
  smallText_contains?: InputMaybe<Scalars['String']['input']>;
  smallText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  smallText_not_contains?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  subtitle_contains?: InputMaybe<Scalars['String']['input']>;
  subtitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subtitle_not?: InputMaybe<Scalars['String']['input']>;
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  theme?: InputMaybe<Scalars['String']['input']>;
  theme_contains?: InputMaybe<Scalars['String']['input']>;
  theme_exists?: InputMaybe<Scalars['Boolean']['input']>;
  theme_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  theme_not?: InputMaybe<Scalars['String']['input']>;
  theme_not_contains?: InputMaybe<Scalars['String']['input']>;
  theme_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title1?: InputMaybe<Scalars['String']['input']>;
  title1_contains?: InputMaybe<Scalars['String']['input']>;
  title1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title1_not?: InputMaybe<Scalars['String']['input']>;
  title1_not_contains?: InputMaybe<Scalars['String']['input']>;
  title1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2?: InputMaybe<Scalars['String']['input']>;
  title2_contains?: InputMaybe<Scalars['String']['input']>;
  title2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2_not?: InputMaybe<Scalars['String']['input']>;
  title2_not_contains?: InputMaybe<Scalars['String']['input']>;
  title2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColour?: InputMaybe<Scalars['String']['input']>;
  titleColour_contains?: InputMaybe<Scalars['String']['input']>;
  titleColour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleColour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColour_not?: InputMaybe<Scalars['String']['input']>;
  titleColour_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleColour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentCardGroupInfoCardListCollection = {
  __typename?: 'ComponentCardGroupInfoCardListCollection';
  items: Array<Maybe<ComponentInfoCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComponentCardGroupInfoCardListCollectionOrder {
  DestinationLabelAsc = 'destinationLabel_ASC',
  DestinationLabelDesc = 'destinationLabel_DESC',
  IsExternalLinkAsc = 'isExternalLink_ASC',
  IsExternalLinkDesc = 'isExternalLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ComponentCardGroupInfoCardListCursorCollection = {
  __typename?: 'ComponentCardGroupInfoCardListCursorCollection';
  items: Array<Maybe<ComponentInfoCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComponentCardGroupInfoCardListCursorCollectionOrder {
  DestinationLabelAsc = 'destinationLabel_ASC',
  DestinationLabelDesc = 'destinationLabel_DESC',
  IsExternalLinkAsc = 'isExternalLink_ASC',
  IsExternalLinkDesc = 'isExternalLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ComponentCardGroupLinkingCollections = {
  __typename?: 'ComponentCardGroupLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildGenericTemplatePageCollection?: Maybe<BuildGenericTemplatePageCollection>;
  buildGenericTemplatePageCursorCollection?: Maybe<BuildGenericTemplatePageCursorCollection>;
  buildProductDetailPageCollection?: Maybe<BuildProductDetailPageCollection>;
  buildProductDetailPageCursorCollection?: Maybe<BuildProductDetailPageCursorCollection>;
  buildTariffPageCollection?: Maybe<BuildTariffPageCollection>;
  buildTariffPageCursorCollection?: Maybe<BuildTariffPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentCardGroupLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardGroupLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCardGroupLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardGroupLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCardGroupLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardGroupLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCardGroupLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardGroupLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCardGroupLinkingCollectionsBuildGenericTemplatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardGroupLinkingCollectionsBuildGenericTemplatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCardGroupLinkingCollectionsBuildGenericTemplatePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardGroupLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCardGroupLinkingCollectionsBuildProductDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardGroupLinkingCollectionsBuildProductDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCardGroupLinkingCollectionsBuildProductDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardGroupLinkingCollectionsBuildProductDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCardGroupLinkingCollectionsBuildTariffPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardGroupLinkingCollectionsBuildTariffPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCardGroupLinkingCollectionsBuildTariffPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardGroupLinkingCollectionsBuildTariffPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCardGroupLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCardGroupLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentCardGroupLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCardGroupLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCardGroupLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCardGroupLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCardGroupLinkingCollectionsBuildGenericTemplatePageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCardGroupLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCardGroupLinkingCollectionsBuildProductDetailPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCardGroupLinkingCollectionsBuildProductDetailPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCardGroupLinkingCollectionsBuildTariffPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCardGroupLinkingCollectionsBuildTariffPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCardGroupOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC'
}

export type ComponentCardGroupSmallText = {
  __typename?: 'ComponentCardGroupSmallText';
  json: Scalars['JSON']['output'];
  links: ComponentCardGroupSmallTextLinks;
};

export type ComponentCardGroupSmallTextAssets = {
  __typename?: 'ComponentCardGroupSmallTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComponentCardGroupSmallTextEntries = {
  __typename?: 'ComponentCardGroupSmallTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComponentCardGroupSmallTextLinks = {
  __typename?: 'ComponentCardGroupSmallTextLinks';
  assets: ComponentCardGroupSmallTextAssets;
  entries: ComponentCardGroupSmallTextEntries;
  resources: ComponentCardGroupSmallTextResources;
};

export type ComponentCardGroupSmallTextResources = {
  __typename?: 'ComponentCardGroupSmallTextResources';
  block: Array<ComponentCardGroupSmallTextResourcesBlock>;
  hyperlink: Array<ComponentCardGroupSmallTextResourcesHyperlink>;
  inline: Array<ComponentCardGroupSmallTextResourcesInline>;
};

export type ComponentCardGroupSmallTextResourcesBlock = ResourceLink & {
  __typename?: 'ComponentCardGroupSmallTextResourcesBlock';
  sys: ResourceSys;
};

export type ComponentCardGroupSmallTextResourcesHyperlink = ResourceLink & {
  __typename?: 'ComponentCardGroupSmallTextResourcesHyperlink';
  sys: ResourceSys;
};

export type ComponentCardGroupSmallTextResourcesInline = ResourceLink & {
  __typename?: 'ComponentCardGroupSmallTextResourcesInline';
  sys: ResourceSys;
};

export type ComponentCardLinkingCollections = {
  __typename?: 'ComponentCardLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  componentCardGridCollection?: Maybe<ComponentCardGridCollection>;
  componentCardGridCursorCollection?: Maybe<ComponentCardGridCursorCollection>;
  componentPageHeroCollection?: Maybe<ComponentPageHeroCollection>;
  componentPageHeroCursorCollection?: Maybe<ComponentPageHeroCursorCollection>;
  componentQuickLinksCollection?: Maybe<ComponentQuickLinksCollection>;
  componentQuickLinksCursorCollection?: Maybe<ComponentQuickLinksCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentCardLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCardLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCardLinkingCollectionsComponentCardGridCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardLinkingCollectionsComponentCardGridCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCardLinkingCollectionsComponentCardGridCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardLinkingCollectionsComponentCardGridCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCardLinkingCollectionsComponentPageHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardLinkingCollectionsComponentPageHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCardLinkingCollectionsComponentPageHeroCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardLinkingCollectionsComponentPageHeroCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCardLinkingCollectionsComponentQuickLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardLinkingCollectionsComponentQuickLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCardLinkingCollectionsComponentQuickLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardLinkingCollectionsComponentQuickLinksCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCardLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCardLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentCardLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCardLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCardLinkingCollectionsComponentCardGridCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCardLinkingCollectionsComponentCardGridCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCardLinkingCollectionsComponentPageHeroCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ComponentCardLinkingCollectionsComponentPageHeroCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ComponentCardLinkingCollectionsComponentQuickLinksCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCardLinkingCollectionsComponentQuickLinksCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComponentCardMedia = ContentType5OiHchWgV9Y8SuvDxHCaLy | WrapperIcon | WrapperImage;

export enum ComponentCardOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  ShortTextAsc = 'shortText_ASC',
  ShortTextDesc = 'shortText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCarousel) */
export type ComponentCarousel = Entry & _Node & {
  __typename?: 'ComponentCarousel';
  _id: Scalars['ID']['output'];
  carouselItemsCollection?: Maybe<ComponentCarouselCarouselItemsCollection>;
  carouselItemsCursorCollection?: Maybe<ComponentCarouselCarouselItemsCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<ComponentCarouselLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCarousel) */
export type ComponentCarouselCarouselItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentCarouselCarouselItemsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCarousel) */
export type ComponentCarouselCarouselItemsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentCarouselCarouselItemsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCarousel) */
export type ComponentCarouselLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCarousel) */
export type ComponentCarouselTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCarouselCard) */
export type ComponentCarouselCard = Entry & _Node & {
  __typename?: 'ComponentCarouselCard';
  _id: Scalars['ID']['output'];
  backgroundSelector?: Maybe<Scalars['String']['output']>;
  bodyCopy?: Maybe<ComponentCarouselCardBodyCopy>;
  bynderMedia?: Maybe<ComponentCarouselCardBynderMedia>;
  cardTabLabel?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  cta?: Maybe<PackCta>;
  linkedFrom?: Maybe<ComponentCarouselCardLinkingCollections>;
  smallText?: Maybe<ComponentCarouselCardSmallText>;
  sys: Sys;
  titleText1?: Maybe<Scalars['String']['output']>;
  titleText2?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCarouselCard) */
export type ComponentCarouselCardBackgroundSelectorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCarouselCard) */
export type ComponentCarouselCardBodyCopyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCarouselCard) */
export type ComponentCarouselCardBynderMediaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentCarouselCardBynderMediaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCarouselCard) */
export type ComponentCarouselCardCardTabLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCarouselCard) */
export type ComponentCarouselCardCtaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCarouselCard) */
export type ComponentCarouselCardLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCarouselCard) */
export type ComponentCarouselCardSmallTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCarouselCard) */
export type ComponentCarouselCardTitleText1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCarouselCard) */
export type ComponentCarouselCardTitleText2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentCarouselCardBodyCopy = {
  __typename?: 'ComponentCarouselCardBodyCopy';
  json: Scalars['JSON']['output'];
  links: ComponentCarouselCardBodyCopyLinks;
};

export type ComponentCarouselCardBodyCopyAssets = {
  __typename?: 'ComponentCarouselCardBodyCopyAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComponentCarouselCardBodyCopyEntries = {
  __typename?: 'ComponentCarouselCardBodyCopyEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComponentCarouselCardBodyCopyLinks = {
  __typename?: 'ComponentCarouselCardBodyCopyLinks';
  assets: ComponentCarouselCardBodyCopyAssets;
  entries: ComponentCarouselCardBodyCopyEntries;
  resources: ComponentCarouselCardBodyCopyResources;
};

export type ComponentCarouselCardBodyCopyResources = {
  __typename?: 'ComponentCarouselCardBodyCopyResources';
  block: Array<ComponentCarouselCardBodyCopyResourcesBlock>;
  hyperlink: Array<ComponentCarouselCardBodyCopyResourcesHyperlink>;
  inline: Array<ComponentCarouselCardBodyCopyResourcesInline>;
};

export type ComponentCarouselCardBodyCopyResourcesBlock = ResourceLink & {
  __typename?: 'ComponentCarouselCardBodyCopyResourcesBlock';
  sys: ResourceSys;
};

export type ComponentCarouselCardBodyCopyResourcesHyperlink = ResourceLink & {
  __typename?: 'ComponentCarouselCardBodyCopyResourcesHyperlink';
  sys: ResourceSys;
};

export type ComponentCarouselCardBodyCopyResourcesInline = ResourceLink & {
  __typename?: 'ComponentCarouselCardBodyCopyResourcesInline';
  sys: ResourceSys;
};

export type ComponentCarouselCardBynderMedia = ContentType5OiHchWgV9Y8SuvDxHCaLy | ContentType5VCz5FHyZ2ZlWqa5OKh6Y9;

export type ComponentCarouselCardBynderMediaFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentCarouselCardBynderMediaFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentCarouselCardBynderMediaFilter>>>;
  altText?: InputMaybe<Scalars['String']['input']>;
  altText_contains?: InputMaybe<Scalars['String']['input']>;
  altText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  altText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  altText_not?: InputMaybe<Scalars['String']['input']>;
  altText_not_contains?: InputMaybe<Scalars['String']['input']>;
  altText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderId?: InputMaybe<Scalars['String']['input']>;
  bynderId_contains?: InputMaybe<Scalars['String']['input']>;
  bynderId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bynderId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderId_not?: InputMaybe<Scalars['String']['input']>;
  bynderId_not_contains?: InputMaybe<Scalars['String']['input']>;
  bynderId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentCarouselCardCollection = {
  __typename?: 'ComponentCarouselCardCollection';
  items: Array<Maybe<ComponentCarouselCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentCarouselCardCursorCollection = {
  __typename?: 'ComponentCarouselCardCursorCollection';
  items: Array<Maybe<ComponentCarouselCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentCarouselCardFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentCarouselCardFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentCarouselCardFilter>>>;
  backgroundSelector?: InputMaybe<Scalars['String']['input']>;
  backgroundSelector_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundSelector_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundSelector_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundSelector_not?: InputMaybe<Scalars['String']['input']>;
  backgroundSelector_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundSelector_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy_contains?: InputMaybe<Scalars['String']['input']>;
  bodyCopy_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bodyCopy_not_contains?: InputMaybe<Scalars['String']['input']>;
  bynderMedia?: InputMaybe<CfbynderMediaMultiTypeNestedFilter>;
  bynderMedia_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardTabLabel?: InputMaybe<Scalars['String']['input']>;
  cardTabLabel_contains?: InputMaybe<Scalars['String']['input']>;
  cardTabLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardTabLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardTabLabel_not?: InputMaybe<Scalars['String']['input']>;
  cardTabLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  cardTabLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta?: InputMaybe<CfPackCtaNestedFilter>;
  cta_exists?: InputMaybe<Scalars['Boolean']['input']>;
  smallText_contains?: InputMaybe<Scalars['String']['input']>;
  smallText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  smallText_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  titleText1?: InputMaybe<Scalars['String']['input']>;
  titleText1_contains?: InputMaybe<Scalars['String']['input']>;
  titleText1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleText1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleText1_not?: InputMaybe<Scalars['String']['input']>;
  titleText1_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleText1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleText2?: InputMaybe<Scalars['String']['input']>;
  titleText2_contains?: InputMaybe<Scalars['String']['input']>;
  titleText2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleText2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleText2_not?: InputMaybe<Scalars['String']['input']>;
  titleText2_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleText2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentCarouselCardLinkingCollections = {
  __typename?: 'ComponentCarouselCardLinkingCollections';
  componentCarouselCollection?: Maybe<ComponentCarouselCollection>;
  componentCarouselCursorCollection?: Maybe<ComponentCarouselCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentCarouselCardLinkingCollectionsComponentCarouselCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCarouselCardLinkingCollectionsComponentCarouselCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCarouselCardLinkingCollectionsComponentCarouselCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCarouselCardLinkingCollectionsComponentCarouselCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCarouselCardLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCarouselCardLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentCarouselCardLinkingCollectionsComponentCarouselCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ComponentCarouselCardLinkingCollectionsComponentCarouselCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ComponentCarouselCardOrder {
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  CardTabLabelAsc = 'cardTabLabel_ASC',
  CardTabLabelDesc = 'cardTabLabel_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleText1Asc = 'titleText1_ASC',
  TitleText1Desc = 'titleText1_DESC',
  TitleText2Asc = 'titleText2_ASC',
  TitleText2Desc = 'titleText2_DESC'
}

export type ComponentCarouselCardSmallText = {
  __typename?: 'ComponentCarouselCardSmallText';
  json: Scalars['JSON']['output'];
  links: ComponentCarouselCardSmallTextLinks;
};

export type ComponentCarouselCardSmallTextAssets = {
  __typename?: 'ComponentCarouselCardSmallTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComponentCarouselCardSmallTextEntries = {
  __typename?: 'ComponentCarouselCardSmallTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComponentCarouselCardSmallTextLinks = {
  __typename?: 'ComponentCarouselCardSmallTextLinks';
  assets: ComponentCarouselCardSmallTextAssets;
  entries: ComponentCarouselCardSmallTextEntries;
  resources: ComponentCarouselCardSmallTextResources;
};

export type ComponentCarouselCardSmallTextResources = {
  __typename?: 'ComponentCarouselCardSmallTextResources';
  block: Array<ComponentCarouselCardSmallTextResourcesBlock>;
  hyperlink: Array<ComponentCarouselCardSmallTextResourcesHyperlink>;
  inline: Array<ComponentCarouselCardSmallTextResourcesInline>;
};

export type ComponentCarouselCardSmallTextResourcesBlock = ResourceLink & {
  __typename?: 'ComponentCarouselCardSmallTextResourcesBlock';
  sys: ResourceSys;
};

export type ComponentCarouselCardSmallTextResourcesHyperlink = ResourceLink & {
  __typename?: 'ComponentCarouselCardSmallTextResourcesHyperlink';
  sys: ResourceSys;
};

export type ComponentCarouselCardSmallTextResourcesInline = ResourceLink & {
  __typename?: 'ComponentCarouselCardSmallTextResourcesInline';
  sys: ResourceSys;
};

export type ComponentCarouselCarouselItemsCollection = {
  __typename?: 'ComponentCarouselCarouselItemsCollection';
  items: Array<Maybe<ComponentCarouselCarouselItemsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentCarouselCarouselItemsCursorCollection = {
  __typename?: 'ComponentCarouselCarouselItemsCursorCollection';
  items: Array<Maybe<ComponentCarouselCarouselItemsItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentCarouselCarouselItemsFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentCarouselCarouselItemsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentCarouselCarouselItemsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type ComponentCarouselCarouselItemsItem = ComponentCarouselCard | ComponentContentBlockV2 | VariationContainer;

export type ComponentCarouselCollection = {
  __typename?: 'ComponentCarouselCollection';
  items: Array<Maybe<ComponentCarousel>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentCarouselCursorCollection = {
  __typename?: 'ComponentCarouselCursorCollection';
  items: Array<Maybe<ComponentCarousel>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentCarouselFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentCarouselFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentCarouselFilter>>>;
  carouselItems?: InputMaybe<CfcarouselItemsMultiTypeNestedFilter>;
  carouselItemsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentCarouselLinkingCollections = {
  __typename?: 'ComponentCarouselLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildLandingpageCollection?: Maybe<BuildLandingpageCollection>;
  buildLandingpageCursorCollection?: Maybe<BuildLandingpageCursorCollection>;
  buildTariffPageCollection?: Maybe<BuildTariffPageCollection>;
  buildTariffPageCursorCollection?: Maybe<BuildTariffPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentCarouselLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCarouselLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCarouselLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCarouselLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCarouselLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCarouselLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCarouselLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCarouselLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCarouselLinkingCollectionsBuildLandingpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCarouselLinkingCollectionsBuildLandingpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCarouselLinkingCollectionsBuildLandingpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCarouselLinkingCollectionsBuildLandingpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCarouselLinkingCollectionsBuildTariffPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCarouselLinkingCollectionsBuildTariffPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCarouselLinkingCollectionsBuildTariffPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCarouselLinkingCollectionsBuildTariffPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCarouselLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCarouselLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentCarouselLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCarouselLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCarouselLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCarouselLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCarouselLinkingCollectionsBuildLandingpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCarouselLinkingCollectionsBuildLandingpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCarouselLinkingCollectionsBuildTariffPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCarouselLinkingCollectionsBuildTariffPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCarouselOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCategoryBrowser) */
export type ComponentCategoryBrowser = Entry & _Node & {
  __typename?: 'ComponentCategoryBrowser';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  categoryList?: Maybe<PackCategoryList>;
  contentfulMetadata: ContentfulMetadata;
  iconSet?: Maybe<Scalars['String']['output']>;
  intro?: Maybe<PackStructuredText>;
  linkedFrom?: Maybe<ComponentCategoryBrowserLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCategoryBrowser) */
export type ComponentCategoryBrowserAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCategoryBrowser) */
export type ComponentCategoryBrowserCategoryListArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCategoryListFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCategoryBrowser) */
export type ComponentCategoryBrowserIconSetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCategoryBrowser) */
export type ComponentCategoryBrowserIntroArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackStructuredTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCategoryBrowser) */
export type ComponentCategoryBrowserLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentCategoryBrowserCollection = {
  __typename?: 'ComponentCategoryBrowserCollection';
  items: Array<Maybe<ComponentCategoryBrowser>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentCategoryBrowserCursorCollection = {
  __typename?: 'ComponentCategoryBrowserCursorCollection';
  items: Array<Maybe<ComponentCategoryBrowser>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentCategoryBrowserFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentCategoryBrowserFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentCategoryBrowserFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryList?: InputMaybe<CfPackCategoryListNestedFilter>;
  categoryList_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  iconSet?: InputMaybe<Scalars['String']['input']>;
  iconSet_contains?: InputMaybe<Scalars['String']['input']>;
  iconSet_exists?: InputMaybe<Scalars['Boolean']['input']>;
  iconSet_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iconSet_not?: InputMaybe<Scalars['String']['input']>;
  iconSet_not_contains?: InputMaybe<Scalars['String']['input']>;
  iconSet_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  intro?: InputMaybe<CfPackStructuredTextNestedFilter>;
  intro_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type ComponentCategoryBrowserLinkingCollections = {
  __typename?: 'ComponentCategoryBrowserLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  componentHelpHomepageDualLayoutCollection?: Maybe<ComponentHelpHomepageDualLayoutCollection>;
  componentHelpHomepageDualLayoutCursorCollection?: Maybe<ComponentHelpHomepageDualLayoutCursorCollection>;
  componentLineupCollection?: Maybe<ComponentLineupCollection>;
  componentLineupCursorCollection?: Maybe<ComponentLineupCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentCategoryBrowserLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCategoryBrowserLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCategoryBrowserLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCategoryBrowserLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCategoryBrowserLinkingCollectionsComponentHelpHomepageDualLayoutCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCategoryBrowserLinkingCollectionsComponentHelpHomepageDualLayoutCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCategoryBrowserLinkingCollectionsComponentHelpHomepageDualLayoutCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCategoryBrowserLinkingCollectionsComponentHelpHomepageDualLayoutCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCategoryBrowserLinkingCollectionsComponentLineupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCategoryBrowserLinkingCollectionsComponentLineupCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCategoryBrowserLinkingCollectionsComponentLineupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCategoryBrowserLinkingCollectionsComponentLineupCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCategoryBrowserLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCategoryBrowserLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentCategoryBrowserLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCategoryBrowserLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCategoryBrowserLinkingCollectionsComponentHelpHomepageDualLayoutCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCategoryBrowserLinkingCollectionsComponentHelpHomepageDualLayoutCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCategoryBrowserLinkingCollectionsComponentLineupCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCategoryBrowserLinkingCollectionsComponentLineupCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCategoryBrowserOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  IconSetAsc = 'iconSet_ASC',
  IconSetDesc = 'iconSet_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContactAndUsefulLinks) */
export type ComponentContactAndUsefulLinks = Entry & _Node & {
  __typename?: 'ComponentContactAndUsefulLinks';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  contactOptions?: Maybe<PackContactOptions>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<ComponentContactAndUsefulLinksLinkingCollections>;
  ovoCommunity?: Maybe<ComponentContentBlock>;
  sys: Sys;
  usefulLinks?: Maybe<ComponentContentBlock>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContactAndUsefulLinks) */
export type ComponentContactAndUsefulLinksAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContactAndUsefulLinks) */
export type ComponentContactAndUsefulLinksContactOptionsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackContactOptionsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContactAndUsefulLinks) */
export type ComponentContactAndUsefulLinksLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContactAndUsefulLinks) */
export type ComponentContactAndUsefulLinksOvoCommunityArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentContentBlockFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContactAndUsefulLinks) */
export type ComponentContactAndUsefulLinksUsefulLinksArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentContentBlockFilter>;
};

export type ComponentContactAndUsefulLinksCollection = {
  __typename?: 'ComponentContactAndUsefulLinksCollection';
  items: Array<Maybe<ComponentContactAndUsefulLinks>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentContactAndUsefulLinksCursorCollection = {
  __typename?: 'ComponentContactAndUsefulLinksCursorCollection';
  items: Array<Maybe<ComponentContactAndUsefulLinks>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentContactAndUsefulLinksFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentContactAndUsefulLinksFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentContactAndUsefulLinksFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactOptions?: InputMaybe<CfPackContactOptionsNestedFilter>;
  contactOptions_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ovoCommunity?: InputMaybe<CfComponentContentBlockNestedFilter>;
  ovoCommunity_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  usefulLinks?: InputMaybe<CfComponentContentBlockNestedFilter>;
  usefulLinks_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentContactAndUsefulLinksLinkingCollections = {
  __typename?: 'ComponentContactAndUsefulLinksLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildCategoryWebpageCollection?: Maybe<BuildCategoryWebpageCollection>;
  buildCategoryWebpageCursorCollection?: Maybe<BuildCategoryWebpageCursorCollection>;
  buildGenericTemplatePageCollection?: Maybe<BuildGenericTemplatePageCollection>;
  buildGenericTemplatePageCursorCollection?: Maybe<BuildGenericTemplatePageCursorCollection>;
  buildLandingpageCollection?: Maybe<BuildLandingpageCollection>;
  buildLandingpageCursorCollection?: Maybe<BuildLandingpageCursorCollection>;
  buildProductDetailPageCollection?: Maybe<BuildProductDetailPageCollection>;
  buildProductDetailPageCursorCollection?: Maybe<BuildProductDetailPageCursorCollection>;
  buildProductOverviewPageCollection?: Maybe<BuildProductOverviewPageCollection>;
  buildProductOverviewPageCursorCollection?: Maybe<BuildProductOverviewPageCursorCollection>;
  buildTariffPageCollection?: Maybe<BuildTariffPageCollection>;
  buildTariffPageCursorCollection?: Maybe<BuildTariffPageCursorCollection>;
  buildWebpageCollection?: Maybe<BuildWebpageCollection>;
  buildWebpageCursorCollection?: Maybe<BuildWebpageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  packCtaCollection?: Maybe<PackCtaCollection>;
  packCtaCursorCollection?: Maybe<PackCtaCursorCollection>;
};


export type ComponentContactAndUsefulLinksLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContactAndUsefulLinksLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContactAndUsefulLinksLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContactAndUsefulLinksLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContactAndUsefulLinksLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContactAndUsefulLinksLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContactAndUsefulLinksLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContactAndUsefulLinksLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContactAndUsefulLinksLinkingCollectionsBuildCategoryWebpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContactAndUsefulLinksLinkingCollectionsBuildCategoryWebpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContactAndUsefulLinksLinkingCollectionsBuildCategoryWebpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContactAndUsefulLinksLinkingCollectionsBuildCategoryWebpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContactAndUsefulLinksLinkingCollectionsBuildGenericTemplatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContactAndUsefulLinksLinkingCollectionsBuildGenericTemplatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContactAndUsefulLinksLinkingCollectionsBuildGenericTemplatePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContactAndUsefulLinksLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContactAndUsefulLinksLinkingCollectionsBuildLandingpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContactAndUsefulLinksLinkingCollectionsBuildLandingpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContactAndUsefulLinksLinkingCollectionsBuildLandingpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContactAndUsefulLinksLinkingCollectionsBuildLandingpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContactAndUsefulLinksLinkingCollectionsBuildProductDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContactAndUsefulLinksLinkingCollectionsBuildProductDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContactAndUsefulLinksLinkingCollectionsBuildProductDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContactAndUsefulLinksLinkingCollectionsBuildProductDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContactAndUsefulLinksLinkingCollectionsBuildProductOverviewPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContactAndUsefulLinksLinkingCollectionsBuildProductOverviewPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContactAndUsefulLinksLinkingCollectionsBuildProductOverviewPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContactAndUsefulLinksLinkingCollectionsBuildProductOverviewPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContactAndUsefulLinksLinkingCollectionsBuildTariffPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContactAndUsefulLinksLinkingCollectionsBuildTariffPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContactAndUsefulLinksLinkingCollectionsBuildTariffPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContactAndUsefulLinksLinkingCollectionsBuildTariffPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContactAndUsefulLinksLinkingCollectionsBuildWebpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContactAndUsefulLinksLinkingCollectionsBuildWebpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContactAndUsefulLinksLinkingCollectionsBuildWebpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContactAndUsefulLinksLinkingCollectionsBuildWebpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContactAndUsefulLinksLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContactAndUsefulLinksLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContactAndUsefulLinksLinkingCollectionsPackCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContactAndUsefulLinksLinkingCollectionsPackCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContactAndUsefulLinksLinkingCollectionsPackCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContactAndUsefulLinksLinkingCollectionsPackCtaCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentContactAndUsefulLinksLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContactAndUsefulLinksLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContactAndUsefulLinksLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContactAndUsefulLinksLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContactAndUsefulLinksLinkingCollectionsBuildCategoryWebpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PathnameAsc = 'pathname_ASC',
  PathnameDesc = 'pathname_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContactAndUsefulLinksLinkingCollectionsBuildCategoryWebpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PathnameAsc = 'pathname_ASC',
  PathnameDesc = 'pathname_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContactAndUsefulLinksLinkingCollectionsBuildGenericTemplatePageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContactAndUsefulLinksLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContactAndUsefulLinksLinkingCollectionsBuildLandingpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContactAndUsefulLinksLinkingCollectionsBuildLandingpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContactAndUsefulLinksLinkingCollectionsBuildProductDetailPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContactAndUsefulLinksLinkingCollectionsBuildProductDetailPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContactAndUsefulLinksLinkingCollectionsBuildProductOverviewPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContactAndUsefulLinksLinkingCollectionsBuildProductOverviewPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContactAndUsefulLinksLinkingCollectionsBuildTariffPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContactAndUsefulLinksLinkingCollectionsBuildTariffPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContactAndUsefulLinksLinkingCollectionsBuildWebpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContactAndUsefulLinksLinkingCollectionsBuildWebpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContactAndUsefulLinksLinkingCollectionsPackCtaCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export enum ComponentContactAndUsefulLinksLinkingCollectionsPackCtaCursorCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export enum ComponentContactAndUsefulLinksOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlock) */
export type ComponentContentBlock = Entry & _Node & {
  __typename?: 'ComponentContentBlock';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  backgroundSelector?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  cta1?: Maybe<PackCta>;
  cta1Behaviour?: Maybe<Scalars['String']['output']>;
  cta1Type?: Maybe<Scalars['String']['output']>;
  cta2?: Maybe<PackCta>;
  cta2Behaviour?: Maybe<Scalars['String']['output']>;
  cta2Type?: Maybe<Scalars['String']['output']>;
  headerLevel?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ComponentContentBlockLinkingCollections>;
  mediaCollection?: Maybe<ComponentContentBlockMediaCollection>;
  mediaCursorCollection?: Maybe<ComponentContentBlockMediaCursorCollection>;
  mediaPosition?: Maybe<Scalars['String']['output']>;
  showTitle?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  text?: Maybe<PackStructuredText>;
  textAlignment?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlock) */
export type ComponentContentBlockAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlock) */
export type ComponentContentBlockBackgroundSelectorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlock) */
export type ComponentContentBlockCta1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlock) */
export type ComponentContentBlockCta1BehaviourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlock) */
export type ComponentContentBlockCta1TypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlock) */
export type ComponentContentBlockCta2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlock) */
export type ComponentContentBlockCta2BehaviourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlock) */
export type ComponentContentBlockCta2TypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlock) */
export type ComponentContentBlockHeaderLevelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlock) */
export type ComponentContentBlockLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlock) */
export type ComponentContentBlockMediaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentContentBlockMediaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlock) */
export type ComponentContentBlockMediaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentContentBlockMediaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlock) */
export type ComponentContentBlockMediaPositionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlock) */
export type ComponentContentBlockShowTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlock) */
export type ComponentContentBlockTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackStructuredTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlock) */
export type ComponentContentBlockTextAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentContentBlockCollection = {
  __typename?: 'ComponentContentBlockCollection';
  items: Array<Maybe<ComponentContentBlock>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentContentBlockCursorCollection = {
  __typename?: 'ComponentContentBlockCursorCollection';
  items: Array<Maybe<ComponentContentBlock>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentContentBlockFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentContentBlockFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentContentBlockFilter>>>;
  Text?: InputMaybe<CfPackStructuredTextNestedFilter>;
  Text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundSelector?: InputMaybe<Scalars['String']['input']>;
  backgroundSelector_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundSelector_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundSelector_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundSelector_not?: InputMaybe<Scalars['String']['input']>;
  backgroundSelector_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundSelector_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta1?: InputMaybe<CfPackCtaNestedFilter>;
  cta1Behaviour?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta1Behaviour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Behaviour_not?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Type?: InputMaybe<Scalars['String']['input']>;
  cta1Type_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta1Type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Type_not?: InputMaybe<Scalars['String']['input']>;
  cta1Type_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2?: InputMaybe<CfPackCtaNestedFilter>;
  cta2Behaviour?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2Behaviour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Behaviour_not?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Type?: InputMaybe<Scalars['String']['input']>;
  cta2Type_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2Type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Type_not?: InputMaybe<Scalars['String']['input']>;
  cta2Type_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headerLevel?: InputMaybe<Scalars['String']['input']>;
  headerLevel_contains?: InputMaybe<Scalars['String']['input']>;
  headerLevel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headerLevel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headerLevel_not?: InputMaybe<Scalars['String']['input']>;
  headerLevel_not_contains?: InputMaybe<Scalars['String']['input']>;
  headerLevel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  media?: InputMaybe<CfmediaMultiTypeNestedFilter>;
  mediaCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mediaPosition?: InputMaybe<Scalars['String']['input']>;
  mediaPosition_contains?: InputMaybe<Scalars['String']['input']>;
  mediaPosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mediaPosition_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mediaPosition_not?: InputMaybe<Scalars['String']['input']>;
  mediaPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  mediaPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  textAlignment?: InputMaybe<Scalars['String']['input']>;
  textAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  textAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  textAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  textAlignment_not?: InputMaybe<Scalars['String']['input']>;
  textAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  textAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentContentBlockLinkingCollections = {
  __typename?: 'ComponentContentBlockLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildCategoryWebpageCollection?: Maybe<BuildCategoryWebpageCollection>;
  buildCategoryWebpageCursorCollection?: Maybe<BuildCategoryWebpageCursorCollection>;
  buildGenericTemplatePageCollection?: Maybe<BuildGenericTemplatePageCollection>;
  buildGenericTemplatePageCursorCollection?: Maybe<BuildGenericTemplatePageCursorCollection>;
  buildLandingpageCollection?: Maybe<BuildLandingpageCollection>;
  buildLandingpageCursorCollection?: Maybe<BuildLandingpageCursorCollection>;
  buildProductDetailPageCollection?: Maybe<BuildProductDetailPageCollection>;
  buildProductDetailPageCursorCollection?: Maybe<BuildProductDetailPageCursorCollection>;
  buildProductOverviewPageCollection?: Maybe<BuildProductOverviewPageCollection>;
  buildProductOverviewPageCursorCollection?: Maybe<BuildProductOverviewPageCursorCollection>;
  buildTariffPageCollection?: Maybe<BuildTariffPageCollection>;
  buildTariffPageCursorCollection?: Maybe<BuildTariffPageCursorCollection>;
  buildWebpageCollection?: Maybe<BuildWebpageCollection>;
  buildWebpageCursorCollection?: Maybe<BuildWebpageCursorCollection>;
  componentContactAndUsefulLinksCollection?: Maybe<ComponentContactAndUsefulLinksCollection>;
  componentContactAndUsefulLinksCursorCollection?: Maybe<ComponentContactAndUsefulLinksCursorCollection>;
  componentLineupCollection?: Maybe<ComponentLineupCollection>;
  componentLineupCursorCollection?: Maybe<ComponentLineupCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  packCtaCollection?: Maybe<PackCtaCollection>;
  packCtaCursorCollection?: Maybe<PackCtaCursorCollection>;
};


export type ComponentContentBlockLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContentBlockLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContentBlockLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContentBlockLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContentBlockLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContentBlockLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContentBlockLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContentBlockLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContentBlockLinkingCollectionsBuildCategoryWebpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContentBlockLinkingCollectionsBuildCategoryWebpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContentBlockLinkingCollectionsBuildCategoryWebpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContentBlockLinkingCollectionsBuildCategoryWebpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContentBlockLinkingCollectionsBuildGenericTemplatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContentBlockLinkingCollectionsBuildGenericTemplatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContentBlockLinkingCollectionsBuildGenericTemplatePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContentBlockLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContentBlockLinkingCollectionsBuildLandingpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContentBlockLinkingCollectionsBuildLandingpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContentBlockLinkingCollectionsBuildLandingpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContentBlockLinkingCollectionsBuildLandingpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContentBlockLinkingCollectionsBuildProductDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContentBlockLinkingCollectionsBuildProductDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContentBlockLinkingCollectionsBuildProductDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContentBlockLinkingCollectionsBuildProductDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContentBlockLinkingCollectionsBuildProductOverviewPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContentBlockLinkingCollectionsBuildProductOverviewPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContentBlockLinkingCollectionsBuildProductOverviewPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContentBlockLinkingCollectionsBuildProductOverviewPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContentBlockLinkingCollectionsBuildTariffPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContentBlockLinkingCollectionsBuildTariffPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContentBlockLinkingCollectionsBuildTariffPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContentBlockLinkingCollectionsBuildTariffPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContentBlockLinkingCollectionsBuildWebpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContentBlockLinkingCollectionsBuildWebpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContentBlockLinkingCollectionsBuildWebpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContentBlockLinkingCollectionsBuildWebpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContentBlockLinkingCollectionsComponentContactAndUsefulLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContentBlockLinkingCollectionsComponentContactAndUsefulLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContentBlockLinkingCollectionsComponentContactAndUsefulLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContentBlockLinkingCollectionsComponentContactAndUsefulLinksCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContentBlockLinkingCollectionsComponentLineupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContentBlockLinkingCollectionsComponentLineupCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContentBlockLinkingCollectionsComponentLineupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContentBlockLinkingCollectionsComponentLineupCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContentBlockLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContentBlockLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContentBlockLinkingCollectionsPackCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContentBlockLinkingCollectionsPackCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContentBlockLinkingCollectionsPackCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContentBlockLinkingCollectionsPackCtaCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentContentBlockLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContentBlockLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContentBlockLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContentBlockLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContentBlockLinkingCollectionsBuildCategoryWebpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PathnameAsc = 'pathname_ASC',
  PathnameDesc = 'pathname_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContentBlockLinkingCollectionsBuildCategoryWebpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PathnameAsc = 'pathname_ASC',
  PathnameDesc = 'pathname_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContentBlockLinkingCollectionsBuildGenericTemplatePageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContentBlockLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContentBlockLinkingCollectionsBuildLandingpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContentBlockLinkingCollectionsBuildLandingpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContentBlockLinkingCollectionsBuildProductDetailPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContentBlockLinkingCollectionsBuildProductDetailPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContentBlockLinkingCollectionsBuildProductOverviewPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContentBlockLinkingCollectionsBuildProductOverviewPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContentBlockLinkingCollectionsBuildTariffPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContentBlockLinkingCollectionsBuildTariffPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContentBlockLinkingCollectionsBuildWebpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContentBlockLinkingCollectionsBuildWebpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContentBlockLinkingCollectionsComponentContactAndUsefulLinksCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContentBlockLinkingCollectionsComponentContactAndUsefulLinksCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContentBlockLinkingCollectionsComponentLineupCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContentBlockLinkingCollectionsComponentLineupCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContentBlockLinkingCollectionsPackCtaCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export enum ComponentContentBlockLinkingCollectionsPackCtaCursorCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export type ComponentContentBlockMediaCollection = {
  __typename?: 'ComponentContentBlockMediaCollection';
  items: Array<Maybe<ComponentContentBlockMediaItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentContentBlockMediaCursorCollection = {
  __typename?: 'ComponentContentBlockMediaCursorCollection';
  items: Array<Maybe<ComponentContentBlockMediaItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentContentBlockMediaFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentContentBlockMediaFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentContentBlockMediaFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type ComponentContentBlockMediaItem = WrapperImage | WrapperVideo;

export enum ComponentContentBlockOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  HeaderLevelAsc = 'headerLevel_ASC',
  HeaderLevelDesc = 'headerLevel_DESC',
  MediaPositionAsc = 'mediaPosition_ASC',
  MediaPositionDesc = 'mediaPosition_DESC',
  ShowTitleAsc = 'showTitle_ASC',
  ShowTitleDesc = 'showTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAlignmentAsc = 'textAlignment_ASC',
  TextAlignmentDesc = 'textAlignment_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlockV2) */
export type ComponentContentBlockV2 = Entry & _Node & {
  __typename?: 'ComponentContentBlockV2';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  backgroundSelector?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  cta1?: Maybe<PackCta>;
  cta1Behaviour?: Maybe<Scalars['String']['output']>;
  cta1Type?: Maybe<Scalars['String']['output']>;
  cta2?: Maybe<PackCta>;
  cta2Behaviour?: Maybe<Scalars['String']['output']>;
  cta2Type?: Maybe<Scalars['String']['output']>;
  headerLevel?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ComponentContentBlockV2LinkingCollections>;
  mediaCollection?: Maybe<ComponentContentBlockV2MediaCollection>;
  mediaCursorCollection?: Maybe<ComponentContentBlockV2MediaCursorCollection>;
  mediaPosition?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<PackStructuredText>;
  sys: Sys;
  terms?: Maybe<PackStructuredText>;
  text?: Maybe<PackStructuredText>;
  text2?: Maybe<PackStructuredText>;
  textAlignment?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlockV2) */
export type ComponentContentBlockV2AnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlockV2) */
export type ComponentContentBlockV2BackgroundSelectorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlockV2) */
export type ComponentContentBlockV2Cta1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlockV2) */
export type ComponentContentBlockV2Cta1BehaviourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlockV2) */
export type ComponentContentBlockV2Cta1TypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlockV2) */
export type ComponentContentBlockV2Cta2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlockV2) */
export type ComponentContentBlockV2Cta2BehaviourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlockV2) */
export type ComponentContentBlockV2Cta2TypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlockV2) */
export type ComponentContentBlockV2HeaderLevelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlockV2) */
export type ComponentContentBlockV2LabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlockV2) */
export type ComponentContentBlockV2LinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlockV2) */
export type ComponentContentBlockV2MediaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentContentBlockV2MediaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlockV2) */
export type ComponentContentBlockV2MediaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentContentBlockV2MediaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlockV2) */
export type ComponentContentBlockV2MediaPositionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlockV2) */
export type ComponentContentBlockV2SubtitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackStructuredTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlockV2) */
export type ComponentContentBlockV2TermsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackStructuredTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlockV2) */
export type ComponentContentBlockV2TextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackStructuredTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlockV2) */
export type ComponentContentBlockV2Text2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackStructuredTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentContentBlockV2) */
export type ComponentContentBlockV2TextAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentContentBlockV2Collection = {
  __typename?: 'ComponentContentBlockV2Collection';
  items: Array<Maybe<ComponentContentBlockV2>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentContentBlockV2CursorCollection = {
  __typename?: 'ComponentContentBlockV2CursorCollection';
  items: Array<Maybe<ComponentContentBlockV2>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentContentBlockV2Filter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentContentBlockV2Filter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentContentBlockV2Filter>>>;
  Text?: InputMaybe<CfPackStructuredTextNestedFilter>;
  Text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundSelector?: InputMaybe<Scalars['String']['input']>;
  backgroundSelector_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundSelector_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundSelector_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundSelector_not?: InputMaybe<Scalars['String']['input']>;
  backgroundSelector_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundSelector_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta1?: InputMaybe<CfPackCtaNestedFilter>;
  cta1Behaviour?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta1Behaviour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Behaviour_not?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Type?: InputMaybe<Scalars['String']['input']>;
  cta1Type_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta1Type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Type_not?: InputMaybe<Scalars['String']['input']>;
  cta1Type_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2?: InputMaybe<CfPackCtaNestedFilter>;
  cta2Behaviour?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2Behaviour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Behaviour_not?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Type?: InputMaybe<Scalars['String']['input']>;
  cta2Type_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2Type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Type_not?: InputMaybe<Scalars['String']['input']>;
  cta2Type_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headerLevel?: InputMaybe<Scalars['String']['input']>;
  headerLevel_contains?: InputMaybe<Scalars['String']['input']>;
  headerLevel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headerLevel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headerLevel_not?: InputMaybe<Scalars['String']['input']>;
  headerLevel_not_contains?: InputMaybe<Scalars['String']['input']>;
  headerLevel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  media?: InputMaybe<CfmediaMultiTypeNestedFilter>;
  mediaCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mediaPosition?: InputMaybe<Scalars['String']['input']>;
  mediaPosition_contains?: InputMaybe<Scalars['String']['input']>;
  mediaPosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mediaPosition_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mediaPosition_not?: InputMaybe<Scalars['String']['input']>;
  mediaPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  mediaPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subtitle?: InputMaybe<CfPackStructuredTextNestedFilter>;
  subtitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  terms?: InputMaybe<CfPackStructuredTextNestedFilter>;
  terms_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text2?: InputMaybe<CfPackStructuredTextNestedFilter>;
  text2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  textAlignment?: InputMaybe<Scalars['String']['input']>;
  textAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  textAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  textAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  textAlignment_not?: InputMaybe<Scalars['String']['input']>;
  textAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  textAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentContentBlockV2LinkingCollections = {
  __typename?: 'ComponentContentBlockV2LinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  componentCarouselCollection?: Maybe<ComponentCarouselCollection>;
  componentCarouselCursorCollection?: Maybe<ComponentCarouselCursorCollection>;
  componentPageHeroCollection?: Maybe<ComponentPageHeroCollection>;
  componentPageHeroCursorCollection?: Maybe<ComponentPageHeroCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  packNavBarItemV2Collection?: Maybe<PackNavBarItemV2Collection>;
  packNavBarItemV2CursorCollection?: Maybe<PackNavBarItemV2CursorCollection>;
};


export type ComponentContentBlockV2LinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContentBlockV2LinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContentBlockV2LinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContentBlockV2LinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContentBlockV2LinkingCollectionsComponentCarouselCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContentBlockV2LinkingCollectionsComponentCarouselCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContentBlockV2LinkingCollectionsComponentCarouselCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContentBlockV2LinkingCollectionsComponentCarouselCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContentBlockV2LinkingCollectionsComponentPageHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContentBlockV2LinkingCollectionsComponentPageHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContentBlockV2LinkingCollectionsComponentPageHeroCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContentBlockV2LinkingCollectionsComponentPageHeroCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContentBlockV2LinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContentBlockV2LinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContentBlockV2LinkingCollectionsPackNavBarItemV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContentBlockV2LinkingCollectionsPackNavBarItemV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentContentBlockV2LinkingCollectionsPackNavBarItemV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContentBlockV2LinkingCollectionsPackNavBarItemV2CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentContentBlockV2LinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContentBlockV2LinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContentBlockV2LinkingCollectionsComponentCarouselCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ComponentContentBlockV2LinkingCollectionsComponentCarouselCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ComponentContentBlockV2LinkingCollectionsComponentPageHeroCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ComponentContentBlockV2LinkingCollectionsComponentPageHeroCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ComponentContentBlockV2LinkingCollectionsPackNavBarItemV2CollectionOrder {
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentContentBlockV2LinkingCollectionsPackNavBarItemV2CursorCollectionOrder {
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComponentContentBlockV2MediaCollection = {
  __typename?: 'ComponentContentBlockV2MediaCollection';
  items: Array<Maybe<ComponentContentBlockV2MediaItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentContentBlockV2MediaCursorCollection = {
  __typename?: 'ComponentContentBlockV2MediaCursorCollection';
  items: Array<Maybe<ComponentContentBlockV2MediaItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentContentBlockV2MediaFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentContentBlockV2MediaFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentContentBlockV2MediaFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type ComponentContentBlockV2MediaItem = AlVvzQa2By0A0OgrM8PSt | ContentType5OiHchWgV9Y8SuvDxHCaLy | ContentType5VCz5FHyZ2ZlWqa5OKh6Y9 | WrapperImage | WrapperVideo;

export enum ComponentContentBlockV2Order {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  HeaderLevelAsc = 'headerLevel_ASC',
  HeaderLevelDesc = 'headerLevel_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MediaPositionAsc = 'mediaPosition_ASC',
  MediaPositionDesc = 'mediaPosition_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAlignmentAsc = 'textAlignment_ASC',
  TextAlignmentDesc = 'textAlignment_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCtaBanner) */
export type ComponentCtaBanner = Entry & _Node & {
  __typename?: 'ComponentCtaBanner';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  bannerType?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  cta?: Maybe<PackCta>;
  ctaBehaviour?: Maybe<Scalars['String']['output']>;
  ctaType?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ComponentCtaBannerLinkingCollections>;
  sys: Sys;
  text?: Maybe<PackStructuredText>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCtaBanner) */
export type ComponentCtaBannerAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCtaBanner) */
export type ComponentCtaBannerBannerTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCtaBanner) */
export type ComponentCtaBannerCtaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCtaBanner) */
export type ComponentCtaBannerCtaBehaviourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCtaBanner) */
export type ComponentCtaBannerCtaTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCtaBanner) */
export type ComponentCtaBannerLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentCtaBanner) */
export type ComponentCtaBannerTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackStructuredTextFilter>;
};

export type ComponentCtaBannerCollection = {
  __typename?: 'ComponentCtaBannerCollection';
  items: Array<Maybe<ComponentCtaBanner>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentCtaBannerCursorCollection = {
  __typename?: 'ComponentCtaBannerCursorCollection';
  items: Array<Maybe<ComponentCtaBanner>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentCtaBannerFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentCtaBannerFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentCtaBannerFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerType?: InputMaybe<Scalars['String']['input']>;
  bannerType_contains?: InputMaybe<Scalars['String']['input']>;
  bannerType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bannerType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerType_not?: InputMaybe<Scalars['String']['input']>;
  bannerType_not_contains?: InputMaybe<Scalars['String']['input']>;
  bannerType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta?: InputMaybe<CfPackCtaNestedFilter>;
  ctaBehaviour?: InputMaybe<Scalars['String']['input']>;
  ctaBehaviour_contains?: InputMaybe<Scalars['String']['input']>;
  ctaBehaviour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaBehaviour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaBehaviour_not?: InputMaybe<Scalars['String']['input']>;
  ctaBehaviour_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaBehaviour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaType?: InputMaybe<Scalars['String']['input']>;
  ctaType_contains?: InputMaybe<Scalars['String']['input']>;
  ctaType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaType_not?: InputMaybe<Scalars['String']['input']>;
  ctaType_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<CfPackStructuredTextNestedFilter>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentCtaBannerLinkingCollections = {
  __typename?: 'ComponentCtaBannerLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildLandingpageCollection?: Maybe<BuildLandingpageCollection>;
  buildLandingpageCursorCollection?: Maybe<BuildLandingpageCursorCollection>;
  buildTariffPageCollection?: Maybe<BuildTariffPageCollection>;
  buildTariffPageCursorCollection?: Maybe<BuildTariffPageCursorCollection>;
  buildWebpageCollection?: Maybe<BuildWebpageCollection>;
  buildWebpageCursorCollection?: Maybe<BuildWebpageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  packCtaCollection?: Maybe<PackCtaCollection>;
  packCtaCursorCollection?: Maybe<PackCtaCursorCollection>;
};


export type ComponentCtaBannerLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCtaBannerLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCtaBannerLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCtaBannerLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCtaBannerLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCtaBannerLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCtaBannerLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCtaBannerLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCtaBannerLinkingCollectionsBuildLandingpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCtaBannerLinkingCollectionsBuildLandingpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCtaBannerLinkingCollectionsBuildLandingpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCtaBannerLinkingCollectionsBuildLandingpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCtaBannerLinkingCollectionsBuildTariffPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCtaBannerLinkingCollectionsBuildTariffPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCtaBannerLinkingCollectionsBuildTariffPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCtaBannerLinkingCollectionsBuildTariffPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCtaBannerLinkingCollectionsBuildWebpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCtaBannerLinkingCollectionsBuildWebpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCtaBannerLinkingCollectionsBuildWebpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCtaBannerLinkingCollectionsBuildWebpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCtaBannerLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCtaBannerLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCtaBannerLinkingCollectionsPackCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCtaBannerLinkingCollectionsPackCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentCtaBannerLinkingCollectionsPackCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCtaBannerLinkingCollectionsPackCtaCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentCtaBannerLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCtaBannerLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCtaBannerLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCtaBannerLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCtaBannerLinkingCollectionsBuildLandingpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCtaBannerLinkingCollectionsBuildLandingpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCtaBannerLinkingCollectionsBuildTariffPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCtaBannerLinkingCollectionsBuildTariffPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCtaBannerLinkingCollectionsBuildWebpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCtaBannerLinkingCollectionsBuildWebpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentCtaBannerLinkingCollectionsPackCtaCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export enum ComponentCtaBannerLinkingCollectionsPackCtaCursorCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export enum ComponentCtaBannerOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  BannerTypeAsc = 'bannerType_ASC',
  BannerTypeDesc = 'bannerType_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentDetailInfoSection) */
export type ComponentDetailInfoSection = Entry & _Node & {
  __typename?: 'ComponentDetailInfoSection';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  bodyText?: Maybe<ComponentDetailInfoSectionBodyText>;
  contentfulMetadata: ContentfulMetadata;
  ctaListCollection?: Maybe<ComponentDetailInfoSectionCtaListCollection>;
  ctaListCursorCollection?: Maybe<ComponentDetailInfoSectionCtaListCursorCollection>;
  image?: Maybe<ContentType5OiHchWgV9Y8SuvDxHCaLy>;
  label?: Maybe<Scalars['String']['output']>;
  layout?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ComponentDetailInfoSectionLinkingCollections>;
  showTitleInline?: Maybe<Scalars['Boolean']['output']>;
  smallText?: Maybe<ComponentDetailInfoSectionSmallText>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  titleColour?: Maybe<Scalars['String']['output']>;
  titlePart1?: Maybe<Scalars['String']['output']>;
  titlePart2?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentDetailInfoSection) */
export type ComponentDetailInfoSectionAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentDetailInfoSection) */
export type ComponentDetailInfoSectionBodyTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentDetailInfoSection) */
export type ComponentDetailInfoSectionCtaListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentDetailInfoSectionCtaListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentDetailInfoSection) */
export type ComponentDetailInfoSectionCtaListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentDetailInfoSectionCtaListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentDetailInfoSection) */
export type ComponentDetailInfoSectionImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentDetailInfoSection) */
export type ComponentDetailInfoSectionLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentDetailInfoSection) */
export type ComponentDetailInfoSectionLayoutArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentDetailInfoSection) */
export type ComponentDetailInfoSectionLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentDetailInfoSection) */
export type ComponentDetailInfoSectionShowTitleInlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentDetailInfoSection) */
export type ComponentDetailInfoSectionSmallTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentDetailInfoSection) */
export type ComponentDetailInfoSectionTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentDetailInfoSection) */
export type ComponentDetailInfoSectionTitleColourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentDetailInfoSection) */
export type ComponentDetailInfoSectionTitlePart1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentDetailInfoSection) */
export type ComponentDetailInfoSectionTitlePart2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentDetailInfoSectionBodyText = {
  __typename?: 'ComponentDetailInfoSectionBodyText';
  json: Scalars['JSON']['output'];
  links: ComponentDetailInfoSectionBodyTextLinks;
};

export type ComponentDetailInfoSectionBodyTextAssets = {
  __typename?: 'ComponentDetailInfoSectionBodyTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComponentDetailInfoSectionBodyTextEntries = {
  __typename?: 'ComponentDetailInfoSectionBodyTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComponentDetailInfoSectionBodyTextLinks = {
  __typename?: 'ComponentDetailInfoSectionBodyTextLinks';
  assets: ComponentDetailInfoSectionBodyTextAssets;
  entries: ComponentDetailInfoSectionBodyTextEntries;
  resources: ComponentDetailInfoSectionBodyTextResources;
};

export type ComponentDetailInfoSectionBodyTextResources = {
  __typename?: 'ComponentDetailInfoSectionBodyTextResources';
  block: Array<ComponentDetailInfoSectionBodyTextResourcesBlock>;
  hyperlink: Array<ComponentDetailInfoSectionBodyTextResourcesHyperlink>;
  inline: Array<ComponentDetailInfoSectionBodyTextResourcesInline>;
};

export type ComponentDetailInfoSectionBodyTextResourcesBlock = ResourceLink & {
  __typename?: 'ComponentDetailInfoSectionBodyTextResourcesBlock';
  sys: ResourceSys;
};

export type ComponentDetailInfoSectionBodyTextResourcesHyperlink = ResourceLink & {
  __typename?: 'ComponentDetailInfoSectionBodyTextResourcesHyperlink';
  sys: ResourceSys;
};

export type ComponentDetailInfoSectionBodyTextResourcesInline = ResourceLink & {
  __typename?: 'ComponentDetailInfoSectionBodyTextResourcesInline';
  sys: ResourceSys;
};

export type ComponentDetailInfoSectionCollection = {
  __typename?: 'ComponentDetailInfoSectionCollection';
  items: Array<Maybe<ComponentDetailInfoSection>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentDetailInfoSectionCtaListCollection = {
  __typename?: 'ComponentDetailInfoSectionCtaListCollection';
  items: Array<Maybe<PackCta>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComponentDetailInfoSectionCtaListCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export type ComponentDetailInfoSectionCtaListCursorCollection = {
  __typename?: 'ComponentDetailInfoSectionCtaListCursorCollection';
  items: Array<Maybe<PackCta>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComponentDetailInfoSectionCtaListCursorCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export type ComponentDetailInfoSectionCursorCollection = {
  __typename?: 'ComponentDetailInfoSectionCursorCollection';
  items: Array<Maybe<ComponentDetailInfoSection>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentDetailInfoSectionFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentDetailInfoSectionFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentDetailInfoSectionFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyText_contains?: InputMaybe<Scalars['String']['input']>;
  bodyText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bodyText_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctaList?: InputMaybe<CfPackCtaNestedFilter>;
  ctaListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<CfContentType5OiHchWgV9Y8SuvDxHCaLyNestedFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  layout?: InputMaybe<Scalars['String']['input']>;
  layout_contains?: InputMaybe<Scalars['String']['input']>;
  layout_exists?: InputMaybe<Scalars['Boolean']['input']>;
  layout_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  layout_not?: InputMaybe<Scalars['String']['input']>;
  layout_not_contains?: InputMaybe<Scalars['String']['input']>;
  layout_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showTitleInline?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_not?: InputMaybe<Scalars['Boolean']['input']>;
  smallText_contains?: InputMaybe<Scalars['String']['input']>;
  smallText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  smallText_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleColour?: InputMaybe<Scalars['String']['input']>;
  titleColour_contains?: InputMaybe<Scalars['String']['input']>;
  titleColour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleColour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColour_not?: InputMaybe<Scalars['String']['input']>;
  titleColour_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleColour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titlePart1?: InputMaybe<Scalars['String']['input']>;
  titlePart1_contains?: InputMaybe<Scalars['String']['input']>;
  titlePart1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titlePart1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titlePart1_not?: InputMaybe<Scalars['String']['input']>;
  titlePart1_not_contains?: InputMaybe<Scalars['String']['input']>;
  titlePart1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titlePart2?: InputMaybe<Scalars['String']['input']>;
  titlePart2_contains?: InputMaybe<Scalars['String']['input']>;
  titlePart2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titlePart2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titlePart2_not?: InputMaybe<Scalars['String']['input']>;
  titlePart2_not_contains?: InputMaybe<Scalars['String']['input']>;
  titlePart2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentDetailInfoSectionLinkingCollections = {
  __typename?: 'ComponentDetailInfoSectionLinkingCollections';
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildGenericTemplatePageCollection?: Maybe<BuildGenericTemplatePageCollection>;
  buildGenericTemplatePageCursorCollection?: Maybe<BuildGenericTemplatePageCursorCollection>;
  buildProductDetailPageCollection?: Maybe<BuildProductDetailPageCollection>;
  buildProductDetailPageCursorCollection?: Maybe<BuildProductDetailPageCursorCollection>;
  buildProductOverviewPageCollection?: Maybe<BuildProductOverviewPageCollection>;
  buildProductOverviewPageCursorCollection?: Maybe<BuildProductOverviewPageCursorCollection>;
  buildTariffPageCollection?: Maybe<BuildTariffPageCollection>;
  buildTariffPageCursorCollection?: Maybe<BuildTariffPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentDetailInfoSectionLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentDetailInfoSectionLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentDetailInfoSectionLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentDetailInfoSectionLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentDetailInfoSectionLinkingCollectionsBuildGenericTemplatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentDetailInfoSectionLinkingCollectionsBuildGenericTemplatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentDetailInfoSectionLinkingCollectionsBuildGenericTemplatePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentDetailInfoSectionLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentDetailInfoSectionLinkingCollectionsBuildProductDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentDetailInfoSectionLinkingCollectionsBuildProductDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentDetailInfoSectionLinkingCollectionsBuildProductDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentDetailInfoSectionLinkingCollectionsBuildProductDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentDetailInfoSectionLinkingCollectionsBuildProductOverviewPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentDetailInfoSectionLinkingCollectionsBuildProductOverviewPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentDetailInfoSectionLinkingCollectionsBuildProductOverviewPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentDetailInfoSectionLinkingCollectionsBuildProductOverviewPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentDetailInfoSectionLinkingCollectionsBuildTariffPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentDetailInfoSectionLinkingCollectionsBuildTariffPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentDetailInfoSectionLinkingCollectionsBuildTariffPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentDetailInfoSectionLinkingCollectionsBuildTariffPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentDetailInfoSectionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentDetailInfoSectionLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentDetailInfoSectionLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentDetailInfoSectionLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentDetailInfoSectionLinkingCollectionsBuildGenericTemplatePageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentDetailInfoSectionLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentDetailInfoSectionLinkingCollectionsBuildProductDetailPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentDetailInfoSectionLinkingCollectionsBuildProductDetailPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentDetailInfoSectionLinkingCollectionsBuildProductOverviewPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentDetailInfoSectionLinkingCollectionsBuildProductOverviewPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentDetailInfoSectionLinkingCollectionsBuildTariffPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentDetailInfoSectionLinkingCollectionsBuildTariffPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentDetailInfoSectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC',
  TitlePart1Asc = 'titlePart1_ASC',
  TitlePart1Desc = 'titlePart1_DESC',
  TitlePart2Asc = 'titlePart2_ASC',
  TitlePart2Desc = 'titlePart2_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ComponentDetailInfoSectionSmallText = {
  __typename?: 'ComponentDetailInfoSectionSmallText';
  json: Scalars['JSON']['output'];
  links: ComponentDetailInfoSectionSmallTextLinks;
};

export type ComponentDetailInfoSectionSmallTextAssets = {
  __typename?: 'ComponentDetailInfoSectionSmallTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComponentDetailInfoSectionSmallTextEntries = {
  __typename?: 'ComponentDetailInfoSectionSmallTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComponentDetailInfoSectionSmallTextLinks = {
  __typename?: 'ComponentDetailInfoSectionSmallTextLinks';
  assets: ComponentDetailInfoSectionSmallTextAssets;
  entries: ComponentDetailInfoSectionSmallTextEntries;
  resources: ComponentDetailInfoSectionSmallTextResources;
};

export type ComponentDetailInfoSectionSmallTextResources = {
  __typename?: 'ComponentDetailInfoSectionSmallTextResources';
  block: Array<ComponentDetailInfoSectionSmallTextResourcesBlock>;
  hyperlink: Array<ComponentDetailInfoSectionSmallTextResourcesHyperlink>;
  inline: Array<ComponentDetailInfoSectionSmallTextResourcesInline>;
};

export type ComponentDetailInfoSectionSmallTextResourcesBlock = ResourceLink & {
  __typename?: 'ComponentDetailInfoSectionSmallTextResourcesBlock';
  sys: ResourceSys;
};

export type ComponentDetailInfoSectionSmallTextResourcesHyperlink = ResourceLink & {
  __typename?: 'ComponentDetailInfoSectionSmallTextResourcesHyperlink';
  sys: ResourceSys;
};

export type ComponentDetailInfoSectionSmallTextResourcesInline = ResourceLink & {
  __typename?: 'ComponentDetailInfoSectionSmallTextResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentFooter) */
export type ComponentFooter = Entry & _Node & {
  __typename?: 'ComponentFooter';
  _id: Scalars['ID']['output'];
  appStoreLinks?: Maybe<PackAppStore>;
  contentfulMetadata: ContentfulMetadata;
  corporateDescriptor?: Maybe<PackMicrocopy>;
  footerItemsCollection?: Maybe<ComponentFooterFooterItemsCollection>;
  footerItemsCursorCollection?: Maybe<ComponentFooterFooterItemsCursorCollection>;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ComponentFooterLinkingCollections>;
  socialIconsCollection?: Maybe<ComponentFooterSocialIconsCollection>;
  socialIconsCursorCollection?: Maybe<ComponentFooterSocialIconsCursorCollection>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentFooter) */
export type ComponentFooterAppStoreLinksArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackAppStoreFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentFooter) */
export type ComponentFooterCorporateDescriptorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackMicrocopyFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentFooter) */
export type ComponentFooterFooterItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFooterFooterItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackFooterItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentFooter) */
export type ComponentFooterFooterItemsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFooterFooterItemsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackFooterItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentFooter) */
export type ComponentFooterInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentFooter) */
export type ComponentFooterLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentFooter) */
export type ComponentFooterSocialIconsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFooterSocialIconsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperSocialMediaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentFooter) */
export type ComponentFooterSocialIconsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFooterSocialIconsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperSocialMediaFilter>;
};

export type ComponentFooterCollection = {
  __typename?: 'ComponentFooterCollection';
  items: Array<Maybe<ComponentFooter>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentFooterCursorCollection = {
  __typename?: 'ComponentFooterCursorCollection';
  items: Array<Maybe<ComponentFooter>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentFooterFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentFooterFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentFooterFilter>>>;
  appStoreLinks?: InputMaybe<CfPackAppStoreNestedFilter>;
  appStoreLinks_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  corporateDescriptor?: InputMaybe<CfPackMicrocopyNestedFilter>;
  corporateDescriptor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  footerItems?: InputMaybe<CfPackFooterItemNestedFilter>;
  footerItemsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialIcons?: InputMaybe<CfWrapperSocialMediaNestedFilter>;
  socialIconsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type ComponentFooterFooterItemsCollection = {
  __typename?: 'ComponentFooterFooterItemsCollection';
  items: Array<Maybe<PackFooterItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComponentFooterFooterItemsCollectionOrder {
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComponentFooterFooterItemsCursorCollection = {
  __typename?: 'ComponentFooterFooterItemsCursorCollection';
  items: Array<Maybe<PackFooterItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComponentFooterFooterItemsCursorCollectionOrder {
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComponentFooterLinkingCollections = {
  __typename?: 'ComponentFooterLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentFooterLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentFooterLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentFooterOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComponentFooterSocialIconsCollection = {
  __typename?: 'ComponentFooterSocialIconsCollection';
  items: Array<Maybe<WrapperSocialMedia>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComponentFooterSocialIconsCollectionOrder {
  ChannelAsc = 'channel_ASC',
  ChannelDesc = 'channel_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComponentFooterSocialIconsCursorCollection = {
  __typename?: 'ComponentFooterSocialIconsCursorCollection';
  items: Array<Maybe<WrapperSocialMedia>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComponentFooterSocialIconsCursorCollectionOrder {
  ChannelAsc = 'channel_ASC',
  ChannelDesc = 'channel_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentFootnotes) */
export type ComponentFootnotes = Entry & _Node & {
  __typename?: 'ComponentFootnotes';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<ComponentFootnotesLinkingCollections>;
  sys: Sys;
  text?: Maybe<PackStructuredText>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentFootnotes) */
export type ComponentFootnotesAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentFootnotes) */
export type ComponentFootnotesLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentFootnotes) */
export type ComponentFootnotesTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackStructuredTextFilter>;
};

export type ComponentFootnotesCollection = {
  __typename?: 'ComponentFootnotesCollection';
  items: Array<Maybe<ComponentFootnotes>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentFootnotesCursorCollection = {
  __typename?: 'ComponentFootnotesCursorCollection';
  items: Array<Maybe<ComponentFootnotes>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentFootnotesFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentFootnotesFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentFootnotesFilter>>>;
  Text?: InputMaybe<CfPackStructuredTextNestedFilter>;
  Text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type ComponentFootnotesLinkingCollections = {
  __typename?: 'ComponentFootnotesLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildGenericTemplatePageCollection?: Maybe<BuildGenericTemplatePageCollection>;
  buildGenericTemplatePageCursorCollection?: Maybe<BuildGenericTemplatePageCursorCollection>;
  buildLandingpageCollection?: Maybe<BuildLandingpageCollection>;
  buildLandingpageCursorCollection?: Maybe<BuildLandingpageCursorCollection>;
  buildProductDetailPageCollection?: Maybe<BuildProductDetailPageCollection>;
  buildProductDetailPageCursorCollection?: Maybe<BuildProductDetailPageCursorCollection>;
  buildProductOverviewPageCollection?: Maybe<BuildProductOverviewPageCollection>;
  buildProductOverviewPageCursorCollection?: Maybe<BuildProductOverviewPageCursorCollection>;
  buildTariffPageCollection?: Maybe<BuildTariffPageCollection>;
  buildTariffPageCursorCollection?: Maybe<BuildTariffPageCursorCollection>;
  buildWebpageCollection?: Maybe<BuildWebpageCollection>;
  buildWebpageCursorCollection?: Maybe<BuildWebpageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentFootnotesLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFootnotesLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentFootnotesLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFootnotesLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentFootnotesLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFootnotesLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentFootnotesLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFootnotesLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentFootnotesLinkingCollectionsBuildGenericTemplatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFootnotesLinkingCollectionsBuildGenericTemplatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentFootnotesLinkingCollectionsBuildGenericTemplatePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFootnotesLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentFootnotesLinkingCollectionsBuildLandingpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFootnotesLinkingCollectionsBuildLandingpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentFootnotesLinkingCollectionsBuildLandingpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFootnotesLinkingCollectionsBuildLandingpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentFootnotesLinkingCollectionsBuildProductDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFootnotesLinkingCollectionsBuildProductDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentFootnotesLinkingCollectionsBuildProductDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFootnotesLinkingCollectionsBuildProductDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentFootnotesLinkingCollectionsBuildProductOverviewPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFootnotesLinkingCollectionsBuildProductOverviewPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentFootnotesLinkingCollectionsBuildProductOverviewPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFootnotesLinkingCollectionsBuildProductOverviewPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentFootnotesLinkingCollectionsBuildTariffPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFootnotesLinkingCollectionsBuildTariffPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentFootnotesLinkingCollectionsBuildTariffPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFootnotesLinkingCollectionsBuildTariffPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentFootnotesLinkingCollectionsBuildWebpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFootnotesLinkingCollectionsBuildWebpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentFootnotesLinkingCollectionsBuildWebpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFootnotesLinkingCollectionsBuildWebpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentFootnotesLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentFootnotesLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentFootnotesLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentFootnotesLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentFootnotesLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentFootnotesLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentFootnotesLinkingCollectionsBuildGenericTemplatePageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentFootnotesLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentFootnotesLinkingCollectionsBuildLandingpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentFootnotesLinkingCollectionsBuildLandingpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentFootnotesLinkingCollectionsBuildProductDetailPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentFootnotesLinkingCollectionsBuildProductDetailPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentFootnotesLinkingCollectionsBuildProductOverviewPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentFootnotesLinkingCollectionsBuildProductOverviewPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentFootnotesLinkingCollectionsBuildTariffPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentFootnotesLinkingCollectionsBuildTariffPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentFootnotesLinkingCollectionsBuildWebpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentFootnotesLinkingCollectionsBuildWebpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentFootnotesOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentForm) */
export type ComponentForm = Entry & _Node & {
  __typename?: 'ComponentForm';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  form?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ComponentFormLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentForm) */
export type ComponentFormAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentForm) */
export type ComponentFormFormArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentForm) */
export type ComponentFormLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentFormCollection = {
  __typename?: 'ComponentFormCollection';
  items: Array<Maybe<ComponentForm>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentFormCursorCollection = {
  __typename?: 'ComponentFormCursorCollection';
  items: Array<Maybe<ComponentForm>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentFormFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentFormFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentFormFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  form?: InputMaybe<Scalars['String']['input']>;
  form_contains?: InputMaybe<Scalars['String']['input']>;
  form_exists?: InputMaybe<Scalars['Boolean']['input']>;
  form_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  form_not?: InputMaybe<Scalars['String']['input']>;
  form_not_contains?: InputMaybe<Scalars['String']['input']>;
  form_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type ComponentFormLinkingCollections = {
  __typename?: 'ComponentFormLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildGenericTemplatePageCollection?: Maybe<BuildGenericTemplatePageCollection>;
  buildGenericTemplatePageCursorCollection?: Maybe<BuildGenericTemplatePageCursorCollection>;
  buildLandingpageCollection?: Maybe<BuildLandingpageCollection>;
  buildLandingpageCursorCollection?: Maybe<BuildLandingpageCursorCollection>;
  buildProductDetailPageCollection?: Maybe<BuildProductDetailPageCollection>;
  buildProductDetailPageCursorCollection?: Maybe<BuildProductDetailPageCursorCollection>;
  buildTariffPageCollection?: Maybe<BuildTariffPageCollection>;
  buildTariffPageCursorCollection?: Maybe<BuildTariffPageCursorCollection>;
  buildWebpageCollection?: Maybe<BuildWebpageCollection>;
  buildWebpageCursorCollection?: Maybe<BuildWebpageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  packCtaCollection?: Maybe<PackCtaCollection>;
  packCtaCursorCollection?: Maybe<PackCtaCursorCollection>;
};


export type ComponentFormLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFormLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentFormLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFormLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentFormLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFormLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentFormLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFormLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentFormLinkingCollectionsBuildGenericTemplatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFormLinkingCollectionsBuildGenericTemplatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentFormLinkingCollectionsBuildGenericTemplatePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFormLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentFormLinkingCollectionsBuildLandingpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFormLinkingCollectionsBuildLandingpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentFormLinkingCollectionsBuildLandingpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFormLinkingCollectionsBuildLandingpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentFormLinkingCollectionsBuildProductDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFormLinkingCollectionsBuildProductDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentFormLinkingCollectionsBuildProductDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFormLinkingCollectionsBuildProductDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentFormLinkingCollectionsBuildTariffPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFormLinkingCollectionsBuildTariffPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentFormLinkingCollectionsBuildTariffPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFormLinkingCollectionsBuildTariffPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentFormLinkingCollectionsBuildWebpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFormLinkingCollectionsBuildWebpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentFormLinkingCollectionsBuildWebpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFormLinkingCollectionsBuildWebpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentFormLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentFormLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentFormLinkingCollectionsPackCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFormLinkingCollectionsPackCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentFormLinkingCollectionsPackCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFormLinkingCollectionsPackCtaCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentFormLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentFormLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentFormLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentFormLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentFormLinkingCollectionsBuildGenericTemplatePageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentFormLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentFormLinkingCollectionsBuildLandingpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentFormLinkingCollectionsBuildLandingpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentFormLinkingCollectionsBuildProductDetailPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentFormLinkingCollectionsBuildProductDetailPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentFormLinkingCollectionsBuildTariffPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentFormLinkingCollectionsBuildTariffPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentFormLinkingCollectionsBuildWebpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentFormLinkingCollectionsBuildWebpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentFormLinkingCollectionsPackCtaCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export enum ComponentFormLinkingCollectionsPackCtaCursorCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export enum ComponentFormOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  FormAsc = 'form_ASC',
  FormDesc = 'form_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentGuideCard) */
export type ComponentGuideCard = Entry & _Node & {
  __typename?: 'ComponentGuideCard';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  cta?: Maybe<PackCta>;
  image?: Maybe<ContentType5OiHchWgV9Y8SuvDxHCaLy>;
  internalTitle?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ComponentGuideCardLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentGuideCard) */
export type ComponentGuideCardCtaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentGuideCard) */
export type ComponentGuideCardImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentGuideCard) */
export type ComponentGuideCardInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentGuideCard) */
export type ComponentGuideCardLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentGuideCard) */
export type ComponentGuideCardLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentGuideCard) */
export type ComponentGuideCardTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentGuideCardCollection = {
  __typename?: 'ComponentGuideCardCollection';
  items: Array<Maybe<ComponentGuideCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentGuideCardCursorCollection = {
  __typename?: 'ComponentGuideCardCursorCollection';
  items: Array<Maybe<ComponentGuideCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentGuideCardFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentGuideCardFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentGuideCardFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta?: InputMaybe<CfPackCtaNestedFilter>;
  cta_exists?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<CfContentType5OiHchWgV9Y8SuvDxHCaLyNestedFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentGuideCardLinkingCollections = {
  __typename?: 'ComponentGuideCardLinkingCollections';
  componentGuidesRailCollection?: Maybe<ComponentGuidesRailCollection>;
  componentGuidesRailCursorCollection?: Maybe<ComponentGuidesRailCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentGuideCardLinkingCollectionsComponentGuidesRailCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentGuideCardLinkingCollectionsComponentGuidesRailCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentGuideCardLinkingCollectionsComponentGuidesRailCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentGuideCardLinkingCollectionsComponentGuidesRailCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentGuideCardLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentGuideCardLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentGuideCardLinkingCollectionsComponentGuidesRailCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export enum ComponentGuideCardLinkingCollectionsComponentGuidesRailCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export enum ComponentGuideCardOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentGuidesRail) */
export type ComponentGuidesRail = Entry & _Node & {
  __typename?: 'ComponentGuidesRail';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  cardsCollection?: Maybe<ComponentGuidesRailCardsCollection>;
  cardsCursorCollection?: Maybe<ComponentGuidesRailCardsCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  cta?: Maybe<PackCta>;
  descriptionText?: Maybe<ComponentGuidesRailDescriptionText>;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ComponentGuidesRailLinkingCollections>;
  showTitleInline?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  title1?: Maybe<Scalars['String']['output']>;
  title2?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentGuidesRail) */
export type ComponentGuidesRailAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentGuidesRail) */
export type ComponentGuidesRailCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentGuidesRailCardsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentGuideCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentGuidesRail) */
export type ComponentGuidesRailCardsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentGuidesRailCardsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentGuideCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentGuidesRail) */
export type ComponentGuidesRailCtaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentGuidesRail) */
export type ComponentGuidesRailDescriptionTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentGuidesRail) */
export type ComponentGuidesRailInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentGuidesRail) */
export type ComponentGuidesRailLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentGuidesRail) */
export type ComponentGuidesRailShowTitleInlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentGuidesRail) */
export type ComponentGuidesRailTitle1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentGuidesRail) */
export type ComponentGuidesRailTitle2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentGuidesRailCardsCollection = {
  __typename?: 'ComponentGuidesRailCardsCollection';
  items: Array<Maybe<ComponentGuideCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComponentGuidesRailCardsCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ComponentGuidesRailCardsCursorCollection = {
  __typename?: 'ComponentGuidesRailCardsCursorCollection';
  items: Array<Maybe<ComponentGuideCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComponentGuidesRailCardsCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ComponentGuidesRailCollection = {
  __typename?: 'ComponentGuidesRailCollection';
  items: Array<Maybe<ComponentGuidesRail>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentGuidesRailCursorCollection = {
  __typename?: 'ComponentGuidesRailCursorCollection';
  items: Array<Maybe<ComponentGuidesRail>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentGuidesRailDescriptionText = {
  __typename?: 'ComponentGuidesRailDescriptionText';
  json: Scalars['JSON']['output'];
  links: ComponentGuidesRailDescriptionTextLinks;
};

export type ComponentGuidesRailDescriptionTextAssets = {
  __typename?: 'ComponentGuidesRailDescriptionTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComponentGuidesRailDescriptionTextEntries = {
  __typename?: 'ComponentGuidesRailDescriptionTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComponentGuidesRailDescriptionTextLinks = {
  __typename?: 'ComponentGuidesRailDescriptionTextLinks';
  assets: ComponentGuidesRailDescriptionTextAssets;
  entries: ComponentGuidesRailDescriptionTextEntries;
  resources: ComponentGuidesRailDescriptionTextResources;
};

export type ComponentGuidesRailDescriptionTextResources = {
  __typename?: 'ComponentGuidesRailDescriptionTextResources';
  block: Array<ComponentGuidesRailDescriptionTextResourcesBlock>;
  hyperlink: Array<ComponentGuidesRailDescriptionTextResourcesHyperlink>;
  inline: Array<ComponentGuidesRailDescriptionTextResourcesInline>;
};

export type ComponentGuidesRailDescriptionTextResourcesBlock = ResourceLink & {
  __typename?: 'ComponentGuidesRailDescriptionTextResourcesBlock';
  sys: ResourceSys;
};

export type ComponentGuidesRailDescriptionTextResourcesHyperlink = ResourceLink & {
  __typename?: 'ComponentGuidesRailDescriptionTextResourcesHyperlink';
  sys: ResourceSys;
};

export type ComponentGuidesRailDescriptionTextResourcesInline = ResourceLink & {
  __typename?: 'ComponentGuidesRailDescriptionTextResourcesInline';
  sys: ResourceSys;
};

export type ComponentGuidesRailFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentGuidesRailFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentGuidesRailFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cards?: InputMaybe<CfComponentGuideCardNestedFilter>;
  cardsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta?: InputMaybe<CfPackCtaNestedFilter>;
  cta_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionText_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionText_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showTitleInline?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title1?: InputMaybe<Scalars['String']['input']>;
  title1_contains?: InputMaybe<Scalars['String']['input']>;
  title1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title1_not?: InputMaybe<Scalars['String']['input']>;
  title1_not_contains?: InputMaybe<Scalars['String']['input']>;
  title1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2?: InputMaybe<Scalars['String']['input']>;
  title2_contains?: InputMaybe<Scalars['String']['input']>;
  title2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2_not?: InputMaybe<Scalars['String']['input']>;
  title2_not_contains?: InputMaybe<Scalars['String']['input']>;
  title2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentGuidesRailLinkingCollections = {
  __typename?: 'ComponentGuidesRailLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildGenericTemplatePageCollection?: Maybe<BuildGenericTemplatePageCollection>;
  buildGenericTemplatePageCursorCollection?: Maybe<BuildGenericTemplatePageCursorCollection>;
  buildLandingpageCollection?: Maybe<BuildLandingpageCollection>;
  buildLandingpageCursorCollection?: Maybe<BuildLandingpageCursorCollection>;
  buildProductDetailPageCollection?: Maybe<BuildProductDetailPageCollection>;
  buildProductDetailPageCursorCollection?: Maybe<BuildProductDetailPageCursorCollection>;
  buildProductOverviewPageCollection?: Maybe<BuildProductOverviewPageCollection>;
  buildProductOverviewPageCursorCollection?: Maybe<BuildProductOverviewPageCursorCollection>;
  buildTariffPageCollection?: Maybe<BuildTariffPageCollection>;
  buildTariffPageCursorCollection?: Maybe<BuildTariffPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentGuidesRailLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentGuidesRailLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentGuidesRailLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentGuidesRailLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentGuidesRailLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentGuidesRailLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentGuidesRailLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentGuidesRailLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentGuidesRailLinkingCollectionsBuildGenericTemplatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentGuidesRailLinkingCollectionsBuildGenericTemplatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentGuidesRailLinkingCollectionsBuildGenericTemplatePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentGuidesRailLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentGuidesRailLinkingCollectionsBuildLandingpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentGuidesRailLinkingCollectionsBuildLandingpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentGuidesRailLinkingCollectionsBuildLandingpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentGuidesRailLinkingCollectionsBuildLandingpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentGuidesRailLinkingCollectionsBuildProductDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentGuidesRailLinkingCollectionsBuildProductDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentGuidesRailLinkingCollectionsBuildProductDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentGuidesRailLinkingCollectionsBuildProductDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentGuidesRailLinkingCollectionsBuildProductOverviewPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentGuidesRailLinkingCollectionsBuildProductOverviewPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentGuidesRailLinkingCollectionsBuildProductOverviewPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentGuidesRailLinkingCollectionsBuildProductOverviewPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentGuidesRailLinkingCollectionsBuildTariffPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentGuidesRailLinkingCollectionsBuildTariffPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentGuidesRailLinkingCollectionsBuildTariffPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentGuidesRailLinkingCollectionsBuildTariffPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentGuidesRailLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentGuidesRailLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentGuidesRailLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentGuidesRailLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentGuidesRailLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentGuidesRailLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentGuidesRailLinkingCollectionsBuildGenericTemplatePageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentGuidesRailLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentGuidesRailLinkingCollectionsBuildLandingpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentGuidesRailLinkingCollectionsBuildLandingpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentGuidesRailLinkingCollectionsBuildProductDetailPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentGuidesRailLinkingCollectionsBuildProductDetailPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentGuidesRailLinkingCollectionsBuildProductOverviewPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentGuidesRailLinkingCollectionsBuildProductOverviewPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentGuidesRailLinkingCollectionsBuildTariffPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentGuidesRailLinkingCollectionsBuildTariffPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentGuidesRailOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentHelpAndCta) */
export type ComponentHelpAndCta = Entry & _Node & {
  __typename?: 'ComponentHelpAndCta';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  cta?: Maybe<PackCta>;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ComponentHelpAndCtaLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentHelpAndCta) */
export type ComponentHelpAndCtaAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentHelpAndCta) */
export type ComponentHelpAndCtaCtaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentHelpAndCta) */
export type ComponentHelpAndCtaInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentHelpAndCta) */
export type ComponentHelpAndCtaLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentHelpAndCta) */
export type ComponentHelpAndCtaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentHelpAndCtaCollection = {
  __typename?: 'ComponentHelpAndCtaCollection';
  items: Array<Maybe<ComponentHelpAndCta>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentHelpAndCtaCursorCollection = {
  __typename?: 'ComponentHelpAndCtaCursorCollection';
  items: Array<Maybe<ComponentHelpAndCta>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentHelpAndCtaFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentHelpAndCtaFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentHelpAndCtaFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta?: InputMaybe<CfPackCtaNestedFilter>;
  cta_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentHelpAndCtaLinkingCollections = {
  __typename?: 'ComponentHelpAndCtaLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildGenericTemplatePageCollection?: Maybe<BuildGenericTemplatePageCollection>;
  buildGenericTemplatePageCursorCollection?: Maybe<BuildGenericTemplatePageCursorCollection>;
  buildLandingpageCollection?: Maybe<BuildLandingpageCollection>;
  buildLandingpageCursorCollection?: Maybe<BuildLandingpageCursorCollection>;
  buildProductDetailPageCollection?: Maybe<BuildProductDetailPageCollection>;
  buildProductDetailPageCursorCollection?: Maybe<BuildProductDetailPageCursorCollection>;
  buildProductOverviewPageCollection?: Maybe<BuildProductOverviewPageCollection>;
  buildProductOverviewPageCursorCollection?: Maybe<BuildProductOverviewPageCursorCollection>;
  buildTariffPageCollection?: Maybe<BuildTariffPageCollection>;
  buildTariffPageCursorCollection?: Maybe<BuildTariffPageCursorCollection>;
  buildWebpageCollection?: Maybe<BuildWebpageCollection>;
  buildWebpageCursorCollection?: Maybe<BuildWebpageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentHelpAndCtaLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentHelpAndCtaLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentHelpAndCtaLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentHelpAndCtaLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentHelpAndCtaLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentHelpAndCtaLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentHelpAndCtaLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentHelpAndCtaLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentHelpAndCtaLinkingCollectionsBuildGenericTemplatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentHelpAndCtaLinkingCollectionsBuildGenericTemplatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentHelpAndCtaLinkingCollectionsBuildGenericTemplatePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentHelpAndCtaLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentHelpAndCtaLinkingCollectionsBuildLandingpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentHelpAndCtaLinkingCollectionsBuildLandingpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentHelpAndCtaLinkingCollectionsBuildLandingpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentHelpAndCtaLinkingCollectionsBuildLandingpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentHelpAndCtaLinkingCollectionsBuildProductDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentHelpAndCtaLinkingCollectionsBuildProductDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentHelpAndCtaLinkingCollectionsBuildProductDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentHelpAndCtaLinkingCollectionsBuildProductDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentHelpAndCtaLinkingCollectionsBuildProductOverviewPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentHelpAndCtaLinkingCollectionsBuildProductOverviewPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentHelpAndCtaLinkingCollectionsBuildProductOverviewPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentHelpAndCtaLinkingCollectionsBuildProductOverviewPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentHelpAndCtaLinkingCollectionsBuildTariffPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentHelpAndCtaLinkingCollectionsBuildTariffPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentHelpAndCtaLinkingCollectionsBuildTariffPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentHelpAndCtaLinkingCollectionsBuildTariffPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentHelpAndCtaLinkingCollectionsBuildWebpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentHelpAndCtaLinkingCollectionsBuildWebpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentHelpAndCtaLinkingCollectionsBuildWebpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentHelpAndCtaLinkingCollectionsBuildWebpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentHelpAndCtaLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentHelpAndCtaLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentHelpAndCtaLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentHelpAndCtaLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentHelpAndCtaLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentHelpAndCtaLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentHelpAndCtaLinkingCollectionsBuildGenericTemplatePageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentHelpAndCtaLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentHelpAndCtaLinkingCollectionsBuildLandingpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentHelpAndCtaLinkingCollectionsBuildLandingpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentHelpAndCtaLinkingCollectionsBuildProductDetailPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentHelpAndCtaLinkingCollectionsBuildProductDetailPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentHelpAndCtaLinkingCollectionsBuildProductOverviewPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentHelpAndCtaLinkingCollectionsBuildProductOverviewPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentHelpAndCtaLinkingCollectionsBuildTariffPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentHelpAndCtaLinkingCollectionsBuildTariffPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentHelpAndCtaLinkingCollectionsBuildWebpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentHelpAndCtaLinkingCollectionsBuildWebpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentHelpAndCtaOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentHelpHomepageDualLayout) */
export type ComponentHelpHomepageDualLayout = Entry & _Node & {
  __typename?: 'ComponentHelpHomepageDualLayout';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  column1?: Maybe<ComponentHelpHomepageDualLayoutColumn1>;
  column2?: Maybe<ComponentHelpHomepageDualLayoutColumn2>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<ComponentHelpHomepageDualLayoutLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentHelpHomepageDualLayout) */
export type ComponentHelpHomepageDualLayoutAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentHelpHomepageDualLayout) */
export type ComponentHelpHomepageDualLayoutColumn1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentHelpHomepageDualLayout) */
export type ComponentHelpHomepageDualLayoutColumn2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentHelpHomepageDualLayout) */
export type ComponentHelpHomepageDualLayoutLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentHelpHomepageDualLayoutCollection = {
  __typename?: 'ComponentHelpHomepageDualLayoutCollection';
  items: Array<Maybe<ComponentHelpHomepageDualLayout>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentHelpHomepageDualLayoutColumn1 = ComponentCategoryBrowser | ComponentTopArticleBrowser;

export type ComponentHelpHomepageDualLayoutColumn2 = ComponentCategoryBrowser | ComponentTopArticleBrowser;

export type ComponentHelpHomepageDualLayoutCursorCollection = {
  __typename?: 'ComponentHelpHomepageDualLayoutCursorCollection';
  items: Array<Maybe<ComponentHelpHomepageDualLayout>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentHelpHomepageDualLayoutFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentHelpHomepageDualLayoutFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentHelpHomepageDualLayoutFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  column1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  column2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type ComponentHelpHomepageDualLayoutLinkingCollections = {
  __typename?: 'ComponentHelpHomepageDualLayoutLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildLandingpageCollection?: Maybe<BuildLandingpageCollection>;
  buildLandingpageCursorCollection?: Maybe<BuildLandingpageCursorCollection>;
  buildTariffPageCollection?: Maybe<BuildTariffPageCollection>;
  buildTariffPageCursorCollection?: Maybe<BuildTariffPageCursorCollection>;
  buildWebpageCollection?: Maybe<BuildWebpageCollection>;
  buildWebpageCursorCollection?: Maybe<BuildWebpageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentHelpHomepageDualLayoutLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentHelpHomepageDualLayoutLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentHelpHomepageDualLayoutLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentHelpHomepageDualLayoutLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentHelpHomepageDualLayoutLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentHelpHomepageDualLayoutLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentHelpHomepageDualLayoutLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentHelpHomepageDualLayoutLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentHelpHomepageDualLayoutLinkingCollectionsBuildLandingpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentHelpHomepageDualLayoutLinkingCollectionsBuildLandingpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentHelpHomepageDualLayoutLinkingCollectionsBuildLandingpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentHelpHomepageDualLayoutLinkingCollectionsBuildLandingpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentHelpHomepageDualLayoutLinkingCollectionsBuildTariffPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentHelpHomepageDualLayoutLinkingCollectionsBuildTariffPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentHelpHomepageDualLayoutLinkingCollectionsBuildTariffPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentHelpHomepageDualLayoutLinkingCollectionsBuildTariffPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentHelpHomepageDualLayoutLinkingCollectionsBuildWebpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentHelpHomepageDualLayoutLinkingCollectionsBuildWebpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentHelpHomepageDualLayoutLinkingCollectionsBuildWebpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentHelpHomepageDualLayoutLinkingCollectionsBuildWebpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentHelpHomepageDualLayoutLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentHelpHomepageDualLayoutLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentHelpHomepageDualLayoutLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentHelpHomepageDualLayoutLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentHelpHomepageDualLayoutLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentHelpHomepageDualLayoutLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentHelpHomepageDualLayoutLinkingCollectionsBuildLandingpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentHelpHomepageDualLayoutLinkingCollectionsBuildLandingpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentHelpHomepageDualLayoutLinkingCollectionsBuildTariffPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentHelpHomepageDualLayoutLinkingCollectionsBuildTariffPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentHelpHomepageDualLayoutLinkingCollectionsBuildWebpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentHelpHomepageDualLayoutLinkingCollectionsBuildWebpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentHelpHomepageDualLayoutOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentHomepageHeroPostcodeSection) */
export type ComponentHomepageHeroPostcodeSection = Entry & _Node & {
  __typename?: 'ComponentHomepageHeroPostcodeSection';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  animations?: Maybe<WrapperAnimation>;
  bynderMedia?: Maybe<ComponentHomepageHeroPostcodeSectionBynderMedia>;
  contentfulMetadata: ContentfulMetadata;
  cta1?: Maybe<PackCta>;
  cta2?: Maybe<PackCta>;
  headerText1?: Maybe<Scalars['String']['output']>;
  headerText2?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ComponentHomepageHeroPostcodeSectionLinkingCollections>;
  postcodeCta?: Maybe<PackCta>;
  showTitleInline?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  variant?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentHomepageHeroPostcodeSection) */
export type ComponentHomepageHeroPostcodeSectionAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentHomepageHeroPostcodeSection) */
export type ComponentHomepageHeroPostcodeSectionAnimationsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperAnimationFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentHomepageHeroPostcodeSection) */
export type ComponentHomepageHeroPostcodeSectionBynderMediaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentHomepageHeroPostcodeSectionBynderMediaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentHomepageHeroPostcodeSection) */
export type ComponentHomepageHeroPostcodeSectionCta1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentHomepageHeroPostcodeSection) */
export type ComponentHomepageHeroPostcodeSectionCta2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentHomepageHeroPostcodeSection) */
export type ComponentHomepageHeroPostcodeSectionHeaderText1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentHomepageHeroPostcodeSection) */
export type ComponentHomepageHeroPostcodeSectionHeaderText2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentHomepageHeroPostcodeSection) */
export type ComponentHomepageHeroPostcodeSectionLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentHomepageHeroPostcodeSection) */
export type ComponentHomepageHeroPostcodeSectionPostcodeCtaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentHomepageHeroPostcodeSection) */
export type ComponentHomepageHeroPostcodeSectionShowTitleInlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentHomepageHeroPostcodeSection) */
export type ComponentHomepageHeroPostcodeSectionVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentHomepageHeroPostcodeSectionBynderMedia = ContentType5OiHchWgV9Y8SuvDxHCaLy | ContentType5VCz5FHyZ2ZlWqa5OKh6Y9;

export type ComponentHomepageHeroPostcodeSectionBynderMediaFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentHomepageHeroPostcodeSectionBynderMediaFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentHomepageHeroPostcodeSectionBynderMediaFilter>>>;
  altText?: InputMaybe<Scalars['String']['input']>;
  altText_contains?: InputMaybe<Scalars['String']['input']>;
  altText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  altText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  altText_not?: InputMaybe<Scalars['String']['input']>;
  altText_not_contains?: InputMaybe<Scalars['String']['input']>;
  altText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderId?: InputMaybe<Scalars['String']['input']>;
  bynderId_contains?: InputMaybe<Scalars['String']['input']>;
  bynderId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bynderId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderId_not?: InputMaybe<Scalars['String']['input']>;
  bynderId_not_contains?: InputMaybe<Scalars['String']['input']>;
  bynderId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentHomepageHeroPostcodeSectionCollection = {
  __typename?: 'ComponentHomepageHeroPostcodeSectionCollection';
  items: Array<Maybe<ComponentHomepageHeroPostcodeSection>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentHomepageHeroPostcodeSectionCursorCollection = {
  __typename?: 'ComponentHomepageHeroPostcodeSectionCursorCollection';
  items: Array<Maybe<ComponentHomepageHeroPostcodeSection>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentHomepageHeroPostcodeSectionFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentHomepageHeroPostcodeSectionFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentHomepageHeroPostcodeSectionFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  animations?: InputMaybe<CfWrapperAnimationNestedFilter>;
  animations_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bynderMedia?: InputMaybe<CfbynderMediaMultiTypeNestedFilter>;
  bynderMedia_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta1?: InputMaybe<CfPackCtaNestedFilter>;
  cta1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2?: InputMaybe<CfPackCtaNestedFilter>;
  cta2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headerText1?: InputMaybe<Scalars['String']['input']>;
  headerText1_contains?: InputMaybe<Scalars['String']['input']>;
  headerText1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headerText1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headerText1_not?: InputMaybe<Scalars['String']['input']>;
  headerText1_not_contains?: InputMaybe<Scalars['String']['input']>;
  headerText1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headerText2?: InputMaybe<Scalars['String']['input']>;
  headerText2_contains?: InputMaybe<Scalars['String']['input']>;
  headerText2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headerText2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headerText2_not?: InputMaybe<Scalars['String']['input']>;
  headerText2_not_contains?: InputMaybe<Scalars['String']['input']>;
  headerText2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  postcodeCta?: InputMaybe<CfPackCtaNestedFilter>;
  postcodeCta_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentHomepageHeroPostcodeSectionLinkingCollections = {
  __typename?: 'ComponentHomepageHeroPostcodeSectionLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  packHomePageCollection?: Maybe<PackHomePageCollection>;
  packHomePageCursorCollection?: Maybe<PackHomePageCursorCollection>;
};


export type ComponentHomepageHeroPostcodeSectionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentHomepageHeroPostcodeSectionLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentHomepageHeroPostcodeSectionLinkingCollectionsPackHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentHomepageHeroPostcodeSectionLinkingCollectionsPackHomePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentHomepageHeroPostcodeSectionLinkingCollectionsPackHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentHomepageHeroPostcodeSectionLinkingCollectionsPackHomePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentHomepageHeroPostcodeSectionLinkingCollectionsPackHomePageCollectionOrder {
  ComponentVariantAsc = 'componentVariant_ASC',
  ComponentVariantDesc = 'componentVariant_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TrustpilotBannerAsc = 'trustpilotBanner_ASC',
  TrustpilotBannerDesc = 'trustpilotBanner_DESC'
}

export enum ComponentHomepageHeroPostcodeSectionLinkingCollectionsPackHomePageCursorCollectionOrder {
  ComponentVariantAsc = 'componentVariant_ASC',
  ComponentVariantDesc = 'componentVariant_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TrustpilotBannerAsc = 'trustpilotBanner_ASC',
  TrustpilotBannerDesc = 'trustpilotBanner_DESC'
}

export enum ComponentHomepageHeroPostcodeSectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentIframe) */
export type ComponentIframe = Entry & _Node & {
  __typename?: 'ComponentIframe';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  center?: Maybe<Scalars['Boolean']['output']>;
  contentfulMetadata: ContentfulMetadata;
  iframeData?: Maybe<Scalars['JSON']['output']>;
  linkedFrom?: Maybe<ComponentIframeLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentIframe) */
export type ComponentIframeAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentIframe) */
export type ComponentIframeCenterArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentIframe) */
export type ComponentIframeIframeDataArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentIframe) */
export type ComponentIframeLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentIframe) */
export type ComponentIframeTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentIframeCollection = {
  __typename?: 'ComponentIframeCollection';
  items: Array<Maybe<ComponentIframe>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentIframeCursorCollection = {
  __typename?: 'ComponentIframeCursorCollection';
  items: Array<Maybe<ComponentIframe>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentIframeFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentIframeFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentIframeFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  center?: InputMaybe<Scalars['Boolean']['input']>;
  center_exists?: InputMaybe<Scalars['Boolean']['input']>;
  center_not?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  iframeData_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentIframeLinkingCollections = {
  __typename?: 'ComponentIframeLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  buildGenericTemplatePageCollection?: Maybe<BuildGenericTemplatePageCollection>;
  buildGenericTemplatePageCursorCollection?: Maybe<BuildGenericTemplatePageCursorCollection>;
  buildLandingpageCollection?: Maybe<BuildLandingpageCollection>;
  buildLandingpageCursorCollection?: Maybe<BuildLandingpageCursorCollection>;
  buildProductDetailPageCollection?: Maybe<BuildProductDetailPageCollection>;
  buildProductDetailPageCursorCollection?: Maybe<BuildProductDetailPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentIframeLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentIframeLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentIframeLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentIframeLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentIframeLinkingCollectionsBuildGenericTemplatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentIframeLinkingCollectionsBuildGenericTemplatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentIframeLinkingCollectionsBuildGenericTemplatePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentIframeLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentIframeLinkingCollectionsBuildLandingpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentIframeLinkingCollectionsBuildLandingpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentIframeLinkingCollectionsBuildLandingpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentIframeLinkingCollectionsBuildLandingpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentIframeLinkingCollectionsBuildProductDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentIframeLinkingCollectionsBuildProductDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentIframeLinkingCollectionsBuildProductDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentIframeLinkingCollectionsBuildProductDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentIframeLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentIframeLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentIframeLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentIframeLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentIframeLinkingCollectionsBuildGenericTemplatePageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentIframeLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentIframeLinkingCollectionsBuildLandingpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentIframeLinkingCollectionsBuildLandingpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentIframeLinkingCollectionsBuildProductDetailPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentIframeLinkingCollectionsBuildProductDetailPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentIframeOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  CenterAsc = 'center_ASC',
  CenterDesc = 'center_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentImageGallery) */
export type ComponentImageGallery = Entry & _Node & {
  __typename?: 'ComponentImageGallery';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  imageAspectRatio?: Maybe<Scalars['String']['output']>;
  imageListCollection?: Maybe<ComponentImageGalleryImageListCollection>;
  imageListCursorCollection?: Maybe<ComponentImageGalleryImageListCursorCollection>;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ComponentImageGalleryLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentImageGallery) */
export type ComponentImageGalleryAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentImageGallery) */
export type ComponentImageGalleryImageAspectRatioArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentImageGallery) */
export type ComponentImageGalleryImageListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentImageGalleryImageListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentImageGallery) */
export type ComponentImageGalleryImageListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentImageGalleryImageListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentImageGallery) */
export type ComponentImageGalleryInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentImageGallery) */
export type ComponentImageGalleryLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentImageGalleryCollection = {
  __typename?: 'ComponentImageGalleryCollection';
  items: Array<Maybe<ComponentImageGallery>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentImageGalleryCursorCollection = {
  __typename?: 'ComponentImageGalleryCursorCollection';
  items: Array<Maybe<ComponentImageGallery>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentImageGalleryFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentImageGalleryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentImageGalleryFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  imageAspectRatio?: InputMaybe<Scalars['String']['input']>;
  imageAspectRatio_contains?: InputMaybe<Scalars['String']['input']>;
  imageAspectRatio_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageAspectRatio_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageAspectRatio_not?: InputMaybe<Scalars['String']['input']>;
  imageAspectRatio_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageAspectRatio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageList?: InputMaybe<CfContentType5OiHchWgV9Y8SuvDxHCaLyNestedFilter>;
  imageListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type ComponentImageGalleryImageListCollection = {
  __typename?: 'ComponentImageGalleryImageListCollection';
  items: Array<Maybe<ContentType5OiHchWgV9Y8SuvDxHCaLy>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComponentImageGalleryImageListCollectionOrder {
  AltTextAsc = 'altText_ASC',
  AltTextDesc = 'altText_DESC',
  BynderIdAsc = 'bynderId_ASC',
  BynderIdDesc = 'bynderId_DESC',
  NetlifyIdAsc = 'netlifyId_ASC',
  NetlifyIdDesc = 'netlifyId_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UsageRightsAsc = 'usageRights_ASC',
  UsageRightsDesc = 'usageRights_DESC',
  UseAltTextAsc = 'useAltText_ASC',
  UseAltTextDesc = 'useAltText_DESC'
}

export type ComponentImageGalleryImageListCursorCollection = {
  __typename?: 'ComponentImageGalleryImageListCursorCollection';
  items: Array<Maybe<ContentType5OiHchWgV9Y8SuvDxHCaLy>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComponentImageGalleryImageListCursorCollectionOrder {
  AltTextAsc = 'altText_ASC',
  AltTextDesc = 'altText_DESC',
  BynderIdAsc = 'bynderId_ASC',
  BynderIdDesc = 'bynderId_DESC',
  NetlifyIdAsc = 'netlifyId_ASC',
  NetlifyIdDesc = 'netlifyId_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UsageRightsAsc = 'usageRights_ASC',
  UsageRightsDesc = 'usageRights_DESC',
  UseAltTextAsc = 'useAltText_ASC',
  UseAltTextDesc = 'useAltText_DESC'
}

export type ComponentImageGalleryLinkingCollections = {
  __typename?: 'ComponentImageGalleryLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildGenericTemplatePageCollection?: Maybe<BuildGenericTemplatePageCollection>;
  buildGenericTemplatePageCursorCollection?: Maybe<BuildGenericTemplatePageCursorCollection>;
  buildProductDetailPageCollection?: Maybe<BuildProductDetailPageCollection>;
  buildProductDetailPageCursorCollection?: Maybe<BuildProductDetailPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  packPageProductDetailCollection?: Maybe<PackPageProductDetailCollection>;
  packPageProductDetailCursorCollection?: Maybe<PackPageProductDetailCursorCollection>;
};


export type ComponentImageGalleryLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentImageGalleryLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentImageGalleryLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentImageGalleryLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentImageGalleryLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentImageGalleryLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentImageGalleryLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentImageGalleryLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentImageGalleryLinkingCollectionsBuildGenericTemplatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentImageGalleryLinkingCollectionsBuildGenericTemplatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentImageGalleryLinkingCollectionsBuildGenericTemplatePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentImageGalleryLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentImageGalleryLinkingCollectionsBuildProductDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentImageGalleryLinkingCollectionsBuildProductDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentImageGalleryLinkingCollectionsBuildProductDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentImageGalleryLinkingCollectionsBuildProductDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentImageGalleryLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentImageGalleryLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentImageGalleryLinkingCollectionsPackPageProductDetailCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentImageGalleryLinkingCollectionsPackPageProductDetailCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentImageGalleryLinkingCollectionsPackPageProductDetailCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentImageGalleryLinkingCollectionsPackPageProductDetailCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentImageGalleryLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentImageGalleryLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentImageGalleryLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentImageGalleryLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentImageGalleryLinkingCollectionsBuildGenericTemplatePageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentImageGalleryLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentImageGalleryLinkingCollectionsBuildProductDetailPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentImageGalleryLinkingCollectionsBuildProductDetailPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentImageGalleryLinkingCollectionsPackPageProductDetailCollectionOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentImageGalleryLinkingCollectionsPackPageProductDetailCursorCollectionOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentImageGalleryOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  ImageAspectRatioAsc = 'imageAspectRatio_ASC',
  ImageAspectRatioDesc = 'imageAspectRatio_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentImageWithDescription) */
export type ComponentImageWithDescription = Entry & _Node & {
  __typename?: 'ComponentImageWithDescription';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  bodyCopy?: Maybe<ComponentImageWithDescriptionBodyCopy>;
  contentOrientation?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  ctaListCollection?: Maybe<ComponentImageWithDescriptionCtaListCollection>;
  ctaListCursorCollection?: Maybe<ComponentImageWithDescriptionCtaListCursorCollection>;
  image?: Maybe<ContentType5OiHchWgV9Y8SuvDxHCaLy>;
  imageAspectRatio?: Maybe<Scalars['String']['output']>;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ComponentImageWithDescriptionLinkingCollections>;
  showTitleInline?: Maybe<Scalars['Boolean']['output']>;
  smallText?: Maybe<ComponentImageWithDescriptionSmallText>;
  sys: Sys;
  title1?: Maybe<Scalars['String']['output']>;
  title2?: Maybe<Scalars['String']['output']>;
  titleColour?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentImageWithDescription) */
export type ComponentImageWithDescriptionAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentImageWithDescription) */
export type ComponentImageWithDescriptionBodyCopyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentImageWithDescription) */
export type ComponentImageWithDescriptionContentOrientationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentImageWithDescription) */
export type ComponentImageWithDescriptionCtaListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentImageWithDescriptionCtaListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentImageWithDescription) */
export type ComponentImageWithDescriptionCtaListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentImageWithDescriptionCtaListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentImageWithDescription) */
export type ComponentImageWithDescriptionImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentImageWithDescription) */
export type ComponentImageWithDescriptionImageAspectRatioArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentImageWithDescription) */
export type ComponentImageWithDescriptionInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentImageWithDescription) */
export type ComponentImageWithDescriptionLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentImageWithDescription) */
export type ComponentImageWithDescriptionShowTitleInlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentImageWithDescription) */
export type ComponentImageWithDescriptionSmallTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentImageWithDescription) */
export type ComponentImageWithDescriptionTitle1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentImageWithDescription) */
export type ComponentImageWithDescriptionTitle2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentImageWithDescription) */
export type ComponentImageWithDescriptionTitleColourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentImageWithDescriptionBodyCopy = {
  __typename?: 'ComponentImageWithDescriptionBodyCopy';
  json: Scalars['JSON']['output'];
  links: ComponentImageWithDescriptionBodyCopyLinks;
};

export type ComponentImageWithDescriptionBodyCopyAssets = {
  __typename?: 'ComponentImageWithDescriptionBodyCopyAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComponentImageWithDescriptionBodyCopyEntries = {
  __typename?: 'ComponentImageWithDescriptionBodyCopyEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComponentImageWithDescriptionBodyCopyLinks = {
  __typename?: 'ComponentImageWithDescriptionBodyCopyLinks';
  assets: ComponentImageWithDescriptionBodyCopyAssets;
  entries: ComponentImageWithDescriptionBodyCopyEntries;
  resources: ComponentImageWithDescriptionBodyCopyResources;
};

export type ComponentImageWithDescriptionBodyCopyResources = {
  __typename?: 'ComponentImageWithDescriptionBodyCopyResources';
  block: Array<ComponentImageWithDescriptionBodyCopyResourcesBlock>;
  hyperlink: Array<ComponentImageWithDescriptionBodyCopyResourcesHyperlink>;
  inline: Array<ComponentImageWithDescriptionBodyCopyResourcesInline>;
};

export type ComponentImageWithDescriptionBodyCopyResourcesBlock = ResourceLink & {
  __typename?: 'ComponentImageWithDescriptionBodyCopyResourcesBlock';
  sys: ResourceSys;
};

export type ComponentImageWithDescriptionBodyCopyResourcesHyperlink = ResourceLink & {
  __typename?: 'ComponentImageWithDescriptionBodyCopyResourcesHyperlink';
  sys: ResourceSys;
};

export type ComponentImageWithDescriptionBodyCopyResourcesInline = ResourceLink & {
  __typename?: 'ComponentImageWithDescriptionBodyCopyResourcesInline';
  sys: ResourceSys;
};

export type ComponentImageWithDescriptionCollection = {
  __typename?: 'ComponentImageWithDescriptionCollection';
  items: Array<Maybe<ComponentImageWithDescription>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentImageWithDescriptionCtaListCollection = {
  __typename?: 'ComponentImageWithDescriptionCtaListCollection';
  items: Array<Maybe<PackCta>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComponentImageWithDescriptionCtaListCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export type ComponentImageWithDescriptionCtaListCursorCollection = {
  __typename?: 'ComponentImageWithDescriptionCtaListCursorCollection';
  items: Array<Maybe<PackCta>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComponentImageWithDescriptionCtaListCursorCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export type ComponentImageWithDescriptionCursorCollection = {
  __typename?: 'ComponentImageWithDescriptionCursorCollection';
  items: Array<Maybe<ComponentImageWithDescription>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentImageWithDescriptionFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentImageWithDescriptionFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentImageWithDescriptionFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy_contains?: InputMaybe<Scalars['String']['input']>;
  bodyCopy_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bodyCopy_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentOrientation?: InputMaybe<Scalars['String']['input']>;
  contentOrientation_contains?: InputMaybe<Scalars['String']['input']>;
  contentOrientation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentOrientation_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentOrientation_not?: InputMaybe<Scalars['String']['input']>;
  contentOrientation_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentOrientation_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctaList?: InputMaybe<CfPackCtaNestedFilter>;
  ctaListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<CfContentType5OiHchWgV9Y8SuvDxHCaLyNestedFilter>;
  imageAspectRatio?: InputMaybe<Scalars['String']['input']>;
  imageAspectRatio_contains?: InputMaybe<Scalars['String']['input']>;
  imageAspectRatio_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageAspectRatio_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageAspectRatio_not?: InputMaybe<Scalars['String']['input']>;
  imageAspectRatio_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageAspectRatio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showTitleInline?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_not?: InputMaybe<Scalars['Boolean']['input']>;
  smallText_contains?: InputMaybe<Scalars['String']['input']>;
  smallText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  smallText_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  title1?: InputMaybe<Scalars['String']['input']>;
  title1_contains?: InputMaybe<Scalars['String']['input']>;
  title1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title1_not?: InputMaybe<Scalars['String']['input']>;
  title1_not_contains?: InputMaybe<Scalars['String']['input']>;
  title1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2?: InputMaybe<Scalars['String']['input']>;
  title2_contains?: InputMaybe<Scalars['String']['input']>;
  title2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2_not?: InputMaybe<Scalars['String']['input']>;
  title2_not_contains?: InputMaybe<Scalars['String']['input']>;
  title2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColour?: InputMaybe<Scalars['String']['input']>;
  titleColour_contains?: InputMaybe<Scalars['String']['input']>;
  titleColour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleColour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColour_not?: InputMaybe<Scalars['String']['input']>;
  titleColour_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleColour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentImageWithDescriptionLinkingCollections = {
  __typename?: 'ComponentImageWithDescriptionLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildGenericTemplatePageCollection?: Maybe<BuildGenericTemplatePageCollection>;
  buildGenericTemplatePageCursorCollection?: Maybe<BuildGenericTemplatePageCursorCollection>;
  buildProductDetailPageCollection?: Maybe<BuildProductDetailPageCollection>;
  buildProductDetailPageCursorCollection?: Maybe<BuildProductDetailPageCursorCollection>;
  buildProductOverviewPageCollection?: Maybe<BuildProductOverviewPageCollection>;
  buildProductOverviewPageCursorCollection?: Maybe<BuildProductOverviewPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentImageWithDescriptionLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentImageWithDescriptionLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentImageWithDescriptionLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentImageWithDescriptionLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentImageWithDescriptionLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentImageWithDescriptionLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentImageWithDescriptionLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentImageWithDescriptionLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentImageWithDescriptionLinkingCollectionsBuildGenericTemplatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentImageWithDescriptionLinkingCollectionsBuildGenericTemplatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentImageWithDescriptionLinkingCollectionsBuildGenericTemplatePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentImageWithDescriptionLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentImageWithDescriptionLinkingCollectionsBuildProductDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentImageWithDescriptionLinkingCollectionsBuildProductDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentImageWithDescriptionLinkingCollectionsBuildProductDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentImageWithDescriptionLinkingCollectionsBuildProductDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentImageWithDescriptionLinkingCollectionsBuildProductOverviewPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentImageWithDescriptionLinkingCollectionsBuildProductOverviewPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentImageWithDescriptionLinkingCollectionsBuildProductOverviewPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentImageWithDescriptionLinkingCollectionsBuildProductOverviewPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentImageWithDescriptionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentImageWithDescriptionLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentImageWithDescriptionLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentImageWithDescriptionLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentImageWithDescriptionLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentImageWithDescriptionLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentImageWithDescriptionLinkingCollectionsBuildGenericTemplatePageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentImageWithDescriptionLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentImageWithDescriptionLinkingCollectionsBuildProductDetailPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentImageWithDescriptionLinkingCollectionsBuildProductDetailPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentImageWithDescriptionLinkingCollectionsBuildProductOverviewPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentImageWithDescriptionLinkingCollectionsBuildProductOverviewPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentImageWithDescriptionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  ContentOrientationAsc = 'contentOrientation_ASC',
  ContentOrientationDesc = 'contentOrientation_DESC',
  ImageAspectRatioAsc = 'imageAspectRatio_ASC',
  ImageAspectRatioDesc = 'imageAspectRatio_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC'
}

export type ComponentImageWithDescriptionSmallText = {
  __typename?: 'ComponentImageWithDescriptionSmallText';
  json: Scalars['JSON']['output'];
  links: ComponentImageWithDescriptionSmallTextLinks;
};

export type ComponentImageWithDescriptionSmallTextAssets = {
  __typename?: 'ComponentImageWithDescriptionSmallTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComponentImageWithDescriptionSmallTextEntries = {
  __typename?: 'ComponentImageWithDescriptionSmallTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComponentImageWithDescriptionSmallTextLinks = {
  __typename?: 'ComponentImageWithDescriptionSmallTextLinks';
  assets: ComponentImageWithDescriptionSmallTextAssets;
  entries: ComponentImageWithDescriptionSmallTextEntries;
  resources: ComponentImageWithDescriptionSmallTextResources;
};

export type ComponentImageWithDescriptionSmallTextResources = {
  __typename?: 'ComponentImageWithDescriptionSmallTextResources';
  block: Array<ComponentImageWithDescriptionSmallTextResourcesBlock>;
  hyperlink: Array<ComponentImageWithDescriptionSmallTextResourcesHyperlink>;
  inline: Array<ComponentImageWithDescriptionSmallTextResourcesInline>;
};

export type ComponentImageWithDescriptionSmallTextResourcesBlock = ResourceLink & {
  __typename?: 'ComponentImageWithDescriptionSmallTextResourcesBlock';
  sys: ResourceSys;
};

export type ComponentImageWithDescriptionSmallTextResourcesHyperlink = ResourceLink & {
  __typename?: 'ComponentImageWithDescriptionSmallTextResourcesHyperlink';
  sys: ResourceSys;
};

export type ComponentImageWithDescriptionSmallTextResourcesInline = ResourceLink & {
  __typename?: 'ComponentImageWithDescriptionSmallTextResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentInfoCard) */
export type ComponentInfoCard = Entry & _Node & {
  __typename?: 'ComponentInfoCard';
  _id: Scalars['ID']['output'];
  bodyCopy?: Maybe<Scalars['String']['output']>;
  bodyRichText?: Maybe<ComponentInfoCardBodyRichText>;
  contentfulMetadata: ContentfulMetadata;
  cta?: Maybe<PackCta>;
  destinationLabel?: Maybe<Scalars['String']['output']>;
  destinationUrl?: Maybe<WrapperUrl>;
  icon?: Maybe<ContentType5OiHchWgV9Y8SuvDxHCaLy>;
  isExternalLink?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<ComponentInfoCardLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentInfoCard) */
export type ComponentInfoCardBodyCopyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentInfoCard) */
export type ComponentInfoCardBodyRichTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentInfoCard) */
export type ComponentInfoCardCtaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentInfoCard) */
export type ComponentInfoCardDestinationLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentInfoCard) */
export type ComponentInfoCardDestinationUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperUrlFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentInfoCard) */
export type ComponentInfoCardIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentInfoCard) */
export type ComponentInfoCardIsExternalLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentInfoCard) */
export type ComponentInfoCardLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentInfoCard) */
export type ComponentInfoCardTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentInfoCardBodyRichText = {
  __typename?: 'ComponentInfoCardBodyRichText';
  json: Scalars['JSON']['output'];
  links: ComponentInfoCardBodyRichTextLinks;
};

export type ComponentInfoCardBodyRichTextAssets = {
  __typename?: 'ComponentInfoCardBodyRichTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComponentInfoCardBodyRichTextEntries = {
  __typename?: 'ComponentInfoCardBodyRichTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComponentInfoCardBodyRichTextLinks = {
  __typename?: 'ComponentInfoCardBodyRichTextLinks';
  assets: ComponentInfoCardBodyRichTextAssets;
  entries: ComponentInfoCardBodyRichTextEntries;
  resources: ComponentInfoCardBodyRichTextResources;
};

export type ComponentInfoCardBodyRichTextResources = {
  __typename?: 'ComponentInfoCardBodyRichTextResources';
  block: Array<ComponentInfoCardBodyRichTextResourcesBlock>;
  hyperlink: Array<ComponentInfoCardBodyRichTextResourcesHyperlink>;
  inline: Array<ComponentInfoCardBodyRichTextResourcesInline>;
};

export type ComponentInfoCardBodyRichTextResourcesBlock = ResourceLink & {
  __typename?: 'ComponentInfoCardBodyRichTextResourcesBlock';
  sys: ResourceSys;
};

export type ComponentInfoCardBodyRichTextResourcesHyperlink = ResourceLink & {
  __typename?: 'ComponentInfoCardBodyRichTextResourcesHyperlink';
  sys: ResourceSys;
};

export type ComponentInfoCardBodyRichTextResourcesInline = ResourceLink & {
  __typename?: 'ComponentInfoCardBodyRichTextResourcesInline';
  sys: ResourceSys;
};

export type ComponentInfoCardCollection = {
  __typename?: 'ComponentInfoCardCollection';
  items: Array<Maybe<ComponentInfoCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentInfoCardCursorCollection = {
  __typename?: 'ComponentInfoCardCursorCollection';
  items: Array<Maybe<ComponentInfoCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentInfoCardFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentInfoCardFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentInfoCardFilter>>>;
  bodyCopy?: InputMaybe<Scalars['String']['input']>;
  bodyCopy_contains?: InputMaybe<Scalars['String']['input']>;
  bodyCopy_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bodyCopy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy_not?: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_contains?: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyRichText_contains?: InputMaybe<Scalars['String']['input']>;
  bodyRichText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bodyRichText_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta?: InputMaybe<CfPackCtaNestedFilter>;
  cta_exists?: InputMaybe<Scalars['Boolean']['input']>;
  destinationLabel?: InputMaybe<Scalars['String']['input']>;
  destinationLabel_contains?: InputMaybe<Scalars['String']['input']>;
  destinationLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  destinationLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  destinationLabel_not?: InputMaybe<Scalars['String']['input']>;
  destinationLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  destinationLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  destinationUrl?: InputMaybe<CfWrapperUrlNestedFilter>;
  destinationUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<CfContentType5OiHchWgV9Y8SuvDxHCaLyNestedFilter>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isExternalLink?: InputMaybe<Scalars['Boolean']['input']>;
  isExternalLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isExternalLink_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentInfoCardLinkingCollections = {
  __typename?: 'ComponentInfoCardLinkingCollections';
  componentCardGroupCollection?: Maybe<ComponentCardGroupCollection>;
  componentCardGroupCursorCollection?: Maybe<ComponentCardGroupCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentInfoCardLinkingCollectionsComponentCardGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentInfoCardLinkingCollectionsComponentCardGroupCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentInfoCardLinkingCollectionsComponentCardGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentInfoCardLinkingCollectionsComponentCardGroupCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentInfoCardLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentInfoCardLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentInfoCardLinkingCollectionsComponentCardGroupCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC'
}

export enum ComponentInfoCardLinkingCollectionsComponentCardGroupCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC'
}

export enum ComponentInfoCardOrder {
  DestinationLabelAsc = 'destinationLabel_ASC',
  DestinationLabelDesc = 'destinationLabel_DESC',
  IsExternalLinkAsc = 'isExternalLink_ASC',
  IsExternalLinkDesc = 'isExternalLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentInfoGroup) */
export type ComponentInfoGroup = Entry & _Node & {
  __typename?: 'ComponentInfoGroup';
  _id: Scalars['ID']['output'];
  align?: Maybe<Scalars['String']['output']>;
  anchor?: Maybe<Scalars['String']['output']>;
  cardListCollection?: Maybe<ComponentInfoGroupCardListCollection>;
  cardListCursorCollection?: Maybe<ComponentInfoGroupCardListCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ComponentInfoGroupLinkingCollections>;
  showTitleInline?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  title1?: Maybe<Scalars['String']['output']>;
  title2?: Maybe<Scalars['String']['output']>;
  titleColour?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentInfoGroup) */
export type ComponentInfoGroupAlignArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentInfoGroup) */
export type ComponentInfoGroupAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentInfoGroup) */
export type ComponentInfoGroupCardListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentInfoGroupCardListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentBlockCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentInfoGroup) */
export type ComponentInfoGroupCardListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentInfoGroupCardListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentBlockCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentInfoGroup) */
export type ComponentInfoGroupInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentInfoGroup) */
export type ComponentInfoGroupLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentInfoGroup) */
export type ComponentInfoGroupShowTitleInlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentInfoGroup) */
export type ComponentInfoGroupTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentInfoGroup) */
export type ComponentInfoGroupTitle1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentInfoGroup) */
export type ComponentInfoGroupTitle2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentInfoGroup) */
export type ComponentInfoGroupTitleColourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentInfoGroupCardListCollection = {
  __typename?: 'ComponentInfoGroupCardListCollection';
  items: Array<Maybe<ComponentBlockCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComponentInfoGroupCardListCollectionOrder {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ComponentInfoGroupCardListCursorCollection = {
  __typename?: 'ComponentInfoGroupCardListCursorCollection';
  items: Array<Maybe<ComponentBlockCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComponentInfoGroupCardListCursorCollectionOrder {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ComponentInfoGroupCollection = {
  __typename?: 'ComponentInfoGroupCollection';
  items: Array<Maybe<ComponentInfoGroup>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentInfoGroupCursorCollection = {
  __typename?: 'ComponentInfoGroupCursorCollection';
  items: Array<Maybe<ComponentInfoGroup>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentInfoGroupFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentInfoGroupFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentInfoGroupFilter>>>;
  align?: InputMaybe<Scalars['String']['input']>;
  align_contains?: InputMaybe<Scalars['String']['input']>;
  align_exists?: InputMaybe<Scalars['Boolean']['input']>;
  align_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  align_not?: InputMaybe<Scalars['String']['input']>;
  align_not_contains?: InputMaybe<Scalars['String']['input']>;
  align_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardList?: InputMaybe<CfComponentBlockCardNestedFilter>;
  cardListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showTitleInline?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title1?: InputMaybe<Scalars['String']['input']>;
  title1_contains?: InputMaybe<Scalars['String']['input']>;
  title1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title1_not?: InputMaybe<Scalars['String']['input']>;
  title1_not_contains?: InputMaybe<Scalars['String']['input']>;
  title1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2?: InputMaybe<Scalars['String']['input']>;
  title2_contains?: InputMaybe<Scalars['String']['input']>;
  title2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2_not?: InputMaybe<Scalars['String']['input']>;
  title2_not_contains?: InputMaybe<Scalars['String']['input']>;
  title2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColour?: InputMaybe<Scalars['String']['input']>;
  titleColour_contains?: InputMaybe<Scalars['String']['input']>;
  titleColour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleColour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColour_not?: InputMaybe<Scalars['String']['input']>;
  titleColour_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleColour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentInfoGroupLinkingCollections = {
  __typename?: 'ComponentInfoGroupLinkingCollections';
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildGenericTemplatePageCollection?: Maybe<BuildGenericTemplatePageCollection>;
  buildGenericTemplatePageCursorCollection?: Maybe<BuildGenericTemplatePageCursorCollection>;
  buildProductDetailPageCollection?: Maybe<BuildProductDetailPageCollection>;
  buildProductDetailPageCursorCollection?: Maybe<BuildProductDetailPageCursorCollection>;
  buildProductOverviewPageCollection?: Maybe<BuildProductOverviewPageCollection>;
  buildProductOverviewPageCursorCollection?: Maybe<BuildProductOverviewPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentInfoGroupLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentInfoGroupLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentInfoGroupLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentInfoGroupLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentInfoGroupLinkingCollectionsBuildGenericTemplatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentInfoGroupLinkingCollectionsBuildGenericTemplatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentInfoGroupLinkingCollectionsBuildGenericTemplatePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentInfoGroupLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentInfoGroupLinkingCollectionsBuildProductDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentInfoGroupLinkingCollectionsBuildProductDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentInfoGroupLinkingCollectionsBuildProductDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentInfoGroupLinkingCollectionsBuildProductDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentInfoGroupLinkingCollectionsBuildProductOverviewPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentInfoGroupLinkingCollectionsBuildProductOverviewPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentInfoGroupLinkingCollectionsBuildProductOverviewPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentInfoGroupLinkingCollectionsBuildProductOverviewPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentInfoGroupLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentInfoGroupLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentInfoGroupLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentInfoGroupLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentInfoGroupLinkingCollectionsBuildGenericTemplatePageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentInfoGroupLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentInfoGroupLinkingCollectionsBuildProductDetailPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentInfoGroupLinkingCollectionsBuildProductDetailPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentInfoGroupLinkingCollectionsBuildProductOverviewPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentInfoGroupLinkingCollectionsBuildProductOverviewPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentInfoGroupOrder {
  AlignAsc = 'align_ASC',
  AlignDesc = 'align_DESC',
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentLauncherGroup) */
export type ComponentLauncherGroup = Entry & _Node & {
  __typename?: 'ComponentLauncherGroup';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  cardListCollection?: Maybe<ComponentLauncherGroupCardListCollection>;
  cardListCursorCollection?: Maybe<ComponentLauncherGroupCardListCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ComponentLauncherGroupLinkingCollections>;
  sys: Sys;
  title1?: Maybe<Scalars['String']['output']>;
  title2?: Maybe<Scalars['String']['output']>;
  titleColour?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentLauncherGroup) */
export type ComponentLauncherGroupAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentLauncherGroup) */
export type ComponentLauncherGroupCardListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentLauncherGroupCardListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentBlockCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentLauncherGroup) */
export type ComponentLauncherGroupCardListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentLauncherGroupCardListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentBlockCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentLauncherGroup) */
export type ComponentLauncherGroupInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentLauncherGroup) */
export type ComponentLauncherGroupLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentLauncherGroup) */
export type ComponentLauncherGroupTitle1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentLauncherGroup) */
export type ComponentLauncherGroupTitle2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentLauncherGroup) */
export type ComponentLauncherGroupTitleColourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentLauncherGroupCardListCollection = {
  __typename?: 'ComponentLauncherGroupCardListCollection';
  items: Array<Maybe<ComponentBlockCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComponentLauncherGroupCardListCollectionOrder {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ComponentLauncherGroupCardListCursorCollection = {
  __typename?: 'ComponentLauncherGroupCardListCursorCollection';
  items: Array<Maybe<ComponentBlockCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComponentLauncherGroupCardListCursorCollectionOrder {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ComponentLauncherGroupCollection = {
  __typename?: 'ComponentLauncherGroupCollection';
  items: Array<Maybe<ComponentLauncherGroup>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentLauncherGroupCursorCollection = {
  __typename?: 'ComponentLauncherGroupCursorCollection';
  items: Array<Maybe<ComponentLauncherGroup>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentLauncherGroupFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentLauncherGroupFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentLauncherGroupFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardList?: InputMaybe<CfComponentBlockCardNestedFilter>;
  cardListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title1?: InputMaybe<Scalars['String']['input']>;
  title1_contains?: InputMaybe<Scalars['String']['input']>;
  title1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title1_not?: InputMaybe<Scalars['String']['input']>;
  title1_not_contains?: InputMaybe<Scalars['String']['input']>;
  title1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2?: InputMaybe<Scalars['String']['input']>;
  title2_contains?: InputMaybe<Scalars['String']['input']>;
  title2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2_not?: InputMaybe<Scalars['String']['input']>;
  title2_not_contains?: InputMaybe<Scalars['String']['input']>;
  title2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColour?: InputMaybe<Scalars['String']['input']>;
  titleColour_contains?: InputMaybe<Scalars['String']['input']>;
  titleColour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleColour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColour_not?: InputMaybe<Scalars['String']['input']>;
  titleColour_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleColour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentLauncherGroupLinkingCollections = {
  __typename?: 'ComponentLauncherGroupLinkingCollections';
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildGenericTemplatePageCollection?: Maybe<BuildGenericTemplatePageCollection>;
  buildGenericTemplatePageCursorCollection?: Maybe<BuildGenericTemplatePageCursorCollection>;
  buildProductDetailPageCollection?: Maybe<BuildProductDetailPageCollection>;
  buildProductDetailPageCursorCollection?: Maybe<BuildProductDetailPageCursorCollection>;
  buildProductOverviewPageCollection?: Maybe<BuildProductOverviewPageCollection>;
  buildProductOverviewPageCursorCollection?: Maybe<BuildProductOverviewPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentLauncherGroupLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentLauncherGroupLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentLauncherGroupLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentLauncherGroupLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentLauncherGroupLinkingCollectionsBuildGenericTemplatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentLauncherGroupLinkingCollectionsBuildGenericTemplatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentLauncherGroupLinkingCollectionsBuildGenericTemplatePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentLauncherGroupLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentLauncherGroupLinkingCollectionsBuildProductDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentLauncherGroupLinkingCollectionsBuildProductDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentLauncherGroupLinkingCollectionsBuildProductDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentLauncherGroupLinkingCollectionsBuildProductDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentLauncherGroupLinkingCollectionsBuildProductOverviewPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentLauncherGroupLinkingCollectionsBuildProductOverviewPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentLauncherGroupLinkingCollectionsBuildProductOverviewPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentLauncherGroupLinkingCollectionsBuildProductOverviewPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentLauncherGroupLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentLauncherGroupLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentLauncherGroupLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentLauncherGroupLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentLauncherGroupLinkingCollectionsBuildGenericTemplatePageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentLauncherGroupLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentLauncherGroupLinkingCollectionsBuildProductDetailPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentLauncherGroupLinkingCollectionsBuildProductDetailPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentLauncherGroupLinkingCollectionsBuildProductOverviewPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentLauncherGroupLinkingCollectionsBuildProductOverviewPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentLauncherGroupOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentLineup) */
export type ComponentLineup = Entry & _Node & {
  __typename?: 'ComponentLineup';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<ComponentLineupLinkingCollections>;
  row1Collection?: Maybe<ComponentLineupRow1Collection>;
  row1CursorCollection?: Maybe<ComponentLineupRow1CursorCollection>;
  row2Collection?: Maybe<ComponentLineupRow2Collection>;
  row2CursorCollection?: Maybe<ComponentLineupRow2CursorCollection>;
  row3Collection?: Maybe<ComponentLineupRow3Collection>;
  row3CursorCollection?: Maybe<ComponentLineupRow3CursorCollection>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentLineup) */
export type ComponentLineupAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentLineup) */
export type ComponentLineupLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentLineup) */
export type ComponentLineupRow1CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentLineupRow1Filter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentLineup) */
export type ComponentLineupRow1CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentLineupRow1Filter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentLineup) */
export type ComponentLineupRow2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentLineupRow2Filter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentLineup) */
export type ComponentLineupRow2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentLineupRow2Filter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentLineup) */
export type ComponentLineupRow3CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentLineupRow3Filter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentLineup) */
export type ComponentLineupRow3CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentLineupRow3Filter>;
};

export type ComponentLineupCollection = {
  __typename?: 'ComponentLineupCollection';
  items: Array<Maybe<ComponentLineup>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentLineupCursorCollection = {
  __typename?: 'ComponentLineupCursorCollection';
  items: Array<Maybe<ComponentLineup>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentLineupFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentLineupFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentLineupFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  row1?: InputMaybe<Cfrow1MultiTypeNestedFilter>;
  row1Collection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  row2?: InputMaybe<Cfrow2MultiTypeNestedFilter>;
  row2Collection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  row3?: InputMaybe<Cfrow3MultiTypeNestedFilter>;
  row3Collection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type ComponentLineupLinkingCollections = {
  __typename?: 'ComponentLineupLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentLineupLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentLineupLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentLineupOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComponentLineupRow1Collection = {
  __typename?: 'ComponentLineupRow1Collection';
  items: Array<Maybe<ComponentLineupRow1Item>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentLineupRow1CursorCollection = {
  __typename?: 'ComponentLineupRow1CursorCollection';
  items: Array<Maybe<ComponentLineupRow1Item>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentLineupRow1Filter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentLineupRow1Filter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentLineupRow1Filter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type ComponentLineupRow1Item = ComponentCategoryBrowser | ComponentContentBlock | ComponentTopArticleBrowser;

export type ComponentLineupRow2Collection = {
  __typename?: 'ComponentLineupRow2Collection';
  items: Array<Maybe<ComponentLineupRow2Item>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentLineupRow2CursorCollection = {
  __typename?: 'ComponentLineupRow2CursorCollection';
  items: Array<Maybe<ComponentLineupRow2Item>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentLineupRow2Filter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentLineupRow2Filter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentLineupRow2Filter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type ComponentLineupRow2Item = ComponentCategoryBrowser | ComponentContentBlock | ComponentTopArticleBrowser;

export type ComponentLineupRow3Collection = {
  __typename?: 'ComponentLineupRow3Collection';
  items: Array<Maybe<ComponentLineupRow3Item>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentLineupRow3CursorCollection = {
  __typename?: 'ComponentLineupRow3CursorCollection';
  items: Array<Maybe<ComponentLineupRow3Item>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentLineupRow3Filter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentLineupRow3Filter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentLineupRow3Filter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type ComponentLineupRow3Item = ComponentCategoryBrowser | ComponentContentBlock | ComponentTopArticleBrowser;

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentLogoGroup) */
export type ComponentLogoGroup = Entry & _Node & {
  __typename?: 'ComponentLogoGroup';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ComponentLogoGroupLinkingCollections>;
  logoListCollection?: Maybe<ComponentLogoGroupLogoListCollection>;
  logoListCursorCollection?: Maybe<ComponentLogoGroupLogoListCursorCollection>;
  showTitleInline?: Maybe<Scalars['Boolean']['output']>;
  smallText?: Maybe<ComponentLogoGroupSmallText>;
  sys: Sys;
  theme?: Maybe<Scalars['String']['output']>;
  title1?: Maybe<Scalars['String']['output']>;
  title2?: Maybe<Scalars['String']['output']>;
  titleColour?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentLogoGroup) */
export type ComponentLogoGroupAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentLogoGroup) */
export type ComponentLogoGroupInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentLogoGroup) */
export type ComponentLogoGroupLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentLogoGroup) */
export type ComponentLogoGroupLogoListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentLogoGroupLogoListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentLogoGroup) */
export type ComponentLogoGroupLogoListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentLogoGroupLogoListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentLogoGroup) */
export type ComponentLogoGroupShowTitleInlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentLogoGroup) */
export type ComponentLogoGroupSmallTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentLogoGroup) */
export type ComponentLogoGroupThemeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentLogoGroup) */
export type ComponentLogoGroupTitle1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentLogoGroup) */
export type ComponentLogoGroupTitle2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentLogoGroup) */
export type ComponentLogoGroupTitleColourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentLogoGroupCollection = {
  __typename?: 'ComponentLogoGroupCollection';
  items: Array<Maybe<ComponentLogoGroup>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentLogoGroupCursorCollection = {
  __typename?: 'ComponentLogoGroupCursorCollection';
  items: Array<Maybe<ComponentLogoGroup>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentLogoGroupFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentLogoGroupFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentLogoGroupFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logoList?: InputMaybe<CfContentType5OiHchWgV9Y8SuvDxHCaLyNestedFilter>;
  logoListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_not?: InputMaybe<Scalars['Boolean']['input']>;
  smallText_contains?: InputMaybe<Scalars['String']['input']>;
  smallText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  smallText_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  theme?: InputMaybe<Scalars['String']['input']>;
  theme_contains?: InputMaybe<Scalars['String']['input']>;
  theme_exists?: InputMaybe<Scalars['Boolean']['input']>;
  theme_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  theme_not?: InputMaybe<Scalars['String']['input']>;
  theme_not_contains?: InputMaybe<Scalars['String']['input']>;
  theme_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title1?: InputMaybe<Scalars['String']['input']>;
  title1_contains?: InputMaybe<Scalars['String']['input']>;
  title1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title1_not?: InputMaybe<Scalars['String']['input']>;
  title1_not_contains?: InputMaybe<Scalars['String']['input']>;
  title1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2?: InputMaybe<Scalars['String']['input']>;
  title2_contains?: InputMaybe<Scalars['String']['input']>;
  title2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2_not?: InputMaybe<Scalars['String']['input']>;
  title2_not_contains?: InputMaybe<Scalars['String']['input']>;
  title2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColour?: InputMaybe<Scalars['String']['input']>;
  titleColour_contains?: InputMaybe<Scalars['String']['input']>;
  titleColour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleColour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColour_not?: InputMaybe<Scalars['String']['input']>;
  titleColour_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleColour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentLogoGroupLinkingCollections = {
  __typename?: 'ComponentLogoGroupLinkingCollections';
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildGenericTemplatePageCollection?: Maybe<BuildGenericTemplatePageCollection>;
  buildGenericTemplatePageCursorCollection?: Maybe<BuildGenericTemplatePageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentLogoGroupLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentLogoGroupLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentLogoGroupLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentLogoGroupLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentLogoGroupLinkingCollectionsBuildGenericTemplatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentLogoGroupLinkingCollectionsBuildGenericTemplatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentLogoGroupLinkingCollectionsBuildGenericTemplatePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentLogoGroupLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentLogoGroupLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentLogoGroupLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentLogoGroupLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentLogoGroupLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentLogoGroupLinkingCollectionsBuildGenericTemplatePageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentLogoGroupLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComponentLogoGroupLogoListCollection = {
  __typename?: 'ComponentLogoGroupLogoListCollection';
  items: Array<Maybe<ContentType5OiHchWgV9Y8SuvDxHCaLy>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComponentLogoGroupLogoListCollectionOrder {
  AltTextAsc = 'altText_ASC',
  AltTextDesc = 'altText_DESC',
  BynderIdAsc = 'bynderId_ASC',
  BynderIdDesc = 'bynderId_DESC',
  NetlifyIdAsc = 'netlifyId_ASC',
  NetlifyIdDesc = 'netlifyId_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UsageRightsAsc = 'usageRights_ASC',
  UsageRightsDesc = 'usageRights_DESC',
  UseAltTextAsc = 'useAltText_ASC',
  UseAltTextDesc = 'useAltText_DESC'
}

export type ComponentLogoGroupLogoListCursorCollection = {
  __typename?: 'ComponentLogoGroupLogoListCursorCollection';
  items: Array<Maybe<ContentType5OiHchWgV9Y8SuvDxHCaLy>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComponentLogoGroupLogoListCursorCollectionOrder {
  AltTextAsc = 'altText_ASC',
  AltTextDesc = 'altText_DESC',
  BynderIdAsc = 'bynderId_ASC',
  BynderIdDesc = 'bynderId_DESC',
  NetlifyIdAsc = 'netlifyId_ASC',
  NetlifyIdDesc = 'netlifyId_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UsageRightsAsc = 'usageRights_ASC',
  UsageRightsDesc = 'usageRights_DESC',
  UseAltTextAsc = 'useAltText_ASC',
  UseAltTextDesc = 'useAltText_DESC'
}

export enum ComponentLogoGroupOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC'
}

export type ComponentLogoGroupSmallText = {
  __typename?: 'ComponentLogoGroupSmallText';
  json: Scalars['JSON']['output'];
  links: ComponentLogoGroupSmallTextLinks;
};

export type ComponentLogoGroupSmallTextAssets = {
  __typename?: 'ComponentLogoGroupSmallTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComponentLogoGroupSmallTextEntries = {
  __typename?: 'ComponentLogoGroupSmallTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComponentLogoGroupSmallTextLinks = {
  __typename?: 'ComponentLogoGroupSmallTextLinks';
  assets: ComponentLogoGroupSmallTextAssets;
  entries: ComponentLogoGroupSmallTextEntries;
  resources: ComponentLogoGroupSmallTextResources;
};

export type ComponentLogoGroupSmallTextResources = {
  __typename?: 'ComponentLogoGroupSmallTextResources';
  block: Array<ComponentLogoGroupSmallTextResourcesBlock>;
  hyperlink: Array<ComponentLogoGroupSmallTextResourcesHyperlink>;
  inline: Array<ComponentLogoGroupSmallTextResourcesInline>;
};

export type ComponentLogoGroupSmallTextResourcesBlock = ResourceLink & {
  __typename?: 'ComponentLogoGroupSmallTextResourcesBlock';
  sys: ResourceSys;
};

export type ComponentLogoGroupSmallTextResourcesHyperlink = ResourceLink & {
  __typename?: 'ComponentLogoGroupSmallTextResourcesHyperlink';
  sys: ResourceSys;
};

export type ComponentLogoGroupSmallTextResourcesInline = ResourceLink & {
  __typename?: 'ComponentLogoGroupSmallTextResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentNavBar) */
export type ComponentNavBar = Entry & _Node & {
  __typename?: 'ComponentNavBar';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  ctasCollection?: Maybe<ComponentNavBarCtasCollection>;
  ctasCursorCollection?: Maybe<ComponentNavBarCtasCursorCollection>;
  internalTitle?: Maybe<Scalars['String']['output']>;
  itemsCollection?: Maybe<ComponentNavBarItemsCollection>;
  itemsCursorCollection?: Maybe<ComponentNavBarItemsCursorCollection>;
  linkedFrom?: Maybe<ComponentNavBarLinkingCollections>;
  mainLogo?: Maybe<WrapperIcon>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentNavBar) */
export type ComponentNavBarCtasCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentNavBarCtasCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackNavBarCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentNavBar) */
export type ComponentNavBarCtasCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentNavBarCtasCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackNavBarCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentNavBar) */
export type ComponentNavBarInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentNavBar) */
export type ComponentNavBarItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentNavBarItemsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentNavBar) */
export type ComponentNavBarItemsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentNavBarItemsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentNavBar) */
export type ComponentNavBarLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentNavBar) */
export type ComponentNavBarMainLogoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperIconFilter>;
};

export type ComponentNavBarCollection = {
  __typename?: 'ComponentNavBarCollection';
  items: Array<Maybe<ComponentNavBar>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentNavBarCtasCollection = {
  __typename?: 'ComponentNavBarCtasCollection';
  items: Array<Maybe<PackNavBarCta>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComponentNavBarCtasCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComponentNavBarCtasCursorCollection = {
  __typename?: 'ComponentNavBarCtasCursorCollection';
  items: Array<Maybe<PackNavBarCta>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComponentNavBarCtasCursorCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComponentNavBarCursorCollection = {
  __typename?: 'ComponentNavBarCursorCollection';
  items: Array<Maybe<ComponentNavBar>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentNavBarFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentNavBarFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentNavBarFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctas?: InputMaybe<CfPackNavBarCtaNestedFilter>;
  ctasCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  items?: InputMaybe<CfitemsMultiTypeNestedFilter>;
  itemsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mainLogo?: InputMaybe<CfWrapperIconNestedFilter>;
  mainLogo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type ComponentNavBarItemsCollection = {
  __typename?: 'ComponentNavBarItemsCollection';
  items: Array<Maybe<ComponentNavBarItemsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentNavBarItemsCursorCollection = {
  __typename?: 'ComponentNavBarItemsCursorCollection';
  items: Array<Maybe<ComponentNavBarItemsItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentNavBarItemsFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentNavBarItemsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentNavBarItemsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  destination_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenText?: InputMaybe<Scalars['String']['input']>;
  hiddenText_contains?: InputMaybe<Scalars['String']['input']>;
  hiddenText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenText_not?: InputMaybe<Scalars['String']['input']>;
  hiddenText_not_contains?: InputMaybe<Scalars['String']['input']>;
  hiddenText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  level?: InputMaybe<Scalars['String']['input']>;
  level_contains?: InputMaybe<Scalars['String']['input']>;
  level_exists?: InputMaybe<Scalars['Boolean']['input']>;
  level_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  level_not?: InputMaybe<Scalars['String']['input']>;
  level_not_contains?: InputMaybe<Scalars['String']['input']>;
  level_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type ComponentNavBarItemsItem = PackNavBarItem | PackNavBarItemV2;

export type ComponentNavBarLinkingCollections = {
  __typename?: 'ComponentNavBarLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentNavBarLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentNavBarLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentNavBarOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPageHero) */
export type ComponentPageHero = Entry & _Node & {
  __typename?: 'ComponentPageHero';
  _id: Scalars['ID']['output'];
  contentCollection?: Maybe<ComponentPageHeroContentCollection>;
  contentCursorCollection?: Maybe<ComponentPageHeroContentCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<ComponentPageHeroLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPageHero) */
export type ComponentPageHeroContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentPageHeroContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPageHero) */
export type ComponentPageHeroContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentPageHeroContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPageHero) */
export type ComponentPageHeroLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPageHero) */
export type ComponentPageHeroTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentPageHeroCollection = {
  __typename?: 'ComponentPageHeroCollection';
  items: Array<Maybe<ComponentPageHero>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentPageHeroContentCollection = {
  __typename?: 'ComponentPageHeroContentCollection';
  items: Array<Maybe<ComponentPageHeroContentItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentPageHeroContentCursorCollection = {
  __typename?: 'ComponentPageHeroContentCursorCollection';
  items: Array<Maybe<ComponentPageHeroContentItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentPageHeroContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentPageHeroContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentPageHeroContentFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type ComponentPageHeroContentItem = ComponentCard | ComponentContentBlockV2;

export type ComponentPageHeroCursorCollection = {
  __typename?: 'ComponentPageHeroCursorCollection';
  items: Array<Maybe<ComponentPageHero>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentPageHeroFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentPageHeroFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentPageHeroFilter>>>;
  content?: InputMaybe<CfcontentMultiTypeNestedFilter>;
  contentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentPageHeroLinkingCollections = {
  __typename?: 'ComponentPageHeroLinkingCollections';
  buildLandingpageCollection?: Maybe<BuildLandingpageCollection>;
  buildLandingpageCursorCollection?: Maybe<BuildLandingpageCursorCollection>;
  buildTariffPageCollection?: Maybe<BuildTariffPageCollection>;
  buildTariffPageCursorCollection?: Maybe<BuildTariffPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentPageHeroLinkingCollectionsBuildLandingpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPageHeroLinkingCollectionsBuildLandingpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPageHeroLinkingCollectionsBuildLandingpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPageHeroLinkingCollectionsBuildLandingpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPageHeroLinkingCollectionsBuildTariffPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPageHeroLinkingCollectionsBuildTariffPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPageHeroLinkingCollectionsBuildTariffPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPageHeroLinkingCollectionsBuildTariffPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPageHeroLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPageHeroLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentPageHeroLinkingCollectionsBuildLandingpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPageHeroLinkingCollectionsBuildLandingpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPageHeroLinkingCollectionsBuildTariffPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPageHeroLinkingCollectionsBuildTariffPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPageHeroOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPostcodeFinder) */
export type ComponentPostcodeFinder = Entry & _Node & {
  __typename?: 'ComponentPostcodeFinder';
  _id: Scalars['ID']['output'];
  bodyText?: Maybe<ComponentPostcodeFinderBodyText>;
  contentfulMetadata: ContentfulMetadata;
  cta1?: Maybe<PackCta>;
  inputFieldText?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ComponentPostcodeFinderLinkingCollections>;
  showTitleInline?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  terms?: Maybe<PackStructuredText>;
  title?: Maybe<Scalars['String']['output']>;
  titleColour?: Maybe<Scalars['String']['output']>;
  titlePart1?: Maybe<Scalars['String']['output']>;
  titlePart2?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPostcodeFinder) */
export type ComponentPostcodeFinderBodyTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPostcodeFinder) */
export type ComponentPostcodeFinderCta1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPostcodeFinder) */
export type ComponentPostcodeFinderInputFieldTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPostcodeFinder) */
export type ComponentPostcodeFinderLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPostcodeFinder) */
export type ComponentPostcodeFinderShowTitleInlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPostcodeFinder) */
export type ComponentPostcodeFinderTermsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackStructuredTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPostcodeFinder) */
export type ComponentPostcodeFinderTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPostcodeFinder) */
export type ComponentPostcodeFinderTitleColourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPostcodeFinder) */
export type ComponentPostcodeFinderTitlePart1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPostcodeFinder) */
export type ComponentPostcodeFinderTitlePart2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPostcodeFinder) */
export type ComponentPostcodeFinderTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentPostcodeFinderBodyText = {
  __typename?: 'ComponentPostcodeFinderBodyText';
  json: Scalars['JSON']['output'];
  links: ComponentPostcodeFinderBodyTextLinks;
};

export type ComponentPostcodeFinderBodyTextAssets = {
  __typename?: 'ComponentPostcodeFinderBodyTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComponentPostcodeFinderBodyTextEntries = {
  __typename?: 'ComponentPostcodeFinderBodyTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComponentPostcodeFinderBodyTextLinks = {
  __typename?: 'ComponentPostcodeFinderBodyTextLinks';
  assets: ComponentPostcodeFinderBodyTextAssets;
  entries: ComponentPostcodeFinderBodyTextEntries;
  resources: ComponentPostcodeFinderBodyTextResources;
};

export type ComponentPostcodeFinderBodyTextResources = {
  __typename?: 'ComponentPostcodeFinderBodyTextResources';
  block: Array<ComponentPostcodeFinderBodyTextResourcesBlock>;
  hyperlink: Array<ComponentPostcodeFinderBodyTextResourcesHyperlink>;
  inline: Array<ComponentPostcodeFinderBodyTextResourcesInline>;
};

export type ComponentPostcodeFinderBodyTextResourcesBlock = ResourceLink & {
  __typename?: 'ComponentPostcodeFinderBodyTextResourcesBlock';
  sys: ResourceSys;
};

export type ComponentPostcodeFinderBodyTextResourcesHyperlink = ResourceLink & {
  __typename?: 'ComponentPostcodeFinderBodyTextResourcesHyperlink';
  sys: ResourceSys;
};

export type ComponentPostcodeFinderBodyTextResourcesInline = ResourceLink & {
  __typename?: 'ComponentPostcodeFinderBodyTextResourcesInline';
  sys: ResourceSys;
};

export type ComponentPostcodeFinderCollection = {
  __typename?: 'ComponentPostcodeFinderCollection';
  items: Array<Maybe<ComponentPostcodeFinder>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentPostcodeFinderCursorCollection = {
  __typename?: 'ComponentPostcodeFinderCursorCollection';
  items: Array<Maybe<ComponentPostcodeFinder>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentPostcodeFinderFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentPostcodeFinderFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentPostcodeFinderFilter>>>;
  bodyText_contains?: InputMaybe<Scalars['String']['input']>;
  bodyText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bodyText_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta1?: InputMaybe<CfPackCtaNestedFilter>;
  cta1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  inputFieldText?: InputMaybe<Scalars['String']['input']>;
  inputFieldText_contains?: InputMaybe<Scalars['String']['input']>;
  inputFieldText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  inputFieldText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inputFieldText_not?: InputMaybe<Scalars['String']['input']>;
  inputFieldText_not_contains?: InputMaybe<Scalars['String']['input']>;
  inputFieldText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showTitleInline?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  terms?: InputMaybe<CfPackStructuredTextNestedFilter>;
  terms_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleColour?: InputMaybe<Scalars['String']['input']>;
  titleColour_contains?: InputMaybe<Scalars['String']['input']>;
  titleColour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleColour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColour_not?: InputMaybe<Scalars['String']['input']>;
  titleColour_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleColour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titlePart1?: InputMaybe<Scalars['String']['input']>;
  titlePart1_contains?: InputMaybe<Scalars['String']['input']>;
  titlePart1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titlePart1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titlePart1_not?: InputMaybe<Scalars['String']['input']>;
  titlePart1_not_contains?: InputMaybe<Scalars['String']['input']>;
  titlePart1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titlePart2?: InputMaybe<Scalars['String']['input']>;
  titlePart2_contains?: InputMaybe<Scalars['String']['input']>;
  titlePart2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titlePart2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titlePart2_not?: InputMaybe<Scalars['String']['input']>;
  titlePart2_not_contains?: InputMaybe<Scalars['String']['input']>;
  titlePart2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentPostcodeFinderLinkingCollections = {
  __typename?: 'ComponentPostcodeFinderLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildGenericTemplatePageCollection?: Maybe<BuildGenericTemplatePageCollection>;
  buildGenericTemplatePageCursorCollection?: Maybe<BuildGenericTemplatePageCursorCollection>;
  buildLandingpageCollection?: Maybe<BuildLandingpageCollection>;
  buildLandingpageCursorCollection?: Maybe<BuildLandingpageCursorCollection>;
  buildProductDetailPageCollection?: Maybe<BuildProductDetailPageCollection>;
  buildProductDetailPageCursorCollection?: Maybe<BuildProductDetailPageCursorCollection>;
  buildTariffPageCollection?: Maybe<BuildTariffPageCollection>;
  buildTariffPageCursorCollection?: Maybe<BuildTariffPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  packCtaCollection?: Maybe<PackCtaCollection>;
  packCtaCursorCollection?: Maybe<PackCtaCursorCollection>;
};


export type ComponentPostcodeFinderLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPostcodeFinderLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPostcodeFinderLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPostcodeFinderLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPostcodeFinderLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPostcodeFinderLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPostcodeFinderLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPostcodeFinderLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPostcodeFinderLinkingCollectionsBuildGenericTemplatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPostcodeFinderLinkingCollectionsBuildGenericTemplatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPostcodeFinderLinkingCollectionsBuildGenericTemplatePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPostcodeFinderLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPostcodeFinderLinkingCollectionsBuildLandingpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPostcodeFinderLinkingCollectionsBuildLandingpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPostcodeFinderLinkingCollectionsBuildLandingpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPostcodeFinderLinkingCollectionsBuildLandingpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPostcodeFinderLinkingCollectionsBuildProductDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPostcodeFinderLinkingCollectionsBuildProductDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPostcodeFinderLinkingCollectionsBuildProductDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPostcodeFinderLinkingCollectionsBuildProductDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPostcodeFinderLinkingCollectionsBuildTariffPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPostcodeFinderLinkingCollectionsBuildTariffPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPostcodeFinderLinkingCollectionsBuildTariffPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPostcodeFinderLinkingCollectionsBuildTariffPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPostcodeFinderLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPostcodeFinderLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPostcodeFinderLinkingCollectionsPackCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPostcodeFinderLinkingCollectionsPackCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPostcodeFinderLinkingCollectionsPackCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPostcodeFinderLinkingCollectionsPackCtaCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentPostcodeFinderLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPostcodeFinderLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPostcodeFinderLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPostcodeFinderLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPostcodeFinderLinkingCollectionsBuildGenericTemplatePageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPostcodeFinderLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPostcodeFinderLinkingCollectionsBuildLandingpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPostcodeFinderLinkingCollectionsBuildLandingpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPostcodeFinderLinkingCollectionsBuildProductDetailPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPostcodeFinderLinkingCollectionsBuildProductDetailPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPostcodeFinderLinkingCollectionsBuildTariffPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPostcodeFinderLinkingCollectionsBuildTariffPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPostcodeFinderLinkingCollectionsPackCtaCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export enum ComponentPostcodeFinderLinkingCollectionsPackCtaCursorCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export enum ComponentPostcodeFinderOrder {
  InputFieldTextAsc = 'inputFieldText_ASC',
  InputFieldTextDesc = 'inputFieldText_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC',
  TitlePart1Asc = 'titlePart1_ASC',
  TitlePart1Desc = 'titlePart1_DESC',
  TitlePart2Asc = 'titlePart2_ASC',
  TitlePart2Desc = 'titlePart2_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductFeaturedCard) */
export type ComponentProductFeaturedCard = Entry & _Node & {
  __typename?: 'ComponentProductFeaturedCard';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  cta1?: Maybe<PackCta>;
  cta2?: Maybe<PackCta>;
  descriptionText?: Maybe<ComponentProductFeaturedCardDescriptionText>;
  image?: Maybe<ContentType5OiHchWgV9Y8SuvDxHCaLy>;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ComponentProductFeaturedCardLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductFeaturedCard) */
export type ComponentProductFeaturedCardCta1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductFeaturedCard) */
export type ComponentProductFeaturedCardCta2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductFeaturedCard) */
export type ComponentProductFeaturedCardDescriptionTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductFeaturedCard) */
export type ComponentProductFeaturedCardImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductFeaturedCard) */
export type ComponentProductFeaturedCardInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductFeaturedCard) */
export type ComponentProductFeaturedCardLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductFeaturedCard) */
export type ComponentProductFeaturedCardTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentProductFeaturedCardCollection = {
  __typename?: 'ComponentProductFeaturedCardCollection';
  items: Array<Maybe<ComponentProductFeaturedCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentProductFeaturedCardCursorCollection = {
  __typename?: 'ComponentProductFeaturedCardCursorCollection';
  items: Array<Maybe<ComponentProductFeaturedCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentProductFeaturedCardDescriptionText = {
  __typename?: 'ComponentProductFeaturedCardDescriptionText';
  json: Scalars['JSON']['output'];
  links: ComponentProductFeaturedCardDescriptionTextLinks;
};

export type ComponentProductFeaturedCardDescriptionTextAssets = {
  __typename?: 'ComponentProductFeaturedCardDescriptionTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComponentProductFeaturedCardDescriptionTextEntries = {
  __typename?: 'ComponentProductFeaturedCardDescriptionTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComponentProductFeaturedCardDescriptionTextLinks = {
  __typename?: 'ComponentProductFeaturedCardDescriptionTextLinks';
  assets: ComponentProductFeaturedCardDescriptionTextAssets;
  entries: ComponentProductFeaturedCardDescriptionTextEntries;
  resources: ComponentProductFeaturedCardDescriptionTextResources;
};

export type ComponentProductFeaturedCardDescriptionTextResources = {
  __typename?: 'ComponentProductFeaturedCardDescriptionTextResources';
  block: Array<ComponentProductFeaturedCardDescriptionTextResourcesBlock>;
  hyperlink: Array<ComponentProductFeaturedCardDescriptionTextResourcesHyperlink>;
  inline: Array<ComponentProductFeaturedCardDescriptionTextResourcesInline>;
};

export type ComponentProductFeaturedCardDescriptionTextResourcesBlock = ResourceLink & {
  __typename?: 'ComponentProductFeaturedCardDescriptionTextResourcesBlock';
  sys: ResourceSys;
};

export type ComponentProductFeaturedCardDescriptionTextResourcesHyperlink = ResourceLink & {
  __typename?: 'ComponentProductFeaturedCardDescriptionTextResourcesHyperlink';
  sys: ResourceSys;
};

export type ComponentProductFeaturedCardDescriptionTextResourcesInline = ResourceLink & {
  __typename?: 'ComponentProductFeaturedCardDescriptionTextResourcesInline';
  sys: ResourceSys;
};

export type ComponentProductFeaturedCardFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentProductFeaturedCardFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentProductFeaturedCardFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta1?: InputMaybe<CfPackCtaNestedFilter>;
  cta1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2?: InputMaybe<CfPackCtaNestedFilter>;
  cta2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionText_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionText_not_contains?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<CfContentType5OiHchWgV9Y8SuvDxHCaLyNestedFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentProductFeaturedCardLinkingCollections = {
  __typename?: 'ComponentProductFeaturedCardLinkingCollections';
  componentProductGroupCollection?: Maybe<ComponentProductGroupCollection>;
  componentProductGroupCursorCollection?: Maybe<ComponentProductGroupCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentProductFeaturedCardLinkingCollectionsComponentProductGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentProductFeaturedCardLinkingCollectionsComponentProductGroupCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentProductFeaturedCardLinkingCollectionsComponentProductGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentProductFeaturedCardLinkingCollectionsComponentProductGroupCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentProductFeaturedCardLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentProductFeaturedCardLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentProductFeaturedCardLinkingCollectionsComponentProductGroupCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TermsAsc = 'terms_ASC',
  TermsDesc = 'terms_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export enum ComponentProductFeaturedCardLinkingCollectionsComponentProductGroupCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TermsAsc = 'terms_ASC',
  TermsDesc = 'terms_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export enum ComponentProductFeaturedCardOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductGroup) */
export type ComponentProductGroup = Entry & _Node & {
  __typename?: 'ComponentProductGroup';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  animations?: Maybe<WrapperAnimation>;
  cardsCollection?: Maybe<ComponentProductGroupCardsCollection>;
  cardsCursorCollection?: Maybe<ComponentProductGroupCardsCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ComponentProductGroupLinkingCollections>;
  showTitleInline?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  terms?: Maybe<Scalars['String']['output']>;
  title1?: Maybe<Scalars['String']['output']>;
  title2?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductGroup) */
export type ComponentProductGroupAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductGroup) */
export type ComponentProductGroupAnimationsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperAnimationFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductGroup) */
export type ComponentProductGroupCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentProductGroupCardsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentProductFeaturedCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductGroup) */
export type ComponentProductGroupCardsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentProductGroupCardsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentProductFeaturedCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductGroup) */
export type ComponentProductGroupInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductGroup) */
export type ComponentProductGroupLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductGroup) */
export type ComponentProductGroupShowTitleInlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductGroup) */
export type ComponentProductGroupTermsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductGroup) */
export type ComponentProductGroupTitle1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductGroup) */
export type ComponentProductGroupTitle2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentProductGroupCardsCollection = {
  __typename?: 'ComponentProductGroupCardsCollection';
  items: Array<Maybe<ComponentProductFeaturedCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComponentProductGroupCardsCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ComponentProductGroupCardsCursorCollection = {
  __typename?: 'ComponentProductGroupCardsCursorCollection';
  items: Array<Maybe<ComponentProductFeaturedCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComponentProductGroupCardsCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ComponentProductGroupCollection = {
  __typename?: 'ComponentProductGroupCollection';
  items: Array<Maybe<ComponentProductGroup>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentProductGroupCursorCollection = {
  __typename?: 'ComponentProductGroupCursorCollection';
  items: Array<Maybe<ComponentProductGroup>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentProductGroupFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentProductGroupFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentProductGroupFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  animations?: InputMaybe<CfWrapperAnimationNestedFilter>;
  animations_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cards?: InputMaybe<CfComponentProductFeaturedCardNestedFilter>;
  cardsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showTitleInline?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  terms?: InputMaybe<Scalars['String']['input']>;
  terms_contains?: InputMaybe<Scalars['String']['input']>;
  terms_exists?: InputMaybe<Scalars['Boolean']['input']>;
  terms_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  terms_not?: InputMaybe<Scalars['String']['input']>;
  terms_not_contains?: InputMaybe<Scalars['String']['input']>;
  terms_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title1?: InputMaybe<Scalars['String']['input']>;
  title1_contains?: InputMaybe<Scalars['String']['input']>;
  title1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title1_not?: InputMaybe<Scalars['String']['input']>;
  title1_not_contains?: InputMaybe<Scalars['String']['input']>;
  title1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2?: InputMaybe<Scalars['String']['input']>;
  title2_contains?: InputMaybe<Scalars['String']['input']>;
  title2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2_not?: InputMaybe<Scalars['String']['input']>;
  title2_not_contains?: InputMaybe<Scalars['String']['input']>;
  title2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentProductGroupLinkingCollections = {
  __typename?: 'ComponentProductGroupLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildGenericTemplatePageCollection?: Maybe<BuildGenericTemplatePageCollection>;
  buildGenericTemplatePageCursorCollection?: Maybe<BuildGenericTemplatePageCursorCollection>;
  buildLandingpageCollection?: Maybe<BuildLandingpageCollection>;
  buildLandingpageCursorCollection?: Maybe<BuildLandingpageCursorCollection>;
  buildTariffPageCollection?: Maybe<BuildTariffPageCollection>;
  buildTariffPageCursorCollection?: Maybe<BuildTariffPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentProductGroupLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentProductGroupLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentProductGroupLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentProductGroupLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentProductGroupLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentProductGroupLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentProductGroupLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentProductGroupLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentProductGroupLinkingCollectionsBuildGenericTemplatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentProductGroupLinkingCollectionsBuildGenericTemplatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentProductGroupLinkingCollectionsBuildGenericTemplatePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentProductGroupLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentProductGroupLinkingCollectionsBuildLandingpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentProductGroupLinkingCollectionsBuildLandingpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentProductGroupLinkingCollectionsBuildLandingpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentProductGroupLinkingCollectionsBuildLandingpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentProductGroupLinkingCollectionsBuildTariffPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentProductGroupLinkingCollectionsBuildTariffPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentProductGroupLinkingCollectionsBuildTariffPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentProductGroupLinkingCollectionsBuildTariffPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentProductGroupLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentProductGroupLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentProductGroupLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentProductGroupLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentProductGroupLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentProductGroupLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentProductGroupLinkingCollectionsBuildGenericTemplatePageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentProductGroupLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentProductGroupLinkingCollectionsBuildLandingpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentProductGroupLinkingCollectionsBuildLandingpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentProductGroupLinkingCollectionsBuildTariffPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentProductGroupLinkingCollectionsBuildTariffPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentProductGroupOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TermsAsc = 'terms_ASC',
  TermsDesc = 'terms_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductModule) */
export type ComponentProductModule = Entry & _Node & {
  __typename?: 'ComponentProductModule';
  _id: Scalars['ID']['output'];
  bulletListCollection?: Maybe<ComponentProductModuleBulletListCollection>;
  bulletListCursorCollection?: Maybe<ComponentProductModuleBulletListCursorCollection>;
  bullets?: Maybe<ComponentProductModuleBullets>;
  contentfulMetadata: ContentfulMetadata;
  ctaListCollection?: Maybe<ComponentProductModuleCtaListCollection>;
  ctaListCursorCollection?: Maybe<ComponentProductModuleCtaListCursorCollection>;
  image?: Maybe<ContentType5OiHchWgV9Y8SuvDxHCaLy>;
  linkedFrom?: Maybe<ComponentProductModuleLinkingCollections>;
  subtitle?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductModule) */
export type ComponentProductModuleBulletListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentProductModuleBulletListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackStructuredTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductModule) */
export type ComponentProductModuleBulletListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentProductModuleBulletListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackStructuredTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductModule) */
export type ComponentProductModuleBulletsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductModule) */
export type ComponentProductModuleCtaListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentProductModuleCtaListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductModule) */
export type ComponentProductModuleCtaListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentProductModuleCtaListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductModule) */
export type ComponentProductModuleImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductModule) */
export type ComponentProductModuleLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductModule) */
export type ComponentProductModuleSubtitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductModule) */
export type ComponentProductModuleTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductModule) */
export type ComponentProductModuleTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentProductModuleBulletListCollection = {
  __typename?: 'ComponentProductModuleBulletListCollection';
  items: Array<Maybe<PackStructuredText>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComponentProductModuleBulletListCollectionOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComponentProductModuleBulletListCursorCollection = {
  __typename?: 'ComponentProductModuleBulletListCursorCollection';
  items: Array<Maybe<PackStructuredText>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComponentProductModuleBulletListCursorCollectionOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComponentProductModuleBullets = {
  __typename?: 'ComponentProductModuleBullets';
  json: Scalars['JSON']['output'];
  links: ComponentProductModuleBulletsLinks;
};

export type ComponentProductModuleBulletsAssets = {
  __typename?: 'ComponentProductModuleBulletsAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComponentProductModuleBulletsEntries = {
  __typename?: 'ComponentProductModuleBulletsEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComponentProductModuleBulletsLinks = {
  __typename?: 'ComponentProductModuleBulletsLinks';
  assets: ComponentProductModuleBulletsAssets;
  entries: ComponentProductModuleBulletsEntries;
  resources: ComponentProductModuleBulletsResources;
};

export type ComponentProductModuleBulletsResources = {
  __typename?: 'ComponentProductModuleBulletsResources';
  block: Array<ComponentProductModuleBulletsResourcesBlock>;
  hyperlink: Array<ComponentProductModuleBulletsResourcesHyperlink>;
  inline: Array<ComponentProductModuleBulletsResourcesInline>;
};

export type ComponentProductModuleBulletsResourcesBlock = ResourceLink & {
  __typename?: 'ComponentProductModuleBulletsResourcesBlock';
  sys: ResourceSys;
};

export type ComponentProductModuleBulletsResourcesHyperlink = ResourceLink & {
  __typename?: 'ComponentProductModuleBulletsResourcesHyperlink';
  sys: ResourceSys;
};

export type ComponentProductModuleBulletsResourcesInline = ResourceLink & {
  __typename?: 'ComponentProductModuleBulletsResourcesInline';
  sys: ResourceSys;
};

export type ComponentProductModuleCollection = {
  __typename?: 'ComponentProductModuleCollection';
  items: Array<Maybe<ComponentProductModule>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentProductModuleCtaListCollection = {
  __typename?: 'ComponentProductModuleCtaListCollection';
  items: Array<Maybe<PackCta>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComponentProductModuleCtaListCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export type ComponentProductModuleCtaListCursorCollection = {
  __typename?: 'ComponentProductModuleCtaListCursorCollection';
  items: Array<Maybe<PackCta>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComponentProductModuleCtaListCursorCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export type ComponentProductModuleCursorCollection = {
  __typename?: 'ComponentProductModuleCursorCollection';
  items: Array<Maybe<ComponentProductModule>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentProductModuleFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentProductModuleFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentProductModuleFilter>>>;
  bulletList?: InputMaybe<CfPackStructuredTextNestedFilter>;
  bulletListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bullets_contains?: InputMaybe<Scalars['String']['input']>;
  bullets_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bullets_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctaList?: InputMaybe<CfPackCtaNestedFilter>;
  ctaListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<CfContentType5OiHchWgV9Y8SuvDxHCaLyNestedFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  subtitle_contains?: InputMaybe<Scalars['String']['input']>;
  subtitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subtitle_not?: InputMaybe<Scalars['String']['input']>;
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text_not?: InputMaybe<Scalars['String']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentProductModuleLinkingCollections = {
  __typename?: 'ComponentProductModuleLinkingCollections';
  componentProductRailCollection?: Maybe<ComponentProductRailCollection>;
  componentProductRailCursorCollection?: Maybe<ComponentProductRailCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentProductModuleLinkingCollectionsComponentProductRailCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentProductModuleLinkingCollectionsComponentProductRailCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentProductModuleLinkingCollectionsComponentProductRailCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentProductModuleLinkingCollectionsComponentProductRailCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentProductModuleLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentProductModuleLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentProductModuleLinkingCollectionsComponentProductRailCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  ComparisonModeAsc = 'comparisonMode_ASC',
  ComparisonModeDesc = 'comparisonMode_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  ShowTrustpilotAsc = 'showTrustpilot_ASC',
  ShowTrustpilotDesc = 'showTrustpilot_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC'
}

export enum ComponentProductModuleLinkingCollectionsComponentProductRailCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  ComparisonModeAsc = 'comparisonMode_ASC',
  ComparisonModeDesc = 'comparisonMode_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  ShowTrustpilotAsc = 'showTrustpilot_ASC',
  ShowTrustpilotDesc = 'showTrustpilot_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC'
}

export enum ComponentProductModuleOrder {
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductRail) */
export type ComponentProductRail = Entry & _Node & {
  __typename?: 'ComponentProductRail';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  comparisonMode?: Maybe<Scalars['Boolean']['output']>;
  contentfulMetadata: ContentfulMetadata;
  disclaimerText?: Maybe<Scalars['String']['output']>;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ComponentProductRailLinkingCollections>;
  railItemsCollection?: Maybe<ComponentProductRailRailItemsCollection>;
  railItemsCursorCollection?: Maybe<ComponentProductRailRailItemsCursorCollection>;
  showTitleInline?: Maybe<Scalars['Boolean']['output']>;
  showTrustpilot?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  title1?: Maybe<Scalars['String']['output']>;
  title2?: Maybe<Scalars['String']['output']>;
  titleColour?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductRail) */
export type ComponentProductRailAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductRail) */
export type ComponentProductRailComparisonModeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductRail) */
export type ComponentProductRailDisclaimerTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductRail) */
export type ComponentProductRailInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductRail) */
export type ComponentProductRailLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductRail) */
export type ComponentProductRailRailItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentProductRailRailItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentProductModuleFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductRail) */
export type ComponentProductRailRailItemsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentProductRailRailItemsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentProductModuleFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductRail) */
export type ComponentProductRailShowTitleInlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductRail) */
export type ComponentProductRailShowTrustpilotArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductRail) */
export type ComponentProductRailTitle1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductRail) */
export type ComponentProductRailTitle2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentProductRail) */
export type ComponentProductRailTitleColourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentProductRailCollection = {
  __typename?: 'ComponentProductRailCollection';
  items: Array<Maybe<ComponentProductRail>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentProductRailCursorCollection = {
  __typename?: 'ComponentProductRailCursorCollection';
  items: Array<Maybe<ComponentProductRail>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentProductRailFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentProductRailFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentProductRailFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  comparisonMode?: InputMaybe<Scalars['Boolean']['input']>;
  comparisonMode_exists?: InputMaybe<Scalars['Boolean']['input']>;
  comparisonMode_not?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  disclaimerText?: InputMaybe<Scalars['String']['input']>;
  disclaimerText_contains?: InputMaybe<Scalars['String']['input']>;
  disclaimerText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disclaimerText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disclaimerText_not?: InputMaybe<Scalars['String']['input']>;
  disclaimerText_not_contains?: InputMaybe<Scalars['String']['input']>;
  disclaimerText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  railItems?: InputMaybe<CfComponentProductModuleNestedFilter>;
  railItemsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_not?: InputMaybe<Scalars['Boolean']['input']>;
  showTrustpilot?: InputMaybe<Scalars['Boolean']['input']>;
  showTrustpilot_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showTrustpilot_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title1?: InputMaybe<Scalars['String']['input']>;
  title1_contains?: InputMaybe<Scalars['String']['input']>;
  title1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title1_not?: InputMaybe<Scalars['String']['input']>;
  title1_not_contains?: InputMaybe<Scalars['String']['input']>;
  title1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2?: InputMaybe<Scalars['String']['input']>;
  title2_contains?: InputMaybe<Scalars['String']['input']>;
  title2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2_not?: InputMaybe<Scalars['String']['input']>;
  title2_not_contains?: InputMaybe<Scalars['String']['input']>;
  title2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColour?: InputMaybe<Scalars['String']['input']>;
  titleColour_contains?: InputMaybe<Scalars['String']['input']>;
  titleColour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleColour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColour_not?: InputMaybe<Scalars['String']['input']>;
  titleColour_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleColour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentProductRailLinkingCollections = {
  __typename?: 'ComponentProductRailLinkingCollections';
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildGenericTemplatePageCollection?: Maybe<BuildGenericTemplatePageCollection>;
  buildGenericTemplatePageCursorCollection?: Maybe<BuildGenericTemplatePageCursorCollection>;
  buildProductDetailPageCollection?: Maybe<BuildProductDetailPageCollection>;
  buildProductDetailPageCursorCollection?: Maybe<BuildProductDetailPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentProductRailLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentProductRailLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentProductRailLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentProductRailLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentProductRailLinkingCollectionsBuildGenericTemplatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentProductRailLinkingCollectionsBuildGenericTemplatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentProductRailLinkingCollectionsBuildGenericTemplatePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentProductRailLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentProductRailLinkingCollectionsBuildProductDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentProductRailLinkingCollectionsBuildProductDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentProductRailLinkingCollectionsBuildProductDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentProductRailLinkingCollectionsBuildProductDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentProductRailLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentProductRailLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentProductRailLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentProductRailLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentProductRailLinkingCollectionsBuildGenericTemplatePageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentProductRailLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentProductRailLinkingCollectionsBuildProductDetailPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentProductRailLinkingCollectionsBuildProductDetailPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentProductRailOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  ComparisonModeAsc = 'comparisonMode_ASC',
  ComparisonModeDesc = 'comparisonMode_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  ShowTrustpilotAsc = 'showTrustpilot_ASC',
  ShowTrustpilotDesc = 'showTrustpilot_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC'
}

export type ComponentProductRailRailItemsCollection = {
  __typename?: 'ComponentProductRailRailItemsCollection';
  items: Array<Maybe<ComponentProductModule>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComponentProductRailRailItemsCollectionOrder {
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ComponentProductRailRailItemsCursorCollection = {
  __typename?: 'ComponentProductRailRailItemsCursorCollection';
  items: Array<Maybe<ComponentProductModule>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComponentProductRailRailItemsCursorCollectionOrder {
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoCardRail) */
export type ComponentPromoCardRail = Entry & _Node & {
  __typename?: 'ComponentPromoCardRail';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  cardsCollection?: Maybe<ComponentPromoCardRailCardsCollection>;
  cardsCursorCollection?: Maybe<ComponentPromoCardRailCardsCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ComponentPromoCardRailLinkingCollections>;
  showTitleInline?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  title1?: Maybe<Scalars['String']['output']>;
  title2?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoCardRail) */
export type ComponentPromoCardRailAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoCardRail) */
export type ComponentPromoCardRailCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoCardRailCardsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PromoCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoCardRail) */
export type ComponentPromoCardRailCardsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoCardRailCardsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PromoCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoCardRail) */
export type ComponentPromoCardRailInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoCardRail) */
export type ComponentPromoCardRailLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoCardRail) */
export type ComponentPromoCardRailShowTitleInlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoCardRail) */
export type ComponentPromoCardRailTitle1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoCardRail) */
export type ComponentPromoCardRailTitle2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentPromoCardRailCardsCollection = {
  __typename?: 'ComponentPromoCardRailCardsCollection';
  items: Array<Maybe<PromoCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComponentPromoCardRailCardsCollectionOrder {
  CtaVariantAsc = 'ctaVariant_ASC',
  CtaVariantDesc = 'ctaVariant_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC',
  TitlePositionAsc = 'titlePosition_ASC',
  TitlePositionDesc = 'titlePosition_DESC',
  TitleVariantAsc = 'titleVariant_ASC',
  TitleVariantDesc = 'titleVariant_DESC'
}

export type ComponentPromoCardRailCardsCursorCollection = {
  __typename?: 'ComponentPromoCardRailCardsCursorCollection';
  items: Array<Maybe<PromoCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComponentPromoCardRailCardsCursorCollectionOrder {
  CtaVariantAsc = 'ctaVariant_ASC',
  CtaVariantDesc = 'ctaVariant_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC',
  TitlePositionAsc = 'titlePosition_ASC',
  TitlePositionDesc = 'titlePosition_DESC',
  TitleVariantAsc = 'titleVariant_ASC',
  TitleVariantDesc = 'titleVariant_DESC'
}

export type ComponentPromoCardRailCollection = {
  __typename?: 'ComponentPromoCardRailCollection';
  items: Array<Maybe<ComponentPromoCardRail>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentPromoCardRailCursorCollection = {
  __typename?: 'ComponentPromoCardRailCursorCollection';
  items: Array<Maybe<ComponentPromoCardRail>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentPromoCardRailFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentPromoCardRailFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentPromoCardRailFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cards?: InputMaybe<CfPromoCardNestedFilter>;
  cardsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showTitleInline?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title1?: InputMaybe<Scalars['String']['input']>;
  title1_contains?: InputMaybe<Scalars['String']['input']>;
  title1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title1_not?: InputMaybe<Scalars['String']['input']>;
  title1_not_contains?: InputMaybe<Scalars['String']['input']>;
  title1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2?: InputMaybe<Scalars['String']['input']>;
  title2_contains?: InputMaybe<Scalars['String']['input']>;
  title2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2_not?: InputMaybe<Scalars['String']['input']>;
  title2_not_contains?: InputMaybe<Scalars['String']['input']>;
  title2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentPromoCardRailLinkingCollections = {
  __typename?: 'ComponentPromoCardRailLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildGenericTemplatePageCollection?: Maybe<BuildGenericTemplatePageCollection>;
  buildGenericTemplatePageCursorCollection?: Maybe<BuildGenericTemplatePageCursorCollection>;
  buildLandingpageCollection?: Maybe<BuildLandingpageCollection>;
  buildLandingpageCursorCollection?: Maybe<BuildLandingpageCursorCollection>;
  buildTariffPageCollection?: Maybe<BuildTariffPageCollection>;
  buildTariffPageCursorCollection?: Maybe<BuildTariffPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentPromoCardRailLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoCardRailLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPromoCardRailLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoCardRailLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPromoCardRailLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoCardRailLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPromoCardRailLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoCardRailLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPromoCardRailLinkingCollectionsBuildGenericTemplatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoCardRailLinkingCollectionsBuildGenericTemplatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPromoCardRailLinkingCollectionsBuildGenericTemplatePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoCardRailLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPromoCardRailLinkingCollectionsBuildLandingpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoCardRailLinkingCollectionsBuildLandingpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPromoCardRailLinkingCollectionsBuildLandingpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoCardRailLinkingCollectionsBuildLandingpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPromoCardRailLinkingCollectionsBuildTariffPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoCardRailLinkingCollectionsBuildTariffPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPromoCardRailLinkingCollectionsBuildTariffPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoCardRailLinkingCollectionsBuildTariffPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPromoCardRailLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPromoCardRailLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentPromoCardRailLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPromoCardRailLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPromoCardRailLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPromoCardRailLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPromoCardRailLinkingCollectionsBuildGenericTemplatePageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPromoCardRailLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPromoCardRailLinkingCollectionsBuildLandingpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPromoCardRailLinkingCollectionsBuildLandingpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPromoCardRailLinkingCollectionsBuildTariffPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPromoCardRailLinkingCollectionsBuildTariffPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPromoCardRailOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoSection) */
export type ComponentPromoSection = Entry & _Node & {
  __typename?: 'ComponentPromoSection';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  bodyCopy?: Maybe<ComponentPromoSectionBodyCopy>;
  bulletListCollection?: Maybe<ComponentPromoSectionBulletListCollection>;
  bulletListCursorCollection?: Maybe<ComponentPromoSectionBulletListCursorCollection>;
  contentOrientation?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  ctaLabel?: Maybe<Scalars['String']['output']>;
  hasPostalCode?: Maybe<Scalars['Boolean']['output']>;
  image?: Maybe<ContentType5OiHchWgV9Y8SuvDxHCaLy>;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ComponentPromoSectionLinkingCollections>;
  showTitleInline?: Maybe<Scalars['Boolean']['output']>;
  smallText?: Maybe<ComponentPromoSectionSmallText>;
  sys: Sys;
  theme?: Maybe<Scalars['String']['output']>;
  title1?: Maybe<Scalars['String']['output']>;
  title2?: Maybe<Scalars['String']['output']>;
  titleColour?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoSection) */
export type ComponentPromoSectionAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoSection) */
export type ComponentPromoSectionBodyCopyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoSection) */
export type ComponentPromoSectionBulletListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoSectionBulletListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackStructuredTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoSection) */
export type ComponentPromoSectionBulletListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoSectionBulletListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackStructuredTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoSection) */
export type ComponentPromoSectionContentOrientationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoSection) */
export type ComponentPromoSectionCtaLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoSection) */
export type ComponentPromoSectionHasPostalCodeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoSection) */
export type ComponentPromoSectionImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoSection) */
export type ComponentPromoSectionInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoSection) */
export type ComponentPromoSectionLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoSection) */
export type ComponentPromoSectionShowTitleInlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoSection) */
export type ComponentPromoSectionSmallTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoSection) */
export type ComponentPromoSectionThemeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoSection) */
export type ComponentPromoSectionTitle1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoSection) */
export type ComponentPromoSectionTitle2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoSection) */
export type ComponentPromoSectionTitleColourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentPromoSectionBodyCopy = {
  __typename?: 'ComponentPromoSectionBodyCopy';
  json: Scalars['JSON']['output'];
  links: ComponentPromoSectionBodyCopyLinks;
};

export type ComponentPromoSectionBodyCopyAssets = {
  __typename?: 'ComponentPromoSectionBodyCopyAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComponentPromoSectionBodyCopyEntries = {
  __typename?: 'ComponentPromoSectionBodyCopyEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComponentPromoSectionBodyCopyLinks = {
  __typename?: 'ComponentPromoSectionBodyCopyLinks';
  assets: ComponentPromoSectionBodyCopyAssets;
  entries: ComponentPromoSectionBodyCopyEntries;
  resources: ComponentPromoSectionBodyCopyResources;
};

export type ComponentPromoSectionBodyCopyResources = {
  __typename?: 'ComponentPromoSectionBodyCopyResources';
  block: Array<ComponentPromoSectionBodyCopyResourcesBlock>;
  hyperlink: Array<ComponentPromoSectionBodyCopyResourcesHyperlink>;
  inline: Array<ComponentPromoSectionBodyCopyResourcesInline>;
};

export type ComponentPromoSectionBodyCopyResourcesBlock = ResourceLink & {
  __typename?: 'ComponentPromoSectionBodyCopyResourcesBlock';
  sys: ResourceSys;
};

export type ComponentPromoSectionBodyCopyResourcesHyperlink = ResourceLink & {
  __typename?: 'ComponentPromoSectionBodyCopyResourcesHyperlink';
  sys: ResourceSys;
};

export type ComponentPromoSectionBodyCopyResourcesInline = ResourceLink & {
  __typename?: 'ComponentPromoSectionBodyCopyResourcesInline';
  sys: ResourceSys;
};

export type ComponentPromoSectionBulletListCollection = {
  __typename?: 'ComponentPromoSectionBulletListCollection';
  items: Array<Maybe<PackStructuredText>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComponentPromoSectionBulletListCollectionOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComponentPromoSectionBulletListCursorCollection = {
  __typename?: 'ComponentPromoSectionBulletListCursorCollection';
  items: Array<Maybe<PackStructuredText>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComponentPromoSectionBulletListCursorCollectionOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComponentPromoSectionCollection = {
  __typename?: 'ComponentPromoSectionCollection';
  items: Array<Maybe<ComponentPromoSection>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentPromoSectionCursorCollection = {
  __typename?: 'ComponentPromoSectionCursorCollection';
  items: Array<Maybe<ComponentPromoSection>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentPromoSectionFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentPromoSectionFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentPromoSectionFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy_contains?: InputMaybe<Scalars['String']['input']>;
  bodyCopy_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bodyCopy_not_contains?: InputMaybe<Scalars['String']['input']>;
  bulletList?: InputMaybe<CfPackStructuredTextNestedFilter>;
  bulletListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentOrientation?: InputMaybe<Scalars['String']['input']>;
  contentOrientation_contains?: InputMaybe<Scalars['String']['input']>;
  contentOrientation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentOrientation_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentOrientation_not?: InputMaybe<Scalars['String']['input']>;
  contentOrientation_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentOrientation_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctaLabel?: InputMaybe<Scalars['String']['input']>;
  ctaLabel_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLabel_not?: InputMaybe<Scalars['String']['input']>;
  ctaLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hasPostalCode?: InputMaybe<Scalars['Boolean']['input']>;
  hasPostalCode_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hasPostalCode_not?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<CfContentType5OiHchWgV9Y8SuvDxHCaLyNestedFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showTitleInline?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_not?: InputMaybe<Scalars['Boolean']['input']>;
  smallText_contains?: InputMaybe<Scalars['String']['input']>;
  smallText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  smallText_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  theme?: InputMaybe<Scalars['String']['input']>;
  theme_contains?: InputMaybe<Scalars['String']['input']>;
  theme_exists?: InputMaybe<Scalars['Boolean']['input']>;
  theme_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  theme_not?: InputMaybe<Scalars['String']['input']>;
  theme_not_contains?: InputMaybe<Scalars['String']['input']>;
  theme_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title1?: InputMaybe<Scalars['String']['input']>;
  title1_contains?: InputMaybe<Scalars['String']['input']>;
  title1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title1_not?: InputMaybe<Scalars['String']['input']>;
  title1_not_contains?: InputMaybe<Scalars['String']['input']>;
  title1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2?: InputMaybe<Scalars['String']['input']>;
  title2_contains?: InputMaybe<Scalars['String']['input']>;
  title2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2_not?: InputMaybe<Scalars['String']['input']>;
  title2_not_contains?: InputMaybe<Scalars['String']['input']>;
  title2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColour?: InputMaybe<Scalars['String']['input']>;
  titleColour_contains?: InputMaybe<Scalars['String']['input']>;
  titleColour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleColour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColour_not?: InputMaybe<Scalars['String']['input']>;
  titleColour_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleColour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentPromoSectionLinkingCollections = {
  __typename?: 'ComponentPromoSectionLinkingCollections';
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildGenericTemplatePageCollection?: Maybe<BuildGenericTemplatePageCollection>;
  buildGenericTemplatePageCursorCollection?: Maybe<BuildGenericTemplatePageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentPromoSectionLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoSectionLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPromoSectionLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoSectionLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPromoSectionLinkingCollectionsBuildGenericTemplatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoSectionLinkingCollectionsBuildGenericTemplatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPromoSectionLinkingCollectionsBuildGenericTemplatePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoSectionLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPromoSectionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPromoSectionLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentPromoSectionLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPromoSectionLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPromoSectionLinkingCollectionsBuildGenericTemplatePageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPromoSectionLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPromoSectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  ContentOrientationAsc = 'contentOrientation_ASC',
  ContentOrientationDesc = 'contentOrientation_DESC',
  CtaLabelAsc = 'ctaLabel_ASC',
  CtaLabelDesc = 'ctaLabel_DESC',
  HasPostalCodeAsc = 'hasPostalCode_ASC',
  HasPostalCodeDesc = 'hasPostalCode_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC'
}

export type ComponentPromoSectionSmallText = {
  __typename?: 'ComponentPromoSectionSmallText';
  json: Scalars['JSON']['output'];
  links: ComponentPromoSectionSmallTextLinks;
};

export type ComponentPromoSectionSmallTextAssets = {
  __typename?: 'ComponentPromoSectionSmallTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComponentPromoSectionSmallTextEntries = {
  __typename?: 'ComponentPromoSectionSmallTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComponentPromoSectionSmallTextLinks = {
  __typename?: 'ComponentPromoSectionSmallTextLinks';
  assets: ComponentPromoSectionSmallTextAssets;
  entries: ComponentPromoSectionSmallTextEntries;
  resources: ComponentPromoSectionSmallTextResources;
};

export type ComponentPromoSectionSmallTextResources = {
  __typename?: 'ComponentPromoSectionSmallTextResources';
  block: Array<ComponentPromoSectionSmallTextResourcesBlock>;
  hyperlink: Array<ComponentPromoSectionSmallTextResourcesHyperlink>;
  inline: Array<ComponentPromoSectionSmallTextResourcesInline>;
};

export type ComponentPromoSectionSmallTextResourcesBlock = ResourceLink & {
  __typename?: 'ComponentPromoSectionSmallTextResourcesBlock';
  sys: ResourceSys;
};

export type ComponentPromoSectionSmallTextResourcesHyperlink = ResourceLink & {
  __typename?: 'ComponentPromoSectionSmallTextResourcesHyperlink';
  sys: ResourceSys;
};

export type ComponentPromoSectionSmallTextResourcesInline = ResourceLink & {
  __typename?: 'ComponentPromoSectionSmallTextResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoTextCard) */
export type ComponentPromoTextCard = Entry & _Node & {
  __typename?: 'ComponentPromoTextCard';
  _id: Scalars['ID']['output'];
  bodyCopy?: Maybe<ComponentPromoTextCardBodyCopy>;
  contentfulMetadata: ContentfulMetadata;
  ctaListCollection?: Maybe<ComponentPromoTextCardCtaListCollection>;
  ctaListCursorCollection?: Maybe<ComponentPromoTextCardCtaListCursorCollection>;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ComponentPromoTextCardLinkingCollections>;
  showTitleInline?: Maybe<Scalars['Boolean']['output']>;
  smallText?: Maybe<ComponentPromoTextCardSmallText>;
  sys: Sys;
  theme?: Maybe<Scalars['String']['output']>;
  titleColour?: Maybe<Scalars['String']['output']>;
  titlePart1?: Maybe<Scalars['String']['output']>;
  titlePart2?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoTextCard) */
export type ComponentPromoTextCardBodyCopyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoTextCard) */
export type ComponentPromoTextCardCtaListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoTextCardCtaListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoTextCard) */
export type ComponentPromoTextCardCtaListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoTextCardCtaListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoTextCard) */
export type ComponentPromoTextCardInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoTextCard) */
export type ComponentPromoTextCardLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoTextCard) */
export type ComponentPromoTextCardShowTitleInlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoTextCard) */
export type ComponentPromoTextCardSmallTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoTextCard) */
export type ComponentPromoTextCardThemeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoTextCard) */
export type ComponentPromoTextCardTitleColourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoTextCard) */
export type ComponentPromoTextCardTitlePart1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoTextCard) */
export type ComponentPromoTextCardTitlePart2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentPromoTextCardBodyCopy = {
  __typename?: 'ComponentPromoTextCardBodyCopy';
  json: Scalars['JSON']['output'];
  links: ComponentPromoTextCardBodyCopyLinks;
};

export type ComponentPromoTextCardBodyCopyAssets = {
  __typename?: 'ComponentPromoTextCardBodyCopyAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComponentPromoTextCardBodyCopyEntries = {
  __typename?: 'ComponentPromoTextCardBodyCopyEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComponentPromoTextCardBodyCopyLinks = {
  __typename?: 'ComponentPromoTextCardBodyCopyLinks';
  assets: ComponentPromoTextCardBodyCopyAssets;
  entries: ComponentPromoTextCardBodyCopyEntries;
  resources: ComponentPromoTextCardBodyCopyResources;
};

export type ComponentPromoTextCardBodyCopyResources = {
  __typename?: 'ComponentPromoTextCardBodyCopyResources';
  block: Array<ComponentPromoTextCardBodyCopyResourcesBlock>;
  hyperlink: Array<ComponentPromoTextCardBodyCopyResourcesHyperlink>;
  inline: Array<ComponentPromoTextCardBodyCopyResourcesInline>;
};

export type ComponentPromoTextCardBodyCopyResourcesBlock = ResourceLink & {
  __typename?: 'ComponentPromoTextCardBodyCopyResourcesBlock';
  sys: ResourceSys;
};

export type ComponentPromoTextCardBodyCopyResourcesHyperlink = ResourceLink & {
  __typename?: 'ComponentPromoTextCardBodyCopyResourcesHyperlink';
  sys: ResourceSys;
};

export type ComponentPromoTextCardBodyCopyResourcesInline = ResourceLink & {
  __typename?: 'ComponentPromoTextCardBodyCopyResourcesInline';
  sys: ResourceSys;
};

export type ComponentPromoTextCardCollection = {
  __typename?: 'ComponentPromoTextCardCollection';
  items: Array<Maybe<ComponentPromoTextCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentPromoTextCardCtaListCollection = {
  __typename?: 'ComponentPromoTextCardCtaListCollection';
  items: Array<Maybe<PackCta>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComponentPromoTextCardCtaListCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export type ComponentPromoTextCardCtaListCursorCollection = {
  __typename?: 'ComponentPromoTextCardCtaListCursorCollection';
  items: Array<Maybe<PackCta>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComponentPromoTextCardCtaListCursorCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export type ComponentPromoTextCardCursorCollection = {
  __typename?: 'ComponentPromoTextCardCursorCollection';
  items: Array<Maybe<ComponentPromoTextCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentPromoTextCardFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentPromoTextCardFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentPromoTextCardFilter>>>;
  bodyCopy_contains?: InputMaybe<Scalars['String']['input']>;
  bodyCopy_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bodyCopy_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctaList?: InputMaybe<CfPackCtaNestedFilter>;
  ctaListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showTitleInline?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_not?: InputMaybe<Scalars['Boolean']['input']>;
  smallText_contains?: InputMaybe<Scalars['String']['input']>;
  smallText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  smallText_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  theme?: InputMaybe<Scalars['String']['input']>;
  theme_contains?: InputMaybe<Scalars['String']['input']>;
  theme_exists?: InputMaybe<Scalars['Boolean']['input']>;
  theme_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  theme_not?: InputMaybe<Scalars['String']['input']>;
  theme_not_contains?: InputMaybe<Scalars['String']['input']>;
  theme_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColour?: InputMaybe<Scalars['String']['input']>;
  titleColour_contains?: InputMaybe<Scalars['String']['input']>;
  titleColour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleColour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColour_not?: InputMaybe<Scalars['String']['input']>;
  titleColour_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleColour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titlePart1?: InputMaybe<Scalars['String']['input']>;
  titlePart1_contains?: InputMaybe<Scalars['String']['input']>;
  titlePart1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titlePart1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titlePart1_not?: InputMaybe<Scalars['String']['input']>;
  titlePart1_not_contains?: InputMaybe<Scalars['String']['input']>;
  titlePart1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titlePart2?: InputMaybe<Scalars['String']['input']>;
  titlePart2_contains?: InputMaybe<Scalars['String']['input']>;
  titlePart2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titlePart2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titlePart2_not?: InputMaybe<Scalars['String']['input']>;
  titlePart2_not_contains?: InputMaybe<Scalars['String']['input']>;
  titlePart2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentPromoTextCardLinkingCollections = {
  __typename?: 'ComponentPromoTextCardLinkingCollections';
  componentPromoTextCardSectionCollection?: Maybe<ComponentPromoTextCardSectionCollection>;
  componentPromoTextCardSectionCursorCollection?: Maybe<ComponentPromoTextCardSectionCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentPromoTextCardLinkingCollectionsComponentPromoTextCardSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoTextCardLinkingCollectionsComponentPromoTextCardSectionCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPromoTextCardLinkingCollectionsComponentPromoTextCardSectionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoTextCardLinkingCollectionsComponentPromoTextCardSectionCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPromoTextCardLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPromoTextCardLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentPromoTextCardLinkingCollectionsComponentPromoTextCardSectionCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPromoTextCardLinkingCollectionsComponentPromoTextCardSectionCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPromoTextCardOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC',
  TitlePart1Asc = 'titlePart1_ASC',
  TitlePart1Desc = 'titlePart1_DESC',
  TitlePart2Asc = 'titlePart2_ASC',
  TitlePart2Desc = 'titlePart2_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoTextCardSection) */
export type ComponentPromoTextCardSection = Entry & _Node & {
  __typename?: 'ComponentPromoTextCardSection';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  card?: Maybe<ComponentPromoTextCard>;
  contentfulMetadata: ContentfulMetadata;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ComponentPromoTextCardSectionLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoTextCardSection) */
export type ComponentPromoTextCardSectionAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoTextCardSection) */
export type ComponentPromoTextCardSectionCardArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentPromoTextCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoTextCardSection) */
export type ComponentPromoTextCardSectionInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentPromoTextCardSection) */
export type ComponentPromoTextCardSectionLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentPromoTextCardSectionCollection = {
  __typename?: 'ComponentPromoTextCardSectionCollection';
  items: Array<Maybe<ComponentPromoTextCardSection>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentPromoTextCardSectionCursorCollection = {
  __typename?: 'ComponentPromoTextCardSectionCursorCollection';
  items: Array<Maybe<ComponentPromoTextCardSection>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentPromoTextCardSectionFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentPromoTextCardSectionFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentPromoTextCardSectionFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  card?: InputMaybe<CfComponentPromoTextCardNestedFilter>;
  card_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type ComponentPromoTextCardSectionLinkingCollections = {
  __typename?: 'ComponentPromoTextCardSectionLinkingCollections';
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildGenericTemplatePageCollection?: Maybe<BuildGenericTemplatePageCollection>;
  buildGenericTemplatePageCursorCollection?: Maybe<BuildGenericTemplatePageCursorCollection>;
  buildProductDetailPageCollection?: Maybe<BuildProductDetailPageCollection>;
  buildProductDetailPageCursorCollection?: Maybe<BuildProductDetailPageCursorCollection>;
  buildProductOverviewPageCollection?: Maybe<BuildProductOverviewPageCollection>;
  buildProductOverviewPageCursorCollection?: Maybe<BuildProductOverviewPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentPromoTextCardSectionLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoTextCardSectionLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPromoTextCardSectionLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoTextCardSectionLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPromoTextCardSectionLinkingCollectionsBuildGenericTemplatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoTextCardSectionLinkingCollectionsBuildGenericTemplatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPromoTextCardSectionLinkingCollectionsBuildGenericTemplatePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoTextCardSectionLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPromoTextCardSectionLinkingCollectionsBuildProductDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoTextCardSectionLinkingCollectionsBuildProductDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPromoTextCardSectionLinkingCollectionsBuildProductDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoTextCardSectionLinkingCollectionsBuildProductDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPromoTextCardSectionLinkingCollectionsBuildProductOverviewPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoTextCardSectionLinkingCollectionsBuildProductOverviewPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPromoTextCardSectionLinkingCollectionsBuildProductOverviewPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoTextCardSectionLinkingCollectionsBuildProductOverviewPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPromoTextCardSectionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentPromoTextCardSectionLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentPromoTextCardSectionLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPromoTextCardSectionLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPromoTextCardSectionLinkingCollectionsBuildGenericTemplatePageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPromoTextCardSectionLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPromoTextCardSectionLinkingCollectionsBuildProductDetailPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPromoTextCardSectionLinkingCollectionsBuildProductDetailPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPromoTextCardSectionLinkingCollectionsBuildProductOverviewPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPromoTextCardSectionLinkingCollectionsBuildProductOverviewPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentPromoTextCardSectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComponentPromoTextCardSmallText = {
  __typename?: 'ComponentPromoTextCardSmallText';
  json: Scalars['JSON']['output'];
  links: ComponentPromoTextCardSmallTextLinks;
};

export type ComponentPromoTextCardSmallTextAssets = {
  __typename?: 'ComponentPromoTextCardSmallTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComponentPromoTextCardSmallTextEntries = {
  __typename?: 'ComponentPromoTextCardSmallTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComponentPromoTextCardSmallTextLinks = {
  __typename?: 'ComponentPromoTextCardSmallTextLinks';
  assets: ComponentPromoTextCardSmallTextAssets;
  entries: ComponentPromoTextCardSmallTextEntries;
  resources: ComponentPromoTextCardSmallTextResources;
};

export type ComponentPromoTextCardSmallTextResources = {
  __typename?: 'ComponentPromoTextCardSmallTextResources';
  block: Array<ComponentPromoTextCardSmallTextResourcesBlock>;
  hyperlink: Array<ComponentPromoTextCardSmallTextResourcesHyperlink>;
  inline: Array<ComponentPromoTextCardSmallTextResourcesInline>;
};

export type ComponentPromoTextCardSmallTextResourcesBlock = ResourceLink & {
  __typename?: 'ComponentPromoTextCardSmallTextResourcesBlock';
  sys: ResourceSys;
};

export type ComponentPromoTextCardSmallTextResourcesHyperlink = ResourceLink & {
  __typename?: 'ComponentPromoTextCardSmallTextResourcesHyperlink';
  sys: ResourceSys;
};

export type ComponentPromoTextCardSmallTextResourcesInline = ResourceLink & {
  __typename?: 'ComponentPromoTextCardSmallTextResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentQrCodePopup) */
export type ComponentQrCodePopup = Entry & _Node & {
  __typename?: 'ComponentQrCodePopup';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  cta?: Maybe<PackCta>;
  linkedFrom?: Maybe<ComponentQrCodePopupLinkingCollections>;
  qrCodeImage?: Maybe<ContentType5OiHchWgV9Y8SuvDxHCaLy>;
  sys: Sys;
  text?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentQrCodePopup) */
export type ComponentQrCodePopupAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentQrCodePopup) */
export type ComponentQrCodePopupCtaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentQrCodePopup) */
export type ComponentQrCodePopupLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentQrCodePopup) */
export type ComponentQrCodePopupQrCodeImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentQrCodePopup) */
export type ComponentQrCodePopupTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentQrCodePopupCollection = {
  __typename?: 'ComponentQrCodePopupCollection';
  items: Array<Maybe<ComponentQrCodePopup>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentQrCodePopupCursorCollection = {
  __typename?: 'ComponentQrCodePopupCursorCollection';
  items: Array<Maybe<ComponentQrCodePopup>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentQrCodePopupFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentQrCodePopupFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentQrCodePopupFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta?: InputMaybe<CfPackCtaNestedFilter>;
  cta_exists?: InputMaybe<Scalars['Boolean']['input']>;
  qrCodeImage?: InputMaybe<CfContentType5OiHchWgV9Y8SuvDxHCaLyNestedFilter>;
  qrCodeImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text_not?: InputMaybe<Scalars['String']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentQrCodePopupLinkingCollections = {
  __typename?: 'ComponentQrCodePopupLinkingCollections';
  buildLandingpageCollection?: Maybe<BuildLandingpageCollection>;
  buildLandingpageCursorCollection?: Maybe<BuildLandingpageCursorCollection>;
  buildTariffPageCollection?: Maybe<BuildTariffPageCollection>;
  buildTariffPageCursorCollection?: Maybe<BuildTariffPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  packPageProductDetailCollection?: Maybe<PackPageProductDetailCollection>;
  packPageProductDetailCursorCollection?: Maybe<PackPageProductDetailCursorCollection>;
};


export type ComponentQrCodePopupLinkingCollectionsBuildLandingpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentQrCodePopupLinkingCollectionsBuildLandingpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentQrCodePopupLinkingCollectionsBuildLandingpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentQrCodePopupLinkingCollectionsBuildLandingpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentQrCodePopupLinkingCollectionsBuildTariffPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentQrCodePopupLinkingCollectionsBuildTariffPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentQrCodePopupLinkingCollectionsBuildTariffPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentQrCodePopupLinkingCollectionsBuildTariffPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentQrCodePopupLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentQrCodePopupLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentQrCodePopupLinkingCollectionsPackPageProductDetailCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentQrCodePopupLinkingCollectionsPackPageProductDetailCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentQrCodePopupLinkingCollectionsPackPageProductDetailCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentQrCodePopupLinkingCollectionsPackPageProductDetailCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentQrCodePopupLinkingCollectionsBuildLandingpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentQrCodePopupLinkingCollectionsBuildLandingpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentQrCodePopupLinkingCollectionsBuildTariffPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentQrCodePopupLinkingCollectionsBuildTariffPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentQrCodePopupLinkingCollectionsPackPageProductDetailCollectionOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentQrCodePopupLinkingCollectionsPackPageProductDetailCursorCollectionOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentQrCodePopupOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentQuickLinks) */
export type ComponentQuickLinks = Entry & _Node & {
  __typename?: 'ComponentQuickLinks';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  cardsCollection?: Maybe<ComponentQuickLinksCardsCollection>;
  cardsCursorCollection?: Maybe<ComponentQuickLinksCardsCursorCollection>;
  cardsIntro?: Maybe<PackStructuredText>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<ComponentQuickLinksLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentQuickLinks) */
export type ComponentQuickLinksAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentQuickLinks) */
export type ComponentQuickLinksCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentQuickLinksCardsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentQuickLinks) */
export type ComponentQuickLinksCardsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentQuickLinksCardsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentQuickLinks) */
export type ComponentQuickLinksCardsIntroArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackStructuredTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentQuickLinks) */
export type ComponentQuickLinksLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentQuickLinksCardsCollection = {
  __typename?: 'ComponentQuickLinksCardsCollection';
  items: Array<Maybe<ComponentCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComponentQuickLinksCardsCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  ShortTextAsc = 'shortText_ASC',
  ShortTextDesc = 'shortText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComponentQuickLinksCardsCursorCollection = {
  __typename?: 'ComponentQuickLinksCardsCursorCollection';
  items: Array<Maybe<ComponentCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComponentQuickLinksCardsCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  ShortTextAsc = 'shortText_ASC',
  ShortTextDesc = 'shortText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComponentQuickLinksCollection = {
  __typename?: 'ComponentQuickLinksCollection';
  items: Array<Maybe<ComponentQuickLinks>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentQuickLinksCursorCollection = {
  __typename?: 'ComponentQuickLinksCursorCollection';
  items: Array<Maybe<ComponentQuickLinks>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentQuickLinksFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentQuickLinksFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentQuickLinksFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cards?: InputMaybe<CfComponentCardNestedFilter>;
  cardsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardsIntro?: InputMaybe<CfPackStructuredTextNestedFilter>;
  cardsIntro_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type ComponentQuickLinksLinkingCollections = {
  __typename?: 'ComponentQuickLinksLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentQuickLinksLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentQuickLinksLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentQuickLinksOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentRecommendedContentAccordion) */
export type ComponentRecommendedContentAccordion = Entry & _Node & {
  __typename?: 'ComponentRecommendedContentAccordion';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  intro?: Maybe<PackFreeFormText>;
  itemsCollection?: Maybe<ComponentRecommendedContentAccordionItemsCollection>;
  itemsCursorCollection?: Maybe<ComponentRecommendedContentAccordionItemsCursorCollection>;
  linkedFrom?: Maybe<ComponentRecommendedContentAccordionLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentRecommendedContentAccordion) */
export type ComponentRecommendedContentAccordionAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentRecommendedContentAccordion) */
export type ComponentRecommendedContentAccordionIntroArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackFreeFormTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentRecommendedContentAccordion) */
export type ComponentRecommendedContentAccordionItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentRecommendedContentAccordionItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackRecommendedContentAccordionItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentRecommendedContentAccordion) */
export type ComponentRecommendedContentAccordionItemsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentRecommendedContentAccordionItemsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackRecommendedContentAccordionItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentRecommendedContentAccordion) */
export type ComponentRecommendedContentAccordionLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentRecommendedContentAccordionCollection = {
  __typename?: 'ComponentRecommendedContentAccordionCollection';
  items: Array<Maybe<ComponentRecommendedContentAccordion>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentRecommendedContentAccordionCursorCollection = {
  __typename?: 'ComponentRecommendedContentAccordionCursorCollection';
  items: Array<Maybe<ComponentRecommendedContentAccordion>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentRecommendedContentAccordionFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentRecommendedContentAccordionFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentRecommendedContentAccordionFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  intro?: InputMaybe<CfPackFreeFormTextNestedFilter>;
  intro_exists?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<CfPackRecommendedContentAccordionItemNestedFilter>;
  itemsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type ComponentRecommendedContentAccordionItemsCollection = {
  __typename?: 'ComponentRecommendedContentAccordionItemsCollection';
  items: Array<Maybe<PackRecommendedContentAccordionItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComponentRecommendedContentAccordionItemsCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComponentRecommendedContentAccordionItemsCursorCollection = {
  __typename?: 'ComponentRecommendedContentAccordionItemsCursorCollection';
  items: Array<Maybe<PackRecommendedContentAccordionItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComponentRecommendedContentAccordionItemsCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComponentRecommendedContentAccordionLinkingCollections = {
  __typename?: 'ComponentRecommendedContentAccordionLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  integrationOptimizelyFlagRuleCollection?: Maybe<IntegrationOptimizelyFlagRuleCollection>;
  integrationOptimizelyFlagRuleCursorCollection?: Maybe<IntegrationOptimizelyFlagRuleCursorCollection>;
};


export type ComponentRecommendedContentAccordionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentRecommendedContentAccordionLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentRecommendedContentAccordionLinkingCollectionsIntegrationOptimizelyFlagRuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentRecommendedContentAccordionLinkingCollectionsIntegrationOptimizelyFlagRuleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentRecommendedContentAccordionLinkingCollectionsIntegrationOptimizelyFlagRuleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentRecommendedContentAccordionLinkingCollectionsIntegrationOptimizelyFlagRuleCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentRecommendedContentAccordionLinkingCollectionsIntegrationOptimizelyFlagRuleCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariationAsc = 'variation_ASC',
  VariationDesc = 'variation_DESC'
}

export enum ComponentRecommendedContentAccordionLinkingCollectionsIntegrationOptimizelyFlagRuleCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariationAsc = 'variation_ASC',
  VariationDesc = 'variation_DESC'
}

export enum ComponentRecommendedContentAccordionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSearch) */
export type ComponentSearch = Entry & _Node & {
  __typename?: 'ComponentSearch';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ComponentSearchLinkingCollections>;
  nothingFound?: Maybe<Scalars['String']['output']>;
  nothingFoundCta?: Maybe<PackCta>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSearch) */
export type ComponentSearchAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSearch) */
export type ComponentSearchDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSearch) */
export type ComponentSearchInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSearch) */
export type ComponentSearchLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSearch) */
export type ComponentSearchNothingFoundArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSearch) */
export type ComponentSearchNothingFoundCtaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSearch) */
export type ComponentSearchTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentSearchCollection = {
  __typename?: 'ComponentSearchCollection';
  items: Array<Maybe<ComponentSearch>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentSearchCursorCollection = {
  __typename?: 'ComponentSearchCursorCollection';
  items: Array<Maybe<ComponentSearch>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentSearchFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentSearchFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentSearchFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nothingFound?: InputMaybe<Scalars['String']['input']>;
  nothingFoundCta?: InputMaybe<CfPackCtaNestedFilter>;
  nothingFoundCta_exists?: InputMaybe<Scalars['Boolean']['input']>;
  nothingFound_contains?: InputMaybe<Scalars['String']['input']>;
  nothingFound_exists?: InputMaybe<Scalars['Boolean']['input']>;
  nothingFound_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nothingFound_not?: InputMaybe<Scalars['String']['input']>;
  nothingFound_not_contains?: InputMaybe<Scalars['String']['input']>;
  nothingFound_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSearchLinkingCollections = {
  __typename?: 'ComponentSearchLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentSearchLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentSearchLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentSearchOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  NothingFoundAsc = 'nothingFound_ASC',
  NothingFoundDesc = 'nothingFound_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSectionSteps) */
export type ComponentSectionSteps = Entry & _Node & {
  __typename?: 'ComponentSectionSteps';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  bodyCopy?: Maybe<ComponentSectionStepsBodyCopy>;
  contentfulMetadata: ContentfulMetadata;
  ctaListCollection?: Maybe<ComponentSectionStepsCtaListCollection>;
  ctaListCursorCollection?: Maybe<ComponentSectionStepsCtaListCursorCollection>;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ComponentSectionStepsLinkingCollections>;
  showTitleInline?: Maybe<Scalars['Boolean']['output']>;
  smallText?: Maybe<ComponentSectionStepsSmallText>;
  stepsListCollection?: Maybe<ComponentSectionStepsStepsListCollection>;
  stepsListCursorCollection?: Maybe<ComponentSectionStepsStepsListCursorCollection>;
  sys: Sys;
  title1?: Maybe<Scalars['String']['output']>;
  title2?: Maybe<Scalars['String']['output']>;
  titleColour?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSectionSteps) */
export type ComponentSectionStepsAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSectionSteps) */
export type ComponentSectionStepsBodyCopyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSectionSteps) */
export type ComponentSectionStepsCtaListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSectionStepsCtaListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSectionSteps) */
export type ComponentSectionStepsCtaListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSectionStepsCtaListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSectionSteps) */
export type ComponentSectionStepsInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSectionSteps) */
export type ComponentSectionStepsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSectionSteps) */
export type ComponentSectionStepsShowTitleInlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSectionSteps) */
export type ComponentSectionStepsSmallTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSectionSteps) */
export type ComponentSectionStepsStepsListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSectionStepsStepsListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentStepFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSectionSteps) */
export type ComponentSectionStepsStepsListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSectionStepsStepsListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentStepFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSectionSteps) */
export type ComponentSectionStepsTitle1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSectionSteps) */
export type ComponentSectionStepsTitle2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSectionSteps) */
export type ComponentSectionStepsTitleColourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentSectionStepsBodyCopy = {
  __typename?: 'ComponentSectionStepsBodyCopy';
  json: Scalars['JSON']['output'];
  links: ComponentSectionStepsBodyCopyLinks;
};

export type ComponentSectionStepsBodyCopyAssets = {
  __typename?: 'ComponentSectionStepsBodyCopyAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComponentSectionStepsBodyCopyEntries = {
  __typename?: 'ComponentSectionStepsBodyCopyEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComponentSectionStepsBodyCopyLinks = {
  __typename?: 'ComponentSectionStepsBodyCopyLinks';
  assets: ComponentSectionStepsBodyCopyAssets;
  entries: ComponentSectionStepsBodyCopyEntries;
  resources: ComponentSectionStepsBodyCopyResources;
};

export type ComponentSectionStepsBodyCopyResources = {
  __typename?: 'ComponentSectionStepsBodyCopyResources';
  block: Array<ComponentSectionStepsBodyCopyResourcesBlock>;
  hyperlink: Array<ComponentSectionStepsBodyCopyResourcesHyperlink>;
  inline: Array<ComponentSectionStepsBodyCopyResourcesInline>;
};

export type ComponentSectionStepsBodyCopyResourcesBlock = ResourceLink & {
  __typename?: 'ComponentSectionStepsBodyCopyResourcesBlock';
  sys: ResourceSys;
};

export type ComponentSectionStepsBodyCopyResourcesHyperlink = ResourceLink & {
  __typename?: 'ComponentSectionStepsBodyCopyResourcesHyperlink';
  sys: ResourceSys;
};

export type ComponentSectionStepsBodyCopyResourcesInline = ResourceLink & {
  __typename?: 'ComponentSectionStepsBodyCopyResourcesInline';
  sys: ResourceSys;
};

export type ComponentSectionStepsCollection = {
  __typename?: 'ComponentSectionStepsCollection';
  items: Array<Maybe<ComponentSectionSteps>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentSectionStepsCtaListCollection = {
  __typename?: 'ComponentSectionStepsCtaListCollection';
  items: Array<Maybe<PackCta>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComponentSectionStepsCtaListCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export type ComponentSectionStepsCtaListCursorCollection = {
  __typename?: 'ComponentSectionStepsCtaListCursorCollection';
  items: Array<Maybe<PackCta>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComponentSectionStepsCtaListCursorCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export type ComponentSectionStepsCursorCollection = {
  __typename?: 'ComponentSectionStepsCursorCollection';
  items: Array<Maybe<ComponentSectionSteps>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentSectionStepsFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentSectionStepsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentSectionStepsFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy_contains?: InputMaybe<Scalars['String']['input']>;
  bodyCopy_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bodyCopy_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctaList?: InputMaybe<CfPackCtaNestedFilter>;
  ctaListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showTitleInline?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_not?: InputMaybe<Scalars['Boolean']['input']>;
  smallText_contains?: InputMaybe<Scalars['String']['input']>;
  smallText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  smallText_not_contains?: InputMaybe<Scalars['String']['input']>;
  stepsList?: InputMaybe<CfComponentStepNestedFilter>;
  stepsListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title1?: InputMaybe<Scalars['String']['input']>;
  title1_contains?: InputMaybe<Scalars['String']['input']>;
  title1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title1_not?: InputMaybe<Scalars['String']['input']>;
  title1_not_contains?: InputMaybe<Scalars['String']['input']>;
  title1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2?: InputMaybe<Scalars['String']['input']>;
  title2_contains?: InputMaybe<Scalars['String']['input']>;
  title2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2_not?: InputMaybe<Scalars['String']['input']>;
  title2_not_contains?: InputMaybe<Scalars['String']['input']>;
  title2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColour?: InputMaybe<Scalars['String']['input']>;
  titleColour_contains?: InputMaybe<Scalars['String']['input']>;
  titleColour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleColour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColour_not?: InputMaybe<Scalars['String']['input']>;
  titleColour_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleColour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSectionStepsLinkingCollections = {
  __typename?: 'ComponentSectionStepsLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildGenericTemplatePageCollection?: Maybe<BuildGenericTemplatePageCollection>;
  buildGenericTemplatePageCursorCollection?: Maybe<BuildGenericTemplatePageCursorCollection>;
  buildProductDetailPageCollection?: Maybe<BuildProductDetailPageCollection>;
  buildProductDetailPageCursorCollection?: Maybe<BuildProductDetailPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentSectionStepsLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSectionStepsLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentSectionStepsLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSectionStepsLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentSectionStepsLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSectionStepsLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentSectionStepsLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSectionStepsLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentSectionStepsLinkingCollectionsBuildGenericTemplatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSectionStepsLinkingCollectionsBuildGenericTemplatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentSectionStepsLinkingCollectionsBuildGenericTemplatePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSectionStepsLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentSectionStepsLinkingCollectionsBuildProductDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSectionStepsLinkingCollectionsBuildProductDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentSectionStepsLinkingCollectionsBuildProductDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSectionStepsLinkingCollectionsBuildProductDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentSectionStepsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentSectionStepsLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentSectionStepsLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentSectionStepsLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentSectionStepsLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentSectionStepsLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentSectionStepsLinkingCollectionsBuildGenericTemplatePageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentSectionStepsLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentSectionStepsLinkingCollectionsBuildProductDetailPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentSectionStepsLinkingCollectionsBuildProductDetailPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentSectionStepsOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC'
}

export type ComponentSectionStepsSmallText = {
  __typename?: 'ComponentSectionStepsSmallText';
  json: Scalars['JSON']['output'];
  links: ComponentSectionStepsSmallTextLinks;
};

export type ComponentSectionStepsSmallTextAssets = {
  __typename?: 'ComponentSectionStepsSmallTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComponentSectionStepsSmallTextEntries = {
  __typename?: 'ComponentSectionStepsSmallTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComponentSectionStepsSmallTextLinks = {
  __typename?: 'ComponentSectionStepsSmallTextLinks';
  assets: ComponentSectionStepsSmallTextAssets;
  entries: ComponentSectionStepsSmallTextEntries;
  resources: ComponentSectionStepsSmallTextResources;
};

export type ComponentSectionStepsSmallTextResources = {
  __typename?: 'ComponentSectionStepsSmallTextResources';
  block: Array<ComponentSectionStepsSmallTextResourcesBlock>;
  hyperlink: Array<ComponentSectionStepsSmallTextResourcesHyperlink>;
  inline: Array<ComponentSectionStepsSmallTextResourcesInline>;
};

export type ComponentSectionStepsSmallTextResourcesBlock = ResourceLink & {
  __typename?: 'ComponentSectionStepsSmallTextResourcesBlock';
  sys: ResourceSys;
};

export type ComponentSectionStepsSmallTextResourcesHyperlink = ResourceLink & {
  __typename?: 'ComponentSectionStepsSmallTextResourcesHyperlink';
  sys: ResourceSys;
};

export type ComponentSectionStepsSmallTextResourcesInline = ResourceLink & {
  __typename?: 'ComponentSectionStepsSmallTextResourcesInline';
  sys: ResourceSys;
};

export type ComponentSectionStepsStepsListCollection = {
  __typename?: 'ComponentSectionStepsStepsListCollection';
  items: Array<Maybe<ComponentStep>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComponentSectionStepsStepsListCollectionOrder {
  StepBodyCopyAsc = 'stepBodyCopy_ASC',
  StepBodyCopyDesc = 'stepBodyCopy_DESC',
  StepTitleAsc = 'stepTitle_ASC',
  StepTitleDesc = 'stepTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComponentSectionStepsStepsListCursorCollection = {
  __typename?: 'ComponentSectionStepsStepsListCursorCollection';
  items: Array<Maybe<ComponentStep>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComponentSectionStepsStepsListCursorCollectionOrder {
  StepBodyCopyAsc = 'stepBodyCopy_ASC',
  StepBodyCopyDesc = 'stepBodyCopy_DESC',
  StepTitleAsc = 'stepTitle_ASC',
  StepTitleDesc = 'stepTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSpotlight) */
export type ComponentSpotlight = Entry & _Node & {
  __typename?: 'ComponentSpotlight';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  bynderImage?: Maybe<ContentType5OiHchWgV9Y8SuvDxHCaLy>;
  contentfulMetadata: ContentfulMetadata;
  icon?: Maybe<WrapperIcon>;
  linkedFrom?: Maybe<ComponentSpotlightLinkingCollections>;
  sys: Sys;
  text?: Maybe<PackStructuredText>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSpotlight) */
export type ComponentSpotlightAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSpotlight) */
export type ComponentSpotlightBynderImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSpotlight) */
export type ComponentSpotlightIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperIconFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSpotlight) */
export type ComponentSpotlightLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSpotlight) */
export type ComponentSpotlightTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackStructuredTextFilter>;
};

export type ComponentSpotlightCollection = {
  __typename?: 'ComponentSpotlightCollection';
  items: Array<Maybe<ComponentSpotlight>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentSpotlightCursorCollection = {
  __typename?: 'ComponentSpotlightCursorCollection';
  items: Array<Maybe<ComponentSpotlight>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentSpotlightFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentSpotlightFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentSpotlightFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderImage?: InputMaybe<CfContentType5OiHchWgV9Y8SuvDxHCaLyNestedFilter>;
  bynderImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon?: InputMaybe<CfWrapperIconNestedFilter>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<CfPackStructuredTextNestedFilter>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSpotlightGrid) */
export type ComponentSpotlightGrid = Entry & _Node & {
  __typename?: 'ComponentSpotlightGrid';
  _id: Scalars['ID']['output'];
  alignment?: Maybe<Scalars['String']['output']>;
  anchor?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  cta?: Maybe<PackCta>;
  ctaBehaviour?: Maybe<Scalars['String']['output']>;
  ctaType?: Maybe<Scalars['String']['output']>;
  image?: Maybe<WrapperImage>;
  linkedFrom?: Maybe<ComponentSpotlightGridLinkingCollections>;
  spotlightCollection?: Maybe<ComponentSpotlightGridSpotlightCollection>;
  spotlightCursorCollection?: Maybe<ComponentSpotlightGridSpotlightCursorCollection>;
  spotlightIntro?: Maybe<PackStructuredText>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSpotlightGrid) */
export type ComponentSpotlightGridAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSpotlightGrid) */
export type ComponentSpotlightGridAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSpotlightGrid) */
export type ComponentSpotlightGridCtaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSpotlightGrid) */
export type ComponentSpotlightGridCtaBehaviourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSpotlightGrid) */
export type ComponentSpotlightGridCtaTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSpotlightGrid) */
export type ComponentSpotlightGridImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSpotlightGrid) */
export type ComponentSpotlightGridLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSpotlightGrid) */
export type ComponentSpotlightGridSpotlightCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSpotlightGridSpotlightCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentSpotlightFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSpotlightGrid) */
export type ComponentSpotlightGridSpotlightCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSpotlightGridSpotlightCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentSpotlightFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentSpotlightGrid) */
export type ComponentSpotlightGridSpotlightIntroArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackStructuredTextFilter>;
};

export type ComponentSpotlightGridCollection = {
  __typename?: 'ComponentSpotlightGridCollection';
  items: Array<Maybe<ComponentSpotlightGrid>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentSpotlightGridCursorCollection = {
  __typename?: 'ComponentSpotlightGridCursorCollection';
  items: Array<Maybe<ComponentSpotlightGrid>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentSpotlightGridFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentSpotlightGridFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentSpotlightGridFilter>>>;
  alignment?: InputMaybe<Scalars['String']['input']>;
  alignment_contains?: InputMaybe<Scalars['String']['input']>;
  alignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  alignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  alignment_not?: InputMaybe<Scalars['String']['input']>;
  alignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  alignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta?: InputMaybe<CfPackCtaNestedFilter>;
  ctaBehaviour?: InputMaybe<Scalars['String']['input']>;
  ctaBehaviour_contains?: InputMaybe<Scalars['String']['input']>;
  ctaBehaviour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaBehaviour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaBehaviour_not?: InputMaybe<Scalars['String']['input']>;
  ctaBehaviour_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaBehaviour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaType?: InputMaybe<Scalars['String']['input']>;
  ctaType_contains?: InputMaybe<Scalars['String']['input']>;
  ctaType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaType_not?: InputMaybe<Scalars['String']['input']>;
  ctaType_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta_exists?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<CfWrapperImageNestedFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  spotlight?: InputMaybe<CfComponentSpotlightNestedFilter>;
  spotlightCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  spotlightIntro?: InputMaybe<CfPackStructuredTextNestedFilter>;
  spotlightIntro_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type ComponentSpotlightGridLinkingCollections = {
  __typename?: 'ComponentSpotlightGridLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildLandingpageCollection?: Maybe<BuildLandingpageCollection>;
  buildLandingpageCursorCollection?: Maybe<BuildLandingpageCursorCollection>;
  buildTariffPageCollection?: Maybe<BuildTariffPageCollection>;
  buildTariffPageCursorCollection?: Maybe<BuildTariffPageCursorCollection>;
  buildWebpageCollection?: Maybe<BuildWebpageCollection>;
  buildWebpageCursorCollection?: Maybe<BuildWebpageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  packCtaCollection?: Maybe<PackCtaCollection>;
  packCtaCursorCollection?: Maybe<PackCtaCursorCollection>;
};


export type ComponentSpotlightGridLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSpotlightGridLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentSpotlightGridLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSpotlightGridLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentSpotlightGridLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSpotlightGridLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentSpotlightGridLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSpotlightGridLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentSpotlightGridLinkingCollectionsBuildLandingpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSpotlightGridLinkingCollectionsBuildLandingpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentSpotlightGridLinkingCollectionsBuildLandingpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSpotlightGridLinkingCollectionsBuildLandingpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentSpotlightGridLinkingCollectionsBuildTariffPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSpotlightGridLinkingCollectionsBuildTariffPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentSpotlightGridLinkingCollectionsBuildTariffPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSpotlightGridLinkingCollectionsBuildTariffPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentSpotlightGridLinkingCollectionsBuildWebpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSpotlightGridLinkingCollectionsBuildWebpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentSpotlightGridLinkingCollectionsBuildWebpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSpotlightGridLinkingCollectionsBuildWebpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentSpotlightGridLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentSpotlightGridLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentSpotlightGridLinkingCollectionsPackCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSpotlightGridLinkingCollectionsPackCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentSpotlightGridLinkingCollectionsPackCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSpotlightGridLinkingCollectionsPackCtaCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentSpotlightGridLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentSpotlightGridLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentSpotlightGridLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentSpotlightGridLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentSpotlightGridLinkingCollectionsBuildLandingpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentSpotlightGridLinkingCollectionsBuildLandingpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentSpotlightGridLinkingCollectionsBuildTariffPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentSpotlightGridLinkingCollectionsBuildTariffPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentSpotlightGridLinkingCollectionsBuildWebpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentSpotlightGridLinkingCollectionsBuildWebpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentSpotlightGridLinkingCollectionsPackCtaCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export enum ComponentSpotlightGridLinkingCollectionsPackCtaCursorCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export enum ComponentSpotlightGridOrder {
  AlignmentAsc = 'alignment_ASC',
  AlignmentDesc = 'alignment_DESC',
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComponentSpotlightGridSpotlightCollection = {
  __typename?: 'ComponentSpotlightGridSpotlightCollection';
  items: Array<Maybe<ComponentSpotlight>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComponentSpotlightGridSpotlightCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComponentSpotlightGridSpotlightCursorCollection = {
  __typename?: 'ComponentSpotlightGridSpotlightCursorCollection';
  items: Array<Maybe<ComponentSpotlight>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComponentSpotlightGridSpotlightCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComponentSpotlightLinkingCollections = {
  __typename?: 'ComponentSpotlightLinkingCollections';
  componentSpotlightGridCollection?: Maybe<ComponentSpotlightGridCollection>;
  componentSpotlightGridCursorCollection?: Maybe<ComponentSpotlightGridCursorCollection>;
  componentTariffCardCollection?: Maybe<ComponentTariffCardCollection>;
  componentTariffCardCursorCollection?: Maybe<ComponentTariffCardCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentSpotlightLinkingCollectionsComponentSpotlightGridCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSpotlightLinkingCollectionsComponentSpotlightGridCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentSpotlightLinkingCollectionsComponentSpotlightGridCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSpotlightLinkingCollectionsComponentSpotlightGridCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentSpotlightLinkingCollectionsComponentTariffCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSpotlightLinkingCollectionsComponentTariffCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentSpotlightLinkingCollectionsComponentTariffCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSpotlightLinkingCollectionsComponentTariffCardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentSpotlightLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentSpotlightLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentSpotlightLinkingCollectionsComponentSpotlightGridCollectionOrder {
  AlignmentAsc = 'alignment_ASC',
  AlignmentDesc = 'alignment_DESC',
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentSpotlightLinkingCollectionsComponentSpotlightGridCursorCollectionOrder {
  AlignmentAsc = 'alignment_ASC',
  AlignmentDesc = 'alignment_DESC',
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentSpotlightLinkingCollectionsComponentTariffCardCollectionOrder {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export enum ComponentSpotlightLinkingCollectionsComponentTariffCardCursorCollectionOrder {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export enum ComponentSpotlightOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentStep) */
export type ComponentStep = Entry & _Node & {
  __typename?: 'ComponentStep';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<ComponentStepLinkingCollections>;
  richTextStepBodyCopy?: Maybe<ComponentStepRichTextStepBodyCopy>;
  stepBodyCopy?: Maybe<Scalars['String']['output']>;
  stepTitle?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentStep) */
export type ComponentStepLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentStep) */
export type ComponentStepRichTextStepBodyCopyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentStep) */
export type ComponentStepStepBodyCopyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentStep) */
export type ComponentStepStepTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentStepCollection = {
  __typename?: 'ComponentStepCollection';
  items: Array<Maybe<ComponentStep>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentStepCursorCollection = {
  __typename?: 'ComponentStepCursorCollection';
  items: Array<Maybe<ComponentStep>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentStepFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentStepFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentStepFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  richTextStepBodyCopy_contains?: InputMaybe<Scalars['String']['input']>;
  richTextStepBodyCopy_exists?: InputMaybe<Scalars['Boolean']['input']>;
  richTextStepBodyCopy_not_contains?: InputMaybe<Scalars['String']['input']>;
  stepBodyCopy?: InputMaybe<Scalars['String']['input']>;
  stepBodyCopy_contains?: InputMaybe<Scalars['String']['input']>;
  stepBodyCopy_exists?: InputMaybe<Scalars['Boolean']['input']>;
  stepBodyCopy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stepBodyCopy_not?: InputMaybe<Scalars['String']['input']>;
  stepBodyCopy_not_contains?: InputMaybe<Scalars['String']['input']>;
  stepBodyCopy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stepTitle?: InputMaybe<Scalars['String']['input']>;
  stepTitle_contains?: InputMaybe<Scalars['String']['input']>;
  stepTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  stepTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stepTitle_not?: InputMaybe<Scalars['String']['input']>;
  stepTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  stepTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type ComponentStepLinkingCollections = {
  __typename?: 'ComponentStepLinkingCollections';
  componentSectionStepsCollection?: Maybe<ComponentSectionStepsCollection>;
  componentSectionStepsCursorCollection?: Maybe<ComponentSectionStepsCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentStepLinkingCollectionsComponentSectionStepsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentStepLinkingCollectionsComponentSectionStepsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentStepLinkingCollectionsComponentSectionStepsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentStepLinkingCollectionsComponentSectionStepsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentStepLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentStepLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentStepLinkingCollectionsComponentSectionStepsCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC'
}

export enum ComponentStepLinkingCollectionsComponentSectionStepsCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC'
}

export enum ComponentStepOrder {
  StepBodyCopyAsc = 'stepBodyCopy_ASC',
  StepBodyCopyDesc = 'stepBodyCopy_DESC',
  StepTitleAsc = 'stepTitle_ASC',
  StepTitleDesc = 'stepTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComponentStepRichTextStepBodyCopy = {
  __typename?: 'ComponentStepRichTextStepBodyCopy';
  json: Scalars['JSON']['output'];
  links: ComponentStepRichTextStepBodyCopyLinks;
};

export type ComponentStepRichTextStepBodyCopyAssets = {
  __typename?: 'ComponentStepRichTextStepBodyCopyAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComponentStepRichTextStepBodyCopyEntries = {
  __typename?: 'ComponentStepRichTextStepBodyCopyEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComponentStepRichTextStepBodyCopyLinks = {
  __typename?: 'ComponentStepRichTextStepBodyCopyLinks';
  assets: ComponentStepRichTextStepBodyCopyAssets;
  entries: ComponentStepRichTextStepBodyCopyEntries;
  resources: ComponentStepRichTextStepBodyCopyResources;
};

export type ComponentStepRichTextStepBodyCopyResources = {
  __typename?: 'ComponentStepRichTextStepBodyCopyResources';
  block: Array<ComponentStepRichTextStepBodyCopyResourcesBlock>;
  hyperlink: Array<ComponentStepRichTextStepBodyCopyResourcesHyperlink>;
  inline: Array<ComponentStepRichTextStepBodyCopyResourcesInline>;
};

export type ComponentStepRichTextStepBodyCopyResourcesBlock = ResourceLink & {
  __typename?: 'ComponentStepRichTextStepBodyCopyResourcesBlock';
  sys: ResourceSys;
};

export type ComponentStepRichTextStepBodyCopyResourcesHyperlink = ResourceLink & {
  __typename?: 'ComponentStepRichTextStepBodyCopyResourcesHyperlink';
  sys: ResourceSys;
};

export type ComponentStepRichTextStepBodyCopyResourcesInline = ResourceLink & {
  __typename?: 'ComponentStepRichTextStepBodyCopyResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTable) */
export type ComponentTable = Entry & _Node & {
  __typename?: 'ComponentTable';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<ComponentTableLinkingCollections>;
  sys: Sys;
  table?: Maybe<TopicTable>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTable) */
export type ComponentTableAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTable) */
export type ComponentTableLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTable) */
export type ComponentTableTableArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TopicTableFilter>;
};

export type ComponentTableCollection = {
  __typename?: 'ComponentTableCollection';
  items: Array<Maybe<ComponentTable>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentTableCursorCollection = {
  __typename?: 'ComponentTableCursorCollection';
  items: Array<Maybe<ComponentTable>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentTableFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentTableFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentTableFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  table?: InputMaybe<CfTopicTableNestedFilter>;
  table_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentTableLinkingCollections = {
  __typename?: 'ComponentTableLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildGenericTemplatePageCollection?: Maybe<BuildGenericTemplatePageCollection>;
  buildGenericTemplatePageCursorCollection?: Maybe<BuildGenericTemplatePageCursorCollection>;
  buildLandingpageCollection?: Maybe<BuildLandingpageCollection>;
  buildLandingpageCursorCollection?: Maybe<BuildLandingpageCursorCollection>;
  buildProductDetailPageCollection?: Maybe<BuildProductDetailPageCollection>;
  buildProductDetailPageCursorCollection?: Maybe<BuildProductDetailPageCursorCollection>;
  buildTariffPageCollection?: Maybe<BuildTariffPageCollection>;
  buildTariffPageCursorCollection?: Maybe<BuildTariffPageCursorCollection>;
  buildWebpageCollection?: Maybe<BuildWebpageCollection>;
  buildWebpageCursorCollection?: Maybe<BuildWebpageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  packCtaCollection?: Maybe<PackCtaCollection>;
  packCtaCursorCollection?: Maybe<PackCtaCursorCollection>;
};


export type ComponentTableLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTableLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTableLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTableLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTableLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTableLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTableLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTableLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTableLinkingCollectionsBuildGenericTemplatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTableLinkingCollectionsBuildGenericTemplatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTableLinkingCollectionsBuildGenericTemplatePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTableLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTableLinkingCollectionsBuildLandingpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTableLinkingCollectionsBuildLandingpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTableLinkingCollectionsBuildLandingpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTableLinkingCollectionsBuildLandingpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTableLinkingCollectionsBuildProductDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTableLinkingCollectionsBuildProductDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTableLinkingCollectionsBuildProductDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTableLinkingCollectionsBuildProductDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTableLinkingCollectionsBuildTariffPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTableLinkingCollectionsBuildTariffPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTableLinkingCollectionsBuildTariffPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTableLinkingCollectionsBuildTariffPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTableLinkingCollectionsBuildWebpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTableLinkingCollectionsBuildWebpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTableLinkingCollectionsBuildWebpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTableLinkingCollectionsBuildWebpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTableLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTableLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTableLinkingCollectionsPackCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTableLinkingCollectionsPackCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTableLinkingCollectionsPackCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTableLinkingCollectionsPackCtaCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentTableLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTableLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTableLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTableLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTableLinkingCollectionsBuildGenericTemplatePageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTableLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTableLinkingCollectionsBuildLandingpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTableLinkingCollectionsBuildLandingpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTableLinkingCollectionsBuildProductDetailPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTableLinkingCollectionsBuildProductDetailPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTableLinkingCollectionsBuildTariffPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTableLinkingCollectionsBuildTariffPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTableLinkingCollectionsBuildWebpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTableLinkingCollectionsBuildWebpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTableLinkingCollectionsPackCtaCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export enum ComponentTableLinkingCollectionsPackCtaCursorCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export enum ComponentTableOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTariffCard) */
export type ComponentTariffCard = Entry & _Node & {
  __typename?: 'ComponentTariffCard';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  cta?: Maybe<PackCta>;
  description?: Maybe<Scalars['String']['output']>;
  featuresCollection?: Maybe<ComponentTariffCardFeaturesCollection>;
  featuresCursorCollection?: Maybe<ComponentTariffCardFeaturesCursorCollection>;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ComponentTariffCardLinkingCollections>;
  sys: Sys;
  title1?: Maybe<Scalars['String']['output']>;
  title2?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTariffCard) */
export type ComponentTariffCardCtaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTariffCard) */
export type ComponentTariffCardDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTariffCard) */
export type ComponentTariffCardFeaturesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTariffCardFeaturesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentSpotlightFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTariffCard) */
export type ComponentTariffCardFeaturesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTariffCardFeaturesCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentSpotlightFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTariffCard) */
export type ComponentTariffCardInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTariffCard) */
export type ComponentTariffCardLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTariffCard) */
export type ComponentTariffCardTitle1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTariffCard) */
export type ComponentTariffCardTitle2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentTariffCardCollection = {
  __typename?: 'ComponentTariffCardCollection';
  items: Array<Maybe<ComponentTariffCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentTariffCardCursorCollection = {
  __typename?: 'ComponentTariffCardCursorCollection';
  items: Array<Maybe<ComponentTariffCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentTariffCardFeaturesCollection = {
  __typename?: 'ComponentTariffCardFeaturesCollection';
  items: Array<Maybe<ComponentSpotlight>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComponentTariffCardFeaturesCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComponentTariffCardFeaturesCursorCollection = {
  __typename?: 'ComponentTariffCardFeaturesCursorCollection';
  items: Array<Maybe<ComponentSpotlight>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComponentTariffCardFeaturesCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComponentTariffCardFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentTariffCardFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentTariffCardFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta?: InputMaybe<CfPackCtaNestedFilter>;
  cta_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  features?: InputMaybe<CfComponentSpotlightNestedFilter>;
  featuresCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title1?: InputMaybe<Scalars['String']['input']>;
  title1_contains?: InputMaybe<Scalars['String']['input']>;
  title1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title1_not?: InputMaybe<Scalars['String']['input']>;
  title1_not_contains?: InputMaybe<Scalars['String']['input']>;
  title1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2?: InputMaybe<Scalars['String']['input']>;
  title2_contains?: InputMaybe<Scalars['String']['input']>;
  title2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2_not?: InputMaybe<Scalars['String']['input']>;
  title2_not_contains?: InputMaybe<Scalars['String']['input']>;
  title2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTariffCardGroup) */
export type ComponentTariffCardGroup = Entry & _Node & {
  __typename?: 'ComponentTariffCardGroup';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  cardsCollection?: Maybe<ComponentTariffCardGroupCardsCollection>;
  cardsCursorCollection?: Maybe<ComponentTariffCardGroupCardsCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ComponentTariffCardGroupLinkingCollections>;
  showTitleInline?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  title1?: Maybe<Scalars['String']['output']>;
  title2?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTariffCardGroup) */
export type ComponentTariffCardGroupAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTariffCardGroup) */
export type ComponentTariffCardGroupCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTariffCardGroupCardsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentTariffCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTariffCardGroup) */
export type ComponentTariffCardGroupCardsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTariffCardGroupCardsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentTariffCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTariffCardGroup) */
export type ComponentTariffCardGroupDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTariffCardGroup) */
export type ComponentTariffCardGroupInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTariffCardGroup) */
export type ComponentTariffCardGroupLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTariffCardGroup) */
export type ComponentTariffCardGroupShowTitleInlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTariffCardGroup) */
export type ComponentTariffCardGroupTitle1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTariffCardGroup) */
export type ComponentTariffCardGroupTitle2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentTariffCardGroupCardsCollection = {
  __typename?: 'ComponentTariffCardGroupCardsCollection';
  items: Array<Maybe<ComponentTariffCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComponentTariffCardGroupCardsCollectionOrder {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export type ComponentTariffCardGroupCardsCursorCollection = {
  __typename?: 'ComponentTariffCardGroupCardsCursorCollection';
  items: Array<Maybe<ComponentTariffCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComponentTariffCardGroupCardsCursorCollectionOrder {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export type ComponentTariffCardGroupCollection = {
  __typename?: 'ComponentTariffCardGroupCollection';
  items: Array<Maybe<ComponentTariffCardGroup>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentTariffCardGroupCursorCollection = {
  __typename?: 'ComponentTariffCardGroupCursorCollection';
  items: Array<Maybe<ComponentTariffCardGroup>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentTariffCardGroupFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentTariffCardGroupFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentTariffCardGroupFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cards?: InputMaybe<CfComponentTariffCardNestedFilter>;
  cardsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showTitleInline?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title1?: InputMaybe<Scalars['String']['input']>;
  title1_contains?: InputMaybe<Scalars['String']['input']>;
  title1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title1_not?: InputMaybe<Scalars['String']['input']>;
  title1_not_contains?: InputMaybe<Scalars['String']['input']>;
  title1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2?: InputMaybe<Scalars['String']['input']>;
  title2_contains?: InputMaybe<Scalars['String']['input']>;
  title2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2_not?: InputMaybe<Scalars['String']['input']>;
  title2_not_contains?: InputMaybe<Scalars['String']['input']>;
  title2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentTariffCardGroupLinkingCollections = {
  __typename?: 'ComponentTariffCardGroupLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildGenericTemplatePageCollection?: Maybe<BuildGenericTemplatePageCollection>;
  buildGenericTemplatePageCursorCollection?: Maybe<BuildGenericTemplatePageCursorCollection>;
  buildProductDetailPageCollection?: Maybe<BuildProductDetailPageCollection>;
  buildProductDetailPageCursorCollection?: Maybe<BuildProductDetailPageCursorCollection>;
  buildTariffPageCollection?: Maybe<BuildTariffPageCollection>;
  buildTariffPageCursorCollection?: Maybe<BuildTariffPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentTariffCardGroupLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTariffCardGroupLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTariffCardGroupLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTariffCardGroupLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTariffCardGroupLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTariffCardGroupLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTariffCardGroupLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTariffCardGroupLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTariffCardGroupLinkingCollectionsBuildGenericTemplatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTariffCardGroupLinkingCollectionsBuildGenericTemplatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTariffCardGroupLinkingCollectionsBuildGenericTemplatePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTariffCardGroupLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTariffCardGroupLinkingCollectionsBuildProductDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTariffCardGroupLinkingCollectionsBuildProductDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTariffCardGroupLinkingCollectionsBuildProductDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTariffCardGroupLinkingCollectionsBuildProductDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTariffCardGroupLinkingCollectionsBuildTariffPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTariffCardGroupLinkingCollectionsBuildTariffPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTariffCardGroupLinkingCollectionsBuildTariffPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTariffCardGroupLinkingCollectionsBuildTariffPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTariffCardGroupLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTariffCardGroupLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentTariffCardGroupLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTariffCardGroupLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTariffCardGroupLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTariffCardGroupLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTariffCardGroupLinkingCollectionsBuildGenericTemplatePageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTariffCardGroupLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTariffCardGroupLinkingCollectionsBuildProductDetailPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTariffCardGroupLinkingCollectionsBuildProductDetailPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTariffCardGroupLinkingCollectionsBuildTariffPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTariffCardGroupLinkingCollectionsBuildTariffPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTariffCardGroupOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export type ComponentTariffCardLinkingCollections = {
  __typename?: 'ComponentTariffCardLinkingCollections';
  componentTariffCardGroupCollection?: Maybe<ComponentTariffCardGroupCollection>;
  componentTariffCardGroupCursorCollection?: Maybe<ComponentTariffCardGroupCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentTariffCardLinkingCollectionsComponentTariffCardGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTariffCardLinkingCollectionsComponentTariffCardGroupCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTariffCardLinkingCollectionsComponentTariffCardGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTariffCardLinkingCollectionsComponentTariffCardGroupCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTariffCardLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTariffCardLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentTariffCardLinkingCollectionsComponentTariffCardGroupCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export enum ComponentTariffCardLinkingCollectionsComponentTariffCardGroupCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export enum ComponentTariffCardOrder {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTariffHero) */
export type ComponentTariffHero = Entry & _Node & {
  __typename?: 'ComponentTariffHero';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  bannerBynderMedia?: Maybe<ContentType5OiHchWgV9Y8SuvDxHCaLy>;
  contentfulMetadata: ContentfulMetadata;
  cta1?: Maybe<PackCta>;
  cta2?: Maybe<PackCta>;
  linkedFrom?: Maybe<ComponentTariffHeroLinkingCollections>;
  postcodeFinderCta?: Maybe<PackCta>;
  postcodeFinderInputFieldText?: Maybe<Scalars['String']['output']>;
  showPostcodeFinder?: Maybe<Scalars['Boolean']['output']>;
  showTitleInline?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  text?: Maybe<ComponentTariffHeroText>;
  title1?: Maybe<Scalars['String']['output']>;
  title2?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTariffHero) */
export type ComponentTariffHeroAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTariffHero) */
export type ComponentTariffHeroBannerBynderMediaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTariffHero) */
export type ComponentTariffHeroCta1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTariffHero) */
export type ComponentTariffHeroCta2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTariffHero) */
export type ComponentTariffHeroLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTariffHero) */
export type ComponentTariffHeroPostcodeFinderCtaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTariffHero) */
export type ComponentTariffHeroPostcodeFinderInputFieldTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTariffHero) */
export type ComponentTariffHeroShowPostcodeFinderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTariffHero) */
export type ComponentTariffHeroShowTitleInlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTariffHero) */
export type ComponentTariffHeroTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTariffHero) */
export type ComponentTariffHeroTitle1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTariffHero) */
export type ComponentTariffHeroTitle2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentTariffHeroCollection = {
  __typename?: 'ComponentTariffHeroCollection';
  items: Array<Maybe<ComponentTariffHero>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentTariffHeroCursorCollection = {
  __typename?: 'ComponentTariffHeroCursorCollection';
  items: Array<Maybe<ComponentTariffHero>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentTariffHeroFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentTariffHeroFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentTariffHeroFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerBynderMedia?: InputMaybe<CfContentType5OiHchWgV9Y8SuvDxHCaLyNestedFilter>;
  bannerBynderMedia_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta1?: InputMaybe<CfPackCtaNestedFilter>;
  cta1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2?: InputMaybe<CfPackCtaNestedFilter>;
  cta2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  postcodeFinderCta?: InputMaybe<CfPackCtaNestedFilter>;
  postcodeFinderCta_exists?: InputMaybe<Scalars['Boolean']['input']>;
  postcodeFinderInputFieldText?: InputMaybe<Scalars['String']['input']>;
  postcodeFinderInputFieldText_contains?: InputMaybe<Scalars['String']['input']>;
  postcodeFinderInputFieldText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  postcodeFinderInputFieldText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  postcodeFinderInputFieldText_not?: InputMaybe<Scalars['String']['input']>;
  postcodeFinderInputFieldText_not_contains?: InputMaybe<Scalars['String']['input']>;
  postcodeFinderInputFieldText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showPostcodeFinder?: InputMaybe<Scalars['Boolean']['input']>;
  showPostcodeFinder_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showPostcodeFinder_not?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  title1?: InputMaybe<Scalars['String']['input']>;
  title1_contains?: InputMaybe<Scalars['String']['input']>;
  title1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title1_not?: InputMaybe<Scalars['String']['input']>;
  title1_not_contains?: InputMaybe<Scalars['String']['input']>;
  title1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2?: InputMaybe<Scalars['String']['input']>;
  title2_contains?: InputMaybe<Scalars['String']['input']>;
  title2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2_not?: InputMaybe<Scalars['String']['input']>;
  title2_not_contains?: InputMaybe<Scalars['String']['input']>;
  title2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentTariffHeroLinkingCollections = {
  __typename?: 'ComponentTariffHeroLinkingCollections';
  buildTariffPageCollection?: Maybe<BuildTariffPageCollection>;
  buildTariffPageCursorCollection?: Maybe<BuildTariffPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentTariffHeroLinkingCollectionsBuildTariffPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTariffHeroLinkingCollectionsBuildTariffPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTariffHeroLinkingCollectionsBuildTariffPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTariffHeroLinkingCollectionsBuildTariffPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTariffHeroLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTariffHeroLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentTariffHeroLinkingCollectionsBuildTariffPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTariffHeroLinkingCollectionsBuildTariffPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTariffHeroOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  PostcodeFinderInputFieldTextAsc = 'postcodeFinderInputFieldText_ASC',
  PostcodeFinderInputFieldTextDesc = 'postcodeFinderInputFieldText_DESC',
  ShowPostcodeFinderAsc = 'showPostcodeFinder_ASC',
  ShowPostcodeFinderDesc = 'showPostcodeFinder_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export type ComponentTariffHeroText = {
  __typename?: 'ComponentTariffHeroText';
  json: Scalars['JSON']['output'];
  links: ComponentTariffHeroTextLinks;
};

export type ComponentTariffHeroTextAssets = {
  __typename?: 'ComponentTariffHeroTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComponentTariffHeroTextEntries = {
  __typename?: 'ComponentTariffHeroTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComponentTariffHeroTextLinks = {
  __typename?: 'ComponentTariffHeroTextLinks';
  assets: ComponentTariffHeroTextAssets;
  entries: ComponentTariffHeroTextEntries;
  resources: ComponentTariffHeroTextResources;
};

export type ComponentTariffHeroTextResources = {
  __typename?: 'ComponentTariffHeroTextResources';
  block: Array<ComponentTariffHeroTextResourcesBlock>;
  hyperlink: Array<ComponentTariffHeroTextResourcesHyperlink>;
  inline: Array<ComponentTariffHeroTextResourcesInline>;
};

export type ComponentTariffHeroTextResourcesBlock = ResourceLink & {
  __typename?: 'ComponentTariffHeroTextResourcesBlock';
  sys: ResourceSys;
};

export type ComponentTariffHeroTextResourcesHyperlink = ResourceLink & {
  __typename?: 'ComponentTariffHeroTextResourcesHyperlink';
  sys: ResourceSys;
};

export type ComponentTariffHeroTextResourcesInline = ResourceLink & {
  __typename?: 'ComponentTariffHeroTextResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTextAndCta) */
export type ComponentTextAndCta = Entry & _Node & {
  __typename?: 'ComponentTextAndCta';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  bodyCopy?: Maybe<ComponentTextAndCtaBodyCopy>;
  contentfulMetadata: ContentfulMetadata;
  ctaListCollection?: Maybe<ComponentTextAndCtaCtaListCollection>;
  ctaListCursorCollection?: Maybe<ComponentTextAndCtaCtaListCursorCollection>;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ComponentTextAndCtaLinkingCollections>;
  showTitleInline?: Maybe<Scalars['Boolean']['output']>;
  smallText?: Maybe<ComponentTextAndCtaSmallText>;
  sys: Sys;
  theme?: Maybe<Scalars['String']['output']>;
  title1?: Maybe<Scalars['String']['output']>;
  title2?: Maybe<Scalars['String']['output']>;
  titleColour?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTextAndCta) */
export type ComponentTextAndCtaAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTextAndCta) */
export type ComponentTextAndCtaBodyCopyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTextAndCta) */
export type ComponentTextAndCtaCtaListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTextAndCtaCtaListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTextAndCta) */
export type ComponentTextAndCtaCtaListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTextAndCtaCtaListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTextAndCta) */
export type ComponentTextAndCtaInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTextAndCta) */
export type ComponentTextAndCtaLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTextAndCta) */
export type ComponentTextAndCtaShowTitleInlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTextAndCta) */
export type ComponentTextAndCtaSmallTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTextAndCta) */
export type ComponentTextAndCtaThemeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTextAndCta) */
export type ComponentTextAndCtaTitle1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTextAndCta) */
export type ComponentTextAndCtaTitle2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTextAndCta) */
export type ComponentTextAndCtaTitleColourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentTextAndCtaBodyCopy = {
  __typename?: 'ComponentTextAndCtaBodyCopy';
  json: Scalars['JSON']['output'];
  links: ComponentTextAndCtaBodyCopyLinks;
};

export type ComponentTextAndCtaBodyCopyAssets = {
  __typename?: 'ComponentTextAndCtaBodyCopyAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComponentTextAndCtaBodyCopyEntries = {
  __typename?: 'ComponentTextAndCtaBodyCopyEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComponentTextAndCtaBodyCopyLinks = {
  __typename?: 'ComponentTextAndCtaBodyCopyLinks';
  assets: ComponentTextAndCtaBodyCopyAssets;
  entries: ComponentTextAndCtaBodyCopyEntries;
  resources: ComponentTextAndCtaBodyCopyResources;
};

export type ComponentTextAndCtaBodyCopyResources = {
  __typename?: 'ComponentTextAndCtaBodyCopyResources';
  block: Array<ComponentTextAndCtaBodyCopyResourcesBlock>;
  hyperlink: Array<ComponentTextAndCtaBodyCopyResourcesHyperlink>;
  inline: Array<ComponentTextAndCtaBodyCopyResourcesInline>;
};

export type ComponentTextAndCtaBodyCopyResourcesBlock = ResourceLink & {
  __typename?: 'ComponentTextAndCtaBodyCopyResourcesBlock';
  sys: ResourceSys;
};

export type ComponentTextAndCtaBodyCopyResourcesHyperlink = ResourceLink & {
  __typename?: 'ComponentTextAndCtaBodyCopyResourcesHyperlink';
  sys: ResourceSys;
};

export type ComponentTextAndCtaBodyCopyResourcesInline = ResourceLink & {
  __typename?: 'ComponentTextAndCtaBodyCopyResourcesInline';
  sys: ResourceSys;
};

export type ComponentTextAndCtaCollection = {
  __typename?: 'ComponentTextAndCtaCollection';
  items: Array<Maybe<ComponentTextAndCta>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentTextAndCtaCtaListCollection = {
  __typename?: 'ComponentTextAndCtaCtaListCollection';
  items: Array<Maybe<PackCta>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComponentTextAndCtaCtaListCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export type ComponentTextAndCtaCtaListCursorCollection = {
  __typename?: 'ComponentTextAndCtaCtaListCursorCollection';
  items: Array<Maybe<PackCta>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComponentTextAndCtaCtaListCursorCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export type ComponentTextAndCtaCursorCollection = {
  __typename?: 'ComponentTextAndCtaCursorCollection';
  items: Array<Maybe<ComponentTextAndCta>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentTextAndCtaFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentTextAndCtaFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentTextAndCtaFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy_contains?: InputMaybe<Scalars['String']['input']>;
  bodyCopy_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bodyCopy_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctaList?: InputMaybe<CfPackCtaNestedFilter>;
  ctaListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showTitleInline?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_not?: InputMaybe<Scalars['Boolean']['input']>;
  smallText_contains?: InputMaybe<Scalars['String']['input']>;
  smallText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  smallText_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  theme?: InputMaybe<Scalars['String']['input']>;
  theme_contains?: InputMaybe<Scalars['String']['input']>;
  theme_exists?: InputMaybe<Scalars['Boolean']['input']>;
  theme_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  theme_not?: InputMaybe<Scalars['String']['input']>;
  theme_not_contains?: InputMaybe<Scalars['String']['input']>;
  theme_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title1?: InputMaybe<Scalars['String']['input']>;
  title1_contains?: InputMaybe<Scalars['String']['input']>;
  title1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title1_not?: InputMaybe<Scalars['String']['input']>;
  title1_not_contains?: InputMaybe<Scalars['String']['input']>;
  title1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2?: InputMaybe<Scalars['String']['input']>;
  title2_contains?: InputMaybe<Scalars['String']['input']>;
  title2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2_not?: InputMaybe<Scalars['String']['input']>;
  title2_not_contains?: InputMaybe<Scalars['String']['input']>;
  title2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColour?: InputMaybe<Scalars['String']['input']>;
  titleColour_contains?: InputMaybe<Scalars['String']['input']>;
  titleColour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleColour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColour_not?: InputMaybe<Scalars['String']['input']>;
  titleColour_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleColour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentTextAndCtaLinkingCollections = {
  __typename?: 'ComponentTextAndCtaLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildGenericTemplatePageCollection?: Maybe<BuildGenericTemplatePageCollection>;
  buildGenericTemplatePageCursorCollection?: Maybe<BuildGenericTemplatePageCursorCollection>;
  buildProductDetailPageCollection?: Maybe<BuildProductDetailPageCollection>;
  buildProductDetailPageCursorCollection?: Maybe<BuildProductDetailPageCursorCollection>;
  buildProductOverviewPageCollection?: Maybe<BuildProductOverviewPageCollection>;
  buildProductOverviewPageCursorCollection?: Maybe<BuildProductOverviewPageCursorCollection>;
  buildTariffPageCollection?: Maybe<BuildTariffPageCollection>;
  buildTariffPageCursorCollection?: Maybe<BuildTariffPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentTextAndCtaLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTextAndCtaLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTextAndCtaLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTextAndCtaLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTextAndCtaLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTextAndCtaLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTextAndCtaLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTextAndCtaLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTextAndCtaLinkingCollectionsBuildGenericTemplatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTextAndCtaLinkingCollectionsBuildGenericTemplatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTextAndCtaLinkingCollectionsBuildGenericTemplatePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTextAndCtaLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTextAndCtaLinkingCollectionsBuildProductDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTextAndCtaLinkingCollectionsBuildProductDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTextAndCtaLinkingCollectionsBuildProductDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTextAndCtaLinkingCollectionsBuildProductDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTextAndCtaLinkingCollectionsBuildProductOverviewPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTextAndCtaLinkingCollectionsBuildProductOverviewPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTextAndCtaLinkingCollectionsBuildProductOverviewPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTextAndCtaLinkingCollectionsBuildProductOverviewPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTextAndCtaLinkingCollectionsBuildTariffPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTextAndCtaLinkingCollectionsBuildTariffPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTextAndCtaLinkingCollectionsBuildTariffPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTextAndCtaLinkingCollectionsBuildTariffPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTextAndCtaLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTextAndCtaLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentTextAndCtaLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTextAndCtaLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTextAndCtaLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTextAndCtaLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTextAndCtaLinkingCollectionsBuildGenericTemplatePageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTextAndCtaLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTextAndCtaLinkingCollectionsBuildProductDetailPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTextAndCtaLinkingCollectionsBuildProductDetailPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTextAndCtaLinkingCollectionsBuildProductOverviewPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTextAndCtaLinkingCollectionsBuildProductOverviewPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTextAndCtaLinkingCollectionsBuildTariffPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTextAndCtaLinkingCollectionsBuildTariffPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTextAndCtaOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC'
}

export type ComponentTextAndCtaSmallText = {
  __typename?: 'ComponentTextAndCtaSmallText';
  json: Scalars['JSON']['output'];
  links: ComponentTextAndCtaSmallTextLinks;
};

export type ComponentTextAndCtaSmallTextAssets = {
  __typename?: 'ComponentTextAndCtaSmallTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComponentTextAndCtaSmallTextEntries = {
  __typename?: 'ComponentTextAndCtaSmallTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComponentTextAndCtaSmallTextLinks = {
  __typename?: 'ComponentTextAndCtaSmallTextLinks';
  assets: ComponentTextAndCtaSmallTextAssets;
  entries: ComponentTextAndCtaSmallTextEntries;
  resources: ComponentTextAndCtaSmallTextResources;
};

export type ComponentTextAndCtaSmallTextResources = {
  __typename?: 'ComponentTextAndCtaSmallTextResources';
  block: Array<ComponentTextAndCtaSmallTextResourcesBlock>;
  hyperlink: Array<ComponentTextAndCtaSmallTextResourcesHyperlink>;
  inline: Array<ComponentTextAndCtaSmallTextResourcesInline>;
};

export type ComponentTextAndCtaSmallTextResourcesBlock = ResourceLink & {
  __typename?: 'ComponentTextAndCtaSmallTextResourcesBlock';
  sys: ResourceSys;
};

export type ComponentTextAndCtaSmallTextResourcesHyperlink = ResourceLink & {
  __typename?: 'ComponentTextAndCtaSmallTextResourcesHyperlink';
  sys: ResourceSys;
};

export type ComponentTextAndCtaSmallTextResourcesInline = ResourceLink & {
  __typename?: 'ComponentTextAndCtaSmallTextResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTopArticleBrowser) */
export type ComponentTopArticleBrowser = Entry & _Node & {
  __typename?: 'ComponentTopArticleBrowser';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  ctaCollection?: Maybe<ComponentTopArticleBrowserCtaCollection>;
  ctaCursorCollection?: Maybe<ComponentTopArticleBrowserCtaCursorCollection>;
  intro?: Maybe<PackStructuredText>;
  linkedFrom?: Maybe<ComponentTopArticleBrowserLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTopArticleBrowser) */
export type ComponentTopArticleBrowserAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTopArticleBrowser) */
export type ComponentTopArticleBrowserCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTopArticleBrowserCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTopArticleBrowser) */
export type ComponentTopArticleBrowserCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTopArticleBrowserCtaCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTopArticleBrowser) */
export type ComponentTopArticleBrowserIntroArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackStructuredTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTopArticleBrowser) */
export type ComponentTopArticleBrowserLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentTopArticleBrowserCollection = {
  __typename?: 'ComponentTopArticleBrowserCollection';
  items: Array<Maybe<ComponentTopArticleBrowser>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentTopArticleBrowserCtaCollection = {
  __typename?: 'ComponentTopArticleBrowserCtaCollection';
  items: Array<Maybe<PackCta>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComponentTopArticleBrowserCtaCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export type ComponentTopArticleBrowserCtaCursorCollection = {
  __typename?: 'ComponentTopArticleBrowserCtaCursorCollection';
  items: Array<Maybe<PackCta>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComponentTopArticleBrowserCtaCursorCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export type ComponentTopArticleBrowserCursorCollection = {
  __typename?: 'ComponentTopArticleBrowserCursorCollection';
  items: Array<Maybe<ComponentTopArticleBrowser>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentTopArticleBrowserFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentTopArticleBrowserFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentTopArticleBrowserFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta?: InputMaybe<CfPackCtaNestedFilter>;
  ctaCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  intro?: InputMaybe<CfPackStructuredTextNestedFilter>;
  intro_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type ComponentTopArticleBrowserLinkingCollections = {
  __typename?: 'ComponentTopArticleBrowserLinkingCollections';
  componentHelpHomepageDualLayoutCollection?: Maybe<ComponentHelpHomepageDualLayoutCollection>;
  componentHelpHomepageDualLayoutCursorCollection?: Maybe<ComponentHelpHomepageDualLayoutCursorCollection>;
  componentLineupCollection?: Maybe<ComponentLineupCollection>;
  componentLineupCursorCollection?: Maybe<ComponentLineupCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentTopArticleBrowserLinkingCollectionsComponentHelpHomepageDualLayoutCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTopArticleBrowserLinkingCollectionsComponentHelpHomepageDualLayoutCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTopArticleBrowserLinkingCollectionsComponentHelpHomepageDualLayoutCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTopArticleBrowserLinkingCollectionsComponentHelpHomepageDualLayoutCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTopArticleBrowserLinkingCollectionsComponentLineupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTopArticleBrowserLinkingCollectionsComponentLineupCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTopArticleBrowserLinkingCollectionsComponentLineupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTopArticleBrowserLinkingCollectionsComponentLineupCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTopArticleBrowserLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTopArticleBrowserLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentTopArticleBrowserLinkingCollectionsComponentHelpHomepageDualLayoutCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTopArticleBrowserLinkingCollectionsComponentHelpHomepageDualLayoutCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTopArticleBrowserLinkingCollectionsComponentLineupCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTopArticleBrowserLinkingCollectionsComponentLineupCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTopArticleBrowserOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTrustpilot) */
export type ComponentTrustpilot = Entry & _Node & {
  __typename?: 'ComponentTrustpilot';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<ComponentTrustpilotLinkingCollections>;
  showAverageRatingAndTotalReviews?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTrustpilot) */
export type ComponentTrustpilotLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTrustpilot) */
export type ComponentTrustpilotShowAverageRatingAndTotalReviewsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentTrustpilot) */
export type ComponentTrustpilotTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentTrustpilotCollection = {
  __typename?: 'ComponentTrustpilotCollection';
  items: Array<Maybe<ComponentTrustpilot>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentTrustpilotCursorCollection = {
  __typename?: 'ComponentTrustpilotCursorCollection';
  items: Array<Maybe<ComponentTrustpilot>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentTrustpilotFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentTrustpilotFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentTrustpilotFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  showAverageRatingAndTotalReviews?: InputMaybe<Scalars['Boolean']['input']>;
  showAverageRatingAndTotalReviews_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showAverageRatingAndTotalReviews_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentTrustpilotLinkingCollections = {
  __typename?: 'ComponentTrustpilotLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildGenericTemplatePageCollection?: Maybe<BuildGenericTemplatePageCollection>;
  buildGenericTemplatePageCursorCollection?: Maybe<BuildGenericTemplatePageCursorCollection>;
  buildLandingpageCollection?: Maybe<BuildLandingpageCollection>;
  buildLandingpageCursorCollection?: Maybe<BuildLandingpageCursorCollection>;
  buildProductDetailPageCollection?: Maybe<BuildProductDetailPageCollection>;
  buildProductDetailPageCursorCollection?: Maybe<BuildProductDetailPageCursorCollection>;
  buildTariffPageCollection?: Maybe<BuildTariffPageCollection>;
  buildTariffPageCursorCollection?: Maybe<BuildTariffPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentTrustpilotLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTrustpilotLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTrustpilotLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTrustpilotLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTrustpilotLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTrustpilotLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTrustpilotLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTrustpilotLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTrustpilotLinkingCollectionsBuildGenericTemplatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTrustpilotLinkingCollectionsBuildGenericTemplatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTrustpilotLinkingCollectionsBuildGenericTemplatePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTrustpilotLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTrustpilotLinkingCollectionsBuildLandingpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTrustpilotLinkingCollectionsBuildLandingpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTrustpilotLinkingCollectionsBuildLandingpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTrustpilotLinkingCollectionsBuildLandingpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTrustpilotLinkingCollectionsBuildProductDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTrustpilotLinkingCollectionsBuildProductDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTrustpilotLinkingCollectionsBuildProductDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTrustpilotLinkingCollectionsBuildProductDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTrustpilotLinkingCollectionsBuildTariffPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTrustpilotLinkingCollectionsBuildTariffPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTrustpilotLinkingCollectionsBuildTariffPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTrustpilotLinkingCollectionsBuildTariffPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTrustpilotLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentTrustpilotLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentTrustpilotLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTrustpilotLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTrustpilotLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTrustpilotLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTrustpilotLinkingCollectionsBuildGenericTemplatePageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTrustpilotLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTrustpilotLinkingCollectionsBuildLandingpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTrustpilotLinkingCollectionsBuildLandingpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTrustpilotLinkingCollectionsBuildProductDetailPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTrustpilotLinkingCollectionsBuildProductDetailPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTrustpilotLinkingCollectionsBuildTariffPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTrustpilotLinkingCollectionsBuildTariffPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentTrustpilotOrder {
  ShowAverageRatingAndTotalReviewsAsc = 'showAverageRatingAndTotalReviews_ASC',
  ShowAverageRatingAndTotalReviewsDesc = 'showAverageRatingAndTotalReviews_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentUspCard) */
export type ComponentUspCard = Entry & _Node & {
  __typename?: 'ComponentUspCard';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  descriptionText?: Maybe<ComponentUspCardDescriptionText>;
  image?: Maybe<ContentType5OiHchWgV9Y8SuvDxHCaLy>;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ComponentUspCardLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentUspCard) */
export type ComponentUspCardDescriptionTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentUspCard) */
export type ComponentUspCardImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentUspCard) */
export type ComponentUspCardInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentUspCard) */
export type ComponentUspCardLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentUspCard) */
export type ComponentUspCardTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentUspCardCollection = {
  __typename?: 'ComponentUspCardCollection';
  items: Array<Maybe<ComponentUspCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentUspCardCursorCollection = {
  __typename?: 'ComponentUspCardCursorCollection';
  items: Array<Maybe<ComponentUspCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentUspCardDescriptionText = {
  __typename?: 'ComponentUspCardDescriptionText';
  json: Scalars['JSON']['output'];
  links: ComponentUspCardDescriptionTextLinks;
};

export type ComponentUspCardDescriptionTextAssets = {
  __typename?: 'ComponentUspCardDescriptionTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComponentUspCardDescriptionTextEntries = {
  __typename?: 'ComponentUspCardDescriptionTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComponentUspCardDescriptionTextLinks = {
  __typename?: 'ComponentUspCardDescriptionTextLinks';
  assets: ComponentUspCardDescriptionTextAssets;
  entries: ComponentUspCardDescriptionTextEntries;
  resources: ComponentUspCardDescriptionTextResources;
};

export type ComponentUspCardDescriptionTextResources = {
  __typename?: 'ComponentUspCardDescriptionTextResources';
  block: Array<ComponentUspCardDescriptionTextResourcesBlock>;
  hyperlink: Array<ComponentUspCardDescriptionTextResourcesHyperlink>;
  inline: Array<ComponentUspCardDescriptionTextResourcesInline>;
};

export type ComponentUspCardDescriptionTextResourcesBlock = ResourceLink & {
  __typename?: 'ComponentUspCardDescriptionTextResourcesBlock';
  sys: ResourceSys;
};

export type ComponentUspCardDescriptionTextResourcesHyperlink = ResourceLink & {
  __typename?: 'ComponentUspCardDescriptionTextResourcesHyperlink';
  sys: ResourceSys;
};

export type ComponentUspCardDescriptionTextResourcesInline = ResourceLink & {
  __typename?: 'ComponentUspCardDescriptionTextResourcesInline';
  sys: ResourceSys;
};

export type ComponentUspCardFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentUspCardFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentUspCardFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  descriptionText_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionText_not_contains?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<CfContentType5OiHchWgV9Y8SuvDxHCaLyNestedFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentUspCardLinkingCollections = {
  __typename?: 'ComponentUspCardLinkingCollections';
  componentUspGroupCollection?: Maybe<ComponentUspGroupCollection>;
  componentUspGroupCursorCollection?: Maybe<ComponentUspGroupCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentUspCardLinkingCollectionsComponentUspGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentUspCardLinkingCollectionsComponentUspGroupCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentUspCardLinkingCollectionsComponentUspGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentUspCardLinkingCollectionsComponentUspGroupCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentUspCardLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentUspCardLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentUspCardLinkingCollectionsComponentUspGroupCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TermsAsc = 'terms_ASC',
  TermsDesc = 'terms_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export enum ComponentUspCardLinkingCollectionsComponentUspGroupCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TermsAsc = 'terms_ASC',
  TermsDesc = 'terms_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export enum ComponentUspCardOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentUspGroup) */
export type ComponentUspGroup = Entry & _Node & {
  __typename?: 'ComponentUspGroup';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  animations?: Maybe<WrapperAnimation>;
  cardsCollection?: Maybe<ComponentUspGroupCardsCollection>;
  cardsCursorCollection?: Maybe<ComponentUspGroupCardsCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  cta1?: Maybe<PackCta>;
  cta2?: Maybe<PackCta>;
  descriptionText?: Maybe<ComponentUspGroupDescriptionText>;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ComponentUspGroupLinkingCollections>;
  showTitleInline?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  terms?: Maybe<Scalars['String']['output']>;
  title1?: Maybe<Scalars['String']['output']>;
  title2?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentUspGroup) */
export type ComponentUspGroupAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentUspGroup) */
export type ComponentUspGroupAnimationsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperAnimationFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentUspGroup) */
export type ComponentUspGroupCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentUspGroupCardsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentUspCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentUspGroup) */
export type ComponentUspGroupCardsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentUspGroupCardsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentUspCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentUspGroup) */
export type ComponentUspGroupCta1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentUspGroup) */
export type ComponentUspGroupCta2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentUspGroup) */
export type ComponentUspGroupDescriptionTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentUspGroup) */
export type ComponentUspGroupInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentUspGroup) */
export type ComponentUspGroupLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentUspGroup) */
export type ComponentUspGroupShowTitleInlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentUspGroup) */
export type ComponentUspGroupTermsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentUspGroup) */
export type ComponentUspGroupTitle1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentUspGroup) */
export type ComponentUspGroupTitle2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentUspGroupCardsCollection = {
  __typename?: 'ComponentUspGroupCardsCollection';
  items: Array<Maybe<ComponentUspCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComponentUspGroupCardsCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ComponentUspGroupCardsCursorCollection = {
  __typename?: 'ComponentUspGroupCardsCursorCollection';
  items: Array<Maybe<ComponentUspCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComponentUspGroupCardsCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ComponentUspGroupCollection = {
  __typename?: 'ComponentUspGroupCollection';
  items: Array<Maybe<ComponentUspGroup>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentUspGroupCursorCollection = {
  __typename?: 'ComponentUspGroupCursorCollection';
  items: Array<Maybe<ComponentUspGroup>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentUspGroupDescriptionText = {
  __typename?: 'ComponentUspGroupDescriptionText';
  json: Scalars['JSON']['output'];
  links: ComponentUspGroupDescriptionTextLinks;
};

export type ComponentUspGroupDescriptionTextAssets = {
  __typename?: 'ComponentUspGroupDescriptionTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComponentUspGroupDescriptionTextEntries = {
  __typename?: 'ComponentUspGroupDescriptionTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComponentUspGroupDescriptionTextLinks = {
  __typename?: 'ComponentUspGroupDescriptionTextLinks';
  assets: ComponentUspGroupDescriptionTextAssets;
  entries: ComponentUspGroupDescriptionTextEntries;
  resources: ComponentUspGroupDescriptionTextResources;
};

export type ComponentUspGroupDescriptionTextResources = {
  __typename?: 'ComponentUspGroupDescriptionTextResources';
  block: Array<ComponentUspGroupDescriptionTextResourcesBlock>;
  hyperlink: Array<ComponentUspGroupDescriptionTextResourcesHyperlink>;
  inline: Array<ComponentUspGroupDescriptionTextResourcesInline>;
};

export type ComponentUspGroupDescriptionTextResourcesBlock = ResourceLink & {
  __typename?: 'ComponentUspGroupDescriptionTextResourcesBlock';
  sys: ResourceSys;
};

export type ComponentUspGroupDescriptionTextResourcesHyperlink = ResourceLink & {
  __typename?: 'ComponentUspGroupDescriptionTextResourcesHyperlink';
  sys: ResourceSys;
};

export type ComponentUspGroupDescriptionTextResourcesInline = ResourceLink & {
  __typename?: 'ComponentUspGroupDescriptionTextResourcesInline';
  sys: ResourceSys;
};

export type ComponentUspGroupFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentUspGroupFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentUspGroupFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  animations?: InputMaybe<CfWrapperAnimationNestedFilter>;
  animations_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cards?: InputMaybe<CfComponentUspCardNestedFilter>;
  cardsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta1?: InputMaybe<CfPackCtaNestedFilter>;
  cta1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2?: InputMaybe<CfPackCtaNestedFilter>;
  cta2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionText_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionText_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showTitleInline?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  terms?: InputMaybe<Scalars['String']['input']>;
  terms_contains?: InputMaybe<Scalars['String']['input']>;
  terms_exists?: InputMaybe<Scalars['Boolean']['input']>;
  terms_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  terms_not?: InputMaybe<Scalars['String']['input']>;
  terms_not_contains?: InputMaybe<Scalars['String']['input']>;
  terms_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title1?: InputMaybe<Scalars['String']['input']>;
  title1_contains?: InputMaybe<Scalars['String']['input']>;
  title1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title1_not?: InputMaybe<Scalars['String']['input']>;
  title1_not_contains?: InputMaybe<Scalars['String']['input']>;
  title1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2?: InputMaybe<Scalars['String']['input']>;
  title2_contains?: InputMaybe<Scalars['String']['input']>;
  title2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2_not?: InputMaybe<Scalars['String']['input']>;
  title2_not_contains?: InputMaybe<Scalars['String']['input']>;
  title2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentUspGroupLinkingCollections = {
  __typename?: 'ComponentUspGroupLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildGenericTemplatePageCollection?: Maybe<BuildGenericTemplatePageCollection>;
  buildGenericTemplatePageCursorCollection?: Maybe<BuildGenericTemplatePageCursorCollection>;
  buildLandingpageCollection?: Maybe<BuildLandingpageCollection>;
  buildLandingpageCursorCollection?: Maybe<BuildLandingpageCursorCollection>;
  buildProductDetailPageCollection?: Maybe<BuildProductDetailPageCollection>;
  buildProductDetailPageCursorCollection?: Maybe<BuildProductDetailPageCursorCollection>;
  buildTariffPageCollection?: Maybe<BuildTariffPageCollection>;
  buildTariffPageCursorCollection?: Maybe<BuildTariffPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentUspGroupLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentUspGroupLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentUspGroupLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentUspGroupLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentUspGroupLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentUspGroupLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentUspGroupLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentUspGroupLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentUspGroupLinkingCollectionsBuildGenericTemplatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentUspGroupLinkingCollectionsBuildGenericTemplatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentUspGroupLinkingCollectionsBuildGenericTemplatePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentUspGroupLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentUspGroupLinkingCollectionsBuildLandingpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentUspGroupLinkingCollectionsBuildLandingpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentUspGroupLinkingCollectionsBuildLandingpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentUspGroupLinkingCollectionsBuildLandingpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentUspGroupLinkingCollectionsBuildProductDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentUspGroupLinkingCollectionsBuildProductDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentUspGroupLinkingCollectionsBuildProductDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentUspGroupLinkingCollectionsBuildProductDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentUspGroupLinkingCollectionsBuildTariffPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentUspGroupLinkingCollectionsBuildTariffPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentUspGroupLinkingCollectionsBuildTariffPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentUspGroupLinkingCollectionsBuildTariffPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentUspGroupLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentUspGroupLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentUspGroupLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentUspGroupLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentUspGroupLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentUspGroupLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentUspGroupLinkingCollectionsBuildGenericTemplatePageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentUspGroupLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentUspGroupLinkingCollectionsBuildLandingpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentUspGroupLinkingCollectionsBuildLandingpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentUspGroupLinkingCollectionsBuildProductDetailPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentUspGroupLinkingCollectionsBuildProductDetailPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentUspGroupLinkingCollectionsBuildTariffPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentUspGroupLinkingCollectionsBuildTariffPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentUspGroupOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TermsAsc = 'terms_ASC',
  TermsDesc = 'terms_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentUspSupportingContent) */
export type ComponentUspSupportingContent = Entry & _Node & {
  __typename?: 'ComponentUspSupportingContent';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  imageAnimationsCollection?: Maybe<ComponentUspSupportingContentImageAnimationsCollection>;
  imageAnimationsCursorCollection?: Maybe<ComponentUspSupportingContentImageAnimationsCursorCollection>;
  linkedFrom?: Maybe<ComponentUspSupportingContentLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentUspSupportingContent) */
export type ComponentUspSupportingContentImageAnimationsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentUspSupportingContentImageAnimationsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackLottieAnimationFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentUspSupportingContent) */
export type ComponentUspSupportingContentImageAnimationsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentUspSupportingContentImageAnimationsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackLottieAnimationFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentUspSupportingContent) */
export type ComponentUspSupportingContentLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentUspSupportingContent) */
export type ComponentUspSupportingContentTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentUspSupportingContentCollection = {
  __typename?: 'ComponentUspSupportingContentCollection';
  items: Array<Maybe<ComponentUspSupportingContent>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentUspSupportingContentCursorCollection = {
  __typename?: 'ComponentUspSupportingContentCursorCollection';
  items: Array<Maybe<ComponentUspSupportingContent>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentUspSupportingContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentUspSupportingContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentUspSupportingContentFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  imageAnimations?: InputMaybe<CfPackLottieAnimationNestedFilter>;
  imageAnimationsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentUspSupportingContentImageAnimationsCollection = {
  __typename?: 'ComponentUspSupportingContentImageAnimationsCollection';
  items: Array<Maybe<PackLottieAnimation>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComponentUspSupportingContentImageAnimationsCollectionOrder {
  AltTextAsc = 'altText_ASC',
  AltTextDesc = 'altText_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ComponentUspSupportingContentImageAnimationsCursorCollection = {
  __typename?: 'ComponentUspSupportingContentImageAnimationsCursorCollection';
  items: Array<Maybe<PackLottieAnimation>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComponentUspSupportingContentImageAnimationsCursorCollectionOrder {
  AltTextAsc = 'altText_ASC',
  AltTextDesc = 'altText_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ComponentUspSupportingContentLinkingCollections = {
  __typename?: 'ComponentUspSupportingContentLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentUspSupportingContentLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentUspSupportingContentLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentUspSupportingContentOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentVideoPlayer) */
export type ComponentVideoPlayer = Entry & _Node & {
  __typename?: 'ComponentVideoPlayer';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  bynderVideo?: Maybe<ContentType5VCz5FHyZ2ZlWqa5OKh6Y9>;
  contentfulMetadata: ContentfulMetadata;
  ctaListCollection?: Maybe<ComponentVideoPlayerCtaListCollection>;
  ctaListCursorCollection?: Maybe<ComponentVideoPlayerCtaListCursorCollection>;
  description?: Maybe<ComponentVideoPlayerDescription>;
  linkedFrom?: Maybe<ComponentVideoPlayerLinkingCollections>;
  showTitleAndDescription?: Maybe<Scalars['Boolean']['output']>;
  showTitleInline?: Maybe<Scalars['Boolean']['output']>;
  smallText?: Maybe<ComponentVideoPlayerSmallText>;
  stillFrameImage?: Maybe<ContentType5OiHchWgV9Y8SuvDxHCaLy>;
  sys: Sys;
  title1?: Maybe<Scalars['String']['output']>;
  title2?: Maybe<Scalars['String']['output']>;
  youTubeVideo?: Maybe<WrapperVideo>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentVideoPlayer) */
export type ComponentVideoPlayerAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentVideoPlayer) */
export type ComponentVideoPlayerBynderVideoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentType5VCz5FHyZ2ZlWqa5OKh6Y9Filter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentVideoPlayer) */
export type ComponentVideoPlayerCtaListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentVideoPlayerCtaListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentVideoPlayer) */
export type ComponentVideoPlayerCtaListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentVideoPlayerCtaListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentVideoPlayer) */
export type ComponentVideoPlayerDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentVideoPlayer) */
export type ComponentVideoPlayerLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentVideoPlayer) */
export type ComponentVideoPlayerShowTitleAndDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentVideoPlayer) */
export type ComponentVideoPlayerShowTitleInlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentVideoPlayer) */
export type ComponentVideoPlayerSmallTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentVideoPlayer) */
export type ComponentVideoPlayerStillFrameImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentVideoPlayer) */
export type ComponentVideoPlayerTitle1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentVideoPlayer) */
export type ComponentVideoPlayerTitle2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/componentVideoPlayer) */
export type ComponentVideoPlayerYouTubeVideoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperVideoFilter>;
};

export type ComponentVideoPlayerCollection = {
  __typename?: 'ComponentVideoPlayerCollection';
  items: Array<Maybe<ComponentVideoPlayer>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComponentVideoPlayerCtaListCollection = {
  __typename?: 'ComponentVideoPlayerCtaListCollection';
  items: Array<Maybe<PackCta>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComponentVideoPlayerCtaListCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export type ComponentVideoPlayerCtaListCursorCollection = {
  __typename?: 'ComponentVideoPlayerCtaListCursorCollection';
  items: Array<Maybe<PackCta>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComponentVideoPlayerCtaListCursorCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export type ComponentVideoPlayerCursorCollection = {
  __typename?: 'ComponentVideoPlayerCursorCollection';
  items: Array<Maybe<ComponentVideoPlayer>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComponentVideoPlayerDescription = {
  __typename?: 'ComponentVideoPlayerDescription';
  json: Scalars['JSON']['output'];
  links: ComponentVideoPlayerDescriptionLinks;
};

export type ComponentVideoPlayerDescriptionAssets = {
  __typename?: 'ComponentVideoPlayerDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComponentVideoPlayerDescriptionEntries = {
  __typename?: 'ComponentVideoPlayerDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComponentVideoPlayerDescriptionLinks = {
  __typename?: 'ComponentVideoPlayerDescriptionLinks';
  assets: ComponentVideoPlayerDescriptionAssets;
  entries: ComponentVideoPlayerDescriptionEntries;
  resources: ComponentVideoPlayerDescriptionResources;
};

export type ComponentVideoPlayerDescriptionResources = {
  __typename?: 'ComponentVideoPlayerDescriptionResources';
  block: Array<ComponentVideoPlayerDescriptionResourcesBlock>;
  hyperlink: Array<ComponentVideoPlayerDescriptionResourcesHyperlink>;
  inline: Array<ComponentVideoPlayerDescriptionResourcesInline>;
};

export type ComponentVideoPlayerDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'ComponentVideoPlayerDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type ComponentVideoPlayerDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'ComponentVideoPlayerDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type ComponentVideoPlayerDescriptionResourcesInline = ResourceLink & {
  __typename?: 'ComponentVideoPlayerDescriptionResourcesInline';
  sys: ResourceSys;
};

export type ComponentVideoPlayerFilter = {
  AND?: InputMaybe<Array<InputMaybe<ComponentVideoPlayerFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ComponentVideoPlayerFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderVideo?: InputMaybe<CfContentType5VCz5FHyZ2ZlWqa5OKh6Y9NestedFilter>;
  bynderVideo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctaList?: InputMaybe<CfPackCtaNestedFilter>;
  ctaListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  showTitleAndDescription?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleAndDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleAndDescription_not?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_not?: InputMaybe<Scalars['Boolean']['input']>;
  smallText_contains?: InputMaybe<Scalars['String']['input']>;
  smallText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  smallText_not_contains?: InputMaybe<Scalars['String']['input']>;
  stillFrameImage?: InputMaybe<CfContentType5OiHchWgV9Y8SuvDxHCaLyNestedFilter>;
  stillFrameImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title1?: InputMaybe<Scalars['String']['input']>;
  title1_contains?: InputMaybe<Scalars['String']['input']>;
  title1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title1_not?: InputMaybe<Scalars['String']['input']>;
  title1_not_contains?: InputMaybe<Scalars['String']['input']>;
  title1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2?: InputMaybe<Scalars['String']['input']>;
  title2_contains?: InputMaybe<Scalars['String']['input']>;
  title2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2_not?: InputMaybe<Scalars['String']['input']>;
  title2_not_contains?: InputMaybe<Scalars['String']['input']>;
  title2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  youTubeVideo?: InputMaybe<CfWrapperVideoNestedFilter>;
  youTubeVideo_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentVideoPlayerLinkingCollections = {
  __typename?: 'ComponentVideoPlayerLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildGenericTemplatePageCollection?: Maybe<BuildGenericTemplatePageCollection>;
  buildGenericTemplatePageCursorCollection?: Maybe<BuildGenericTemplatePageCursorCollection>;
  buildProductDetailPageCollection?: Maybe<BuildProductDetailPageCollection>;
  buildProductDetailPageCursorCollection?: Maybe<BuildProductDetailPageCursorCollection>;
  buildProductOverviewPageCollection?: Maybe<BuildProductOverviewPageCollection>;
  buildProductOverviewPageCursorCollection?: Maybe<BuildProductOverviewPageCursorCollection>;
  buildTariffPageCollection?: Maybe<BuildTariffPageCollection>;
  buildTariffPageCursorCollection?: Maybe<BuildTariffPageCursorCollection>;
  buildWebpageCollection?: Maybe<BuildWebpageCollection>;
  buildWebpageCursorCollection?: Maybe<BuildWebpageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ComponentVideoPlayerLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentVideoPlayerLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentVideoPlayerLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentVideoPlayerLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentVideoPlayerLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentVideoPlayerLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentVideoPlayerLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentVideoPlayerLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentVideoPlayerLinkingCollectionsBuildGenericTemplatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentVideoPlayerLinkingCollectionsBuildGenericTemplatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentVideoPlayerLinkingCollectionsBuildGenericTemplatePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentVideoPlayerLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentVideoPlayerLinkingCollectionsBuildProductDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentVideoPlayerLinkingCollectionsBuildProductDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentVideoPlayerLinkingCollectionsBuildProductDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentVideoPlayerLinkingCollectionsBuildProductDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentVideoPlayerLinkingCollectionsBuildProductOverviewPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentVideoPlayerLinkingCollectionsBuildProductOverviewPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentVideoPlayerLinkingCollectionsBuildProductOverviewPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentVideoPlayerLinkingCollectionsBuildProductOverviewPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentVideoPlayerLinkingCollectionsBuildTariffPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentVideoPlayerLinkingCollectionsBuildTariffPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentVideoPlayerLinkingCollectionsBuildTariffPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentVideoPlayerLinkingCollectionsBuildTariffPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentVideoPlayerLinkingCollectionsBuildWebpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentVideoPlayerLinkingCollectionsBuildWebpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentVideoPlayerLinkingCollectionsBuildWebpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentVideoPlayerLinkingCollectionsBuildWebpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentVideoPlayerLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComponentVideoPlayerLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComponentVideoPlayerLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentVideoPlayerLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentVideoPlayerLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentVideoPlayerLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentVideoPlayerLinkingCollectionsBuildGenericTemplatePageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentVideoPlayerLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentVideoPlayerLinkingCollectionsBuildProductDetailPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentVideoPlayerLinkingCollectionsBuildProductDetailPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentVideoPlayerLinkingCollectionsBuildProductOverviewPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentVideoPlayerLinkingCollectionsBuildProductOverviewPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentVideoPlayerLinkingCollectionsBuildTariffPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentVideoPlayerLinkingCollectionsBuildTariffPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentVideoPlayerLinkingCollectionsBuildWebpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentVideoPlayerLinkingCollectionsBuildWebpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComponentVideoPlayerOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  ShowTitleAndDescriptionAsc = 'showTitleAndDescription_ASC',
  ShowTitleAndDescriptionDesc = 'showTitleAndDescription_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export type ComponentVideoPlayerSmallText = {
  __typename?: 'ComponentVideoPlayerSmallText';
  json: Scalars['JSON']['output'];
  links: ComponentVideoPlayerSmallTextLinks;
};

export type ComponentVideoPlayerSmallTextAssets = {
  __typename?: 'ComponentVideoPlayerSmallTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComponentVideoPlayerSmallTextEntries = {
  __typename?: 'ComponentVideoPlayerSmallTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComponentVideoPlayerSmallTextLinks = {
  __typename?: 'ComponentVideoPlayerSmallTextLinks';
  assets: ComponentVideoPlayerSmallTextAssets;
  entries: ComponentVideoPlayerSmallTextEntries;
  resources: ComponentVideoPlayerSmallTextResources;
};

export type ComponentVideoPlayerSmallTextResources = {
  __typename?: 'ComponentVideoPlayerSmallTextResources';
  block: Array<ComponentVideoPlayerSmallTextResourcesBlock>;
  hyperlink: Array<ComponentVideoPlayerSmallTextResourcesHyperlink>;
  inline: Array<ComponentVideoPlayerSmallTextResourcesInline>;
};

export type ComponentVideoPlayerSmallTextResourcesBlock = ResourceLink & {
  __typename?: 'ComponentVideoPlayerSmallTextResourcesBlock';
  sys: ResourceSys;
};

export type ComponentVideoPlayerSmallTextResourcesHyperlink = ResourceLink & {
  __typename?: 'ComponentVideoPlayerSmallTextResourcesHyperlink';
  sys: ResourceSys;
};

export type ComponentVideoPlayerSmallTextResourcesInline = ResourceLink & {
  __typename?: 'ComponentVideoPlayerSmallTextResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/1ggZsWOlfK2wI0qIH0Pwim) */
export type ContentType1GgZsWOlfK2Wi0QIh0Pwim = Entry & _Node & {
  __typename?: 'ContentType1GgZsWOlfK2WI0QIh0Pwim';
  _id: Scalars['ID']['output'];
  altText?: Maybe<Scalars['String']['output']>;
  bynderDoc?: Maybe<Scalars['JSON']['output']>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<ContentType1GgZsWOlfK2Wi0QIh0PwimLinkingCollections>;
  notes?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/1ggZsWOlfK2wI0qIH0Pwim) */
export type ContentType1GgZsWOlfK2Wi0QIh0PwimAltTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/1ggZsWOlfK2wI0qIH0Pwim) */
export type ContentType1GgZsWOlfK2Wi0QIh0PwimBynderDocArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/1ggZsWOlfK2wI0qIH0Pwim) */
export type ContentType1GgZsWOlfK2Wi0QIh0PwimLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/1ggZsWOlfK2wI0qIH0Pwim) */
export type ContentType1GgZsWOlfK2Wi0QIh0PwimNotesArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/1ggZsWOlfK2wI0qIH0Pwim) */
export type ContentType1GgZsWOlfK2Wi0QIh0PwimSlugArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/1ggZsWOlfK2wI0qIH0Pwim) */
export type ContentType1GgZsWOlfK2Wi0QIh0PwimTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentType1GgZsWOlfK2Wi0QIh0PwimCollection = {
  __typename?: 'ContentType1GgZsWOlfK2WI0QIh0PwimCollection';
  items: Array<Maybe<ContentType1GgZsWOlfK2Wi0QIh0Pwim>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentType1GgZsWOlfK2Wi0QIh0PwimCursorCollection = {
  __typename?: 'ContentType1GgZsWOlfK2WI0QIh0PwimCursorCollection';
  items: Array<Maybe<ContentType1GgZsWOlfK2Wi0QIh0Pwim>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ContentType1GgZsWOlfK2Wi0QIh0PwimFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentType1GgZsWOlfK2Wi0QIh0PwimFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentType1GgZsWOlfK2Wi0QIh0PwimFilter>>>;
  altText?: InputMaybe<Scalars['String']['input']>;
  altText_contains?: InputMaybe<Scalars['String']['input']>;
  altText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  altText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  altText_not?: InputMaybe<Scalars['String']['input']>;
  altText_not_contains?: InputMaybe<Scalars['String']['input']>;
  altText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderDoc_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notes_contains?: InputMaybe<Scalars['String']['input']>;
  notes_exists?: InputMaybe<Scalars['Boolean']['input']>;
  notes_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notes_not?: InputMaybe<Scalars['String']['input']>;
  notes_not_contains?: InputMaybe<Scalars['String']['input']>;
  notes_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentType1GgZsWOlfK2Wi0QIh0PwimLinkingCollections = {
  __typename?: 'ContentType1GgZsWOlfK2WI0QIh0PwimLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ContentType1GgZsWOlfK2Wi0QIh0PwimLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType1GgZsWOlfK2Wi0QIh0PwimLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ContentType1GgZsWOlfK2Wi0QIh0PwimOrder {
  AltTextAsc = 'altText_ASC',
  AltTextDesc = 'altText_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/5oiHCHWgV9y8SuvDxHCaLy) */
export type ContentType5OiHchWgV9Y8SuvDxHCaLy = Entry & _Node & {
  __typename?: 'ContentType5OiHchWgV9Y8SuvDxHCaLy';
  _id: Scalars['ID']['output'];
  altText?: Maybe<Scalars['String']['output']>;
  bynderId?: Maybe<Scalars['String']['output']>;
  bynderImage?: Maybe<Scalars['JSON']['output']>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollections>;
  mobileImage?: Maybe<Scalars['JSON']['output']>;
  netlifyId?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  usageRights?: Maybe<Scalars['String']['output']>;
  useAltText?: Maybe<Scalars['Boolean']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/5oiHCHWgV9y8SuvDxHCaLy) */
export type ContentType5OiHchWgV9Y8SuvDxHCaLyAltTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/5oiHCHWgV9y8SuvDxHCaLy) */
export type ContentType5OiHchWgV9Y8SuvDxHCaLyBynderIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/5oiHCHWgV9y8SuvDxHCaLy) */
export type ContentType5OiHchWgV9Y8SuvDxHCaLyBynderImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/5oiHCHWgV9y8SuvDxHCaLy) */
export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/5oiHCHWgV9y8SuvDxHCaLy) */
export type ContentType5OiHchWgV9Y8SuvDxHCaLyMobileImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/5oiHCHWgV9y8SuvDxHCaLy) */
export type ContentType5OiHchWgV9Y8SuvDxHCaLyNetlifyIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/5oiHCHWgV9y8SuvDxHCaLy) */
export type ContentType5OiHchWgV9Y8SuvDxHCaLySlugArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/5oiHCHWgV9y8SuvDxHCaLy) */
export type ContentType5OiHchWgV9Y8SuvDxHCaLyTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/5oiHCHWgV9y8SuvDxHCaLy) */
export type ContentType5OiHchWgV9Y8SuvDxHCaLyUsageRightsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/5oiHCHWgV9y8SuvDxHCaLy) */
export type ContentType5OiHchWgV9Y8SuvDxHCaLyUseAltTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentType5OiHchWgV9Y8SuvDxHCaLyCollection = {
  __typename?: 'ContentType5OiHchWgV9Y8SuvDxHCaLyCollection';
  items: Array<Maybe<ContentType5OiHchWgV9Y8SuvDxHCaLy>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentType5OiHchWgV9Y8SuvDxHCaLyCursorCollection = {
  __typename?: 'ContentType5OiHchWgV9Y8SuvDxHCaLyCursorCollection';
  items: Array<Maybe<ContentType5OiHchWgV9Y8SuvDxHCaLy>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ContentType5OiHchWgV9Y8SuvDxHCaLyFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyFilter>>>;
  altText?: InputMaybe<Scalars['String']['input']>;
  altText_contains?: InputMaybe<Scalars['String']['input']>;
  altText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  altText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  altText_not?: InputMaybe<Scalars['String']['input']>;
  altText_not_contains?: InputMaybe<Scalars['String']['input']>;
  altText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderId?: InputMaybe<Scalars['String']['input']>;
  bynderId_contains?: InputMaybe<Scalars['String']['input']>;
  bynderId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bynderId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderId_not?: InputMaybe<Scalars['String']['input']>;
  bynderId_not_contains?: InputMaybe<Scalars['String']['input']>;
  bynderId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  mobileImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  netlifyId?: InputMaybe<Scalars['String']['input']>;
  netlifyId_contains?: InputMaybe<Scalars['String']['input']>;
  netlifyId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  netlifyId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  netlifyId_not?: InputMaybe<Scalars['String']['input']>;
  netlifyId_not_contains?: InputMaybe<Scalars['String']['input']>;
  netlifyId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  usageRights?: InputMaybe<Scalars['String']['input']>;
  usageRights_contains?: InputMaybe<Scalars['String']['input']>;
  usageRights_exists?: InputMaybe<Scalars['Boolean']['input']>;
  usageRights_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  usageRights_not?: InputMaybe<Scalars['String']['input']>;
  usageRights_not_contains?: InputMaybe<Scalars['String']['input']>;
  usageRights_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  useAltText?: InputMaybe<Scalars['Boolean']['input']>;
  useAltText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useAltText_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollections = {
  __typename?: 'ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollections';
  componentBlockCardCollection?: Maybe<ComponentBlockCardCollection>;
  componentBlockCardCursorCollection?: Maybe<ComponentBlockCardCursorCollection>;
  componentCardCollection?: Maybe<ComponentCardCollection>;
  componentCardCursorCollection?: Maybe<ComponentCardCursorCollection>;
  componentCarouselCardCollection?: Maybe<ComponentCarouselCardCollection>;
  componentCarouselCardCursorCollection?: Maybe<ComponentCarouselCardCursorCollection>;
  componentContentBlockV2Collection?: Maybe<ComponentContentBlockV2Collection>;
  componentContentBlockV2CursorCollection?: Maybe<ComponentContentBlockV2CursorCollection>;
  componentDetailInfoSectionCollection?: Maybe<ComponentDetailInfoSectionCollection>;
  componentDetailInfoSectionCursorCollection?: Maybe<ComponentDetailInfoSectionCursorCollection>;
  componentGuideCardCollection?: Maybe<ComponentGuideCardCollection>;
  componentGuideCardCursorCollection?: Maybe<ComponentGuideCardCursorCollection>;
  componentHomepageHeroPostcodeSectionCollection?: Maybe<ComponentHomepageHeroPostcodeSectionCollection>;
  componentHomepageHeroPostcodeSectionCursorCollection?: Maybe<ComponentHomepageHeroPostcodeSectionCursorCollection>;
  componentImageGalleryCollection?: Maybe<ComponentImageGalleryCollection>;
  componentImageGalleryCursorCollection?: Maybe<ComponentImageGalleryCursorCollection>;
  componentImageWithDescriptionCollection?: Maybe<ComponentImageWithDescriptionCollection>;
  componentImageWithDescriptionCursorCollection?: Maybe<ComponentImageWithDescriptionCursorCollection>;
  componentInfoCardCollection?: Maybe<ComponentInfoCardCollection>;
  componentInfoCardCursorCollection?: Maybe<ComponentInfoCardCursorCollection>;
  componentLogoGroupCollection?: Maybe<ComponentLogoGroupCollection>;
  componentLogoGroupCursorCollection?: Maybe<ComponentLogoGroupCursorCollection>;
  componentProductFeaturedCardCollection?: Maybe<ComponentProductFeaturedCardCollection>;
  componentProductFeaturedCardCursorCollection?: Maybe<ComponentProductFeaturedCardCursorCollection>;
  componentProductModuleCollection?: Maybe<ComponentProductModuleCollection>;
  componentProductModuleCursorCollection?: Maybe<ComponentProductModuleCursorCollection>;
  componentPromoSectionCollection?: Maybe<ComponentPromoSectionCollection>;
  componentPromoSectionCursorCollection?: Maybe<ComponentPromoSectionCursorCollection>;
  componentQrCodePopupCollection?: Maybe<ComponentQrCodePopupCollection>;
  componentQrCodePopupCursorCollection?: Maybe<ComponentQrCodePopupCursorCollection>;
  componentSpotlightCollection?: Maybe<ComponentSpotlightCollection>;
  componentSpotlightCursorCollection?: Maybe<ComponentSpotlightCursorCollection>;
  componentTariffHeroCollection?: Maybe<ComponentTariffHeroCollection>;
  componentTariffHeroCursorCollection?: Maybe<ComponentTariffHeroCursorCollection>;
  componentUspCardCollection?: Maybe<ComponentUspCardCollection>;
  componentUspCardCursorCollection?: Maybe<ComponentUspCardCursorCollection>;
  componentVideoPlayerCollection?: Maybe<ComponentVideoPlayerCollection>;
  componentVideoPlayerCursorCollection?: Maybe<ComponentVideoPlayerCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  packArticlePageCollection?: Maybe<PackArticlePageCollection>;
  packArticlePageCursorCollection?: Maybe<PackArticlePageCursorCollection>;
  packCampaignPageCollection?: Maybe<PackCampaignPageCollection>;
  packCampaignPageCursorCollection?: Maybe<PackCampaignPageCursorCollection>;
  packHomePageCollection?: Maybe<PackHomePageCollection>;
  packHomePageCursorCollection?: Maybe<PackHomePageCursorCollection>;
  packPageStandardCollection?: Maybe<PackPageStandardCollection>;
  packPageStandardCursorCollection?: Maybe<PackPageStandardCursorCollection>;
  packPageStandardV2Collection?: Maybe<PackPageStandardV2Collection>;
  packPageStandardV2CursorCollection?: Maybe<PackPageStandardV2CursorCollection>;
  promoCardCollection?: Maybe<PromoCardCollection>;
  promoCardCursorCollection?: Maybe<PromoCardCursorCollection>;
  wrapperImageCollection?: Maybe<WrapperImageCollection>;
  wrapperImageCursorCollection?: Maybe<WrapperImageCursorCollection>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentBlockCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentBlockCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentBlockCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentBlockCardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentCardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentCarouselCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentCarouselCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentCarouselCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentCarouselCardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentContentBlockV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentContentBlockV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentContentBlockV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentContentBlockV2CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentDetailInfoSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentDetailInfoSectionCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentDetailInfoSectionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentDetailInfoSectionCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentGuideCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentGuideCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentGuideCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentGuideCardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentHomepageHeroPostcodeSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentHomepageHeroPostcodeSectionCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentHomepageHeroPostcodeSectionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentHomepageHeroPostcodeSectionCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentImageGalleryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentImageGalleryCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentImageGalleryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentImageGalleryCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentImageWithDescriptionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentImageWithDescriptionCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentImageWithDescriptionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentImageWithDescriptionCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentInfoCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentInfoCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentInfoCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentInfoCardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentLogoGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentLogoGroupCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentLogoGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentLogoGroupCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentProductFeaturedCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentProductFeaturedCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentProductFeaturedCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentProductFeaturedCardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentProductModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentProductModuleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentProductModuleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentProductModuleCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentPromoSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentPromoSectionCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentPromoSectionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentPromoSectionCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentQrCodePopupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentQrCodePopupCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentQrCodePopupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentQrCodePopupCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentSpotlightCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentSpotlightCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentSpotlightCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentSpotlightCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentTariffHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentTariffHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentTariffHeroCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentTariffHeroCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentUspCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentUspCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentUspCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentUspCardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentVideoPlayerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentVideoPlayerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentVideoPlayerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentVideoPlayerCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsPackArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsPackArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsPackArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsPackArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsPackCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsPackCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsPackCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsPackCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsPackHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsPackHomePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsPackHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsPackHomePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsPackPageStandardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsPackPageStandardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsPackPageStandardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsPackPageStandardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsPackPageStandardV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsPackPageStandardV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsPackPageStandardV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsPackPageStandardV2CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsPromoCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsPromoCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsPromoCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsPromoCardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsWrapperImageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsWrapperImageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsWrapperImageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsWrapperImageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentBlockCardCollectionOrder {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentBlockCardCursorCollectionOrder {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentCardCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  ShortTextAsc = 'shortText_ASC',
  ShortTextDesc = 'shortText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentCardCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  ShortTextAsc = 'shortText_ASC',
  ShortTextDesc = 'shortText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentCarouselCardCollectionOrder {
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  CardTabLabelAsc = 'cardTabLabel_ASC',
  CardTabLabelDesc = 'cardTabLabel_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleText1Asc = 'titleText1_ASC',
  TitleText1Desc = 'titleText1_DESC',
  TitleText2Asc = 'titleText2_ASC',
  TitleText2Desc = 'titleText2_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentCarouselCardCursorCollectionOrder {
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  CardTabLabelAsc = 'cardTabLabel_ASC',
  CardTabLabelDesc = 'cardTabLabel_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleText1Asc = 'titleText1_ASC',
  TitleText1Desc = 'titleText1_DESC',
  TitleText2Asc = 'titleText2_ASC',
  TitleText2Desc = 'titleText2_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentContentBlockV2CollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  HeaderLevelAsc = 'headerLevel_ASC',
  HeaderLevelDesc = 'headerLevel_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MediaPositionAsc = 'mediaPosition_ASC',
  MediaPositionDesc = 'mediaPosition_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAlignmentAsc = 'textAlignment_ASC',
  TextAlignmentDesc = 'textAlignment_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentContentBlockV2CursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  HeaderLevelAsc = 'headerLevel_ASC',
  HeaderLevelDesc = 'headerLevel_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MediaPositionAsc = 'mediaPosition_ASC',
  MediaPositionDesc = 'mediaPosition_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAlignmentAsc = 'textAlignment_ASC',
  TextAlignmentDesc = 'textAlignment_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentDetailInfoSectionCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC',
  TitlePart1Asc = 'titlePart1_ASC',
  TitlePart1Desc = 'titlePart1_DESC',
  TitlePart2Asc = 'titlePart2_ASC',
  TitlePart2Desc = 'titlePart2_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentDetailInfoSectionCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC',
  TitlePart1Asc = 'titlePart1_ASC',
  TitlePart1Desc = 'titlePart1_DESC',
  TitlePart2Asc = 'titlePart2_ASC',
  TitlePart2Desc = 'titlePart2_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentGuideCardCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentGuideCardCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentHomepageHeroPostcodeSectionCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentHomepageHeroPostcodeSectionCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentImageGalleryCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  ImageAspectRatioAsc = 'imageAspectRatio_ASC',
  ImageAspectRatioDesc = 'imageAspectRatio_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentImageGalleryCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  ImageAspectRatioAsc = 'imageAspectRatio_ASC',
  ImageAspectRatioDesc = 'imageAspectRatio_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentImageWithDescriptionCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  ContentOrientationAsc = 'contentOrientation_ASC',
  ContentOrientationDesc = 'contentOrientation_DESC',
  ImageAspectRatioAsc = 'imageAspectRatio_ASC',
  ImageAspectRatioDesc = 'imageAspectRatio_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentImageWithDescriptionCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  ContentOrientationAsc = 'contentOrientation_ASC',
  ContentOrientationDesc = 'contentOrientation_DESC',
  ImageAspectRatioAsc = 'imageAspectRatio_ASC',
  ImageAspectRatioDesc = 'imageAspectRatio_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentInfoCardCollectionOrder {
  DestinationLabelAsc = 'destinationLabel_ASC',
  DestinationLabelDesc = 'destinationLabel_DESC',
  IsExternalLinkAsc = 'isExternalLink_ASC',
  IsExternalLinkDesc = 'isExternalLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentInfoCardCursorCollectionOrder {
  DestinationLabelAsc = 'destinationLabel_ASC',
  DestinationLabelDesc = 'destinationLabel_DESC',
  IsExternalLinkAsc = 'isExternalLink_ASC',
  IsExternalLinkDesc = 'isExternalLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentLogoGroupCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentLogoGroupCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentProductFeaturedCardCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentProductFeaturedCardCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentProductModuleCollectionOrder {
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentProductModuleCursorCollectionOrder {
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentPromoSectionCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  ContentOrientationAsc = 'contentOrientation_ASC',
  ContentOrientationDesc = 'contentOrientation_DESC',
  CtaLabelAsc = 'ctaLabel_ASC',
  CtaLabelDesc = 'ctaLabel_DESC',
  HasPostalCodeAsc = 'hasPostalCode_ASC',
  HasPostalCodeDesc = 'hasPostalCode_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentPromoSectionCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  ContentOrientationAsc = 'contentOrientation_ASC',
  ContentOrientationDesc = 'contentOrientation_DESC',
  CtaLabelAsc = 'ctaLabel_ASC',
  CtaLabelDesc = 'ctaLabel_DESC',
  HasPostalCodeAsc = 'hasPostalCode_ASC',
  HasPostalCodeDesc = 'hasPostalCode_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentQrCodePopupCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentQrCodePopupCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentSpotlightCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentSpotlightCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentTariffHeroCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  PostcodeFinderInputFieldTextAsc = 'postcodeFinderInputFieldText_ASC',
  PostcodeFinderInputFieldTextDesc = 'postcodeFinderInputFieldText_DESC',
  ShowPostcodeFinderAsc = 'showPostcodeFinder_ASC',
  ShowPostcodeFinderDesc = 'showPostcodeFinder_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentTariffHeroCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  PostcodeFinderInputFieldTextAsc = 'postcodeFinderInputFieldText_ASC',
  PostcodeFinderInputFieldTextDesc = 'postcodeFinderInputFieldText_DESC',
  ShowPostcodeFinderAsc = 'showPostcodeFinder_ASC',
  ShowPostcodeFinderDesc = 'showPostcodeFinder_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentUspCardCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentUspCardCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentVideoPlayerCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  ShowTitleAndDescriptionAsc = 'showTitleAndDescription_ASC',
  ShowTitleAndDescriptionDesc = 'showTitleAndDescription_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsComponentVideoPlayerCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  ShowTitleAndDescriptionAsc = 'showTitleAndDescription_ASC',
  ShowTitleAndDescriptionDesc = 'showTitleAndDescription_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsPackArticlePageCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  ShareLinkAsc = 'shareLink_ASC',
  ShareLinkDesc = 'shareLink_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsPackArticlePageCursorCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  ShareLinkAsc = 'shareLink_ASC',
  ShareLinkDesc = 'shareLink_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsPackCampaignPageCollectionOrder {
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  HasGradientAsc = 'hasGradient_ASC',
  HasGradientDesc = 'hasGradient_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  HeroTextPositionAsc = 'heroTextPosition_ASC',
  HeroTextPositionDesc = 'heroTextPosition_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsPackCampaignPageCursorCollectionOrder {
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  HasGradientAsc = 'hasGradient_ASC',
  HasGradientDesc = 'hasGradient_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  HeroTextPositionAsc = 'heroTextPosition_ASC',
  HeroTextPositionDesc = 'heroTextPosition_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsPackHomePageCollectionOrder {
  ComponentVariantAsc = 'componentVariant_ASC',
  ComponentVariantDesc = 'componentVariant_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TrustpilotBannerAsc = 'trustpilotBanner_ASC',
  TrustpilotBannerDesc = 'trustpilotBanner_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsPackHomePageCursorCollectionOrder {
  ComponentVariantAsc = 'componentVariant_ASC',
  ComponentVariantDesc = 'componentVariant_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TrustpilotBannerAsc = 'trustpilotBanner_ASC',
  TrustpilotBannerDesc = 'trustpilotBanner_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsPackPageStandardCollectionOrder {
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsPackPageStandardCursorCollectionOrder {
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsPackPageStandardV2CollectionOrder {
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsPackPageStandardV2CursorCollectionOrder {
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsPromoCardCollectionOrder {
  CtaVariantAsc = 'ctaVariant_ASC',
  CtaVariantDesc = 'ctaVariant_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC',
  TitlePositionAsc = 'titlePosition_ASC',
  TitlePositionDesc = 'titlePosition_DESC',
  TitleVariantAsc = 'titleVariant_ASC',
  TitleVariantDesc = 'titleVariant_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsPromoCardCursorCollectionOrder {
  CtaVariantAsc = 'ctaVariant_ASC',
  CtaVariantDesc = 'ctaVariant_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC',
  TitlePositionAsc = 'titlePosition_ASC',
  TitlePositionDesc = 'titlePosition_DESC',
  TitleVariantAsc = 'titleVariant_ASC',
  TitleVariantDesc = 'titleVariant_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsWrapperImageCollectionOrder {
  AltTextAsc = 'altText_ASC',
  AltTextDesc = 'altText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UseAltTextAsc = 'useAltText_ASC',
  UseAltTextDesc = 'useAltText_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyLinkingCollectionsWrapperImageCursorCollectionOrder {
  AltTextAsc = 'altText_ASC',
  AltTextDesc = 'altText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UseAltTextAsc = 'useAltText_ASC',
  UseAltTextDesc = 'useAltText_DESC'
}

export enum ContentType5OiHchWgV9Y8SuvDxHCaLyOrder {
  AltTextAsc = 'altText_ASC',
  AltTextDesc = 'altText_DESC',
  BynderIdAsc = 'bynderId_ASC',
  BynderIdDesc = 'bynderId_DESC',
  NetlifyIdAsc = 'netlifyId_ASC',
  NetlifyIdDesc = 'netlifyId_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UsageRightsAsc = 'usageRights_ASC',
  UsageRightsDesc = 'usageRights_DESC',
  UseAltTextAsc = 'useAltText_ASC',
  UseAltTextDesc = 'useAltText_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/5vCZ5FHyZ2zlWqa5oKH6y9) */
export type ContentType5VCz5FHyZ2ZlWqa5OKh6Y9 = Entry & _Node & {
  __typename?: 'ContentType5VCz5FHyZ2ZlWqa5OKh6Y9';
  _id: Scalars['ID']['output'];
  altText?: Maybe<Scalars['String']['output']>;
  bynderId?: Maybe<Scalars['String']['output']>;
  bynderVideo?: Maybe<Scalars['JSON']['output']>;
  contentfulMetadata: ContentfulMetadata;
  hasGradient?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollections>;
  mobileVideo?: Maybe<Scalars['JSON']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/5vCZ5FHyZ2zlWqa5oKH6y9) */
export type ContentType5VCz5FHyZ2ZlWqa5OKh6Y9AltTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/5vCZ5FHyZ2zlWqa5oKH6y9) */
export type ContentType5VCz5FHyZ2ZlWqa5OKh6Y9BynderIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/5vCZ5FHyZ2zlWqa5oKH6y9) */
export type ContentType5VCz5FHyZ2ZlWqa5OKh6Y9BynderVideoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/5vCZ5FHyZ2zlWqa5oKH6y9) */
export type ContentType5VCz5FHyZ2ZlWqa5OKh6Y9HasGradientArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/5vCZ5FHyZ2zlWqa5oKH6y9) */
export type ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/5vCZ5FHyZ2zlWqa5oKH6y9) */
export type ContentType5VCz5FHyZ2ZlWqa5OKh6Y9MobileVideoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/5vCZ5FHyZ2zlWqa5oKH6y9) */
export type ContentType5VCz5FHyZ2ZlWqa5OKh6Y9NotesArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/5vCZ5FHyZ2zlWqa5oKH6y9) */
export type ContentType5VCz5FHyZ2ZlWqa5OKh6Y9SlugArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/5vCZ5FHyZ2zlWqa5oKH6y9) */
export type ContentType5VCz5FHyZ2ZlWqa5OKh6Y9TitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentType5VCz5FHyZ2ZlWqa5OKh6Y9Collection = {
  __typename?: 'ContentType5VCz5FHyZ2ZlWqa5OKh6Y9Collection';
  items: Array<Maybe<ContentType5VCz5FHyZ2ZlWqa5OKh6Y9>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentType5VCz5FHyZ2ZlWqa5OKh6Y9CursorCollection = {
  __typename?: 'ContentType5VCz5FHyZ2ZlWqa5OKh6Y9CursorCollection';
  items: Array<Maybe<ContentType5VCz5FHyZ2ZlWqa5OKh6Y9>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ContentType5VCz5FHyZ2ZlWqa5OKh6Y9Filter = {
  AND?: InputMaybe<Array<InputMaybe<ContentType5VCz5FHyZ2ZlWqa5OKh6Y9Filter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentType5VCz5FHyZ2ZlWqa5OKh6Y9Filter>>>;
  altText?: InputMaybe<Scalars['String']['input']>;
  altText_contains?: InputMaybe<Scalars['String']['input']>;
  altText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  altText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  altText_not?: InputMaybe<Scalars['String']['input']>;
  altText_not_contains?: InputMaybe<Scalars['String']['input']>;
  altText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderId?: InputMaybe<Scalars['String']['input']>;
  bynderId_contains?: InputMaybe<Scalars['String']['input']>;
  bynderId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bynderId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderId_not?: InputMaybe<Scalars['String']['input']>;
  bynderId_not_contains?: InputMaybe<Scalars['String']['input']>;
  bynderId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderVideo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  hasGradient?: InputMaybe<Scalars['Boolean']['input']>;
  hasGradient_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hasGradient_not?: InputMaybe<Scalars['Boolean']['input']>;
  mobileVideo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notes_contains?: InputMaybe<Scalars['String']['input']>;
  notes_exists?: InputMaybe<Scalars['Boolean']['input']>;
  notes_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notes_not?: InputMaybe<Scalars['String']['input']>;
  notes_not_contains?: InputMaybe<Scalars['String']['input']>;
  notes_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollections = {
  __typename?: 'ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollections';
  componentCarouselCardCollection?: Maybe<ComponentCarouselCardCollection>;
  componentCarouselCardCursorCollection?: Maybe<ComponentCarouselCardCursorCollection>;
  componentContentBlockV2Collection?: Maybe<ComponentContentBlockV2Collection>;
  componentContentBlockV2CursorCollection?: Maybe<ComponentContentBlockV2CursorCollection>;
  componentHomepageHeroPostcodeSectionCollection?: Maybe<ComponentHomepageHeroPostcodeSectionCollection>;
  componentHomepageHeroPostcodeSectionCursorCollection?: Maybe<ComponentHomepageHeroPostcodeSectionCursorCollection>;
  componentVideoPlayerCollection?: Maybe<ComponentVideoPlayerCollection>;
  componentVideoPlayerCursorCollection?: Maybe<ComponentVideoPlayerCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  packArticlePageCollection?: Maybe<PackArticlePageCollection>;
  packArticlePageCursorCollection?: Maybe<PackArticlePageCursorCollection>;
  packCampaignPageCollection?: Maybe<PackCampaignPageCollection>;
  packCampaignPageCursorCollection?: Maybe<PackCampaignPageCursorCollection>;
  packHomePageCollection?: Maybe<PackHomePageCollection>;
  packHomePageCursorCollection?: Maybe<PackHomePageCursorCollection>;
  packPageStandardCollection?: Maybe<PackPageStandardCollection>;
  packPageStandardCursorCollection?: Maybe<PackPageStandardCursorCollection>;
  packPageStandardV2Collection?: Maybe<PackPageStandardV2Collection>;
  packPageStandardV2CursorCollection?: Maybe<PackPageStandardV2CursorCollection>;
};


export type ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsComponentCarouselCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsComponentCarouselCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsComponentCarouselCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsComponentCarouselCardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsComponentContentBlockV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsComponentContentBlockV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsComponentContentBlockV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsComponentContentBlockV2CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsComponentHomepageHeroPostcodeSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsComponentHomepageHeroPostcodeSectionCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsComponentHomepageHeroPostcodeSectionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsComponentHomepageHeroPostcodeSectionCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsComponentVideoPlayerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsComponentVideoPlayerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsComponentVideoPlayerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsComponentVideoPlayerCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsPackArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsPackArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsPackArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsPackArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsPackCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsPackCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsPackCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsPackCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsPackHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsPackHomePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsPackHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsPackHomePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsPackPageStandardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsPackPageStandardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsPackPageStandardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsPackPageStandardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsPackPageStandardV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsPackPageStandardV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsPackPageStandardV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsPackPageStandardV2CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsComponentCarouselCardCollectionOrder {
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  CardTabLabelAsc = 'cardTabLabel_ASC',
  CardTabLabelDesc = 'cardTabLabel_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleText1Asc = 'titleText1_ASC',
  TitleText1Desc = 'titleText1_DESC',
  TitleText2Asc = 'titleText2_ASC',
  TitleText2Desc = 'titleText2_DESC'
}

export enum ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsComponentCarouselCardCursorCollectionOrder {
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  CardTabLabelAsc = 'cardTabLabel_ASC',
  CardTabLabelDesc = 'cardTabLabel_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleText1Asc = 'titleText1_ASC',
  TitleText1Desc = 'titleText1_DESC',
  TitleText2Asc = 'titleText2_ASC',
  TitleText2Desc = 'titleText2_DESC'
}

export enum ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsComponentContentBlockV2CollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  HeaderLevelAsc = 'headerLevel_ASC',
  HeaderLevelDesc = 'headerLevel_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MediaPositionAsc = 'mediaPosition_ASC',
  MediaPositionDesc = 'mediaPosition_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAlignmentAsc = 'textAlignment_ASC',
  TextAlignmentDesc = 'textAlignment_DESC'
}

export enum ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsComponentContentBlockV2CursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  HeaderLevelAsc = 'headerLevel_ASC',
  HeaderLevelDesc = 'headerLevel_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MediaPositionAsc = 'mediaPosition_ASC',
  MediaPositionDesc = 'mediaPosition_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAlignmentAsc = 'textAlignment_ASC',
  TextAlignmentDesc = 'textAlignment_DESC'
}

export enum ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsComponentHomepageHeroPostcodeSectionCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsComponentHomepageHeroPostcodeSectionCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsComponentVideoPlayerCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  ShowTitleAndDescriptionAsc = 'showTitleAndDescription_ASC',
  ShowTitleAndDescriptionDesc = 'showTitleAndDescription_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export enum ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsComponentVideoPlayerCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  ShowTitleAndDescriptionAsc = 'showTitleAndDescription_ASC',
  ShowTitleAndDescriptionDesc = 'showTitleAndDescription_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export enum ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsPackArticlePageCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  ShareLinkAsc = 'shareLink_ASC',
  ShareLinkDesc = 'shareLink_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsPackArticlePageCursorCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  ShareLinkAsc = 'shareLink_ASC',
  ShareLinkDesc = 'shareLink_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsPackCampaignPageCollectionOrder {
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  HasGradientAsc = 'hasGradient_ASC',
  HasGradientDesc = 'hasGradient_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  HeroTextPositionAsc = 'heroTextPosition_ASC',
  HeroTextPositionDesc = 'heroTextPosition_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC'
}

export enum ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsPackCampaignPageCursorCollectionOrder {
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  HasGradientAsc = 'hasGradient_ASC',
  HasGradientDesc = 'hasGradient_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  HeroTextPositionAsc = 'heroTextPosition_ASC',
  HeroTextPositionDesc = 'heroTextPosition_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC'
}

export enum ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsPackHomePageCollectionOrder {
  ComponentVariantAsc = 'componentVariant_ASC',
  ComponentVariantDesc = 'componentVariant_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TrustpilotBannerAsc = 'trustpilotBanner_ASC',
  TrustpilotBannerDesc = 'trustpilotBanner_DESC'
}

export enum ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsPackHomePageCursorCollectionOrder {
  ComponentVariantAsc = 'componentVariant_ASC',
  ComponentVariantDesc = 'componentVariant_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TrustpilotBannerAsc = 'trustpilotBanner_ASC',
  TrustpilotBannerDesc = 'trustpilotBanner_DESC'
}

export enum ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsPackPageStandardCollectionOrder {
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsPackPageStandardCursorCollectionOrder {
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsPackPageStandardV2CollectionOrder {
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ContentType5VCz5FHyZ2ZlWqa5OKh6Y9LinkingCollectionsPackPageStandardV2CursorCollectionOrder {
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ContentType5VCz5FHyZ2ZlWqa5OKh6Y9Order {
  AltTextAsc = 'altText_ASC',
  AltTextDesc = 'altText_DESC',
  BynderIdAsc = 'bynderId_ASC',
  BynderIdDesc = 'bynderId_DESC',
  HasGradientAsc = 'hasGradient_ASC',
  HasGradientDesc = 'hasGradient_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ContentfulMetadata = {
  __typename?: 'ContentfulMetadata';
  concepts: Array<Maybe<TaxonomyConcept>>;
  tags: Array<Maybe<ContentfulTag>>;
};

export type ContentfulMetadataConceptsDescendantsFilter = {
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulMetadataConceptsFilter = {
  descendants?: InputMaybe<ContentfulMetadataConceptsDescendantsFilter>;
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulMetadataFilter = {
  concepts?: InputMaybe<ContentfulMetadataConceptsFilter>;
  concepts_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<ContentfulMetadataTagsFilter>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulMetadataTagsFilter = {
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/**
 * Represents a tag entity for finding and organizing content easily.
 *       Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-tags
 */
export type ContentfulTag = {
  __typename?: 'ContentfulTag';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CursorPages = {
  __typename?: 'CursorPages';
  next?: Maybe<Scalars['String']['output']>;
  prev?: Maybe<Scalars['String']['output']>;
};

export type Entry = {
  contentfulMetadata: ContentfulMetadata;
  sys: Sys;
};

export type EntryCollection = {
  __typename?: 'EntryCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type EntryCursorCollection = {
  __typename?: 'EntryCursorCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type EntryFilter = {
  AND?: InputMaybe<Array<InputMaybe<EntryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<EntryFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export enum EntryOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ImageFormat {
  /** AVIF image format. */
  Avif = 'AVIF',
  /** JPG image format. */
  Jpg = 'JPG',
  /**
   * Progressive JPG format stores multiple passes of an image in progressively higher detail.
   *         When a progressive image is loading, the viewer will first see a lower quality pixelated version which
   *         will gradually improve in detail, until the image is fully downloaded. This is to display an image as
   *         early as possible to make the layout look as designed.
   */
  JpgProgressive = 'JPG_PROGRESSIVE',
  /** PNG image format */
  Png = 'PNG',
  /**
   * 8-bit PNG images support up to 256 colors and weigh less than the standard 24-bit PNG equivalent.
   *         The 8-bit PNG format is mostly used for simple images, such as icons or logos.
   */
  Png8 = 'PNG8',
  /** WebP image format. */
  Webp = 'WEBP'
}

export enum ImageResizeFocus {
  /** Focus the resizing on the bottom. */
  Bottom = 'BOTTOM',
  /** Focus the resizing on the bottom left. */
  BottomLeft = 'BOTTOM_LEFT',
  /** Focus the resizing on the bottom right. */
  BottomRight = 'BOTTOM_RIGHT',
  /** Focus the resizing on the center. */
  Center = 'CENTER',
  /** Focus the resizing on the largest face. */
  Face = 'FACE',
  /** Focus the resizing on the area containing all the faces. */
  Faces = 'FACES',
  /** Focus the resizing on the left. */
  Left = 'LEFT',
  /** Focus the resizing on the right. */
  Right = 'RIGHT',
  /** Focus the resizing on the top. */
  Top = 'TOP',
  /** Focus the resizing on the top left. */
  TopLeft = 'TOP_LEFT',
  /** Focus the resizing on the top right. */
  TopRight = 'TOP_RIGHT'
}

export enum ImageResizeStrategy {
  /** Crops a part of the original image to fit into the specified dimensions. */
  Crop = 'CROP',
  /** Resizes the image to the specified dimensions, cropping the image if needed. */
  Fill = 'FILL',
  /** Resizes the image to fit into the specified dimensions. */
  Fit = 'FIT',
  /**
   * Resizes the image to the specified dimensions, padding the image if needed.
   *         Uses desired background color as padding color.
   */
  Pad = 'PAD',
  /** Resizes the image to the specified dimensions, changing the original aspect ratio if needed. */
  Scale = 'SCALE',
  /** Creates a thumbnail from the image. */
  Thumb = 'THUMB'
}

export type ImageTransformOptions = {
  /**
   * Desired background color, used with corner radius or `PAD` resize strategy.
   *         Defaults to transparent (for `PNG`, `PNG8` and `WEBP`) or white (for `JPG` and `JPG_PROGRESSIVE`).
   */
  backgroundColor?: InputMaybe<Scalars['HexColor']['input']>;
  /**
   * Desired corner radius in pixels.
   *         Results in an image with rounded corners (pass `-1` for a full circle/ellipse).
   *         Defaults to `0`. Uses desired background color as padding color,
   *         unless the format is `JPG` or `JPG_PROGRESSIVE` and resize strategy is `PAD`, then defaults to white.
   */
  cornerRadius?: InputMaybe<Scalars['Int']['input']>;
  /** Desired image format. Defaults to the original image format. */
  format?: InputMaybe<ImageFormat>;
  /** Desired height in pixels. Defaults to the original image height. */
  height?: InputMaybe<Scalars['Dimension']['input']>;
  /**
   * Desired quality of the image in percents.
   *         Used for `PNG8`, `JPG`, `JPG_PROGRESSIVE` and `WEBP` formats.
   */
  quality?: InputMaybe<Scalars['Quality']['input']>;
  /** Desired resize focus area. Defaults to `CENTER`. */
  resizeFocus?: InputMaybe<ImageResizeFocus>;
  /** Desired resize strategy. Defaults to `FIT`. */
  resizeStrategy?: InputMaybe<ImageResizeStrategy>;
  /** Desired width in pixels. Defaults to the original image width. */
  width?: InputMaybe<Scalars['Dimension']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/integrationOptimizelyFlag) */
export type IntegrationOptimizelyFlag = Entry & _Node & {
  __typename?: 'IntegrationOptimizelyFlag';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  identifier?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<IntegrationOptimizelyFlagLinkingCollections>;
  rulesCollection?: Maybe<IntegrationOptimizelyFlagRulesCollection>;
  rulesCursorCollection?: Maybe<IntegrationOptimizelyFlagRulesCursorCollection>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/integrationOptimizelyFlag) */
export type IntegrationOptimizelyFlagIdentifierArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/integrationOptimizelyFlag) */
export type IntegrationOptimizelyFlagLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/integrationOptimizelyFlag) */
export type IntegrationOptimizelyFlagRulesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<IntegrationOptimizelyFlagRulesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<IntegrationOptimizelyFlagRuleFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/integrationOptimizelyFlag) */
export type IntegrationOptimizelyFlagRulesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<IntegrationOptimizelyFlagRulesCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<IntegrationOptimizelyFlagRuleFilter>;
};

export type IntegrationOptimizelyFlagCollection = {
  __typename?: 'IntegrationOptimizelyFlagCollection';
  items: Array<Maybe<IntegrationOptimizelyFlag>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type IntegrationOptimizelyFlagCursorCollection = {
  __typename?: 'IntegrationOptimizelyFlagCursorCollection';
  items: Array<Maybe<IntegrationOptimizelyFlag>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type IntegrationOptimizelyFlagFilter = {
  AND?: InputMaybe<Array<InputMaybe<IntegrationOptimizelyFlagFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<IntegrationOptimizelyFlagFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  identifier_contains?: InputMaybe<Scalars['String']['input']>;
  identifier_exists?: InputMaybe<Scalars['Boolean']['input']>;
  identifier_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  identifier_not?: InputMaybe<Scalars['String']['input']>;
  identifier_not_contains?: InputMaybe<Scalars['String']['input']>;
  identifier_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rules?: InputMaybe<CfIntegrationOptimizelyFlagRuleNestedFilter>;
  rulesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type IntegrationOptimizelyFlagLinkingCollections = {
  __typename?: 'IntegrationOptimizelyFlagLinkingCollections';
  buildRecommendedContentCollection?: Maybe<BuildRecommendedContentCollection>;
  buildRecommendedContentCursorCollection?: Maybe<BuildRecommendedContentCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type IntegrationOptimizelyFlagLinkingCollectionsBuildRecommendedContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<IntegrationOptimizelyFlagLinkingCollectionsBuildRecommendedContentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type IntegrationOptimizelyFlagLinkingCollectionsBuildRecommendedContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<IntegrationOptimizelyFlagLinkingCollectionsBuildRecommendedContentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type IntegrationOptimizelyFlagLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type IntegrationOptimizelyFlagLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum IntegrationOptimizelyFlagLinkingCollectionsBuildRecommendedContentCollectionOrder {
  AnnotationAsc = 'annotation_ASC',
  AnnotationDesc = 'annotation_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum IntegrationOptimizelyFlagLinkingCollectionsBuildRecommendedContentCursorCollectionOrder {
  AnnotationAsc = 'annotation_ASC',
  AnnotationDesc = 'annotation_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum IntegrationOptimizelyFlagOrder {
  IdentifierAsc = 'identifier_ASC',
  IdentifierDesc = 'identifier_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/integrationOptimizelyFlagRule) */
export type IntegrationOptimizelyFlagRule = Entry & _Node & {
  __typename?: 'IntegrationOptimizelyFlagRule';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<IntegrationOptimizelyFlagRuleLinkingCollections>;
  recommendedContentAccordion?: Maybe<ComponentRecommendedContentAccordion>;
  sys: Sys;
  variation?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/integrationOptimizelyFlagRule) */
export type IntegrationOptimizelyFlagRuleLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/integrationOptimizelyFlagRule) */
export type IntegrationOptimizelyFlagRuleRecommendedContentAccordionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentRecommendedContentAccordionFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/integrationOptimizelyFlagRule) */
export type IntegrationOptimizelyFlagRuleVariationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IntegrationOptimizelyFlagRuleCollection = {
  __typename?: 'IntegrationOptimizelyFlagRuleCollection';
  items: Array<Maybe<IntegrationOptimizelyFlagRule>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type IntegrationOptimizelyFlagRuleCursorCollection = {
  __typename?: 'IntegrationOptimizelyFlagRuleCursorCollection';
  items: Array<Maybe<IntegrationOptimizelyFlagRule>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type IntegrationOptimizelyFlagRuleFilter = {
  AND?: InputMaybe<Array<InputMaybe<IntegrationOptimizelyFlagRuleFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<IntegrationOptimizelyFlagRuleFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  recommendedContentAccordion?: InputMaybe<CfComponentRecommendedContentAccordionNestedFilter>;
  recommendedContentAccordion_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  variation?: InputMaybe<Scalars['String']['input']>;
  variation_contains?: InputMaybe<Scalars['String']['input']>;
  variation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variation_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variation_not?: InputMaybe<Scalars['String']['input']>;
  variation_not_contains?: InputMaybe<Scalars['String']['input']>;
  variation_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type IntegrationOptimizelyFlagRuleLinkingCollections = {
  __typename?: 'IntegrationOptimizelyFlagRuleLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  integrationOptimizelyFlagCollection?: Maybe<IntegrationOptimizelyFlagCollection>;
  integrationOptimizelyFlagCursorCollection?: Maybe<IntegrationOptimizelyFlagCursorCollection>;
};


export type IntegrationOptimizelyFlagRuleLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type IntegrationOptimizelyFlagRuleLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type IntegrationOptimizelyFlagRuleLinkingCollectionsIntegrationOptimizelyFlagCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<IntegrationOptimizelyFlagRuleLinkingCollectionsIntegrationOptimizelyFlagCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type IntegrationOptimizelyFlagRuleLinkingCollectionsIntegrationOptimizelyFlagCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<IntegrationOptimizelyFlagRuleLinkingCollectionsIntegrationOptimizelyFlagCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum IntegrationOptimizelyFlagRuleLinkingCollectionsIntegrationOptimizelyFlagCollectionOrder {
  IdentifierAsc = 'identifier_ASC',
  IdentifierDesc = 'identifier_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum IntegrationOptimizelyFlagRuleLinkingCollectionsIntegrationOptimizelyFlagCursorCollectionOrder {
  IdentifierAsc = 'identifier_ASC',
  IdentifierDesc = 'identifier_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum IntegrationOptimizelyFlagRuleOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariationAsc = 'variation_ASC',
  VariationDesc = 'variation_DESC'
}

export type IntegrationOptimizelyFlagRulesCollection = {
  __typename?: 'IntegrationOptimizelyFlagRulesCollection';
  items: Array<Maybe<IntegrationOptimizelyFlagRule>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum IntegrationOptimizelyFlagRulesCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariationAsc = 'variation_ASC',
  VariationDesc = 'variation_DESC'
}

export type IntegrationOptimizelyFlagRulesCursorCollection = {
  __typename?: 'IntegrationOptimizelyFlagRulesCursorCollection';
  items: Array<Maybe<IntegrationOptimizelyFlagRule>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum IntegrationOptimizelyFlagRulesCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariationAsc = 'variation_ASC',
  VariationDesc = 'variation_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packAlertBanner) */
export type PackAlertBanner = Entry & _Node & {
  __typename?: 'PackAlertBanner';
  _id: Scalars['ID']['output'];
  body?: Maybe<PackAlertBannerBody>;
  contentfulMetadata: ContentfulMetadata;
  expires?: Maybe<Scalars['DateTime']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<PackAlertBannerLinkingCollections>;
  sys: Sys;
  theme?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packAlertBanner) */
export type PackAlertBannerBodyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packAlertBanner) */
export type PackAlertBannerExpiresArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packAlertBanner) */
export type PackAlertBannerHeaderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packAlertBanner) */
export type PackAlertBannerInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packAlertBanner) */
export type PackAlertBannerLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packAlertBanner) */
export type PackAlertBannerThemeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PackAlertBannerBody = {
  __typename?: 'PackAlertBannerBody';
  json: Scalars['JSON']['output'];
  links: PackAlertBannerBodyLinks;
};

export type PackAlertBannerBodyAssets = {
  __typename?: 'PackAlertBannerBodyAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type PackAlertBannerBodyEntries = {
  __typename?: 'PackAlertBannerBodyEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type PackAlertBannerBodyLinks = {
  __typename?: 'PackAlertBannerBodyLinks';
  assets: PackAlertBannerBodyAssets;
  entries: PackAlertBannerBodyEntries;
  resources: PackAlertBannerBodyResources;
};

export type PackAlertBannerBodyResources = {
  __typename?: 'PackAlertBannerBodyResources';
  block: Array<PackAlertBannerBodyResourcesBlock>;
  hyperlink: Array<PackAlertBannerBodyResourcesHyperlink>;
  inline: Array<PackAlertBannerBodyResourcesInline>;
};

export type PackAlertBannerBodyResourcesBlock = ResourceLink & {
  __typename?: 'PackAlertBannerBodyResourcesBlock';
  sys: ResourceSys;
};

export type PackAlertBannerBodyResourcesHyperlink = ResourceLink & {
  __typename?: 'PackAlertBannerBodyResourcesHyperlink';
  sys: ResourceSys;
};

export type PackAlertBannerBodyResourcesInline = ResourceLink & {
  __typename?: 'PackAlertBannerBodyResourcesInline';
  sys: ResourceSys;
};

export type PackAlertBannerCollection = {
  __typename?: 'PackAlertBannerCollection';
  items: Array<Maybe<PackAlertBanner>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PackAlertBannerCursorCollection = {
  __typename?: 'PackAlertBannerCursorCollection';
  items: Array<Maybe<PackAlertBanner>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PackAlertBannerFilter = {
  AND?: InputMaybe<Array<InputMaybe<PackAlertBannerFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackAlertBannerFilter>>>;
  body_contains?: InputMaybe<Scalars['String']['input']>;
  body_exists?: InputMaybe<Scalars['Boolean']['input']>;
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  expires?: InputMaybe<Scalars['DateTime']['input']>;
  expires_exists?: InputMaybe<Scalars['Boolean']['input']>;
  expires_gt?: InputMaybe<Scalars['DateTime']['input']>;
  expires_gte?: InputMaybe<Scalars['DateTime']['input']>;
  expires_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  expires_lt?: InputMaybe<Scalars['DateTime']['input']>;
  expires_lte?: InputMaybe<Scalars['DateTime']['input']>;
  expires_not?: InputMaybe<Scalars['DateTime']['input']>;
  expires_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  header?: InputMaybe<Scalars['String']['input']>;
  header_contains?: InputMaybe<Scalars['String']['input']>;
  header_exists?: InputMaybe<Scalars['Boolean']['input']>;
  header_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  header_not?: InputMaybe<Scalars['String']['input']>;
  header_not_contains?: InputMaybe<Scalars['String']['input']>;
  header_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  theme?: InputMaybe<Scalars['String']['input']>;
  theme_contains?: InputMaybe<Scalars['String']['input']>;
  theme_exists?: InputMaybe<Scalars['Boolean']['input']>;
  theme_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  theme_not?: InputMaybe<Scalars['String']['input']>;
  theme_not_contains?: InputMaybe<Scalars['String']['input']>;
  theme_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PackAlertBannerLinkingCollections = {
  __typename?: 'PackAlertBannerLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  packArticlePageCollection?: Maybe<PackArticlePageCollection>;
  packArticlePageCursorCollection?: Maybe<PackArticlePageCursorCollection>;
  packCampaignPageCollection?: Maybe<PackCampaignPageCollection>;
  packCampaignPageCursorCollection?: Maybe<PackCampaignPageCursorCollection>;
  packHomePageCollection?: Maybe<PackHomePageCollection>;
  packHomePageCursorCollection?: Maybe<PackHomePageCursorCollection>;
  packLandingPageArticlesCollection?: Maybe<PackLandingPageArticlesCollection>;
  packLandingPageArticlesCursorCollection?: Maybe<PackLandingPageArticlesCursorCollection>;
  packPageProductDetailCollection?: Maybe<PackPageProductDetailCollection>;
  packPageProductDetailCursorCollection?: Maybe<PackPageProductDetailCursorCollection>;
  packPageStandardCollection?: Maybe<PackPageStandardCollection>;
  packPageStandardCursorCollection?: Maybe<PackPageStandardCursorCollection>;
  packPageStandardV2Collection?: Maybe<PackPageStandardV2Collection>;
  packPageStandardV2CursorCollection?: Maybe<PackPageStandardV2CursorCollection>;
  packPageStandardV2DevCollection?: Maybe<PackPageStandardV2DevCollection>;
  packPageStandardV2DevCursorCollection?: Maybe<PackPageStandardV2DevCursorCollection>;
};


export type PackAlertBannerLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackAlertBannerLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackAlertBannerLinkingCollectionsPackArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackAlertBannerLinkingCollectionsPackArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackAlertBannerLinkingCollectionsPackArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackAlertBannerLinkingCollectionsPackArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackAlertBannerLinkingCollectionsPackCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackAlertBannerLinkingCollectionsPackCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackAlertBannerLinkingCollectionsPackCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackAlertBannerLinkingCollectionsPackCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackAlertBannerLinkingCollectionsPackHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackAlertBannerLinkingCollectionsPackHomePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackAlertBannerLinkingCollectionsPackHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackAlertBannerLinkingCollectionsPackHomePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackAlertBannerLinkingCollectionsPackLandingPageArticlesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackAlertBannerLinkingCollectionsPackLandingPageArticlesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackAlertBannerLinkingCollectionsPackLandingPageArticlesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackAlertBannerLinkingCollectionsPackLandingPageArticlesCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackAlertBannerLinkingCollectionsPackPageProductDetailCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackAlertBannerLinkingCollectionsPackPageProductDetailCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackAlertBannerLinkingCollectionsPackPageProductDetailCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackAlertBannerLinkingCollectionsPackPageProductDetailCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackAlertBannerLinkingCollectionsPackPageStandardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackAlertBannerLinkingCollectionsPackPageStandardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackAlertBannerLinkingCollectionsPackPageStandardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackAlertBannerLinkingCollectionsPackPageStandardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackAlertBannerLinkingCollectionsPackPageStandardV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackAlertBannerLinkingCollectionsPackPageStandardV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackAlertBannerLinkingCollectionsPackPageStandardV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackAlertBannerLinkingCollectionsPackPageStandardV2CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackAlertBannerLinkingCollectionsPackPageStandardV2DevCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackAlertBannerLinkingCollectionsPackPageStandardV2DevCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackAlertBannerLinkingCollectionsPackPageStandardV2DevCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackAlertBannerLinkingCollectionsPackPageStandardV2DevCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PackAlertBannerLinkingCollectionsPackArticlePageCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  ShareLinkAsc = 'shareLink_ASC',
  ShareLinkDesc = 'shareLink_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackAlertBannerLinkingCollectionsPackArticlePageCursorCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  ShareLinkAsc = 'shareLink_ASC',
  ShareLinkDesc = 'shareLink_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackAlertBannerLinkingCollectionsPackCampaignPageCollectionOrder {
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  HasGradientAsc = 'hasGradient_ASC',
  HasGradientDesc = 'hasGradient_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  HeroTextPositionAsc = 'heroTextPosition_ASC',
  HeroTextPositionDesc = 'heroTextPosition_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC'
}

export enum PackAlertBannerLinkingCollectionsPackCampaignPageCursorCollectionOrder {
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  HasGradientAsc = 'hasGradient_ASC',
  HasGradientDesc = 'hasGradient_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  HeroTextPositionAsc = 'heroTextPosition_ASC',
  HeroTextPositionDesc = 'heroTextPosition_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC'
}

export enum PackAlertBannerLinkingCollectionsPackHomePageCollectionOrder {
  ComponentVariantAsc = 'componentVariant_ASC',
  ComponentVariantDesc = 'componentVariant_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TrustpilotBannerAsc = 'trustpilotBanner_ASC',
  TrustpilotBannerDesc = 'trustpilotBanner_DESC'
}

export enum PackAlertBannerLinkingCollectionsPackHomePageCursorCollectionOrder {
  ComponentVariantAsc = 'componentVariant_ASC',
  ComponentVariantDesc = 'componentVariant_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TrustpilotBannerAsc = 'trustpilotBanner_ASC',
  TrustpilotBannerDesc = 'trustpilotBanner_DESC'
}

export enum PackAlertBannerLinkingCollectionsPackLandingPageArticlesCollectionOrder {
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackAlertBannerLinkingCollectionsPackLandingPageArticlesCursorCollectionOrder {
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackAlertBannerLinkingCollectionsPackPageProductDetailCollectionOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackAlertBannerLinkingCollectionsPackPageProductDetailCursorCollectionOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackAlertBannerLinkingCollectionsPackPageStandardCollectionOrder {
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackAlertBannerLinkingCollectionsPackPageStandardCursorCollectionOrder {
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackAlertBannerLinkingCollectionsPackPageStandardV2CollectionOrder {
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackAlertBannerLinkingCollectionsPackPageStandardV2CursorCollectionOrder {
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackAlertBannerLinkingCollectionsPackPageStandardV2DevCollectionOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  Subheader2Asc = 'subheader2_ASC',
  Subheader2Desc = 'subheader2_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackAlertBannerLinkingCollectionsPackPageStandardV2DevCursorCollectionOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  Subheader2Asc = 'subheader2_ASC',
  Subheader2Desc = 'subheader2_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackAlertBannerOrder {
  ExpiresAsc = 'expires_ASC',
  ExpiresDesc = 'expires_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packAppStore) */
export type PackAppStore = Entry & _Node & {
  __typename?: 'PackAppStore';
  _id: Scalars['ID']['output'];
  appleIconAltText?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<PackAppStoreLinkingCollections>;
  playstoreIconAltText?: Maybe<Scalars['String']['output']>;
  showAppleIcon?: Maybe<Scalars['Boolean']['output']>;
  showPlaystoreIcon?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packAppStore) */
export type PackAppStoreAppleIconAltTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packAppStore) */
export type PackAppStoreInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packAppStore) */
export type PackAppStoreLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packAppStore) */
export type PackAppStorePlaystoreIconAltTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packAppStore) */
export type PackAppStoreShowAppleIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packAppStore) */
export type PackAppStoreShowPlaystoreIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PackAppStoreCollection = {
  __typename?: 'PackAppStoreCollection';
  items: Array<Maybe<PackAppStore>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PackAppStoreCursorCollection = {
  __typename?: 'PackAppStoreCursorCollection';
  items: Array<Maybe<PackAppStore>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PackAppStoreFilter = {
  AND?: InputMaybe<Array<InputMaybe<PackAppStoreFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackAppStoreFilter>>>;
  appleIconAltText?: InputMaybe<Scalars['String']['input']>;
  appleIconAltText_contains?: InputMaybe<Scalars['String']['input']>;
  appleIconAltText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  appleIconAltText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appleIconAltText_not?: InputMaybe<Scalars['String']['input']>;
  appleIconAltText_not_contains?: InputMaybe<Scalars['String']['input']>;
  appleIconAltText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  playstoreIconAltText?: InputMaybe<Scalars['String']['input']>;
  playstoreIconAltText_contains?: InputMaybe<Scalars['String']['input']>;
  playstoreIconAltText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  playstoreIconAltText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  playstoreIconAltText_not?: InputMaybe<Scalars['String']['input']>;
  playstoreIconAltText_not_contains?: InputMaybe<Scalars['String']['input']>;
  playstoreIconAltText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAppleIcon?: InputMaybe<Scalars['Boolean']['input']>;
  showAppleIcon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showAppleIcon_not?: InputMaybe<Scalars['Boolean']['input']>;
  showPlaystoreIcon?: InputMaybe<Scalars['Boolean']['input']>;
  showPlaystoreIcon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showPlaystoreIcon_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type PackAppStoreLinkingCollections = {
  __typename?: 'PackAppStoreLinkingCollections';
  componentFooterCollection?: Maybe<ComponentFooterCollection>;
  componentFooterCursorCollection?: Maybe<ComponentFooterCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type PackAppStoreLinkingCollectionsComponentFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackAppStoreLinkingCollectionsComponentFooterCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackAppStoreLinkingCollectionsComponentFooterCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackAppStoreLinkingCollectionsComponentFooterCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackAppStoreLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackAppStoreLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PackAppStoreLinkingCollectionsComponentFooterCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackAppStoreLinkingCollectionsComponentFooterCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackAppStoreOrder {
  AppleIconAltTextAsc = 'appleIconAltText_ASC',
  AppleIconAltTextDesc = 'appleIconAltText_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  PlaystoreIconAltTextAsc = 'playstoreIconAltText_ASC',
  PlaystoreIconAltTextDesc = 'playstoreIconAltText_DESC',
  ShowAppleIconAsc = 'showAppleIcon_ASC',
  ShowAppleIconDesc = 'showAppleIcon_DESC',
  ShowPlaystoreIconAsc = 'showPlaystoreIcon_ASC',
  ShowPlaystoreIconDesc = 'showPlaystoreIcon_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packArticlePage) */
export type PackArticlePage = Entry & _Node & {
  __typename?: 'PackArticlePage';
  _id: Scalars['ID']['output'];
  alertBanner?: Maybe<PackArticlePageAlertBanner>;
  author?: Maybe<Scalars['String']['output']>;
  bannerBynderMedia?: Maybe<PackArticlePageBannerBynderMedia>;
  bannerImage?: Maybe<WrapperBannerImage>;
  bannerTextPosition?: Maybe<Scalars['Boolean']['output']>;
  contentfulMetadata: ContentfulMetadata;
  header?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<PackArticlePageLinkingCollections>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  ogImage?: Maybe<WrapperImage>;
  ogMetaDescription?: Maybe<Scalars['String']['output']>;
  ogMetaTitle?: Maybe<Scalars['String']['output']>;
  searchBar?: Maybe<PackSearchBar>;
  shareLink?: Maybe<Scalars['String']['output']>;
  subheader?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  text?: Maybe<PackArticlePageText>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packArticlePage) */
export type PackArticlePageAlertBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packArticlePage) */
export type PackArticlePageAuthorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packArticlePage) */
export type PackArticlePageBannerBynderMediaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackArticlePageBannerBynderMediaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packArticlePage) */
export type PackArticlePageBannerImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperBannerImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packArticlePage) */
export type PackArticlePageBannerTextPositionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packArticlePage) */
export type PackArticlePageHeaderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packArticlePage) */
export type PackArticlePageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packArticlePage) */
export type PackArticlePageMetaDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packArticlePage) */
export type PackArticlePageMetaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packArticlePage) */
export type PackArticlePageOgImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packArticlePage) */
export type PackArticlePageOgMetaDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packArticlePage) */
export type PackArticlePageOgMetaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packArticlePage) */
export type PackArticlePageSearchBarArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackSearchBarFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packArticlePage) */
export type PackArticlePageShareLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packArticlePage) */
export type PackArticlePageSubheaderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packArticlePage) */
export type PackArticlePageTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PackArticlePageAlertBanner = PackAlertBanner | VariationContainer;

export type PackArticlePageBannerBynderMedia = ContentType5OiHchWgV9Y8SuvDxHCaLy | ContentType5VCz5FHyZ2ZlWqa5OKh6Y9;

export type PackArticlePageBannerBynderMediaFilter = {
  AND?: InputMaybe<Array<InputMaybe<PackArticlePageBannerBynderMediaFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackArticlePageBannerBynderMediaFilter>>>;
  altText?: InputMaybe<Scalars['String']['input']>;
  altText_contains?: InputMaybe<Scalars['String']['input']>;
  altText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  altText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  altText_not?: InputMaybe<Scalars['String']['input']>;
  altText_not_contains?: InputMaybe<Scalars['String']['input']>;
  altText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderId?: InputMaybe<Scalars['String']['input']>;
  bynderId_contains?: InputMaybe<Scalars['String']['input']>;
  bynderId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bynderId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderId_not?: InputMaybe<Scalars['String']['input']>;
  bynderId_not_contains?: InputMaybe<Scalars['String']['input']>;
  bynderId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PackArticlePageCollection = {
  __typename?: 'PackArticlePageCollection';
  items: Array<Maybe<PackArticlePage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PackArticlePageCursorCollection = {
  __typename?: 'PackArticlePageCursorCollection';
  items: Array<Maybe<PackArticlePage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PackArticlePageFilter = {
  AND?: InputMaybe<Array<InputMaybe<PackArticlePageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackArticlePageFilter>>>;
  alertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  author?: InputMaybe<Scalars['String']['input']>;
  author_contains?: InputMaybe<Scalars['String']['input']>;
  author_exists?: InputMaybe<Scalars['Boolean']['input']>;
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  author_not?: InputMaybe<Scalars['String']['input']>;
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerBynderMedia?: InputMaybe<CfbannerBynderMediaMultiTypeNestedFilter>;
  bannerBynderMedia_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bannerImage?: InputMaybe<CfWrapperBannerImageNestedFilter>;
  bannerImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bannerTextPosition?: InputMaybe<Scalars['Boolean']['input']>;
  bannerTextPosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bannerTextPosition_not?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  header?: InputMaybe<Scalars['String']['input']>;
  header_contains?: InputMaybe<Scalars['String']['input']>;
  header_exists?: InputMaybe<Scalars['Boolean']['input']>;
  header_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  header_not?: InputMaybe<Scalars['String']['input']>;
  header_not_contains?: InputMaybe<Scalars['String']['input']>;
  header_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaDescription_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaDescription_not?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  metaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle_not?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogImage?: InputMaybe<CfWrapperImageNestedFilter>;
  ogImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ogMetaDescription?: InputMaybe<Scalars['String']['input']>;
  ogMetaDescription_contains?: InputMaybe<Scalars['String']['input']>;
  ogMetaDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ogMetaDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogMetaDescription_not?: InputMaybe<Scalars['String']['input']>;
  ogMetaDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  ogMetaDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogMetaTitle?: InputMaybe<Scalars['String']['input']>;
  ogMetaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  ogMetaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ogMetaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogMetaTitle_not?: InputMaybe<Scalars['String']['input']>;
  ogMetaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  ogMetaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchBar?: InputMaybe<CfPackSearchBarNestedFilter>;
  searchBar_exists?: InputMaybe<Scalars['Boolean']['input']>;
  shareLink?: InputMaybe<Scalars['String']['input']>;
  shareLink_contains?: InputMaybe<Scalars['String']['input']>;
  shareLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  shareLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shareLink_not?: InputMaybe<Scalars['String']['input']>;
  shareLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  shareLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subheader?: InputMaybe<Scalars['String']['input']>;
  subheader_contains?: InputMaybe<Scalars['String']['input']>;
  subheader_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subheader_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subheader_not?: InputMaybe<Scalars['String']['input']>;
  subheader_not_contains?: InputMaybe<Scalars['String']['input']>;
  subheader_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
};

export type PackArticlePageLinkingCollections = {
  __typename?: 'PackArticlePageLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type PackArticlePageLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackArticlePageLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackArticlePageLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackArticlePageLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackArticlePageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackArticlePageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PackArticlePageLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackArticlePageLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackArticlePageOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  ShareLinkAsc = 'shareLink_ASC',
  ShareLinkDesc = 'shareLink_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type PackArticlePageText = {
  __typename?: 'PackArticlePageText';
  json: Scalars['JSON']['output'];
  links: PackArticlePageTextLinks;
};

export type PackArticlePageTextAssets = {
  __typename?: 'PackArticlePageTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type PackArticlePageTextEntries = {
  __typename?: 'PackArticlePageTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type PackArticlePageTextLinks = {
  __typename?: 'PackArticlePageTextLinks';
  assets: PackArticlePageTextAssets;
  entries: PackArticlePageTextEntries;
  resources: PackArticlePageTextResources;
};

export type PackArticlePageTextResources = {
  __typename?: 'PackArticlePageTextResources';
  block: Array<PackArticlePageTextResourcesBlock>;
  hyperlink: Array<PackArticlePageTextResourcesHyperlink>;
  inline: Array<PackArticlePageTextResourcesInline>;
};

export type PackArticlePageTextResourcesBlock = ResourceLink & {
  __typename?: 'PackArticlePageTextResourcesBlock';
  sys: ResourceSys;
};

export type PackArticlePageTextResourcesHyperlink = ResourceLink & {
  __typename?: 'PackArticlePageTextResourcesHyperlink';
  sys: ResourceSys;
};

export type PackArticlePageTextResourcesInline = ResourceLink & {
  __typename?: 'PackArticlePageTextResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCampaignPage) */
export type PackCampaignPage = Entry & _Node & {
  __typename?: 'PackCampaignPage';
  _id: Scalars['ID']['output'];
  alertBanner?: Maybe<PackCampaignPageAlertBanner>;
  animations?: Maybe<WrapperAnimation>;
  contentfulMetadata: ContentfulMetadata;
  eyebrowImage?: Maybe<ContentType5OiHchWgV9Y8SuvDxHCaLy>;
  eyebrowText?: Maybe<Scalars['String']['output']>;
  hasGradient?: Maybe<Scalars['Boolean']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  heroAlertBanner?: Maybe<PackAlertBanner>;
  heroBynderMediaCollection?: Maybe<PackCampaignPageHeroBynderMediaCollection>;
  heroBynderMediaCursorCollection?: Maybe<PackCampaignPageHeroBynderMediaCursorCollection>;
  heroTextPosition?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<PackCampaignPageLinkingCollections>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  ogImage?: Maybe<WrapperImage>;
  ogMetaDescription?: Maybe<Scalars['String']['output']>;
  ogMetaTitle?: Maybe<Scalars['String']['output']>;
  subheader?: Maybe<PackCampaignPageSubheader>;
  sys: Sys;
  theme?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCampaignPage) */
export type PackCampaignPageAlertBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCampaignPage) */
export type PackCampaignPageAnimationsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperAnimationFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCampaignPage) */
export type PackCampaignPageEyebrowImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCampaignPage) */
export type PackCampaignPageEyebrowTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCampaignPage) */
export type PackCampaignPageHasGradientArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCampaignPage) */
export type PackCampaignPageHeaderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCampaignPage) */
export type PackCampaignPageHeroAlertBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackAlertBannerFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCampaignPage) */
export type PackCampaignPageHeroBynderMediaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCampaignPageHeroBynderMediaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCampaignPage) */
export type PackCampaignPageHeroBynderMediaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCampaignPageHeroBynderMediaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCampaignPage) */
export type PackCampaignPageHeroTextPositionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCampaignPage) */
export type PackCampaignPageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCampaignPage) */
export type PackCampaignPageMetaDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCampaignPage) */
export type PackCampaignPageMetaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCampaignPage) */
export type PackCampaignPageOgImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCampaignPage) */
export type PackCampaignPageOgMetaDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCampaignPage) */
export type PackCampaignPageOgMetaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCampaignPage) */
export type PackCampaignPageSubheaderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCampaignPage) */
export type PackCampaignPageThemeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PackCampaignPageAlertBanner = PackAlertBanner | VariationContainer;

export type PackCampaignPageCollection = {
  __typename?: 'PackCampaignPageCollection';
  items: Array<Maybe<PackCampaignPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PackCampaignPageCursorCollection = {
  __typename?: 'PackCampaignPageCursorCollection';
  items: Array<Maybe<PackCampaignPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PackCampaignPageFilter = {
  AND?: InputMaybe<Array<InputMaybe<PackCampaignPageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackCampaignPageFilter>>>;
  alertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  animations?: InputMaybe<CfWrapperAnimationNestedFilter>;
  animations_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  eyebrowImage?: InputMaybe<CfContentType5OiHchWgV9Y8SuvDxHCaLyNestedFilter>;
  eyebrowImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowText?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowText_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hasGradient?: InputMaybe<Scalars['Boolean']['input']>;
  hasGradient_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hasGradient_not?: InputMaybe<Scalars['Boolean']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  header_contains?: InputMaybe<Scalars['String']['input']>;
  header_exists?: InputMaybe<Scalars['Boolean']['input']>;
  header_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  header_not?: InputMaybe<Scalars['String']['input']>;
  header_not_contains?: InputMaybe<Scalars['String']['input']>;
  header_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heroAlertBanner?: InputMaybe<CfPackAlertBannerNestedFilter>;
  heroAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heroBynderMedia?: InputMaybe<CfheroBynderMediaMultiTypeNestedFilter>;
  heroBynderMediaCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heroTextPosition?: InputMaybe<Scalars['String']['input']>;
  heroTextPosition_contains?: InputMaybe<Scalars['String']['input']>;
  heroTextPosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heroTextPosition_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heroTextPosition_not?: InputMaybe<Scalars['String']['input']>;
  heroTextPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  heroTextPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaDescription_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaDescription_not?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  metaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle_not?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogImage?: InputMaybe<CfWrapperImageNestedFilter>;
  ogImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ogMetaDescription?: InputMaybe<Scalars['String']['input']>;
  ogMetaDescription_contains?: InputMaybe<Scalars['String']['input']>;
  ogMetaDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ogMetaDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogMetaDescription_not?: InputMaybe<Scalars['String']['input']>;
  ogMetaDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  ogMetaDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogMetaTitle?: InputMaybe<Scalars['String']['input']>;
  ogMetaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  ogMetaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ogMetaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogMetaTitle_not?: InputMaybe<Scalars['String']['input']>;
  ogMetaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  ogMetaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subheader_contains?: InputMaybe<Scalars['String']['input']>;
  subheader_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subheader_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  theme?: InputMaybe<Scalars['String']['input']>;
  theme_contains?: InputMaybe<Scalars['String']['input']>;
  theme_exists?: InputMaybe<Scalars['Boolean']['input']>;
  theme_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  theme_not?: InputMaybe<Scalars['String']['input']>;
  theme_not_contains?: InputMaybe<Scalars['String']['input']>;
  theme_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PackCampaignPageHeroBynderMediaCollection = {
  __typename?: 'PackCampaignPageHeroBynderMediaCollection';
  items: Array<Maybe<PackCampaignPageHeroBynderMediaItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PackCampaignPageHeroBynderMediaCursorCollection = {
  __typename?: 'PackCampaignPageHeroBynderMediaCursorCollection';
  items: Array<Maybe<PackCampaignPageHeroBynderMediaItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PackCampaignPageHeroBynderMediaFilter = {
  AND?: InputMaybe<Array<InputMaybe<PackCampaignPageHeroBynderMediaFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackCampaignPageHeroBynderMediaFilter>>>;
  altText?: InputMaybe<Scalars['String']['input']>;
  altText_contains?: InputMaybe<Scalars['String']['input']>;
  altText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  altText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  altText_not?: InputMaybe<Scalars['String']['input']>;
  altText_not_contains?: InputMaybe<Scalars['String']['input']>;
  altText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderId?: InputMaybe<Scalars['String']['input']>;
  bynderId_contains?: InputMaybe<Scalars['String']['input']>;
  bynderId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bynderId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderId_not?: InputMaybe<Scalars['String']['input']>;
  bynderId_not_contains?: InputMaybe<Scalars['String']['input']>;
  bynderId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PackCampaignPageHeroBynderMediaItem = ContentType5OiHchWgV9Y8SuvDxHCaLy | ContentType5VCz5FHyZ2ZlWqa5OKh6Y9;

export type PackCampaignPageLinkingCollections = {
  __typename?: 'PackCampaignPageLinkingCollections';
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildProductOverviewPageCollection?: Maybe<BuildProductOverviewPageCollection>;
  buildProductOverviewPageCursorCollection?: Maybe<BuildProductOverviewPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type PackCampaignPageLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCampaignPageLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCampaignPageLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCampaignPageLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCampaignPageLinkingCollectionsBuildProductOverviewPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCampaignPageLinkingCollectionsBuildProductOverviewPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCampaignPageLinkingCollectionsBuildProductOverviewPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCampaignPageLinkingCollectionsBuildProductOverviewPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCampaignPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCampaignPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PackCampaignPageLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCampaignPageLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCampaignPageLinkingCollectionsBuildProductOverviewPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCampaignPageLinkingCollectionsBuildProductOverviewPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCampaignPageOrder {
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  HasGradientAsc = 'hasGradient_ASC',
  HasGradientDesc = 'hasGradient_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  HeroTextPositionAsc = 'heroTextPosition_ASC',
  HeroTextPositionDesc = 'heroTextPosition_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC'
}

export type PackCampaignPageSubheader = {
  __typename?: 'PackCampaignPageSubheader';
  json: Scalars['JSON']['output'];
  links: PackCampaignPageSubheaderLinks;
};

export type PackCampaignPageSubheaderAssets = {
  __typename?: 'PackCampaignPageSubheaderAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type PackCampaignPageSubheaderEntries = {
  __typename?: 'PackCampaignPageSubheaderEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type PackCampaignPageSubheaderLinks = {
  __typename?: 'PackCampaignPageSubheaderLinks';
  assets: PackCampaignPageSubheaderAssets;
  entries: PackCampaignPageSubheaderEntries;
  resources: PackCampaignPageSubheaderResources;
};

export type PackCampaignPageSubheaderResources = {
  __typename?: 'PackCampaignPageSubheaderResources';
  block: Array<PackCampaignPageSubheaderResourcesBlock>;
  hyperlink: Array<PackCampaignPageSubheaderResourcesHyperlink>;
  inline: Array<PackCampaignPageSubheaderResourcesInline>;
};

export type PackCampaignPageSubheaderResourcesBlock = ResourceLink & {
  __typename?: 'PackCampaignPageSubheaderResourcesBlock';
  sys: ResourceSys;
};

export type PackCampaignPageSubheaderResourcesHyperlink = ResourceLink & {
  __typename?: 'PackCampaignPageSubheaderResourcesHyperlink';
  sys: ResourceSys;
};

export type PackCampaignPageSubheaderResourcesInline = ResourceLink & {
  __typename?: 'PackCampaignPageSubheaderResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCategory) */
export type PackCategory = Entry & _Node & {
  __typename?: 'PackCategory';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  iconCollection?: Maybe<PackCategoryIconCollection>;
  iconCursorCollection?: Maybe<PackCategoryIconCursorCollection>;
  internalTitle?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<PackCategoryLinkingCollections>;
  parentCategory?: Maybe<PackCategory>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCategory) */
export type PackCategoryIconCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCategoryIconCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperIconFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCategory) */
export type PackCategoryIconCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCategoryIconCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperIconFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCategory) */
export type PackCategoryInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCategory) */
export type PackCategoryLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCategory) */
export type PackCategoryLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCategory) */
export type PackCategoryParentCategoryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCategoryFilter>;
};

export type PackCategoryCollection = {
  __typename?: 'PackCategoryCollection';
  items: Array<Maybe<PackCategory>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PackCategoryCursorCollection = {
  __typename?: 'PackCategoryCursorCollection';
  items: Array<Maybe<PackCategory>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PackCategoryFilter = {
  AND?: InputMaybe<Array<InputMaybe<PackCategoryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackCategoryFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon?: InputMaybe<CfWrapperIconNestedFilter>;
  iconCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parentCategory?: InputMaybe<CfPackCategoryNestedFilter>;
  parentCategory_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type PackCategoryIconCollection = {
  __typename?: 'PackCategoryIconCollection';
  items: Array<Maybe<WrapperIcon>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum PackCategoryIconCollectionOrder {
  AltTextAsc = 'altText_ASC',
  AltTextDesc = 'altText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UseAltTextAsc = 'useAltText_ASC',
  UseAltTextDesc = 'useAltText_DESC'
}

export type PackCategoryIconCursorCollection = {
  __typename?: 'PackCategoryIconCursorCollection';
  items: Array<Maybe<WrapperIcon>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum PackCategoryIconCursorCollectionOrder {
  AltTextAsc = 'altText_ASC',
  AltTextDesc = 'altText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UseAltTextAsc = 'useAltText_ASC',
  UseAltTextDesc = 'useAltText_DESC'
}

export type PackCategoryLinkingCollections = {
  __typename?: 'PackCategoryLinkingCollections';
  buildCategoryWebpageCollection?: Maybe<BuildCategoryWebpageCollection>;
  buildCategoryWebpageCursorCollection?: Maybe<BuildCategoryWebpageCursorCollection>;
  buildWebpageCollection?: Maybe<BuildWebpageCollection>;
  buildWebpageCursorCollection?: Maybe<BuildWebpageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  packCategoryCollection?: Maybe<PackCategoryCollection>;
  packCategoryCursorCollection?: Maybe<PackCategoryCursorCollection>;
  packCategoryListCollection?: Maybe<PackCategoryListCollection>;
  packCategoryListCursorCollection?: Maybe<PackCategoryListCursorCollection>;
};


export type PackCategoryLinkingCollectionsBuildCategoryWebpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCategoryLinkingCollectionsBuildCategoryWebpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCategoryLinkingCollectionsBuildCategoryWebpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCategoryLinkingCollectionsBuildCategoryWebpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCategoryLinkingCollectionsBuildWebpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCategoryLinkingCollectionsBuildWebpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCategoryLinkingCollectionsBuildWebpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCategoryLinkingCollectionsBuildWebpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCategoryLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCategoryLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCategoryLinkingCollectionsPackCategoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCategoryLinkingCollectionsPackCategoryCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCategoryLinkingCollectionsPackCategoryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCategoryLinkingCollectionsPackCategoryCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCategoryLinkingCollectionsPackCategoryListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCategoryLinkingCollectionsPackCategoryListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCategoryLinkingCollectionsPackCategoryListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCategoryLinkingCollectionsPackCategoryListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PackCategoryLinkingCollectionsBuildCategoryWebpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PathnameAsc = 'pathname_ASC',
  PathnameDesc = 'pathname_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCategoryLinkingCollectionsBuildCategoryWebpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PathnameAsc = 'pathname_ASC',
  PathnameDesc = 'pathname_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCategoryLinkingCollectionsBuildWebpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCategoryLinkingCollectionsBuildWebpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCategoryLinkingCollectionsPackCategoryCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCategoryLinkingCollectionsPackCategoryCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCategoryLinkingCollectionsPackCategoryListCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCategoryLinkingCollectionsPackCategoryListCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCategoryList) */
export type PackCategoryList = Entry & _Node & {
  __typename?: 'PackCategoryList';
  _id: Scalars['ID']['output'];
  categoryCollection?: Maybe<PackCategoryListCategoryCollection>;
  categoryCursorCollection?: Maybe<PackCategoryListCategoryCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<PackCategoryListLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCategoryList) */
export type PackCategoryListCategoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCategoryListCategoryCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCategoryFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCategoryList) */
export type PackCategoryListCategoryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCategoryListCategoryCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCategoryFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCategoryList) */
export type PackCategoryListInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCategoryList) */
export type PackCategoryListLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PackCategoryListCategoryCollection = {
  __typename?: 'PackCategoryListCategoryCollection';
  items: Array<Maybe<PackCategory>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum PackCategoryListCategoryCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type PackCategoryListCategoryCursorCollection = {
  __typename?: 'PackCategoryListCategoryCursorCollection';
  items: Array<Maybe<PackCategory>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum PackCategoryListCategoryCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type PackCategoryListCollection = {
  __typename?: 'PackCategoryListCollection';
  items: Array<Maybe<PackCategoryList>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PackCategoryListCursorCollection = {
  __typename?: 'PackCategoryListCursorCollection';
  items: Array<Maybe<PackCategoryList>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PackCategoryListFilter = {
  AND?: InputMaybe<Array<InputMaybe<PackCategoryListFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackCategoryListFilter>>>;
  category?: InputMaybe<CfPackCategoryNestedFilter>;
  categoryCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type PackCategoryListLinkingCollections = {
  __typename?: 'PackCategoryListLinkingCollections';
  buildCategoryWebpageCollection?: Maybe<BuildCategoryWebpageCollection>;
  buildCategoryWebpageCursorCollection?: Maybe<BuildCategoryWebpageCursorCollection>;
  componentCategoryBrowserCollection?: Maybe<ComponentCategoryBrowserCollection>;
  componentCategoryBrowserCursorCollection?: Maybe<ComponentCategoryBrowserCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type PackCategoryListLinkingCollectionsBuildCategoryWebpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCategoryListLinkingCollectionsBuildCategoryWebpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCategoryListLinkingCollectionsBuildCategoryWebpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCategoryListLinkingCollectionsBuildCategoryWebpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCategoryListLinkingCollectionsComponentCategoryBrowserCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCategoryListLinkingCollectionsComponentCategoryBrowserCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCategoryListLinkingCollectionsComponentCategoryBrowserCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCategoryListLinkingCollectionsComponentCategoryBrowserCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCategoryListLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCategoryListLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PackCategoryListLinkingCollectionsBuildCategoryWebpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PathnameAsc = 'pathname_ASC',
  PathnameDesc = 'pathname_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCategoryListLinkingCollectionsBuildCategoryWebpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PathnameAsc = 'pathname_ASC',
  PathnameDesc = 'pathname_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCategoryListLinkingCollectionsComponentCategoryBrowserCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  IconSetAsc = 'iconSet_ASC',
  IconSetDesc = 'iconSet_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCategoryListLinkingCollectionsComponentCategoryBrowserCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  IconSetAsc = 'iconSet_ASC',
  IconSetDesc = 'iconSet_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCategoryListOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCategoryOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packContactOptions) */
export type PackContactOptions = Entry & _Node & {
  __typename?: 'PackContactOptions';
  _id: Scalars['ID']['output'];
  chatButtonLabel?: Maybe<Scalars['String']['output']>;
  contactChannelCollection?: Maybe<PackContactOptionsContactChannelCollection>;
  contactChannelCursorCollection?: Maybe<PackContactOptionsContactChannelCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  internalTitle?: Maybe<Scalars['String']['output']>;
  intro?: Maybe<PackStructuredText>;
  linkedFrom?: Maybe<PackContactOptionsLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packContactOptions) */
export type PackContactOptionsChatButtonLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packContactOptions) */
export type PackContactOptionsContactChannelCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackContactOptionsContactChannelCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackStructuredTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packContactOptions) */
export type PackContactOptionsContactChannelCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackContactOptionsContactChannelCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackStructuredTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packContactOptions) */
export type PackContactOptionsInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packContactOptions) */
export type PackContactOptionsIntroArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackStructuredTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packContactOptions) */
export type PackContactOptionsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PackContactOptionsCollection = {
  __typename?: 'PackContactOptionsCollection';
  items: Array<Maybe<PackContactOptions>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PackContactOptionsContactChannelCollection = {
  __typename?: 'PackContactOptionsContactChannelCollection';
  items: Array<Maybe<PackStructuredText>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum PackContactOptionsContactChannelCollectionOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type PackContactOptionsContactChannelCursorCollection = {
  __typename?: 'PackContactOptionsContactChannelCursorCollection';
  items: Array<Maybe<PackStructuredText>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum PackContactOptionsContactChannelCursorCollectionOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type PackContactOptionsCursorCollection = {
  __typename?: 'PackContactOptionsCursorCollection';
  items: Array<Maybe<PackContactOptions>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PackContactOptionsFilter = {
  AND?: InputMaybe<Array<InputMaybe<PackContactOptionsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackContactOptionsFilter>>>;
  chatButtonLabel?: InputMaybe<Scalars['String']['input']>;
  chatButtonLabel_contains?: InputMaybe<Scalars['String']['input']>;
  chatButtonLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  chatButtonLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  chatButtonLabel_not?: InputMaybe<Scalars['String']['input']>;
  chatButtonLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  chatButtonLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactChannel?: InputMaybe<CfPackStructuredTextNestedFilter>;
  contactChannelCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  intro?: InputMaybe<CfPackStructuredTextNestedFilter>;
  intro_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type PackContactOptionsLinkingCollections = {
  __typename?: 'PackContactOptionsLinkingCollections';
  componentContactAndUsefulLinksCollection?: Maybe<ComponentContactAndUsefulLinksCollection>;
  componentContactAndUsefulLinksCursorCollection?: Maybe<ComponentContactAndUsefulLinksCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type PackContactOptionsLinkingCollectionsComponentContactAndUsefulLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackContactOptionsLinkingCollectionsComponentContactAndUsefulLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackContactOptionsLinkingCollectionsComponentContactAndUsefulLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackContactOptionsLinkingCollectionsComponentContactAndUsefulLinksCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackContactOptionsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackContactOptionsLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PackContactOptionsLinkingCollectionsComponentContactAndUsefulLinksCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackContactOptionsLinkingCollectionsComponentContactAndUsefulLinksCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackContactOptionsOrder {
  ChatButtonLabelAsc = 'chatButtonLabel_ASC',
  ChatButtonLabelDesc = 'chatButtonLabel_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCta) */
export type PackCta = Entry & _Node & {
  __typename?: 'PackCta';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  destination?: Maybe<PackCtaDestination>;
  destinationAnchor?: Maybe<PackCtaDestinationAnchor>;
  hiddenText?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<PackCtaLinkingCollections>;
  mixpanelId?: Maybe<Scalars['String']['output']>;
  queryStringExtras?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  utmCampaign?: Maybe<Scalars['String']['output']>;
  utmContent?: Maybe<Scalars['String']['output']>;
  utmMedium?: Maybe<Scalars['String']['output']>;
  utmSource?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCta) */
export type PackCtaDestinationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCta) */
export type PackCtaDestinationAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCta) */
export type PackCtaHiddenTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCta) */
export type PackCtaLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCta) */
export type PackCtaLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCta) */
export type PackCtaMixpanelIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCta) */
export type PackCtaQueryStringExtrasArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCta) */
export type PackCtaUtmCampaignArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCta) */
export type PackCtaUtmContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCta) */
export type PackCtaUtmMediumArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packCta) */
export type PackCtaUtmSourceArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PackCtaCollection = {
  __typename?: 'PackCtaCollection';
  items: Array<Maybe<PackCta>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PackCtaCursorCollection = {
  __typename?: 'PackCtaCursorCollection';
  items: Array<Maybe<PackCta>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PackCtaDestination = BuildCategoryWebpage | BuildWebpage | PackUserAction | WrapperDocument | WrapperUrl;

export type PackCtaDestinationAnchor = ComponentAccordion | ComponentCallout | ComponentCardGrid | ComponentContactAndUsefulLinks | ComponentContentBlock | ComponentCtaBanner | ComponentForm | ComponentPostcodeFinder | ComponentSpotlightGrid | ComponentTable;

export type PackCtaFilter = {
  AND?: InputMaybe<Array<InputMaybe<PackCtaFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackCtaFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  destinationAnchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  destination_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenText?: InputMaybe<Scalars['String']['input']>;
  hiddenText_contains?: InputMaybe<Scalars['String']['input']>;
  hiddenText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenText_not?: InputMaybe<Scalars['String']['input']>;
  hiddenText_not_contains?: InputMaybe<Scalars['String']['input']>;
  hiddenText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mixpanelId?: InputMaybe<Scalars['String']['input']>;
  mixpanelId_contains?: InputMaybe<Scalars['String']['input']>;
  mixpanelId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mixpanelId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mixpanelId_not?: InputMaybe<Scalars['String']['input']>;
  mixpanelId_not_contains?: InputMaybe<Scalars['String']['input']>;
  mixpanelId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  queryStringExtras?: InputMaybe<Scalars['String']['input']>;
  queryStringExtras_contains?: InputMaybe<Scalars['String']['input']>;
  queryStringExtras_exists?: InputMaybe<Scalars['Boolean']['input']>;
  queryStringExtras_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  queryStringExtras_not?: InputMaybe<Scalars['String']['input']>;
  queryStringExtras_not_contains?: InputMaybe<Scalars['String']['input']>;
  queryStringExtras_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmCampaign_contains?: InputMaybe<Scalars['String']['input']>;
  utmCampaign_exists?: InputMaybe<Scalars['Boolean']['input']>;
  utmCampaign_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  utmCampaign_not?: InputMaybe<Scalars['String']['input']>;
  utmCampaign_not_contains?: InputMaybe<Scalars['String']['input']>;
  utmCampaign_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmContent_contains?: InputMaybe<Scalars['String']['input']>;
  utmContent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  utmContent_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  utmContent_not?: InputMaybe<Scalars['String']['input']>;
  utmContent_not_contains?: InputMaybe<Scalars['String']['input']>;
  utmContent_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmMedium_contains?: InputMaybe<Scalars['String']['input']>;
  utmMedium_exists?: InputMaybe<Scalars['Boolean']['input']>;
  utmMedium_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  utmMedium_not?: InputMaybe<Scalars['String']['input']>;
  utmMedium_not_contains?: InputMaybe<Scalars['String']['input']>;
  utmMedium_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmSource_contains?: InputMaybe<Scalars['String']['input']>;
  utmSource_exists?: InputMaybe<Scalars['Boolean']['input']>;
  utmSource_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  utmSource_not?: InputMaybe<Scalars['String']['input']>;
  utmSource_not_contains?: InputMaybe<Scalars['String']['input']>;
  utmSource_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PackCtaLinkingCollections = {
  __typename?: 'PackCtaLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildGenericTemplatePageCollection?: Maybe<BuildGenericTemplatePageCollection>;
  buildGenericTemplatePageCursorCollection?: Maybe<BuildGenericTemplatePageCursorCollection>;
  buildLandingpageCollection?: Maybe<BuildLandingpageCollection>;
  buildLandingpageCursorCollection?: Maybe<BuildLandingpageCursorCollection>;
  buildProductDetailPageCollection?: Maybe<BuildProductDetailPageCollection>;
  buildProductDetailPageCursorCollection?: Maybe<BuildProductDetailPageCursorCollection>;
  buildProductOverviewPageCollection?: Maybe<BuildProductOverviewPageCollection>;
  buildProductOverviewPageCursorCollection?: Maybe<BuildProductOverviewPageCursorCollection>;
  buildTariffPageCollection?: Maybe<BuildTariffPageCollection>;
  buildTariffPageCursorCollection?: Maybe<BuildTariffPageCursorCollection>;
  buildWebpageCollection?: Maybe<BuildWebpageCollection>;
  buildWebpageCursorCollection?: Maybe<BuildWebpageCursorCollection>;
  componentActionCardCollection?: Maybe<ComponentActionCardCollection>;
  componentActionCardCursorCollection?: Maybe<ComponentActionCardCursorCollection>;
  componentBlockCardCollection?: Maybe<ComponentBlockCardCollection>;
  componentBlockCardCursorCollection?: Maybe<ComponentBlockCardCursorCollection>;
  componentCardCollection?: Maybe<ComponentCardCollection>;
  componentCardCursorCollection?: Maybe<ComponentCardCursorCollection>;
  componentCardGroupCollection?: Maybe<ComponentCardGroupCollection>;
  componentCardGroupCursorCollection?: Maybe<ComponentCardGroupCursorCollection>;
  componentCarouselCardCollection?: Maybe<ComponentCarouselCardCollection>;
  componentCarouselCardCursorCollection?: Maybe<ComponentCarouselCardCursorCollection>;
  componentContentBlockCollection?: Maybe<ComponentContentBlockCollection>;
  componentContentBlockCursorCollection?: Maybe<ComponentContentBlockCursorCollection>;
  componentContentBlockV2Collection?: Maybe<ComponentContentBlockV2Collection>;
  componentContentBlockV2CursorCollection?: Maybe<ComponentContentBlockV2CursorCollection>;
  componentCtaBannerCollection?: Maybe<ComponentCtaBannerCollection>;
  componentCtaBannerCursorCollection?: Maybe<ComponentCtaBannerCursorCollection>;
  componentDetailInfoSectionCollection?: Maybe<ComponentDetailInfoSectionCollection>;
  componentDetailInfoSectionCursorCollection?: Maybe<ComponentDetailInfoSectionCursorCollection>;
  componentGuideCardCollection?: Maybe<ComponentGuideCardCollection>;
  componentGuideCardCursorCollection?: Maybe<ComponentGuideCardCursorCollection>;
  componentGuidesRailCollection?: Maybe<ComponentGuidesRailCollection>;
  componentGuidesRailCursorCollection?: Maybe<ComponentGuidesRailCursorCollection>;
  componentHelpAndCtaCollection?: Maybe<ComponentHelpAndCtaCollection>;
  componentHelpAndCtaCursorCollection?: Maybe<ComponentHelpAndCtaCursorCollection>;
  componentHomepageHeroPostcodeSectionCollection?: Maybe<ComponentHomepageHeroPostcodeSectionCollection>;
  componentHomepageHeroPostcodeSectionCursorCollection?: Maybe<ComponentHomepageHeroPostcodeSectionCursorCollection>;
  componentImageWithDescriptionCollection?: Maybe<ComponentImageWithDescriptionCollection>;
  componentImageWithDescriptionCursorCollection?: Maybe<ComponentImageWithDescriptionCursorCollection>;
  componentInfoCardCollection?: Maybe<ComponentInfoCardCollection>;
  componentInfoCardCursorCollection?: Maybe<ComponentInfoCardCursorCollection>;
  componentPostcodeFinderCollection?: Maybe<ComponentPostcodeFinderCollection>;
  componentPostcodeFinderCursorCollection?: Maybe<ComponentPostcodeFinderCursorCollection>;
  componentProductFeaturedCardCollection?: Maybe<ComponentProductFeaturedCardCollection>;
  componentProductFeaturedCardCursorCollection?: Maybe<ComponentProductFeaturedCardCursorCollection>;
  componentProductModuleCollection?: Maybe<ComponentProductModuleCollection>;
  componentProductModuleCursorCollection?: Maybe<ComponentProductModuleCursorCollection>;
  componentPromoTextCardCollection?: Maybe<ComponentPromoTextCardCollection>;
  componentPromoTextCardCursorCollection?: Maybe<ComponentPromoTextCardCursorCollection>;
  componentQrCodePopupCollection?: Maybe<ComponentQrCodePopupCollection>;
  componentQrCodePopupCursorCollection?: Maybe<ComponentQrCodePopupCursorCollection>;
  componentSearchCollection?: Maybe<ComponentSearchCollection>;
  componentSearchCursorCollection?: Maybe<ComponentSearchCursorCollection>;
  componentSectionStepsCollection?: Maybe<ComponentSectionStepsCollection>;
  componentSectionStepsCursorCollection?: Maybe<ComponentSectionStepsCursorCollection>;
  componentSpotlightGridCollection?: Maybe<ComponentSpotlightGridCollection>;
  componentSpotlightGridCursorCollection?: Maybe<ComponentSpotlightGridCursorCollection>;
  componentTariffCardCollection?: Maybe<ComponentTariffCardCollection>;
  componentTariffCardCursorCollection?: Maybe<ComponentTariffCardCursorCollection>;
  componentTariffHeroCollection?: Maybe<ComponentTariffHeroCollection>;
  componentTariffHeroCursorCollection?: Maybe<ComponentTariffHeroCursorCollection>;
  componentTextAndCtaCollection?: Maybe<ComponentTextAndCtaCollection>;
  componentTextAndCtaCursorCollection?: Maybe<ComponentTextAndCtaCursorCollection>;
  componentTopArticleBrowserCollection?: Maybe<ComponentTopArticleBrowserCollection>;
  componentTopArticleBrowserCursorCollection?: Maybe<ComponentTopArticleBrowserCursorCollection>;
  componentUspGroupCollection?: Maybe<ComponentUspGroupCollection>;
  componentUspGroupCursorCollection?: Maybe<ComponentUspGroupCursorCollection>;
  componentVideoPlayerCollection?: Maybe<ComponentVideoPlayerCollection>;
  componentVideoPlayerCursorCollection?: Maybe<ComponentVideoPlayerCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  packPageProductDetailCollection?: Maybe<PackPageProductDetailCollection>;
  packPageProductDetailCursorCollection?: Maybe<PackPageProductDetailCursorCollection>;
  packRecommendedContentAccordionItemCollection?: Maybe<PackRecommendedContentAccordionItemCollection>;
  packRecommendedContentAccordionItemCursorCollection?: Maybe<PackRecommendedContentAccordionItemCursorCollection>;
  promoCardCollection?: Maybe<PromoCardCollection>;
  promoCardCursorCollection?: Maybe<PromoCardCursorCollection>;
};


export type PackCtaLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsBuildGenericTemplatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsBuildGenericTemplatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsBuildGenericTemplatePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsBuildLandingpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsBuildLandingpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsBuildLandingpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsBuildLandingpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsBuildProductDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsBuildProductDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsBuildProductDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsBuildProductDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsBuildProductOverviewPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsBuildProductOverviewPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsBuildProductOverviewPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsBuildProductOverviewPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsBuildTariffPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsBuildTariffPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsBuildTariffPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsBuildTariffPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsBuildWebpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsBuildWebpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsBuildWebpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsBuildWebpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentActionCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentActionCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentActionCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentActionCardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentBlockCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentBlockCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentBlockCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentBlockCardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentCardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentCardGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentCardGroupCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentCardGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentCardGroupCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentCarouselCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentCarouselCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentCarouselCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentCarouselCardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentContentBlockCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentContentBlockCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentContentBlockCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentContentBlockCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentContentBlockV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentContentBlockV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentContentBlockV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentContentBlockV2CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentCtaBannerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentCtaBannerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentCtaBannerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentCtaBannerCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentDetailInfoSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentDetailInfoSectionCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentDetailInfoSectionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentDetailInfoSectionCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentGuideCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentGuideCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentGuideCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentGuideCardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentGuidesRailCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentGuidesRailCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentGuidesRailCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentGuidesRailCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentHelpAndCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentHelpAndCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentHelpAndCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentHelpAndCtaCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentHomepageHeroPostcodeSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentHomepageHeroPostcodeSectionCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentHomepageHeroPostcodeSectionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentHomepageHeroPostcodeSectionCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentImageWithDescriptionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentImageWithDescriptionCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentImageWithDescriptionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentImageWithDescriptionCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentInfoCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentInfoCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentInfoCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentInfoCardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentPostcodeFinderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentPostcodeFinderCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentPostcodeFinderCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentPostcodeFinderCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentProductFeaturedCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentProductFeaturedCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentProductFeaturedCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentProductFeaturedCardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentProductModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentProductModuleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentProductModuleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentProductModuleCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentPromoTextCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentPromoTextCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentPromoTextCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentPromoTextCardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentQrCodePopupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentQrCodePopupCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentQrCodePopupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentQrCodePopupCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentSearchCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentSearchCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentSearchCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentSearchCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentSectionStepsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentSectionStepsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentSectionStepsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentSectionStepsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentSpotlightGridCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentSpotlightGridCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentSpotlightGridCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentSpotlightGridCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentTariffCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentTariffCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentTariffCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentTariffCardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentTariffHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentTariffHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentTariffHeroCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentTariffHeroCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentTextAndCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentTextAndCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentTextAndCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentTextAndCtaCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentTopArticleBrowserCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentTopArticleBrowserCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentTopArticleBrowserCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentTopArticleBrowserCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentUspGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentUspGroupCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentUspGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentUspGroupCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentVideoPlayerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentVideoPlayerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsComponentVideoPlayerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsComponentVideoPlayerCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsPackPageProductDetailCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsPackPageProductDetailCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsPackPageProductDetailCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsPackPageProductDetailCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsPackRecommendedContentAccordionItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsPackRecommendedContentAccordionItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsPackRecommendedContentAccordionItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsPackRecommendedContentAccordionItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsPromoCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsPromoCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackCtaLinkingCollectionsPromoCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaLinkingCollectionsPromoCardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PackCtaLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCtaLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCtaLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCtaLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCtaLinkingCollectionsBuildGenericTemplatePageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCtaLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCtaLinkingCollectionsBuildLandingpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCtaLinkingCollectionsBuildLandingpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCtaLinkingCollectionsBuildProductDetailPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCtaLinkingCollectionsBuildProductDetailPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCtaLinkingCollectionsBuildProductOverviewPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCtaLinkingCollectionsBuildProductOverviewPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCtaLinkingCollectionsBuildTariffPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCtaLinkingCollectionsBuildTariffPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCtaLinkingCollectionsBuildWebpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCtaLinkingCollectionsBuildWebpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCtaLinkingCollectionsComponentActionCardCollectionOrder {
  ActionCodeAsc = 'actionCode_ASC',
  ActionCodeDesc = 'actionCode_DESC',
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  CanBeDismissedAsc = 'canBeDismissed_ASC',
  CanBeDismissedDesc = 'canBeDismissed_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  DarkModeAsc = 'darkMode_ASC',
  DarkModeDesc = 'darkMode_DESC',
  InvertedAsc = 'inverted_ASC',
  InvertedDesc = 'inverted_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  NonRoundedEdgesAsc = 'nonRoundedEdges_ASC',
  NonRoundedEdgesDesc = 'nonRoundedEdges_DESC',
  OptimizelyFeatureFlagAsc = 'optimizelyFeatureFlag_ASC',
  OptimizelyFeatureFlagDesc = 'optimizelyFeatureFlag_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCtaLinkingCollectionsComponentActionCardCursorCollectionOrder {
  ActionCodeAsc = 'actionCode_ASC',
  ActionCodeDesc = 'actionCode_DESC',
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  CanBeDismissedAsc = 'canBeDismissed_ASC',
  CanBeDismissedDesc = 'canBeDismissed_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  DarkModeAsc = 'darkMode_ASC',
  DarkModeDesc = 'darkMode_DESC',
  InvertedAsc = 'inverted_ASC',
  InvertedDesc = 'inverted_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  NonRoundedEdgesAsc = 'nonRoundedEdges_ASC',
  NonRoundedEdgesDesc = 'nonRoundedEdges_DESC',
  OptimizelyFeatureFlagAsc = 'optimizelyFeatureFlag_ASC',
  OptimizelyFeatureFlagDesc = 'optimizelyFeatureFlag_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCtaLinkingCollectionsComponentBlockCardCollectionOrder {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PackCtaLinkingCollectionsComponentBlockCardCursorCollectionOrder {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PackCtaLinkingCollectionsComponentCardCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  ShortTextAsc = 'shortText_ASC',
  ShortTextDesc = 'shortText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCtaLinkingCollectionsComponentCardCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  ShortTextAsc = 'shortText_ASC',
  ShortTextDesc = 'shortText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCtaLinkingCollectionsComponentCardGroupCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC'
}

export enum PackCtaLinkingCollectionsComponentCardGroupCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC'
}

export enum PackCtaLinkingCollectionsComponentCarouselCardCollectionOrder {
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  CardTabLabelAsc = 'cardTabLabel_ASC',
  CardTabLabelDesc = 'cardTabLabel_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleText1Asc = 'titleText1_ASC',
  TitleText1Desc = 'titleText1_DESC',
  TitleText2Asc = 'titleText2_ASC',
  TitleText2Desc = 'titleText2_DESC'
}

export enum PackCtaLinkingCollectionsComponentCarouselCardCursorCollectionOrder {
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  CardTabLabelAsc = 'cardTabLabel_ASC',
  CardTabLabelDesc = 'cardTabLabel_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleText1Asc = 'titleText1_ASC',
  TitleText1Desc = 'titleText1_DESC',
  TitleText2Asc = 'titleText2_ASC',
  TitleText2Desc = 'titleText2_DESC'
}

export enum PackCtaLinkingCollectionsComponentContentBlockCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  HeaderLevelAsc = 'headerLevel_ASC',
  HeaderLevelDesc = 'headerLevel_DESC',
  MediaPositionAsc = 'mediaPosition_ASC',
  MediaPositionDesc = 'mediaPosition_DESC',
  ShowTitleAsc = 'showTitle_ASC',
  ShowTitleDesc = 'showTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAlignmentAsc = 'textAlignment_ASC',
  TextAlignmentDesc = 'textAlignment_DESC'
}

export enum PackCtaLinkingCollectionsComponentContentBlockCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  HeaderLevelAsc = 'headerLevel_ASC',
  HeaderLevelDesc = 'headerLevel_DESC',
  MediaPositionAsc = 'mediaPosition_ASC',
  MediaPositionDesc = 'mediaPosition_DESC',
  ShowTitleAsc = 'showTitle_ASC',
  ShowTitleDesc = 'showTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAlignmentAsc = 'textAlignment_ASC',
  TextAlignmentDesc = 'textAlignment_DESC'
}

export enum PackCtaLinkingCollectionsComponentContentBlockV2CollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  HeaderLevelAsc = 'headerLevel_ASC',
  HeaderLevelDesc = 'headerLevel_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MediaPositionAsc = 'mediaPosition_ASC',
  MediaPositionDesc = 'mediaPosition_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAlignmentAsc = 'textAlignment_ASC',
  TextAlignmentDesc = 'textAlignment_DESC'
}

export enum PackCtaLinkingCollectionsComponentContentBlockV2CursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  HeaderLevelAsc = 'headerLevel_ASC',
  HeaderLevelDesc = 'headerLevel_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MediaPositionAsc = 'mediaPosition_ASC',
  MediaPositionDesc = 'mediaPosition_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAlignmentAsc = 'textAlignment_ASC',
  TextAlignmentDesc = 'textAlignment_DESC'
}

export enum PackCtaLinkingCollectionsComponentCtaBannerCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  BannerTypeAsc = 'bannerType_ASC',
  BannerTypeDesc = 'bannerType_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCtaLinkingCollectionsComponentCtaBannerCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  BannerTypeAsc = 'bannerType_ASC',
  BannerTypeDesc = 'bannerType_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCtaLinkingCollectionsComponentDetailInfoSectionCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC',
  TitlePart1Asc = 'titlePart1_ASC',
  TitlePart1Desc = 'titlePart1_DESC',
  TitlePart2Asc = 'titlePart2_ASC',
  TitlePart2Desc = 'titlePart2_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PackCtaLinkingCollectionsComponentDetailInfoSectionCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC',
  TitlePart1Asc = 'titlePart1_ASC',
  TitlePart1Desc = 'titlePart1_DESC',
  TitlePart2Asc = 'titlePart2_ASC',
  TitlePart2Desc = 'titlePart2_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PackCtaLinkingCollectionsComponentGuideCardCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PackCtaLinkingCollectionsComponentGuideCardCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PackCtaLinkingCollectionsComponentGuidesRailCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export enum PackCtaLinkingCollectionsComponentGuidesRailCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export enum PackCtaLinkingCollectionsComponentHelpAndCtaCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PackCtaLinkingCollectionsComponentHelpAndCtaCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PackCtaLinkingCollectionsComponentHomepageHeroPostcodeSectionCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum PackCtaLinkingCollectionsComponentHomepageHeroPostcodeSectionCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum PackCtaLinkingCollectionsComponentImageWithDescriptionCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  ContentOrientationAsc = 'contentOrientation_ASC',
  ContentOrientationDesc = 'contentOrientation_DESC',
  ImageAspectRatioAsc = 'imageAspectRatio_ASC',
  ImageAspectRatioDesc = 'imageAspectRatio_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC'
}

export enum PackCtaLinkingCollectionsComponentImageWithDescriptionCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  ContentOrientationAsc = 'contentOrientation_ASC',
  ContentOrientationDesc = 'contentOrientation_DESC',
  ImageAspectRatioAsc = 'imageAspectRatio_ASC',
  ImageAspectRatioDesc = 'imageAspectRatio_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC'
}

export enum PackCtaLinkingCollectionsComponentInfoCardCollectionOrder {
  DestinationLabelAsc = 'destinationLabel_ASC',
  DestinationLabelDesc = 'destinationLabel_DESC',
  IsExternalLinkAsc = 'isExternalLink_ASC',
  IsExternalLinkDesc = 'isExternalLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PackCtaLinkingCollectionsComponentInfoCardCursorCollectionOrder {
  DestinationLabelAsc = 'destinationLabel_ASC',
  DestinationLabelDesc = 'destinationLabel_DESC',
  IsExternalLinkAsc = 'isExternalLink_ASC',
  IsExternalLinkDesc = 'isExternalLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PackCtaLinkingCollectionsComponentPostcodeFinderCollectionOrder {
  InputFieldTextAsc = 'inputFieldText_ASC',
  InputFieldTextDesc = 'inputFieldText_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC',
  TitlePart1Asc = 'titlePart1_ASC',
  TitlePart1Desc = 'titlePart1_DESC',
  TitlePart2Asc = 'titlePart2_ASC',
  TitlePart2Desc = 'titlePart2_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum PackCtaLinkingCollectionsComponentPostcodeFinderCursorCollectionOrder {
  InputFieldTextAsc = 'inputFieldText_ASC',
  InputFieldTextDesc = 'inputFieldText_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC',
  TitlePart1Asc = 'titlePart1_ASC',
  TitlePart1Desc = 'titlePart1_DESC',
  TitlePart2Asc = 'titlePart2_ASC',
  TitlePart2Desc = 'titlePart2_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum PackCtaLinkingCollectionsComponentProductFeaturedCardCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PackCtaLinkingCollectionsComponentProductFeaturedCardCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PackCtaLinkingCollectionsComponentProductModuleCollectionOrder {
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PackCtaLinkingCollectionsComponentProductModuleCursorCollectionOrder {
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PackCtaLinkingCollectionsComponentPromoTextCardCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC',
  TitlePart1Asc = 'titlePart1_ASC',
  TitlePart1Desc = 'titlePart1_DESC',
  TitlePart2Asc = 'titlePart2_ASC',
  TitlePart2Desc = 'titlePart2_DESC'
}

export enum PackCtaLinkingCollectionsComponentPromoTextCardCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC',
  TitlePart1Asc = 'titlePart1_ASC',
  TitlePart1Desc = 'titlePart1_DESC',
  TitlePart2Asc = 'titlePart2_ASC',
  TitlePart2Desc = 'titlePart2_DESC'
}

export enum PackCtaLinkingCollectionsComponentQrCodePopupCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC'
}

export enum PackCtaLinkingCollectionsComponentQrCodePopupCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC'
}

export enum PackCtaLinkingCollectionsComponentSearchCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  NothingFoundAsc = 'nothingFound_ASC',
  NothingFoundDesc = 'nothingFound_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PackCtaLinkingCollectionsComponentSearchCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  NothingFoundAsc = 'nothingFound_ASC',
  NothingFoundDesc = 'nothingFound_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PackCtaLinkingCollectionsComponentSectionStepsCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC'
}

export enum PackCtaLinkingCollectionsComponentSectionStepsCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC'
}

export enum PackCtaLinkingCollectionsComponentSpotlightGridCollectionOrder {
  AlignmentAsc = 'alignment_ASC',
  AlignmentDesc = 'alignment_DESC',
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCtaLinkingCollectionsComponentSpotlightGridCursorCollectionOrder {
  AlignmentAsc = 'alignment_ASC',
  AlignmentDesc = 'alignment_DESC',
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCtaLinkingCollectionsComponentTariffCardCollectionOrder {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export enum PackCtaLinkingCollectionsComponentTariffCardCursorCollectionOrder {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export enum PackCtaLinkingCollectionsComponentTariffHeroCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  PostcodeFinderInputFieldTextAsc = 'postcodeFinderInputFieldText_ASC',
  PostcodeFinderInputFieldTextDesc = 'postcodeFinderInputFieldText_DESC',
  ShowPostcodeFinderAsc = 'showPostcodeFinder_ASC',
  ShowPostcodeFinderDesc = 'showPostcodeFinder_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export enum PackCtaLinkingCollectionsComponentTariffHeroCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  PostcodeFinderInputFieldTextAsc = 'postcodeFinderInputFieldText_ASC',
  PostcodeFinderInputFieldTextDesc = 'postcodeFinderInputFieldText_DESC',
  ShowPostcodeFinderAsc = 'showPostcodeFinder_ASC',
  ShowPostcodeFinderDesc = 'showPostcodeFinder_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export enum PackCtaLinkingCollectionsComponentTextAndCtaCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC'
}

export enum PackCtaLinkingCollectionsComponentTextAndCtaCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC'
}

export enum PackCtaLinkingCollectionsComponentTopArticleBrowserCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCtaLinkingCollectionsComponentTopArticleBrowserCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCtaLinkingCollectionsComponentUspGroupCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TermsAsc = 'terms_ASC',
  TermsDesc = 'terms_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export enum PackCtaLinkingCollectionsComponentUspGroupCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TermsAsc = 'terms_ASC',
  TermsDesc = 'terms_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export enum PackCtaLinkingCollectionsComponentVideoPlayerCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  ShowTitleAndDescriptionAsc = 'showTitleAndDescription_ASC',
  ShowTitleAndDescriptionDesc = 'showTitleAndDescription_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export enum PackCtaLinkingCollectionsComponentVideoPlayerCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  ShowTitleAndDescriptionAsc = 'showTitleAndDescription_ASC',
  ShowTitleAndDescriptionDesc = 'showTitleAndDescription_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export enum PackCtaLinkingCollectionsPackPageProductDetailCollectionOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCtaLinkingCollectionsPackPageProductDetailCursorCollectionOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCtaLinkingCollectionsPackRecommendedContentAccordionItemCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCtaLinkingCollectionsPackRecommendedContentAccordionItemCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackCtaLinkingCollectionsPromoCardCollectionOrder {
  CtaVariantAsc = 'ctaVariant_ASC',
  CtaVariantDesc = 'ctaVariant_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC',
  TitlePositionAsc = 'titlePosition_ASC',
  TitlePositionDesc = 'titlePosition_DESC',
  TitleVariantAsc = 'titleVariant_ASC',
  TitleVariantDesc = 'titleVariant_DESC'
}

export enum PackCtaLinkingCollectionsPromoCardCursorCollectionOrder {
  CtaVariantAsc = 'ctaVariant_ASC',
  CtaVariantDesc = 'ctaVariant_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC',
  TitlePositionAsc = 'titlePosition_ASC',
  TitlePositionDesc = 'titlePosition_DESC',
  TitleVariantAsc = 'titleVariant_ASC',
  TitleVariantDesc = 'titleVariant_DESC'
}

export enum PackCtaOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packDynamicVariablePlaceholder) */
export type PackDynamicVariablePlaceholder = Entry & _Node & {
  __typename?: 'PackDynamicVariablePlaceholder';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<PackDynamicVariablePlaceholderLinkingCollections>;
  sys: Sys;
  variableName?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packDynamicVariablePlaceholder) */
export type PackDynamicVariablePlaceholderLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packDynamicVariablePlaceholder) */
export type PackDynamicVariablePlaceholderVariableNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PackDynamicVariablePlaceholderCollection = {
  __typename?: 'PackDynamicVariablePlaceholderCollection';
  items: Array<Maybe<PackDynamicVariablePlaceholder>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PackDynamicVariablePlaceholderCursorCollection = {
  __typename?: 'PackDynamicVariablePlaceholderCursorCollection';
  items: Array<Maybe<PackDynamicVariablePlaceholder>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PackDynamicVariablePlaceholderFilter = {
  AND?: InputMaybe<Array<InputMaybe<PackDynamicVariablePlaceholderFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackDynamicVariablePlaceholderFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  variableName?: InputMaybe<Scalars['String']['input']>;
  variableName_contains?: InputMaybe<Scalars['String']['input']>;
  variableName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variableName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variableName_not?: InputMaybe<Scalars['String']['input']>;
  variableName_not_contains?: InputMaybe<Scalars['String']['input']>;
  variableName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PackDynamicVariablePlaceholderLinkingCollections = {
  __typename?: 'PackDynamicVariablePlaceholderLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type PackDynamicVariablePlaceholderLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackDynamicVariablePlaceholderLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PackDynamicVariablePlaceholderOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariableNameAsc = 'variableName_ASC',
  VariableNameDesc = 'variableName_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packFooterItem) */
export type PackFooterItem = Entry & _Node & {
  __typename?: 'PackFooterItem';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  ctaBehaviour?: Maybe<Scalars['String']['output']>;
  destination?: Maybe<PackFooterItemDestination>;
  hiddenText?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<PackFooterItemLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packFooterItem) */
export type PackFooterItemCtaBehaviourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packFooterItem) */
export type PackFooterItemDestinationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packFooterItem) */
export type PackFooterItemHiddenTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packFooterItem) */
export type PackFooterItemLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packFooterItem) */
export type PackFooterItemLevelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packFooterItem) */
export type PackFooterItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PackFooterItemCollection = {
  __typename?: 'PackFooterItemCollection';
  items: Array<Maybe<PackFooterItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PackFooterItemCursorCollection = {
  __typename?: 'PackFooterItemCursorCollection';
  items: Array<Maybe<PackFooterItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PackFooterItemDestination = BuildCategoryWebpage | BuildWebpage | WrapperUrl;

export type PackFooterItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<PackFooterItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackFooterItemFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctaBehaviour?: InputMaybe<Scalars['String']['input']>;
  ctaBehaviour_contains?: InputMaybe<Scalars['String']['input']>;
  ctaBehaviour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaBehaviour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaBehaviour_not?: InputMaybe<Scalars['String']['input']>;
  ctaBehaviour_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaBehaviour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  destination_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenText?: InputMaybe<Scalars['String']['input']>;
  hiddenText_contains?: InputMaybe<Scalars['String']['input']>;
  hiddenText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenText_not?: InputMaybe<Scalars['String']['input']>;
  hiddenText_not_contains?: InputMaybe<Scalars['String']['input']>;
  hiddenText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  level?: InputMaybe<Scalars['String']['input']>;
  level_contains?: InputMaybe<Scalars['String']['input']>;
  level_exists?: InputMaybe<Scalars['Boolean']['input']>;
  level_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  level_not?: InputMaybe<Scalars['String']['input']>;
  level_not_contains?: InputMaybe<Scalars['String']['input']>;
  level_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type PackFooterItemLinkingCollections = {
  __typename?: 'PackFooterItemLinkingCollections';
  componentFooterCollection?: Maybe<ComponentFooterCollection>;
  componentFooterCursorCollection?: Maybe<ComponentFooterCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type PackFooterItemLinkingCollectionsComponentFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackFooterItemLinkingCollectionsComponentFooterCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackFooterItemLinkingCollectionsComponentFooterCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackFooterItemLinkingCollectionsComponentFooterCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackFooterItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackFooterItemLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PackFooterItemLinkingCollectionsComponentFooterCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackFooterItemLinkingCollectionsComponentFooterCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackFooterItemOrder {
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packFreeFormPrivacyText) */
export type PackFreeFormPrivacyText = Entry & _Node & {
  __typename?: 'PackFreeFormPrivacyText';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<PackFreeFormPrivacyTextLinkingCollections>;
  sys: Sys;
  text?: Maybe<PackFreeFormPrivacyTextText>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packFreeFormPrivacyText) */
export type PackFreeFormPrivacyTextInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packFreeFormPrivacyText) */
export type PackFreeFormPrivacyTextLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packFreeFormPrivacyText) */
export type PackFreeFormPrivacyTextTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PackFreeFormPrivacyTextCollection = {
  __typename?: 'PackFreeFormPrivacyTextCollection';
  items: Array<Maybe<PackFreeFormPrivacyText>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PackFreeFormPrivacyTextCursorCollection = {
  __typename?: 'PackFreeFormPrivacyTextCursorCollection';
  items: Array<Maybe<PackFreeFormPrivacyText>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PackFreeFormPrivacyTextFilter = {
  AND?: InputMaybe<Array<InputMaybe<PackFreeFormPrivacyTextFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackFreeFormPrivacyTextFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
};

export type PackFreeFormPrivacyTextLinkingCollections = {
  __typename?: 'PackFreeFormPrivacyTextLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type PackFreeFormPrivacyTextLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackFreeFormPrivacyTextLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PackFreeFormPrivacyTextOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type PackFreeFormPrivacyTextText = {
  __typename?: 'PackFreeFormPrivacyTextText';
  json: Scalars['JSON']['output'];
  links: PackFreeFormPrivacyTextTextLinks;
};

export type PackFreeFormPrivacyTextTextAssets = {
  __typename?: 'PackFreeFormPrivacyTextTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type PackFreeFormPrivacyTextTextEntries = {
  __typename?: 'PackFreeFormPrivacyTextTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type PackFreeFormPrivacyTextTextLinks = {
  __typename?: 'PackFreeFormPrivacyTextTextLinks';
  assets: PackFreeFormPrivacyTextTextAssets;
  entries: PackFreeFormPrivacyTextTextEntries;
  resources: PackFreeFormPrivacyTextTextResources;
};

export type PackFreeFormPrivacyTextTextResources = {
  __typename?: 'PackFreeFormPrivacyTextTextResources';
  block: Array<PackFreeFormPrivacyTextTextResourcesBlock>;
  hyperlink: Array<PackFreeFormPrivacyTextTextResourcesHyperlink>;
  inline: Array<PackFreeFormPrivacyTextTextResourcesInline>;
};

export type PackFreeFormPrivacyTextTextResourcesBlock = ResourceLink & {
  __typename?: 'PackFreeFormPrivacyTextTextResourcesBlock';
  sys: ResourceSys;
};

export type PackFreeFormPrivacyTextTextResourcesHyperlink = ResourceLink & {
  __typename?: 'PackFreeFormPrivacyTextTextResourcesHyperlink';
  sys: ResourceSys;
};

export type PackFreeFormPrivacyTextTextResourcesInline = ResourceLink & {
  __typename?: 'PackFreeFormPrivacyTextTextResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packFreeFormText) */
export type PackFreeFormText = Entry & _Node & {
  __typename?: 'PackFreeFormText';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<PackFreeFormTextLinkingCollections>;
  sys: Sys;
  text?: Maybe<PackFreeFormTextText>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packFreeFormText) */
export type PackFreeFormTextInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packFreeFormText) */
export type PackFreeFormTextLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packFreeFormText) */
export type PackFreeFormTextTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PackFreeFormTextCollection = {
  __typename?: 'PackFreeFormTextCollection';
  items: Array<Maybe<PackFreeFormText>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PackFreeFormTextCursorCollection = {
  __typename?: 'PackFreeFormTextCursorCollection';
  items: Array<Maybe<PackFreeFormText>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PackFreeFormTextFilter = {
  AND?: InputMaybe<Array<InputMaybe<PackFreeFormTextFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackFreeFormTextFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
};

export type PackFreeFormTextLinkingCollections = {
  __typename?: 'PackFreeFormTextLinkingCollections';
  componentRecommendedContentAccordionCollection?: Maybe<ComponentRecommendedContentAccordionCollection>;
  componentRecommendedContentAccordionCursorCollection?: Maybe<ComponentRecommendedContentAccordionCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type PackFreeFormTextLinkingCollectionsComponentRecommendedContentAccordionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackFreeFormTextLinkingCollectionsComponentRecommendedContentAccordionCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackFreeFormTextLinkingCollectionsComponentRecommendedContentAccordionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackFreeFormTextLinkingCollectionsComponentRecommendedContentAccordionCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackFreeFormTextLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackFreeFormTextLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PackFreeFormTextLinkingCollectionsComponentRecommendedContentAccordionCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackFreeFormTextLinkingCollectionsComponentRecommendedContentAccordionCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackFreeFormTextOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type PackFreeFormTextText = {
  __typename?: 'PackFreeFormTextText';
  json: Scalars['JSON']['output'];
  links: PackFreeFormTextTextLinks;
};

export type PackFreeFormTextTextAssets = {
  __typename?: 'PackFreeFormTextTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type PackFreeFormTextTextEntries = {
  __typename?: 'PackFreeFormTextTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type PackFreeFormTextTextLinks = {
  __typename?: 'PackFreeFormTextTextLinks';
  assets: PackFreeFormTextTextAssets;
  entries: PackFreeFormTextTextEntries;
  resources: PackFreeFormTextTextResources;
};

export type PackFreeFormTextTextResources = {
  __typename?: 'PackFreeFormTextTextResources';
  block: Array<PackFreeFormTextTextResourcesBlock>;
  hyperlink: Array<PackFreeFormTextTextResourcesHyperlink>;
  inline: Array<PackFreeFormTextTextResourcesInline>;
};

export type PackFreeFormTextTextResourcesBlock = ResourceLink & {
  __typename?: 'PackFreeFormTextTextResourcesBlock';
  sys: ResourceSys;
};

export type PackFreeFormTextTextResourcesHyperlink = ResourceLink & {
  __typename?: 'PackFreeFormTextTextResourcesHyperlink';
  sys: ResourceSys;
};

export type PackFreeFormTextTextResourcesInline = ResourceLink & {
  __typename?: 'PackFreeFormTextTextResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packHighlightedText) */
export type PackHighlightedText = Entry & _Node & {
  __typename?: 'PackHighlightedText';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  highlighted?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<PackHighlightedTextLinkingCollections>;
  nonHighlighted?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packHighlightedText) */
export type PackHighlightedTextHighlightedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packHighlightedText) */
export type PackHighlightedTextLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packHighlightedText) */
export type PackHighlightedTextNonHighlightedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PackHighlightedTextCollection = {
  __typename?: 'PackHighlightedTextCollection';
  items: Array<Maybe<PackHighlightedText>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PackHighlightedTextCursorCollection = {
  __typename?: 'PackHighlightedTextCursorCollection';
  items: Array<Maybe<PackHighlightedText>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PackHighlightedTextFilter = {
  AND?: InputMaybe<Array<InputMaybe<PackHighlightedTextFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackHighlightedTextFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  highlighted?: InputMaybe<Scalars['String']['input']>;
  highlighted_contains?: InputMaybe<Scalars['String']['input']>;
  highlighted_exists?: InputMaybe<Scalars['Boolean']['input']>;
  highlighted_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  highlighted_not?: InputMaybe<Scalars['String']['input']>;
  highlighted_not_contains?: InputMaybe<Scalars['String']['input']>;
  highlighted_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonHighlighted?: InputMaybe<Scalars['String']['input']>;
  nonHighlighted_contains?: InputMaybe<Scalars['String']['input']>;
  nonHighlighted_exists?: InputMaybe<Scalars['Boolean']['input']>;
  nonHighlighted_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonHighlighted_not?: InputMaybe<Scalars['String']['input']>;
  nonHighlighted_not_contains?: InputMaybe<Scalars['String']['input']>;
  nonHighlighted_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type PackHighlightedTextLinkingCollections = {
  __typename?: 'PackHighlightedTextLinkingCollections';
  componentCalloutCollection?: Maybe<ComponentCalloutCollection>;
  componentCalloutCursorCollection?: Maybe<ComponentCalloutCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type PackHighlightedTextLinkingCollectionsComponentCalloutCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackHighlightedTextLinkingCollectionsComponentCalloutCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackHighlightedTextLinkingCollectionsComponentCalloutCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackHighlightedTextLinkingCollectionsComponentCalloutCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackHighlightedTextLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackHighlightedTextLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PackHighlightedTextLinkingCollectionsComponentCalloutCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackHighlightedTextLinkingCollectionsComponentCalloutCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackHighlightedTextOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packHomePage) */
export type PackHomePage = Entry & _Node & {
  __typename?: 'PackHomePage';
  _id: Scalars['ID']['output'];
  alertBanner?: Maybe<PackHomePageAlertBanner>;
  componentVariant?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  globalAlertBanner?: Maybe<PackHomePageGlobalAlertBanner>;
  header?: Maybe<Scalars['String']['output']>;
  headerText1?: Maybe<Scalars['String']['output']>;
  headerText2?: Maybe<Scalars['String']['output']>;
  headerVideo?: Maybe<PackHomePageHeaderVideo>;
  linkedFrom?: Maybe<PackHomePageLinkingCollections>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  ogImage?: Maybe<WrapperImage>;
  ogMetaDescription?: Maybe<Scalars['String']['output']>;
  ogMetaTitle?: Maybe<Scalars['String']['output']>;
  pageLevelTrustpilotBanner?: Maybe<PackHomePagePageLevelTrustpilotBanner>;
  postcodeSection?: Maybe<PackHomePagePostcodeSection>;
  sys: Sys;
  trustpilotBanner?: Maybe<Scalars['Boolean']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packHomePage) */
export type PackHomePageAlertBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packHomePage) */
export type PackHomePageComponentVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packHomePage) */
export type PackHomePageGlobalAlertBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packHomePage) */
export type PackHomePageHeaderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packHomePage) */
export type PackHomePageHeaderText1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packHomePage) */
export type PackHomePageHeaderText2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packHomePage) */
export type PackHomePageHeaderVideoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackHomePageHeaderVideoFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packHomePage) */
export type PackHomePageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packHomePage) */
export type PackHomePageMetaDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packHomePage) */
export type PackHomePageMetaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packHomePage) */
export type PackHomePageOgImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packHomePage) */
export type PackHomePageOgMetaDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packHomePage) */
export type PackHomePageOgMetaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packHomePage) */
export type PackHomePagePageLevelTrustpilotBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packHomePage) */
export type PackHomePagePostcodeSectionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packHomePage) */
export type PackHomePageTrustpilotBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PackHomePageAlertBanner = PackAlertBanner | VariationContainer;

export type PackHomePageCollection = {
  __typename?: 'PackHomePageCollection';
  items: Array<Maybe<PackHomePage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PackHomePageCursorCollection = {
  __typename?: 'PackHomePageCursorCollection';
  items: Array<Maybe<PackHomePage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PackHomePageFilter = {
  AND?: InputMaybe<Array<InputMaybe<PackHomePageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackHomePageFilter>>>;
  alertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  componentVariant?: InputMaybe<Scalars['String']['input']>;
  componentVariant_contains?: InputMaybe<Scalars['String']['input']>;
  componentVariant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  componentVariant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  componentVariant_not?: InputMaybe<Scalars['String']['input']>;
  componentVariant_not_contains?: InputMaybe<Scalars['String']['input']>;
  componentVariant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  globalAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  headerText1?: InputMaybe<Scalars['String']['input']>;
  headerText1_contains?: InputMaybe<Scalars['String']['input']>;
  headerText1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headerText1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headerText1_not?: InputMaybe<Scalars['String']['input']>;
  headerText1_not_contains?: InputMaybe<Scalars['String']['input']>;
  headerText1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headerText2?: InputMaybe<Scalars['String']['input']>;
  headerText2_contains?: InputMaybe<Scalars['String']['input']>;
  headerText2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headerText2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headerText2_not?: InputMaybe<Scalars['String']['input']>;
  headerText2_not_contains?: InputMaybe<Scalars['String']['input']>;
  headerText2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headerVideo?: InputMaybe<CfheaderVideoMultiTypeNestedFilter>;
  headerVideo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  header_contains?: InputMaybe<Scalars['String']['input']>;
  header_exists?: InputMaybe<Scalars['Boolean']['input']>;
  header_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  header_not?: InputMaybe<Scalars['String']['input']>;
  header_not_contains?: InputMaybe<Scalars['String']['input']>;
  header_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaDescription_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaDescription_not?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  metaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle_not?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogImage?: InputMaybe<CfWrapperImageNestedFilter>;
  ogImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ogMetaDescription?: InputMaybe<Scalars['String']['input']>;
  ogMetaDescription_contains?: InputMaybe<Scalars['String']['input']>;
  ogMetaDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ogMetaDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogMetaDescription_not?: InputMaybe<Scalars['String']['input']>;
  ogMetaDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  ogMetaDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogMetaTitle?: InputMaybe<Scalars['String']['input']>;
  ogMetaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  ogMetaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ogMetaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogMetaTitle_not?: InputMaybe<Scalars['String']['input']>;
  ogMetaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  ogMetaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageLevelTrustpilotBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  postcodeSection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  trustpilotBanner?: InputMaybe<Scalars['Boolean']['input']>;
  trustpilotBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  trustpilotBanner_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PackHomePageGlobalAlertBanner = PackAlertBanner | VariationContainer;

export type PackHomePageHeaderVideo = ContentType5OiHchWgV9Y8SuvDxHCaLy | ContentType5VCz5FHyZ2ZlWqa5OKh6Y9;

export type PackHomePageHeaderVideoFilter = {
  AND?: InputMaybe<Array<InputMaybe<PackHomePageHeaderVideoFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackHomePageHeaderVideoFilter>>>;
  altText?: InputMaybe<Scalars['String']['input']>;
  altText_contains?: InputMaybe<Scalars['String']['input']>;
  altText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  altText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  altText_not?: InputMaybe<Scalars['String']['input']>;
  altText_not_contains?: InputMaybe<Scalars['String']['input']>;
  altText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderId?: InputMaybe<Scalars['String']['input']>;
  bynderId_contains?: InputMaybe<Scalars['String']['input']>;
  bynderId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bynderId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderId_not?: InputMaybe<Scalars['String']['input']>;
  bynderId_not_contains?: InputMaybe<Scalars['String']['input']>;
  bynderId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PackHomePageLinkingCollections = {
  __typename?: 'PackHomePageLinkingCollections';
  buildLandingpageCollection?: Maybe<BuildLandingpageCollection>;
  buildLandingpageCursorCollection?: Maybe<BuildLandingpageCursorCollection>;
  buildTariffPageCollection?: Maybe<BuildTariffPageCollection>;
  buildTariffPageCursorCollection?: Maybe<BuildTariffPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type PackHomePageLinkingCollectionsBuildLandingpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackHomePageLinkingCollectionsBuildLandingpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackHomePageLinkingCollectionsBuildLandingpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackHomePageLinkingCollectionsBuildLandingpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackHomePageLinkingCollectionsBuildTariffPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackHomePageLinkingCollectionsBuildTariffPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackHomePageLinkingCollectionsBuildTariffPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackHomePageLinkingCollectionsBuildTariffPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackHomePageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackHomePageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PackHomePageLinkingCollectionsBuildLandingpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackHomePageLinkingCollectionsBuildLandingpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackHomePageLinkingCollectionsBuildTariffPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackHomePageLinkingCollectionsBuildTariffPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackHomePageOrder {
  ComponentVariantAsc = 'componentVariant_ASC',
  ComponentVariantDesc = 'componentVariant_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TrustpilotBannerAsc = 'trustpilotBanner_ASC',
  TrustpilotBannerDesc = 'trustpilotBanner_DESC'
}

export type PackHomePagePageLevelTrustpilotBanner = PackTrustpilotBanner | VariationContainer;

export type PackHomePagePostcodeSection = ComponentHomepageHeroPostcodeSection | VariationContainer;

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packLandingPageArticles) */
export type PackLandingPageArticles = Entry & _Node & {
  __typename?: 'PackLandingPageArticles';
  _id: Scalars['ID']['output'];
  alertBanner?: Maybe<PackLandingPageArticlesAlertBanner>;
  contentfulMetadata: ContentfulMetadata;
  featureArticle?: Maybe<BuildArticlePage>;
  header?: Maybe<Scalars['String']['output']>;
  headerText1?: Maybe<Scalars['String']['output']>;
  headerText2?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<PackLandingPageArticlesLinkingCollections>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  ogImage?: Maybe<WrapperImage>;
  ogMetaDescription?: Maybe<Scalars['String']['output']>;
  ogMetaTitle?: Maybe<Scalars['String']['output']>;
  searchBar?: Maybe<PackSearchBar>;
  sys: Sys;
  text?: Maybe<PackLandingPageArticlesText>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packLandingPageArticles) */
export type PackLandingPageArticlesAlertBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packLandingPageArticles) */
export type PackLandingPageArticlesFeatureArticleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildArticlePageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packLandingPageArticles) */
export type PackLandingPageArticlesHeaderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packLandingPageArticles) */
export type PackLandingPageArticlesHeaderText1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packLandingPageArticles) */
export type PackLandingPageArticlesHeaderText2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packLandingPageArticles) */
export type PackLandingPageArticlesLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packLandingPageArticles) */
export type PackLandingPageArticlesMetaDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packLandingPageArticles) */
export type PackLandingPageArticlesMetaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packLandingPageArticles) */
export type PackLandingPageArticlesOgImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packLandingPageArticles) */
export type PackLandingPageArticlesOgMetaDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packLandingPageArticles) */
export type PackLandingPageArticlesOgMetaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packLandingPageArticles) */
export type PackLandingPageArticlesSearchBarArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackSearchBarFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packLandingPageArticles) */
export type PackLandingPageArticlesTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PackLandingPageArticlesAlertBanner = PackAlertBanner | VariationContainer;

export type PackLandingPageArticlesCollection = {
  __typename?: 'PackLandingPageArticlesCollection';
  items: Array<Maybe<PackLandingPageArticles>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PackLandingPageArticlesCursorCollection = {
  __typename?: 'PackLandingPageArticlesCursorCollection';
  items: Array<Maybe<PackLandingPageArticles>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PackLandingPageArticlesFilter = {
  AND?: InputMaybe<Array<InputMaybe<PackLandingPageArticlesFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackLandingPageArticlesFilter>>>;
  alertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  featureArticle?: InputMaybe<CfBuildArticlePageNestedFilter>;
  featureArticle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  headerText1?: InputMaybe<Scalars['String']['input']>;
  headerText1_contains?: InputMaybe<Scalars['String']['input']>;
  headerText1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headerText1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headerText1_not?: InputMaybe<Scalars['String']['input']>;
  headerText1_not_contains?: InputMaybe<Scalars['String']['input']>;
  headerText1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headerText2?: InputMaybe<Scalars['String']['input']>;
  headerText2_contains?: InputMaybe<Scalars['String']['input']>;
  headerText2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headerText2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headerText2_not?: InputMaybe<Scalars['String']['input']>;
  headerText2_not_contains?: InputMaybe<Scalars['String']['input']>;
  headerText2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  header_contains?: InputMaybe<Scalars['String']['input']>;
  header_exists?: InputMaybe<Scalars['Boolean']['input']>;
  header_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  header_not?: InputMaybe<Scalars['String']['input']>;
  header_not_contains?: InputMaybe<Scalars['String']['input']>;
  header_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaDescription_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaDescription_not?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  metaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle_not?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogImage?: InputMaybe<CfWrapperImageNestedFilter>;
  ogImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ogMetaDescription?: InputMaybe<Scalars['String']['input']>;
  ogMetaDescription_contains?: InputMaybe<Scalars['String']['input']>;
  ogMetaDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ogMetaDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogMetaDescription_not?: InputMaybe<Scalars['String']['input']>;
  ogMetaDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  ogMetaDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogMetaTitle?: InputMaybe<Scalars['String']['input']>;
  ogMetaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  ogMetaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ogMetaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogMetaTitle_not?: InputMaybe<Scalars['String']['input']>;
  ogMetaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  ogMetaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchBar?: InputMaybe<CfPackSearchBarNestedFilter>;
  searchBar_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
};

export type PackLandingPageArticlesLinkingCollections = {
  __typename?: 'PackLandingPageArticlesLinkingCollections';
  buildArticlesLandingPageCollection?: Maybe<BuildArticlesLandingPageCollection>;
  buildArticlesLandingPageCursorCollection?: Maybe<BuildArticlesLandingPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type PackLandingPageArticlesLinkingCollectionsBuildArticlesLandingPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackLandingPageArticlesLinkingCollectionsBuildArticlesLandingPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackLandingPageArticlesLinkingCollectionsBuildArticlesLandingPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackLandingPageArticlesLinkingCollectionsBuildArticlesLandingPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackLandingPageArticlesLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackLandingPageArticlesLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PackLandingPageArticlesLinkingCollectionsBuildArticlesLandingPageCollectionOrder {
  ArticlesTypeAsc = 'articlesType_ASC',
  ArticlesTypeDesc = 'articlesType_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackLandingPageArticlesLinkingCollectionsBuildArticlesLandingPageCursorCollectionOrder {
  ArticlesTypeAsc = 'articlesType_ASC',
  ArticlesTypeDesc = 'articlesType_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackLandingPageArticlesOrder {
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type PackLandingPageArticlesText = {
  __typename?: 'PackLandingPageArticlesText';
  json: Scalars['JSON']['output'];
  links: PackLandingPageArticlesTextLinks;
};

export type PackLandingPageArticlesTextAssets = {
  __typename?: 'PackLandingPageArticlesTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type PackLandingPageArticlesTextEntries = {
  __typename?: 'PackLandingPageArticlesTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type PackLandingPageArticlesTextLinks = {
  __typename?: 'PackLandingPageArticlesTextLinks';
  assets: PackLandingPageArticlesTextAssets;
  entries: PackLandingPageArticlesTextEntries;
  resources: PackLandingPageArticlesTextResources;
};

export type PackLandingPageArticlesTextResources = {
  __typename?: 'PackLandingPageArticlesTextResources';
  block: Array<PackLandingPageArticlesTextResourcesBlock>;
  hyperlink: Array<PackLandingPageArticlesTextResourcesHyperlink>;
  inline: Array<PackLandingPageArticlesTextResourcesInline>;
};

export type PackLandingPageArticlesTextResourcesBlock = ResourceLink & {
  __typename?: 'PackLandingPageArticlesTextResourcesBlock';
  sys: ResourceSys;
};

export type PackLandingPageArticlesTextResourcesHyperlink = ResourceLink & {
  __typename?: 'PackLandingPageArticlesTextResourcesHyperlink';
  sys: ResourceSys;
};

export type PackLandingPageArticlesTextResourcesInline = ResourceLink & {
  __typename?: 'PackLandingPageArticlesTextResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packLottieAnimation) */
export type PackLottieAnimation = Entry & _Node & {
  __typename?: 'PackLottieAnimation';
  _id: Scalars['ID']['output'];
  altText?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<PackLottieAnimationLinkingCollections>;
  lottieJson?: Maybe<Scalars['JSON']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packLottieAnimation) */
export type PackLottieAnimationAltTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packLottieAnimation) */
export type PackLottieAnimationDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packLottieAnimation) */
export type PackLottieAnimationLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packLottieAnimation) */
export type PackLottieAnimationLottieJsonArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packLottieAnimation) */
export type PackLottieAnimationTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PackLottieAnimationCollection = {
  __typename?: 'PackLottieAnimationCollection';
  items: Array<Maybe<PackLottieAnimation>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PackLottieAnimationCursorCollection = {
  __typename?: 'PackLottieAnimationCursorCollection';
  items: Array<Maybe<PackLottieAnimation>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PackLottieAnimationFilter = {
  AND?: InputMaybe<Array<InputMaybe<PackLottieAnimationFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackLottieAnimationFilter>>>;
  altText?: InputMaybe<Scalars['String']['input']>;
  altText_contains?: InputMaybe<Scalars['String']['input']>;
  altText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  altText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  altText_not?: InputMaybe<Scalars['String']['input']>;
  altText_not_contains?: InputMaybe<Scalars['String']['input']>;
  altText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lottieJson_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PackLottieAnimationLinkingCollections = {
  __typename?: 'PackLottieAnimationLinkingCollections';
  componentUspSupportingContentCollection?: Maybe<ComponentUspSupportingContentCollection>;
  componentUspSupportingContentCursorCollection?: Maybe<ComponentUspSupportingContentCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type PackLottieAnimationLinkingCollectionsComponentUspSupportingContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackLottieAnimationLinkingCollectionsComponentUspSupportingContentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackLottieAnimationLinkingCollectionsComponentUspSupportingContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackLottieAnimationLinkingCollectionsComponentUspSupportingContentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackLottieAnimationLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackLottieAnimationLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PackLottieAnimationLinkingCollectionsComponentUspSupportingContentCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PackLottieAnimationLinkingCollectionsComponentUspSupportingContentCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PackLottieAnimationOrder {
  AltTextAsc = 'altText_ASC',
  AltTextDesc = 'altText_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packMicrocopy) */
export type PackMicrocopy = Entry & _Node & {
  __typename?: 'PackMicrocopy';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  label?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<PackMicrocopyLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packMicrocopy) */
export type PackMicrocopyLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packMicrocopy) */
export type PackMicrocopyLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PackMicrocopyCollection = {
  __typename?: 'PackMicrocopyCollection';
  items: Array<Maybe<PackMicrocopy>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PackMicrocopyCursorCollection = {
  __typename?: 'PackMicrocopyCursorCollection';
  items: Array<Maybe<PackMicrocopy>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PackMicrocopyFilter = {
  AND?: InputMaybe<Array<InputMaybe<PackMicrocopyFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackMicrocopyFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type PackMicrocopyLinkingCollections = {
  __typename?: 'PackMicrocopyLinkingCollections';
  componentFooterCollection?: Maybe<ComponentFooterCollection>;
  componentFooterCursorCollection?: Maybe<ComponentFooterCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type PackMicrocopyLinkingCollectionsComponentFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackMicrocopyLinkingCollectionsComponentFooterCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackMicrocopyLinkingCollectionsComponentFooterCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackMicrocopyLinkingCollectionsComponentFooterCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackMicrocopyLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackMicrocopyLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PackMicrocopyLinkingCollectionsComponentFooterCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackMicrocopyLinkingCollectionsComponentFooterCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackMicrocopyOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packNavBarCta) */
export type PackNavBarCta = Entry & _Node & {
  __typename?: 'PackNavBarCta';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  destination?: Maybe<PackNavBarCtaDestination>;
  hiddenText?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<WrapperIcon>;
  label?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<PackNavBarCtaLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packNavBarCta) */
export type PackNavBarCtaDestinationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packNavBarCta) */
export type PackNavBarCtaHiddenTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packNavBarCta) */
export type PackNavBarCtaIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperIconFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packNavBarCta) */
export type PackNavBarCtaLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packNavBarCta) */
export type PackNavBarCtaLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PackNavBarCtaCollection = {
  __typename?: 'PackNavBarCtaCollection';
  items: Array<Maybe<PackNavBarCta>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PackNavBarCtaCursorCollection = {
  __typename?: 'PackNavBarCtaCursorCollection';
  items: Array<Maybe<PackNavBarCta>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PackNavBarCtaDestination = BuildCategoryWebpage | BuildWebpage | WrapperUrl;

export type PackNavBarCtaFilter = {
  AND?: InputMaybe<Array<InputMaybe<PackNavBarCtaFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackNavBarCtaFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  destination_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenText?: InputMaybe<Scalars['String']['input']>;
  hiddenText_contains?: InputMaybe<Scalars['String']['input']>;
  hiddenText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenText_not?: InputMaybe<Scalars['String']['input']>;
  hiddenText_not_contains?: InputMaybe<Scalars['String']['input']>;
  hiddenText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon?: InputMaybe<CfWrapperIconNestedFilter>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type PackNavBarCtaLinkingCollections = {
  __typename?: 'PackNavBarCtaLinkingCollections';
  componentNavBarCollection?: Maybe<ComponentNavBarCollection>;
  componentNavBarCursorCollection?: Maybe<ComponentNavBarCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type PackNavBarCtaLinkingCollectionsComponentNavBarCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackNavBarCtaLinkingCollectionsComponentNavBarCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackNavBarCtaLinkingCollectionsComponentNavBarCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackNavBarCtaLinkingCollectionsComponentNavBarCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackNavBarCtaLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackNavBarCtaLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PackNavBarCtaLinkingCollectionsComponentNavBarCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackNavBarCtaLinkingCollectionsComponentNavBarCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackNavBarCtaOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packNavBarItem) */
export type PackNavBarItem = Entry & _Node & {
  __typename?: 'PackNavBarItem';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  destination?: Maybe<PackNavBarItemDestination>;
  hiddenText?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<PackNavBarItemLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packNavBarItem) */
export type PackNavBarItemDestinationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packNavBarItem) */
export type PackNavBarItemHiddenTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packNavBarItem) */
export type PackNavBarItemLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packNavBarItem) */
export type PackNavBarItemLevelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packNavBarItem) */
export type PackNavBarItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packNavBarItem) */
export type PackNavBarItemTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PackNavBarItemCollection = {
  __typename?: 'PackNavBarItemCollection';
  items: Array<Maybe<PackNavBarItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PackNavBarItemCursorCollection = {
  __typename?: 'PackNavBarItemCursorCollection';
  items: Array<Maybe<PackNavBarItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PackNavBarItemDestination = BuildCategoryWebpage | BuildWebpage | WrapperPath | WrapperUrl;

export type PackNavBarItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<PackNavBarItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackNavBarItemFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  destination_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenText?: InputMaybe<Scalars['String']['input']>;
  hiddenText_contains?: InputMaybe<Scalars['String']['input']>;
  hiddenText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenText_not?: InputMaybe<Scalars['String']['input']>;
  hiddenText_not_contains?: InputMaybe<Scalars['String']['input']>;
  hiddenText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  level?: InputMaybe<Scalars['String']['input']>;
  level_contains?: InputMaybe<Scalars['String']['input']>;
  level_exists?: InputMaybe<Scalars['Boolean']['input']>;
  level_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  level_not?: InputMaybe<Scalars['String']['input']>;
  level_not_contains?: InputMaybe<Scalars['String']['input']>;
  level_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PackNavBarItemLinkingCollections = {
  __typename?: 'PackNavBarItemLinkingCollections';
  componentNavBarCollection?: Maybe<ComponentNavBarCollection>;
  componentNavBarCursorCollection?: Maybe<ComponentNavBarCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type PackNavBarItemLinkingCollectionsComponentNavBarCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackNavBarItemLinkingCollectionsComponentNavBarCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackNavBarItemLinkingCollectionsComponentNavBarCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackNavBarItemLinkingCollectionsComponentNavBarCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackNavBarItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackNavBarItemLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PackNavBarItemLinkingCollectionsComponentNavBarCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackNavBarItemLinkingCollectionsComponentNavBarCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackNavBarItemOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packNavBarItemV2) */
export type PackNavBarItemV2 = Entry & _Node & {
  __typename?: 'PackNavBarItemV2';
  _id: Scalars['ID']['output'];
  backgroundSelector?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  destination?: Maybe<PackNavBarItemV2Destination>;
  hiddenText?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<PackNavBarItemV2LinkingCollections>;
  navPromo?: Maybe<ComponentContentBlockV2>;
  overviewText?: Maybe<PackStructuredText>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packNavBarItemV2) */
export type PackNavBarItemV2BackgroundSelectorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packNavBarItemV2) */
export type PackNavBarItemV2DestinationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packNavBarItemV2) */
export type PackNavBarItemV2HiddenTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packNavBarItemV2) */
export type PackNavBarItemV2LabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packNavBarItemV2) */
export type PackNavBarItemV2LevelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packNavBarItemV2) */
export type PackNavBarItemV2LinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packNavBarItemV2) */
export type PackNavBarItemV2NavPromoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentContentBlockV2Filter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packNavBarItemV2) */
export type PackNavBarItemV2OverviewTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackStructuredTextFilter>;
};

export type PackNavBarItemV2Collection = {
  __typename?: 'PackNavBarItemV2Collection';
  items: Array<Maybe<PackNavBarItemV2>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PackNavBarItemV2CursorCollection = {
  __typename?: 'PackNavBarItemV2CursorCollection';
  items: Array<Maybe<PackNavBarItemV2>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PackNavBarItemV2Destination = BuildCategoryWebpage | BuildWebpage | WrapperPath | WrapperUrl;

export type PackNavBarItemV2Filter = {
  AND?: InputMaybe<Array<InputMaybe<PackNavBarItemV2Filter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackNavBarItemV2Filter>>>;
  backgroundSelector?: InputMaybe<Scalars['String']['input']>;
  backgroundSelector_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundSelector_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundSelector_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundSelector_not?: InputMaybe<Scalars['String']['input']>;
  backgroundSelector_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundSelector_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  destination_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenText?: InputMaybe<Scalars['String']['input']>;
  hiddenText_contains?: InputMaybe<Scalars['String']['input']>;
  hiddenText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenText_not?: InputMaybe<Scalars['String']['input']>;
  hiddenText_not_contains?: InputMaybe<Scalars['String']['input']>;
  hiddenText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  level?: InputMaybe<Scalars['String']['input']>;
  level_contains?: InputMaybe<Scalars['String']['input']>;
  level_exists?: InputMaybe<Scalars['Boolean']['input']>;
  level_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  level_not?: InputMaybe<Scalars['String']['input']>;
  level_not_contains?: InputMaybe<Scalars['String']['input']>;
  level_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navPromo?: InputMaybe<CfComponentContentBlockV2NestedFilter>;
  navPromo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  overviewText?: InputMaybe<CfPackStructuredTextNestedFilter>;
  overviewText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type PackNavBarItemV2LinkingCollections = {
  __typename?: 'PackNavBarItemV2LinkingCollections';
  componentNavBarCollection?: Maybe<ComponentNavBarCollection>;
  componentNavBarCursorCollection?: Maybe<ComponentNavBarCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type PackNavBarItemV2LinkingCollectionsComponentNavBarCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackNavBarItemV2LinkingCollectionsComponentNavBarCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackNavBarItemV2LinkingCollectionsComponentNavBarCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackNavBarItemV2LinkingCollectionsComponentNavBarCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackNavBarItemV2LinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackNavBarItemV2LinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PackNavBarItemV2LinkingCollectionsComponentNavBarCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackNavBarItemV2LinkingCollectionsComponentNavBarCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackNavBarItemV2Order {
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageProductDetail) */
export type PackPageProductDetail = Entry & _Node & {
  __typename?: 'PackPageProductDetail';
  _id: Scalars['ID']['output'];
  alertBanner?: Maybe<PackPageProductDetailAlertBanner>;
  breadcrumbListCollection?: Maybe<PackPageProductDetailBreadcrumbListCollection>;
  breadcrumbListCursorCollection?: Maybe<PackPageProductDetailBreadcrumbListCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  ctaListCollection?: Maybe<PackPageProductDetailCtaListCollection>;
  ctaListCursorCollection?: Maybe<PackPageProductDetailCtaListCursorCollection>;
  header?: Maybe<Scalars['String']['output']>;
  imageGallery?: Maybe<ComponentImageGallery>;
  linkedFrom?: Maybe<PackPageProductDetailLinkingCollections>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  ogImage?: Maybe<WrapperImage>;
  ogMetaDescription?: Maybe<Scalars['String']['output']>;
  ogMetaTitle?: Maybe<Scalars['String']['output']>;
  smallText?: Maybe<PackPageProductDetailSmallText>;
  sys: Sys;
  text?: Maybe<PackPageProductDetailText>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageProductDetail) */
export type PackPageProductDetailAlertBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageProductDetail) */
export type PackPageProductDetailBreadcrumbListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackPageProductDetailBreadcrumbListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageProductDetail) */
export type PackPageProductDetailBreadcrumbListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackPageProductDetailBreadcrumbListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageProductDetail) */
export type PackPageProductDetailCtaListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackPageProductDetailCtaListFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageProductDetail) */
export type PackPageProductDetailCtaListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackPageProductDetailCtaListFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageProductDetail) */
export type PackPageProductDetailHeaderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageProductDetail) */
export type PackPageProductDetailImageGalleryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentImageGalleryFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageProductDetail) */
export type PackPageProductDetailLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageProductDetail) */
export type PackPageProductDetailMetaDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageProductDetail) */
export type PackPageProductDetailMetaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageProductDetail) */
export type PackPageProductDetailOgImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageProductDetail) */
export type PackPageProductDetailOgMetaDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageProductDetail) */
export type PackPageProductDetailOgMetaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageProductDetail) */
export type PackPageProductDetailSmallTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageProductDetail) */
export type PackPageProductDetailTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PackPageProductDetailAlertBanner = PackAlertBanner | VariationContainer;

export type PackPageProductDetailBreadcrumbListCollection = {
  __typename?: 'PackPageProductDetailBreadcrumbListCollection';
  items: Array<Maybe<PackCta>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum PackPageProductDetailBreadcrumbListCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export type PackPageProductDetailBreadcrumbListCursorCollection = {
  __typename?: 'PackPageProductDetailBreadcrumbListCursorCollection';
  items: Array<Maybe<PackCta>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum PackPageProductDetailBreadcrumbListCursorCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export type PackPageProductDetailCollection = {
  __typename?: 'PackPageProductDetailCollection';
  items: Array<Maybe<PackPageProductDetail>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PackPageProductDetailCtaListCollection = {
  __typename?: 'PackPageProductDetailCtaListCollection';
  items: Array<Maybe<PackPageProductDetailCtaListItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PackPageProductDetailCtaListCursorCollection = {
  __typename?: 'PackPageProductDetailCtaListCursorCollection';
  items: Array<Maybe<PackPageProductDetailCtaListItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PackPageProductDetailCtaListFilter = {
  AND?: InputMaybe<Array<InputMaybe<PackPageProductDetailCtaListFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackPageProductDetailCtaListFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type PackPageProductDetailCtaListItem = ComponentQrCodePopup | PackCta;

export type PackPageProductDetailCursorCollection = {
  __typename?: 'PackPageProductDetailCursorCollection';
  items: Array<Maybe<PackPageProductDetail>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PackPageProductDetailFilter = {
  AND?: InputMaybe<Array<InputMaybe<PackPageProductDetailFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackPageProductDetailFilter>>>;
  alertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  breadcrumbList?: InputMaybe<CfPackCtaNestedFilter>;
  breadcrumbListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctaList?: InputMaybe<CfctaListMultiTypeNestedFilter>;
  ctaListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  header_contains?: InputMaybe<Scalars['String']['input']>;
  header_exists?: InputMaybe<Scalars['Boolean']['input']>;
  header_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  header_not?: InputMaybe<Scalars['String']['input']>;
  header_not_contains?: InputMaybe<Scalars['String']['input']>;
  header_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageGallery?: InputMaybe<CfComponentImageGalleryNestedFilter>;
  imageGallery_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaDescription_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaDescription_not?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  metaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle_not?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogImage?: InputMaybe<CfWrapperImageNestedFilter>;
  ogImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ogMetaDescription?: InputMaybe<Scalars['String']['input']>;
  ogMetaDescription_contains?: InputMaybe<Scalars['String']['input']>;
  ogMetaDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ogMetaDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogMetaDescription_not?: InputMaybe<Scalars['String']['input']>;
  ogMetaDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  ogMetaDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogMetaTitle?: InputMaybe<Scalars['String']['input']>;
  ogMetaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  ogMetaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ogMetaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogMetaTitle_not?: InputMaybe<Scalars['String']['input']>;
  ogMetaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  ogMetaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  smallText_contains?: InputMaybe<Scalars['String']['input']>;
  smallText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  smallText_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
};

export type PackPageProductDetailLinkingCollections = {
  __typename?: 'PackPageProductDetailLinkingCollections';
  buildProductDetailPageCollection?: Maybe<BuildProductDetailPageCollection>;
  buildProductDetailPageCursorCollection?: Maybe<BuildProductDetailPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type PackPageProductDetailLinkingCollectionsBuildProductDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackPageProductDetailLinkingCollectionsBuildProductDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackPageProductDetailLinkingCollectionsBuildProductDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackPageProductDetailLinkingCollectionsBuildProductDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackPageProductDetailLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackPageProductDetailLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PackPageProductDetailLinkingCollectionsBuildProductDetailPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackPageProductDetailLinkingCollectionsBuildProductDetailPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackPageProductDetailOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type PackPageProductDetailSmallText = {
  __typename?: 'PackPageProductDetailSmallText';
  json: Scalars['JSON']['output'];
  links: PackPageProductDetailSmallTextLinks;
};

export type PackPageProductDetailSmallTextAssets = {
  __typename?: 'PackPageProductDetailSmallTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type PackPageProductDetailSmallTextEntries = {
  __typename?: 'PackPageProductDetailSmallTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type PackPageProductDetailSmallTextLinks = {
  __typename?: 'PackPageProductDetailSmallTextLinks';
  assets: PackPageProductDetailSmallTextAssets;
  entries: PackPageProductDetailSmallTextEntries;
  resources: PackPageProductDetailSmallTextResources;
};

export type PackPageProductDetailSmallTextResources = {
  __typename?: 'PackPageProductDetailSmallTextResources';
  block: Array<PackPageProductDetailSmallTextResourcesBlock>;
  hyperlink: Array<PackPageProductDetailSmallTextResourcesHyperlink>;
  inline: Array<PackPageProductDetailSmallTextResourcesInline>;
};

export type PackPageProductDetailSmallTextResourcesBlock = ResourceLink & {
  __typename?: 'PackPageProductDetailSmallTextResourcesBlock';
  sys: ResourceSys;
};

export type PackPageProductDetailSmallTextResourcesHyperlink = ResourceLink & {
  __typename?: 'PackPageProductDetailSmallTextResourcesHyperlink';
  sys: ResourceSys;
};

export type PackPageProductDetailSmallTextResourcesInline = ResourceLink & {
  __typename?: 'PackPageProductDetailSmallTextResourcesInline';
  sys: ResourceSys;
};

export type PackPageProductDetailText = {
  __typename?: 'PackPageProductDetailText';
  json: Scalars['JSON']['output'];
  links: PackPageProductDetailTextLinks;
};

export type PackPageProductDetailTextAssets = {
  __typename?: 'PackPageProductDetailTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type PackPageProductDetailTextEntries = {
  __typename?: 'PackPageProductDetailTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type PackPageProductDetailTextLinks = {
  __typename?: 'PackPageProductDetailTextLinks';
  assets: PackPageProductDetailTextAssets;
  entries: PackPageProductDetailTextEntries;
  resources: PackPageProductDetailTextResources;
};

export type PackPageProductDetailTextResources = {
  __typename?: 'PackPageProductDetailTextResources';
  block: Array<PackPageProductDetailTextResourcesBlock>;
  hyperlink: Array<PackPageProductDetailTextResourcesHyperlink>;
  inline: Array<PackPageProductDetailTextResourcesInline>;
};

export type PackPageProductDetailTextResourcesBlock = ResourceLink & {
  __typename?: 'PackPageProductDetailTextResourcesBlock';
  sys: ResourceSys;
};

export type PackPageProductDetailTextResourcesHyperlink = ResourceLink & {
  __typename?: 'PackPageProductDetailTextResourcesHyperlink';
  sys: ResourceSys;
};

export type PackPageProductDetailTextResourcesInline = ResourceLink & {
  __typename?: 'PackPageProductDetailTextResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandard) */
export type PackPageStandard = Entry & _Node & {
  __typename?: 'PackPageStandard';
  _id: Scalars['ID']['output'];
  alertBanner?: Maybe<PackPageStandardAlertBanner>;
  bannerBynderMedia?: Maybe<PackPageStandardBannerBynderMedia>;
  bannerImage?: Maybe<WrapperBannerImage>;
  bannerTextPosition?: Maybe<Scalars['Boolean']['output']>;
  contentfulMetadata: ContentfulMetadata;
  header?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<PackPageStandardLinkingCollections>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  ogImage?: Maybe<WrapperImage>;
  ogMetaDescription?: Maybe<Scalars['String']['output']>;
  ogMetaTitle?: Maybe<Scalars['String']['output']>;
  searchBar?: Maybe<PackSearchBar>;
  subheader?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  text?: Maybe<PackPageStandardText>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandard) */
export type PackPageStandardAlertBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandard) */
export type PackPageStandardBannerBynderMediaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackPageStandardBannerBynderMediaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandard) */
export type PackPageStandardBannerImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperBannerImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandard) */
export type PackPageStandardBannerTextPositionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandard) */
export type PackPageStandardHeaderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandard) */
export type PackPageStandardLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandard) */
export type PackPageStandardMetaDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandard) */
export type PackPageStandardMetaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandard) */
export type PackPageStandardOgImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandard) */
export type PackPageStandardOgMetaDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandard) */
export type PackPageStandardOgMetaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandard) */
export type PackPageStandardSearchBarArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackSearchBarFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandard) */
export type PackPageStandardSubheaderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandard) */
export type PackPageStandardTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PackPageStandardAlertBanner = PackAlertBanner | VariationContainer;

export type PackPageStandardBannerBynderMedia = ContentType5OiHchWgV9Y8SuvDxHCaLy | ContentType5VCz5FHyZ2ZlWqa5OKh6Y9;

export type PackPageStandardBannerBynderMediaFilter = {
  AND?: InputMaybe<Array<InputMaybe<PackPageStandardBannerBynderMediaFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackPageStandardBannerBynderMediaFilter>>>;
  altText?: InputMaybe<Scalars['String']['input']>;
  altText_contains?: InputMaybe<Scalars['String']['input']>;
  altText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  altText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  altText_not?: InputMaybe<Scalars['String']['input']>;
  altText_not_contains?: InputMaybe<Scalars['String']['input']>;
  altText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderId?: InputMaybe<Scalars['String']['input']>;
  bynderId_contains?: InputMaybe<Scalars['String']['input']>;
  bynderId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bynderId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderId_not?: InputMaybe<Scalars['String']['input']>;
  bynderId_not_contains?: InputMaybe<Scalars['String']['input']>;
  bynderId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PackPageStandardCollection = {
  __typename?: 'PackPageStandardCollection';
  items: Array<Maybe<PackPageStandard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PackPageStandardCursorCollection = {
  __typename?: 'PackPageStandardCursorCollection';
  items: Array<Maybe<PackPageStandard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PackPageStandardFilter = {
  AND?: InputMaybe<Array<InputMaybe<PackPageStandardFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackPageStandardFilter>>>;
  alertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bannerBynderMedia?: InputMaybe<CfbannerBynderMediaMultiTypeNestedFilter>;
  bannerBynderMedia_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bannerImage?: InputMaybe<CfWrapperBannerImageNestedFilter>;
  bannerImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bannerTextPosition?: InputMaybe<Scalars['Boolean']['input']>;
  bannerTextPosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bannerTextPosition_not?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  header?: InputMaybe<Scalars['String']['input']>;
  header_contains?: InputMaybe<Scalars['String']['input']>;
  header_exists?: InputMaybe<Scalars['Boolean']['input']>;
  header_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  header_not?: InputMaybe<Scalars['String']['input']>;
  header_not_contains?: InputMaybe<Scalars['String']['input']>;
  header_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaDescription_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaDescription_not?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  metaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle_not?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogImage?: InputMaybe<CfWrapperImageNestedFilter>;
  ogImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ogMetaDescription?: InputMaybe<Scalars['String']['input']>;
  ogMetaDescription_contains?: InputMaybe<Scalars['String']['input']>;
  ogMetaDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ogMetaDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogMetaDescription_not?: InputMaybe<Scalars['String']['input']>;
  ogMetaDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  ogMetaDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogMetaTitle?: InputMaybe<Scalars['String']['input']>;
  ogMetaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  ogMetaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ogMetaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogMetaTitle_not?: InputMaybe<Scalars['String']['input']>;
  ogMetaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  ogMetaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchBar?: InputMaybe<CfPackSearchBarNestedFilter>;
  searchBar_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subheader?: InputMaybe<Scalars['String']['input']>;
  subheader_contains?: InputMaybe<Scalars['String']['input']>;
  subheader_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subheader_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subheader_not?: InputMaybe<Scalars['String']['input']>;
  subheader_not_contains?: InputMaybe<Scalars['String']['input']>;
  subheader_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
};

export type PackPageStandardLinkingCollections = {
  __typename?: 'PackPageStandardLinkingCollections';
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildCategoryWebpageCollection?: Maybe<BuildCategoryWebpageCollection>;
  buildCategoryWebpageCursorCollection?: Maybe<BuildCategoryWebpageCursorCollection>;
  buildGenericTemplatePageCollection?: Maybe<BuildGenericTemplatePageCollection>;
  buildGenericTemplatePageCursorCollection?: Maybe<BuildGenericTemplatePageCursorCollection>;
  buildLandingpageCollection?: Maybe<BuildLandingpageCollection>;
  buildLandingpageCursorCollection?: Maybe<BuildLandingpageCursorCollection>;
  buildProductOverviewPageCollection?: Maybe<BuildProductOverviewPageCollection>;
  buildProductOverviewPageCursorCollection?: Maybe<BuildProductOverviewPageCursorCollection>;
  buildTariffPageCollection?: Maybe<BuildTariffPageCollection>;
  buildTariffPageCursorCollection?: Maybe<BuildTariffPageCursorCollection>;
  buildWebpageCollection?: Maybe<BuildWebpageCollection>;
  buildWebpageCursorCollection?: Maybe<BuildWebpageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type PackPageStandardLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackPageStandardLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackPageStandardLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackPageStandardLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackPageStandardLinkingCollectionsBuildCategoryWebpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackPageStandardLinkingCollectionsBuildCategoryWebpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackPageStandardLinkingCollectionsBuildCategoryWebpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackPageStandardLinkingCollectionsBuildCategoryWebpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackPageStandardLinkingCollectionsBuildGenericTemplatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackPageStandardLinkingCollectionsBuildGenericTemplatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackPageStandardLinkingCollectionsBuildGenericTemplatePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackPageStandardLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackPageStandardLinkingCollectionsBuildLandingpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackPageStandardLinkingCollectionsBuildLandingpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackPageStandardLinkingCollectionsBuildLandingpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackPageStandardLinkingCollectionsBuildLandingpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackPageStandardLinkingCollectionsBuildProductOverviewPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackPageStandardLinkingCollectionsBuildProductOverviewPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackPageStandardLinkingCollectionsBuildProductOverviewPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackPageStandardLinkingCollectionsBuildProductOverviewPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackPageStandardLinkingCollectionsBuildTariffPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackPageStandardLinkingCollectionsBuildTariffPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackPageStandardLinkingCollectionsBuildTariffPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackPageStandardLinkingCollectionsBuildTariffPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackPageStandardLinkingCollectionsBuildWebpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackPageStandardLinkingCollectionsBuildWebpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackPageStandardLinkingCollectionsBuildWebpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackPageStandardLinkingCollectionsBuildWebpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackPageStandardLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackPageStandardLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PackPageStandardLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackPageStandardLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackPageStandardLinkingCollectionsBuildCategoryWebpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PathnameAsc = 'pathname_ASC',
  PathnameDesc = 'pathname_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackPageStandardLinkingCollectionsBuildCategoryWebpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PathnameAsc = 'pathname_ASC',
  PathnameDesc = 'pathname_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackPageStandardLinkingCollectionsBuildGenericTemplatePageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackPageStandardLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackPageStandardLinkingCollectionsBuildLandingpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackPageStandardLinkingCollectionsBuildLandingpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackPageStandardLinkingCollectionsBuildProductOverviewPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackPageStandardLinkingCollectionsBuildProductOverviewPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackPageStandardLinkingCollectionsBuildTariffPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackPageStandardLinkingCollectionsBuildTariffPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackPageStandardLinkingCollectionsBuildWebpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackPageStandardLinkingCollectionsBuildWebpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackPageStandardOrder {
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type PackPageStandardText = {
  __typename?: 'PackPageStandardText';
  json: Scalars['JSON']['output'];
  links: PackPageStandardTextLinks;
};

export type PackPageStandardTextAssets = {
  __typename?: 'PackPageStandardTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type PackPageStandardTextEntries = {
  __typename?: 'PackPageStandardTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type PackPageStandardTextLinks = {
  __typename?: 'PackPageStandardTextLinks';
  assets: PackPageStandardTextAssets;
  entries: PackPageStandardTextEntries;
  resources: PackPageStandardTextResources;
};

export type PackPageStandardTextResources = {
  __typename?: 'PackPageStandardTextResources';
  block: Array<PackPageStandardTextResourcesBlock>;
  hyperlink: Array<PackPageStandardTextResourcesHyperlink>;
  inline: Array<PackPageStandardTextResourcesInline>;
};

export type PackPageStandardTextResourcesBlock = ResourceLink & {
  __typename?: 'PackPageStandardTextResourcesBlock';
  sys: ResourceSys;
};

export type PackPageStandardTextResourcesHyperlink = ResourceLink & {
  __typename?: 'PackPageStandardTextResourcesHyperlink';
  sys: ResourceSys;
};

export type PackPageStandardTextResourcesInline = ResourceLink & {
  __typename?: 'PackPageStandardTextResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandardV2) */
export type PackPageStandardV2 = Entry & _Node & {
  __typename?: 'PackPageStandardV2';
  _id: Scalars['ID']['output'];
  alertBanner?: Maybe<PackPageStandardV2AlertBanner>;
  bannerBynderMedia?: Maybe<PackPageStandardV2BannerBynderMedia>;
  bannerImage?: Maybe<WrapperBannerImage>;
  bannerTextPosition?: Maybe<Scalars['Boolean']['output']>;
  contentfulMetadata: ContentfulMetadata;
  header?: Maybe<Scalars['String']['output']>;
  headerText1?: Maybe<Scalars['String']['output']>;
  headerText2?: Maybe<Scalars['String']['output']>;
  imageInHeader?: Maybe<WrapperImage>;
  linkedFrom?: Maybe<PackPageStandardV2LinkingCollections>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  ogImage?: Maybe<WrapperImage>;
  ogMetaDescription?: Maybe<Scalars['String']['output']>;
  ogMetaTitle?: Maybe<Scalars['String']['output']>;
  searchBar?: Maybe<PackSearchBar>;
  subheader?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  text?: Maybe<PackPageStandardV2Text>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandardV2) */
export type PackPageStandardV2AlertBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandardV2) */
export type PackPageStandardV2BannerBynderMediaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackPageStandardV2BannerBynderMediaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandardV2) */
export type PackPageStandardV2BannerImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperBannerImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandardV2) */
export type PackPageStandardV2BannerTextPositionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandardV2) */
export type PackPageStandardV2HeaderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandardV2) */
export type PackPageStandardV2HeaderText1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandardV2) */
export type PackPageStandardV2HeaderText2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandardV2) */
export type PackPageStandardV2ImageInHeaderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandardV2) */
export type PackPageStandardV2LinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandardV2) */
export type PackPageStandardV2MetaDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandardV2) */
export type PackPageStandardV2MetaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandardV2) */
export type PackPageStandardV2OgImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandardV2) */
export type PackPageStandardV2OgMetaDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandardV2) */
export type PackPageStandardV2OgMetaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandardV2) */
export type PackPageStandardV2SearchBarArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackSearchBarFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandardV2) */
export type PackPageStandardV2SubheaderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandardV2) */
export type PackPageStandardV2TextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PackPageStandardV2AlertBanner = PackAlertBanner | VariationContainer;

export type PackPageStandardV2BannerBynderMedia = ContentType5OiHchWgV9Y8SuvDxHCaLy | ContentType5VCz5FHyZ2ZlWqa5OKh6Y9;

export type PackPageStandardV2BannerBynderMediaFilter = {
  AND?: InputMaybe<Array<InputMaybe<PackPageStandardV2BannerBynderMediaFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackPageStandardV2BannerBynderMediaFilter>>>;
  altText?: InputMaybe<Scalars['String']['input']>;
  altText_contains?: InputMaybe<Scalars['String']['input']>;
  altText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  altText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  altText_not?: InputMaybe<Scalars['String']['input']>;
  altText_not_contains?: InputMaybe<Scalars['String']['input']>;
  altText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderId?: InputMaybe<Scalars['String']['input']>;
  bynderId_contains?: InputMaybe<Scalars['String']['input']>;
  bynderId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bynderId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderId_not?: InputMaybe<Scalars['String']['input']>;
  bynderId_not_contains?: InputMaybe<Scalars['String']['input']>;
  bynderId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PackPageStandardV2Collection = {
  __typename?: 'PackPageStandardV2Collection';
  items: Array<Maybe<PackPageStandardV2>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PackPageStandardV2CursorCollection = {
  __typename?: 'PackPageStandardV2CursorCollection';
  items: Array<Maybe<PackPageStandardV2>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandardV2Dev) */
export type PackPageStandardV2Dev = Entry & _Node & {
  __typename?: 'PackPageStandardV2Dev';
  _id: Scalars['ID']['output'];
  alertBanner?: Maybe<PackAlertBanner>;
  bannerImage?: Maybe<WrapperBannerImage>;
  contentfulMetadata: ContentfulMetadata;
  header?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<PackPageStandardV2DevLinkingCollections>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  ogImage?: Maybe<WrapperImage>;
  ogMetaDescription?: Maybe<Scalars['String']['output']>;
  ogMetaTitle?: Maybe<Scalars['String']['output']>;
  searchBar?: Maybe<PackSearchBar>;
  subheader?: Maybe<Scalars['String']['output']>;
  subheader2?: Maybe<Scalars['String']['output']>;
  subheaderColour?: Maybe<Scalars['JSON']['output']>;
  subheaderColour2?: Maybe<Scalars['JSON']['output']>;
  sys: Sys;
  text?: Maybe<PackPageStandardV2DevText>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandardV2Dev) */
export type PackPageStandardV2DevAlertBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackAlertBannerFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandardV2Dev) */
export type PackPageStandardV2DevBannerImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperBannerImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandardV2Dev) */
export type PackPageStandardV2DevHeaderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandardV2Dev) */
export type PackPageStandardV2DevLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandardV2Dev) */
export type PackPageStandardV2DevMetaDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandardV2Dev) */
export type PackPageStandardV2DevMetaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandardV2Dev) */
export type PackPageStandardV2DevOgImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandardV2Dev) */
export type PackPageStandardV2DevOgMetaDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandardV2Dev) */
export type PackPageStandardV2DevOgMetaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandardV2Dev) */
export type PackPageStandardV2DevSearchBarArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackSearchBarFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandardV2Dev) */
export type PackPageStandardV2DevSubheaderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandardV2Dev) */
export type PackPageStandardV2DevSubheader2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandardV2Dev) */
export type PackPageStandardV2DevSubheaderColourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandardV2Dev) */
export type PackPageStandardV2DevSubheaderColour2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packPageStandardV2Dev) */
export type PackPageStandardV2DevTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PackPageStandardV2DevCollection = {
  __typename?: 'PackPageStandardV2DevCollection';
  items: Array<Maybe<PackPageStandardV2Dev>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PackPageStandardV2DevCursorCollection = {
  __typename?: 'PackPageStandardV2DevCursorCollection';
  items: Array<Maybe<PackPageStandardV2Dev>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PackPageStandardV2DevFilter = {
  AND?: InputMaybe<Array<InputMaybe<PackPageStandardV2DevFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackPageStandardV2DevFilter>>>;
  alertBanner?: InputMaybe<CfPackAlertBannerNestedFilter>;
  alertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bannerImage?: InputMaybe<CfWrapperBannerImageNestedFilter>;
  bannerImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  header?: InputMaybe<Scalars['String']['input']>;
  header_contains?: InputMaybe<Scalars['String']['input']>;
  header_exists?: InputMaybe<Scalars['Boolean']['input']>;
  header_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  header_not?: InputMaybe<Scalars['String']['input']>;
  header_not_contains?: InputMaybe<Scalars['String']['input']>;
  header_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaDescription_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaDescription_not?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  metaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle_not?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogImage?: InputMaybe<CfWrapperImageNestedFilter>;
  ogImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ogMetaDescription?: InputMaybe<Scalars['String']['input']>;
  ogMetaDescription_contains?: InputMaybe<Scalars['String']['input']>;
  ogMetaDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ogMetaDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogMetaDescription_not?: InputMaybe<Scalars['String']['input']>;
  ogMetaDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  ogMetaDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogMetaTitle?: InputMaybe<Scalars['String']['input']>;
  ogMetaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  ogMetaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ogMetaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogMetaTitle_not?: InputMaybe<Scalars['String']['input']>;
  ogMetaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  ogMetaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchBar?: InputMaybe<CfPackSearchBarNestedFilter>;
  searchBar_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subheader?: InputMaybe<Scalars['String']['input']>;
  subheader2?: InputMaybe<Scalars['String']['input']>;
  subheader2_contains?: InputMaybe<Scalars['String']['input']>;
  subheader2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subheader2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subheader2_not?: InputMaybe<Scalars['String']['input']>;
  subheader2_not_contains?: InputMaybe<Scalars['String']['input']>;
  subheader2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subheaderColour2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subheaderColour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subheader_contains?: InputMaybe<Scalars['String']['input']>;
  subheader_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subheader_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subheader_not?: InputMaybe<Scalars['String']['input']>;
  subheader_not_contains?: InputMaybe<Scalars['String']['input']>;
  subheader_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
};

export type PackPageStandardV2DevLinkingCollections = {
  __typename?: 'PackPageStandardV2DevLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type PackPageStandardV2DevLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackPageStandardV2DevLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PackPageStandardV2DevOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  Subheader2Asc = 'subheader2_ASC',
  Subheader2Desc = 'subheader2_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type PackPageStandardV2DevText = {
  __typename?: 'PackPageStandardV2DevText';
  json: Scalars['JSON']['output'];
  links: PackPageStandardV2DevTextLinks;
};

export type PackPageStandardV2DevTextAssets = {
  __typename?: 'PackPageStandardV2DevTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type PackPageStandardV2DevTextEntries = {
  __typename?: 'PackPageStandardV2DevTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type PackPageStandardV2DevTextLinks = {
  __typename?: 'PackPageStandardV2DevTextLinks';
  assets: PackPageStandardV2DevTextAssets;
  entries: PackPageStandardV2DevTextEntries;
  resources: PackPageStandardV2DevTextResources;
};

export type PackPageStandardV2DevTextResources = {
  __typename?: 'PackPageStandardV2DevTextResources';
  block: Array<PackPageStandardV2DevTextResourcesBlock>;
  hyperlink: Array<PackPageStandardV2DevTextResourcesHyperlink>;
  inline: Array<PackPageStandardV2DevTextResourcesInline>;
};

export type PackPageStandardV2DevTextResourcesBlock = ResourceLink & {
  __typename?: 'PackPageStandardV2DevTextResourcesBlock';
  sys: ResourceSys;
};

export type PackPageStandardV2DevTextResourcesHyperlink = ResourceLink & {
  __typename?: 'PackPageStandardV2DevTextResourcesHyperlink';
  sys: ResourceSys;
};

export type PackPageStandardV2DevTextResourcesInline = ResourceLink & {
  __typename?: 'PackPageStandardV2DevTextResourcesInline';
  sys: ResourceSys;
};

export type PackPageStandardV2Filter = {
  AND?: InputMaybe<Array<InputMaybe<PackPageStandardV2Filter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackPageStandardV2Filter>>>;
  alertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bannerBynderMedia?: InputMaybe<CfbannerBynderMediaMultiTypeNestedFilter>;
  bannerBynderMedia_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bannerImage?: InputMaybe<CfWrapperBannerImageNestedFilter>;
  bannerImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bannerTextPosition?: InputMaybe<Scalars['Boolean']['input']>;
  bannerTextPosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bannerTextPosition_not?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  header?: InputMaybe<Scalars['String']['input']>;
  headerText1?: InputMaybe<Scalars['String']['input']>;
  headerText1_contains?: InputMaybe<Scalars['String']['input']>;
  headerText1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headerText1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headerText1_not?: InputMaybe<Scalars['String']['input']>;
  headerText1_not_contains?: InputMaybe<Scalars['String']['input']>;
  headerText1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headerText2?: InputMaybe<Scalars['String']['input']>;
  headerText2_contains?: InputMaybe<Scalars['String']['input']>;
  headerText2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headerText2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headerText2_not?: InputMaybe<Scalars['String']['input']>;
  headerText2_not_contains?: InputMaybe<Scalars['String']['input']>;
  headerText2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  header_contains?: InputMaybe<Scalars['String']['input']>;
  header_exists?: InputMaybe<Scalars['Boolean']['input']>;
  header_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  header_not?: InputMaybe<Scalars['String']['input']>;
  header_not_contains?: InputMaybe<Scalars['String']['input']>;
  header_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageInHeader?: InputMaybe<CfWrapperImageNestedFilter>;
  imageInHeader_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaDescription_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaDescription_not?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  metaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle_not?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogImage?: InputMaybe<CfWrapperImageNestedFilter>;
  ogImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ogMetaDescription?: InputMaybe<Scalars['String']['input']>;
  ogMetaDescription_contains?: InputMaybe<Scalars['String']['input']>;
  ogMetaDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ogMetaDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogMetaDescription_not?: InputMaybe<Scalars['String']['input']>;
  ogMetaDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  ogMetaDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogMetaTitle?: InputMaybe<Scalars['String']['input']>;
  ogMetaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  ogMetaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ogMetaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogMetaTitle_not?: InputMaybe<Scalars['String']['input']>;
  ogMetaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  ogMetaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchBar?: InputMaybe<CfPackSearchBarNestedFilter>;
  searchBar_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subheader?: InputMaybe<Scalars['String']['input']>;
  subheader_contains?: InputMaybe<Scalars['String']['input']>;
  subheader_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subheader_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subheader_not?: InputMaybe<Scalars['String']['input']>;
  subheader_not_contains?: InputMaybe<Scalars['String']['input']>;
  subheader_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
};

export type PackPageStandardV2LinkingCollections = {
  __typename?: 'PackPageStandardV2LinkingCollections';
  buildGenericTemplatePageCollection?: Maybe<BuildGenericTemplatePageCollection>;
  buildGenericTemplatePageCursorCollection?: Maybe<BuildGenericTemplatePageCursorCollection>;
  buildLandingpageCollection?: Maybe<BuildLandingpageCollection>;
  buildLandingpageCursorCollection?: Maybe<BuildLandingpageCursorCollection>;
  buildProductOverviewPageCollection?: Maybe<BuildProductOverviewPageCollection>;
  buildProductOverviewPageCursorCollection?: Maybe<BuildProductOverviewPageCursorCollection>;
  buildTariffPageCollection?: Maybe<BuildTariffPageCollection>;
  buildTariffPageCursorCollection?: Maybe<BuildTariffPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type PackPageStandardV2LinkingCollectionsBuildGenericTemplatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackPageStandardV2LinkingCollectionsBuildGenericTemplatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackPageStandardV2LinkingCollectionsBuildGenericTemplatePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackPageStandardV2LinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackPageStandardV2LinkingCollectionsBuildLandingpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackPageStandardV2LinkingCollectionsBuildLandingpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackPageStandardV2LinkingCollectionsBuildLandingpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackPageStandardV2LinkingCollectionsBuildLandingpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackPageStandardV2LinkingCollectionsBuildProductOverviewPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackPageStandardV2LinkingCollectionsBuildProductOverviewPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackPageStandardV2LinkingCollectionsBuildProductOverviewPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackPageStandardV2LinkingCollectionsBuildProductOverviewPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackPageStandardV2LinkingCollectionsBuildTariffPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackPageStandardV2LinkingCollectionsBuildTariffPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackPageStandardV2LinkingCollectionsBuildTariffPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackPageStandardV2LinkingCollectionsBuildTariffPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackPageStandardV2LinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackPageStandardV2LinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PackPageStandardV2LinkingCollectionsBuildGenericTemplatePageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackPageStandardV2LinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackPageStandardV2LinkingCollectionsBuildLandingpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackPageStandardV2LinkingCollectionsBuildLandingpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackPageStandardV2LinkingCollectionsBuildProductOverviewPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackPageStandardV2LinkingCollectionsBuildProductOverviewPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackPageStandardV2LinkingCollectionsBuildTariffPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackPageStandardV2LinkingCollectionsBuildTariffPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackPageStandardV2Order {
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type PackPageStandardV2Text = {
  __typename?: 'PackPageStandardV2Text';
  json: Scalars['JSON']['output'];
  links: PackPageStandardV2TextLinks;
};

export type PackPageStandardV2TextAssets = {
  __typename?: 'PackPageStandardV2TextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type PackPageStandardV2TextEntries = {
  __typename?: 'PackPageStandardV2TextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type PackPageStandardV2TextLinks = {
  __typename?: 'PackPageStandardV2TextLinks';
  assets: PackPageStandardV2TextAssets;
  entries: PackPageStandardV2TextEntries;
  resources: PackPageStandardV2TextResources;
};

export type PackPageStandardV2TextResources = {
  __typename?: 'PackPageStandardV2TextResources';
  block: Array<PackPageStandardV2TextResourcesBlock>;
  hyperlink: Array<PackPageStandardV2TextResourcesHyperlink>;
  inline: Array<PackPageStandardV2TextResourcesInline>;
};

export type PackPageStandardV2TextResourcesBlock = ResourceLink & {
  __typename?: 'PackPageStandardV2TextResourcesBlock';
  sys: ResourceSys;
};

export type PackPageStandardV2TextResourcesHyperlink = ResourceLink & {
  __typename?: 'PackPageStandardV2TextResourcesHyperlink';
  sys: ResourceSys;
};

export type PackPageStandardV2TextResourcesInline = ResourceLink & {
  __typename?: 'PackPageStandardV2TextResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packRecommendedContentAccordionItem) */
export type PackRecommendedContentAccordionItem = Entry & _Node & {
  __typename?: 'PackRecommendedContentAccordionItem';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  cta?: Maybe<PackRecommendedContentAccordionItemCta>;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<PackRecommendedContentAccordionItemLinkingCollections>;
  sys: Sys;
  text?: Maybe<PackStructuredText>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packRecommendedContentAccordionItem) */
export type PackRecommendedContentAccordionItemCtaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packRecommendedContentAccordionItem) */
export type PackRecommendedContentAccordionItemInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packRecommendedContentAccordionItem) */
export type PackRecommendedContentAccordionItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packRecommendedContentAccordionItem) */
export type PackRecommendedContentAccordionItemTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackStructuredTextFilter>;
};

export type PackRecommendedContentAccordionItemCollection = {
  __typename?: 'PackRecommendedContentAccordionItemCollection';
  items: Array<Maybe<PackRecommendedContentAccordionItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PackRecommendedContentAccordionItemCta = BuildCategoryWebpage | BuildWebpage | PackCta | WrapperUrl;

export type PackRecommendedContentAccordionItemCursorCollection = {
  __typename?: 'PackRecommendedContentAccordionItemCursorCollection';
  items: Array<Maybe<PackRecommendedContentAccordionItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PackRecommendedContentAccordionItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<PackRecommendedContentAccordionItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackRecommendedContentAccordionItemFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<CfPackStructuredTextNestedFilter>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PackRecommendedContentAccordionItemLinkingCollections = {
  __typename?: 'PackRecommendedContentAccordionItemLinkingCollections';
  componentRecommendedContentAccordionCollection?: Maybe<ComponentRecommendedContentAccordionCollection>;
  componentRecommendedContentAccordionCursorCollection?: Maybe<ComponentRecommendedContentAccordionCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type PackRecommendedContentAccordionItemLinkingCollectionsComponentRecommendedContentAccordionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackRecommendedContentAccordionItemLinkingCollectionsComponentRecommendedContentAccordionCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackRecommendedContentAccordionItemLinkingCollectionsComponentRecommendedContentAccordionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackRecommendedContentAccordionItemLinkingCollectionsComponentRecommendedContentAccordionCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackRecommendedContentAccordionItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackRecommendedContentAccordionItemLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PackRecommendedContentAccordionItemLinkingCollectionsComponentRecommendedContentAccordionCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackRecommendedContentAccordionItemLinkingCollectionsComponentRecommendedContentAccordionCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackRecommendedContentAccordionItemOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packRichText) */
export type PackRichText = Entry & _Node & {
  __typename?: 'PackRichText';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  header?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<PackRichTextLinkingCollections>;
  sys: Sys;
  text?: Maybe<PackRichTextText>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packRichText) */
export type PackRichTextHeaderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packRichText) */
export type PackRichTextLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packRichText) */
export type PackRichTextTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PackRichTextCollection = {
  __typename?: 'PackRichTextCollection';
  items: Array<Maybe<PackRichText>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PackRichTextCursorCollection = {
  __typename?: 'PackRichTextCursorCollection';
  items: Array<Maybe<PackRichText>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PackRichTextFilter = {
  AND?: InputMaybe<Array<InputMaybe<PackRichTextFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackRichTextFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  header?: InputMaybe<Scalars['String']['input']>;
  header_contains?: InputMaybe<Scalars['String']['input']>;
  header_exists?: InputMaybe<Scalars['Boolean']['input']>;
  header_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  header_not?: InputMaybe<Scalars['String']['input']>;
  header_not_contains?: InputMaybe<Scalars['String']['input']>;
  header_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
};

export type PackRichTextLinkingCollections = {
  __typename?: 'PackRichTextLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type PackRichTextLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackRichTextLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PackRichTextOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type PackRichTextText = {
  __typename?: 'PackRichTextText';
  json: Scalars['JSON']['output'];
  links: PackRichTextTextLinks;
};

export type PackRichTextTextAssets = {
  __typename?: 'PackRichTextTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type PackRichTextTextEntries = {
  __typename?: 'PackRichTextTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type PackRichTextTextLinks = {
  __typename?: 'PackRichTextTextLinks';
  assets: PackRichTextTextAssets;
  entries: PackRichTextTextEntries;
  resources: PackRichTextTextResources;
};

export type PackRichTextTextResources = {
  __typename?: 'PackRichTextTextResources';
  block: Array<PackRichTextTextResourcesBlock>;
  hyperlink: Array<PackRichTextTextResourcesHyperlink>;
  inline: Array<PackRichTextTextResourcesInline>;
};

export type PackRichTextTextResourcesBlock = ResourceLink & {
  __typename?: 'PackRichTextTextResourcesBlock';
  sys: ResourceSys;
};

export type PackRichTextTextResourcesHyperlink = ResourceLink & {
  __typename?: 'PackRichTextTextResourcesHyperlink';
  sys: ResourceSys;
};

export type PackRichTextTextResourcesInline = ResourceLink & {
  __typename?: 'PackRichTextTextResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packSearchBar) */
export type PackSearchBar = Entry & _Node & {
  __typename?: 'PackSearchBar';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  hintText?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<WrapperIcon>;
  linkedFrom?: Maybe<PackSearchBarLinkingCollections>;
  searchRequirementsCollection?: Maybe<PackSearchBarSearchRequirementsCollection>;
  searchRequirementsCursorCollection?: Maybe<PackSearchBarSearchRequirementsCursorCollection>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packSearchBar) */
export type PackSearchBarHintTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packSearchBar) */
export type PackSearchBarIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperIconFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packSearchBar) */
export type PackSearchBarLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packSearchBar) */
export type PackSearchBarSearchRequirementsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackSearchBarSearchRequirementsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackSearchRequirementsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packSearchBar) */
export type PackSearchBarSearchRequirementsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackSearchBarSearchRequirementsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackSearchRequirementsFilter>;
};

export type PackSearchBarCollection = {
  __typename?: 'PackSearchBarCollection';
  items: Array<Maybe<PackSearchBar>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PackSearchBarCursorCollection = {
  __typename?: 'PackSearchBarCursorCollection';
  items: Array<Maybe<PackSearchBar>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PackSearchBarFilter = {
  AND?: InputMaybe<Array<InputMaybe<PackSearchBarFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackSearchBarFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  hintText?: InputMaybe<Scalars['String']['input']>;
  hintText_contains?: InputMaybe<Scalars['String']['input']>;
  hintText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hintText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hintText_not?: InputMaybe<Scalars['String']['input']>;
  hintText_not_contains?: InputMaybe<Scalars['String']['input']>;
  hintText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon?: InputMaybe<CfWrapperIconNestedFilter>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  searchRequirements?: InputMaybe<CfPackSearchRequirementsNestedFilter>;
  searchRequirementsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type PackSearchBarLinkingCollections = {
  __typename?: 'PackSearchBarLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  packArticlePageCollection?: Maybe<PackArticlePageCollection>;
  packArticlePageCursorCollection?: Maybe<PackArticlePageCursorCollection>;
  packLandingPageArticlesCollection?: Maybe<PackLandingPageArticlesCollection>;
  packLandingPageArticlesCursorCollection?: Maybe<PackLandingPageArticlesCursorCollection>;
  packPageStandardCollection?: Maybe<PackPageStandardCollection>;
  packPageStandardCursorCollection?: Maybe<PackPageStandardCursorCollection>;
  packPageStandardV2Collection?: Maybe<PackPageStandardV2Collection>;
  packPageStandardV2CursorCollection?: Maybe<PackPageStandardV2CursorCollection>;
  packPageStandardV2DevCollection?: Maybe<PackPageStandardV2DevCollection>;
  packPageStandardV2DevCursorCollection?: Maybe<PackPageStandardV2DevCursorCollection>;
};


export type PackSearchBarLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackSearchBarLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackSearchBarLinkingCollectionsPackArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackSearchBarLinkingCollectionsPackArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackSearchBarLinkingCollectionsPackArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackSearchBarLinkingCollectionsPackArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackSearchBarLinkingCollectionsPackLandingPageArticlesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackSearchBarLinkingCollectionsPackLandingPageArticlesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackSearchBarLinkingCollectionsPackLandingPageArticlesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackSearchBarLinkingCollectionsPackLandingPageArticlesCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackSearchBarLinkingCollectionsPackPageStandardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackSearchBarLinkingCollectionsPackPageStandardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackSearchBarLinkingCollectionsPackPageStandardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackSearchBarLinkingCollectionsPackPageStandardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackSearchBarLinkingCollectionsPackPageStandardV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackSearchBarLinkingCollectionsPackPageStandardV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackSearchBarLinkingCollectionsPackPageStandardV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackSearchBarLinkingCollectionsPackPageStandardV2CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackSearchBarLinkingCollectionsPackPageStandardV2DevCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackSearchBarLinkingCollectionsPackPageStandardV2DevCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackSearchBarLinkingCollectionsPackPageStandardV2DevCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackSearchBarLinkingCollectionsPackPageStandardV2DevCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PackSearchBarLinkingCollectionsPackArticlePageCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  ShareLinkAsc = 'shareLink_ASC',
  ShareLinkDesc = 'shareLink_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackSearchBarLinkingCollectionsPackArticlePageCursorCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  ShareLinkAsc = 'shareLink_ASC',
  ShareLinkDesc = 'shareLink_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackSearchBarLinkingCollectionsPackLandingPageArticlesCollectionOrder {
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackSearchBarLinkingCollectionsPackLandingPageArticlesCursorCollectionOrder {
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackSearchBarLinkingCollectionsPackPageStandardCollectionOrder {
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackSearchBarLinkingCollectionsPackPageStandardCursorCollectionOrder {
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackSearchBarLinkingCollectionsPackPageStandardV2CollectionOrder {
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackSearchBarLinkingCollectionsPackPageStandardV2CursorCollectionOrder {
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackSearchBarLinkingCollectionsPackPageStandardV2DevCollectionOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  Subheader2Asc = 'subheader2_ASC',
  Subheader2Desc = 'subheader2_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackSearchBarLinkingCollectionsPackPageStandardV2DevCursorCollectionOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  Subheader2Asc = 'subheader2_ASC',
  Subheader2Desc = 'subheader2_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackSearchBarOrder {
  HintTextAsc = 'hintText_ASC',
  HintTextDesc = 'hintText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type PackSearchBarSearchRequirementsCollection = {
  __typename?: 'PackSearchBarSearchRequirementsCollection';
  items: Array<Maybe<PackSearchRequirements>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum PackSearchBarSearchRequirementsCollectionOrder {
  SearchQueryAsc = 'searchQuery_ASC',
  SearchQueryDesc = 'searchQuery_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type PackSearchBarSearchRequirementsCursorCollection = {
  __typename?: 'PackSearchBarSearchRequirementsCursorCollection';
  items: Array<Maybe<PackSearchRequirements>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum PackSearchBarSearchRequirementsCursorCollectionOrder {
  SearchQueryAsc = 'searchQuery_ASC',
  SearchQueryDesc = 'searchQuery_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packSearchRequirements) */
export type PackSearchRequirements = Entry & _Node & {
  __typename?: 'PackSearchRequirements';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  excludedPages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  linkedFrom?: Maybe<PackSearchRequirementsLinkingCollections>;
  prioritisedPages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  searchQuery?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packSearchRequirements) */
export type PackSearchRequirementsExcludedPagesArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packSearchRequirements) */
export type PackSearchRequirementsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packSearchRequirements) */
export type PackSearchRequirementsPrioritisedPagesArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packSearchRequirements) */
export type PackSearchRequirementsSearchQueryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PackSearchRequirementsCollection = {
  __typename?: 'PackSearchRequirementsCollection';
  items: Array<Maybe<PackSearchRequirements>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PackSearchRequirementsCursorCollection = {
  __typename?: 'PackSearchRequirementsCursorCollection';
  items: Array<Maybe<PackSearchRequirements>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PackSearchRequirementsFilter = {
  AND?: InputMaybe<Array<InputMaybe<PackSearchRequirementsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackSearchRequirementsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  excludedPages_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedPages_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedPages_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedPages_exists?: InputMaybe<Scalars['Boolean']['input']>;
  prioritisedPages_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  prioritisedPages_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  prioritisedPages_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  prioritisedPages_exists?: InputMaybe<Scalars['Boolean']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  searchQuery_contains?: InputMaybe<Scalars['String']['input']>;
  searchQuery_exists?: InputMaybe<Scalars['Boolean']['input']>;
  searchQuery_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchQuery_not?: InputMaybe<Scalars['String']['input']>;
  searchQuery_not_contains?: InputMaybe<Scalars['String']['input']>;
  searchQuery_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type PackSearchRequirementsLinkingCollections = {
  __typename?: 'PackSearchRequirementsLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  packSearchBarCollection?: Maybe<PackSearchBarCollection>;
  packSearchBarCursorCollection?: Maybe<PackSearchBarCursorCollection>;
};


export type PackSearchRequirementsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackSearchRequirementsLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackSearchRequirementsLinkingCollectionsPackSearchBarCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackSearchRequirementsLinkingCollectionsPackSearchBarCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackSearchRequirementsLinkingCollectionsPackSearchBarCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackSearchRequirementsLinkingCollectionsPackSearchBarCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PackSearchRequirementsLinkingCollectionsPackSearchBarCollectionOrder {
  HintTextAsc = 'hintText_ASC',
  HintTextDesc = 'hintText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackSearchRequirementsLinkingCollectionsPackSearchBarCursorCollectionOrder {
  HintTextAsc = 'hintText_ASC',
  HintTextDesc = 'hintText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackSearchRequirementsOrder {
  SearchQueryAsc = 'searchQuery_ASC',
  SearchQueryDesc = 'searchQuery_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packSearchResult) */
export type PackSearchResult = Entry & _Node & {
  __typename?: 'PackSearchResult';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  errorText?: Maybe<PackStructuredText>;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<PackSearchResultLinkingCollections>;
  successText?: Maybe<PackStructuredText>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packSearchResult) */
export type PackSearchResultErrorTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackStructuredTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packSearchResult) */
export type PackSearchResultInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packSearchResult) */
export type PackSearchResultLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packSearchResult) */
export type PackSearchResultSuccessTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackStructuredTextFilter>;
};

export type PackSearchResultCollection = {
  __typename?: 'PackSearchResultCollection';
  items: Array<Maybe<PackSearchResult>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PackSearchResultCursorCollection = {
  __typename?: 'PackSearchResultCursorCollection';
  items: Array<Maybe<PackSearchResult>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PackSearchResultFilter = {
  AND?: InputMaybe<Array<InputMaybe<PackSearchResultFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackSearchResultFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  errorText?: InputMaybe<CfPackStructuredTextNestedFilter>;
  errorText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  successText?: InputMaybe<CfPackStructuredTextNestedFilter>;
  successText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type PackSearchResultLinkingCollections = {
  __typename?: 'PackSearchResultLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type PackSearchResultLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackSearchResultLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PackSearchResultOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packStructuredText) */
export type PackStructuredText = Entry & _Node & {
  __typename?: 'PackStructuredText';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  header?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<PackStructuredTextLinkingCollections>;
  sys: Sys;
  text?: Maybe<PackStructuredTextText>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packStructuredText) */
export type PackStructuredTextHeaderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packStructuredText) */
export type PackStructuredTextLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packStructuredText) */
export type PackStructuredTextTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PackStructuredTextCollection = {
  __typename?: 'PackStructuredTextCollection';
  items: Array<Maybe<PackStructuredText>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PackStructuredTextCursorCollection = {
  __typename?: 'PackStructuredTextCursorCollection';
  items: Array<Maybe<PackStructuredText>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PackStructuredTextFilter = {
  AND?: InputMaybe<Array<InputMaybe<PackStructuredTextFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackStructuredTextFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  header?: InputMaybe<Scalars['String']['input']>;
  header_contains?: InputMaybe<Scalars['String']['input']>;
  header_exists?: InputMaybe<Scalars['Boolean']['input']>;
  header_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  header_not?: InputMaybe<Scalars['String']['input']>;
  header_not_contains?: InputMaybe<Scalars['String']['input']>;
  header_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
};

export type PackStructuredTextLinkingCollections = {
  __typename?: 'PackStructuredTextLinkingCollections';
  buildFaQsCollection?: Maybe<BuildFaQsCollection>;
  buildFaQsCursorCollection?: Maybe<BuildFaQsCursorCollection>;
  componentAccordionCollection?: Maybe<ComponentAccordionCollection>;
  componentAccordionCursorCollection?: Maybe<ComponentAccordionCursorCollection>;
  componentActionCardCollection?: Maybe<ComponentActionCardCollection>;
  componentActionCardCursorCollection?: Maybe<ComponentActionCardCursorCollection>;
  componentCardCollection?: Maybe<ComponentCardCollection>;
  componentCardCursorCollection?: Maybe<ComponentCardCursorCollection>;
  componentCardGridCollection?: Maybe<ComponentCardGridCollection>;
  componentCardGridCursorCollection?: Maybe<ComponentCardGridCursorCollection>;
  componentCategoryBrowserCollection?: Maybe<ComponentCategoryBrowserCollection>;
  componentCategoryBrowserCursorCollection?: Maybe<ComponentCategoryBrowserCursorCollection>;
  componentContentBlockCollection?: Maybe<ComponentContentBlockCollection>;
  componentContentBlockCursorCollection?: Maybe<ComponentContentBlockCursorCollection>;
  componentContentBlockV2Collection?: Maybe<ComponentContentBlockV2Collection>;
  componentContentBlockV2CursorCollection?: Maybe<ComponentContentBlockV2CursorCollection>;
  componentCtaBannerCollection?: Maybe<ComponentCtaBannerCollection>;
  componentCtaBannerCursorCollection?: Maybe<ComponentCtaBannerCursorCollection>;
  componentFootnotesCollection?: Maybe<ComponentFootnotesCollection>;
  componentFootnotesCursorCollection?: Maybe<ComponentFootnotesCursorCollection>;
  componentPostcodeFinderCollection?: Maybe<ComponentPostcodeFinderCollection>;
  componentPostcodeFinderCursorCollection?: Maybe<ComponentPostcodeFinderCursorCollection>;
  componentProductModuleCollection?: Maybe<ComponentProductModuleCollection>;
  componentProductModuleCursorCollection?: Maybe<ComponentProductModuleCursorCollection>;
  componentPromoSectionCollection?: Maybe<ComponentPromoSectionCollection>;
  componentPromoSectionCursorCollection?: Maybe<ComponentPromoSectionCursorCollection>;
  componentQuickLinksCollection?: Maybe<ComponentQuickLinksCollection>;
  componentQuickLinksCursorCollection?: Maybe<ComponentQuickLinksCursorCollection>;
  componentSpotlightCollection?: Maybe<ComponentSpotlightCollection>;
  componentSpotlightCursorCollection?: Maybe<ComponentSpotlightCursorCollection>;
  componentSpotlightGridCollection?: Maybe<ComponentSpotlightGridCollection>;
  componentSpotlightGridCursorCollection?: Maybe<ComponentSpotlightGridCursorCollection>;
  componentTopArticleBrowserCollection?: Maybe<ComponentTopArticleBrowserCollection>;
  componentTopArticleBrowserCursorCollection?: Maybe<ComponentTopArticleBrowserCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  packContactOptionsCollection?: Maybe<PackContactOptionsCollection>;
  packContactOptionsCursorCollection?: Maybe<PackContactOptionsCursorCollection>;
  packNavBarItemV2Collection?: Maybe<PackNavBarItemV2Collection>;
  packNavBarItemV2CursorCollection?: Maybe<PackNavBarItemV2CursorCollection>;
  packRecommendedContentAccordionItemCollection?: Maybe<PackRecommendedContentAccordionItemCollection>;
  packRecommendedContentAccordionItemCursorCollection?: Maybe<PackRecommendedContentAccordionItemCursorCollection>;
  packSearchResultCollection?: Maybe<PackSearchResultCollection>;
  packSearchResultCursorCollection?: Maybe<PackSearchResultCursorCollection>;
};


export type PackStructuredTextLinkingCollectionsBuildFaQsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsBuildFaQsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsBuildFaQsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsBuildFaQsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsComponentAccordionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsComponentAccordionCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsComponentAccordionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsComponentAccordionCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsComponentActionCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsComponentActionCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsComponentActionCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsComponentActionCardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsComponentCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsComponentCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsComponentCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsComponentCardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsComponentCardGridCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsComponentCardGridCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsComponentCardGridCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsComponentCardGridCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsComponentCategoryBrowserCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsComponentCategoryBrowserCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsComponentCategoryBrowserCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsComponentCategoryBrowserCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsComponentContentBlockCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsComponentContentBlockCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsComponentContentBlockCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsComponentContentBlockCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsComponentContentBlockV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsComponentContentBlockV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsComponentContentBlockV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsComponentContentBlockV2CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsComponentCtaBannerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsComponentCtaBannerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsComponentCtaBannerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsComponentCtaBannerCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsComponentFootnotesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsComponentFootnotesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsComponentFootnotesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsComponentFootnotesCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsComponentPostcodeFinderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsComponentPostcodeFinderCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsComponentPostcodeFinderCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsComponentPostcodeFinderCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsComponentProductModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsComponentProductModuleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsComponentProductModuleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsComponentProductModuleCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsComponentPromoSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsComponentPromoSectionCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsComponentPromoSectionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsComponentPromoSectionCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsComponentQuickLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsComponentQuickLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsComponentQuickLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsComponentQuickLinksCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsComponentSpotlightCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsComponentSpotlightCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsComponentSpotlightCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsComponentSpotlightCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsComponentSpotlightGridCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsComponentSpotlightGridCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsComponentSpotlightGridCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsComponentSpotlightGridCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsComponentTopArticleBrowserCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsComponentTopArticleBrowserCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsComponentTopArticleBrowserCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsComponentTopArticleBrowserCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsPackContactOptionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsPackContactOptionsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsPackContactOptionsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsPackContactOptionsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsPackNavBarItemV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsPackNavBarItemV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsPackNavBarItemV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsPackNavBarItemV2CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsPackRecommendedContentAccordionItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsPackRecommendedContentAccordionItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsPackRecommendedContentAccordionItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsPackRecommendedContentAccordionItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsPackSearchResultCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsPackSearchResultCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackStructuredTextLinkingCollectionsPackSearchResultCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextLinkingCollectionsPackSearchResultCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PackStructuredTextLinkingCollectionsBuildFaQsCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackStructuredTextLinkingCollectionsBuildFaQsCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackStructuredTextLinkingCollectionsComponentAccordionCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  BehaviourAsc = 'behaviour_ASC',
  BehaviourDesc = 'behaviour_DESC',
  ShowTitleAsc = 'showTitle_ASC',
  ShowTitleDesc = 'showTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum PackStructuredTextLinkingCollectionsComponentAccordionCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  BehaviourAsc = 'behaviour_ASC',
  BehaviourDesc = 'behaviour_DESC',
  ShowTitleAsc = 'showTitle_ASC',
  ShowTitleDesc = 'showTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum PackStructuredTextLinkingCollectionsComponentActionCardCollectionOrder {
  ActionCodeAsc = 'actionCode_ASC',
  ActionCodeDesc = 'actionCode_DESC',
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  CanBeDismissedAsc = 'canBeDismissed_ASC',
  CanBeDismissedDesc = 'canBeDismissed_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  DarkModeAsc = 'darkMode_ASC',
  DarkModeDesc = 'darkMode_DESC',
  InvertedAsc = 'inverted_ASC',
  InvertedDesc = 'inverted_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  NonRoundedEdgesAsc = 'nonRoundedEdges_ASC',
  NonRoundedEdgesDesc = 'nonRoundedEdges_DESC',
  OptimizelyFeatureFlagAsc = 'optimizelyFeatureFlag_ASC',
  OptimizelyFeatureFlagDesc = 'optimizelyFeatureFlag_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackStructuredTextLinkingCollectionsComponentActionCardCursorCollectionOrder {
  ActionCodeAsc = 'actionCode_ASC',
  ActionCodeDesc = 'actionCode_DESC',
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  CanBeDismissedAsc = 'canBeDismissed_ASC',
  CanBeDismissedDesc = 'canBeDismissed_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  DarkModeAsc = 'darkMode_ASC',
  DarkModeDesc = 'darkMode_DESC',
  InvertedAsc = 'inverted_ASC',
  InvertedDesc = 'inverted_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  NonRoundedEdgesAsc = 'nonRoundedEdges_ASC',
  NonRoundedEdgesDesc = 'nonRoundedEdges_DESC',
  OptimizelyFeatureFlagAsc = 'optimizelyFeatureFlag_ASC',
  OptimizelyFeatureFlagDesc = 'optimizelyFeatureFlag_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackStructuredTextLinkingCollectionsComponentCardCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  ShortTextAsc = 'shortText_ASC',
  ShortTextDesc = 'shortText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackStructuredTextLinkingCollectionsComponentCardCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  ShortTextAsc = 'shortText_ASC',
  ShortTextDesc = 'shortText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackStructuredTextLinkingCollectionsComponentCardGridCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackStructuredTextLinkingCollectionsComponentCardGridCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackStructuredTextLinkingCollectionsComponentCategoryBrowserCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  IconSetAsc = 'iconSet_ASC',
  IconSetDesc = 'iconSet_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackStructuredTextLinkingCollectionsComponentCategoryBrowserCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  IconSetAsc = 'iconSet_ASC',
  IconSetDesc = 'iconSet_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackStructuredTextLinkingCollectionsComponentContentBlockCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  HeaderLevelAsc = 'headerLevel_ASC',
  HeaderLevelDesc = 'headerLevel_DESC',
  MediaPositionAsc = 'mediaPosition_ASC',
  MediaPositionDesc = 'mediaPosition_DESC',
  ShowTitleAsc = 'showTitle_ASC',
  ShowTitleDesc = 'showTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAlignmentAsc = 'textAlignment_ASC',
  TextAlignmentDesc = 'textAlignment_DESC'
}

export enum PackStructuredTextLinkingCollectionsComponentContentBlockCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  HeaderLevelAsc = 'headerLevel_ASC',
  HeaderLevelDesc = 'headerLevel_DESC',
  MediaPositionAsc = 'mediaPosition_ASC',
  MediaPositionDesc = 'mediaPosition_DESC',
  ShowTitleAsc = 'showTitle_ASC',
  ShowTitleDesc = 'showTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAlignmentAsc = 'textAlignment_ASC',
  TextAlignmentDesc = 'textAlignment_DESC'
}

export enum PackStructuredTextLinkingCollectionsComponentContentBlockV2CollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  HeaderLevelAsc = 'headerLevel_ASC',
  HeaderLevelDesc = 'headerLevel_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MediaPositionAsc = 'mediaPosition_ASC',
  MediaPositionDesc = 'mediaPosition_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAlignmentAsc = 'textAlignment_ASC',
  TextAlignmentDesc = 'textAlignment_DESC'
}

export enum PackStructuredTextLinkingCollectionsComponentContentBlockV2CursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  HeaderLevelAsc = 'headerLevel_ASC',
  HeaderLevelDesc = 'headerLevel_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MediaPositionAsc = 'mediaPosition_ASC',
  MediaPositionDesc = 'mediaPosition_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAlignmentAsc = 'textAlignment_ASC',
  TextAlignmentDesc = 'textAlignment_DESC'
}

export enum PackStructuredTextLinkingCollectionsComponentCtaBannerCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  BannerTypeAsc = 'bannerType_ASC',
  BannerTypeDesc = 'bannerType_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackStructuredTextLinkingCollectionsComponentCtaBannerCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  BannerTypeAsc = 'bannerType_ASC',
  BannerTypeDesc = 'bannerType_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackStructuredTextLinkingCollectionsComponentFootnotesCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackStructuredTextLinkingCollectionsComponentFootnotesCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackStructuredTextLinkingCollectionsComponentPostcodeFinderCollectionOrder {
  InputFieldTextAsc = 'inputFieldText_ASC',
  InputFieldTextDesc = 'inputFieldText_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC',
  TitlePart1Asc = 'titlePart1_ASC',
  TitlePart1Desc = 'titlePart1_DESC',
  TitlePart2Asc = 'titlePart2_ASC',
  TitlePart2Desc = 'titlePart2_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum PackStructuredTextLinkingCollectionsComponentPostcodeFinderCursorCollectionOrder {
  InputFieldTextAsc = 'inputFieldText_ASC',
  InputFieldTextDesc = 'inputFieldText_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC',
  TitlePart1Asc = 'titlePart1_ASC',
  TitlePart1Desc = 'titlePart1_DESC',
  TitlePart2Asc = 'titlePart2_ASC',
  TitlePart2Desc = 'titlePart2_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum PackStructuredTextLinkingCollectionsComponentProductModuleCollectionOrder {
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PackStructuredTextLinkingCollectionsComponentProductModuleCursorCollectionOrder {
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PackStructuredTextLinkingCollectionsComponentPromoSectionCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  ContentOrientationAsc = 'contentOrientation_ASC',
  ContentOrientationDesc = 'contentOrientation_DESC',
  CtaLabelAsc = 'ctaLabel_ASC',
  CtaLabelDesc = 'ctaLabel_DESC',
  HasPostalCodeAsc = 'hasPostalCode_ASC',
  HasPostalCodeDesc = 'hasPostalCode_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC'
}

export enum PackStructuredTextLinkingCollectionsComponentPromoSectionCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  ContentOrientationAsc = 'contentOrientation_ASC',
  ContentOrientationDesc = 'contentOrientation_DESC',
  CtaLabelAsc = 'ctaLabel_ASC',
  CtaLabelDesc = 'ctaLabel_DESC',
  HasPostalCodeAsc = 'hasPostalCode_ASC',
  HasPostalCodeDesc = 'hasPostalCode_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC'
}

export enum PackStructuredTextLinkingCollectionsComponentQuickLinksCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackStructuredTextLinkingCollectionsComponentQuickLinksCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackStructuredTextLinkingCollectionsComponentSpotlightCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackStructuredTextLinkingCollectionsComponentSpotlightCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackStructuredTextLinkingCollectionsComponentSpotlightGridCollectionOrder {
  AlignmentAsc = 'alignment_ASC',
  AlignmentDesc = 'alignment_DESC',
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackStructuredTextLinkingCollectionsComponentSpotlightGridCursorCollectionOrder {
  AlignmentAsc = 'alignment_ASC',
  AlignmentDesc = 'alignment_DESC',
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackStructuredTextLinkingCollectionsComponentTopArticleBrowserCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackStructuredTextLinkingCollectionsComponentTopArticleBrowserCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackStructuredTextLinkingCollectionsPackContactOptionsCollectionOrder {
  ChatButtonLabelAsc = 'chatButtonLabel_ASC',
  ChatButtonLabelDesc = 'chatButtonLabel_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackStructuredTextLinkingCollectionsPackContactOptionsCursorCollectionOrder {
  ChatButtonLabelAsc = 'chatButtonLabel_ASC',
  ChatButtonLabelDesc = 'chatButtonLabel_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackStructuredTextLinkingCollectionsPackNavBarItemV2CollectionOrder {
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackStructuredTextLinkingCollectionsPackNavBarItemV2CursorCollectionOrder {
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackStructuredTextLinkingCollectionsPackRecommendedContentAccordionItemCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackStructuredTextLinkingCollectionsPackRecommendedContentAccordionItemCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackStructuredTextLinkingCollectionsPackSearchResultCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackStructuredTextLinkingCollectionsPackSearchResultCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PackStructuredTextOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type PackStructuredTextText = {
  __typename?: 'PackStructuredTextText';
  json: Scalars['JSON']['output'];
  links: PackStructuredTextTextLinks;
};

export type PackStructuredTextTextAssets = {
  __typename?: 'PackStructuredTextTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type PackStructuredTextTextEntries = {
  __typename?: 'PackStructuredTextTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type PackStructuredTextTextLinks = {
  __typename?: 'PackStructuredTextTextLinks';
  assets: PackStructuredTextTextAssets;
  entries: PackStructuredTextTextEntries;
  resources: PackStructuredTextTextResources;
};

export type PackStructuredTextTextResources = {
  __typename?: 'PackStructuredTextTextResources';
  block: Array<PackStructuredTextTextResourcesBlock>;
  hyperlink: Array<PackStructuredTextTextResourcesHyperlink>;
  inline: Array<PackStructuredTextTextResourcesInline>;
};

export type PackStructuredTextTextResourcesBlock = ResourceLink & {
  __typename?: 'PackStructuredTextTextResourcesBlock';
  sys: ResourceSys;
};

export type PackStructuredTextTextResourcesHyperlink = ResourceLink & {
  __typename?: 'PackStructuredTextTextResourcesHyperlink';
  sys: ResourceSys;
};

export type PackStructuredTextTextResourcesInline = ResourceLink & {
  __typename?: 'PackStructuredTextTextResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packTrustpilotBanner) */
export type PackTrustpilotBanner = Entry & _Node & {
  __typename?: 'PackTrustpilotBanner';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<PackTrustpilotBannerLinkingCollections>;
  sys: Sys;
  trustpilotBanner?: Maybe<Scalars['Boolean']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packTrustpilotBanner) */
export type PackTrustpilotBannerInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packTrustpilotBanner) */
export type PackTrustpilotBannerLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packTrustpilotBanner) */
export type PackTrustpilotBannerTrustpilotBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PackTrustpilotBannerCollection = {
  __typename?: 'PackTrustpilotBannerCollection';
  items: Array<Maybe<PackTrustpilotBanner>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PackTrustpilotBannerCursorCollection = {
  __typename?: 'PackTrustpilotBannerCursorCollection';
  items: Array<Maybe<PackTrustpilotBanner>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PackTrustpilotBannerFilter = {
  AND?: InputMaybe<Array<InputMaybe<PackTrustpilotBannerFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackTrustpilotBannerFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  trustpilotBanner?: InputMaybe<Scalars['Boolean']['input']>;
  trustpilotBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  trustpilotBanner_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PackTrustpilotBannerLinkingCollections = {
  __typename?: 'PackTrustpilotBannerLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  packHomePageCollection?: Maybe<PackHomePageCollection>;
  packHomePageCursorCollection?: Maybe<PackHomePageCursorCollection>;
};


export type PackTrustpilotBannerLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackTrustpilotBannerLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackTrustpilotBannerLinkingCollectionsPackHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackTrustpilotBannerLinkingCollectionsPackHomePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackTrustpilotBannerLinkingCollectionsPackHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackTrustpilotBannerLinkingCollectionsPackHomePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PackTrustpilotBannerLinkingCollectionsPackHomePageCollectionOrder {
  ComponentVariantAsc = 'componentVariant_ASC',
  ComponentVariantDesc = 'componentVariant_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TrustpilotBannerAsc = 'trustpilotBanner_ASC',
  TrustpilotBannerDesc = 'trustpilotBanner_DESC'
}

export enum PackTrustpilotBannerLinkingCollectionsPackHomePageCursorCollectionOrder {
  ComponentVariantAsc = 'componentVariant_ASC',
  ComponentVariantDesc = 'componentVariant_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TrustpilotBannerAsc = 'trustpilotBanner_ASC',
  TrustpilotBannerDesc = 'trustpilotBanner_DESC'
}

export enum PackTrustpilotBannerOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TrustpilotBannerAsc = 'trustpilotBanner_ASC',
  TrustpilotBannerDesc = 'trustpilotBanner_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packUserAction) */
export type PackUserAction = Entry & _Node & {
  __typename?: 'PackUserAction';
  _id: Scalars['ID']['output'];
  actionName?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<PackUserActionLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packUserAction) */
export type PackUserActionActionNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/packUserAction) */
export type PackUserActionLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PackUserActionCollection = {
  __typename?: 'PackUserActionCollection';
  items: Array<Maybe<PackUserAction>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PackUserActionCursorCollection = {
  __typename?: 'PackUserActionCursorCollection';
  items: Array<Maybe<PackUserAction>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PackUserActionFilter = {
  AND?: InputMaybe<Array<InputMaybe<PackUserActionFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PackUserActionFilter>>>;
  actionName?: InputMaybe<Scalars['String']['input']>;
  actionName_contains?: InputMaybe<Scalars['String']['input']>;
  actionName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  actionName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionName_not?: InputMaybe<Scalars['String']['input']>;
  actionName_not_contains?: InputMaybe<Scalars['String']['input']>;
  actionName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type PackUserActionLinkingCollections = {
  __typename?: 'PackUserActionLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  packCtaCollection?: Maybe<PackCtaCollection>;
  packCtaCursorCollection?: Maybe<PackCtaCursorCollection>;
};


export type PackUserActionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackUserActionLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackUserActionLinkingCollectionsPackCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackUserActionLinkingCollectionsPackCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackUserActionLinkingCollectionsPackCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackUserActionLinkingCollectionsPackCtaCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PackUserActionLinkingCollectionsPackCtaCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export enum PackUserActionLinkingCollectionsPackCtaCursorCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export enum PackUserActionOrder {
  ActionNameAsc = 'actionName_ASC',
  ActionNameDesc = 'actionName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/promoCard) */
export type PromoCard = Entry & _Node & {
  __typename?: 'PromoCard';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  cta?: Maybe<PackCta>;
  ctaVariant?: Maybe<Scalars['String']['output']>;
  image?: Maybe<ContentType5OiHchWgV9Y8SuvDxHCaLy>;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<PromoCardLinkingCollections>;
  smallText?: Maybe<PromoCardSmallText>;
  sys: Sys;
  title1?: Maybe<Scalars['String']['output']>;
  title2?: Maybe<Scalars['String']['output']>;
  titleColour?: Maybe<Scalars['String']['output']>;
  titlePosition?: Maybe<Scalars['Boolean']['output']>;
  titleVariant?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/promoCard) */
export type PromoCardCtaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/promoCard) */
export type PromoCardCtaVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/promoCard) */
export type PromoCardImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/promoCard) */
export type PromoCardInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/promoCard) */
export type PromoCardLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/promoCard) */
export type PromoCardSmallTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/promoCard) */
export type PromoCardTitle1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/promoCard) */
export type PromoCardTitle2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/promoCard) */
export type PromoCardTitleColourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/promoCard) */
export type PromoCardTitlePositionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/promoCard) */
export type PromoCardTitleVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PromoCardCollection = {
  __typename?: 'PromoCardCollection';
  items: Array<Maybe<PromoCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PromoCardCursorCollection = {
  __typename?: 'PromoCardCursorCollection';
  items: Array<Maybe<PromoCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PromoCardFilter = {
  AND?: InputMaybe<Array<InputMaybe<PromoCardFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PromoCardFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta?: InputMaybe<CfPackCtaNestedFilter>;
  ctaVariant?: InputMaybe<Scalars['String']['input']>;
  ctaVariant_contains?: InputMaybe<Scalars['String']['input']>;
  ctaVariant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaVariant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaVariant_not?: InputMaybe<Scalars['String']['input']>;
  ctaVariant_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaVariant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta_exists?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<CfContentType5OiHchWgV9Y8SuvDxHCaLyNestedFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  smallText_contains?: InputMaybe<Scalars['String']['input']>;
  smallText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  smallText_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  title1?: InputMaybe<Scalars['String']['input']>;
  title1_contains?: InputMaybe<Scalars['String']['input']>;
  title1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title1_not?: InputMaybe<Scalars['String']['input']>;
  title1_not_contains?: InputMaybe<Scalars['String']['input']>;
  title1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2?: InputMaybe<Scalars['String']['input']>;
  title2_contains?: InputMaybe<Scalars['String']['input']>;
  title2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2_not?: InputMaybe<Scalars['String']['input']>;
  title2_not_contains?: InputMaybe<Scalars['String']['input']>;
  title2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColour?: InputMaybe<Scalars['String']['input']>;
  titleColour_contains?: InputMaybe<Scalars['String']['input']>;
  titleColour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleColour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColour_not?: InputMaybe<Scalars['String']['input']>;
  titleColour_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleColour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titlePosition?: InputMaybe<Scalars['Boolean']['input']>;
  titlePosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titlePosition_not?: InputMaybe<Scalars['Boolean']['input']>;
  titleVariant?: InputMaybe<Scalars['String']['input']>;
  titleVariant_contains?: InputMaybe<Scalars['String']['input']>;
  titleVariant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleVariant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleVariant_not?: InputMaybe<Scalars['String']['input']>;
  titleVariant_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleVariant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PromoCardLinkingCollections = {
  __typename?: 'PromoCardLinkingCollections';
  componentPromoCardRailCollection?: Maybe<ComponentPromoCardRailCollection>;
  componentPromoCardRailCursorCollection?: Maybe<ComponentPromoCardRailCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type PromoCardLinkingCollectionsComponentPromoCardRailCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PromoCardLinkingCollectionsComponentPromoCardRailCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PromoCardLinkingCollectionsComponentPromoCardRailCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PromoCardLinkingCollectionsComponentPromoCardRailCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PromoCardLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PromoCardLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PromoCardLinkingCollectionsComponentPromoCardRailCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export enum PromoCardLinkingCollectionsComponentPromoCardRailCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export enum PromoCardOrder {
  CtaVariantAsc = 'ctaVariant_ASC',
  CtaVariantDesc = 'ctaVariant_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  TitleColourAsc = 'titleColour_ASC',
  TitleColourDesc = 'titleColour_DESC',
  TitlePositionAsc = 'titlePosition_ASC',
  TitlePositionDesc = 'titlePosition_DESC',
  TitleVariantAsc = 'titleVariant_ASC',
  TitleVariantDesc = 'titleVariant_DESC'
}

export type PromoCardSmallText = {
  __typename?: 'PromoCardSmallText';
  json: Scalars['JSON']['output'];
  links: PromoCardSmallTextLinks;
};

export type PromoCardSmallTextAssets = {
  __typename?: 'PromoCardSmallTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type PromoCardSmallTextEntries = {
  __typename?: 'PromoCardSmallTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type PromoCardSmallTextLinks = {
  __typename?: 'PromoCardSmallTextLinks';
  assets: PromoCardSmallTextAssets;
  entries: PromoCardSmallTextEntries;
  resources: PromoCardSmallTextResources;
};

export type PromoCardSmallTextResources = {
  __typename?: 'PromoCardSmallTextResources';
  block: Array<PromoCardSmallTextResourcesBlock>;
  hyperlink: Array<PromoCardSmallTextResourcesHyperlink>;
  inline: Array<PromoCardSmallTextResourcesInline>;
};

export type PromoCardSmallTextResourcesBlock = ResourceLink & {
  __typename?: 'PromoCardSmallTextResourcesBlock';
  sys: ResourceSys;
};

export type PromoCardSmallTextResourcesHyperlink = ResourceLink & {
  __typename?: 'PromoCardSmallTextResourcesHyperlink';
  sys: ResourceSys;
};

export type PromoCardSmallTextResourcesInline = ResourceLink & {
  __typename?: 'PromoCardSmallTextResourcesInline';
  sys: ResourceSys;
};

export type Query = {
  __typename?: 'Query';
  _node?: Maybe<_Node>;
  _nodes: Array<Maybe<_Node>>;
  aLVvzQa2BY0A0OgrM8PSt?: Maybe<AlVvzQa2By0A0OgrM8PSt>;
  aLVvzQa2BY0A0OgrM8PStCollection?: Maybe<AlVvzQa2By0A0OgrM8PStCollection>;
  aLVvzQa2BY0A0OgrM8PStCursorCollection?: Maybe<AlVvzQa2By0A0OgrM8PStCursorCollection>;
  asset?: Maybe<Asset>;
  assetCollection?: Maybe<AssetCollection>;
  assetCursorCollection?: Maybe<AssetCursorCollection>;
  author?: Maybe<Author>;
  authorCollection?: Maybe<AuthorCollection>;
  authorCursorCollection?: Maybe<AuthorCursorCollection>;
  buildArticlePage?: Maybe<BuildArticlePage>;
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  buildArticlesLandingPage?: Maybe<BuildArticlesLandingPage>;
  buildArticlesLandingPageCollection?: Maybe<BuildArticlesLandingPageCollection>;
  buildArticlesLandingPageCursorCollection?: Maybe<BuildArticlesLandingPageCursorCollection>;
  buildCampaignPage?: Maybe<BuildCampaignPage>;
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildCategoryWebpage?: Maybe<BuildCategoryWebpage>;
  buildCategoryWebpageCollection?: Maybe<BuildCategoryWebpageCollection>;
  buildCategoryWebpageCursorCollection?: Maybe<BuildCategoryWebpageCursorCollection>;
  buildCustomerInformationCard?: Maybe<BuildCustomerInformationCard>;
  buildCustomerInformationCardCollection?: Maybe<BuildCustomerInformationCardCollection>;
  buildCustomerInformationCardCursorCollection?: Maybe<BuildCustomerInformationCardCursorCollection>;
  buildFaQs?: Maybe<BuildFaQs>;
  buildFaQsCollection?: Maybe<BuildFaQsCollection>;
  buildFaQsCursorCollection?: Maybe<BuildFaQsCursorCollection>;
  buildGenericTemplatePage?: Maybe<BuildGenericTemplatePage>;
  buildGenericTemplatePageCollection?: Maybe<BuildGenericTemplatePageCollection>;
  buildGenericTemplatePageCursorCollection?: Maybe<BuildGenericTemplatePageCursorCollection>;
  buildLandingpage?: Maybe<BuildLandingpage>;
  buildLandingpageCollection?: Maybe<BuildLandingpageCollection>;
  buildLandingpageCursorCollection?: Maybe<BuildLandingpageCursorCollection>;
  buildNextBestAction?: Maybe<BuildNextBestAction>;
  buildNextBestActionCollection?: Maybe<BuildNextBestActionCollection>;
  buildNextBestActionCursorCollection?: Maybe<BuildNextBestActionCursorCollection>;
  buildProductDetailPage?: Maybe<BuildProductDetailPage>;
  buildProductDetailPageCollection?: Maybe<BuildProductDetailPageCollection>;
  buildProductDetailPageCursorCollection?: Maybe<BuildProductDetailPageCursorCollection>;
  buildProductOverviewPage?: Maybe<BuildProductOverviewPage>;
  buildProductOverviewPageCollection?: Maybe<BuildProductOverviewPageCollection>;
  buildProductOverviewPageCursorCollection?: Maybe<BuildProductOverviewPageCursorCollection>;
  buildRecommendedContent?: Maybe<BuildRecommendedContent>;
  buildRecommendedContentCollection?: Maybe<BuildRecommendedContentCollection>;
  buildRecommendedContentCursorCollection?: Maybe<BuildRecommendedContentCursorCollection>;
  buildTariffPage?: Maybe<BuildTariffPage>;
  buildTariffPageCollection?: Maybe<BuildTariffPageCollection>;
  buildTariffPageCursorCollection?: Maybe<BuildTariffPageCursorCollection>;
  buildWebpage?: Maybe<BuildWebpage>;
  buildWebpageCollection?: Maybe<BuildWebpageCollection>;
  buildWebpageCursorCollection?: Maybe<BuildWebpageCursorCollection>;
  componentAccordion?: Maybe<ComponentAccordion>;
  componentAccordionCollection?: Maybe<ComponentAccordionCollection>;
  componentAccordionCursorCollection?: Maybe<ComponentAccordionCursorCollection>;
  componentActionCard?: Maybe<ComponentActionCard>;
  componentActionCardCollection?: Maybe<ComponentActionCardCollection>;
  componentActionCardCursorCollection?: Maybe<ComponentActionCardCursorCollection>;
  componentBlockCard?: Maybe<ComponentBlockCard>;
  componentBlockCardCollection?: Maybe<ComponentBlockCardCollection>;
  componentBlockCardCursorCollection?: Maybe<ComponentBlockCardCursorCollection>;
  componentCallout?: Maybe<ComponentCallout>;
  componentCalloutCollection?: Maybe<ComponentCalloutCollection>;
  componentCalloutCursorCollection?: Maybe<ComponentCalloutCursorCollection>;
  componentCard?: Maybe<ComponentCard>;
  componentCardCollection?: Maybe<ComponentCardCollection>;
  componentCardCursorCollection?: Maybe<ComponentCardCursorCollection>;
  componentCardGrid?: Maybe<ComponentCardGrid>;
  componentCardGridCollection?: Maybe<ComponentCardGridCollection>;
  componentCardGridCursorCollection?: Maybe<ComponentCardGridCursorCollection>;
  componentCardGroup?: Maybe<ComponentCardGroup>;
  componentCardGroupCollection?: Maybe<ComponentCardGroupCollection>;
  componentCardGroupCursorCollection?: Maybe<ComponentCardGroupCursorCollection>;
  componentCarousel?: Maybe<ComponentCarousel>;
  componentCarouselCard?: Maybe<ComponentCarouselCard>;
  componentCarouselCardCollection?: Maybe<ComponentCarouselCardCollection>;
  componentCarouselCardCursorCollection?: Maybe<ComponentCarouselCardCursorCollection>;
  componentCarouselCollection?: Maybe<ComponentCarouselCollection>;
  componentCarouselCursorCollection?: Maybe<ComponentCarouselCursorCollection>;
  componentCategoryBrowser?: Maybe<ComponentCategoryBrowser>;
  componentCategoryBrowserCollection?: Maybe<ComponentCategoryBrowserCollection>;
  componentCategoryBrowserCursorCollection?: Maybe<ComponentCategoryBrowserCursorCollection>;
  componentContactAndUsefulLinks?: Maybe<ComponentContactAndUsefulLinks>;
  componentContactAndUsefulLinksCollection?: Maybe<ComponentContactAndUsefulLinksCollection>;
  componentContactAndUsefulLinksCursorCollection?: Maybe<ComponentContactAndUsefulLinksCursorCollection>;
  componentContentBlock?: Maybe<ComponentContentBlock>;
  componentContentBlockCollection?: Maybe<ComponentContentBlockCollection>;
  componentContentBlockCursorCollection?: Maybe<ComponentContentBlockCursorCollection>;
  componentContentBlockV2?: Maybe<ComponentContentBlockV2>;
  componentContentBlockV2Collection?: Maybe<ComponentContentBlockV2Collection>;
  componentContentBlockV2CursorCollection?: Maybe<ComponentContentBlockV2CursorCollection>;
  componentCtaBanner?: Maybe<ComponentCtaBanner>;
  componentCtaBannerCollection?: Maybe<ComponentCtaBannerCollection>;
  componentCtaBannerCursorCollection?: Maybe<ComponentCtaBannerCursorCollection>;
  componentDetailInfoSection?: Maybe<ComponentDetailInfoSection>;
  componentDetailInfoSectionCollection?: Maybe<ComponentDetailInfoSectionCollection>;
  componentDetailInfoSectionCursorCollection?: Maybe<ComponentDetailInfoSectionCursorCollection>;
  componentFooter?: Maybe<ComponentFooter>;
  componentFooterCollection?: Maybe<ComponentFooterCollection>;
  componentFooterCursorCollection?: Maybe<ComponentFooterCursorCollection>;
  componentFootnotes?: Maybe<ComponentFootnotes>;
  componentFootnotesCollection?: Maybe<ComponentFootnotesCollection>;
  componentFootnotesCursorCollection?: Maybe<ComponentFootnotesCursorCollection>;
  componentForm?: Maybe<ComponentForm>;
  componentFormCollection?: Maybe<ComponentFormCollection>;
  componentFormCursorCollection?: Maybe<ComponentFormCursorCollection>;
  componentGuideCard?: Maybe<ComponentGuideCard>;
  componentGuideCardCollection?: Maybe<ComponentGuideCardCollection>;
  componentGuideCardCursorCollection?: Maybe<ComponentGuideCardCursorCollection>;
  componentGuidesRail?: Maybe<ComponentGuidesRail>;
  componentGuidesRailCollection?: Maybe<ComponentGuidesRailCollection>;
  componentGuidesRailCursorCollection?: Maybe<ComponentGuidesRailCursorCollection>;
  componentHelpAndCta?: Maybe<ComponentHelpAndCta>;
  componentHelpAndCtaCollection?: Maybe<ComponentHelpAndCtaCollection>;
  componentHelpAndCtaCursorCollection?: Maybe<ComponentHelpAndCtaCursorCollection>;
  componentHelpHomepageDualLayout?: Maybe<ComponentHelpHomepageDualLayout>;
  componentHelpHomepageDualLayoutCollection?: Maybe<ComponentHelpHomepageDualLayoutCollection>;
  componentHelpHomepageDualLayoutCursorCollection?: Maybe<ComponentHelpHomepageDualLayoutCursorCollection>;
  componentHomepageHeroPostcodeSection?: Maybe<ComponentHomepageHeroPostcodeSection>;
  componentHomepageHeroPostcodeSectionCollection?: Maybe<ComponentHomepageHeroPostcodeSectionCollection>;
  componentHomepageHeroPostcodeSectionCursorCollection?: Maybe<ComponentHomepageHeroPostcodeSectionCursorCollection>;
  componentIframe?: Maybe<ComponentIframe>;
  componentIframeCollection?: Maybe<ComponentIframeCollection>;
  componentIframeCursorCollection?: Maybe<ComponentIframeCursorCollection>;
  componentImageGallery?: Maybe<ComponentImageGallery>;
  componentImageGalleryCollection?: Maybe<ComponentImageGalleryCollection>;
  componentImageGalleryCursorCollection?: Maybe<ComponentImageGalleryCursorCollection>;
  componentImageWithDescription?: Maybe<ComponentImageWithDescription>;
  componentImageWithDescriptionCollection?: Maybe<ComponentImageWithDescriptionCollection>;
  componentImageWithDescriptionCursorCollection?: Maybe<ComponentImageWithDescriptionCursorCollection>;
  componentInfoCard?: Maybe<ComponentInfoCard>;
  componentInfoCardCollection?: Maybe<ComponentInfoCardCollection>;
  componentInfoCardCursorCollection?: Maybe<ComponentInfoCardCursorCollection>;
  componentInfoGroup?: Maybe<ComponentInfoGroup>;
  componentInfoGroupCollection?: Maybe<ComponentInfoGroupCollection>;
  componentInfoGroupCursorCollection?: Maybe<ComponentInfoGroupCursorCollection>;
  componentLauncherGroup?: Maybe<ComponentLauncherGroup>;
  componentLauncherGroupCollection?: Maybe<ComponentLauncherGroupCollection>;
  componentLauncherGroupCursorCollection?: Maybe<ComponentLauncherGroupCursorCollection>;
  componentLineup?: Maybe<ComponentLineup>;
  componentLineupCollection?: Maybe<ComponentLineupCollection>;
  componentLineupCursorCollection?: Maybe<ComponentLineupCursorCollection>;
  componentLogoGroup?: Maybe<ComponentLogoGroup>;
  componentLogoGroupCollection?: Maybe<ComponentLogoGroupCollection>;
  componentLogoGroupCursorCollection?: Maybe<ComponentLogoGroupCursorCollection>;
  componentNavBar?: Maybe<ComponentNavBar>;
  componentNavBarCollection?: Maybe<ComponentNavBarCollection>;
  componentNavBarCursorCollection?: Maybe<ComponentNavBarCursorCollection>;
  componentPageHero?: Maybe<ComponentPageHero>;
  componentPageHeroCollection?: Maybe<ComponentPageHeroCollection>;
  componentPageHeroCursorCollection?: Maybe<ComponentPageHeroCursorCollection>;
  componentPostcodeFinder?: Maybe<ComponentPostcodeFinder>;
  componentPostcodeFinderCollection?: Maybe<ComponentPostcodeFinderCollection>;
  componentPostcodeFinderCursorCollection?: Maybe<ComponentPostcodeFinderCursorCollection>;
  componentProductFeaturedCard?: Maybe<ComponentProductFeaturedCard>;
  componentProductFeaturedCardCollection?: Maybe<ComponentProductFeaturedCardCollection>;
  componentProductFeaturedCardCursorCollection?: Maybe<ComponentProductFeaturedCardCursorCollection>;
  componentProductGroup?: Maybe<ComponentProductGroup>;
  componentProductGroupCollection?: Maybe<ComponentProductGroupCollection>;
  componentProductGroupCursorCollection?: Maybe<ComponentProductGroupCursorCollection>;
  componentProductModule?: Maybe<ComponentProductModule>;
  componentProductModuleCollection?: Maybe<ComponentProductModuleCollection>;
  componentProductModuleCursorCollection?: Maybe<ComponentProductModuleCursorCollection>;
  componentProductRail?: Maybe<ComponentProductRail>;
  componentProductRailCollection?: Maybe<ComponentProductRailCollection>;
  componentProductRailCursorCollection?: Maybe<ComponentProductRailCursorCollection>;
  componentPromoCardRail?: Maybe<ComponentPromoCardRail>;
  componentPromoCardRailCollection?: Maybe<ComponentPromoCardRailCollection>;
  componentPromoCardRailCursorCollection?: Maybe<ComponentPromoCardRailCursorCollection>;
  componentPromoSection?: Maybe<ComponentPromoSection>;
  componentPromoSectionCollection?: Maybe<ComponentPromoSectionCollection>;
  componentPromoSectionCursorCollection?: Maybe<ComponentPromoSectionCursorCollection>;
  componentPromoTextCard?: Maybe<ComponentPromoTextCard>;
  componentPromoTextCardCollection?: Maybe<ComponentPromoTextCardCollection>;
  componentPromoTextCardCursorCollection?: Maybe<ComponentPromoTextCardCursorCollection>;
  componentPromoTextCardSection?: Maybe<ComponentPromoTextCardSection>;
  componentPromoTextCardSectionCollection?: Maybe<ComponentPromoTextCardSectionCollection>;
  componentPromoTextCardSectionCursorCollection?: Maybe<ComponentPromoTextCardSectionCursorCollection>;
  componentQrCodePopup?: Maybe<ComponentQrCodePopup>;
  componentQrCodePopupCollection?: Maybe<ComponentQrCodePopupCollection>;
  componentQrCodePopupCursorCollection?: Maybe<ComponentQrCodePopupCursorCollection>;
  componentQuickLinks?: Maybe<ComponentQuickLinks>;
  componentQuickLinksCollection?: Maybe<ComponentQuickLinksCollection>;
  componentQuickLinksCursorCollection?: Maybe<ComponentQuickLinksCursorCollection>;
  componentRecommendedContentAccordion?: Maybe<ComponentRecommendedContentAccordion>;
  componentRecommendedContentAccordionCollection?: Maybe<ComponentRecommendedContentAccordionCollection>;
  componentRecommendedContentAccordionCursorCollection?: Maybe<ComponentRecommendedContentAccordionCursorCollection>;
  componentSearch?: Maybe<ComponentSearch>;
  componentSearchCollection?: Maybe<ComponentSearchCollection>;
  componentSearchCursorCollection?: Maybe<ComponentSearchCursorCollection>;
  componentSectionSteps?: Maybe<ComponentSectionSteps>;
  componentSectionStepsCollection?: Maybe<ComponentSectionStepsCollection>;
  componentSectionStepsCursorCollection?: Maybe<ComponentSectionStepsCursorCollection>;
  componentSpotlight?: Maybe<ComponentSpotlight>;
  componentSpotlightCollection?: Maybe<ComponentSpotlightCollection>;
  componentSpotlightCursorCollection?: Maybe<ComponentSpotlightCursorCollection>;
  componentSpotlightGrid?: Maybe<ComponentSpotlightGrid>;
  componentSpotlightGridCollection?: Maybe<ComponentSpotlightGridCollection>;
  componentSpotlightGridCursorCollection?: Maybe<ComponentSpotlightGridCursorCollection>;
  componentStep?: Maybe<ComponentStep>;
  componentStepCollection?: Maybe<ComponentStepCollection>;
  componentStepCursorCollection?: Maybe<ComponentStepCursorCollection>;
  componentTable?: Maybe<ComponentTable>;
  componentTableCollection?: Maybe<ComponentTableCollection>;
  componentTableCursorCollection?: Maybe<ComponentTableCursorCollection>;
  componentTariffCard?: Maybe<ComponentTariffCard>;
  componentTariffCardCollection?: Maybe<ComponentTariffCardCollection>;
  componentTariffCardCursorCollection?: Maybe<ComponentTariffCardCursorCollection>;
  componentTariffCardGroup?: Maybe<ComponentTariffCardGroup>;
  componentTariffCardGroupCollection?: Maybe<ComponentTariffCardGroupCollection>;
  componentTariffCardGroupCursorCollection?: Maybe<ComponentTariffCardGroupCursorCollection>;
  componentTariffHero?: Maybe<ComponentTariffHero>;
  componentTariffHeroCollection?: Maybe<ComponentTariffHeroCollection>;
  componentTariffHeroCursorCollection?: Maybe<ComponentTariffHeroCursorCollection>;
  componentTextAndCta?: Maybe<ComponentTextAndCta>;
  componentTextAndCtaCollection?: Maybe<ComponentTextAndCtaCollection>;
  componentTextAndCtaCursorCollection?: Maybe<ComponentTextAndCtaCursorCollection>;
  componentTopArticleBrowser?: Maybe<ComponentTopArticleBrowser>;
  componentTopArticleBrowserCollection?: Maybe<ComponentTopArticleBrowserCollection>;
  componentTopArticleBrowserCursorCollection?: Maybe<ComponentTopArticleBrowserCursorCollection>;
  componentTrustpilot?: Maybe<ComponentTrustpilot>;
  componentTrustpilotCollection?: Maybe<ComponentTrustpilotCollection>;
  componentTrustpilotCursorCollection?: Maybe<ComponentTrustpilotCursorCollection>;
  componentUspCard?: Maybe<ComponentUspCard>;
  componentUspCardCollection?: Maybe<ComponentUspCardCollection>;
  componentUspCardCursorCollection?: Maybe<ComponentUspCardCursorCollection>;
  componentUspGroup?: Maybe<ComponentUspGroup>;
  componentUspGroupCollection?: Maybe<ComponentUspGroupCollection>;
  componentUspGroupCursorCollection?: Maybe<ComponentUspGroupCursorCollection>;
  componentUspSupportingContent?: Maybe<ComponentUspSupportingContent>;
  componentUspSupportingContentCollection?: Maybe<ComponentUspSupportingContentCollection>;
  componentUspSupportingContentCursorCollection?: Maybe<ComponentUspSupportingContentCursorCollection>;
  componentVideoPlayer?: Maybe<ComponentVideoPlayer>;
  componentVideoPlayerCollection?: Maybe<ComponentVideoPlayerCollection>;
  componentVideoPlayerCursorCollection?: Maybe<ComponentVideoPlayerCursorCollection>;
  contentType1GgZsWOlfK2WI0QIh0Pwim?: Maybe<ContentType1GgZsWOlfK2Wi0QIh0Pwim>;
  contentType1GgZsWOlfK2WI0QIh0PwimCollection?: Maybe<ContentType1GgZsWOlfK2Wi0QIh0PwimCollection>;
  contentType1GgZsWOlfK2WI0QIh0PwimCursorCollection?: Maybe<ContentType1GgZsWOlfK2Wi0QIh0PwimCursorCollection>;
  contentType5OiHchWgV9Y8SuvDxHCaLy?: Maybe<ContentType5OiHchWgV9Y8SuvDxHCaLy>;
  contentType5OiHchWgV9Y8SuvDxHCaLyCollection?: Maybe<ContentType5OiHchWgV9Y8SuvDxHCaLyCollection>;
  contentType5OiHchWgV9Y8SuvDxHCaLyCursorCollection?: Maybe<ContentType5OiHchWgV9Y8SuvDxHCaLyCursorCollection>;
  contentType5VCz5FHyZ2ZlWqa5OKh6Y9?: Maybe<ContentType5VCz5FHyZ2ZlWqa5OKh6Y9>;
  contentType5VCz5FHyZ2ZlWqa5OKh6Y9Collection?: Maybe<ContentType5VCz5FHyZ2ZlWqa5OKh6Y9Collection>;
  contentType5VCz5FHyZ2ZlWqa5OKh6Y9CursorCollection?: Maybe<ContentType5VCz5FHyZ2ZlWqa5OKh6Y9CursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  integrationOptimizelyFlag?: Maybe<IntegrationOptimizelyFlag>;
  integrationOptimizelyFlagCollection?: Maybe<IntegrationOptimizelyFlagCollection>;
  integrationOptimizelyFlagCursorCollection?: Maybe<IntegrationOptimizelyFlagCursorCollection>;
  integrationOptimizelyFlagRule?: Maybe<IntegrationOptimizelyFlagRule>;
  integrationOptimizelyFlagRuleCollection?: Maybe<IntegrationOptimizelyFlagRuleCollection>;
  integrationOptimizelyFlagRuleCursorCollection?: Maybe<IntegrationOptimizelyFlagRuleCursorCollection>;
  packAlertBanner?: Maybe<PackAlertBanner>;
  packAlertBannerCollection?: Maybe<PackAlertBannerCollection>;
  packAlertBannerCursorCollection?: Maybe<PackAlertBannerCursorCollection>;
  packAppStore?: Maybe<PackAppStore>;
  packAppStoreCollection?: Maybe<PackAppStoreCollection>;
  packAppStoreCursorCollection?: Maybe<PackAppStoreCursorCollection>;
  packArticlePage?: Maybe<PackArticlePage>;
  packArticlePageCollection?: Maybe<PackArticlePageCollection>;
  packArticlePageCursorCollection?: Maybe<PackArticlePageCursorCollection>;
  packCampaignPage?: Maybe<PackCampaignPage>;
  packCampaignPageCollection?: Maybe<PackCampaignPageCollection>;
  packCampaignPageCursorCollection?: Maybe<PackCampaignPageCursorCollection>;
  packCategory?: Maybe<PackCategory>;
  packCategoryCollection?: Maybe<PackCategoryCollection>;
  packCategoryCursorCollection?: Maybe<PackCategoryCursorCollection>;
  packCategoryList?: Maybe<PackCategoryList>;
  packCategoryListCollection?: Maybe<PackCategoryListCollection>;
  packCategoryListCursorCollection?: Maybe<PackCategoryListCursorCollection>;
  packContactOptions?: Maybe<PackContactOptions>;
  packContactOptionsCollection?: Maybe<PackContactOptionsCollection>;
  packContactOptionsCursorCollection?: Maybe<PackContactOptionsCursorCollection>;
  packCta?: Maybe<PackCta>;
  packCtaCollection?: Maybe<PackCtaCollection>;
  packCtaCursorCollection?: Maybe<PackCtaCursorCollection>;
  packDynamicVariablePlaceholder?: Maybe<PackDynamicVariablePlaceholder>;
  packDynamicVariablePlaceholderCollection?: Maybe<PackDynamicVariablePlaceholderCollection>;
  packDynamicVariablePlaceholderCursorCollection?: Maybe<PackDynamicVariablePlaceholderCursorCollection>;
  packFooterItem?: Maybe<PackFooterItem>;
  packFooterItemCollection?: Maybe<PackFooterItemCollection>;
  packFooterItemCursorCollection?: Maybe<PackFooterItemCursorCollection>;
  packFreeFormPrivacyText?: Maybe<PackFreeFormPrivacyText>;
  packFreeFormPrivacyTextCollection?: Maybe<PackFreeFormPrivacyTextCollection>;
  packFreeFormPrivacyTextCursorCollection?: Maybe<PackFreeFormPrivacyTextCursorCollection>;
  packFreeFormText?: Maybe<PackFreeFormText>;
  packFreeFormTextCollection?: Maybe<PackFreeFormTextCollection>;
  packFreeFormTextCursorCollection?: Maybe<PackFreeFormTextCursorCollection>;
  packHighlightedText?: Maybe<PackHighlightedText>;
  packHighlightedTextCollection?: Maybe<PackHighlightedTextCollection>;
  packHighlightedTextCursorCollection?: Maybe<PackHighlightedTextCursorCollection>;
  packHomePage?: Maybe<PackHomePage>;
  packHomePageCollection?: Maybe<PackHomePageCollection>;
  packHomePageCursorCollection?: Maybe<PackHomePageCursorCollection>;
  packLandingPageArticles?: Maybe<PackLandingPageArticles>;
  packLandingPageArticlesCollection?: Maybe<PackLandingPageArticlesCollection>;
  packLandingPageArticlesCursorCollection?: Maybe<PackLandingPageArticlesCursorCollection>;
  packLottieAnimation?: Maybe<PackLottieAnimation>;
  packLottieAnimationCollection?: Maybe<PackLottieAnimationCollection>;
  packLottieAnimationCursorCollection?: Maybe<PackLottieAnimationCursorCollection>;
  packMicrocopy?: Maybe<PackMicrocopy>;
  packMicrocopyCollection?: Maybe<PackMicrocopyCollection>;
  packMicrocopyCursorCollection?: Maybe<PackMicrocopyCursorCollection>;
  packNavBarCta?: Maybe<PackNavBarCta>;
  packNavBarCtaCollection?: Maybe<PackNavBarCtaCollection>;
  packNavBarCtaCursorCollection?: Maybe<PackNavBarCtaCursorCollection>;
  packNavBarItem?: Maybe<PackNavBarItem>;
  packNavBarItemCollection?: Maybe<PackNavBarItemCollection>;
  packNavBarItemCursorCollection?: Maybe<PackNavBarItemCursorCollection>;
  packNavBarItemV2?: Maybe<PackNavBarItemV2>;
  packNavBarItemV2Collection?: Maybe<PackNavBarItemV2Collection>;
  packNavBarItemV2CursorCollection?: Maybe<PackNavBarItemV2CursorCollection>;
  packPageProductDetail?: Maybe<PackPageProductDetail>;
  packPageProductDetailCollection?: Maybe<PackPageProductDetailCollection>;
  packPageProductDetailCursorCollection?: Maybe<PackPageProductDetailCursorCollection>;
  packPageStandard?: Maybe<PackPageStandard>;
  packPageStandardCollection?: Maybe<PackPageStandardCollection>;
  packPageStandardCursorCollection?: Maybe<PackPageStandardCursorCollection>;
  packPageStandardV2?: Maybe<PackPageStandardV2>;
  packPageStandardV2Collection?: Maybe<PackPageStandardV2Collection>;
  packPageStandardV2CursorCollection?: Maybe<PackPageStandardV2CursorCollection>;
  packPageStandardV2Dev?: Maybe<PackPageStandardV2Dev>;
  packPageStandardV2DevCollection?: Maybe<PackPageStandardV2DevCollection>;
  packPageStandardV2DevCursorCollection?: Maybe<PackPageStandardV2DevCursorCollection>;
  packRecommendedContentAccordionItem?: Maybe<PackRecommendedContentAccordionItem>;
  packRecommendedContentAccordionItemCollection?: Maybe<PackRecommendedContentAccordionItemCollection>;
  packRecommendedContentAccordionItemCursorCollection?: Maybe<PackRecommendedContentAccordionItemCursorCollection>;
  packRichText?: Maybe<PackRichText>;
  packRichTextCollection?: Maybe<PackRichTextCollection>;
  packRichTextCursorCollection?: Maybe<PackRichTextCursorCollection>;
  packSearchBar?: Maybe<PackSearchBar>;
  packSearchBarCollection?: Maybe<PackSearchBarCollection>;
  packSearchBarCursorCollection?: Maybe<PackSearchBarCursorCollection>;
  packSearchRequirements?: Maybe<PackSearchRequirements>;
  packSearchRequirementsCollection?: Maybe<PackSearchRequirementsCollection>;
  packSearchRequirementsCursorCollection?: Maybe<PackSearchRequirementsCursorCollection>;
  packSearchResult?: Maybe<PackSearchResult>;
  packSearchResultCollection?: Maybe<PackSearchResultCollection>;
  packSearchResultCursorCollection?: Maybe<PackSearchResultCursorCollection>;
  packStructuredText?: Maybe<PackStructuredText>;
  packStructuredTextCollection?: Maybe<PackStructuredTextCollection>;
  packStructuredTextCursorCollection?: Maybe<PackStructuredTextCursorCollection>;
  packTrustpilotBanner?: Maybe<PackTrustpilotBanner>;
  packTrustpilotBannerCollection?: Maybe<PackTrustpilotBannerCollection>;
  packTrustpilotBannerCursorCollection?: Maybe<PackTrustpilotBannerCursorCollection>;
  packUserAction?: Maybe<PackUserAction>;
  packUserActionCollection?: Maybe<PackUserActionCollection>;
  packUserActionCursorCollection?: Maybe<PackUserActionCursorCollection>;
  promoCard?: Maybe<PromoCard>;
  promoCardCollection?: Maybe<PromoCardCollection>;
  promoCardCursorCollection?: Maybe<PromoCardCursorCollection>;
  topicTable?: Maybe<TopicTable>;
  topicTableCollection?: Maybe<TopicTableCollection>;
  topicTableCursorCollection?: Maybe<TopicTableCursorCollection>;
  variationContainer?: Maybe<VariationContainer>;
  variationContainerCollection?: Maybe<VariationContainerCollection>;
  variationContainerCursorCollection?: Maybe<VariationContainerCursorCollection>;
  wrapperAnchor?: Maybe<WrapperAnchor>;
  wrapperAnchorCollection?: Maybe<WrapperAnchorCollection>;
  wrapperAnchorCursorCollection?: Maybe<WrapperAnchorCursorCollection>;
  wrapperAnimation?: Maybe<WrapperAnimation>;
  wrapperAnimationCollection?: Maybe<WrapperAnimationCollection>;
  wrapperAnimationCursorCollection?: Maybe<WrapperAnimationCursorCollection>;
  wrapperAppScreen?: Maybe<WrapperAppScreen>;
  wrapperAppScreenCollection?: Maybe<WrapperAppScreenCollection>;
  wrapperAppScreenCursorCollection?: Maybe<WrapperAppScreenCursorCollection>;
  wrapperBannerImage?: Maybe<WrapperBannerImage>;
  wrapperBannerImageCollection?: Maybe<WrapperBannerImageCollection>;
  wrapperBannerImageCursorCollection?: Maybe<WrapperBannerImageCursorCollection>;
  wrapperDocument?: Maybe<WrapperDocument>;
  wrapperDocumentCollection?: Maybe<WrapperDocumentCollection>;
  wrapperDocumentCursorCollection?: Maybe<WrapperDocumentCursorCollection>;
  wrapperIcon?: Maybe<WrapperIcon>;
  wrapperIconCollection?: Maybe<WrapperIconCollection>;
  wrapperIconCursorCollection?: Maybe<WrapperIconCursorCollection>;
  wrapperImage?: Maybe<WrapperImage>;
  wrapperImageCollection?: Maybe<WrapperImageCollection>;
  wrapperImageCursorCollection?: Maybe<WrapperImageCursorCollection>;
  wrapperPageRouting?: Maybe<WrapperPageRouting>;
  wrapperPageRoutingCollection?: Maybe<WrapperPageRoutingCollection>;
  wrapperPageRoutingCursorCollection?: Maybe<WrapperPageRoutingCursorCollection>;
  wrapperPath?: Maybe<WrapperPath>;
  wrapperPathCollection?: Maybe<WrapperPathCollection>;
  wrapperPathCursorCollection?: Maybe<WrapperPathCursorCollection>;
  wrapperSocialMedia?: Maybe<WrapperSocialMedia>;
  wrapperSocialMediaCollection?: Maybe<WrapperSocialMediaCollection>;
  wrapperSocialMediaCursorCollection?: Maybe<WrapperSocialMediaCursorCollection>;
  wrapperUrl?: Maybe<WrapperUrl>;
  wrapperUrlCollection?: Maybe<WrapperUrlCollection>;
  wrapperUrlCursorCollection?: Maybe<WrapperUrlCursorCollection>;
  wrapperVideo?: Maybe<WrapperVideo>;
  wrapperVideoCollection?: Maybe<WrapperVideoCollection>;
  wrapperVideoCursorCollection?: Maybe<WrapperVideoCursorCollection>;
};


export type Query_NodeArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Query_NodesArgs = {
  ids: Array<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAlVvzQa2By0A0OgrM8PStArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAlVvzQa2By0A0OgrM8PStCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AlVvzQa2By0A0OgrM8PStOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AlVvzQa2By0A0OgrM8PStFilter>;
};


export type QueryAlVvzQa2By0A0OgrM8PStCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AlVvzQa2By0A0OgrM8PStOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AlVvzQa2By0A0OgrM8PStFilter>;
};


export type QueryAssetArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAssetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AssetOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssetFilter>;
};


export type QueryAssetCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AssetOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssetFilter>;
};


export type QueryAuthorArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAuthorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AuthorOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AuthorFilter>;
};


export type QueryAuthorCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AuthorOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AuthorFilter>;
};


export type QueryBuildArticlePageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildArticlePageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildArticlePageFilter>;
};


export type QueryBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildArticlePageOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildArticlePageFilter>;
};


export type QueryBuildArticlesLandingPageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBuildArticlesLandingPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildArticlesLandingPageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildArticlesLandingPageFilter>;
};


export type QueryBuildArticlesLandingPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildArticlesLandingPageOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildArticlesLandingPageFilter>;
};


export type QueryBuildCampaignPageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildCampaignPageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildCampaignPageFilter>;
};


export type QueryBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildCampaignPageOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildCampaignPageFilter>;
};


export type QueryBuildCategoryWebpageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBuildCategoryWebpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildCategoryWebpageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildCategoryWebpageFilter>;
};


export type QueryBuildCategoryWebpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildCategoryWebpageOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildCategoryWebpageFilter>;
};


export type QueryBuildCustomerInformationCardArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBuildCustomerInformationCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildCustomerInformationCardOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildCustomerInformationCardFilter>;
};


export type QueryBuildCustomerInformationCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildCustomerInformationCardOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildCustomerInformationCardFilter>;
};


export type QueryBuildFaQsArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBuildFaQsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildFaQsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildFaQsFilter>;
};


export type QueryBuildFaQsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildFaQsOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildFaQsFilter>;
};


export type QueryBuildGenericTemplatePageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBuildGenericTemplatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildGenericTemplatePageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildGenericTemplatePageFilter>;
};


export type QueryBuildGenericTemplatePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildGenericTemplatePageOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildGenericTemplatePageFilter>;
};


export type QueryBuildLandingpageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBuildLandingpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildLandingpageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildLandingpageFilter>;
};


export type QueryBuildLandingpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildLandingpageOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildLandingpageFilter>;
};


export type QueryBuildNextBestActionArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBuildNextBestActionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildNextBestActionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildNextBestActionFilter>;
};


export type QueryBuildNextBestActionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildNextBestActionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildNextBestActionFilter>;
};


export type QueryBuildProductDetailPageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBuildProductDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildProductDetailPageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildProductDetailPageFilter>;
};


export type QueryBuildProductDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildProductDetailPageOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildProductDetailPageFilter>;
};


export type QueryBuildProductOverviewPageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBuildProductOverviewPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildProductOverviewPageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildProductOverviewPageFilter>;
};


export type QueryBuildProductOverviewPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildProductOverviewPageOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildProductOverviewPageFilter>;
};


export type QueryBuildRecommendedContentArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBuildRecommendedContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildRecommendedContentOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildRecommendedContentFilter>;
};


export type QueryBuildRecommendedContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildRecommendedContentOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildRecommendedContentFilter>;
};


export type QueryBuildTariffPageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBuildTariffPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildTariffPageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildTariffPageFilter>;
};


export type QueryBuildTariffPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildTariffPageOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildTariffPageFilter>;
};


export type QueryBuildWebpageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBuildWebpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildWebpageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildWebpageFilter>;
};


export type QueryBuildWebpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BuildWebpageOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BuildWebpageFilter>;
};


export type QueryComponentAccordionArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentAccordionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentAccordionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentAccordionFilter>;
};


export type QueryComponentAccordionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentAccordionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentAccordionFilter>;
};


export type QueryComponentActionCardArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentActionCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentActionCardOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentActionCardFilter>;
};


export type QueryComponentActionCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentActionCardOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentActionCardFilter>;
};


export type QueryComponentBlockCardArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentBlockCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentBlockCardOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentBlockCardFilter>;
};


export type QueryComponentBlockCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentBlockCardOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentBlockCardFilter>;
};


export type QueryComponentCalloutArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentCalloutCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCalloutOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentCalloutFilter>;
};


export type QueryComponentCalloutCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCalloutOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentCalloutFilter>;
};


export type QueryComponentCardArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentCardFilter>;
};


export type QueryComponentCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentCardFilter>;
};


export type QueryComponentCardGridArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentCardGridCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardGridOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentCardGridFilter>;
};


export type QueryComponentCardGridCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardGridOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentCardGridFilter>;
};


export type QueryComponentCardGroupArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentCardGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardGroupOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentCardGroupFilter>;
};


export type QueryComponentCardGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCardGroupOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentCardGroupFilter>;
};


export type QueryComponentCarouselArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentCarouselCardArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentCarouselCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCarouselCardOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentCarouselCardFilter>;
};


export type QueryComponentCarouselCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCarouselCardOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentCarouselCardFilter>;
};


export type QueryComponentCarouselCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCarouselOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentCarouselFilter>;
};


export type QueryComponentCarouselCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCarouselOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentCarouselFilter>;
};


export type QueryComponentCategoryBrowserArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentCategoryBrowserCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCategoryBrowserOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentCategoryBrowserFilter>;
};


export type QueryComponentCategoryBrowserCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCategoryBrowserOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentCategoryBrowserFilter>;
};


export type QueryComponentContactAndUsefulLinksArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentContactAndUsefulLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContactAndUsefulLinksOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentContactAndUsefulLinksFilter>;
};


export type QueryComponentContactAndUsefulLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContactAndUsefulLinksOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentContactAndUsefulLinksFilter>;
};


export type QueryComponentContentBlockArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentContentBlockCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContentBlockOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentContentBlockFilter>;
};


export type QueryComponentContentBlockCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContentBlockOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentContentBlockFilter>;
};


export type QueryComponentContentBlockV2Args = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentContentBlockV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContentBlockV2Order>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentContentBlockV2Filter>;
};


export type QueryComponentContentBlockV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentContentBlockV2Order>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentContentBlockV2Filter>;
};


export type QueryComponentCtaBannerArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentCtaBannerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCtaBannerOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentCtaBannerFilter>;
};


export type QueryComponentCtaBannerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentCtaBannerOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentCtaBannerFilter>;
};


export type QueryComponentDetailInfoSectionArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentDetailInfoSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentDetailInfoSectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentDetailInfoSectionFilter>;
};


export type QueryComponentDetailInfoSectionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentDetailInfoSectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentDetailInfoSectionFilter>;
};


export type QueryComponentFooterArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFooterOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentFooterFilter>;
};


export type QueryComponentFooterCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFooterOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentFooterFilter>;
};


export type QueryComponentFootnotesArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentFootnotesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFootnotesOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentFootnotesFilter>;
};


export type QueryComponentFootnotesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFootnotesOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentFootnotesFilter>;
};


export type QueryComponentFormArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentFormCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFormOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentFormFilter>;
};


export type QueryComponentFormCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentFormOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentFormFilter>;
};


export type QueryComponentGuideCardArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentGuideCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentGuideCardOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentGuideCardFilter>;
};


export type QueryComponentGuideCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentGuideCardOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentGuideCardFilter>;
};


export type QueryComponentGuidesRailArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentGuidesRailCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentGuidesRailOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentGuidesRailFilter>;
};


export type QueryComponentGuidesRailCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentGuidesRailOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentGuidesRailFilter>;
};


export type QueryComponentHelpAndCtaArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentHelpAndCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentHelpAndCtaOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentHelpAndCtaFilter>;
};


export type QueryComponentHelpAndCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentHelpAndCtaOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentHelpAndCtaFilter>;
};


export type QueryComponentHelpHomepageDualLayoutArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentHelpHomepageDualLayoutCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentHelpHomepageDualLayoutOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentHelpHomepageDualLayoutFilter>;
};


export type QueryComponentHelpHomepageDualLayoutCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentHelpHomepageDualLayoutOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentHelpHomepageDualLayoutFilter>;
};


export type QueryComponentHomepageHeroPostcodeSectionArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentHomepageHeroPostcodeSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentHomepageHeroPostcodeSectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentHomepageHeroPostcodeSectionFilter>;
};


export type QueryComponentHomepageHeroPostcodeSectionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentHomepageHeroPostcodeSectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentHomepageHeroPostcodeSectionFilter>;
};


export type QueryComponentIframeArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentIframeCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentIframeOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentIframeFilter>;
};


export type QueryComponentIframeCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentIframeOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentIframeFilter>;
};


export type QueryComponentImageGalleryArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentImageGalleryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentImageGalleryOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentImageGalleryFilter>;
};


export type QueryComponentImageGalleryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentImageGalleryOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentImageGalleryFilter>;
};


export type QueryComponentImageWithDescriptionArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentImageWithDescriptionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentImageWithDescriptionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentImageWithDescriptionFilter>;
};


export type QueryComponentImageWithDescriptionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentImageWithDescriptionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentImageWithDescriptionFilter>;
};


export type QueryComponentInfoCardArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentInfoCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentInfoCardOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentInfoCardFilter>;
};


export type QueryComponentInfoCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentInfoCardOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentInfoCardFilter>;
};


export type QueryComponentInfoGroupArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentInfoGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentInfoGroupOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentInfoGroupFilter>;
};


export type QueryComponentInfoGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentInfoGroupOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentInfoGroupFilter>;
};


export type QueryComponentLauncherGroupArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentLauncherGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentLauncherGroupOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentLauncherGroupFilter>;
};


export type QueryComponentLauncherGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentLauncherGroupOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentLauncherGroupFilter>;
};


export type QueryComponentLineupArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentLineupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentLineupOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentLineupFilter>;
};


export type QueryComponentLineupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentLineupOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentLineupFilter>;
};


export type QueryComponentLogoGroupArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentLogoGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentLogoGroupOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentLogoGroupFilter>;
};


export type QueryComponentLogoGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentLogoGroupOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentLogoGroupFilter>;
};


export type QueryComponentNavBarArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentNavBarCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentNavBarOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentNavBarFilter>;
};


export type QueryComponentNavBarCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentNavBarOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentNavBarFilter>;
};


export type QueryComponentPageHeroArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentPageHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPageHeroOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentPageHeroFilter>;
};


export type QueryComponentPageHeroCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPageHeroOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentPageHeroFilter>;
};


export type QueryComponentPostcodeFinderArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentPostcodeFinderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPostcodeFinderOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentPostcodeFinderFilter>;
};


export type QueryComponentPostcodeFinderCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPostcodeFinderOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentPostcodeFinderFilter>;
};


export type QueryComponentProductFeaturedCardArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentProductFeaturedCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentProductFeaturedCardOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentProductFeaturedCardFilter>;
};


export type QueryComponentProductFeaturedCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentProductFeaturedCardOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentProductFeaturedCardFilter>;
};


export type QueryComponentProductGroupArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentProductGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentProductGroupOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentProductGroupFilter>;
};


export type QueryComponentProductGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentProductGroupOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentProductGroupFilter>;
};


export type QueryComponentProductModuleArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentProductModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentProductModuleOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentProductModuleFilter>;
};


export type QueryComponentProductModuleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentProductModuleOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentProductModuleFilter>;
};


export type QueryComponentProductRailArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentProductRailCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentProductRailOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentProductRailFilter>;
};


export type QueryComponentProductRailCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentProductRailOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentProductRailFilter>;
};


export type QueryComponentPromoCardRailArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentPromoCardRailCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoCardRailOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentPromoCardRailFilter>;
};


export type QueryComponentPromoCardRailCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoCardRailOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentPromoCardRailFilter>;
};


export type QueryComponentPromoSectionArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentPromoSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoSectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentPromoSectionFilter>;
};


export type QueryComponentPromoSectionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoSectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentPromoSectionFilter>;
};


export type QueryComponentPromoTextCardArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentPromoTextCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoTextCardOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentPromoTextCardFilter>;
};


export type QueryComponentPromoTextCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoTextCardOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentPromoTextCardFilter>;
};


export type QueryComponentPromoTextCardSectionArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentPromoTextCardSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoTextCardSectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentPromoTextCardSectionFilter>;
};


export type QueryComponentPromoTextCardSectionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentPromoTextCardSectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentPromoTextCardSectionFilter>;
};


export type QueryComponentQrCodePopupArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentQrCodePopupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentQrCodePopupOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentQrCodePopupFilter>;
};


export type QueryComponentQrCodePopupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentQrCodePopupOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentQrCodePopupFilter>;
};


export type QueryComponentQuickLinksArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentQuickLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentQuickLinksOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentQuickLinksFilter>;
};


export type QueryComponentQuickLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentQuickLinksOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentQuickLinksFilter>;
};


export type QueryComponentRecommendedContentAccordionArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentRecommendedContentAccordionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentRecommendedContentAccordionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentRecommendedContentAccordionFilter>;
};


export type QueryComponentRecommendedContentAccordionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentRecommendedContentAccordionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentRecommendedContentAccordionFilter>;
};


export type QueryComponentSearchArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentSearchCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSearchOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentSearchFilter>;
};


export type QueryComponentSearchCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSearchOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentSearchFilter>;
};


export type QueryComponentSectionStepsArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentSectionStepsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSectionStepsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentSectionStepsFilter>;
};


export type QueryComponentSectionStepsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSectionStepsOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentSectionStepsFilter>;
};


export type QueryComponentSpotlightArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentSpotlightCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSpotlightOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentSpotlightFilter>;
};


export type QueryComponentSpotlightCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSpotlightOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentSpotlightFilter>;
};


export type QueryComponentSpotlightGridArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentSpotlightGridCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSpotlightGridOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentSpotlightGridFilter>;
};


export type QueryComponentSpotlightGridCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentSpotlightGridOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentSpotlightGridFilter>;
};


export type QueryComponentStepArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentStepCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentStepOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentStepFilter>;
};


export type QueryComponentStepCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentStepOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentStepFilter>;
};


export type QueryComponentTableArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentTableCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTableOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentTableFilter>;
};


export type QueryComponentTableCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTableOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentTableFilter>;
};


export type QueryComponentTariffCardArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentTariffCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTariffCardOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentTariffCardFilter>;
};


export type QueryComponentTariffCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTariffCardOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentTariffCardFilter>;
};


export type QueryComponentTariffCardGroupArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentTariffCardGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTariffCardGroupOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentTariffCardGroupFilter>;
};


export type QueryComponentTariffCardGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTariffCardGroupOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentTariffCardGroupFilter>;
};


export type QueryComponentTariffHeroArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentTariffHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTariffHeroOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentTariffHeroFilter>;
};


export type QueryComponentTariffHeroCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTariffHeroOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentTariffHeroFilter>;
};


export type QueryComponentTextAndCtaArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentTextAndCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTextAndCtaOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentTextAndCtaFilter>;
};


export type QueryComponentTextAndCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTextAndCtaOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentTextAndCtaFilter>;
};


export type QueryComponentTopArticleBrowserArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentTopArticleBrowserCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTopArticleBrowserOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentTopArticleBrowserFilter>;
};


export type QueryComponentTopArticleBrowserCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTopArticleBrowserOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentTopArticleBrowserFilter>;
};


export type QueryComponentTrustpilotArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentTrustpilotCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTrustpilotOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentTrustpilotFilter>;
};


export type QueryComponentTrustpilotCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentTrustpilotOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentTrustpilotFilter>;
};


export type QueryComponentUspCardArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentUspCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentUspCardOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentUspCardFilter>;
};


export type QueryComponentUspCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentUspCardOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentUspCardFilter>;
};


export type QueryComponentUspGroupArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentUspGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentUspGroupOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentUspGroupFilter>;
};


export type QueryComponentUspGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentUspGroupOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentUspGroupFilter>;
};


export type QueryComponentUspSupportingContentArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentUspSupportingContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentUspSupportingContentOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentUspSupportingContentFilter>;
};


export type QueryComponentUspSupportingContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentUspSupportingContentOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentUspSupportingContentFilter>;
};


export type QueryComponentVideoPlayerArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComponentVideoPlayerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentVideoPlayerOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentVideoPlayerFilter>;
};


export type QueryComponentVideoPlayerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ComponentVideoPlayerOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ComponentVideoPlayerFilter>;
};


export type QueryContentType1GgZsWOlfK2Wi0QIh0PwimArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryContentType1GgZsWOlfK2Wi0QIh0PwimCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType1GgZsWOlfK2Wi0QIh0PwimOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentType1GgZsWOlfK2Wi0QIh0PwimFilter>;
};


export type QueryContentType1GgZsWOlfK2Wi0QIh0PwimCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType1GgZsWOlfK2Wi0QIh0PwimOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentType1GgZsWOlfK2Wi0QIh0PwimFilter>;
};


export type QueryContentType5OiHchWgV9Y8SuvDxHCaLyArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryContentType5OiHchWgV9Y8SuvDxHCaLyCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyFilter>;
};


export type QueryContentType5OiHchWgV9Y8SuvDxHCaLyCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyFilter>;
};


export type QueryContentType5VCz5FHyZ2ZlWqa5OKh6Y9Args = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryContentType5VCz5FHyZ2ZlWqa5OKh6Y9CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5VCz5FHyZ2ZlWqa5OKh6Y9Order>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentType5VCz5FHyZ2ZlWqa5OKh6Y9Filter>;
};


export type QueryContentType5VCz5FHyZ2ZlWqa5OKh6Y9CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentType5VCz5FHyZ2ZlWqa5OKh6Y9Order>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentType5VCz5FHyZ2ZlWqa5OKh6Y9Filter>;
};


export type QueryEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<EntryOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EntryFilter>;
};


export type QueryEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<EntryOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EntryFilter>;
};


export type QueryIntegrationOptimizelyFlagArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryIntegrationOptimizelyFlagCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<IntegrationOptimizelyFlagOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<IntegrationOptimizelyFlagFilter>;
};


export type QueryIntegrationOptimizelyFlagCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<IntegrationOptimizelyFlagOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<IntegrationOptimizelyFlagFilter>;
};


export type QueryIntegrationOptimizelyFlagRuleArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryIntegrationOptimizelyFlagRuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<IntegrationOptimizelyFlagRuleOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<IntegrationOptimizelyFlagRuleFilter>;
};


export type QueryIntegrationOptimizelyFlagRuleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<IntegrationOptimizelyFlagRuleOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<IntegrationOptimizelyFlagRuleFilter>;
};


export type QueryPackAlertBannerArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPackAlertBannerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackAlertBannerOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackAlertBannerFilter>;
};


export type QueryPackAlertBannerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackAlertBannerOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackAlertBannerFilter>;
};


export type QueryPackAppStoreArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPackAppStoreCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackAppStoreOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackAppStoreFilter>;
};


export type QueryPackAppStoreCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackAppStoreOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackAppStoreFilter>;
};


export type QueryPackArticlePageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPackArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackArticlePageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackArticlePageFilter>;
};


export type QueryPackArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackArticlePageOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackArticlePageFilter>;
};


export type QueryPackCampaignPageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPackCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCampaignPageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCampaignPageFilter>;
};


export type QueryPackCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCampaignPageOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCampaignPageFilter>;
};


export type QueryPackCategoryArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPackCategoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCategoryOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCategoryFilter>;
};


export type QueryPackCategoryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCategoryOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCategoryFilter>;
};


export type QueryPackCategoryListArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPackCategoryListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCategoryListOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCategoryListFilter>;
};


export type QueryPackCategoryListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCategoryListOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCategoryListFilter>;
};


export type QueryPackContactOptionsArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPackContactOptionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackContactOptionsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackContactOptionsFilter>;
};


export type QueryPackContactOptionsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackContactOptionsOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackContactOptionsFilter>;
};


export type QueryPackCtaArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPackCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


export type QueryPackCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackCtaOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackCtaFilter>;
};


export type QueryPackDynamicVariablePlaceholderArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPackDynamicVariablePlaceholderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackDynamicVariablePlaceholderOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackDynamicVariablePlaceholderFilter>;
};


export type QueryPackDynamicVariablePlaceholderCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackDynamicVariablePlaceholderOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackDynamicVariablePlaceholderFilter>;
};


export type QueryPackFooterItemArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPackFooterItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackFooterItemOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackFooterItemFilter>;
};


export type QueryPackFooterItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackFooterItemOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackFooterItemFilter>;
};


export type QueryPackFreeFormPrivacyTextArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPackFreeFormPrivacyTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackFreeFormPrivacyTextOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackFreeFormPrivacyTextFilter>;
};


export type QueryPackFreeFormPrivacyTextCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackFreeFormPrivacyTextOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackFreeFormPrivacyTextFilter>;
};


export type QueryPackFreeFormTextArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPackFreeFormTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackFreeFormTextOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackFreeFormTextFilter>;
};


export type QueryPackFreeFormTextCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackFreeFormTextOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackFreeFormTextFilter>;
};


export type QueryPackHighlightedTextArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPackHighlightedTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackHighlightedTextOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackHighlightedTextFilter>;
};


export type QueryPackHighlightedTextCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackHighlightedTextOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackHighlightedTextFilter>;
};


export type QueryPackHomePageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPackHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackHomePageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackHomePageFilter>;
};


export type QueryPackHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackHomePageOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackHomePageFilter>;
};


export type QueryPackLandingPageArticlesArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPackLandingPageArticlesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackLandingPageArticlesOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackLandingPageArticlesFilter>;
};


export type QueryPackLandingPageArticlesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackLandingPageArticlesOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackLandingPageArticlesFilter>;
};


export type QueryPackLottieAnimationArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPackLottieAnimationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackLottieAnimationOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackLottieAnimationFilter>;
};


export type QueryPackLottieAnimationCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackLottieAnimationOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackLottieAnimationFilter>;
};


export type QueryPackMicrocopyArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPackMicrocopyCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackMicrocopyOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackMicrocopyFilter>;
};


export type QueryPackMicrocopyCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackMicrocopyOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackMicrocopyFilter>;
};


export type QueryPackNavBarCtaArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPackNavBarCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackNavBarCtaOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackNavBarCtaFilter>;
};


export type QueryPackNavBarCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackNavBarCtaOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackNavBarCtaFilter>;
};


export type QueryPackNavBarItemArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPackNavBarItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackNavBarItemOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackNavBarItemFilter>;
};


export type QueryPackNavBarItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackNavBarItemOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackNavBarItemFilter>;
};


export type QueryPackNavBarItemV2Args = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPackNavBarItemV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackNavBarItemV2Order>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackNavBarItemV2Filter>;
};


export type QueryPackNavBarItemV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackNavBarItemV2Order>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackNavBarItemV2Filter>;
};


export type QueryPackPageProductDetailArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPackPageProductDetailCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackPageProductDetailOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackPageProductDetailFilter>;
};


export type QueryPackPageProductDetailCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackPageProductDetailOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackPageProductDetailFilter>;
};


export type QueryPackPageStandardArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPackPageStandardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackPageStandardOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackPageStandardFilter>;
};


export type QueryPackPageStandardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackPageStandardOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackPageStandardFilter>;
};


export type QueryPackPageStandardV2Args = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPackPageStandardV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackPageStandardV2Order>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackPageStandardV2Filter>;
};


export type QueryPackPageStandardV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackPageStandardV2Order>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackPageStandardV2Filter>;
};


export type QueryPackPageStandardV2DevArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPackPageStandardV2DevCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackPageStandardV2DevOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackPageStandardV2DevFilter>;
};


export type QueryPackPageStandardV2DevCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackPageStandardV2DevOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackPageStandardV2DevFilter>;
};


export type QueryPackRecommendedContentAccordionItemArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPackRecommendedContentAccordionItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackRecommendedContentAccordionItemOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackRecommendedContentAccordionItemFilter>;
};


export type QueryPackRecommendedContentAccordionItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackRecommendedContentAccordionItemOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackRecommendedContentAccordionItemFilter>;
};


export type QueryPackRichTextArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPackRichTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackRichTextOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackRichTextFilter>;
};


export type QueryPackRichTextCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackRichTextOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackRichTextFilter>;
};


export type QueryPackSearchBarArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPackSearchBarCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackSearchBarOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackSearchBarFilter>;
};


export type QueryPackSearchBarCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackSearchBarOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackSearchBarFilter>;
};


export type QueryPackSearchRequirementsArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPackSearchRequirementsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackSearchRequirementsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackSearchRequirementsFilter>;
};


export type QueryPackSearchRequirementsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackSearchRequirementsOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackSearchRequirementsFilter>;
};


export type QueryPackSearchResultArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPackSearchResultCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackSearchResultOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackSearchResultFilter>;
};


export type QueryPackSearchResultCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackSearchResultOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackSearchResultFilter>;
};


export type QueryPackStructuredTextArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPackStructuredTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackStructuredTextFilter>;
};


export type QueryPackStructuredTextCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackStructuredTextOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackStructuredTextFilter>;
};


export type QueryPackTrustpilotBannerArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPackTrustpilotBannerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackTrustpilotBannerOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackTrustpilotBannerFilter>;
};


export type QueryPackTrustpilotBannerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackTrustpilotBannerOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackTrustpilotBannerFilter>;
};


export type QueryPackUserActionArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPackUserActionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackUserActionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackUserActionFilter>;
};


export type QueryPackUserActionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PackUserActionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PackUserActionFilter>;
};


export type QueryPromoCardArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPromoCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PromoCardOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PromoCardFilter>;
};


export type QueryPromoCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PromoCardOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PromoCardFilter>;
};


export type QueryTopicTableArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTopicTableCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TopicTableOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TopicTableFilter>;
};


export type QueryTopicTableCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TopicTableOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TopicTableFilter>;
};


export type QueryVariationContainerArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryVariationContainerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VariationContainerOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<VariationContainerFilter>;
};


export type QueryVariationContainerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VariationContainerOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<VariationContainerFilter>;
};


export type QueryWrapperAnchorArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryWrapperAnchorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperAnchorOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperAnchorFilter>;
};


export type QueryWrapperAnchorCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperAnchorOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperAnchorFilter>;
};


export type QueryWrapperAnimationArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryWrapperAnimationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperAnimationOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperAnimationFilter>;
};


export type QueryWrapperAnimationCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperAnimationOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperAnimationFilter>;
};


export type QueryWrapperAppScreenArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryWrapperAppScreenCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperAppScreenOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperAppScreenFilter>;
};


export type QueryWrapperAppScreenCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperAppScreenOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperAppScreenFilter>;
};


export type QueryWrapperBannerImageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryWrapperBannerImageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperBannerImageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperBannerImageFilter>;
};


export type QueryWrapperBannerImageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperBannerImageOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperBannerImageFilter>;
};


export type QueryWrapperDocumentArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryWrapperDocumentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperDocumentOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperDocumentFilter>;
};


export type QueryWrapperDocumentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperDocumentOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperDocumentFilter>;
};


export type QueryWrapperIconArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryWrapperIconCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperIconOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperIconFilter>;
};


export type QueryWrapperIconCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperIconOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperIconFilter>;
};


export type QueryWrapperImageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryWrapperImageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperImageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperImageFilter>;
};


export type QueryWrapperImageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperImageOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperImageFilter>;
};


export type QueryWrapperPageRoutingArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryWrapperPageRoutingCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperPageRoutingOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperPageRoutingFilter>;
};


export type QueryWrapperPageRoutingCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperPageRoutingOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperPageRoutingFilter>;
};


export type QueryWrapperPathArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryWrapperPathCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperPathOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperPathFilter>;
};


export type QueryWrapperPathCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperPathOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperPathFilter>;
};


export type QueryWrapperSocialMediaArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryWrapperSocialMediaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperSocialMediaOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperSocialMediaFilter>;
};


export type QueryWrapperSocialMediaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperSocialMediaOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperSocialMediaFilter>;
};


export type QueryWrapperUrlArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryWrapperUrlCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperUrlOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperUrlFilter>;
};


export type QueryWrapperUrlCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperUrlOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperUrlFilter>;
};


export type QueryWrapperVideoArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryWrapperVideoCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperVideoOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperVideoFilter>;
};


export type QueryWrapperVideoCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperVideoOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperVideoFilter>;
};

export type ResourceLink = {
  sys: ResourceSys;
};

export type ResourceSys = {
  __typename?: 'ResourceSys';
  linkType: Scalars['String']['output'];
  urn: Scalars['String']['output'];
};

export type Sys = {
  __typename?: 'Sys';
  environmentId: Scalars['String']['output'];
  firstPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  /** The locale that was requested. */
  locale?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedVersion?: Maybe<Scalars['Int']['output']>;
  spaceId: Scalars['String']['output'];
};

export type SysFilter = {
  firstPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_exists?: InputMaybe<Scalars['Boolean']['input']>;
  firstPublishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  firstPublishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_exists?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedVersion?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_exists?: InputMaybe<Scalars['Boolean']['input']>;
  publishedVersion_gt?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_gte?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  publishedVersion_lt?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_lte?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_not?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/**
 * Represents a taxonomy concept entity for finding and organizing content easily.
 *         Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-concepts
 */
export type TaxonomyConcept = {
  __typename?: 'TaxonomyConcept';
  id?: Maybe<Scalars['String']['output']>;
};

export type TimelineFilterInput = {
  /** Preview content starting from a given release date */
  release_lte?: InputMaybe<Scalars['String']['input']>;
  /** Preview content starting from a given timestamp */
  timestamp_lte?: InputMaybe<Scalars['DateTime']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/topicTable) */
export type TopicTable = Entry & _Node & {
  __typename?: 'TopicTable';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<TopicTableLinkingCollections>;
  sys: Sys;
  table?: Maybe<TopicTableTable>;
  tableCaption?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/topicTable) */
export type TopicTableLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/topicTable) */
export type TopicTableTableArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/topicTable) */
export type TopicTableTableCaptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TopicTableCollection = {
  __typename?: 'TopicTableCollection';
  items: Array<Maybe<TopicTable>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TopicTableCursorCollection = {
  __typename?: 'TopicTableCursorCollection';
  items: Array<Maybe<TopicTable>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type TopicTableFilter = {
  AND?: InputMaybe<Array<InputMaybe<TopicTableFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TopicTableFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  tableCaption?: InputMaybe<Scalars['String']['input']>;
  tableCaption_contains?: InputMaybe<Scalars['String']['input']>;
  tableCaption_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tableCaption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tableCaption_not?: InputMaybe<Scalars['String']['input']>;
  tableCaption_not_contains?: InputMaybe<Scalars['String']['input']>;
  tableCaption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  table_contains?: InputMaybe<Scalars['String']['input']>;
  table_exists?: InputMaybe<Scalars['Boolean']['input']>;
  table_not_contains?: InputMaybe<Scalars['String']['input']>;
};

export type TopicTableLinkingCollections = {
  __typename?: 'TopicTableLinkingCollections';
  componentTableCollection?: Maybe<ComponentTableCollection>;
  componentTableCursorCollection?: Maybe<ComponentTableCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type TopicTableLinkingCollectionsComponentTableCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TopicTableLinkingCollectionsComponentTableCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TopicTableLinkingCollectionsComponentTableCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TopicTableLinkingCollectionsComponentTableCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TopicTableLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TopicTableLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum TopicTableLinkingCollectionsComponentTableCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum TopicTableLinkingCollectionsComponentTableCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum TopicTableOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TableCaptionAsc = 'tableCaption_ASC',
  TableCaptionDesc = 'tableCaption_DESC'
}

export type TopicTableTable = {
  __typename?: 'TopicTableTable';
  json: Scalars['JSON']['output'];
  links: TopicTableTableLinks;
};

export type TopicTableTableAssets = {
  __typename?: 'TopicTableTableAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type TopicTableTableEntries = {
  __typename?: 'TopicTableTableEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type TopicTableTableLinks = {
  __typename?: 'TopicTableTableLinks';
  assets: TopicTableTableAssets;
  entries: TopicTableTableEntries;
  resources: TopicTableTableResources;
};

export type TopicTableTableResources = {
  __typename?: 'TopicTableTableResources';
  block: Array<TopicTableTableResourcesBlock>;
  hyperlink: Array<TopicTableTableResourcesHyperlink>;
  inline: Array<TopicTableTableResourcesInline>;
};

export type TopicTableTableResourcesBlock = ResourceLink & {
  __typename?: 'TopicTableTableResourcesBlock';
  sys: ResourceSys;
};

export type TopicTableTableResourcesHyperlink = ResourceLink & {
  __typename?: 'TopicTableTableResourcesHyperlink';
  sys: ResourceSys;
};

export type TopicTableTableResourcesInline = ResourceLink & {
  __typename?: 'TopicTableTableResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/variationContainer) */
export type VariationContainer = Entry & _Node & {
  __typename?: 'VariationContainer';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  environment?: Maybe<Scalars['String']['output']>;
  experimentId?: Maybe<Scalars['String']['output']>;
  experimentKey?: Maybe<Scalars['String']['output']>;
  experimentTitle?: Maybe<Scalars['String']['output']>;
  flagKey?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<VariationContainerLinkingCollections>;
  meta?: Maybe<Scalars['JSON']['output']>;
  sys: Sys;
  variationsCollection?: Maybe<VariationContainerVariationsCollection>;
  variationsCursorCollection?: Maybe<VariationContainerVariationsCursorCollection>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/variationContainer) */
export type VariationContainerEnvironmentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/variationContainer) */
export type VariationContainerExperimentIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/variationContainer) */
export type VariationContainerExperimentKeyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/variationContainer) */
export type VariationContainerExperimentTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/variationContainer) */
export type VariationContainerFlagKeyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/variationContainer) */
export type VariationContainerLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/variationContainer) */
export type VariationContainerMetaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/variationContainer) */
export type VariationContainerVariationsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/variationContainer) */
export type VariationContainerVariationsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VariationContainerCollection = {
  __typename?: 'VariationContainerCollection';
  items: Array<Maybe<VariationContainer>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type VariationContainerCursorCollection = {
  __typename?: 'VariationContainerCursorCollection';
  items: Array<Maybe<VariationContainer>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type VariationContainerFilter = {
  AND?: InputMaybe<Array<InputMaybe<VariationContainerFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<VariationContainerFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  environment?: InputMaybe<Scalars['String']['input']>;
  environment_contains?: InputMaybe<Scalars['String']['input']>;
  environment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  environment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  environment_not?: InputMaybe<Scalars['String']['input']>;
  environment_not_contains?: InputMaybe<Scalars['String']['input']>;
  environment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  experimentId?: InputMaybe<Scalars['String']['input']>;
  experimentId_contains?: InputMaybe<Scalars['String']['input']>;
  experimentId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  experimentId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  experimentId_not?: InputMaybe<Scalars['String']['input']>;
  experimentId_not_contains?: InputMaybe<Scalars['String']['input']>;
  experimentId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  experimentKey?: InputMaybe<Scalars['String']['input']>;
  experimentKey_contains?: InputMaybe<Scalars['String']['input']>;
  experimentKey_exists?: InputMaybe<Scalars['Boolean']['input']>;
  experimentKey_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  experimentKey_not?: InputMaybe<Scalars['String']['input']>;
  experimentKey_not_contains?: InputMaybe<Scalars['String']['input']>;
  experimentKey_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  experimentTitle?: InputMaybe<Scalars['String']['input']>;
  experimentTitle_contains?: InputMaybe<Scalars['String']['input']>;
  experimentTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  experimentTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  experimentTitle_not?: InputMaybe<Scalars['String']['input']>;
  experimentTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  experimentTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  flagKey?: InputMaybe<Scalars['String']['input']>;
  flagKey_contains?: InputMaybe<Scalars['String']['input']>;
  flagKey_exists?: InputMaybe<Scalars['Boolean']['input']>;
  flagKey_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  flagKey_not?: InputMaybe<Scalars['String']['input']>;
  flagKey_not_contains?: InputMaybe<Scalars['String']['input']>;
  flagKey_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  meta_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  variationsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VariationContainerLinkingCollections = {
  __typename?: 'VariationContainerLinkingCollections';
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildGenericTemplatePageCollection?: Maybe<BuildGenericTemplatePageCollection>;
  buildGenericTemplatePageCursorCollection?: Maybe<BuildGenericTemplatePageCursorCollection>;
  buildLandingpageCollection?: Maybe<BuildLandingpageCollection>;
  buildLandingpageCursorCollection?: Maybe<BuildLandingpageCursorCollection>;
  buildTariffPageCollection?: Maybe<BuildTariffPageCollection>;
  buildTariffPageCursorCollection?: Maybe<BuildTariffPageCursorCollection>;
  componentCarouselCollection?: Maybe<ComponentCarouselCollection>;
  componentCarouselCursorCollection?: Maybe<ComponentCarouselCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  packArticlePageCollection?: Maybe<PackArticlePageCollection>;
  packArticlePageCursorCollection?: Maybe<PackArticlePageCursorCollection>;
  packCampaignPageCollection?: Maybe<PackCampaignPageCollection>;
  packCampaignPageCursorCollection?: Maybe<PackCampaignPageCursorCollection>;
  packHomePageCollection?: Maybe<PackHomePageCollection>;
  packHomePageCursorCollection?: Maybe<PackHomePageCursorCollection>;
  packLandingPageArticlesCollection?: Maybe<PackLandingPageArticlesCollection>;
  packLandingPageArticlesCursorCollection?: Maybe<PackLandingPageArticlesCursorCollection>;
  packPageProductDetailCollection?: Maybe<PackPageProductDetailCollection>;
  packPageProductDetailCursorCollection?: Maybe<PackPageProductDetailCursorCollection>;
  packPageStandardCollection?: Maybe<PackPageStandardCollection>;
  packPageStandardCursorCollection?: Maybe<PackPageStandardCursorCollection>;
  packPageStandardV2Collection?: Maybe<PackPageStandardV2Collection>;
  packPageStandardV2CursorCollection?: Maybe<PackPageStandardV2CursorCollection>;
};


export type VariationContainerLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VariationContainerLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VariationContainerLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VariationContainerLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VariationContainerLinkingCollectionsBuildGenericTemplatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VariationContainerLinkingCollectionsBuildGenericTemplatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VariationContainerLinkingCollectionsBuildGenericTemplatePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VariationContainerLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VariationContainerLinkingCollectionsBuildLandingpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VariationContainerLinkingCollectionsBuildLandingpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VariationContainerLinkingCollectionsBuildLandingpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VariationContainerLinkingCollectionsBuildLandingpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VariationContainerLinkingCollectionsBuildTariffPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VariationContainerLinkingCollectionsBuildTariffPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VariationContainerLinkingCollectionsBuildTariffPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VariationContainerLinkingCollectionsBuildTariffPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VariationContainerLinkingCollectionsComponentCarouselCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VariationContainerLinkingCollectionsComponentCarouselCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VariationContainerLinkingCollectionsComponentCarouselCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VariationContainerLinkingCollectionsComponentCarouselCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VariationContainerLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VariationContainerLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VariationContainerLinkingCollectionsPackArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VariationContainerLinkingCollectionsPackArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VariationContainerLinkingCollectionsPackArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VariationContainerLinkingCollectionsPackArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VariationContainerLinkingCollectionsPackCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VariationContainerLinkingCollectionsPackCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VariationContainerLinkingCollectionsPackCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VariationContainerLinkingCollectionsPackCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VariationContainerLinkingCollectionsPackHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VariationContainerLinkingCollectionsPackHomePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VariationContainerLinkingCollectionsPackHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VariationContainerLinkingCollectionsPackHomePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VariationContainerLinkingCollectionsPackLandingPageArticlesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VariationContainerLinkingCollectionsPackLandingPageArticlesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VariationContainerLinkingCollectionsPackLandingPageArticlesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VariationContainerLinkingCollectionsPackLandingPageArticlesCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VariationContainerLinkingCollectionsPackPageProductDetailCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VariationContainerLinkingCollectionsPackPageProductDetailCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VariationContainerLinkingCollectionsPackPageProductDetailCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VariationContainerLinkingCollectionsPackPageProductDetailCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VariationContainerLinkingCollectionsPackPageStandardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VariationContainerLinkingCollectionsPackPageStandardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VariationContainerLinkingCollectionsPackPageStandardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VariationContainerLinkingCollectionsPackPageStandardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VariationContainerLinkingCollectionsPackPageStandardV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VariationContainerLinkingCollectionsPackPageStandardV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VariationContainerLinkingCollectionsPackPageStandardV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VariationContainerLinkingCollectionsPackPageStandardV2CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum VariationContainerLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum VariationContainerLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum VariationContainerLinkingCollectionsBuildGenericTemplatePageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum VariationContainerLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum VariationContainerLinkingCollectionsBuildLandingpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum VariationContainerLinkingCollectionsBuildLandingpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum VariationContainerLinkingCollectionsBuildTariffPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum VariationContainerLinkingCollectionsBuildTariffPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum VariationContainerLinkingCollectionsComponentCarouselCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum VariationContainerLinkingCollectionsComponentCarouselCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum VariationContainerLinkingCollectionsPackArticlePageCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  ShareLinkAsc = 'shareLink_ASC',
  ShareLinkDesc = 'shareLink_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum VariationContainerLinkingCollectionsPackArticlePageCursorCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  ShareLinkAsc = 'shareLink_ASC',
  ShareLinkDesc = 'shareLink_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum VariationContainerLinkingCollectionsPackCampaignPageCollectionOrder {
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  HasGradientAsc = 'hasGradient_ASC',
  HasGradientDesc = 'hasGradient_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  HeroTextPositionAsc = 'heroTextPosition_ASC',
  HeroTextPositionDesc = 'heroTextPosition_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC'
}

export enum VariationContainerLinkingCollectionsPackCampaignPageCursorCollectionOrder {
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  HasGradientAsc = 'hasGradient_ASC',
  HasGradientDesc = 'hasGradient_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  HeroTextPositionAsc = 'heroTextPosition_ASC',
  HeroTextPositionDesc = 'heroTextPosition_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC'
}

export enum VariationContainerLinkingCollectionsPackHomePageCollectionOrder {
  ComponentVariantAsc = 'componentVariant_ASC',
  ComponentVariantDesc = 'componentVariant_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TrustpilotBannerAsc = 'trustpilotBanner_ASC',
  TrustpilotBannerDesc = 'trustpilotBanner_DESC'
}

export enum VariationContainerLinkingCollectionsPackHomePageCursorCollectionOrder {
  ComponentVariantAsc = 'componentVariant_ASC',
  ComponentVariantDesc = 'componentVariant_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TrustpilotBannerAsc = 'trustpilotBanner_ASC',
  TrustpilotBannerDesc = 'trustpilotBanner_DESC'
}

export enum VariationContainerLinkingCollectionsPackLandingPageArticlesCollectionOrder {
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum VariationContainerLinkingCollectionsPackLandingPageArticlesCursorCollectionOrder {
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum VariationContainerLinkingCollectionsPackPageProductDetailCollectionOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum VariationContainerLinkingCollectionsPackPageProductDetailCursorCollectionOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum VariationContainerLinkingCollectionsPackPageStandardCollectionOrder {
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum VariationContainerLinkingCollectionsPackPageStandardCursorCollectionOrder {
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum VariationContainerLinkingCollectionsPackPageStandardV2CollectionOrder {
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum VariationContainerLinkingCollectionsPackPageStandardV2CursorCollectionOrder {
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum VariationContainerOrder {
  EnvironmentAsc = 'environment_ASC',
  EnvironmentDesc = 'environment_DESC',
  ExperimentIdAsc = 'experimentId_ASC',
  ExperimentIdDesc = 'experimentId_DESC',
  ExperimentKeyAsc = 'experimentKey_ASC',
  ExperimentKeyDesc = 'experimentKey_DESC',
  ExperimentTitleAsc = 'experimentTitle_ASC',
  ExperimentTitleDesc = 'experimentTitle_DESC',
  FlagKeyAsc = 'flagKey_ASC',
  FlagKeyDesc = 'flagKey_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type VariationContainerVariationsCollection = {
  __typename?: 'VariationContainerVariationsCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type VariationContainerVariationsCursorCollection = {
  __typename?: 'VariationContainerVariationsCursorCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperAnchor) */
export type WrapperAnchor = Entry & _Node & {
  __typename?: 'WrapperAnchor';
  _id: Scalars['ID']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<WrapperAnchorLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperAnchor) */
export type WrapperAnchorAnchorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperAnchor) */
export type WrapperAnchorLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type WrapperAnchorCollection = {
  __typename?: 'WrapperAnchorCollection';
  items: Array<Maybe<WrapperAnchor>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type WrapperAnchorCursorCollection = {
  __typename?: 'WrapperAnchorCursorCollection';
  items: Array<Maybe<WrapperAnchor>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type WrapperAnchorFilter = {
  AND?: InputMaybe<Array<InputMaybe<WrapperAnchorFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<WrapperAnchorFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type WrapperAnchorLinkingCollections = {
  __typename?: 'WrapperAnchorLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type WrapperAnchorLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperAnchorLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum WrapperAnchorOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperAnimation) */
export type WrapperAnimation = Entry & _Node & {
  __typename?: 'WrapperAnimation';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  hasDesktopAnimation?: Maybe<Scalars['Boolean']['output']>;
  hasMobileAnimation?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<WrapperAnimationLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperAnimation) */
export type WrapperAnimationHasDesktopAnimationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperAnimation) */
export type WrapperAnimationHasMobileAnimationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperAnimation) */
export type WrapperAnimationLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperAnimation) */
export type WrapperAnimationTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WrapperAnimationCollection = {
  __typename?: 'WrapperAnimationCollection';
  items: Array<Maybe<WrapperAnimation>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type WrapperAnimationCursorCollection = {
  __typename?: 'WrapperAnimationCursorCollection';
  items: Array<Maybe<WrapperAnimation>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type WrapperAnimationFilter = {
  AND?: InputMaybe<Array<InputMaybe<WrapperAnimationFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<WrapperAnimationFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  hasDesktopAnimation?: InputMaybe<Scalars['Boolean']['input']>;
  hasDesktopAnimation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hasDesktopAnimation_not?: InputMaybe<Scalars['Boolean']['input']>;
  hasMobileAnimation?: InputMaybe<Scalars['Boolean']['input']>;
  hasMobileAnimation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hasMobileAnimation_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type WrapperAnimationLinkingCollections = {
  __typename?: 'WrapperAnimationLinkingCollections';
  componentHomepageHeroPostcodeSectionCollection?: Maybe<ComponentHomepageHeroPostcodeSectionCollection>;
  componentHomepageHeroPostcodeSectionCursorCollection?: Maybe<ComponentHomepageHeroPostcodeSectionCursorCollection>;
  componentProductGroupCollection?: Maybe<ComponentProductGroupCollection>;
  componentProductGroupCursorCollection?: Maybe<ComponentProductGroupCursorCollection>;
  componentUspGroupCollection?: Maybe<ComponentUspGroupCollection>;
  componentUspGroupCursorCollection?: Maybe<ComponentUspGroupCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  packCampaignPageCollection?: Maybe<PackCampaignPageCollection>;
  packCampaignPageCursorCollection?: Maybe<PackCampaignPageCursorCollection>;
};


export type WrapperAnimationLinkingCollectionsComponentHomepageHeroPostcodeSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperAnimationLinkingCollectionsComponentHomepageHeroPostcodeSectionCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperAnimationLinkingCollectionsComponentHomepageHeroPostcodeSectionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperAnimationLinkingCollectionsComponentHomepageHeroPostcodeSectionCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperAnimationLinkingCollectionsComponentProductGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperAnimationLinkingCollectionsComponentProductGroupCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperAnimationLinkingCollectionsComponentProductGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperAnimationLinkingCollectionsComponentProductGroupCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperAnimationLinkingCollectionsComponentUspGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperAnimationLinkingCollectionsComponentUspGroupCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperAnimationLinkingCollectionsComponentUspGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperAnimationLinkingCollectionsComponentUspGroupCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperAnimationLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperAnimationLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperAnimationLinkingCollectionsPackCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperAnimationLinkingCollectionsPackCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperAnimationLinkingCollectionsPackCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperAnimationLinkingCollectionsPackCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum WrapperAnimationLinkingCollectionsComponentHomepageHeroPostcodeSectionCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum WrapperAnimationLinkingCollectionsComponentHomepageHeroPostcodeSectionCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum WrapperAnimationLinkingCollectionsComponentProductGroupCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TermsAsc = 'terms_ASC',
  TermsDesc = 'terms_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export enum WrapperAnimationLinkingCollectionsComponentProductGroupCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TermsAsc = 'terms_ASC',
  TermsDesc = 'terms_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export enum WrapperAnimationLinkingCollectionsComponentUspGroupCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TermsAsc = 'terms_ASC',
  TermsDesc = 'terms_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export enum WrapperAnimationLinkingCollectionsComponentUspGroupCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TermsAsc = 'terms_ASC',
  TermsDesc = 'terms_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export enum WrapperAnimationLinkingCollectionsPackCampaignPageCollectionOrder {
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  HasGradientAsc = 'hasGradient_ASC',
  HasGradientDesc = 'hasGradient_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  HeroTextPositionAsc = 'heroTextPosition_ASC',
  HeroTextPositionDesc = 'heroTextPosition_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC'
}

export enum WrapperAnimationLinkingCollectionsPackCampaignPageCursorCollectionOrder {
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  HasGradientAsc = 'hasGradient_ASC',
  HasGradientDesc = 'hasGradient_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  HeroTextPositionAsc = 'heroTextPosition_ASC',
  HeroTextPositionDesc = 'heroTextPosition_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC'
}

export enum WrapperAnimationOrder {
  HasDesktopAnimationAsc = 'hasDesktopAnimation_ASC',
  HasDesktopAnimationDesc = 'hasDesktopAnimation_DESC',
  HasMobileAnimationAsc = 'hasMobileAnimation_ASC',
  HasMobileAnimationDesc = 'hasMobileAnimation_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperAppScreen) */
export type WrapperAppScreen = Entry & _Node & {
  __typename?: 'WrapperAppScreen';
  _id: Scalars['ID']['output'];
  appScreenName?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<WrapperAppScreenLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperAppScreen) */
export type WrapperAppScreenAppScreenNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperAppScreen) */
export type WrapperAppScreenLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type WrapperAppScreenCollection = {
  __typename?: 'WrapperAppScreenCollection';
  items: Array<Maybe<WrapperAppScreen>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type WrapperAppScreenCursorCollection = {
  __typename?: 'WrapperAppScreenCursorCollection';
  items: Array<Maybe<WrapperAppScreen>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type WrapperAppScreenFilter = {
  AND?: InputMaybe<Array<InputMaybe<WrapperAppScreenFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<WrapperAppScreenFilter>>>;
  appScreenName?: InputMaybe<Scalars['String']['input']>;
  appScreenName_contains?: InputMaybe<Scalars['String']['input']>;
  appScreenName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  appScreenName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appScreenName_not?: InputMaybe<Scalars['String']['input']>;
  appScreenName_not_contains?: InputMaybe<Scalars['String']['input']>;
  appScreenName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type WrapperAppScreenLinkingCollections = {
  __typename?: 'WrapperAppScreenLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type WrapperAppScreenLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperAppScreenLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum WrapperAppScreenOrder {
  AppScreenNameAsc = 'appScreenName_ASC',
  AppScreenNameDesc = 'appScreenName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperBannerImage) */
export type WrapperBannerImage = Entry & _Node & {
  __typename?: 'WrapperBannerImage';
  _id: Scalars['ID']['output'];
  altText?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  desktopImage?: Maybe<Asset>;
  linkedFrom?: Maybe<WrapperBannerImageLinkingCollections>;
  mobileImage?: Maybe<Asset>;
  sys: Sys;
  useAltText?: Maybe<Scalars['Boolean']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperBannerImage) */
export type WrapperBannerImageAltTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperBannerImage) */
export type WrapperBannerImageDesktopImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperBannerImage) */
export type WrapperBannerImageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperBannerImage) */
export type WrapperBannerImageMobileImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperBannerImage) */
export type WrapperBannerImageUseAltTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WrapperBannerImageCollection = {
  __typename?: 'WrapperBannerImageCollection';
  items: Array<Maybe<WrapperBannerImage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type WrapperBannerImageCursorCollection = {
  __typename?: 'WrapperBannerImageCursorCollection';
  items: Array<Maybe<WrapperBannerImage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type WrapperBannerImageFilter = {
  AND?: InputMaybe<Array<InputMaybe<WrapperBannerImageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<WrapperBannerImageFilter>>>;
  altText?: InputMaybe<Scalars['String']['input']>;
  altText_contains?: InputMaybe<Scalars['String']['input']>;
  altText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  altText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  altText_not?: InputMaybe<Scalars['String']['input']>;
  altText_not_contains?: InputMaybe<Scalars['String']['input']>;
  altText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  desktopImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mobileImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  useAltText?: InputMaybe<Scalars['Boolean']['input']>;
  useAltText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useAltText_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WrapperBannerImageLinkingCollections = {
  __typename?: 'WrapperBannerImageLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  packArticlePageCollection?: Maybe<PackArticlePageCollection>;
  packArticlePageCursorCollection?: Maybe<PackArticlePageCursorCollection>;
  packPageStandardCollection?: Maybe<PackPageStandardCollection>;
  packPageStandardCursorCollection?: Maybe<PackPageStandardCursorCollection>;
  packPageStandardV2Collection?: Maybe<PackPageStandardV2Collection>;
  packPageStandardV2CursorCollection?: Maybe<PackPageStandardV2CursorCollection>;
  packPageStandardV2DevCollection?: Maybe<PackPageStandardV2DevCollection>;
  packPageStandardV2DevCursorCollection?: Maybe<PackPageStandardV2DevCursorCollection>;
};


export type WrapperBannerImageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperBannerImageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperBannerImageLinkingCollectionsPackArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperBannerImageLinkingCollectionsPackArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperBannerImageLinkingCollectionsPackArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperBannerImageLinkingCollectionsPackArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperBannerImageLinkingCollectionsPackPageStandardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperBannerImageLinkingCollectionsPackPageStandardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperBannerImageLinkingCollectionsPackPageStandardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperBannerImageLinkingCollectionsPackPageStandardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperBannerImageLinkingCollectionsPackPageStandardV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperBannerImageLinkingCollectionsPackPageStandardV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperBannerImageLinkingCollectionsPackPageStandardV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperBannerImageLinkingCollectionsPackPageStandardV2CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperBannerImageLinkingCollectionsPackPageStandardV2DevCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperBannerImageLinkingCollectionsPackPageStandardV2DevCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperBannerImageLinkingCollectionsPackPageStandardV2DevCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperBannerImageLinkingCollectionsPackPageStandardV2DevCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum WrapperBannerImageLinkingCollectionsPackArticlePageCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  ShareLinkAsc = 'shareLink_ASC',
  ShareLinkDesc = 'shareLink_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperBannerImageLinkingCollectionsPackArticlePageCursorCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  ShareLinkAsc = 'shareLink_ASC',
  ShareLinkDesc = 'shareLink_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperBannerImageLinkingCollectionsPackPageStandardCollectionOrder {
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperBannerImageLinkingCollectionsPackPageStandardCursorCollectionOrder {
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperBannerImageLinkingCollectionsPackPageStandardV2CollectionOrder {
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperBannerImageLinkingCollectionsPackPageStandardV2CursorCollectionOrder {
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperBannerImageLinkingCollectionsPackPageStandardV2DevCollectionOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  Subheader2Asc = 'subheader2_ASC',
  Subheader2Desc = 'subheader2_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperBannerImageLinkingCollectionsPackPageStandardV2DevCursorCollectionOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  Subheader2Asc = 'subheader2_ASC',
  Subheader2Desc = 'subheader2_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperBannerImageOrder {
  AltTextAsc = 'altText_ASC',
  AltTextDesc = 'altText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UseAltTextAsc = 'useAltText_ASC',
  UseAltTextDesc = 'useAltText_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperDocument) */
export type WrapperDocument = Entry & _Node & {
  __typename?: 'WrapperDocument';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  document?: Maybe<Asset>;
  documentTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<WrapperDocumentLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperDocument) */
export type WrapperDocumentDocumentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperDocument) */
export type WrapperDocumentDocumentTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperDocument) */
export type WrapperDocumentLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type WrapperDocumentCollection = {
  __typename?: 'WrapperDocumentCollection';
  items: Array<Maybe<WrapperDocument>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type WrapperDocumentCursorCollection = {
  __typename?: 'WrapperDocumentCursorCollection';
  items: Array<Maybe<WrapperDocument>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type WrapperDocumentFilter = {
  AND?: InputMaybe<Array<InputMaybe<WrapperDocumentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<WrapperDocumentFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  documentTitle?: InputMaybe<Scalars['String']['input']>;
  documentTitle_contains?: InputMaybe<Scalars['String']['input']>;
  documentTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  documentTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentTitle_not?: InputMaybe<Scalars['String']['input']>;
  documentTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  documentTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  document_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type WrapperDocumentLinkingCollections = {
  __typename?: 'WrapperDocumentLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  packCtaCollection?: Maybe<PackCtaCollection>;
  packCtaCursorCollection?: Maybe<PackCtaCursorCollection>;
};


export type WrapperDocumentLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperDocumentLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperDocumentLinkingCollectionsPackCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperDocumentLinkingCollectionsPackCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperDocumentLinkingCollectionsPackCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperDocumentLinkingCollectionsPackCtaCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum WrapperDocumentLinkingCollectionsPackCtaCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export enum WrapperDocumentLinkingCollectionsPackCtaCursorCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export enum WrapperDocumentOrder {
  DocumentTitleAsc = 'documentTitle_ASC',
  DocumentTitleDesc = 'documentTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperIcon) */
export type WrapperIcon = Entry & _Node & {
  __typename?: 'WrapperIcon';
  _id: Scalars['ID']['output'];
  altText?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<WrapperIconLinkingCollections>;
  svg?: Maybe<Asset>;
  sys: Sys;
  useAltText?: Maybe<Scalars['Boolean']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperIcon) */
export type WrapperIconAltTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperIcon) */
export type WrapperIconLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperIcon) */
export type WrapperIconSvgArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperIcon) */
export type WrapperIconUseAltTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WrapperIconCollection = {
  __typename?: 'WrapperIconCollection';
  items: Array<Maybe<WrapperIcon>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type WrapperIconCursorCollection = {
  __typename?: 'WrapperIconCursorCollection';
  items: Array<Maybe<WrapperIcon>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type WrapperIconFilter = {
  AND?: InputMaybe<Array<InputMaybe<WrapperIconFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<WrapperIconFilter>>>;
  altText?: InputMaybe<Scalars['String']['input']>;
  altText_contains?: InputMaybe<Scalars['String']['input']>;
  altText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  altText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  altText_not?: InputMaybe<Scalars['String']['input']>;
  altText_not_contains?: InputMaybe<Scalars['String']['input']>;
  altText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  svg_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  useAltText?: InputMaybe<Scalars['Boolean']['input']>;
  useAltText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useAltText_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WrapperIconLinkingCollections = {
  __typename?: 'WrapperIconLinkingCollections';
  componentCalloutCollection?: Maybe<ComponentCalloutCollection>;
  componentCalloutCursorCollection?: Maybe<ComponentCalloutCursorCollection>;
  componentCardCollection?: Maybe<ComponentCardCollection>;
  componentCardCursorCollection?: Maybe<ComponentCardCursorCollection>;
  componentNavBarCollection?: Maybe<ComponentNavBarCollection>;
  componentNavBarCursorCollection?: Maybe<ComponentNavBarCursorCollection>;
  componentSpotlightCollection?: Maybe<ComponentSpotlightCollection>;
  componentSpotlightCursorCollection?: Maybe<ComponentSpotlightCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  packCategoryCollection?: Maybe<PackCategoryCollection>;
  packCategoryCursorCollection?: Maybe<PackCategoryCursorCollection>;
  packNavBarCtaCollection?: Maybe<PackNavBarCtaCollection>;
  packNavBarCtaCursorCollection?: Maybe<PackNavBarCtaCursorCollection>;
  packSearchBarCollection?: Maybe<PackSearchBarCollection>;
  packSearchBarCursorCollection?: Maybe<PackSearchBarCursorCollection>;
  wrapperSocialMediaCollection?: Maybe<WrapperSocialMediaCollection>;
  wrapperSocialMediaCursorCollection?: Maybe<WrapperSocialMediaCursorCollection>;
};


export type WrapperIconLinkingCollectionsComponentCalloutCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperIconLinkingCollectionsComponentCalloutCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperIconLinkingCollectionsComponentCalloutCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperIconLinkingCollectionsComponentCalloutCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperIconLinkingCollectionsComponentCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperIconLinkingCollectionsComponentCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperIconLinkingCollectionsComponentCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperIconLinkingCollectionsComponentCardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperIconLinkingCollectionsComponentNavBarCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperIconLinkingCollectionsComponentNavBarCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperIconLinkingCollectionsComponentNavBarCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperIconLinkingCollectionsComponentNavBarCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperIconLinkingCollectionsComponentSpotlightCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperIconLinkingCollectionsComponentSpotlightCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperIconLinkingCollectionsComponentSpotlightCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperIconLinkingCollectionsComponentSpotlightCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperIconLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperIconLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperIconLinkingCollectionsPackCategoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperIconLinkingCollectionsPackCategoryCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperIconLinkingCollectionsPackCategoryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperIconLinkingCollectionsPackCategoryCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperIconLinkingCollectionsPackNavBarCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperIconLinkingCollectionsPackNavBarCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperIconLinkingCollectionsPackNavBarCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperIconLinkingCollectionsPackNavBarCtaCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperIconLinkingCollectionsPackSearchBarCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperIconLinkingCollectionsPackSearchBarCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperIconLinkingCollectionsPackSearchBarCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperIconLinkingCollectionsPackSearchBarCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperIconLinkingCollectionsWrapperSocialMediaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperIconLinkingCollectionsWrapperSocialMediaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperIconLinkingCollectionsWrapperSocialMediaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperIconLinkingCollectionsWrapperSocialMediaCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum WrapperIconLinkingCollectionsComponentCalloutCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperIconLinkingCollectionsComponentCalloutCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperIconLinkingCollectionsComponentCardCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  ShortTextAsc = 'shortText_ASC',
  ShortTextDesc = 'shortText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperIconLinkingCollectionsComponentCardCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  ShortTextAsc = 'shortText_ASC',
  ShortTextDesc = 'shortText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperIconLinkingCollectionsComponentNavBarCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperIconLinkingCollectionsComponentNavBarCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperIconLinkingCollectionsComponentSpotlightCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperIconLinkingCollectionsComponentSpotlightCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperIconLinkingCollectionsPackCategoryCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperIconLinkingCollectionsPackCategoryCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperIconLinkingCollectionsPackNavBarCtaCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperIconLinkingCollectionsPackNavBarCtaCursorCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperIconLinkingCollectionsPackSearchBarCollectionOrder {
  HintTextAsc = 'hintText_ASC',
  HintTextDesc = 'hintText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperIconLinkingCollectionsPackSearchBarCursorCollectionOrder {
  HintTextAsc = 'hintText_ASC',
  HintTextDesc = 'hintText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperIconLinkingCollectionsWrapperSocialMediaCollectionOrder {
  ChannelAsc = 'channel_ASC',
  ChannelDesc = 'channel_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperIconLinkingCollectionsWrapperSocialMediaCursorCollectionOrder {
  ChannelAsc = 'channel_ASC',
  ChannelDesc = 'channel_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperIconOrder {
  AltTextAsc = 'altText_ASC',
  AltTextDesc = 'altText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UseAltTextAsc = 'useAltText_ASC',
  UseAltTextDesc = 'useAltText_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperImage) */
export type WrapperImage = Entry & _Node & {
  __typename?: 'WrapperImage';
  _id: Scalars['ID']['output'];
  altText?: Maybe<Scalars['String']['output']>;
  bynderImage?: Maybe<ContentType5OiHchWgV9Y8SuvDxHCaLy>;
  contentfulMetadata: ContentfulMetadata;
  desktopImage?: Maybe<Asset>;
  linkedFrom?: Maybe<WrapperImageLinkingCollections>;
  mobileImage?: Maybe<Asset>;
  sys: Sys;
  useAltText?: Maybe<Scalars['Boolean']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperImage) */
export type WrapperImageAltTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperImage) */
export type WrapperImageBynderImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentType5OiHchWgV9Y8SuvDxHCaLyFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperImage) */
export type WrapperImageDesktopImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperImage) */
export type WrapperImageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperImage) */
export type WrapperImageMobileImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperImage) */
export type WrapperImageUseAltTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WrapperImageCollection = {
  __typename?: 'WrapperImageCollection';
  items: Array<Maybe<WrapperImage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type WrapperImageCursorCollection = {
  __typename?: 'WrapperImageCursorCollection';
  items: Array<Maybe<WrapperImage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type WrapperImageFilter = {
  AND?: InputMaybe<Array<InputMaybe<WrapperImageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<WrapperImageFilter>>>;
  altText?: InputMaybe<Scalars['String']['input']>;
  altText_contains?: InputMaybe<Scalars['String']['input']>;
  altText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  altText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  altText_not?: InputMaybe<Scalars['String']['input']>;
  altText_not_contains?: InputMaybe<Scalars['String']['input']>;
  altText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderImage?: InputMaybe<CfContentType5OiHchWgV9Y8SuvDxHCaLyNestedFilter>;
  bynderImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  desktopImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mobileImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  useAltText?: InputMaybe<Scalars['Boolean']['input']>;
  useAltText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useAltText_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WrapperImageLinkingCollections = {
  __typename?: 'WrapperImageLinkingCollections';
  buildRecommendedContentCollection?: Maybe<BuildRecommendedContentCollection>;
  buildRecommendedContentCursorCollection?: Maybe<BuildRecommendedContentCursorCollection>;
  componentActionCardCollection?: Maybe<ComponentActionCardCollection>;
  componentActionCardCursorCollection?: Maybe<ComponentActionCardCursorCollection>;
  componentCardCollection?: Maybe<ComponentCardCollection>;
  componentCardCursorCollection?: Maybe<ComponentCardCursorCollection>;
  componentContentBlockCollection?: Maybe<ComponentContentBlockCollection>;
  componentContentBlockCursorCollection?: Maybe<ComponentContentBlockCursorCollection>;
  componentContentBlockV2Collection?: Maybe<ComponentContentBlockV2Collection>;
  componentContentBlockV2CursorCollection?: Maybe<ComponentContentBlockV2CursorCollection>;
  componentSpotlightGridCollection?: Maybe<ComponentSpotlightGridCollection>;
  componentSpotlightGridCursorCollection?: Maybe<ComponentSpotlightGridCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  packArticlePageCollection?: Maybe<PackArticlePageCollection>;
  packArticlePageCursorCollection?: Maybe<PackArticlePageCursorCollection>;
  packCampaignPageCollection?: Maybe<PackCampaignPageCollection>;
  packCampaignPageCursorCollection?: Maybe<PackCampaignPageCursorCollection>;
  packHomePageCollection?: Maybe<PackHomePageCollection>;
  packHomePageCursorCollection?: Maybe<PackHomePageCursorCollection>;
  packLandingPageArticlesCollection?: Maybe<PackLandingPageArticlesCollection>;
  packLandingPageArticlesCursorCollection?: Maybe<PackLandingPageArticlesCursorCollection>;
  packPageProductDetailCollection?: Maybe<PackPageProductDetailCollection>;
  packPageProductDetailCursorCollection?: Maybe<PackPageProductDetailCursorCollection>;
  packPageStandardCollection?: Maybe<PackPageStandardCollection>;
  packPageStandardCursorCollection?: Maybe<PackPageStandardCursorCollection>;
  packPageStandardV2Collection?: Maybe<PackPageStandardV2Collection>;
  packPageStandardV2CursorCollection?: Maybe<PackPageStandardV2CursorCollection>;
  packPageStandardV2DevCollection?: Maybe<PackPageStandardV2DevCollection>;
  packPageStandardV2DevCursorCollection?: Maybe<PackPageStandardV2DevCursorCollection>;
};


export type WrapperImageLinkingCollectionsBuildRecommendedContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperImageLinkingCollectionsBuildRecommendedContentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperImageLinkingCollectionsBuildRecommendedContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperImageLinkingCollectionsBuildRecommendedContentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperImageLinkingCollectionsComponentActionCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperImageLinkingCollectionsComponentActionCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperImageLinkingCollectionsComponentActionCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperImageLinkingCollectionsComponentActionCardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperImageLinkingCollectionsComponentCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperImageLinkingCollectionsComponentCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperImageLinkingCollectionsComponentCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperImageLinkingCollectionsComponentCardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperImageLinkingCollectionsComponentContentBlockCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperImageLinkingCollectionsComponentContentBlockCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperImageLinkingCollectionsComponentContentBlockCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperImageLinkingCollectionsComponentContentBlockCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperImageLinkingCollectionsComponentContentBlockV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperImageLinkingCollectionsComponentContentBlockV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperImageLinkingCollectionsComponentContentBlockV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperImageLinkingCollectionsComponentContentBlockV2CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperImageLinkingCollectionsComponentSpotlightGridCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperImageLinkingCollectionsComponentSpotlightGridCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperImageLinkingCollectionsComponentSpotlightGridCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperImageLinkingCollectionsComponentSpotlightGridCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperImageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperImageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperImageLinkingCollectionsPackArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperImageLinkingCollectionsPackArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperImageLinkingCollectionsPackArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperImageLinkingCollectionsPackArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperImageLinkingCollectionsPackCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperImageLinkingCollectionsPackCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperImageLinkingCollectionsPackCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperImageLinkingCollectionsPackCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperImageLinkingCollectionsPackHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperImageLinkingCollectionsPackHomePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperImageLinkingCollectionsPackHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperImageLinkingCollectionsPackHomePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperImageLinkingCollectionsPackLandingPageArticlesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperImageLinkingCollectionsPackLandingPageArticlesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperImageLinkingCollectionsPackLandingPageArticlesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperImageLinkingCollectionsPackLandingPageArticlesCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperImageLinkingCollectionsPackPageProductDetailCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperImageLinkingCollectionsPackPageProductDetailCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperImageLinkingCollectionsPackPageProductDetailCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperImageLinkingCollectionsPackPageProductDetailCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperImageLinkingCollectionsPackPageStandardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperImageLinkingCollectionsPackPageStandardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperImageLinkingCollectionsPackPageStandardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperImageLinkingCollectionsPackPageStandardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperImageLinkingCollectionsPackPageStandardV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperImageLinkingCollectionsPackPageStandardV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperImageLinkingCollectionsPackPageStandardV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperImageLinkingCollectionsPackPageStandardV2CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperImageLinkingCollectionsPackPageStandardV2DevCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperImageLinkingCollectionsPackPageStandardV2DevCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperImageLinkingCollectionsPackPageStandardV2DevCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperImageLinkingCollectionsPackPageStandardV2DevCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum WrapperImageLinkingCollectionsBuildRecommendedContentCollectionOrder {
  AnnotationAsc = 'annotation_ASC',
  AnnotationDesc = 'annotation_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperImageLinkingCollectionsBuildRecommendedContentCursorCollectionOrder {
  AnnotationAsc = 'annotation_ASC',
  AnnotationDesc = 'annotation_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperImageLinkingCollectionsComponentActionCardCollectionOrder {
  ActionCodeAsc = 'actionCode_ASC',
  ActionCodeDesc = 'actionCode_DESC',
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  CanBeDismissedAsc = 'canBeDismissed_ASC',
  CanBeDismissedDesc = 'canBeDismissed_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  DarkModeAsc = 'darkMode_ASC',
  DarkModeDesc = 'darkMode_DESC',
  InvertedAsc = 'inverted_ASC',
  InvertedDesc = 'inverted_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  NonRoundedEdgesAsc = 'nonRoundedEdges_ASC',
  NonRoundedEdgesDesc = 'nonRoundedEdges_DESC',
  OptimizelyFeatureFlagAsc = 'optimizelyFeatureFlag_ASC',
  OptimizelyFeatureFlagDesc = 'optimizelyFeatureFlag_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperImageLinkingCollectionsComponentActionCardCursorCollectionOrder {
  ActionCodeAsc = 'actionCode_ASC',
  ActionCodeDesc = 'actionCode_DESC',
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  CanBeDismissedAsc = 'canBeDismissed_ASC',
  CanBeDismissedDesc = 'canBeDismissed_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  DarkModeAsc = 'darkMode_ASC',
  DarkModeDesc = 'darkMode_DESC',
  InvertedAsc = 'inverted_ASC',
  InvertedDesc = 'inverted_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  NonRoundedEdgesAsc = 'nonRoundedEdges_ASC',
  NonRoundedEdgesDesc = 'nonRoundedEdges_DESC',
  OptimizelyFeatureFlagAsc = 'optimizelyFeatureFlag_ASC',
  OptimizelyFeatureFlagDesc = 'optimizelyFeatureFlag_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperImageLinkingCollectionsComponentCardCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  ShortTextAsc = 'shortText_ASC',
  ShortTextDesc = 'shortText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperImageLinkingCollectionsComponentCardCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  ShortTextAsc = 'shortText_ASC',
  ShortTextDesc = 'shortText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperImageLinkingCollectionsComponentContentBlockCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  HeaderLevelAsc = 'headerLevel_ASC',
  HeaderLevelDesc = 'headerLevel_DESC',
  MediaPositionAsc = 'mediaPosition_ASC',
  MediaPositionDesc = 'mediaPosition_DESC',
  ShowTitleAsc = 'showTitle_ASC',
  ShowTitleDesc = 'showTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAlignmentAsc = 'textAlignment_ASC',
  TextAlignmentDesc = 'textAlignment_DESC'
}

export enum WrapperImageLinkingCollectionsComponentContentBlockCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  HeaderLevelAsc = 'headerLevel_ASC',
  HeaderLevelDesc = 'headerLevel_DESC',
  MediaPositionAsc = 'mediaPosition_ASC',
  MediaPositionDesc = 'mediaPosition_DESC',
  ShowTitleAsc = 'showTitle_ASC',
  ShowTitleDesc = 'showTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAlignmentAsc = 'textAlignment_ASC',
  TextAlignmentDesc = 'textAlignment_DESC'
}

export enum WrapperImageLinkingCollectionsComponentContentBlockV2CollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  HeaderLevelAsc = 'headerLevel_ASC',
  HeaderLevelDesc = 'headerLevel_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MediaPositionAsc = 'mediaPosition_ASC',
  MediaPositionDesc = 'mediaPosition_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAlignmentAsc = 'textAlignment_ASC',
  TextAlignmentDesc = 'textAlignment_DESC'
}

export enum WrapperImageLinkingCollectionsComponentContentBlockV2CursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  HeaderLevelAsc = 'headerLevel_ASC',
  HeaderLevelDesc = 'headerLevel_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MediaPositionAsc = 'mediaPosition_ASC',
  MediaPositionDesc = 'mediaPosition_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAlignmentAsc = 'textAlignment_ASC',
  TextAlignmentDesc = 'textAlignment_DESC'
}

export enum WrapperImageLinkingCollectionsComponentSpotlightGridCollectionOrder {
  AlignmentAsc = 'alignment_ASC',
  AlignmentDesc = 'alignment_DESC',
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperImageLinkingCollectionsComponentSpotlightGridCursorCollectionOrder {
  AlignmentAsc = 'alignment_ASC',
  AlignmentDesc = 'alignment_DESC',
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperImageLinkingCollectionsPackArticlePageCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  ShareLinkAsc = 'shareLink_ASC',
  ShareLinkDesc = 'shareLink_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperImageLinkingCollectionsPackArticlePageCursorCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  ShareLinkAsc = 'shareLink_ASC',
  ShareLinkDesc = 'shareLink_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperImageLinkingCollectionsPackCampaignPageCollectionOrder {
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  HasGradientAsc = 'hasGradient_ASC',
  HasGradientDesc = 'hasGradient_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  HeroTextPositionAsc = 'heroTextPosition_ASC',
  HeroTextPositionDesc = 'heroTextPosition_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC'
}

export enum WrapperImageLinkingCollectionsPackCampaignPageCursorCollectionOrder {
  EyebrowTextAsc = 'eyebrowText_ASC',
  EyebrowTextDesc = 'eyebrowText_DESC',
  HasGradientAsc = 'hasGradient_ASC',
  HasGradientDesc = 'hasGradient_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  HeroTextPositionAsc = 'heroTextPosition_ASC',
  HeroTextPositionDesc = 'heroTextPosition_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC'
}

export enum WrapperImageLinkingCollectionsPackHomePageCollectionOrder {
  ComponentVariantAsc = 'componentVariant_ASC',
  ComponentVariantDesc = 'componentVariant_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TrustpilotBannerAsc = 'trustpilotBanner_ASC',
  TrustpilotBannerDesc = 'trustpilotBanner_DESC'
}

export enum WrapperImageLinkingCollectionsPackHomePageCursorCollectionOrder {
  ComponentVariantAsc = 'componentVariant_ASC',
  ComponentVariantDesc = 'componentVariant_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TrustpilotBannerAsc = 'trustpilotBanner_ASC',
  TrustpilotBannerDesc = 'trustpilotBanner_DESC'
}

export enum WrapperImageLinkingCollectionsPackLandingPageArticlesCollectionOrder {
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperImageLinkingCollectionsPackLandingPageArticlesCursorCollectionOrder {
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperImageLinkingCollectionsPackPageProductDetailCollectionOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperImageLinkingCollectionsPackPageProductDetailCursorCollectionOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperImageLinkingCollectionsPackPageStandardCollectionOrder {
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperImageLinkingCollectionsPackPageStandardCursorCollectionOrder {
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperImageLinkingCollectionsPackPageStandardV2CollectionOrder {
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperImageLinkingCollectionsPackPageStandardV2CursorCollectionOrder {
  BannerTextPositionAsc = 'bannerTextPosition_ASC',
  BannerTextPositionDesc = 'bannerTextPosition_DESC',
  HeaderText1Asc = 'headerText1_ASC',
  HeaderText1Desc = 'headerText1_DESC',
  HeaderText2Asc = 'headerText2_ASC',
  HeaderText2Desc = 'headerText2_DESC',
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperImageLinkingCollectionsPackPageStandardV2DevCollectionOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  Subheader2Asc = 'subheader2_ASC',
  Subheader2Desc = 'subheader2_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperImageLinkingCollectionsPackPageStandardV2DevCursorCollectionOrder {
  HeaderAsc = 'header_ASC',
  HeaderDesc = 'header_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  OgMetaDescriptionAsc = 'ogMetaDescription_ASC',
  OgMetaDescriptionDesc = 'ogMetaDescription_DESC',
  OgMetaTitleAsc = 'ogMetaTitle_ASC',
  OgMetaTitleDesc = 'ogMetaTitle_DESC',
  Subheader2Asc = 'subheader2_ASC',
  Subheader2Desc = 'subheader2_DESC',
  SubheaderAsc = 'subheader_ASC',
  SubheaderDesc = 'subheader_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperImageOrder {
  AltTextAsc = 'altText_ASC',
  AltTextDesc = 'altText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UseAltTextAsc = 'useAltText_ASC',
  UseAltTextDesc = 'useAltText_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperPageRouting) */
export type WrapperPageRouting = Entry & _Node & {
  __typename?: 'WrapperPageRouting';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  destination?: Maybe<WrapperPageRoutingDestination>;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<WrapperPageRoutingLinkingCollections>;
  queryStringExtras?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  temporaryOrPermanent?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  utmCampaign?: Maybe<Scalars['String']['output']>;
  utmContent?: Maybe<Scalars['String']['output']>;
  utmMedium?: Maybe<Scalars['String']['output']>;
  utmSource?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperPageRouting) */
export type WrapperPageRoutingDestinationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperPageRouting) */
export type WrapperPageRoutingInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperPageRouting) */
export type WrapperPageRoutingLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperPageRouting) */
export type WrapperPageRoutingQueryStringExtrasArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperPageRouting) */
export type WrapperPageRoutingTemporaryOrPermanentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperPageRouting) */
export type WrapperPageRoutingTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperPageRouting) */
export type WrapperPageRoutingUtmCampaignArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperPageRouting) */
export type WrapperPageRoutingUtmContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperPageRouting) */
export type WrapperPageRoutingUtmMediumArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperPageRouting) */
export type WrapperPageRoutingUtmSourceArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WrapperPageRoutingCollection = {
  __typename?: 'WrapperPageRoutingCollection';
  items: Array<Maybe<WrapperPageRouting>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type WrapperPageRoutingCursorCollection = {
  __typename?: 'WrapperPageRoutingCursorCollection';
  items: Array<Maybe<WrapperPageRouting>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type WrapperPageRoutingDestination = BuildCategoryWebpage | BuildWebpage | WrapperUrl;

export type WrapperPageRoutingFilter = {
  AND?: InputMaybe<Array<InputMaybe<WrapperPageRoutingFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<WrapperPageRoutingFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  destination_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  queryStringExtras?: InputMaybe<Scalars['String']['input']>;
  queryStringExtras_contains?: InputMaybe<Scalars['String']['input']>;
  queryStringExtras_exists?: InputMaybe<Scalars['Boolean']['input']>;
  queryStringExtras_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  queryStringExtras_not?: InputMaybe<Scalars['String']['input']>;
  queryStringExtras_not_contains?: InputMaybe<Scalars['String']['input']>;
  queryStringExtras_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  temporaryOrPermanent?: InputMaybe<Scalars['String']['input']>;
  temporaryOrPermanent_contains?: InputMaybe<Scalars['String']['input']>;
  temporaryOrPermanent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  temporaryOrPermanent_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  temporaryOrPermanent_not?: InputMaybe<Scalars['String']['input']>;
  temporaryOrPermanent_not_contains?: InputMaybe<Scalars['String']['input']>;
  temporaryOrPermanent_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmCampaign_contains?: InputMaybe<Scalars['String']['input']>;
  utmCampaign_exists?: InputMaybe<Scalars['Boolean']['input']>;
  utmCampaign_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  utmCampaign_not?: InputMaybe<Scalars['String']['input']>;
  utmCampaign_not_contains?: InputMaybe<Scalars['String']['input']>;
  utmCampaign_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmContent_contains?: InputMaybe<Scalars['String']['input']>;
  utmContent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  utmContent_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  utmContent_not?: InputMaybe<Scalars['String']['input']>;
  utmContent_not_contains?: InputMaybe<Scalars['String']['input']>;
  utmContent_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmMedium_contains?: InputMaybe<Scalars['String']['input']>;
  utmMedium_exists?: InputMaybe<Scalars['Boolean']['input']>;
  utmMedium_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  utmMedium_not?: InputMaybe<Scalars['String']['input']>;
  utmMedium_not_contains?: InputMaybe<Scalars['String']['input']>;
  utmMedium_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmSource_contains?: InputMaybe<Scalars['String']['input']>;
  utmSource_exists?: InputMaybe<Scalars['Boolean']['input']>;
  utmSource_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  utmSource_not?: InputMaybe<Scalars['String']['input']>;
  utmSource_not_contains?: InputMaybe<Scalars['String']['input']>;
  utmSource_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type WrapperPageRoutingLinkingCollections = {
  __typename?: 'WrapperPageRoutingLinkingCollections';
  buildArticlePageCollection?: Maybe<BuildArticlePageCollection>;
  buildArticlePageCursorCollection?: Maybe<BuildArticlePageCursorCollection>;
  buildCampaignPageCollection?: Maybe<BuildCampaignPageCollection>;
  buildCampaignPageCursorCollection?: Maybe<BuildCampaignPageCursorCollection>;
  buildCategoryWebpageCollection?: Maybe<BuildCategoryWebpageCollection>;
  buildCategoryWebpageCursorCollection?: Maybe<BuildCategoryWebpageCursorCollection>;
  buildGenericTemplatePageCollection?: Maybe<BuildGenericTemplatePageCollection>;
  buildGenericTemplatePageCursorCollection?: Maybe<BuildGenericTemplatePageCursorCollection>;
  buildLandingpageCollection?: Maybe<BuildLandingpageCollection>;
  buildLandingpageCursorCollection?: Maybe<BuildLandingpageCursorCollection>;
  buildProductDetailPageCollection?: Maybe<BuildProductDetailPageCollection>;
  buildProductDetailPageCursorCollection?: Maybe<BuildProductDetailPageCursorCollection>;
  buildProductOverviewPageCollection?: Maybe<BuildProductOverviewPageCollection>;
  buildProductOverviewPageCursorCollection?: Maybe<BuildProductOverviewPageCursorCollection>;
  buildTariffPageCollection?: Maybe<BuildTariffPageCollection>;
  buildTariffPageCursorCollection?: Maybe<BuildTariffPageCursorCollection>;
  buildWebpageCollection?: Maybe<BuildWebpageCollection>;
  buildWebpageCursorCollection?: Maybe<BuildWebpageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type WrapperPageRoutingLinkingCollectionsBuildArticlePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperPageRoutingLinkingCollectionsBuildArticlePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperPageRoutingLinkingCollectionsBuildArticlePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperPageRoutingLinkingCollectionsBuildArticlePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperPageRoutingLinkingCollectionsBuildCampaignPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperPageRoutingLinkingCollectionsBuildCampaignPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperPageRoutingLinkingCollectionsBuildCampaignPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperPageRoutingLinkingCollectionsBuildCampaignPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperPageRoutingLinkingCollectionsBuildCategoryWebpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperPageRoutingLinkingCollectionsBuildCategoryWebpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperPageRoutingLinkingCollectionsBuildCategoryWebpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperPageRoutingLinkingCollectionsBuildCategoryWebpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperPageRoutingLinkingCollectionsBuildGenericTemplatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperPageRoutingLinkingCollectionsBuildGenericTemplatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperPageRoutingLinkingCollectionsBuildGenericTemplatePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperPageRoutingLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperPageRoutingLinkingCollectionsBuildLandingpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperPageRoutingLinkingCollectionsBuildLandingpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperPageRoutingLinkingCollectionsBuildLandingpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperPageRoutingLinkingCollectionsBuildLandingpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperPageRoutingLinkingCollectionsBuildProductDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperPageRoutingLinkingCollectionsBuildProductDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperPageRoutingLinkingCollectionsBuildProductDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperPageRoutingLinkingCollectionsBuildProductDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperPageRoutingLinkingCollectionsBuildProductOverviewPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperPageRoutingLinkingCollectionsBuildProductOverviewPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperPageRoutingLinkingCollectionsBuildProductOverviewPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperPageRoutingLinkingCollectionsBuildProductOverviewPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperPageRoutingLinkingCollectionsBuildTariffPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperPageRoutingLinkingCollectionsBuildTariffPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperPageRoutingLinkingCollectionsBuildTariffPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperPageRoutingLinkingCollectionsBuildTariffPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperPageRoutingLinkingCollectionsBuildWebpageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperPageRoutingLinkingCollectionsBuildWebpageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperPageRoutingLinkingCollectionsBuildWebpageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperPageRoutingLinkingCollectionsBuildWebpageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperPageRoutingLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperPageRoutingLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum WrapperPageRoutingLinkingCollectionsBuildArticlePageCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperPageRoutingLinkingCollectionsBuildArticlePageCursorCollectionOrder {
  ArticleMainLabelAsc = 'articleMainLabel_ASC',
  ArticleMainLabelDesc = 'articleMainLabel_DESC',
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperPageRoutingLinkingCollectionsBuildCampaignPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperPageRoutingLinkingCollectionsBuildCampaignPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperPageRoutingLinkingCollectionsBuildCategoryWebpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PathnameAsc = 'pathname_ASC',
  PathnameDesc = 'pathname_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperPageRoutingLinkingCollectionsBuildCategoryWebpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  PathnameAsc = 'pathname_ASC',
  PathnameDesc = 'pathname_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperPageRoutingLinkingCollectionsBuildGenericTemplatePageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperPageRoutingLinkingCollectionsBuildGenericTemplatePageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperPageRoutingLinkingCollectionsBuildLandingpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperPageRoutingLinkingCollectionsBuildLandingpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperPageRoutingLinkingCollectionsBuildProductDetailPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperPageRoutingLinkingCollectionsBuildProductDetailPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperPageRoutingLinkingCollectionsBuildProductOverviewPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperPageRoutingLinkingCollectionsBuildProductOverviewPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperPageRoutingLinkingCollectionsBuildTariffPageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperPageRoutingLinkingCollectionsBuildTariffPageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperPageRoutingLinkingCollectionsBuildWebpageCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperPageRoutingLinkingCollectionsBuildWebpageCursorCollectionOrder {
  CanonicalUrlAsc = 'canonicalUrl_ASC',
  CanonicalUrlDesc = 'canonicalUrl_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  IncludeInSiteMapAsc = 'includeInSiteMap_ASC',
  IncludeInSiteMapDesc = 'includeInSiteMap_DESC',
  IndexibilityAsc = 'indexibility_ASC',
  IndexibilityDesc = 'indexibility_DESC',
  JiraStoryNumberAsc = 'jiraStoryNumber_ASC',
  JiraStoryNumberDesc = 'jiraStoryNumber_DESC',
  MastheadLayoutAsc = 'mastheadLayout_ASC',
  MastheadLayoutDesc = 'mastheadLayout_DESC',
  NextReviewAsc = 'nextReview_ASC',
  NextReviewDesc = 'nextReview_DESC',
  ShowInCategoryListAsc = 'showInCategoryList_ASC',
  ShowInCategoryListDesc = 'showInCategoryList_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperPageRoutingOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TemporaryOrPermanentAsc = 'temporaryOrPermanent_ASC',
  TemporaryOrPermanentDesc = 'temporaryOrPermanent_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperPath) */
export type WrapperPath = Entry & _Node & {
  __typename?: 'WrapperPath';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<WrapperPathLinkingCollections>;
  sys: Sys;
  url?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperPath) */
export type WrapperPathLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperPath) */
export type WrapperPathUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WrapperPathCollection = {
  __typename?: 'WrapperPathCollection';
  items: Array<Maybe<WrapperPath>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type WrapperPathCursorCollection = {
  __typename?: 'WrapperPathCursorCollection';
  items: Array<Maybe<WrapperPath>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type WrapperPathFilter = {
  AND?: InputMaybe<Array<InputMaybe<WrapperPathFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<WrapperPathFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type WrapperPathLinkingCollections = {
  __typename?: 'WrapperPathLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  packNavBarItemCollection?: Maybe<PackNavBarItemCollection>;
  packNavBarItemCursorCollection?: Maybe<PackNavBarItemCursorCollection>;
  packNavBarItemV2Collection?: Maybe<PackNavBarItemV2Collection>;
  packNavBarItemV2CursorCollection?: Maybe<PackNavBarItemV2CursorCollection>;
};


export type WrapperPathLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperPathLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperPathLinkingCollectionsPackNavBarItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperPathLinkingCollectionsPackNavBarItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperPathLinkingCollectionsPackNavBarItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperPathLinkingCollectionsPackNavBarItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperPathLinkingCollectionsPackNavBarItemV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperPathLinkingCollectionsPackNavBarItemV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperPathLinkingCollectionsPackNavBarItemV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperPathLinkingCollectionsPackNavBarItemV2CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum WrapperPathLinkingCollectionsPackNavBarItemCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum WrapperPathLinkingCollectionsPackNavBarItemCursorCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum WrapperPathLinkingCollectionsPackNavBarItemV2CollectionOrder {
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperPathLinkingCollectionsPackNavBarItemV2CursorCollectionOrder {
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperPathOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperSocialMedia) */
export type WrapperSocialMedia = Entry & _Node & {
  __typename?: 'WrapperSocialMedia';
  _id: Scalars['ID']['output'];
  channel?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  icon?: Maybe<WrapperIcon>;
  linkedFrom?: Maybe<WrapperSocialMediaLinkingCollections>;
  sys: Sys;
  url?: Maybe<WrapperUrl>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperSocialMedia) */
export type WrapperSocialMediaChannelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperSocialMedia) */
export type WrapperSocialMediaIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperIconFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperSocialMedia) */
export type WrapperSocialMediaLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperSocialMedia) */
export type WrapperSocialMediaUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WrapperUrlFilter>;
};

export type WrapperSocialMediaCollection = {
  __typename?: 'WrapperSocialMediaCollection';
  items: Array<Maybe<WrapperSocialMedia>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type WrapperSocialMediaCursorCollection = {
  __typename?: 'WrapperSocialMediaCursorCollection';
  items: Array<Maybe<WrapperSocialMedia>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type WrapperSocialMediaFilter = {
  AND?: InputMaybe<Array<InputMaybe<WrapperSocialMediaFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<WrapperSocialMediaFilter>>>;
  channel?: InputMaybe<Scalars['String']['input']>;
  channel_contains?: InputMaybe<Scalars['String']['input']>;
  channel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  channel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  channel_not?: InputMaybe<Scalars['String']['input']>;
  channel_not_contains?: InputMaybe<Scalars['String']['input']>;
  channel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon?: InputMaybe<CfWrapperIconNestedFilter>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  url?: InputMaybe<CfWrapperUrlNestedFilter>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WrapperSocialMediaLinkingCollections = {
  __typename?: 'WrapperSocialMediaLinkingCollections';
  componentFooterCollection?: Maybe<ComponentFooterCollection>;
  componentFooterCursorCollection?: Maybe<ComponentFooterCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type WrapperSocialMediaLinkingCollectionsComponentFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperSocialMediaLinkingCollectionsComponentFooterCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperSocialMediaLinkingCollectionsComponentFooterCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperSocialMediaLinkingCollectionsComponentFooterCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperSocialMediaLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperSocialMediaLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum WrapperSocialMediaLinkingCollectionsComponentFooterCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperSocialMediaLinkingCollectionsComponentFooterCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperSocialMediaOrder {
  ChannelAsc = 'channel_ASC',
  ChannelDesc = 'channel_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperUrl) */
export type WrapperUrl = Entry & _Node & {
  __typename?: 'WrapperUrl';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<WrapperUrlLinkingCollections>;
  sys: Sys;
  url?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperUrl) */
export type WrapperUrlLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperUrl) */
export type WrapperUrlUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WrapperUrlCollection = {
  __typename?: 'WrapperUrlCollection';
  items: Array<Maybe<WrapperUrl>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type WrapperUrlCursorCollection = {
  __typename?: 'WrapperUrlCursorCollection';
  items: Array<Maybe<WrapperUrl>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type WrapperUrlFilter = {
  AND?: InputMaybe<Array<InputMaybe<WrapperUrlFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<WrapperUrlFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type WrapperUrlLinkingCollections = {
  __typename?: 'WrapperUrlLinkingCollections';
  componentInfoCardCollection?: Maybe<ComponentInfoCardCollection>;
  componentInfoCardCursorCollection?: Maybe<ComponentInfoCardCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  packCtaCollection?: Maybe<PackCtaCollection>;
  packCtaCursorCollection?: Maybe<PackCtaCursorCollection>;
  packFooterItemCollection?: Maybe<PackFooterItemCollection>;
  packFooterItemCursorCollection?: Maybe<PackFooterItemCursorCollection>;
  packNavBarCtaCollection?: Maybe<PackNavBarCtaCollection>;
  packNavBarCtaCursorCollection?: Maybe<PackNavBarCtaCursorCollection>;
  packNavBarItemCollection?: Maybe<PackNavBarItemCollection>;
  packNavBarItemCursorCollection?: Maybe<PackNavBarItemCursorCollection>;
  packNavBarItemV2Collection?: Maybe<PackNavBarItemV2Collection>;
  packNavBarItemV2CursorCollection?: Maybe<PackNavBarItemV2CursorCollection>;
  packRecommendedContentAccordionItemCollection?: Maybe<PackRecommendedContentAccordionItemCollection>;
  packRecommendedContentAccordionItemCursorCollection?: Maybe<PackRecommendedContentAccordionItemCursorCollection>;
  wrapperPageRoutingCollection?: Maybe<WrapperPageRoutingCollection>;
  wrapperPageRoutingCursorCollection?: Maybe<WrapperPageRoutingCursorCollection>;
  wrapperSocialMediaCollection?: Maybe<WrapperSocialMediaCollection>;
  wrapperSocialMediaCursorCollection?: Maybe<WrapperSocialMediaCursorCollection>;
};


export type WrapperUrlLinkingCollectionsComponentInfoCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperUrlLinkingCollectionsComponentInfoCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperUrlLinkingCollectionsComponentInfoCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperUrlLinkingCollectionsComponentInfoCardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperUrlLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperUrlLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperUrlLinkingCollectionsPackCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperUrlLinkingCollectionsPackCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperUrlLinkingCollectionsPackCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperUrlLinkingCollectionsPackCtaCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperUrlLinkingCollectionsPackFooterItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperUrlLinkingCollectionsPackFooterItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperUrlLinkingCollectionsPackFooterItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperUrlLinkingCollectionsPackFooterItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperUrlLinkingCollectionsPackNavBarCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperUrlLinkingCollectionsPackNavBarCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperUrlLinkingCollectionsPackNavBarCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperUrlLinkingCollectionsPackNavBarCtaCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperUrlLinkingCollectionsPackNavBarItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperUrlLinkingCollectionsPackNavBarItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperUrlLinkingCollectionsPackNavBarItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperUrlLinkingCollectionsPackNavBarItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperUrlLinkingCollectionsPackNavBarItemV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperUrlLinkingCollectionsPackNavBarItemV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperUrlLinkingCollectionsPackNavBarItemV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperUrlLinkingCollectionsPackNavBarItemV2CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperUrlLinkingCollectionsPackRecommendedContentAccordionItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperUrlLinkingCollectionsPackRecommendedContentAccordionItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperUrlLinkingCollectionsPackRecommendedContentAccordionItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperUrlLinkingCollectionsPackRecommendedContentAccordionItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperUrlLinkingCollectionsWrapperPageRoutingCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperUrlLinkingCollectionsWrapperPageRoutingCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperUrlLinkingCollectionsWrapperPageRoutingCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperUrlLinkingCollectionsWrapperPageRoutingCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperUrlLinkingCollectionsWrapperSocialMediaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperUrlLinkingCollectionsWrapperSocialMediaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperUrlLinkingCollectionsWrapperSocialMediaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperUrlLinkingCollectionsWrapperSocialMediaCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum WrapperUrlLinkingCollectionsComponentInfoCardCollectionOrder {
  DestinationLabelAsc = 'destinationLabel_ASC',
  DestinationLabelDesc = 'destinationLabel_DESC',
  IsExternalLinkAsc = 'isExternalLink_ASC',
  IsExternalLinkDesc = 'isExternalLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum WrapperUrlLinkingCollectionsComponentInfoCardCursorCollectionOrder {
  DestinationLabelAsc = 'destinationLabel_ASC',
  DestinationLabelDesc = 'destinationLabel_DESC',
  IsExternalLinkAsc = 'isExternalLink_ASC',
  IsExternalLinkDesc = 'isExternalLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum WrapperUrlLinkingCollectionsPackCtaCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export enum WrapperUrlLinkingCollectionsPackCtaCursorCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MixpanelIdAsc = 'mixpanelId_ASC',
  MixpanelIdDesc = 'mixpanelId_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export enum WrapperUrlLinkingCollectionsPackFooterItemCollectionOrder {
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperUrlLinkingCollectionsPackFooterItemCursorCollectionOrder {
  CtaBehaviourAsc = 'ctaBehaviour_ASC',
  CtaBehaviourDesc = 'ctaBehaviour_DESC',
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperUrlLinkingCollectionsPackNavBarCtaCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperUrlLinkingCollectionsPackNavBarCtaCursorCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperUrlLinkingCollectionsPackNavBarItemCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum WrapperUrlLinkingCollectionsPackNavBarItemCursorCollectionOrder {
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum WrapperUrlLinkingCollectionsPackNavBarItemV2CollectionOrder {
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperUrlLinkingCollectionsPackNavBarItemV2CursorCollectionOrder {
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  HiddenTextAsc = 'hiddenText_ASC',
  HiddenTextDesc = 'hiddenText_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperUrlLinkingCollectionsPackRecommendedContentAccordionItemCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperUrlLinkingCollectionsPackRecommendedContentAccordionItemCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperUrlLinkingCollectionsWrapperPageRoutingCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TemporaryOrPermanentAsc = 'temporaryOrPermanent_ASC',
  TemporaryOrPermanentDesc = 'temporaryOrPermanent_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export enum WrapperUrlLinkingCollectionsWrapperPageRoutingCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  QueryStringExtrasAsc = 'queryStringExtras_ASC',
  QueryStringExtrasDesc = 'queryStringExtras_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TemporaryOrPermanentAsc = 'temporaryOrPermanent_ASC',
  TemporaryOrPermanentDesc = 'temporaryOrPermanent_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  UtmCampaignAsc = 'utmCampaign_ASC',
  UtmCampaignDesc = 'utmCampaign_DESC',
  UtmContentAsc = 'utmContent_ASC',
  UtmContentDesc = 'utmContent_DESC',
  UtmMediumAsc = 'utmMedium_ASC',
  UtmMediumDesc = 'utmMedium_DESC',
  UtmSourceAsc = 'utmSource_ASC',
  UtmSourceDesc = 'utmSource_DESC'
}

export enum WrapperUrlLinkingCollectionsWrapperSocialMediaCollectionOrder {
  ChannelAsc = 'channel_ASC',
  ChannelDesc = 'channel_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperUrlLinkingCollectionsWrapperSocialMediaCursorCollectionOrder {
  ChannelAsc = 'channel_ASC',
  ChannelDesc = 'channel_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WrapperUrlOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperVideo) */
export type WrapperVideo = Entry & _Node & {
  __typename?: 'WrapperVideo';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<WrapperVideoDescription>;
  linkedFrom?: Maybe<WrapperVideoLinkingCollections>;
  sys: Sys;
  transcript?: Maybe<Scalars['String']['output']>;
  video?: Maybe<Asset>;
  videoLink?: Maybe<Scalars['String']['output']>;
  videoTitle?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperVideo) */
export type WrapperVideoDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperVideo) */
export type WrapperVideoLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperVideo) */
export type WrapperVideoTranscriptArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperVideo) */
export type WrapperVideoVideoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperVideo) */
export type WrapperVideoVideoLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/x13m240jxjqd/content_types/wrapperVideo) */
export type WrapperVideoVideoTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WrapperVideoCollection = {
  __typename?: 'WrapperVideoCollection';
  items: Array<Maybe<WrapperVideo>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type WrapperVideoCursorCollection = {
  __typename?: 'WrapperVideoCursorCollection';
  items: Array<Maybe<WrapperVideo>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type WrapperVideoDescription = {
  __typename?: 'WrapperVideoDescription';
  json: Scalars['JSON']['output'];
  links: WrapperVideoDescriptionLinks;
};

export type WrapperVideoDescriptionAssets = {
  __typename?: 'WrapperVideoDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type WrapperVideoDescriptionEntries = {
  __typename?: 'WrapperVideoDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type WrapperVideoDescriptionLinks = {
  __typename?: 'WrapperVideoDescriptionLinks';
  assets: WrapperVideoDescriptionAssets;
  entries: WrapperVideoDescriptionEntries;
  resources: WrapperVideoDescriptionResources;
};

export type WrapperVideoDescriptionResources = {
  __typename?: 'WrapperVideoDescriptionResources';
  block: Array<WrapperVideoDescriptionResourcesBlock>;
  hyperlink: Array<WrapperVideoDescriptionResourcesHyperlink>;
  inline: Array<WrapperVideoDescriptionResourcesInline>;
};

export type WrapperVideoDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'WrapperVideoDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type WrapperVideoDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'WrapperVideoDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type WrapperVideoDescriptionResourcesInline = ResourceLink & {
  __typename?: 'WrapperVideoDescriptionResourcesInline';
  sys: ResourceSys;
};

export type WrapperVideoFilter = {
  AND?: InputMaybe<Array<InputMaybe<WrapperVideoFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<WrapperVideoFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  transcript?: InputMaybe<Scalars['String']['input']>;
  transcript_contains?: InputMaybe<Scalars['String']['input']>;
  transcript_exists?: InputMaybe<Scalars['Boolean']['input']>;
  transcript_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  transcript_not?: InputMaybe<Scalars['String']['input']>;
  transcript_not_contains?: InputMaybe<Scalars['String']['input']>;
  transcript_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoLink?: InputMaybe<Scalars['String']['input']>;
  videoLink_contains?: InputMaybe<Scalars['String']['input']>;
  videoLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  videoLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoLink_not?: InputMaybe<Scalars['String']['input']>;
  videoLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  videoLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoTitle?: InputMaybe<Scalars['String']['input']>;
  videoTitle_contains?: InputMaybe<Scalars['String']['input']>;
  videoTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  videoTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoTitle_not?: InputMaybe<Scalars['String']['input']>;
  videoTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  videoTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  video_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WrapperVideoLinkingCollections = {
  __typename?: 'WrapperVideoLinkingCollections';
  componentContentBlockCollection?: Maybe<ComponentContentBlockCollection>;
  componentContentBlockCursorCollection?: Maybe<ComponentContentBlockCursorCollection>;
  componentContentBlockV2Collection?: Maybe<ComponentContentBlockV2Collection>;
  componentContentBlockV2CursorCollection?: Maybe<ComponentContentBlockV2CursorCollection>;
  componentVideoPlayerCollection?: Maybe<ComponentVideoPlayerCollection>;
  componentVideoPlayerCursorCollection?: Maybe<ComponentVideoPlayerCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type WrapperVideoLinkingCollectionsComponentContentBlockCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperVideoLinkingCollectionsComponentContentBlockCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperVideoLinkingCollectionsComponentContentBlockCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperVideoLinkingCollectionsComponentContentBlockCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperVideoLinkingCollectionsComponentContentBlockV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperVideoLinkingCollectionsComponentContentBlockV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperVideoLinkingCollectionsComponentContentBlockV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperVideoLinkingCollectionsComponentContentBlockV2CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperVideoLinkingCollectionsComponentVideoPlayerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperVideoLinkingCollectionsComponentVideoPlayerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperVideoLinkingCollectionsComponentVideoPlayerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<WrapperVideoLinkingCollectionsComponentVideoPlayerCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperVideoLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WrapperVideoLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum WrapperVideoLinkingCollectionsComponentContentBlockCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  HeaderLevelAsc = 'headerLevel_ASC',
  HeaderLevelDesc = 'headerLevel_DESC',
  MediaPositionAsc = 'mediaPosition_ASC',
  MediaPositionDesc = 'mediaPosition_DESC',
  ShowTitleAsc = 'showTitle_ASC',
  ShowTitleDesc = 'showTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAlignmentAsc = 'textAlignment_ASC',
  TextAlignmentDesc = 'textAlignment_DESC'
}

export enum WrapperVideoLinkingCollectionsComponentContentBlockCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  HeaderLevelAsc = 'headerLevel_ASC',
  HeaderLevelDesc = 'headerLevel_DESC',
  MediaPositionAsc = 'mediaPosition_ASC',
  MediaPositionDesc = 'mediaPosition_DESC',
  ShowTitleAsc = 'showTitle_ASC',
  ShowTitleDesc = 'showTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAlignmentAsc = 'textAlignment_ASC',
  TextAlignmentDesc = 'textAlignment_DESC'
}

export enum WrapperVideoLinkingCollectionsComponentContentBlockV2CollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  HeaderLevelAsc = 'headerLevel_ASC',
  HeaderLevelDesc = 'headerLevel_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MediaPositionAsc = 'mediaPosition_ASC',
  MediaPositionDesc = 'mediaPosition_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAlignmentAsc = 'textAlignment_ASC',
  TextAlignmentDesc = 'textAlignment_DESC'
}

export enum WrapperVideoLinkingCollectionsComponentContentBlockV2CursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  BackgroundSelectorAsc = 'backgroundSelector_ASC',
  BackgroundSelectorDesc = 'backgroundSelector_DESC',
  Cta1BehaviourAsc = 'cta1Behaviour_ASC',
  Cta1BehaviourDesc = 'cta1Behaviour_DESC',
  Cta1TypeAsc = 'cta1Type_ASC',
  Cta1TypeDesc = 'cta1Type_DESC',
  Cta2BehaviourAsc = 'cta2Behaviour_ASC',
  Cta2BehaviourDesc = 'cta2Behaviour_DESC',
  Cta2TypeAsc = 'cta2Type_ASC',
  Cta2TypeDesc = 'cta2Type_DESC',
  HeaderLevelAsc = 'headerLevel_ASC',
  HeaderLevelDesc = 'headerLevel_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MediaPositionAsc = 'mediaPosition_ASC',
  MediaPositionDesc = 'mediaPosition_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAlignmentAsc = 'textAlignment_ASC',
  TextAlignmentDesc = 'textAlignment_DESC'
}

export enum WrapperVideoLinkingCollectionsComponentVideoPlayerCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  ShowTitleAndDescriptionAsc = 'showTitleAndDescription_ASC',
  ShowTitleAndDescriptionDesc = 'showTitleAndDescription_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export enum WrapperVideoLinkingCollectionsComponentVideoPlayerCursorCollectionOrder {
  AnchorAsc = 'anchor_ASC',
  AnchorDesc = 'anchor_DESC',
  ShowTitleAndDescriptionAsc = 'showTitleAndDescription_ASC',
  ShowTitleAndDescriptionDesc = 'showTitleAndDescription_DESC',
  ShowTitleInlineAsc = 'showTitleInline_ASC',
  ShowTitleInlineDesc = 'showTitleInline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC'
}

export enum WrapperVideoOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VideoLinkAsc = 'videoLink_ASC',
  VideoLinkDesc = 'videoLink_DESC',
  VideoTitleAsc = 'videoTitle_ASC',
  VideoTitleDesc = 'videoTitle_DESC'
}

export type _Node = {
  _id: Scalars['ID']['output'];
};

export type CfAuthorNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfAuthorNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfAuthorNestedFilter>>>;
  bio_contains?: InputMaybe<Scalars['String']['input']>;
  bio_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bio_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfBuildArticlePageNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfBuildArticlePageNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfBuildArticlePageNestedFilter>>>;
  articleLabels_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  articleLabels_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  articleLabels_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  articleLabels_exists?: InputMaybe<Scalars['Boolean']['input']>;
  articleMainLabel?: InputMaybe<Scalars['String']['input']>;
  articleMainLabel_contains?: InputMaybe<Scalars['String']['input']>;
  articleMainLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  articleMainLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  articleMainLabel_not?: InputMaybe<Scalars['String']['input']>;
  articleMainLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  articleMainLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  author_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonicalUrl?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_contains?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonicalUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonicalUrl_not?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  componentsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta1Behaviour?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta1Behaviour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Behaviour_not?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Type?: InputMaybe<Scalars['String']['input']>;
  cta1Type_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta1Type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Type_not?: InputMaybe<Scalars['String']['input']>;
  cta1Type_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2Behaviour?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2Behaviour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Behaviour_not?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Type?: InputMaybe<Scalars['String']['input']>;
  cta2Type_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2Type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Type_not?: InputMaybe<Scalars['String']['input']>;
  cta2Type_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  includeInSiteMap?: InputMaybe<Scalars['Boolean']['input']>;
  includeInSiteMap_exists?: InputMaybe<Scalars['Boolean']['input']>;
  includeInSiteMap_not?: InputMaybe<Scalars['Boolean']['input']>;
  indexibility?: InputMaybe<Scalars['String']['input']>;
  indexibility_contains?: InputMaybe<Scalars['String']['input']>;
  indexibility_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexibility_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  indexibility_not?: InputMaybe<Scalars['String']['input']>;
  indexibility_not_contains?: InputMaybe<Scalars['String']['input']>;
  indexibility_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  jiraStoryNumber?: InputMaybe<Scalars['Int']['input']>;
  jiraStoryNumber_exists?: InputMaybe<Scalars['Boolean']['input']>;
  jiraStoryNumber_gt?: InputMaybe<Scalars['Int']['input']>;
  jiraStoryNumber_gte?: InputMaybe<Scalars['Int']['input']>;
  jiraStoryNumber_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  jiraStoryNumber_lt?: InputMaybe<Scalars['Int']['input']>;
  jiraStoryNumber_lte?: InputMaybe<Scalars['Int']['input']>;
  jiraStoryNumber_not?: InputMaybe<Scalars['Int']['input']>;
  jiraStoryNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  mastheadLayout?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_contains?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mastheadLayout_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mastheadLayout_not?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_not_contains?: InputMaybe<Scalars['String']['input']>;
  mastheadLayout_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  masthead_exists?: InputMaybe<Scalars['Boolean']['input']>;
  nextReview?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_exists?: InputMaybe<Scalars['Boolean']['input']>;
  nextReview_gt?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_gte?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nextReview_lt?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_lte?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_not?: InputMaybe<Scalars['DateTime']['input']>;
  nextReview_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishDate?: InputMaybe<Scalars['DateTime']['input']>;
  publishDate_exists?: InputMaybe<Scalars['Boolean']['input']>;
  publishDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  publishDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  publishDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  publishDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  publishDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  publishDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  relatedContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfComponentActionCardNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfComponentActionCardNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfComponentActionCardNestedFilter>>>;
  actionCode?: InputMaybe<Scalars['String']['input']>;
  actionCode_contains?: InputMaybe<Scalars['String']['input']>;
  actionCode_exists?: InputMaybe<Scalars['Boolean']['input']>;
  actionCode_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionCode_not?: InputMaybe<Scalars['String']['input']>;
  actionCode_not_contains?: InputMaybe<Scalars['String']['input']>;
  actionCode_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canBeDismissed?: InputMaybe<Scalars['Boolean']['input']>;
  canBeDismissed_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canBeDismissed_not?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctaBehaviour?: InputMaybe<Scalars['String']['input']>;
  ctaBehaviour_contains?: InputMaybe<Scalars['String']['input']>;
  ctaBehaviour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaBehaviour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaBehaviour_not?: InputMaybe<Scalars['String']['input']>;
  ctaBehaviour_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaBehaviour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaType?: InputMaybe<Scalars['String']['input']>;
  ctaType_contains?: InputMaybe<Scalars['String']['input']>;
  ctaType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaType_not?: InputMaybe<Scalars['String']['input']>;
  ctaType_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta_exists?: InputMaybe<Scalars['Boolean']['input']>;
  darkMode?: InputMaybe<Scalars['Boolean']['input']>;
  darkMode_exists?: InputMaybe<Scalars['Boolean']['input']>;
  darkMode_not?: InputMaybe<Scalars['Boolean']['input']>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  inverted?: InputMaybe<Scalars['Boolean']['input']>;
  inverted_exists?: InputMaybe<Scalars['Boolean']['input']>;
  inverted_not?: InputMaybe<Scalars['Boolean']['input']>;
  mixpanelId?: InputMaybe<Scalars['String']['input']>;
  mixpanelId_contains?: InputMaybe<Scalars['String']['input']>;
  mixpanelId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mixpanelId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mixpanelId_not?: InputMaybe<Scalars['String']['input']>;
  mixpanelId_not_contains?: InputMaybe<Scalars['String']['input']>;
  mixpanelId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonRoundedEdges?: InputMaybe<Scalars['Boolean']['input']>;
  nonRoundedEdges_exists?: InputMaybe<Scalars['Boolean']['input']>;
  nonRoundedEdges_not?: InputMaybe<Scalars['Boolean']['input']>;
  optimizelyFeatureFlag?: InputMaybe<Scalars['String']['input']>;
  optimizelyFeatureFlag_contains?: InputMaybe<Scalars['String']['input']>;
  optimizelyFeatureFlag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  optimizelyFeatureFlag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optimizelyFeatureFlag_not?: InputMaybe<Scalars['String']['input']>;
  optimizelyFeatureFlag_not_contains?: InputMaybe<Scalars['String']['input']>;
  optimizelyFeatureFlag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfComponentBlockCardNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfComponentBlockCardNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfComponentBlockCardNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  richTextDescription_contains?: InputMaybe<Scalars['String']['input']>;
  richTextDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  richTextDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfComponentCardNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfComponentCardNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfComponentCardNestedFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctaBehaviour?: InputMaybe<Scalars['String']['input']>;
  ctaBehaviour_contains?: InputMaybe<Scalars['String']['input']>;
  ctaBehaviour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaBehaviour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaBehaviour_not?: InputMaybe<Scalars['String']['input']>;
  ctaBehaviour_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaBehaviour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaType?: InputMaybe<Scalars['String']['input']>;
  ctaType_contains?: InputMaybe<Scalars['String']['input']>;
  ctaType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaType_not?: InputMaybe<Scalars['String']['input']>;
  ctaType_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta_exists?: InputMaybe<Scalars['Boolean']['input']>;
  media_exists?: InputMaybe<Scalars['Boolean']['input']>;
  shortText?: InputMaybe<Scalars['String']['input']>;
  shortText_contains?: InputMaybe<Scalars['String']['input']>;
  shortText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  shortText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortText_not?: InputMaybe<Scalars['String']['input']>;
  shortText_not_contains?: InputMaybe<Scalars['String']['input']>;
  shortText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfComponentContactAndUsefulLinksNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfComponentContactAndUsefulLinksNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfComponentContactAndUsefulLinksNestedFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactOptions_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ovoCommunity_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  usefulLinks_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfComponentContentBlockNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfComponentContentBlockNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfComponentContentBlockNestedFilter>>>;
  Text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundSelector?: InputMaybe<Scalars['String']['input']>;
  backgroundSelector_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundSelector_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundSelector_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundSelector_not?: InputMaybe<Scalars['String']['input']>;
  backgroundSelector_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundSelector_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta1Behaviour?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta1Behaviour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Behaviour_not?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Type?: InputMaybe<Scalars['String']['input']>;
  cta1Type_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta1Type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Type_not?: InputMaybe<Scalars['String']['input']>;
  cta1Type_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2Behaviour?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2Behaviour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Behaviour_not?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Type?: InputMaybe<Scalars['String']['input']>;
  cta2Type_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2Type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Type_not?: InputMaybe<Scalars['String']['input']>;
  cta2Type_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headerLevel?: InputMaybe<Scalars['String']['input']>;
  headerLevel_contains?: InputMaybe<Scalars['String']['input']>;
  headerLevel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headerLevel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headerLevel_not?: InputMaybe<Scalars['String']['input']>;
  headerLevel_not_contains?: InputMaybe<Scalars['String']['input']>;
  headerLevel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mediaCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mediaPosition?: InputMaybe<Scalars['String']['input']>;
  mediaPosition_contains?: InputMaybe<Scalars['String']['input']>;
  mediaPosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mediaPosition_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mediaPosition_not?: InputMaybe<Scalars['String']['input']>;
  mediaPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  mediaPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  textAlignment?: InputMaybe<Scalars['String']['input']>;
  textAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  textAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  textAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  textAlignment_not?: InputMaybe<Scalars['String']['input']>;
  textAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  textAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfComponentContentBlockV2NestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfComponentContentBlockV2NestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfComponentContentBlockV2NestedFilter>>>;
  Text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundSelector?: InputMaybe<Scalars['String']['input']>;
  backgroundSelector_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundSelector_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundSelector_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundSelector_not?: InputMaybe<Scalars['String']['input']>;
  backgroundSelector_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundSelector_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta1Behaviour?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta1Behaviour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Behaviour_not?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Behaviour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Type?: InputMaybe<Scalars['String']['input']>;
  cta1Type_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta1Type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1Type_not?: InputMaybe<Scalars['String']['input']>;
  cta1Type_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta1Type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2Behaviour?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2Behaviour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Behaviour_not?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Behaviour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Type?: InputMaybe<Scalars['String']['input']>;
  cta2Type_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2Type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2Type_not?: InputMaybe<Scalars['String']['input']>;
  cta2Type_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta2Type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headerLevel?: InputMaybe<Scalars['String']['input']>;
  headerLevel_contains?: InputMaybe<Scalars['String']['input']>;
  headerLevel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headerLevel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headerLevel_not?: InputMaybe<Scalars['String']['input']>;
  headerLevel_not_contains?: InputMaybe<Scalars['String']['input']>;
  headerLevel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mediaCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mediaPosition?: InputMaybe<Scalars['String']['input']>;
  mediaPosition_contains?: InputMaybe<Scalars['String']['input']>;
  mediaPosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mediaPosition_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mediaPosition_not?: InputMaybe<Scalars['String']['input']>;
  mediaPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  mediaPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subtitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  terms_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  textAlignment?: InputMaybe<Scalars['String']['input']>;
  textAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  textAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  textAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  textAlignment_not?: InputMaybe<Scalars['String']['input']>;
  textAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  textAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfComponentGuideCardNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfComponentGuideCardNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfComponentGuideCardNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta_exists?: InputMaybe<Scalars['Boolean']['input']>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfComponentImageGalleryNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfComponentImageGalleryNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfComponentImageGalleryNestedFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  imageAspectRatio?: InputMaybe<Scalars['String']['input']>;
  imageAspectRatio_contains?: InputMaybe<Scalars['String']['input']>;
  imageAspectRatio_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageAspectRatio_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageAspectRatio_not?: InputMaybe<Scalars['String']['input']>;
  imageAspectRatio_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageAspectRatio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfComponentImageWithDescriptionNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfComponentImageWithDescriptionNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfComponentImageWithDescriptionNestedFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy_contains?: InputMaybe<Scalars['String']['input']>;
  bodyCopy_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bodyCopy_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentOrientation?: InputMaybe<Scalars['String']['input']>;
  contentOrientation_contains?: InputMaybe<Scalars['String']['input']>;
  contentOrientation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentOrientation_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentOrientation_not?: InputMaybe<Scalars['String']['input']>;
  contentOrientation_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentOrientation_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctaListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageAspectRatio?: InputMaybe<Scalars['String']['input']>;
  imageAspectRatio_contains?: InputMaybe<Scalars['String']['input']>;
  imageAspectRatio_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageAspectRatio_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageAspectRatio_not?: InputMaybe<Scalars['String']['input']>;
  imageAspectRatio_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageAspectRatio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showTitleInline?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_not?: InputMaybe<Scalars['Boolean']['input']>;
  smallText_contains?: InputMaybe<Scalars['String']['input']>;
  smallText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  smallText_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  title1?: InputMaybe<Scalars['String']['input']>;
  title1_contains?: InputMaybe<Scalars['String']['input']>;
  title1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title1_not?: InputMaybe<Scalars['String']['input']>;
  title1_not_contains?: InputMaybe<Scalars['String']['input']>;
  title1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2?: InputMaybe<Scalars['String']['input']>;
  title2_contains?: InputMaybe<Scalars['String']['input']>;
  title2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2_not?: InputMaybe<Scalars['String']['input']>;
  title2_not_contains?: InputMaybe<Scalars['String']['input']>;
  title2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColour?: InputMaybe<Scalars['String']['input']>;
  titleColour_contains?: InputMaybe<Scalars['String']['input']>;
  titleColour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleColour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColour_not?: InputMaybe<Scalars['String']['input']>;
  titleColour_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleColour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfComponentInfoCardNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfComponentInfoCardNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfComponentInfoCardNestedFilter>>>;
  bodyCopy?: InputMaybe<Scalars['String']['input']>;
  bodyCopy_contains?: InputMaybe<Scalars['String']['input']>;
  bodyCopy_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bodyCopy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy_not?: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_contains?: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyRichText_contains?: InputMaybe<Scalars['String']['input']>;
  bodyRichText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bodyRichText_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta_exists?: InputMaybe<Scalars['Boolean']['input']>;
  destinationLabel?: InputMaybe<Scalars['String']['input']>;
  destinationLabel_contains?: InputMaybe<Scalars['String']['input']>;
  destinationLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  destinationLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  destinationLabel_not?: InputMaybe<Scalars['String']['input']>;
  destinationLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  destinationLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  destinationUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isExternalLink?: InputMaybe<Scalars['Boolean']['input']>;
  isExternalLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isExternalLink_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfComponentProductFeaturedCardNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfComponentProductFeaturedCardNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfComponentProductFeaturedCardNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionText_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionText_not_contains?: InputMaybe<Scalars['String']['input']>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfComponentProductModuleNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfComponentProductModuleNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfComponentProductModuleNestedFilter>>>;
  bulletListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bullets_contains?: InputMaybe<Scalars['String']['input']>;
  bullets_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bullets_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctaListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  subtitle_contains?: InputMaybe<Scalars['String']['input']>;
  subtitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subtitle_not?: InputMaybe<Scalars['String']['input']>;
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text_not?: InputMaybe<Scalars['String']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfComponentPromoTextCardNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfComponentPromoTextCardNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfComponentPromoTextCardNestedFilter>>>;
  bodyCopy_contains?: InputMaybe<Scalars['String']['input']>;
  bodyCopy_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bodyCopy_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctaListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showTitleInline?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showTitleInline_not?: InputMaybe<Scalars['Boolean']['input']>;
  smallText_contains?: InputMaybe<Scalars['String']['input']>;
  smallText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  smallText_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  theme?: InputMaybe<Scalars['String']['input']>;
  theme_contains?: InputMaybe<Scalars['String']['input']>;
  theme_exists?: InputMaybe<Scalars['Boolean']['input']>;
  theme_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  theme_not?: InputMaybe<Scalars['String']['input']>;
  theme_not_contains?: InputMaybe<Scalars['String']['input']>;
  theme_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColour?: InputMaybe<Scalars['String']['input']>;
  titleColour_contains?: InputMaybe<Scalars['String']['input']>;
  titleColour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleColour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColour_not?: InputMaybe<Scalars['String']['input']>;
  titleColour_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleColour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titlePart1?: InputMaybe<Scalars['String']['input']>;
  titlePart1_contains?: InputMaybe<Scalars['String']['input']>;
  titlePart1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titlePart1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titlePart1_not?: InputMaybe<Scalars['String']['input']>;
  titlePart1_not_contains?: InputMaybe<Scalars['String']['input']>;
  titlePart1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titlePart2?: InputMaybe<Scalars['String']['input']>;
  titlePart2_contains?: InputMaybe<Scalars['String']['input']>;
  titlePart2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titlePart2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titlePart2_not?: InputMaybe<Scalars['String']['input']>;
  titlePart2_not_contains?: InputMaybe<Scalars['String']['input']>;
  titlePart2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfComponentRecommendedContentAccordionNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfComponentRecommendedContentAccordionNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfComponentRecommendedContentAccordionNestedFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  intro_exists?: InputMaybe<Scalars['Boolean']['input']>;
  itemsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type CfComponentSpotlightNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfComponentSpotlightNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfComponentSpotlightNestedFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfComponentStepNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfComponentStepNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfComponentStepNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  richTextStepBodyCopy_contains?: InputMaybe<Scalars['String']['input']>;
  richTextStepBodyCopy_exists?: InputMaybe<Scalars['Boolean']['input']>;
  richTextStepBodyCopy_not_contains?: InputMaybe<Scalars['String']['input']>;
  stepBodyCopy?: InputMaybe<Scalars['String']['input']>;
  stepBodyCopy_contains?: InputMaybe<Scalars['String']['input']>;
  stepBodyCopy_exists?: InputMaybe<Scalars['Boolean']['input']>;
  stepBodyCopy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stepBodyCopy_not?: InputMaybe<Scalars['String']['input']>;
  stepBodyCopy_not_contains?: InputMaybe<Scalars['String']['input']>;
  stepBodyCopy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stepTitle?: InputMaybe<Scalars['String']['input']>;
  stepTitle_contains?: InputMaybe<Scalars['String']['input']>;
  stepTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  stepTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stepTitle_not?: InputMaybe<Scalars['String']['input']>;
  stepTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  stepTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfComponentTariffCardNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfComponentTariffCardNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfComponentTariffCardNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featuresCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title1?: InputMaybe<Scalars['String']['input']>;
  title1_contains?: InputMaybe<Scalars['String']['input']>;
  title1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title1_not?: InputMaybe<Scalars['String']['input']>;
  title1_not_contains?: InputMaybe<Scalars['String']['input']>;
  title1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2?: InputMaybe<Scalars['String']['input']>;
  title2_contains?: InputMaybe<Scalars['String']['input']>;
  title2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2_not?: InputMaybe<Scalars['String']['input']>;
  title2_not_contains?: InputMaybe<Scalars['String']['input']>;
  title2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfComponentUspCardNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfComponentUspCardNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfComponentUspCardNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  descriptionText_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionText_not_contains?: InputMaybe<Scalars['String']['input']>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfContentType5OiHchWgV9Y8SuvDxHCaLyNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfContentType5OiHchWgV9Y8SuvDxHCaLyNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfContentType5OiHchWgV9Y8SuvDxHCaLyNestedFilter>>>;
  altText?: InputMaybe<Scalars['String']['input']>;
  altText_contains?: InputMaybe<Scalars['String']['input']>;
  altText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  altText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  altText_not?: InputMaybe<Scalars['String']['input']>;
  altText_not_contains?: InputMaybe<Scalars['String']['input']>;
  altText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderId?: InputMaybe<Scalars['String']['input']>;
  bynderId_contains?: InputMaybe<Scalars['String']['input']>;
  bynderId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bynderId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderId_not?: InputMaybe<Scalars['String']['input']>;
  bynderId_not_contains?: InputMaybe<Scalars['String']['input']>;
  bynderId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  mobileImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  netlifyId?: InputMaybe<Scalars['String']['input']>;
  netlifyId_contains?: InputMaybe<Scalars['String']['input']>;
  netlifyId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  netlifyId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  netlifyId_not?: InputMaybe<Scalars['String']['input']>;
  netlifyId_not_contains?: InputMaybe<Scalars['String']['input']>;
  netlifyId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  usageRights?: InputMaybe<Scalars['String']['input']>;
  usageRights_contains?: InputMaybe<Scalars['String']['input']>;
  usageRights_exists?: InputMaybe<Scalars['Boolean']['input']>;
  usageRights_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  usageRights_not?: InputMaybe<Scalars['String']['input']>;
  usageRights_not_contains?: InputMaybe<Scalars['String']['input']>;
  usageRights_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  useAltText?: InputMaybe<Scalars['Boolean']['input']>;
  useAltText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useAltText_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfContentType5VCz5FHyZ2ZlWqa5OKh6Y9NestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfContentType5VCz5FHyZ2ZlWqa5OKh6Y9NestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfContentType5VCz5FHyZ2ZlWqa5OKh6Y9NestedFilter>>>;
  altText?: InputMaybe<Scalars['String']['input']>;
  altText_contains?: InputMaybe<Scalars['String']['input']>;
  altText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  altText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  altText_not?: InputMaybe<Scalars['String']['input']>;
  altText_not_contains?: InputMaybe<Scalars['String']['input']>;
  altText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderId?: InputMaybe<Scalars['String']['input']>;
  bynderId_contains?: InputMaybe<Scalars['String']['input']>;
  bynderId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bynderId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderId_not?: InputMaybe<Scalars['String']['input']>;
  bynderId_not_contains?: InputMaybe<Scalars['String']['input']>;
  bynderId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderVideo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  hasGradient?: InputMaybe<Scalars['Boolean']['input']>;
  hasGradient_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hasGradient_not?: InputMaybe<Scalars['Boolean']['input']>;
  mobileVideo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notes_contains?: InputMaybe<Scalars['String']['input']>;
  notes_exists?: InputMaybe<Scalars['Boolean']['input']>;
  notes_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notes_not?: InputMaybe<Scalars['String']['input']>;
  notes_not_contains?: InputMaybe<Scalars['String']['input']>;
  notes_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfIntegrationOptimizelyFlagNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfIntegrationOptimizelyFlagNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfIntegrationOptimizelyFlagNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  identifier_contains?: InputMaybe<Scalars['String']['input']>;
  identifier_exists?: InputMaybe<Scalars['Boolean']['input']>;
  identifier_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  identifier_not?: InputMaybe<Scalars['String']['input']>;
  identifier_not_contains?: InputMaybe<Scalars['String']['input']>;
  identifier_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rulesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type CfIntegrationOptimizelyFlagRuleNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfIntegrationOptimizelyFlagRuleNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfIntegrationOptimizelyFlagRuleNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  recommendedContentAccordion_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  variation?: InputMaybe<Scalars['String']['input']>;
  variation_contains?: InputMaybe<Scalars['String']['input']>;
  variation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variation_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variation_not?: InputMaybe<Scalars['String']['input']>;
  variation_not_contains?: InputMaybe<Scalars['String']['input']>;
  variation_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfPackAlertBannerNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfPackAlertBannerNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfPackAlertBannerNestedFilter>>>;
  body_contains?: InputMaybe<Scalars['String']['input']>;
  body_exists?: InputMaybe<Scalars['Boolean']['input']>;
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  expires?: InputMaybe<Scalars['DateTime']['input']>;
  expires_exists?: InputMaybe<Scalars['Boolean']['input']>;
  expires_gt?: InputMaybe<Scalars['DateTime']['input']>;
  expires_gte?: InputMaybe<Scalars['DateTime']['input']>;
  expires_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  expires_lt?: InputMaybe<Scalars['DateTime']['input']>;
  expires_lte?: InputMaybe<Scalars['DateTime']['input']>;
  expires_not?: InputMaybe<Scalars['DateTime']['input']>;
  expires_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  header?: InputMaybe<Scalars['String']['input']>;
  header_contains?: InputMaybe<Scalars['String']['input']>;
  header_exists?: InputMaybe<Scalars['Boolean']['input']>;
  header_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  header_not?: InputMaybe<Scalars['String']['input']>;
  header_not_contains?: InputMaybe<Scalars['String']['input']>;
  header_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  theme?: InputMaybe<Scalars['String']['input']>;
  theme_contains?: InputMaybe<Scalars['String']['input']>;
  theme_exists?: InputMaybe<Scalars['Boolean']['input']>;
  theme_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  theme_not?: InputMaybe<Scalars['String']['input']>;
  theme_not_contains?: InputMaybe<Scalars['String']['input']>;
  theme_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfPackAppStoreNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfPackAppStoreNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfPackAppStoreNestedFilter>>>;
  appleIconAltText?: InputMaybe<Scalars['String']['input']>;
  appleIconAltText_contains?: InputMaybe<Scalars['String']['input']>;
  appleIconAltText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  appleIconAltText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appleIconAltText_not?: InputMaybe<Scalars['String']['input']>;
  appleIconAltText_not_contains?: InputMaybe<Scalars['String']['input']>;
  appleIconAltText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  playstoreIconAltText?: InputMaybe<Scalars['String']['input']>;
  playstoreIconAltText_contains?: InputMaybe<Scalars['String']['input']>;
  playstoreIconAltText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  playstoreIconAltText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  playstoreIconAltText_not?: InputMaybe<Scalars['String']['input']>;
  playstoreIconAltText_not_contains?: InputMaybe<Scalars['String']['input']>;
  playstoreIconAltText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAppleIcon?: InputMaybe<Scalars['Boolean']['input']>;
  showAppleIcon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showAppleIcon_not?: InputMaybe<Scalars['Boolean']['input']>;
  showPlaystoreIcon?: InputMaybe<Scalars['Boolean']['input']>;
  showPlaystoreIcon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showPlaystoreIcon_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type CfPackCategoryListNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfPackCategoryListNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfPackCategoryListNestedFilter>>>;
  categoryCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfPackCategoryNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfPackCategoryNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfPackCategoryNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  iconCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parentCategory_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type CfPackContactOptionsNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfPackContactOptionsNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfPackContactOptionsNestedFilter>>>;
  chatButtonLabel?: InputMaybe<Scalars['String']['input']>;
  chatButtonLabel_contains?: InputMaybe<Scalars['String']['input']>;
  chatButtonLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  chatButtonLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  chatButtonLabel_not?: InputMaybe<Scalars['String']['input']>;
  chatButtonLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  chatButtonLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactChannelCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  intro_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type CfPackCtaNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfPackCtaNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfPackCtaNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  destinationAnchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  destination_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenText?: InputMaybe<Scalars['String']['input']>;
  hiddenText_contains?: InputMaybe<Scalars['String']['input']>;
  hiddenText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenText_not?: InputMaybe<Scalars['String']['input']>;
  hiddenText_not_contains?: InputMaybe<Scalars['String']['input']>;
  hiddenText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mixpanelId?: InputMaybe<Scalars['String']['input']>;
  mixpanelId_contains?: InputMaybe<Scalars['String']['input']>;
  mixpanelId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mixpanelId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mixpanelId_not?: InputMaybe<Scalars['String']['input']>;
  mixpanelId_not_contains?: InputMaybe<Scalars['String']['input']>;
  mixpanelId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  queryStringExtras?: InputMaybe<Scalars['String']['input']>;
  queryStringExtras_contains?: InputMaybe<Scalars['String']['input']>;
  queryStringExtras_exists?: InputMaybe<Scalars['Boolean']['input']>;
  queryStringExtras_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  queryStringExtras_not?: InputMaybe<Scalars['String']['input']>;
  queryStringExtras_not_contains?: InputMaybe<Scalars['String']['input']>;
  queryStringExtras_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmCampaign_contains?: InputMaybe<Scalars['String']['input']>;
  utmCampaign_exists?: InputMaybe<Scalars['Boolean']['input']>;
  utmCampaign_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  utmCampaign_not?: InputMaybe<Scalars['String']['input']>;
  utmCampaign_not_contains?: InputMaybe<Scalars['String']['input']>;
  utmCampaign_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmContent_contains?: InputMaybe<Scalars['String']['input']>;
  utmContent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  utmContent_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  utmContent_not?: InputMaybe<Scalars['String']['input']>;
  utmContent_not_contains?: InputMaybe<Scalars['String']['input']>;
  utmContent_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmMedium_contains?: InputMaybe<Scalars['String']['input']>;
  utmMedium_exists?: InputMaybe<Scalars['Boolean']['input']>;
  utmMedium_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  utmMedium_not?: InputMaybe<Scalars['String']['input']>;
  utmMedium_not_contains?: InputMaybe<Scalars['String']['input']>;
  utmMedium_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmSource_contains?: InputMaybe<Scalars['String']['input']>;
  utmSource_exists?: InputMaybe<Scalars['Boolean']['input']>;
  utmSource_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  utmSource_not?: InputMaybe<Scalars['String']['input']>;
  utmSource_not_contains?: InputMaybe<Scalars['String']['input']>;
  utmSource_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfPackFooterItemNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfPackFooterItemNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfPackFooterItemNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctaBehaviour?: InputMaybe<Scalars['String']['input']>;
  ctaBehaviour_contains?: InputMaybe<Scalars['String']['input']>;
  ctaBehaviour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaBehaviour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaBehaviour_not?: InputMaybe<Scalars['String']['input']>;
  ctaBehaviour_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaBehaviour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  destination_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenText?: InputMaybe<Scalars['String']['input']>;
  hiddenText_contains?: InputMaybe<Scalars['String']['input']>;
  hiddenText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenText_not?: InputMaybe<Scalars['String']['input']>;
  hiddenText_not_contains?: InputMaybe<Scalars['String']['input']>;
  hiddenText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  level?: InputMaybe<Scalars['String']['input']>;
  level_contains?: InputMaybe<Scalars['String']['input']>;
  level_exists?: InputMaybe<Scalars['Boolean']['input']>;
  level_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  level_not?: InputMaybe<Scalars['String']['input']>;
  level_not_contains?: InputMaybe<Scalars['String']['input']>;
  level_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfPackFreeFormTextNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfPackFreeFormTextNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfPackFreeFormTextNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
};

export type CfPackHighlightedTextNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfPackHighlightedTextNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfPackHighlightedTextNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  highlighted?: InputMaybe<Scalars['String']['input']>;
  highlighted_contains?: InputMaybe<Scalars['String']['input']>;
  highlighted_exists?: InputMaybe<Scalars['Boolean']['input']>;
  highlighted_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  highlighted_not?: InputMaybe<Scalars['String']['input']>;
  highlighted_not_contains?: InputMaybe<Scalars['String']['input']>;
  highlighted_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonHighlighted?: InputMaybe<Scalars['String']['input']>;
  nonHighlighted_contains?: InputMaybe<Scalars['String']['input']>;
  nonHighlighted_exists?: InputMaybe<Scalars['Boolean']['input']>;
  nonHighlighted_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonHighlighted_not?: InputMaybe<Scalars['String']['input']>;
  nonHighlighted_not_contains?: InputMaybe<Scalars['String']['input']>;
  nonHighlighted_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfPackLandingPageArticlesNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfPackLandingPageArticlesNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfPackLandingPageArticlesNestedFilter>>>;
  alertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  featureArticle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  headerText1?: InputMaybe<Scalars['String']['input']>;
  headerText1_contains?: InputMaybe<Scalars['String']['input']>;
  headerText1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headerText1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headerText1_not?: InputMaybe<Scalars['String']['input']>;
  headerText1_not_contains?: InputMaybe<Scalars['String']['input']>;
  headerText1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headerText2?: InputMaybe<Scalars['String']['input']>;
  headerText2_contains?: InputMaybe<Scalars['String']['input']>;
  headerText2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headerText2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headerText2_not?: InputMaybe<Scalars['String']['input']>;
  headerText2_not_contains?: InputMaybe<Scalars['String']['input']>;
  headerText2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  header_contains?: InputMaybe<Scalars['String']['input']>;
  header_exists?: InputMaybe<Scalars['Boolean']['input']>;
  header_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  header_not?: InputMaybe<Scalars['String']['input']>;
  header_not_contains?: InputMaybe<Scalars['String']['input']>;
  header_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaDescription_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaDescription_not?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  metaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle_not?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ogMetaDescription?: InputMaybe<Scalars['String']['input']>;
  ogMetaDescription_contains?: InputMaybe<Scalars['String']['input']>;
  ogMetaDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ogMetaDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogMetaDescription_not?: InputMaybe<Scalars['String']['input']>;
  ogMetaDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  ogMetaDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogMetaTitle?: InputMaybe<Scalars['String']['input']>;
  ogMetaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  ogMetaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ogMetaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogMetaTitle_not?: InputMaybe<Scalars['String']['input']>;
  ogMetaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  ogMetaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchBar_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
};

export type CfPackLottieAnimationNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfPackLottieAnimationNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfPackLottieAnimationNestedFilter>>>;
  altText?: InputMaybe<Scalars['String']['input']>;
  altText_contains?: InputMaybe<Scalars['String']['input']>;
  altText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  altText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  altText_not?: InputMaybe<Scalars['String']['input']>;
  altText_not_contains?: InputMaybe<Scalars['String']['input']>;
  altText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lottieJson_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfPackMicrocopyNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfPackMicrocopyNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfPackMicrocopyNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfPackNavBarCtaNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfPackNavBarCtaNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfPackNavBarCtaNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  destination_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenText?: InputMaybe<Scalars['String']['input']>;
  hiddenText_contains?: InputMaybe<Scalars['String']['input']>;
  hiddenText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenText_not?: InputMaybe<Scalars['String']['input']>;
  hiddenText_not_contains?: InputMaybe<Scalars['String']['input']>;
  hiddenText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfPackRecommendedContentAccordionItemNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfPackRecommendedContentAccordionItemNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfPackRecommendedContentAccordionItemNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfPackSearchBarNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfPackSearchBarNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfPackSearchBarNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  hintText?: InputMaybe<Scalars['String']['input']>;
  hintText_contains?: InputMaybe<Scalars['String']['input']>;
  hintText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hintText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hintText_not?: InputMaybe<Scalars['String']['input']>;
  hintText_not_contains?: InputMaybe<Scalars['String']['input']>;
  hintText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  searchRequirementsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type CfPackSearchRequirementsNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfPackSearchRequirementsNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfPackSearchRequirementsNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  excludedPages_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedPages_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedPages_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedPages_exists?: InputMaybe<Scalars['Boolean']['input']>;
  prioritisedPages_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  prioritisedPages_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  prioritisedPages_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  prioritisedPages_exists?: InputMaybe<Scalars['Boolean']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  searchQuery_contains?: InputMaybe<Scalars['String']['input']>;
  searchQuery_exists?: InputMaybe<Scalars['Boolean']['input']>;
  searchQuery_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchQuery_not?: InputMaybe<Scalars['String']['input']>;
  searchQuery_not_contains?: InputMaybe<Scalars['String']['input']>;
  searchQuery_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfPackStructuredTextNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfPackStructuredTextNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfPackStructuredTextNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  header?: InputMaybe<Scalars['String']['input']>;
  header_contains?: InputMaybe<Scalars['String']['input']>;
  header_exists?: InputMaybe<Scalars['Boolean']['input']>;
  header_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  header_not?: InputMaybe<Scalars['String']['input']>;
  header_not_contains?: InputMaybe<Scalars['String']['input']>;
  header_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
};

export type CfPromoCardNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfPromoCardNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfPromoCardNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctaVariant?: InputMaybe<Scalars['String']['input']>;
  ctaVariant_contains?: InputMaybe<Scalars['String']['input']>;
  ctaVariant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaVariant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaVariant_not?: InputMaybe<Scalars['String']['input']>;
  ctaVariant_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaVariant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta_exists?: InputMaybe<Scalars['Boolean']['input']>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  smallText_contains?: InputMaybe<Scalars['String']['input']>;
  smallText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  smallText_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  title1?: InputMaybe<Scalars['String']['input']>;
  title1_contains?: InputMaybe<Scalars['String']['input']>;
  title1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title1_not?: InputMaybe<Scalars['String']['input']>;
  title1_not_contains?: InputMaybe<Scalars['String']['input']>;
  title1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2?: InputMaybe<Scalars['String']['input']>;
  title2_contains?: InputMaybe<Scalars['String']['input']>;
  title2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title2_not?: InputMaybe<Scalars['String']['input']>;
  title2_not_contains?: InputMaybe<Scalars['String']['input']>;
  title2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColour?: InputMaybe<Scalars['String']['input']>;
  titleColour_contains?: InputMaybe<Scalars['String']['input']>;
  titleColour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleColour_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColour_not?: InputMaybe<Scalars['String']['input']>;
  titleColour_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleColour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titlePosition?: InputMaybe<Scalars['Boolean']['input']>;
  titlePosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titlePosition_not?: InputMaybe<Scalars['Boolean']['input']>;
  titleVariant?: InputMaybe<Scalars['String']['input']>;
  titleVariant_contains?: InputMaybe<Scalars['String']['input']>;
  titleVariant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleVariant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleVariant_not?: InputMaybe<Scalars['String']['input']>;
  titleVariant_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleVariant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfTopicTableNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfTopicTableNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfTopicTableNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  tableCaption?: InputMaybe<Scalars['String']['input']>;
  tableCaption_contains?: InputMaybe<Scalars['String']['input']>;
  tableCaption_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tableCaption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tableCaption_not?: InputMaybe<Scalars['String']['input']>;
  tableCaption_not_contains?: InputMaybe<Scalars['String']['input']>;
  tableCaption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  table_contains?: InputMaybe<Scalars['String']['input']>;
  table_exists?: InputMaybe<Scalars['Boolean']['input']>;
  table_not_contains?: InputMaybe<Scalars['String']['input']>;
};

export type CfWrapperAnimationNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfWrapperAnimationNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfWrapperAnimationNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  hasDesktopAnimation?: InputMaybe<Scalars['Boolean']['input']>;
  hasDesktopAnimation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hasDesktopAnimation_not?: InputMaybe<Scalars['Boolean']['input']>;
  hasMobileAnimation?: InputMaybe<Scalars['Boolean']['input']>;
  hasMobileAnimation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hasMobileAnimation_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfWrapperBannerImageNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfWrapperBannerImageNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfWrapperBannerImageNestedFilter>>>;
  altText?: InputMaybe<Scalars['String']['input']>;
  altText_contains?: InputMaybe<Scalars['String']['input']>;
  altText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  altText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  altText_not?: InputMaybe<Scalars['String']['input']>;
  altText_not_contains?: InputMaybe<Scalars['String']['input']>;
  altText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  desktopImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mobileImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  useAltText?: InputMaybe<Scalars['Boolean']['input']>;
  useAltText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useAltText_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfWrapperIconNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfWrapperIconNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfWrapperIconNestedFilter>>>;
  altText?: InputMaybe<Scalars['String']['input']>;
  altText_contains?: InputMaybe<Scalars['String']['input']>;
  altText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  altText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  altText_not?: InputMaybe<Scalars['String']['input']>;
  altText_not_contains?: InputMaybe<Scalars['String']['input']>;
  altText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  svg_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  useAltText?: InputMaybe<Scalars['Boolean']['input']>;
  useAltText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useAltText_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfWrapperImageNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfWrapperImageNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfWrapperImageNestedFilter>>>;
  altText?: InputMaybe<Scalars['String']['input']>;
  altText_contains?: InputMaybe<Scalars['String']['input']>;
  altText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  altText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  altText_not?: InputMaybe<Scalars['String']['input']>;
  altText_not_contains?: InputMaybe<Scalars['String']['input']>;
  altText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  desktopImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mobileImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  useAltText?: InputMaybe<Scalars['Boolean']['input']>;
  useAltText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useAltText_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfWrapperSocialMediaNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfWrapperSocialMediaNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfWrapperSocialMediaNestedFilter>>>;
  channel?: InputMaybe<Scalars['String']['input']>;
  channel_contains?: InputMaybe<Scalars['String']['input']>;
  channel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  channel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  channel_not?: InputMaybe<Scalars['String']['input']>;
  channel_not_contains?: InputMaybe<Scalars['String']['input']>;
  channel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfWrapperUrlNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfWrapperUrlNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfWrapperUrlNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfWrapperVideoNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfWrapperVideoNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfWrapperVideoNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  transcript?: InputMaybe<Scalars['String']['input']>;
  transcript_contains?: InputMaybe<Scalars['String']['input']>;
  transcript_exists?: InputMaybe<Scalars['Boolean']['input']>;
  transcript_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  transcript_not?: InputMaybe<Scalars['String']['input']>;
  transcript_not_contains?: InputMaybe<Scalars['String']['input']>;
  transcript_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoLink?: InputMaybe<Scalars['String']['input']>;
  videoLink_contains?: InputMaybe<Scalars['String']['input']>;
  videoLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  videoLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoLink_not?: InputMaybe<Scalars['String']['input']>;
  videoLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  videoLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoTitle?: InputMaybe<Scalars['String']['input']>;
  videoTitle_contains?: InputMaybe<Scalars['String']['input']>;
  videoTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  videoTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoTitle_not?: InputMaybe<Scalars['String']['input']>;
  videoTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  videoTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  video_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfbannerBynderMediaMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfbannerBynderMediaMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfbannerBynderMediaMultiTypeNestedFilter>>>;
  altText?: InputMaybe<Scalars['String']['input']>;
  altText_contains?: InputMaybe<Scalars['String']['input']>;
  altText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  altText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  altText_not?: InputMaybe<Scalars['String']['input']>;
  altText_not_contains?: InputMaybe<Scalars['String']['input']>;
  altText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderId?: InputMaybe<Scalars['String']['input']>;
  bynderId_contains?: InputMaybe<Scalars['String']['input']>;
  bynderId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bynderId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderId_not?: InputMaybe<Scalars['String']['input']>;
  bynderId_not_contains?: InputMaybe<Scalars['String']['input']>;
  bynderId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfbynderMediaMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfbynderMediaMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfbynderMediaMultiTypeNestedFilter>>>;
  altText?: InputMaybe<Scalars['String']['input']>;
  altText_contains?: InputMaybe<Scalars['String']['input']>;
  altText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  altText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  altText_not?: InputMaybe<Scalars['String']['input']>;
  altText_not_contains?: InputMaybe<Scalars['String']['input']>;
  altText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderId?: InputMaybe<Scalars['String']['input']>;
  bynderId_contains?: InputMaybe<Scalars['String']['input']>;
  bynderId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bynderId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderId_not?: InputMaybe<Scalars['String']['input']>;
  bynderId_not_contains?: InputMaybe<Scalars['String']['input']>;
  bynderId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfcarouselItemsMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfcarouselItemsMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfcarouselItemsMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type CfcomponentsMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfcomponentsMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfcomponentsMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type CfcontentMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfcontentMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfcontentMultiTypeNestedFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type CfctaListMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfctaListMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfctaListMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type CfheaderVideoMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfheaderVideoMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfheaderVideoMultiTypeNestedFilter>>>;
  altText?: InputMaybe<Scalars['String']['input']>;
  altText_contains?: InputMaybe<Scalars['String']['input']>;
  altText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  altText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  altText_not?: InputMaybe<Scalars['String']['input']>;
  altText_not_contains?: InputMaybe<Scalars['String']['input']>;
  altText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderId?: InputMaybe<Scalars['String']['input']>;
  bynderId_contains?: InputMaybe<Scalars['String']['input']>;
  bynderId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bynderId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderId_not?: InputMaybe<Scalars['String']['input']>;
  bynderId_not_contains?: InputMaybe<Scalars['String']['input']>;
  bynderId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfheroBynderMediaMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfheroBynderMediaMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfheroBynderMediaMultiTypeNestedFilter>>>;
  altText?: InputMaybe<Scalars['String']['input']>;
  altText_contains?: InputMaybe<Scalars['String']['input']>;
  altText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  altText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  altText_not?: InputMaybe<Scalars['String']['input']>;
  altText_not_contains?: InputMaybe<Scalars['String']['input']>;
  altText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderId?: InputMaybe<Scalars['String']['input']>;
  bynderId_contains?: InputMaybe<Scalars['String']['input']>;
  bynderId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bynderId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderId_not?: InputMaybe<Scalars['String']['input']>;
  bynderId_not_contains?: InputMaybe<Scalars['String']['input']>;
  bynderId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfitemsMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfitemsMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfitemsMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  destination_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenText?: InputMaybe<Scalars['String']['input']>;
  hiddenText_contains?: InputMaybe<Scalars['String']['input']>;
  hiddenText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenText_not?: InputMaybe<Scalars['String']['input']>;
  hiddenText_not_contains?: InputMaybe<Scalars['String']['input']>;
  hiddenText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  level?: InputMaybe<Scalars['String']['input']>;
  level_contains?: InputMaybe<Scalars['String']['input']>;
  level_exists?: InputMaybe<Scalars['Boolean']['input']>;
  level_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  level_not?: InputMaybe<Scalars['String']['input']>;
  level_not_contains?: InputMaybe<Scalars['String']['input']>;
  level_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfmediaMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfmediaMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfmediaMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type Cfrow1MultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<Cfrow1MultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<Cfrow1MultiTypeNestedFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type Cfrow2MultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<Cfrow2MultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<Cfrow2MultiTypeNestedFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type Cfrow3MultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<Cfrow3MultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<Cfrow3MultiTypeNestedFilter>>>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  anchor_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchor_not?: InputMaybe<Scalars['String']['input']>;
  anchor_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type NextBestActionsQueryQueryVariables = Exact<{
  nbaContainerId: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  actionCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type NextBestActionsQueryQuery = { __typename?: 'Query', buildNextBestAction?: { __typename?: 'BuildNextBestAction', actionCardsCollection?: (
      { __typename?: 'BuildNextBestActionActionCardsCollection' }
      & { ' $fragmentRefs'?: { 'ShowableCardsFragmentFragment': ShowableCardsFragmentFragment } }
    ) | null } | null };

export type CustomerInformationCardQueryQueryVariables = Exact<{
  containerId: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CustomerInformationCardQueryQuery = { __typename?: 'Query', buildCustomerInformationCard?: { __typename?: 'BuildCustomerInformationCard', actionCardsCollection?: { __typename?: 'BuildCustomerInformationCardActionCardsCollection', items: Array<{ __typename?: 'ComponentActionCard', mixpanelId?: string | null, text?: { __typename?: 'PackStructuredText', header?: string | null, text?: { __typename?: 'PackStructuredTextText', json: unknown } | null } | null, cta?: (
          { __typename?: 'PackCta' }
          & { ' $fragmentRefs'?: { 'PackCtaFragmentFragment': PackCtaFragmentFragment } }
        ) | null } | null> } | null } | null };

export type ShowableCardsFragmentFragment = { __typename?: 'BuildNextBestActionActionCardsCollection', items: Array<{ __typename?: 'ComponentActionCard', actionCode?: string | null, nonRoundedEdges?: boolean | null, canBeDismissed?: boolean | null, optimizelyFeatureFlag?: string | null, inverted?: boolean | null, ctaBehaviour?: string | null, mixpanelId?: string | null, sys: { __typename?: 'Sys', id: string }, text?: { __typename?: 'PackStructuredText', header?: string | null, text?: { __typename?: 'PackStructuredTextText', json: unknown } | null } | null, image?: { __typename?: 'WrapperImage', altText?: string | null, desktopImage?: { __typename?: 'Asset', url?: string | null, width?: number | null } | null } | null, cta?: (
      { __typename?: 'PackCta' }
      & { ' $fragmentRefs'?: { 'PackCtaFragmentFragment': PackCtaFragmentFragment } }
    ) | null } | null> } & { ' $fragmentName'?: 'ShowableCardsFragmentFragment' };

export type EntryHyperLinkFragmentFragment = { __typename?: 'PackStructuredTextTextLinks', entries: { __typename?: 'PackStructuredTextTextEntries', hyperlink: Array<{ __typename: 'ALVvzQa2BY0A0OgrM8PSt', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Author', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BuildArticlePage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BuildArticlesLandingPage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BuildCampaignPage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BuildCategoryWebpage', pathname?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename: 'BuildCustomerInformationCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BuildFaQs', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BuildGenericTemplatePage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BuildLandingpage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BuildNextBestAction', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BuildProductDetailPage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BuildProductOverviewPage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BuildRecommendedContent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BuildTariffPage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BuildWebpage', slug?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentAccordion', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentActionCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentBlockCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentCallout', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentCardGrid', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentCardGroup', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentCarousel', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentCarouselCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentCategoryBrowser', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentContactAndUsefulLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentContentBlock', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentContentBlockV2', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentCtaBanner', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentDetailInfoSection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentFooter', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentFootnotes', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentForm', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentGuideCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentGuidesRail', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentHelpAndCta', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentHelpHomepageDualLayout', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentHomepageHeroPostcodeSection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentIframe', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentImageGallery', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentImageWithDescription', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentInfoCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentInfoGroup', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentLauncherGroup', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentLineup', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentLogoGroup', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentNavBar', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentPageHero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentPostcodeFinder', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentProductFeaturedCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentProductGroup', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentProductModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentProductRail', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentPromoCardRail', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentPromoSection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentPromoTextCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentPromoTextCardSection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentQrCodePopup', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentQuickLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentRecommendedContentAccordion', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentSearch', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentSectionSteps', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentSpotlight', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentSpotlightGrid', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentStep', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentTable', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentTariffCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentTariffCardGroup', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentTariffHero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentTextAndCta', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentTopArticleBrowser', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentTrustpilot', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentUspCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentUspGroup', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentUspSupportingContent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ComponentVideoPlayer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentType1GgZsWOlfK2WI0QIh0Pwim', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentType5OiHchWgV9Y8SuvDxHCaLy', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentType5VCz5FHyZ2ZlWqa5OKh6Y9', sys: { __typename?: 'Sys', id: string } } | { __typename: 'IntegrationOptimizelyFlag', sys: { __typename?: 'Sys', id: string } } | { __typename: 'IntegrationOptimizelyFlagRule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PackAlertBanner', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PackAppStore', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PackArticlePage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PackCampaignPage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PackCategory', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PackCategoryList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PackContactOptions', sys: { __typename?: 'Sys', id: string } } | (
      { __typename: 'PackCta', sys: { __typename?: 'Sys', id: string } }
      & { ' $fragmentRefs'?: { 'PackCtaFragmentFragment': PackCtaFragmentFragment } }
    ) | { __typename: 'PackDynamicVariablePlaceholder', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PackFooterItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PackFreeFormPrivacyText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PackFreeFormText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PackHighlightedText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PackHomePage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PackLandingPageArticles', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PackLottieAnimation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PackMicrocopy', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PackNavBarCta', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PackNavBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PackNavBarItemV2', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PackPageProductDetail', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PackPageStandard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PackPageStandardV2', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PackPageStandardV2Dev', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PackRecommendedContentAccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PackRichText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PackSearchBar', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PackSearchRequirements', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PackSearchResult', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PackStructuredText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PackTrustpilotBanner', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PackUserAction', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PromoCard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TopicTable', sys: { __typename?: 'Sys', id: string } } | { __typename: 'VariationContainer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'WrapperAnchor', sys: { __typename?: 'Sys', id: string } } | { __typename: 'WrapperAnimation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'WrapperAppScreen', sys: { __typename?: 'Sys', id: string } } | { __typename: 'WrapperBannerImage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'WrapperDocument', document?: { __typename?: 'Asset', url?: string | null } | null, sys: { __typename?: 'Sys', id: string } } | { __typename: 'WrapperIcon', sys: { __typename?: 'Sys', id: string } } | { __typename: 'WrapperImage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'WrapperPageRouting', sys: { __typename?: 'Sys', id: string } } | { __typename: 'WrapperPath', sys: { __typename?: 'Sys', id: string } } | { __typename: 'WrapperSocialMedia', sys: { __typename?: 'Sys', id: string } } | { __typename: 'WrapperUrl', url?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename: 'WrapperVideo', sys: { __typename?: 'Sys', id: string } } | null> } } & { ' $fragmentName'?: 'EntryHyperLinkFragmentFragment' };

export type PackCtaFragmentFragment = { __typename?: 'PackCta', label?: string | null, utmSource?: string | null, utmMedium?: string | null, utmContent?: string | null, utmCampaign?: string | null, queryStringExtras?: string | null, destination?: { __typename: 'BuildCategoryWebpage', pathname?: string | null } | { __typename: 'BuildWebpage', slug?: string | null } | { __typename: 'PackUserAction', actionName?: string | null } | { __typename: 'WrapperDocument', document?: { __typename?: 'Asset', url?: string | null } | null } | { __typename: 'WrapperUrl', url?: string | null } | null, destinationAnchor?: { __typename: 'ComponentAccordion' } | { __typename: 'ComponentCallout' } | { __typename: 'ComponentCardGrid' } | { __typename: 'ComponentContactAndUsefulLinks', anchor?: string | null } | { __typename: 'ComponentContentBlock', anchor?: string | null } | { __typename: 'ComponentCtaBanner' } | { __typename: 'ComponentForm' } | { __typename: 'ComponentPostcodeFinder' } | { __typename: 'ComponentSpotlightGrid' } | { __typename: 'ComponentTable' } | null } & { ' $fragmentName'?: 'PackCtaFragmentFragment' };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const PackCtaFragmentFragmentDoc = new TypedDocumentString(`
    fragment PackCTAFragment on PackCta {
  label
  utmSource
  utmMedium
  utmContent
  utmCampaign
  queryStringExtras
  destination {
    __typename
    ... on WrapperUrl {
      url
    }
    ... on BuildWebpage {
      slug
    }
    ... on BuildCategoryWebpage {
      pathname
    }
    ... on PackUserAction {
      actionName
    }
    ... on WrapperDocument {
      document {
        url
      }
    }
  }
  destinationAnchor {
    __typename
    ... on ComponentContentBlock {
      anchor
    }
    ... on ComponentContactAndUsefulLinks {
      anchor
    }
  }
}
    `, {"fragmentName":"PackCTAFragment"}) as unknown as TypedDocumentString<PackCtaFragmentFragment, unknown>;
export const ShowableCardsFragmentFragmentDoc = new TypedDocumentString(`
    fragment ShowableCardsFragment on BuildNextBestActionActionCardsCollection {
  items {
    sys {
      id
    }
    actionCode
    text {
      header
      text {
        json
      }
    }
    nonRoundedEdges
    canBeDismissed
    image {
      ... on WrapperImage {
        altText
        desktopImage {
          url
          width
        }
      }
    }
    optimizelyFeatureFlag
    inverted
    ctaBehaviour
    cta {
      ...PackCTAFragment
    }
    mixpanelId
  }
}
    fragment PackCTAFragment on PackCta {
  label
  utmSource
  utmMedium
  utmContent
  utmCampaign
  queryStringExtras
  destination {
    __typename
    ... on WrapperUrl {
      url
    }
    ... on BuildWebpage {
      slug
    }
    ... on BuildCategoryWebpage {
      pathname
    }
    ... on PackUserAction {
      actionName
    }
    ... on WrapperDocument {
      document {
        url
      }
    }
  }
  destinationAnchor {
    __typename
    ... on ComponentContentBlock {
      anchor
    }
    ... on ComponentContactAndUsefulLinks {
      anchor
    }
  }
}`, {"fragmentName":"ShowableCardsFragment"}) as unknown as TypedDocumentString<ShowableCardsFragmentFragment, unknown>;
export const EntryHyperLinkFragmentFragmentDoc = new TypedDocumentString(`
    fragment EntryHyperLinkFragment on PackStructuredTextTextLinks {
  entries {
    hyperlink {
      sys {
        id
      }
      __typename
      ... on WrapperUrl {
        url
      }
      ... on BuildWebpage {
        slug
      }
      ... on BuildCategoryWebpage {
        pathname
      }
      ... on WrapperDocument {
        document {
          url
        }
      }
      ... on PackCta {
        ...PackCTAFragment
      }
    }
  }
}
    fragment PackCTAFragment on PackCta {
  label
  utmSource
  utmMedium
  utmContent
  utmCampaign
  queryStringExtras
  destination {
    __typename
    ... on WrapperUrl {
      url
    }
    ... on BuildWebpage {
      slug
    }
    ... on BuildCategoryWebpage {
      pathname
    }
    ... on PackUserAction {
      actionName
    }
    ... on WrapperDocument {
      document {
        url
      }
    }
  }
  destinationAnchor {
    __typename
    ... on ComponentContentBlock {
      anchor
    }
    ... on ComponentContactAndUsefulLinks {
      anchor
    }
  }
}`, {"fragmentName":"EntryHyperLinkFragment"}) as unknown as TypedDocumentString<EntryHyperLinkFragmentFragment, unknown>;
export const NextBestActionsQueryDocument = new TypedDocumentString(`
    query nextBestActionsQuery($nbaContainerId: String!, $preview: Boolean, $actionCode: String) {
  buildNextBestAction(id: $nbaContainerId, preview: $preview) {
    actionCardsCollection(preview: $preview, where: {actionCode: $actionCode}) {
      ...ShowableCardsFragment
    }
  }
}
    fragment ShowableCardsFragment on BuildNextBestActionActionCardsCollection {
  items {
    sys {
      id
    }
    actionCode
    text {
      header
      text {
        json
      }
    }
    nonRoundedEdges
    canBeDismissed
    image {
      ... on WrapperImage {
        altText
        desktopImage {
          url
          width
        }
      }
    }
    optimizelyFeatureFlag
    inverted
    ctaBehaviour
    cta {
      ...PackCTAFragment
    }
    mixpanelId
  }
}
fragment PackCTAFragment on PackCta {
  label
  utmSource
  utmMedium
  utmContent
  utmCampaign
  queryStringExtras
  destination {
    __typename
    ... on WrapperUrl {
      url
    }
    ... on BuildWebpage {
      slug
    }
    ... on BuildCategoryWebpage {
      pathname
    }
    ... on PackUserAction {
      actionName
    }
    ... on WrapperDocument {
      document {
        url
      }
    }
  }
  destinationAnchor {
    __typename
    ... on ComponentContentBlock {
      anchor
    }
    ... on ComponentContactAndUsefulLinks {
      anchor
    }
  }
}`) as unknown as TypedDocumentString<NextBestActionsQueryQuery, NextBestActionsQueryQueryVariables>;
export const CustomerInformationCardQueryDocument = new TypedDocumentString(`
    query customerInformationCardQuery($containerId: String!, $preview: Boolean) {
  buildCustomerInformationCard(id: $containerId, preview: $preview) {
    actionCardsCollection(limit: 1) {
      items {
        text {
          header
          text {
            json
          }
        }
        mixpanelId
        cta {
          ...PackCTAFragment
        }
      }
    }
  }
}
    fragment PackCTAFragment on PackCta {
  label
  utmSource
  utmMedium
  utmContent
  utmCampaign
  queryStringExtras
  destination {
    __typename
    ... on WrapperUrl {
      url
    }
    ... on BuildWebpage {
      slug
    }
    ... on BuildCategoryWebpage {
      pathname
    }
    ... on PackUserAction {
      actionName
    }
    ... on WrapperDocument {
      document {
        url
      }
    }
  }
  destinationAnchor {
    __typename
    ... on ComponentContentBlock {
      anchor
    }
    ... on ComponentContactAndUsefulLinks {
      anchor
    }
  }
}`) as unknown as TypedDocumentString<CustomerInformationCardQueryQuery, CustomerInformationCardQueryQueryVariables>;